import { RenderTarget as ms, DepthTexture as ys, WebGLCoordinateSystem as En, WebGPUCoordinateSystem as sn, Vector3 as Y, Vector2 as He, Vector4 as Ce, Material as bu, NormalBlending as zs, AddOperation as rg, MixOperation as ig, MultiplyOperation as og, MeshBasicMaterial as Gc, Plane as Oc, UVMapping as ag, SRGBColorSpace as q, NoToneMapping as $s, PCFShadowMap as ug, HalfFloatType as at, RGBAFormat as Xs, LinearSRGBColorSpace as cs, LinearFilter as Lt, BackSide as Tt, FrontSide as ho, DoubleSide as Ws, warnOnce as cg, PointLight as lg, DirectionalLight as dg, RectAreaLight as hg, SpotLight as kc, AmbientLight as pg, HemisphereLight as fg, LightProbe as gg, LinearToneMapping as mg, ReinhardToneMapping as yg, CineonToneMapping as xg, ACESFilmicToneMapping as Tg, AgXToneMapping as _g, NeutralToneMapping as Ng, EventDispatcher as zc, MathUtils as $c, DynamicDrawUsage as Is, Matrix3 as $n, Matrix4 as Ue, DepthStencilFormat as Zr, DepthFormat as Jr, UnsignedInt248Type as ei, UnsignedIntType as Pe, UnsignedByteType as ls, EquirectangularReflectionMapping as Wn, EquirectangularRefractionMapping as Hn, CubeReflectionMapping as Ks, CubeRefractionMapping as Ys, Color as Ct, Mesh as js, Euler as bg, ColorManagement as ht, SphereGeometry as Sg, CubeUVReflectionMapping as po, Scene as Wc, Frustum as vg, NoColorSpace as wn, DataTexture as Ag, FloatType as st, IntType as Ve, createCanvasElement as Rg, REVISION as Hc, AddEquation as Us, SubtractEquation as qc, ReverseSubtractEquation as Xc, ZeroFactor as Kc, OneFactor as Yc, SrcColorFactor as jc, SrcAlphaFactor as Qc, SrcAlphaSaturateFactor as Zc, DstColorFactor as Jc, DstAlphaFactor as el, OneMinusSrcColorFactor as tl, OneMinusSrcAlphaFactor as sl, OneMinusDstColorFactor as nl, OneMinusDstAlphaFactor as rl, CullFaceNone as Cg, CullFaceBack as Eg, CullFaceFront as wg, NoBlending as Mn, CustomBlending as il, MultiplyBlending as Dr, SubtractiveBlending as Ir, AdditiveBlending as Lr, NotEqualDepth as ol, GreaterDepth as al, GreaterEqualDepth as ul, EqualDepth as cl, LessEqualDepth as ll, LessDepth as dl, AlwaysDepth as hl, NeverDepth as pl, UnsignedShort4444Type as Mg, UnsignedShort5551Type as Bg, UnsignedInt5999Type as fl, ByteType as Tn, ShortType as _n, UnsignedShortType as Ls, AlphaFormat as Fg, RGBFormat as Jo, LuminanceFormat as Ug, LuminanceAlphaFormat as Pg, RedFormat as ea, RedIntegerFormat as ta, RGFormat as Bn, RGIntegerFormat as sa, RGBAIntegerFormat as na, RGB_S3TC_DXT1_Format as Ei, RGBA_S3TC_DXT1_Format as vr, RGBA_S3TC_DXT3_Format as Ar, RGBA_S3TC_DXT5_Format as Rr, RGB_PVRTC_4BPPV1_Format as Su, RGB_PVRTC_2BPPV1_Format as vu, RGBA_PVRTC_4BPPV1_Format as Au, RGBA_PVRTC_2BPPV1_Format as Ru, RGB_ETC1_Format as Cu, RGB_ETC2_Format as fo, RGBA_ETC2_EAC_Format as go, RGBA_ASTC_4x4_Format as mo, RGBA_ASTC_5x4_Format as yo, RGBA_ASTC_5x5_Format as xo, RGBA_ASTC_6x5_Format as To, RGBA_ASTC_6x6_Format as _o, RGBA_ASTC_8x5_Format as No, RGBA_ASTC_8x6_Format as bo, RGBA_ASTC_8x8_Format as So, RGBA_ASTC_10x5_Format as vo, RGBA_ASTC_10x6_Format as Ao, RGBA_ASTC_10x8_Format as Ro, RGBA_ASTC_10x10_Format as Co, RGBA_ASTC_12x10_Format as Eo, RGBA_ASTC_12x12_Format as wo, RGBA_BPTC_Format as wi, RED_RGTC1_Format as Dg, SIGNED_RED_RGTC1_Format as Eu, RED_GREEN_RGTC2_Format as wu, SIGNED_RED_GREEN_RGTC2_Format as Mu, RepeatWrapping as ti, ClampToEdgeWrapping as ra, MirroredRepeatWrapping as si, NearestFilter as pt, NearestMipmapNearestFilter as Mo, NearestMipmapLinearFilter as Hs, LinearMipmapNearestFilter as Bo, LinearMipmapLinearFilter as ds, NeverCompare as gl, AlwaysCompare as ml, LessCompare as ia, LessEqualCompare as yl, EqualCompare as xl, GreaterEqualCompare as Tl, GreaterCompare as _l, NotEqualCompare as Nl, SRGBTransfer as Bu, StaticDrawUsage as Ig, InterleavedBuffer as Lg, TangentSpaceNormalMap as Fu, ObjectSpaceNormalMap as Vg, InstancedInterleavedBuffer as Gg, InstancedBufferAttribute as oa, FramebufferTexture as bl, LineBasicMaterial as Og, LineDashedMaterial as kg, MeshNormalMaterial as zg, CubeTexture as Sl, MeshLambertMaterial as $g, MeshPhongMaterial as Wg, Texture as vl, MeshStandardMaterial as Hg, MeshPhysicalMaterial as qg, MeshToonMaterial as Xg, MeshMatcapMaterial as Kg, PointsMaterial as Yg, SpriteMaterial as jg, ShadowMaterial as Qg, Uint32BufferAttribute as Zg, Uint16BufferAttribute as Jg, Object3D as em, LinearMipMapLinearFilter as tm, OrthographicCamera as Al, BufferAttribute as Cr, VSMShadowMap as or, Float16BufferAttribute as Rl, RGBIntegerFormat as sm, NotEqualStencilFunc as nm, GreaterStencilFunc as rm, GreaterEqualStencilFunc as im, EqualStencilFunc as om, LessEqualStencilFunc as am, LessStencilFunc as um, AlwaysStencilFunc as cm, NeverStencilFunc as lm, DecrementWrapStencilOp as dm, IncrementWrapStencilOp as hm, DecrementStencilOp as pm, IncrementStencilOp as fm, InvertStencilOp as gm, ReplaceStencilOp as mm, ZeroStencilOp as ym, KeepStencilOp as xm, MaxEquation as Tm, MinEquation as _m, InterleavedBufferAttribute as Nm, DataArrayTexture as bm, WebGLCubeRenderTarget as Sm, BoxGeometry as Cl, CubeCamera as vm, BufferGeometry as El, Float32BufferAttribute as Uu, BasicShadowMap as Am, PerspectiveCamera as Rm } from "./three.core.js";
import { Box3 as tR, Camera as sR, ImageUtils as nR, Layers as rR, Light as iR, LinearTransfer as oR, Quaternion as aR, Ray as uR, ShaderMaterial as cR, Source as lR, Sphere as dR, SphericalHarmonics3 as hR, Triangle as pR, WebGLRenderTarget as fR } from "./three.core.js";
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const Cm = [
  "alphaMap",
  "alphaTest",
  "anisotropy",
  "anisotropyMap",
  "anisotropyRotation",
  "aoMap",
  "attenuationColor",
  "attenuationDistance",
  "bumpMap",
  "clearcoat",
  "clearcoatMap",
  "clearcoatNormalMap",
  "clearcoatNormalScale",
  "clearcoatRoughness",
  "color",
  "dispersion",
  "displacementMap",
  "emissive",
  "emissiveMap",
  "envMap",
  "gradientMap",
  "ior",
  "iridescence",
  "iridescenceIOR",
  "iridescenceMap",
  "iridescenceThicknessMap",
  "lightMap",
  "map",
  "matcap",
  "metalness",
  "metalnessMap",
  "normalMap",
  "normalScale",
  "opacity",
  "roughness",
  "roughnessMap",
  "sheen",
  "sheenColor",
  "sheenColorMap",
  "sheenRoughnessMap",
  "shininess",
  "specular",
  "specularColor",
  "specularColorMap",
  "specularIntensity",
  "specularIntensityMap",
  "specularMap",
  "thickness",
  "transmission",
  "transmissionMap"
];
class Em {
  /**
   * Constructs a new node material observer.
   *
   * @param {NodeBuilder} builder - The node builder.
   */
  constructor(e) {
    this.renderObjects = /* @__PURE__ */ new WeakMap(), this.hasNode = this.containsNode(e), this.hasAnimation = e.object.isSkinnedMesh === !0, this.refreshUniforms = Cm, this.renderId = 0;
  }
  /**
   * Returns `true` if the given render object is verified for the first time of this observer.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the given render object is verified for the first time of this observer.
   */
  firstInitialization(e) {
    return this.renderObjects.has(e) === !1 ? (this.getRenderObjectData(e), !0) : !1;
  }
  /**
   * Returns monitoring data for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Object} The monitoring data.
   */
  getRenderObjectData(e) {
    let t = this.renderObjects.get(e);
    if (t === void 0) {
      const { geometry: s, material: n, object: r } = e;
      if (t = {
        material: this.getMaterialData(n),
        geometry: {
          attributes: this.getAttributesData(s.attributes),
          indexVersion: s.index ? s.index.version : null,
          drawRange: { start: s.drawRange.start, count: s.drawRange.count }
        },
        worldMatrix: r.matrixWorld.clone()
      }, r.center && (t.center = r.center.clone()), r.morphTargetInfluences && (t.morphTargetInfluences = r.morphTargetInfluences.slice()), e.bundle !== null && (t.version = e.bundle.version), t.material.transmission > 0) {
        const { width: i, height: a } = e.context;
        t.bufferWidth = i, t.bufferHeight = a;
      }
      this.renderObjects.set(e, t);
    }
    return t;
  }
  /**
   * Returns an attribute data structure holding the attributes versions for
   * monitoring.
   *
   * @param {Object} attributes - The geometry attributes.
   * @return {Object} An object for monitoring the versions of attributes.
   */
  getAttributesData(e) {
    const t = {};
    for (const s in e) {
      const n = e[s];
      t[s] = {
        version: n.version
      };
    }
    return t;
  }
  /**
   * Returns `true` if the node builder's material uses
   * node properties.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Boolean} Whether the node builder's material uses node properties or not.
   */
  containsNode(e) {
    const t = e.material;
    for (const s in t)
      if (t[s] && t[s].isNode)
        return !0;
    return e.renderer.nodes.modelViewMatrix !== null || e.renderer.nodes.modelNormalViewMatrix !== null;
  }
  /**
   * Returns a material data structure holding the material property values for
   * monitoring.
   *
   * @param {Material} material - The material.
   * @return {Object} An object for monitoring material properties.
   */
  getMaterialData(e) {
    const t = {};
    for (const s of this.refreshUniforms) {
      const n = e[s];
      n != null && (typeof n == "object" && n.clone !== void 0 ? n.isTexture === !0 ? t[s] = { id: n.id, version: n.version } : t[s] = n.clone() : t[s] = n);
    }
    return t;
  }
  /**
   * Returns `true` if the given render object has not changed its state.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the given render object has changed its state or not.
   */
  equals(e) {
    const { object: t, material: s, geometry: n } = e, r = this.getRenderObjectData(e);
    if (r.worldMatrix.equals(t.matrixWorld) !== !0)
      return r.worldMatrix.copy(t.matrixWorld), !1;
    const i = r.material;
    for (const m in i) {
      const _ = i[m], S = s[m];
      if (_.equals !== void 0) {
        if (_.equals(S) === !1)
          return _.copy(S), !1;
      } else if (S.isTexture === !0) {
        if (_.id !== S.id || _.version !== S.version)
          return _.id = S.id, _.version = S.version, !1;
      } else if (_ !== S)
        return i[m] = S, !1;
    }
    if (i.transmission > 0) {
      const { width: m, height: _ } = e.context;
      if (r.bufferWidth !== m || r.bufferHeight !== _)
        return r.bufferWidth = m, r.bufferHeight = _, !1;
    }
    const a = r.geometry, u = n.attributes, c = a.attributes, l = Object.keys(c), d = Object.keys(u);
    if (l.length !== d.length)
      return r.geometry.attributes = this.getAttributesData(u), !1;
    for (const m of l) {
      const _ = c[m], S = u[m];
      if (S === void 0)
        return delete c[m], !1;
      if (_.version !== S.version)
        return _.version = S.version, !1;
    }
    const h = n.index, p = a.indexVersion, f = h ? h.version : null;
    if (p !== f)
      return a.indexVersion = f, !1;
    if (a.drawRange.start !== n.drawRange.start || a.drawRange.count !== n.drawRange.count)
      return a.drawRange.start = n.drawRange.start, a.drawRange.count = n.drawRange.count, !1;
    if (r.morphTargetInfluences) {
      let m = !1;
      for (let _ = 0; _ < r.morphTargetInfluences.length; _++)
        r.morphTargetInfluences[_] !== t.morphTargetInfluences[_] && (m = !0);
      if (m) return !0;
    }
    return r.center && r.center.equals(t.center) === !1 ? (r.center.copy(t.center), !0) : (e.bundle !== null && (r.version = e.bundle.version), !0);
  }
  /**
   * Checks if the given render object requires a refresh.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {NodeFrame} nodeFrame - The current node frame.
   * @return {Boolean} Whether the given render object requires a refresh or not.
   */
  needsRefresh(e, t) {
    if (this.hasNode || this.hasAnimation || this.firstInitialization(e))
      return !0;
    const { renderId: s } = t;
    if (this.renderId !== s)
      return this.renderId = s, !0;
    const n = e.object.static === !0, r = e.bundle !== null && e.bundle.static === !0 && this.getRenderObjectData(e).version === e.bundle.version;
    return n || r ? !1 : this.equals(e) !== !0;
  }
}
function Fn(o, e = 0) {
  let t = 3735928559 ^ e, s = 1103547991 ^ e;
  if (o instanceof Array)
    for (let n = 0, r; n < o.length; n++)
      r = o[n], t = Math.imul(t ^ r, 2654435761), s = Math.imul(s ^ r, 1597334677);
  else
    for (let n = 0, r; n < o.length; n++)
      r = o.charCodeAt(n), t = Math.imul(t ^ r, 2654435761), s = Math.imul(s ^ r, 1597334677);
  return t = Math.imul(t ^ t >>> 16, 2246822507), t ^= Math.imul(s ^ s >>> 13, 3266489909), s = Math.imul(s ^ s >>> 16, 2246822507), s ^= Math.imul(t ^ t >>> 13, 3266489909), 4294967296 * (2097151 & s) + (t >>> 0);
}
const wl = (o) => Fn(o), ni = (o) => Fn(o), aa = (...o) => Fn(o);
function Ml(o, e = !1) {
  const t = [];
  o.isNode === !0 && (t.push(o.id), o = o.getSelf());
  for (const { property: s, childNode: n } of Vr(o))
    t.push(t, Fn(s.slice(0, -4)), n.getCacheKey(e));
  return Fn(t);
}
function* Vr(o, e = !1) {
  for (const t in o) {
    if (t.startsWith("_") === !0) continue;
    const s = o[t];
    if (Array.isArray(s) === !0)
      for (let n = 0; n < s.length; n++) {
        const r = s[n];
        r && (r.isNode === !0 || e && typeof r.toJSON == "function") && (yield { property: t, index: n, childNode: r });
      }
    else if (s && s.isNode === !0)
      yield { property: t, childNode: s };
    else if (typeof s == "object")
      for (const n in s) {
        const r = s[n];
        r && (r.isNode === !0 || e && typeof r.toJSON == "function") && (yield { property: t, index: n, childNode: r });
      }
  }
}
const wm = /* @__PURE__ */ new Map([
  [1, "float"],
  [2, "vec2"],
  [3, "vec3"],
  [4, "vec4"],
  [9, "mat3"],
  [16, "mat4"]
]), Pu = /* @__PURE__ */ new WeakMap();
function Bl(o) {
  return wm.get(o);
}
function Fl(o) {
  if (/[iu]?vec\d/.test(o))
    return o.startsWith("ivec") ? Int32Array : o.startsWith("uvec") ? Uint32Array : Float32Array;
  if (/mat\d/.test(o) || /float/.test(o)) return Float32Array;
  if (/uint/.test(o)) return Uint32Array;
  if (/int/.test(o)) return Int32Array;
  throw new Error(`THREE.NodeUtils: Unsupported type: ${o}`);
}
function Ul(o) {
  if (/float|int|uint/.test(o)) return 1;
  if (/vec2/.test(o)) return 2;
  if (/vec3/.test(o)) return 3;
  if (/vec4/.test(o)) return 4;
  if (/mat3/.test(o)) return 9;
  if (/mat4/.test(o)) return 16;
  console.error("THREE.TSL: Unsupported type:", o);
}
function Yt(o) {
  if (o == null) return null;
  const e = typeof o;
  return o.isNode === !0 ? "node" : e === "number" ? "float" : e === "boolean" ? "bool" : e === "string" ? "string" : e === "function" ? "shader" : o.isVector2 === !0 ? "vec2" : o.isVector3 === !0 ? "vec3" : o.isVector4 === !0 ? "vec4" : o.isMatrix3 === !0 ? "mat3" : o.isMatrix4 === !0 ? "mat4" : o.isColor === !0 ? "color" : o instanceof ArrayBuffer ? "ArrayBuffer" : null;
}
function Pl(o, ...e) {
  const t = o ? o.slice(-4) : void 0;
  return e.length === 1 && (t === "vec2" ? e = [e[0], e[0]] : t === "vec3" ? e = [e[0], e[0], e[0]] : t === "vec4" && (e = [e[0], e[0], e[0], e[0]])), o === "color" ? new Ct(...e) : t === "vec2" ? new He(...e) : t === "vec3" ? new Y(...e) : t === "vec4" ? new Ce(...e) : t === "mat3" ? new $n(...e) : t === "mat4" ? new Ue(...e) : o === "bool" ? e[0] || !1 : o === "float" || o === "int" || o === "uint" ? e[0] || 0 : o === "string" ? e[0] || "" : o === "ArrayBuffer" ? Ll(e[0]) : null;
}
function Dl(o) {
  let e = Pu.get(o);
  return e === void 0 && (e = {}, Pu.set(o, e)), e;
}
function Il(o) {
  let e = "";
  const t = new Uint8Array(o);
  for (let s = 0; s < t.length; s++)
    e += String.fromCharCode(t[s]);
  return btoa(e);
}
function Ll(o) {
  return Uint8Array.from(atob(o), (e) => e.charCodeAt(0)).buffer;
}
const Fo = {
  VERTEX: "vertex",
  FRAGMENT: "fragment"
}, z = {
  NONE: "none",
  FRAME: "frame",
  RENDER: "render",
  OBJECT: "object"
}, Mm = {
  BOOLEAN: "bool",
  INTEGER: "int",
  FLOAT: "float",
  VECTOR2: "vec2",
  VECTOR3: "vec3",
  VECTOR4: "vec4",
  MATRIX2: "mat2",
  MATRIX3: "mat3",
  MATRIX4: "mat4"
}, De = {
  READ_ONLY: "readOnly",
  WRITE_ONLY: "writeOnly",
  READ_WRITE: "readWrite"
}, Vl = ["fragment", "vertex"], Uo = ["setup", "analyze", "generate"], Po = [...Vl, "compute"], xs = ["x", "y", "z", "w"];
let Bm = 0;
class G extends zc {
  static get type() {
    return "Node";
  }
  /**
   * Constructs a new node.
   *
   * @param {String?} nodeType - The node type.
   */
  constructor(e = null) {
    super(), this.nodeType = e, this.updateType = z.NONE, this.updateBeforeType = z.NONE, this.updateAfterType = z.NONE, this.uuid = $c.generateUUID(), this.version = 0, this.global = !1, this.isNode = !0, this._cacheKey = null, this._cacheKeyVersion = 0, Object.defineProperty(this, "id", { value: Bm++ });
  }
  /**
   * Set this property to `true` when the node should be regenerated.
   *
   * @type {Boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * The type of the class. The value is usually the constructor name.
   *
   * @type {String}
  	 * @readonly
   */
  get type() {
    return this.constructor.type;
  }
  /**
   * Convenient method for defining {@link Node#update}.
   *
   * @param {Function} callback - The update method.
   * @param {String} updateType - The update type.
   * @return {Node} A reference to this node.
   */
  onUpdate(e, t) {
    return this.updateType = t, this.update = e.bind(this.getSelf()), this;
  }
  /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `FRAME`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onFrameUpdate(e) {
    return this.onUpdate(e, z.FRAME);
  }
  /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `RENDER`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onRenderUpdate(e) {
    return this.onUpdate(e, z.RENDER);
  }
  /**
   * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
   * this method automatically sets the update type to `OBJECT`.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onObjectUpdate(e) {
    return this.onUpdate(e, z.OBJECT);
  }
  /**
   * Convenient method for defining {@link Node#updateReference}.
   *
   * @param {Function} callback - The update method.
   * @return {Node} A reference to this node.
   */
  onReference(e) {
    return this.updateReference = e.bind(this.getSelf()), this;
  }
  /**
   * The `this` reference might point to a Proxy so this method can be used
   * to get the reference to the actual node instance.
   *
   * @return {Node} A reference to the node.
   */
  getSelf() {
    return this.self || this;
  }
  /**
   * Nodes might refer to other objects like materials. This method allows to dynamically update the reference
   * to such objects based on a given state (e.g. the current node frame or builder).
   *
   * @param {Any} state - This method can be invocated in different contexts so `state` can refer to any object type.
   * @return {Any} The updated reference.
   */
  updateReference() {
    return this;
  }
  /**
   * By default this method returns the value of the {@link Node#global} flag. This method
   * can be overwritten in derived classes if an analytical way is required to determine the
   * global status.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Boolean} Whether this node is global or not.
   */
  isGlobal() {
    return this.global;
  }
  /**
   * Generator function that can be used to iterate over the child nodes.
   *
   * @generator
   * @yields {Node} A child node.
   */
  *getChildren() {
    for (const { childNode: e } of Vr(this))
      yield e;
  }
  /**
   * Calling this method dispatches the `dispose` event. This event can be used
   * to register event listeners for clean up tasks.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Callback for {@link Node#traverse}.
   *
   * @callback traverseCallback
   * @param {Node} node - The current node.
   */
  /**
   * Can be used to traverse through the node's hierarchy.
   *
   * @param {traverseCallback} callback - A callback that is executed per node.
   */
  traverse(e) {
    e(this);
    for (const t of this.getChildren())
      t.traverse(e);
  }
  /**
   * Returns the cache key for this node.
   *
   * @param {Boolean} [force=false] - When set to `true`, a recomputation of the cache key is forced.
   * @return {Number} The cache key of the node.
   */
  getCacheKey(e = !1) {
    return e = e || this.version !== this._cacheKeyVersion, (e === !0 || this._cacheKey === null) && (this._cacheKey = aa(Ml(this, e), this.customCacheKey()), this._cacheKeyVersion = this.version), this._cacheKey;
  }
  /**
   * Generate a custom cache key for this node.
   *
   * @return {Number} The cache key of the node.
   */
  customCacheKey() {
    return 0;
  }
  /**
   * Returns the references to this node which is by default `this`.
   *
   * @return {Node} A reference to this node.
   */
  getScope() {
    return this;
  }
  /**
   * Returns the hash of the node which is used to identify the node. By default it's
   * the {@link Node#uuid} however derived node classes might have to overwrite this method
   * depending on their implementation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The hash.
   */
  getHash() {
    return this.uuid;
  }
  /**
   * Returns the update type of {@link Node#update}.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateType() {
    return this.updateType;
  }
  /**
   * Returns the update type of {@link Node#updateBefore}.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateBeforeType() {
    return this.updateBeforeType;
  }
  /**
   * Returns the update type of {@link Node#updateAfter}.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateAfterType() {
    return this.updateAfterType;
  }
  /**
   * Certain types are composed of multiple elements. For example a `vec3`
   * is composed of three `float` values. This method returns the type of
   * these elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The type of the node.
   */
  getElementType(e) {
    const t = this.getNodeType(e);
    return e.getElementType(t);
  }
  /**
   * Returns the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The type of the node.
   */
  getNodeType(e) {
    const t = e.getNodeProperties(this);
    return t.outputNode ? t.outputNode.getNodeType(e) : this.nodeType;
  }
  /**
   * This method is used during the build process of a node and ensures
   * equal nodes are not built multiple times but just once. For example if
   * `attribute( 'uv' )` is used multiple times by the user, the build
   * process makes sure to process just the first node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The shared node if possible. Otherwise `this` is returned.
   */
  getShared(e) {
    const t = this.getHash(e);
    return e.getNodeFromHash(t) || this;
  }
  /**
   * Represents the setup stage which is the first step of the build process, see {@link Node#build} method.
   * This method is often overwritten in derived modules to prepare the node which is used as the output/result.
   * The output node must be returned in the `return` statement.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node?} The output node.
   */
  setup(e) {
    const t = e.getNodeProperties(this);
    let s = 0;
    for (const n of this.getChildren())
      t["node" + s++] = n;
    return t.outputNode || null;
  }
  /**
   * Represents the analyze stage which is the second step of the build process, see {@link Node#build} method.
   * This stage analyzes the node hierarchy and ensures descendent nodes are built.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  analyze(e) {
    if (e.increaseUsage(this) === 1) {
      const s = e.getNodeProperties(this);
      for (const n of Object.values(s))
        n && n.isNode === !0 && n.build(e);
    }
  }
  /**
   * Represents the generate stage which is the third step of the build process, see {@link Node#build} method.
   * This state builds the output node and returns the resulting shader string.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String?} output - Can be used to define the output type.
   * @return {String?} The generated shader string.
   */
  generate(e, t) {
    const { outputNode: s } = e.getNodeProperties(this);
    if (s && s.isNode === !0)
      return s.build(e, t);
  }
  /**
   * The method can be implemented to update the node's internal state before it is used to render an object.
   * The {@link Node#updateBeforeType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {Boolean?} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */
  updateBefore() {
    console.warn("Abstract function.");
  }
  /**
   * The method can be implemented to update the node's internal state after it was used to render an object.
   * The {@link Node#updateAfterType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {Boolean?} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */
  updateAfter() {
    console.warn("Abstract function.");
  }
  /**
   * The method can be implemented to update the node's internal state when it is used to render an object.
   * The {@link Node#updateType} property defines how often the update is executed.
   *
   * @abstract
   * @param {NodeFrame} frame - A reference to the current node frame.
   * @return {Boolean?} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
   */
  update() {
    console.warn("Abstract function.");
  }
  /**
   * This method performs the build of a node. The behavior of this method as well as its return value depend
   * on the current build stage (setup, analyze or generate).
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String?} output - Can be used to define the output type.
   * @return {String?} When this method is executed in the setup or analyze stage, `null` is returned. In the generate stage, the generated shader string.
   */
  build(e, t = null) {
    const s = this.getShared(e);
    if (this !== s)
      return s.build(e, t);
    e.addNode(this), e.addChain(this);
    let n = null;
    const r = e.getBuildStage();
    if (r === "setup") {
      this.updateReference(e);
      const i = e.getNodeProperties(this);
      if (i.initialized !== !0) {
        i.initialized = !0;
        const a = this.setup(e), u = a && a.isNode === !0;
        for (const c of Object.values(i))
          c && c.isNode === !0 && c.build(e);
        u && a.build(e), i.outputNode = a;
      }
    } else if (r === "analyze")
      this.analyze(e);
    else if (r === "generate")
      if (this.generate.length === 1) {
        const a = this.getNodeType(e), u = e.getDataFromNode(this);
        n = u.snippet, n === void 0 ? (n = this.generate(e) || "", u.snippet = n) : u.flowCodes !== void 0 && e.context.nodeBlock !== void 0 && e.addFlowCodeHierarchy(this, e.context.nodeBlock), n = e.format(n, a, t);
      } else
        n = this.generate(e, t) || "";
    return e.removeChain(this), e.addSequentialNode(this), n;
  }
  /**
   * Returns the child nodes as a JSON object.
   *
   * @return {Object} The serialized child objects as JSON.
   */
  getSerializeChildren() {
    return Vr(this);
  }
  /**
   * Serializes the node to JSON.
   *
   * @param {Object} json - The output JSON object.
   */
  serialize(e) {
    const t = this.getSerializeChildren(), s = {};
    for (const { property: n, index: r, childNode: i } of t)
      r !== void 0 ? (s[n] === void 0 && (s[n] = Number.isInteger(r) ? [] : {}), s[n][r] = i.toJSON(e.meta).uuid) : s[n] = i.toJSON(e.meta).uuid;
    Object.keys(s).length > 0 && (e.inputNodes = s);
  }
  /**
   * Deserializes the node from the given JSON.
   *
   * @param {Object} json - The JSON object.
   */
  deserialize(e) {
    if (e.inputNodes !== void 0) {
      const t = e.meta.nodes;
      for (const s in e.inputNodes)
        if (Array.isArray(e.inputNodes[s])) {
          const n = [];
          for (const r of e.inputNodes[s])
            n.push(t[r]);
          this[s] = n;
        } else if (typeof e.inputNodes[s] == "object") {
          const n = {};
          for (const r in e.inputNodes[s]) {
            const i = e.inputNodes[s][r];
            n[r] = t[i];
          }
          this[s] = n;
        } else {
          const n = e.inputNodes[s];
          this[s] = t[n];
        }
    }
  }
  /**
   * Serializes the node into the three.js JSON Object/Scene format.
   *
   * @param {Object?} meta - An optional JSON object that already holds serialized data from other scene objects.
   * @return {Object} The serialized node.
   */
  toJSON(e) {
    const { uuid: t, type: s } = this, n = e === void 0 || typeof e == "string";
    n && (e = {
      textures: {},
      images: {},
      nodes: {}
    });
    let r = e.nodes[t];
    r === void 0 && (r = {
      uuid: t,
      type: s,
      meta: e,
      metadata: {
        version: 4.6,
        type: "Node",
        generator: "Node.toJSON"
      }
    }, n !== !0 && (e.nodes[r.uuid] = r), this.serialize(r), delete r.meta);
    function i(a) {
      const u = [];
      for (const c in a) {
        const l = a[c];
        delete l.metadata, u.push(l);
      }
      return u;
    }
    if (n) {
      const a = i(e.textures), u = i(e.images), c = i(e.nodes);
      a.length > 0 && (r.textures = a), u.length > 0 && (r.images = u), c.length > 0 && (r.nodes = c);
    }
    return r;
  }
}
class Ts extends G {
  // @TODO: If extending from TempNode it breaks webgpu_compute
  static get type() {
    return "ArrayElementNode";
  }
  /**
   * Constructs an array element node.
   *
   * @param {Node} node - The array-like node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(), this.node = e, this.indexNode = t, this.isArrayElementNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from the array-like node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.node.getElementType(e);
  }
  generate(e) {
    const t = this.node.build(e), s = this.indexNode.build(e, "uint");
    return `${t}[ ${s} ]`;
  }
}
class Gl extends G {
  static get type() {
    return "ConvertNode";
  }
  /**
   * Constructs a new convert node.
   *
   * @param {Node} node - The node which type should be converted.
   * @param {String} convertTo - The target node type. Multiple types can be defined by separating them with a `|` sign.
   */
  constructor(e, t) {
    super(), this.node = e, this.convertTo = t;
  }
  /**
   * This method is overwritten since the implementation tries to infer the best
   * matching type from the {@link ConvertNode#convertTo} property.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    const t = this.node.getNodeType(e);
    let s = null;
    for (const n of this.convertTo.split("|"))
      (s === null || e.getTypeLength(t) === e.getTypeLength(n)) && (s = n);
    return s;
  }
  serialize(e) {
    super.serialize(e), e.convertTo = this.convertTo;
  }
  deserialize(e) {
    super.deserialize(e), this.convertTo = e.convertTo;
  }
  generate(e, t) {
    const s = this.node, n = this.getNodeType(e), r = s.build(e, n);
    return e.format(r, n, t);
  }
}
class Ne extends G {
  static get type() {
    return "TempNode";
  }
  /**
   * Constructs a temp node.
   *
   * @param {String?} nodeType - The node type.
   */
  constructor(e = null) {
    super(e), this.isTempNode = !0;
  }
  /**
   * Whether this node is used more than once in context of other nodes.
   *
   * @param {NodeBuilder} builder - The node builder.
   * @return {Boolean} A flag that indicates if there is more than one dependency to other nodes.
   */
  hasDependencies(e) {
    return e.getDataFromNode(this).usageCount > 1;
  }
  build(e, t) {
    if (e.getBuildStage() === "generate") {
      const n = e.getVectorType(this.getNodeType(e, t)), r = e.getDataFromNode(this);
      if (r.propertyName !== void 0)
        return e.format(r.propertyName, n, t);
      if (n !== "void" && t !== "void" && this.hasDependencies(e)) {
        const i = super.build(e, n), a = e.getVarFromNode(this, null, n), u = e.getPropertyName(a);
        return e.addLineFlowCode(`${u} = ${i}`, this), r.snippet = i, r.propertyName = u, e.format(r.propertyName, n, t);
      }
    }
    return super.build(e, t);
  }
}
class Fm extends Ne {
  static get type() {
    return "JoinNode";
  }
  /**
   * Constructs a new join node.
   *
   * @param {Array<Node>} nodes - An array of nodes that should be joined.
   * @param {String?} [nodeType=null] - The node type.
   */
  constructor(e = [], t = null) {
    super(t), this.nodes = e;
  }
  /**
   * This method is overwritten since the node type must be inferred from the
   * joined data length if not explicitly defined.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.nodeType !== null ? e.getVectorType(this.nodeType) : e.getTypeFromLength(this.nodes.reduce((t, s) => t + e.getTypeLength(s.getNodeType(e)), 0));
  }
  generate(e, t) {
    const s = this.getNodeType(e), n = this.nodes, r = e.getComponentType(s), i = [];
    for (const u of n) {
      let c = u.build(e);
      const l = e.getComponentType(u.getNodeType(e));
      l !== r && (c = e.format(c, l, r)), i.push(c);
    }
    const a = `${e.getType(s)}( ${i.join(", ")} )`;
    return e.format(a, s, t);
  }
}
const Um = xs.join("");
class Do extends G {
  static get type() {
    return "SplitNode";
  }
  /**
   * Constructs a new split node.
   *
   * @param {Node} node - The node that should be accessed.
   * @param {String} [components='x'] - The components that should be accessed.
   */
  constructor(e, t = "x") {
    super(), this.node = e, this.components = t, this.isSplitNode = !0;
  }
  /**
   * Returns the vector length which is computed based on the requested components.
   *
   * @return {Number} The vector length.
   */
  getVectorLength() {
    let e = this.components.length;
    for (const t of this.components)
      e = Math.max(xs.indexOf(t) + 1, e);
    return e;
  }
  /**
   * Returns the component type of the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The component type.
   */
  getComponentType(e) {
    return e.getComponentType(this.node.getNodeType(e));
  }
  /**
   * This method is overwritten since the node type is inferred from requested components.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return e.getTypeFromLength(this.components.length, this.getComponentType(e));
  }
  generate(e, t) {
    const s = this.node, n = e.getTypeLength(s.getNodeType(e));
    let r = null;
    if (n > 1) {
      let i = null;
      this.getVectorLength() >= n && (i = e.getTypeFromLength(this.getVectorLength(), this.getComponentType(e)));
      const u = s.build(e, i);
      this.components.length === n && this.components === Um.slice(0, this.components.length) ? r = e.format(u, i, t) : r = e.format(`${u}.${this.components}`, this.getNodeType(e), t);
    } else
      r = s.build(e, t);
    return r;
  }
  serialize(e) {
    super.serialize(e), e.components = this.components;
  }
  deserialize(e) {
    super.deserialize(e), this.components = e.components;
  }
}
class Pm extends Ne {
  static get type() {
    return "SetNode";
  }
  /**
   * Constructs a new set node.
   *
   * @param {Node} sourceNode - The node that should be updated.
   * @param {String} components - The components that should be updated.
   * @param {Node} targetNode - The value node.
   */
  constructor(e, t, s) {
    super(), this.sourceNode = e, this.components = t, this.targetNode = s;
  }
  /**
   * This method is overwritten since the node type is inferred from {@link SetNode#sourceNode}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.sourceNode.getNodeType(e);
  }
  generate(e) {
    const { sourceNode: t, components: s, targetNode: n } = this, r = this.getNodeType(e), i = e.getComponentType(n.getNodeType(e)), a = e.getTypeFromLength(s.length, i), u = n.build(e, a), c = t.build(e, r), l = e.getTypeLength(r), d = [];
    for (let h = 0; h < l; h++) {
      const p = xs[h];
      p === s[0] ? (d.push(u), h += s.length - 1) : d.push(c + "." + p);
    }
    return `${e.getType(r)}( ${d.join(", ")} )`;
  }
}
class Dm extends Ne {
  static get type() {
    return "FlipNode";
  }
  /**
   * Constructs a new flip node.
   *
   * @param {Node} sourceNode - The node which component(s) should be flipped.
   * @param {String} components - The components that should be flipped e.g. `'x'` or `'xy'`.
   */
  constructor(e, t) {
    super(), this.sourceNode = e, this.components = t;
  }
  /**
   * This method is overwritten since the node type is inferred from the source node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.sourceNode.getNodeType(e);
  }
  generate(e) {
    const { components: t, sourceNode: s } = this, n = this.getNodeType(e), r = s.build(e), i = e.getVarFromNode(this), a = e.getPropertyName(i);
    e.addLineFlowCode(a + " = " + r, this);
    const u = e.getTypeLength(n), c = [];
    let l = 0;
    for (let d = 0; d < u; d++) {
      const h = xs[d];
      h === t[l] ? (c.push("1.0 - " + (a + "." + h)), l++) : c.push(a + "." + h);
    }
    return `${e.getType(n)}( ${c.join(", ")} )`;
  }
}
class ua extends G {
  static get type() {
    return "InputNode";
  }
  /**
   * Constructs a new input node.
   *
   * @param {Any} value - The value of this node. This can be a any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
   * @param {String?} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */
  constructor(e, t = null) {
    super(t), this.isInputNode = !0, this.value = e, this.precision = null;
  }
  getNodeType() {
    return this.nodeType === null ? Yt(this.value) : this.nodeType;
  }
  /**
   * Returns the input type of the node which is by default the node type. Derived modules
   * might overwrite this method and use a fixed type or compute one analytically.
   *
   * A typical example for different input and node types are textures. The input type of a
   * normal RGBA texture is `texture` whereas its node type is `vec4`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType(e) {
    return this.getNodeType(e);
  }
  /**
   * Sets the precision to the given value. The method can be
   * overwritten in derived classes if the final precision must be computed
   * analytically.
   *
   * @param {('low'|'medium'|'high')} precision - The precision of the input value in the shader.
   * @return {InputNode} A reference to this node.
   */
  setPrecision(e) {
    return this.precision = e, this;
  }
  serialize(e) {
    super.serialize(e), e.value = this.value, this.value && this.value.toArray && (e.value = this.value.toArray()), e.valueType = Yt(this.value), e.nodeType = this.nodeType, e.valueType === "ArrayBuffer" && (e.value = Il(e.value)), e.precision = this.precision;
  }
  deserialize(e) {
    super.deserialize(e), this.nodeType = e.nodeType, this.value = Array.isArray(e.value) ? Pl(e.valueType, ...e.value) : e.value, this.precision = e.precision || null, this.value && this.value.fromArray && (this.value = this.value.fromArray(e.value));
  }
  generate() {
    console.warn("Abstract function.");
  }
}
class ct extends ua {
  static get type() {
    return "ConstNode";
  }
  /**
   * Constructs a new input node.
   *
   * @param {Any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color).
   * @param {String?} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */
  constructor(e, t = null) {
    super(e, t), this.isConstNode = !0;
  }
  /**
   * Generates the shader string of the value with the current node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The generated value as a shader string.
   */
  generateConst(e) {
    return e.generateConst(this.getNodeType(e), this.value);
  }
  generate(e, t) {
    const s = this.getNodeType(e);
    return e.format(this.generateConst(e), s, t);
  }
}
let Qs = null;
const Vs = /* @__PURE__ */ new Map();
function R(o, e) {
  if (Vs.has(o)) {
    console.warn(`Redefinition of method chaining ${o}`);
    return;
  }
  if (typeof e != "function") throw new Error(`Node element ${o} is not a function`);
  Vs.set(o, e);
}
const Ol = (o) => o.replace(/r|s/g, "x").replace(/g|t/g, "y").replace(/b|p/g, "z").replace(/a|q/g, "w"), Du = (o) => Ol(o).split("").sort().join(""), kl = {
  setup(o, e) {
    const t = e.shift();
    return o(qn(t), ...e);
  },
  get(o, e, t) {
    if (typeof e == "string" && o[e] === void 0) {
      if (o.isStackNode !== !0 && e === "assign")
        return (...s) => (Qs.assign(t, ...s), t);
      if (Vs.has(e)) {
        const s = Vs.get(e);
        return o.isStackNode ? (...n) => t.add(s(...n)) : (...n) => s(t, ...n);
      } else {
        if (e === "self")
          return o;
        if (e.endsWith("Assign") && Vs.has(e.slice(0, e.length - 6))) {
          const s = Vs.get(e.slice(0, e.length - 6));
          return o.isStackNode ? (...n) => t.assign(n[0], s(...n)) : (...n) => t.assign(s(t, ...n));
        } else {
          if (/^[xyzwrgbastpq]{1,4}$/.test(e) === !0)
            return e = Ol(e), E(new Do(t, e));
          if (/^set[XYZWRGBASTPQ]{1,4}$/.test(e) === !0)
            return e = Du(e.slice(3).toLowerCase()), (s) => E(new Pm(o, e, s));
          if (/^flip[XYZWRGBASTPQ]{1,4}$/.test(e) === !0)
            return e = Du(e.slice(4).toLowerCase()), () => E(new Dm(E(o), e));
          if (e === "width" || e === "height" || e === "depth")
            return e === "width" ? e = "x" : e === "height" ? e = "y" : e === "depth" && (e = "z"), E(new Do(o, e));
          if (/^\d+$/.test(e) === !0)
            return E(new Ts(t, new ct(Number(e), "uint")));
        }
      }
    }
    return Reflect.get(o, e, t);
  },
  set(o, e, t, s) {
    return typeof e == "string" && o[e] === void 0 && (/^[xyzwrgbastpq]{1,4}$/.test(e) === !0 || e === "width" || e === "height" || e === "depth" || /^\d+$/.test(e) === !0) ? (s[e].assign(t), !0) : Reflect.set(o, e, t, s);
  }
}, Mi = /* @__PURE__ */ new WeakMap(), Iu = /* @__PURE__ */ new WeakMap(), Im = function(o, e = null) {
  const t = Yt(o);
  if (t === "node") {
    let s = Mi.get(o);
    return s === void 0 && (s = new Proxy(o, kl), Mi.set(o, s), Mi.set(s, s)), s;
  } else {
    if (e === null && (t === "float" || t === "boolean") || t && t !== "shader" && t !== "string")
      return E(Io(o, e));
    if (t === "shader")
      return b(o);
  }
  return o;
}, Lm = function(o, e = null) {
  for (const t in o)
    o[t] = E(o[t], e);
  return o;
}, Vm = function(o, e = null) {
  const t = o.length;
  for (let s = 0; s < t; s++)
    o[s] = E(o[s], e);
  return o;
}, Gm = function(o, e = null, t = null, s = null) {
  const n = (r) => E(s !== null ? Object.assign(r, s) : r);
  return e === null ? (...r) => n(new o(...hs(r))) : t !== null ? (t = E(t), (...r) => n(new o(e, ...hs(r), t))) : (...r) => n(new o(e, ...hs(r)));
}, Om = function(o, ...e) {
  return E(new o(...hs(e)));
};
class km extends G {
  constructor(e, t) {
    super(), this.shaderNode = e, this.inputNodes = t;
  }
  getNodeType(e) {
    return this.shaderNode.nodeType || this.getOutputNode(e).getNodeType(e);
  }
  call(e) {
    const { shaderNode: t, inputNodes: s } = this, n = e.getNodeProperties(t);
    if (n.onceOutput) return n.onceOutput;
    let r = null;
    if (t.layout) {
      let i = Iu.get(e.constructor);
      i === void 0 && (i = /* @__PURE__ */ new WeakMap(), Iu.set(e.constructor, i));
      let a = i.get(t);
      a === void 0 && (a = E(e.buildFunctionNode(t)), i.set(t, a)), e.currentFunctionNode !== null && e.currentFunctionNode.includes.push(a), r = E(a.call(s));
    } else {
      const i = t.jsFunc, a = s !== null ? i(s, e) : i(e);
      r = E(a);
    }
    return t.once && (n.onceOutput = r), r;
  }
  getOutputNode(e) {
    const t = e.getNodeProperties(this);
    return t.outputNode === null && (t.outputNode = this.setupOutput(e)), t.outputNode;
  }
  setup(e) {
    return this.getOutputNode(e);
  }
  setupOutput(e) {
    return e.addStack(), e.stack.outputNode = this.call(e), e.removeStack();
  }
  generate(e, t) {
    return this.getOutputNode(e).build(e, t);
  }
}
class zm extends G {
  constructor(e, t) {
    super(t), this.jsFunc = e, this.layout = null, this.global = !0, this.once = !1;
  }
  setLayout(e) {
    return this.layout = e, this;
  }
  call(e = null) {
    return qn(e), E(new km(this, e));
  }
  setup() {
    return this.call();
  }
}
const $m = [!1, !0], Wm = [0, 1, 2, 3], Hm = [-1, -2], zl = [0.5, 1.5, 1 / 3, 1e-6, 1e6, Math.PI, Math.PI * 2, 1 / Math.PI, 2 / Math.PI, 1 / (Math.PI * 2), Math.PI / 2], ca = /* @__PURE__ */ new Map();
for (const o of $m) ca.set(o, new ct(o));
const la = /* @__PURE__ */ new Map();
for (const o of Wm) la.set(o, new ct(o, "uint"));
const da = new Map([...la].map((o) => new ct(o.value, "int")));
for (const o of Hm) da.set(o, new ct(o, "int"));
const ri = new Map([...da].map((o) => new ct(o.value)));
for (const o of zl) ri.set(o, new ct(o));
for (const o of zl) ri.set(-o, new ct(-o));
const ii = { bool: ca, uint: la, ints: da, float: ri }, Lu = new Map([...ca, ...ri]), Io = (o, e) => Lu.has(o) ? Lu.get(o) : o.isNode === !0 ? o : new ct(o, e), qm = (o) => {
  try {
    return o.getNodeType();
  } catch {
    return;
  }
}, ve = function(o, e = null) {
  return (...t) => {
    if ((t.length === 0 || !["bool", "float", "int", "uint"].includes(o) && t.every((n) => typeof n != "object")) && (t = [Pl(o, ...t)]), t.length === 1 && e !== null && e.has(t[0]))
      return E(e.get(t[0]));
    if (t.length === 1) {
      const n = Io(t[0], o);
      return qm(n) === o ? E(n) : E(new Gl(n, o));
    }
    const s = t.map((n) => Io(n));
    return E(new Fm(s, o));
  };
}, Un = (o) => typeof o == "object" && o !== null ? o.value : o, $l = (o) => o != null ? o.nodeType || o.convertTo || (typeof o == "string" ? o : null) : null;
function Nn(o, e) {
  return new Proxy(new zm(o, e), kl);
}
const E = (o, e = null) => (
  /* new */
  Im(o, e)
), qn = (o, e = null) => new Lm(o, e), hs = (o, e = null) => new Vm(o, e), C = (...o) => new Gm(...o), B = (...o) => new Om(...o), b = (o, e) => {
  const t = new Nn(o, e), s = (...n) => {
    let r;
    return qn(n), n[0] && n[0].isNode ? r = [...n] : r = n[0], t.call(r);
  };
  return s.shaderNode = t, s.setLayout = (n) => (t.setLayout(n), s), s.once = () => (t.once = !0, s), s;
}, Xm = (...o) => (console.warn("TSL.ShaderNode: tslFn() has been renamed to Fn()."), b(...o));
R("toGlobal", (o) => (o.global = !0, o));
const Pn = (o) => {
  Qs = o;
}, ha = () => Qs, H = (...o) => Qs.If(...o);
function Wl(o) {
  return Qs && Qs.add(o), o;
}
R("append", Wl);
const Hl = new ve("color"), g = new ve("float", ii.float), y = new ve("int", ii.ints), U = new ve("uint", ii.uint), Vt = new ve("bool", ii.bool), w = new ve("vec2"), Ae = new ve("ivec2"), ql = new ve("uvec2"), Xl = new ve("bvec2"), T = new ve("vec3"), Kl = new ve("ivec3"), nn = new ve("uvec3"), pa = new ve("bvec3"), I = new ve("vec4"), Yl = new ve("ivec4"), jl = new ve("uvec4"), Ql = new ve("bvec4"), oi = new ve("mat2"), Le = new ve("mat3"), ps = new ve("mat4"), Km = (o = "") => E(new ct(o, "string")), Ym = (o) => E(new ct(o, "ArrayBuffer"));
R("toColor", Hl);
R("toFloat", g);
R("toInt", y);
R("toUint", U);
R("toBool", Vt);
R("toVec2", w);
R("toIVec2", Ae);
R("toUVec2", ql);
R("toBVec2", Xl);
R("toVec3", T);
R("toIVec3", Kl);
R("toUVec3", nn);
R("toBVec3", pa);
R("toVec4", I);
R("toIVec4", Yl);
R("toUVec4", jl);
R("toBVec4", Ql);
R("toMat2", oi);
R("toMat3", Le);
R("toMat4", ps);
const Zl = /* @__PURE__ */ C(Ts), Jl = (o, e) => E(new Gl(E(o), e)), jm = (o, e) => E(new Do(E(o), e));
R("element", Zl);
R("convert", Jl);
class ed extends G {
  static get type() {
    return "UniformGroupNode";
  }
  /**
   * Constructs a new uniform group node.
   *
   * @param {String} name - The name of the uniform group node.
   * @param {Boolean} [shared=false] - Whether this uniform group node is shared or not.
   * @param {Number} [order=1] - Influences the internal sorting.
   */
  constructor(e, t = !1, s = 1) {
    super("string"), this.name = e, this.shared = t, this.order = s, this.isUniformGroup = !0;
  }
  serialize(e) {
    super.serialize(e), e.name = this.name, e.version = this.version, e.shared = this.shared;
  }
  deserialize(e) {
    super.deserialize(e), this.name = e.name, this.version = e.version, this.shared = e.shared;
  }
}
const td = (o) => new ed(o), fa = (o, e = 0) => new ed(o, !0, e), sd = /* @__PURE__ */ fa("frame"), O = /* @__PURE__ */ fa("render"), ga = /* @__PURE__ */ td("object");
class Xn extends ua {
  static get type() {
    return "UniformNode";
  }
  /**
   * Constructs a new uniform node.
   *
   * @param {Any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color, texture).
   * @param {String?} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
   */
  constructor(e, t = null) {
    super(e, t), this.isUniformNode = !0, this.name = "", this.groupNode = ga;
  }
  /**
   * Sets the {@link UniformNode#name} property.
   *
   * @param {String} name - The name of the uniform.
   * @return {UniformNode} A reference to this node.
   */
  label(e) {
    return this.name = e, this;
  }
  /**
   * Sets the {@link UniformNode#groupNode} property.
   *
   * @param {UniformGroupNode} group - The uniform group.
   * @return {UniformNode} A reference to this node.
   */
  setGroup(e) {
    return this.groupNode = e, this;
  }
  /**
   * Returns the {@link UniformNode#groupNode}.
   *
   * @return {UniformGroupNode} The uniform group.
   */
  getGroup() {
    return this.groupNode;
  }
  /**
   * By default, this method returns the result of {@link Node#getHash} but derived
   * classes might overwrite this method with a different implementation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The uniform hash.
   */
  getUniformHash(e) {
    return this.getHash(e);
  }
  onUpdate(e, t) {
    const s = this.getSelf();
    return e = e.bind(s), super.onUpdate((n) => {
      const r = e(n, s);
      r !== void 0 && (this.value = r);
    }, t);
  }
  generate(e, t) {
    const s = this.getNodeType(e), n = this.getUniformHash(e);
    let r = e.getNodeFromHash(n);
    r === void 0 && (e.setHashNode(this, n), r = this);
    const i = r.getInputType(e), a = e.getUniformFromNode(r, i, e.shaderStage, this.name || e.context.label), u = e.getPropertyName(a);
    return e.context.label !== void 0 && delete e.context.label, e.format(u, s, t);
  }
}
const L = (o, e) => {
  const t = $l(e || o), s = o && o.isNode === !0 ? o.node && o.node.value || o.value : o;
  return E(new Xn(s, t));
};
class ee extends G {
  static get type() {
    return "PropertyNode";
  }
  /**
   * Constructs a new property node.
   *
   * @param {String} nodeType - The type of the node.
   * @param {String?} [name=null] - The name of the property in the shader.
   * @param {Boolean} [varying=false] - Whether this property is a varying or not.
   */
  constructor(e, t = null, s = !1) {
    super(e), this.name = t, this.varying = s, this.isPropertyNode = !0;
  }
  getHash(e) {
    return this.name || super.getHash(e);
  }
  /**
   * The method is overwritten so it always returns `true`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Boolean} Whether this node is global or not.
   */
  isGlobal() {
    return !0;
  }
  generate(e) {
    let t;
    return this.varying === !0 ? (t = e.getVaryingFromNode(this, this.name), t.needsInterpolation = !0) : t = e.getVarFromNode(this, this.name), e.getPropertyName(t);
  }
}
const nd = (o, e) => E(new ee(o, e)), Dn = (o, e) => E(new ee(o, e, !0)), Q = /* @__PURE__ */ B(ee, "vec4", "DiffuseColor"), Lo = /* @__PURE__ */ B(ee, "vec3", "EmissiveColor"), ft = /* @__PURE__ */ B(ee, "float", "Roughness"), In = /* @__PURE__ */ B(ee, "float", "Metalness"), Gr = /* @__PURE__ */ B(ee, "float", "Clearcoat"), Ln = /* @__PURE__ */ B(ee, "float", "ClearcoatRoughness"), as = /* @__PURE__ */ B(ee, "vec3", "Sheen"), ai = /* @__PURE__ */ B(ee, "float", "SheenRoughness"), ui = /* @__PURE__ */ B(ee, "float", "Iridescence"), ma = /* @__PURE__ */ B(ee, "float", "IridescenceIOR"), ya = /* @__PURE__ */ B(ee, "float", "IridescenceThickness"), Or = /* @__PURE__ */ B(ee, "float", "AlphaT"), Ht = /* @__PURE__ */ B(ee, "float", "Anisotropy"), bn = /* @__PURE__ */ B(ee, "vec3", "AnisotropyT"), fs = /* @__PURE__ */ B(ee, "vec3", "AnisotropyB"), Ge = /* @__PURE__ */ B(ee, "color", "SpecularColor"), Vn = /* @__PURE__ */ B(ee, "float", "SpecularF90"), kr = /* @__PURE__ */ B(ee, "float", "Shininess"), Gn = /* @__PURE__ */ B(ee, "vec4", "Output"), Er = /* @__PURE__ */ B(ee, "float", "dashSize"), Vo = /* @__PURE__ */ B(ee, "float", "gapSize"), Qm = /* @__PURE__ */ B(ee, "float", "pointWidth"), Sn = /* @__PURE__ */ B(ee, "float", "IOR"), zr = /* @__PURE__ */ B(ee, "float", "Transmission"), xa = /* @__PURE__ */ B(ee, "float", "Thickness"), Ta = /* @__PURE__ */ B(ee, "float", "AttenuationDistance"), _a = /* @__PURE__ */ B(ee, "color", "AttenuationColor"), Na = /* @__PURE__ */ B(ee, "float", "Dispersion");
class Zm extends Ne {
  static get type() {
    return "AssignNode";
  }
  /**
   * Constructs a new assign node.
   *
   * @param {Node} targetNode - The target node.
   * @param {Node} sourceNode - The source type.
   */
  constructor(e, t) {
    super(), this.targetNode = e, this.sourceNode = t;
  }
  /**
   * Whether this node is used more than once in context of other nodes. This method
   * is overwritten since it always returns `false` (assigns are unique).
   *
   * @return {Boolean} A flag that indicates if there is more than one dependency to other nodes. Always `false`.
   */
  hasDependencies() {
    return !1;
  }
  getNodeType(e, t) {
    return t !== "void" ? this.targetNode.getNodeType(e) : "void";
  }
  /**
   * Whether a split is required when assigning source to target. This can happen when the component length of
   * target and source data type does not match.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Boolean} Whether a split is required when assigning source to target.
   */
  needsSplitAssign(e) {
    const { targetNode: t } = this;
    if (e.isAvailable("swizzleAssign") === !1 && t.isSplitNode && t.components.length > 1) {
      const s = e.getTypeLength(t.node.getNodeType(e));
      return xs.join("").slice(0, s) !== t.components;
    }
    return !1;
  }
  generate(e, t) {
    const { targetNode: s, sourceNode: n } = this, r = this.needsSplitAssign(e), i = s.getNodeType(e), a = s.context({ assign: !0 }).build(e), u = n.build(e, i), c = n.getNodeType(e), l = e.getDataFromNode(this);
    let d;
    if (l.initialized === !0)
      t !== "void" && (d = a);
    else if (r) {
      const h = e.getVarFromNode(this, null, i), p = e.getPropertyName(h);
      e.addLineFlowCode(`${p} = ${u}`, this);
      const f = s.node.context({ assign: !0 }).build(e);
      for (let m = 0; m < s.components.length; m++) {
        const _ = s.components[m];
        e.addLineFlowCode(`${f}.${_} = ${p}[ ${m} ]`, this);
      }
      t !== "void" && (d = a);
    } else
      d = `${a} = ${u}`, (t === "void" || c === "void") && (e.addLineFlowCode(d, this), t !== "void" && (d = a));
    return l.initialized = !0, e.format(d, i, t);
  }
}
const rd = /* @__PURE__ */ C(Zm);
R("assign", rd);
class Jm extends Ne {
  static get type() {
    return "FunctionCallNode";
  }
  /**
   * Constructs a new function call node.
   *
   * @param {FunctionNode?} functionNode - The function node.
   * @param {Object<String, Node>} [parameters={}] - The parameters for the function call.
   */
  constructor(e = null, t = {}) {
    super(), this.functionNode = e, this.parameters = t;
  }
  /**
   * Sets the parameters of the function call node.
   *
   * @param {Object<String, Node>} parameters - The parameters to set.
   * @return {FunctionCallNode} A reference to this node.
   */
  setParameters(e) {
    return this.parameters = e, this;
  }
  /**
   * Returns the parameters of the function call node.
   *
   * @return {Object<String, Node>} The parameters of this node.
   */
  getParameters() {
    return this.parameters;
  }
  getNodeType(e) {
    return this.functionNode.getNodeType(e);
  }
  generate(e) {
    const t = [], s = this.functionNode, n = s.getInputs(e), r = this.parameters, i = (u, c) => {
      const l = c.type, d = l === "pointer";
      let h;
      return d ? h = "&" + u.build(e) : h = u.build(e, l), h;
    };
    if (Array.isArray(r))
      for (let u = 0; u < r.length; u++)
        t.push(i(r[u], n[u]));
    else
      for (const u of n) {
        const c = r[u.name];
        if (c !== void 0)
          t.push(i(c, u));
        else
          throw new Error(`FunctionCallNode: Input '${u.name}' not found in FunctionNode.`);
      }
    return `${s.build(e, "property")}( ${t.join(", ")} )`;
  }
}
const id = (o, ...e) => (e = e.length > 1 || e[0] && e[0].isNode === !0 ? hs(e) : qn(e[0]), E(new Jm(E(o), e)));
R("call", id);
class ce extends Ne {
  static get type() {
    return "OperatorNode";
  }
  /**
   * Constructs a new operator node.
   *
   * @param {String} op - The operator.
   * @param {Node} aNode - The first input.
   * @param {Node} bNode - The second input.
   * @param {...Node} params - Additional input parameters.
   */
  constructor(e, t, s, ...n) {
    if (super(), n.length > 0) {
      let r = new ce(e, t, s);
      for (let i = 0; i < n.length - 1; i++)
        r = new ce(e, r, n[i]);
      t = r, s = n[n.length - 1];
    }
    this.op = e, this.aNode = t, this.bNode = s;
  }
  /**
   * This method is overwritten since the node type is inferred from the operator
   * and the input node types.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String} output - The current output string.
   * @return {String} The node type.
   */
  getNodeType(e, t) {
    const s = this.op, n = this.aNode, r = this.bNode, i = n.getNodeType(e), a = typeof r < "u" ? r.getNodeType(e) : null;
    if (i === "void" || a === "void")
      return "void";
    if (s === "%")
      return i;
    if (s === "~" || s === "&" || s === "|" || s === "^" || s === ">>" || s === "<<")
      return e.getIntegerType(i);
    if (s === "!" || s === "==" || s === "&&" || s === "||" || s === "^^")
      return "bool";
    if (s === "<" || s === ">" || s === "<=" || s === ">=") {
      const u = t ? e.getTypeLength(t) : Math.max(e.getTypeLength(i), e.getTypeLength(a));
      return u > 1 ? `bvec${u}` : "bool";
    } else
      return i === "float" && e.isMatrix(a) ? a : e.isMatrix(i) && e.isVector(a) ? e.getVectorFromMatrix(i) : e.isVector(i) && e.isMatrix(a) ? e.getVectorFromMatrix(a) : e.getTypeLength(a) > e.getTypeLength(i) ? a : i;
  }
  generate(e, t) {
    const s = this.op, n = this.aNode, r = this.bNode, i = this.getNodeType(e, t);
    let a = null, u = null;
    i !== "void" ? (a = n.getNodeType(e), u = typeof r < "u" ? r.getNodeType(e) : null, s === "<" || s === ">" || s === "<=" || s === ">=" || s === "==" ? e.isVector(a) ? u = a : a !== u && (a = u = "float") : s === ">>" || s === "<<" ? (a = i, u = e.changeComponentType(u, "uint")) : e.isMatrix(a) && e.isVector(u) ? u = e.getVectorFromMatrix(a) : e.isVector(a) && e.isMatrix(u) ? a = e.getVectorFromMatrix(u) : a = u = i) : a = u = i;
    const c = n.build(e, a), l = typeof r < "u" ? r.build(e, u) : null, d = e.getTypeLength(t), h = e.getFunctionOperator(s);
    if (t !== "void")
      return s === "<" && d > 1 ? e.useComparisonMethod ? e.format(`${e.getMethod("lessThan", t)}( ${c}, ${l} )`, i, t) : e.format(`( ${c} < ${l} )`, i, t) : s === "<=" && d > 1 ? e.useComparisonMethod ? e.format(`${e.getMethod("lessThanEqual", t)}( ${c}, ${l} )`, i, t) : e.format(`( ${c} <= ${l} )`, i, t) : s === ">" && d > 1 ? e.useComparisonMethod ? e.format(`${e.getMethod("greaterThan", t)}( ${c}, ${l} )`, i, t) : e.format(`( ${c} > ${l} )`, i, t) : s === ">=" && d > 1 ? e.useComparisonMethod ? e.format(`${e.getMethod("greaterThanEqual", t)}( ${c}, ${l} )`, i, t) : e.format(`( ${c} >= ${l} )`, i, t) : s === "!" || s === "~" ? e.format(`(${s}${c})`, a, t) : h ? e.format(`${h}( ${c}, ${l} )`, i, t) : e.format(`( ${c} ${s} ${l} )`, i, t);
    if (a !== "void")
      return h ? e.format(`${h}( ${c}, ${l} )`, i, t) : e.format(`${c} ${s} ${l}`, i, t);
  }
  serialize(e) {
    super.serialize(e), e.op = this.op;
  }
  deserialize(e) {
    super.deserialize(e), this.op = e.op;
  }
}
const _e = /* @__PURE__ */ C(ce, "+"), K = /* @__PURE__ */ C(ce, "-"), $ = /* @__PURE__ */ C(ce, "*"), ut = /* @__PURE__ */ C(ce, "/"), ba = /* @__PURE__ */ C(ce, "%"), od = /* @__PURE__ */ C(ce, "=="), ad = /* @__PURE__ */ C(ce, "!="), ud = /* @__PURE__ */ C(ce, "<"), Sa = /* @__PURE__ */ C(ce, ">"), cd = /* @__PURE__ */ C(ce, "<="), ld = /* @__PURE__ */ C(ce, ">="), dd = /* @__PURE__ */ C(ce, "&&"), hd = /* @__PURE__ */ C(ce, "||"), pd = /* @__PURE__ */ C(ce, "!"), fd = /* @__PURE__ */ C(ce, "^^"), gd = /* @__PURE__ */ C(ce, "&"), md = /* @__PURE__ */ C(ce, "~"), yd = /* @__PURE__ */ C(ce, "|"), xd = /* @__PURE__ */ C(ce, "^"), Td = /* @__PURE__ */ C(ce, "<<"), _d = /* @__PURE__ */ C(ce, ">>");
R("add", _e);
R("sub", K);
R("mul", $);
R("div", ut);
R("modInt", ba);
R("equal", od);
R("notEqual", ad);
R("lessThan", ud);
R("greaterThan", Sa);
R("lessThanEqual", cd);
R("greaterThanEqual", ld);
R("and", dd);
R("or", hd);
R("not", pd);
R("xor", fd);
R("bitAnd", gd);
R("bitNot", md);
R("bitOr", yd);
R("bitXor", xd);
R("shiftLeft", Td);
R("shiftRight", _d);
const Nd = (...o) => (console.warn("TSL.OperatorNode: .remainder() has been renamed to .modInt()."), ba(...o));
R("remainder", Nd);
class N extends Ne {
  static get type() {
    return "MathNode";
  }
  /**
   * Constructs a new math node.
   *
   * @param {String} method - The method name.
   * @param {Node} aNode - The first input.
   * @param {Node?} [bNode=null] - The second input.
   * @param {Node?} [cNode=null] - The third input.
   */
  constructor(e, t, s = null, n = null) {
    super(), this.method = e, this.aNode = t, this.bNode = s, this.cNode = n;
  }
  /**
   * The input type is inferred from the node types of the input nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType(e) {
    const t = this.aNode.getNodeType(e), s = this.bNode ? this.bNode.getNodeType(e) : null, n = this.cNode ? this.cNode.getNodeType(e) : null, r = e.isMatrix(t) ? 0 : e.getTypeLength(t), i = e.isMatrix(s) ? 0 : e.getTypeLength(s), a = e.isMatrix(n) ? 0 : e.getTypeLength(n);
    return r > i && r > a ? t : i > a ? s : a > r ? n : t;
  }
  /**
   * The selected method as well as the input type determine the node type of this node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    const t = this.method;
    return t === N.LENGTH || t === N.DISTANCE || t === N.DOT ? "float" : t === N.CROSS ? "vec3" : t === N.ALL ? "bool" : t === N.EQUALS ? e.changeComponentType(this.aNode.getNodeType(e), "bool") : t === N.MOD ? this.aNode.getNodeType(e) : this.getInputType(e);
  }
  generate(e, t) {
    let s = this.method;
    const n = this.getNodeType(e), r = this.getInputType(e), i = this.aNode, a = this.bNode, u = this.cNode, c = e.renderer.coordinateSystem;
    if (s === N.TRANSFORM_DIRECTION) {
      let l = i, d = a;
      e.isMatrix(l.getNodeType(e)) ? d = I(T(d), 0) : l = I(T(l), 0);
      const h = $(l, d).xyz;
      return Gt(h).build(e, t);
    } else {
      if (s === N.NEGATE)
        return e.format("( - " + i.build(e, r) + " )", n, t);
      if (s === N.ONE_MINUS)
        return K(1, i).build(e, t);
      if (s === N.RECIPROCAL)
        return ut(1, i).build(e, t);
      if (s === N.DIFFERENCE)
        return re(K(i, a)).build(e, t);
      {
        const l = [];
        return s === N.CROSS || s === N.MOD ? l.push(
          i.build(e, n),
          a.build(e, n)
        ) : c === En && s === N.STEP ? l.push(
          i.build(e, e.getTypeLength(i.getNodeType(e)) === 1 ? "float" : r),
          a.build(e, r)
        ) : c === En && (s === N.MIN || s === N.MAX) || s === N.MOD ? l.push(
          i.build(e, r),
          a.build(e, e.getTypeLength(a.getNodeType(e)) === 1 ? "float" : r)
        ) : s === N.REFRACT ? l.push(
          i.build(e, r),
          a.build(e, r),
          u.build(e, "float")
        ) : s === N.MIX ? l.push(
          i.build(e, r),
          a.build(e, r),
          u.build(e, e.getTypeLength(u.getNodeType(e)) === 1 ? "float" : r)
        ) : (c === sn && s === N.ATAN && a !== null && (s = "atan2"), l.push(i.build(e, r)), a !== null && l.push(a.build(e, r)), u !== null && l.push(u.build(e, r))), e.format(`${e.getMethod(s, n)}( ${l.join(", ")} )`, n, t);
      }
    }
  }
  serialize(e) {
    super.serialize(e), e.method = this.method;
  }
  deserialize(e) {
    super.deserialize(e), this.method = e.method;
  }
}
N.ALL = "all";
N.ANY = "any";
N.RADIANS = "radians";
N.DEGREES = "degrees";
N.EXP = "exp";
N.EXP2 = "exp2";
N.LOG = "log";
N.LOG2 = "log2";
N.SQRT = "sqrt";
N.INVERSE_SQRT = "inversesqrt";
N.FLOOR = "floor";
N.CEIL = "ceil";
N.NORMALIZE = "normalize";
N.FRACT = "fract";
N.SIN = "sin";
N.COS = "cos";
N.TAN = "tan";
N.ASIN = "asin";
N.ACOS = "acos";
N.ATAN = "atan";
N.ABS = "abs";
N.SIGN = "sign";
N.LENGTH = "length";
N.NEGATE = "negate";
N.ONE_MINUS = "oneMinus";
N.DFDX = "dFdx";
N.DFDY = "dFdy";
N.ROUND = "round";
N.RECIPROCAL = "reciprocal";
N.TRUNC = "trunc";
N.FWIDTH = "fwidth";
N.TRANSPOSE = "transpose";
N.BITCAST = "bitcast";
N.EQUALS = "equals";
N.MIN = "min";
N.MAX = "max";
N.MOD = "mod";
N.STEP = "step";
N.REFLECT = "reflect";
N.DISTANCE = "distance";
N.DIFFERENCE = "difference";
N.DOT = "dot";
N.CROSS = "cross";
N.POW = "pow";
N.TRANSFORM_DIRECTION = "transformDirection";
N.MIX = "mix";
N.CLAMP = "clamp";
N.REFRACT = "refract";
N.SMOOTHSTEP = "smoothstep";
N.FACEFORWARD = "faceforward";
const bd = /* @__PURE__ */ g(1e-6), ey = /* @__PURE__ */ g(1e6), $r = /* @__PURE__ */ g(Math.PI), ty = /* @__PURE__ */ g(Math.PI * 2), va = /* @__PURE__ */ C(N, N.ALL), Sd = /* @__PURE__ */ C(N, N.ANY), vd = /* @__PURE__ */ C(N, N.RADIANS), Ad = /* @__PURE__ */ C(N, N.DEGREES), Aa = /* @__PURE__ */ C(N, N.EXP), Zs = /* @__PURE__ */ C(N, N.EXP2), ci = /* @__PURE__ */ C(N, N.LOG), mt = /* @__PURE__ */ C(N, N.LOG2), Et = /* @__PURE__ */ C(N, N.SQRT), Ra = /* @__PURE__ */ C(N, N.INVERSE_SQRT), yt = /* @__PURE__ */ C(N, N.FLOOR), li = /* @__PURE__ */ C(N, N.CEIL), Gt = /* @__PURE__ */ C(N, N.NORMALIZE), kt = /* @__PURE__ */ C(N, N.FRACT), Ze = /* @__PURE__ */ C(N, N.SIN), Bt = /* @__PURE__ */ C(N, N.COS), Rd = /* @__PURE__ */ C(N, N.TAN), Cd = /* @__PURE__ */ C(N, N.ASIN), Ed = /* @__PURE__ */ C(N, N.ACOS), Ca = /* @__PURE__ */ C(N, N.ATAN), re = /* @__PURE__ */ C(N, N.ABS), On = /* @__PURE__ */ C(N, N.SIGN), Dt = /* @__PURE__ */ C(N, N.LENGTH), wd = /* @__PURE__ */ C(N, N.NEGATE), Md = /* @__PURE__ */ C(N, N.ONE_MINUS), Ea = /* @__PURE__ */ C(N, N.DFDX), wa = /* @__PURE__ */ C(N, N.DFDY), Bd = /* @__PURE__ */ C(N, N.ROUND), Fd = /* @__PURE__ */ C(N, N.RECIPROCAL), Ma = /* @__PURE__ */ C(N, N.TRUNC), Ud = /* @__PURE__ */ C(N, N.FWIDTH), Pd = /* @__PURE__ */ C(N, N.TRANSPOSE), sy = /* @__PURE__ */ C(N, N.BITCAST), Dd = /* @__PURE__ */ C(N, N.EQUALS), $e = /* @__PURE__ */ C(N, N.MIN), fe = /* @__PURE__ */ C(N, N.MAX), Ba = /* @__PURE__ */ C(N, N.MOD), di = /* @__PURE__ */ C(N, N.STEP), Id = /* @__PURE__ */ C(N, N.REFLECT), Ld = /* @__PURE__ */ C(N, N.DISTANCE), Vd = /* @__PURE__ */ C(N, N.DIFFERENCE), Zt = /* @__PURE__ */ C(N, N.DOT), hi = /* @__PURE__ */ C(N, N.CROSS), ot = /* @__PURE__ */ C(N, N.POW), Fa = /* @__PURE__ */ C(N, N.POW, 2), Gd = /* @__PURE__ */ C(N, N.POW, 3), Od = /* @__PURE__ */ C(N, N.POW, 4), kd = /* @__PURE__ */ C(N, N.TRANSFORM_DIRECTION), zd = (o) => $(On(o), ot(re(o), 1 / 3)), $d = (o) => Zt(o, o), Z = /* @__PURE__ */ C(N, N.MIX), _t = (o, e = 0, t = 1) => E(new N(N.CLAMP, E(o), E(e), E(t))), Wd = (o) => _t(o), Ua = /* @__PURE__ */ C(N, N.REFRACT), Ot = /* @__PURE__ */ C(N, N.SMOOTHSTEP), Pa = /* @__PURE__ */ C(N, N.FACEFORWARD), Hd = /* @__PURE__ */ b(([o]) => {
  const s = 43758.5453, n = Zt(o.xy, w(12.9898, 78.233)), r = Ba(n, $r);
  return kt(Ze(r).mul(s));
}), qd = (o, e, t) => Z(e, t, o), Xd = (o, e, t) => Ot(e, t, o), Kd = (o, e) => (console.warn('THREE.TSL: "atan2" is overloaded. Use "atan" instead.'), Ca(o, e)), ny = Pa, ry = Ra;
R("all", va);
R("any", Sd);
R("equals", Dd);
R("radians", vd);
R("degrees", Ad);
R("exp", Aa);
R("exp2", Zs);
R("log", ci);
R("log2", mt);
R("sqrt", Et);
R("inverseSqrt", Ra);
R("floor", yt);
R("ceil", li);
R("normalize", Gt);
R("fract", kt);
R("sin", Ze);
R("cos", Bt);
R("tan", Rd);
R("asin", Cd);
R("acos", Ed);
R("atan", Ca);
R("abs", re);
R("sign", On);
R("length", Dt);
R("lengthSq", $d);
R("negate", wd);
R("oneMinus", Md);
R("dFdx", Ea);
R("dFdy", wa);
R("round", Bd);
R("reciprocal", Fd);
R("trunc", Ma);
R("fwidth", Ud);
R("atan2", Kd);
R("min", $e);
R("max", fe);
R("mod", Ba);
R("step", di);
R("reflect", Id);
R("distance", Ld);
R("dot", Zt);
R("cross", hi);
R("pow", ot);
R("pow2", Fa);
R("pow3", Gd);
R("pow4", Od);
R("transformDirection", kd);
R("mix", qd);
R("clamp", _t);
R("refract", Ua);
R("smoothstep", Xd);
R("faceForward", Pa);
R("difference", Vd);
R("saturate", Wd);
R("cbrt", zd);
R("transpose", Pd);
R("rand", Hd);
class iy extends G {
  static get type() {
    return "ConditionalNode";
  }
  /**
   * Constructs a new conditional node.
   *
   * @param {Node} condNode - The node that defines the condition.
   * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
   * @param {Node?} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
   */
  constructor(e, t, s = null) {
    super(), this.condNode = e, this.ifNode = t, this.elseNode = s;
  }
  /**
   * This method is overwritten since the node type is inferred from the if/else
   * nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    const { ifNode: t, elseNode: s } = e.getNodeProperties(this);
    if (t === void 0)
      return this.setup(e), this.getNodeType(e);
    const n = t.getNodeType(e);
    if (s !== null) {
      const r = s.getNodeType(e);
      if (e.getTypeLength(r) > e.getTypeLength(n))
        return r;
    }
    return n;
  }
  setup(e) {
    const t = this.condNode.cache(), s = this.ifNode.cache(), n = this.elseNode ? this.elseNode.cache() : null, r = e.context.nodeBlock;
    e.getDataFromNode(s).parentNodeBlock = r, n !== null && (e.getDataFromNode(n).parentNodeBlock = r);
    const i = e.getNodeProperties(this);
    i.condNode = t, i.ifNode = s.context({ nodeBlock: s }), i.elseNode = n ? n.context({ nodeBlock: n }) : null;
  }
  generate(e, t) {
    const s = this.getNodeType(e), n = e.getDataFromNode(this);
    if (n.nodeProperty !== void 0)
      return n.nodeProperty;
    const { condNode: r, ifNode: i, elseNode: a } = e.getNodeProperties(this), u = t !== "void", c = u ? nd(s).build(e) : "";
    n.nodeProperty = c;
    const l = r.build(e, "bool");
    e.addFlowCode(`
${e.tab}if ( ${l} ) {

`).addFlowTab();
    let d = i.build(e, s);
    if (d && (u ? d = c + " = " + d + ";" : d = "return " + d + ";"), e.removeFlowTab().addFlowCode(e.tab + "	" + d + `

` + e.tab + "}"), a !== null) {
      e.addFlowCode(` else {

`).addFlowTab();
      let h = a.build(e, s);
      h && (u ? h = c + " = " + h + ";" : h = "return " + h + ";"), e.removeFlowTab().addFlowCode(e.tab + "	" + h + `

` + e.tab + `}

`);
    } else
      e.addFlowCode(`

`);
    return e.format(c, s, t);
  }
}
const Me = /* @__PURE__ */ C(iy);
R("select", Me);
const Yd = (...o) => (console.warn("TSL.ConditionalNode: cond() has been renamed to select()."), Me(...o));
R("cond", Yd);
class jd extends G {
  static get type() {
    return "ContextNode";
  }
  /**
   * Constructs a new context node.
   *
   * @param {Node} node - The node whose context should be modified.
   * @param {Object} [value={}] - The modified context data.
   */
  constructor(e, t = {}) {
    super(), this.isContextNode = !0, this.node = e, this.value = t;
  }
  /**
   * This method is overwritten to ensure it returns the reference to {@link module:ContextNode~ContextNode#node}.
   *
   * @return {Node} A reference to {@link module:ContextNode~ContextNode#node}.
   */
  getScope() {
    return this.node.getScope();
  }
  /**
   * This method is overwritten to ensure it returns the type of {@link module:ContextNode~ContextNode#node}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.node.getNodeType(e);
  }
  analyze(e) {
    this.node.build(e);
  }
  setup(e) {
    const t = e.getContext();
    e.setContext({ ...e.context, ...this.value });
    const s = this.node.build(e);
    return e.setContext(t), s;
  }
  generate(e, t) {
    const s = e.getContext();
    e.setContext({ ...e.context, ...this.value });
    const n = this.node.build(e, t);
    return e.setContext(s), n;
  }
}
const pi = /* @__PURE__ */ C(jd), Qd = (o, e) => pi(o, { label: e });
R("context", pi);
R("label", Qd);
class wr extends G {
  static get type() {
    return "VarNode";
  }
  /**
   * Constructs a new variable node.
   *
   * @param {Node} node - The node for which a variable should be created.
   * @param {String?} name - The name of the variable in the shader.
   */
  constructor(e, t = null) {
    super(), this.node = e, this.name = t, this.global = !0, this.isVarNode = !0;
  }
  getHash(e) {
    return this.name || super.getHash(e);
  }
  getNodeType(e) {
    return this.node.getNodeType(e);
  }
  generate(e) {
    const { node: t, name: s } = this, n = e.getVarFromNode(this, s, e.getVectorType(this.getNodeType(e))), r = e.getPropertyName(n), i = t.build(e, n.type);
    return e.addLineFlowCode(`${r} = ${i}`, this), r;
  }
}
const Zd = /* @__PURE__ */ C(wr);
R("toVar", (...o) => Zd(...o).append());
const Jd = (o) => (console.warn('TSL: "temp" is deprecated. Use ".toVar()" instead.'), Zd(o));
R("temp", Jd);
class oy extends G {
  static get type() {
    return "VaryingNode";
  }
  /**
   * Constructs a new varying node.
   *
   * @param {Node} node - The node for which a varying should be created.
   * @param {String?} name - The name of the varying in the shader.
   */
  constructor(e, t = null) {
    super(), this.node = e, this.name = t, this.isVaryingNode = !0;
  }
  /**
   * The method is overwritten so it always returns `true`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Boolean} Whether this node is global or not.
   */
  isGlobal() {
    return !0;
  }
  getHash(e) {
    return this.name || super.getHash(e);
  }
  getNodeType(e) {
    return this.node.getNodeType(e);
  }
  /**
   * This method performs the setup of a varying node with the current node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeVarying} The node varying from the node builder.
   */
  setupVarying(e) {
    const t = e.getNodeProperties(this);
    let s = t.varying;
    if (s === void 0) {
      const n = this.name, r = this.getNodeType(e);
      t.varying = s = e.getVaryingFromNode(this, n, r), t.node = this.node;
    }
    return s.needsInterpolation || (s.needsInterpolation = e.shaderStage === "fragment"), s;
  }
  setup(e) {
    this.setupVarying(e);
  }
  analyze(e) {
    return this.setupVarying(e), this.node.analyze(e);
  }
  generate(e) {
    const t = e.getNodeProperties(this), s = this.setupVarying(e), n = e.shaderStage === "fragment" && t.reassignPosition === !0 && e.context.needsPositionReassign;
    if (t.propertyName === void 0 || n) {
      const r = this.getNodeType(e), i = e.getPropertyName(s, Fo.VERTEX);
      e.flowNodeFromShaderStage(Fo.VERTEX, this.node, r, i), t.propertyName = i, n ? t.reassignPosition = !1 : t.reassignPosition === void 0 && e.context.isPositionNodeInput && (t.reassignPosition = !0);
    }
    return e.getPropertyName(s);
  }
}
const qe = /* @__PURE__ */ C(oy), eh = (o) => qe(o);
R("varying", qe);
R("vertexStage", eh);
const th = /* @__PURE__ */ b(([o]) => {
  const e = o.mul(0.9478672986).add(0.0521327014).pow(2.4), t = o.mul(0.0773993808), s = o.lessThanEqual(0.04045);
  return Z(e, t, s);
}).setLayout({
  name: "sRGBTransferEOTF",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" }
  ]
}), sh = /* @__PURE__ */ b(([o]) => {
  const e = o.pow(0.41666).mul(1.055).sub(0.055), t = o.mul(12.92), s = o.lessThanEqual(31308e-7);
  return Z(e, t, s);
}).setLayout({
  name: "sRGBTransferOETF",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" }
  ]
}), Kn = "WorkingColorSpace", Da = "OutputColorSpace";
class Yn extends Ne {
  static get type() {
    return "ColorSpaceNode";
  }
  /**
   * Constructs a new color space node.
   *
   * @param {Node} colorNode - Represents the color to convert.
   * @param {String} source - The source color space.
   * @param {String} target - The target color space.
   */
  constructor(e, t, s) {
    super("vec4"), this.colorNode = e, this.source = t, this.target = s;
  }
  /**
   * This method resolves the constants `WORKING_COLOR_SPACE` and
   * `OUTPUT_COLOR_SPACE` based on the current configuration of the
   * color management and renderer.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String} colorSpace - The color space to resolve.
   * @return {String} The resolved color space.
   */
  resolveColorSpace(e, t) {
    return t === Kn ? ht.workingColorSpace : t === Da ? e.context.outputColorSpace || e.renderer.outputColorSpace : t;
  }
  setup(e) {
    const { colorNode: t } = this, s = this.resolveColorSpace(e, this.source), n = this.resolveColorSpace(e, this.target);
    let r = t;
    return ht.enabled === !1 || s === n || !s || !n || (ht.getTransfer(s) === Bu && (r = I(th(r.rgb), r.a)), ht.getPrimaries(s) !== ht.getPrimaries(n) && (r = I(
      Le(ht._getMatrix(new $n(), s, n)).mul(r.rgb),
      r.a
    )), ht.getTransfer(n) === Bu && (r = I(sh(r.rgb), r.a))), r;
  }
}
const nh = (o) => E(new Yn(E(o), Kn, Da)), rh = (o) => E(new Yn(E(o), Da, Kn)), ih = (o, e) => E(new Yn(E(o), Kn, e)), Ia = (o, e) => E(new Yn(E(o), e, Kn)), ay = (o, e, t) => E(new Yn(E(o), e, t));
R("toOutputColorSpace", nh);
R("toWorkingColorSpace", rh);
R("workingToColorSpace", ih);
R("colorSpaceToWorking", Ia);
let uy = class extends Ts {
  static get type() {
    return "ReferenceElementNode";
  }
  /**
   * Constructs a new reference element node.
   *
   * @param {Node?} referenceNode - The reference node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.referenceNode = e, this.isReferenceElementNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the uniform type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    return this.referenceNode.uniformType;
  }
  generate(e) {
    const t = super.generate(e), s = this.referenceNode.getNodeType(), n = this.getNodeType();
    return e.format(t, s, n);
  }
};
class oh extends G {
  static get type() {
    return "ReferenceBaseNode";
  }
  /**
   * Constructs a new reference base node.
   *
   * @param {String} property - The name of the property the node refers to.
   * @param {String} uniformType - The uniform type that should be used to represent the property value.
   * @param {Object?} [object=null] - The object the property belongs to.
   * @param {Number?} [count=null] - When the linked property is an array-like, this parameter defines its length.
   */
  constructor(e, t, s = null, n = null) {
    super(), this.property = e, this.uniformType = t, this.object = s, this.count = n, this.properties = e.split("."), this.reference = s, this.node = null, this.group = null, this.updateType = z.OBJECT;
  }
  /**
   * Sets the uniform group for this reference node.
   *
   * @param {UniformGroupNode} group - The uniform group to set.
   * @return {ReferenceBaseNode} A reference to this node.
   */
  setGroup(e) {
    return this.group = e, this;
  }
  /**
   * When the referred property is array-like, this method can be used
   * to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {ReferenceElementNode} A reference to an element.
   */
  element(e) {
    return E(new uy(this, E(e)));
  }
  /**
   * Sets the node type which automatically defines the internal
   * uniform type.
   *
   * @param {String} uniformType - The type to set.
   */
  setNodeType(e) {
    const t = L(null, e).getSelf();
    this.group !== null && t.setGroup(this.group), this.node = t;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.node === null && (this.updateReference(e), this.updateValue()), this.node.getNodeType(e);
  }
  /**
   * Returns the property value from the given referred object.
   *
   * @param {Object} [object=this.reference] - The object to retrieve the property value from.
   * @return {Any} The value.
   */
  getValueFromReference(e = this.reference) {
    const { properties: t } = this;
    let s = e[t[0]];
    for (let n = 1; n < t.length; n++)
      s = s[t[n]];
    return s;
  }
  /**
   * Allows to update the reference based on the given state. The state is only
   * evaluated {@link module:ReferenceBaseNode~ReferenceBaseNode#object} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.object !== null ? this.object : e.object, this.reference;
  }
  /**
   * The output of the reference node is the internal uniform node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {UniformNode} The output node.
   */
  setup() {
    return this.updateValue(), this.node;
  }
  /**
   * Overwritten to to update the internal uniform value.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    this.updateValue();
  }
  /**
   * Retrieves the value from the referred object property and uses it
   * to updated the internal uniform.
   */
  updateValue() {
    this.node === null && this.setNodeType(this.uniformType);
    const e = this.getValueFromReference();
    Array.isArray(e) ? this.node.array = e : this.node.value = e;
  }
}
const cy = (o, e, t) => E(new oh(o, e, t));
class ly extends oh {
  static get type() {
    return "RendererReferenceNode";
  }
  /**
   * Constructs a new renderer reference node.
   *
   * @param {String} property - The name of the property the node refers to.
   * @param {String} inputType - The uniform type that should be used to represent the property value.
   * @param {Renderer?} [renderer=null] - The renderer the property belongs to. When no renderer is set,
   * the node refers to the renderer of the current state.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.renderer = s, this.setGroup(O);
  }
  /**
   * Updates the reference based on the given state. The state is only evaluated
   * {@link module:RendererReferenceNode~RendererReferenceNode#renderer} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.renderer !== null ? this.renderer : e.renderer, this.reference;
  }
}
const ah = (o, e, t = null) => E(new ly(o, e, t));
class dy extends Ne {
  static get type() {
    return "ToneMappingNode";
  }
  /**
   * Constructs a new tone mapping node.
   *
   * @param {Number} toneMapping - The tone mapping type.
   * @param {Node} exposureNode - The tone mapping exposure.
   * @param {Node} [colorNode=null] - The color node to process.
   */
  constructor(e, t = ch, s = null) {
    super("vec3"), this.toneMapping = e, this.exposureNode = t, this.colorNode = s;
  }
  /**
   * Overwrites the default `customCacheKey()` implementation by including the tone
   * mapping type into the cache key.
   *
   * @return {Number} The hash.
   */
  customCacheKey() {
    return aa(this.toneMapping);
  }
  setup(e) {
    const t = this.colorNode || e.context.color, s = this.toneMapping;
    if (s === $s) return t;
    let n = null;
    const r = e.renderer.library.getToneMappingFunction(s);
    return r !== null ? n = I(r(t.rgb, this.exposureNode), t.a) : (console.error("ToneMappingNode: Unsupported Tone Mapping configuration.", s), n = t), n;
  }
}
const uh = (o, e, t) => E(new dy(o, E(e), E(t))), ch = /* @__PURE__ */ ah("toneMappingExposure", "float");
R("toneMapping", (o, e, t) => uh(e, t, o));
class hy extends ua {
  static get type() {
    return "BufferAttributeNode";
  }
  /**
   * Constructs a new buffer attribute node.
   *
   * @param {BufferAttribute|InterleavedBuffer|TypedArray} value - The attribute data.
   * @param {String?} [bufferType=null] - The buffer type (e.g. `'vec3'`).
   * @param {Number} [bufferStride=0] - The buffer stride.
   * @param {Number} [bufferOffset=0] - The buffer offset.
   */
  constructor(e, t = null, s = 0, n = 0) {
    super(e, t), this.isBufferNode = !0, this.bufferType = t, this.bufferStride = s, this.bufferOffset = n, this.usage = Ig, this.instanced = !1, this.attribute = null, this.global = !0, e && e.isBufferAttribute === !0 && (this.attribute = e, this.usage = e.usage, this.instanced = e.isInstancedBufferAttribute);
  }
  /**
   * This method is overwritten since the attribute data might be shared
   * and thus the hash should be shared as well.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The hash.
   */
  getHash(e) {
    if (this.bufferStride === 0 && this.bufferOffset === 0) {
      let t = e.globalCache.getData(this.value);
      return t === void 0 && (t = {
        node: this
      }, e.globalCache.setData(this.value, t)), t.node.uuid;
    }
    return this.uuid;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the buffer attribute.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.bufferType === null && (this.bufferType = e.getTypeFromAttribute(this.attribute)), this.bufferType;
  }
  /**
   * Depending on which value was passed to the node, `setup()` behaves
   * differently. If no instance of `BufferAttribute` was passed, the method
   * creates an internal attribute and configures it respectively.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    if (this.attribute !== null) return;
    const t = this.getNodeType(e), s = this.value, n = e.getTypeLength(t), r = this.bufferStride || n, i = this.bufferOffset, a = s.isInterleavedBuffer === !0 ? s : new Lg(s, r), u = new Nm(a, n, i);
    a.setUsage(this.usage), this.attribute = u, this.attribute.isInstancedBufferAttribute = this.instanced;
  }
  /**
   * Generates the code snippet of the buffer attribute node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The generated code snippet.
   */
  generate(e) {
    const t = this.getNodeType(e), s = e.getBufferAttributeFromNode(this, t), n = e.getPropertyName(s);
    let r = null;
    return e.shaderStage === "vertex" || e.shaderStage === "compute" ? (this.name = n, r = n) : r = qe(this).build(e, t), r;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'bufferAttribute'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return "bufferAttribute";
  }
  /**
   * Sets the `usage` property to the given value.
   *
   * @param {Number} value - The usage to set.
   * @return {BufferAttributeNode} A reference to this node.
   */
  setUsage(e) {
    return this.usage = e, this.attribute && this.attribute.isBufferAttribute === !0 && (this.attribute.usage = e), this;
  }
  /**
   * Sets the `instanced` property to the given value.
   *
   * @param {Number} value - The value to set.
   * @return {BufferAttributeNode} A reference to this node.
   */
  setInstanced(e) {
    return this.instanced = e, this;
  }
}
const jn = (o, e = null, t = 0, s = 0) => E(new hy(o, e, t, s)), lh = (o, e = null, t = 0, s = 0) => jn(o, e, t, s).setUsage(Is), Wr = (o, e = null, t = 0, s = 0) => jn(o, e, t, s).setInstanced(!0), Go = (o, e = null, t = 0, s = 0) => lh(o, e, t, s).setInstanced(!0);
R("toAttribute", (o) => jn(o.value));
class py extends G {
  static get type() {
    return "ComputeNode";
  }
  /**
   * Constructs a new compute node.
   *
   * @param {Node} computeNode - TODO
   * @param {Number} count - TODO.
   * @param {Array<Number>} [workgroupSize=[64]] - TODO.
   */
  constructor(e, t, s = [64]) {
    super("void"), this.isComputeNode = !0, this.computeNode = e, this.count = t, this.workgroupSize = s, this.dispatchCount = 0, this.version = 1, this.name = "", this.updateBeforeType = z.OBJECT, this.onInitFunction = null, this.updateDispatchCount();
  }
  /**
   * Executes the `dispose` event for this node.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Sets the {@link ComputeNode#name} property.
   *
   * @param {String} name - The name of the uniform.
   * @return {ComputeNode} A reference to this node.
   */
  label(e) {
    return this.name = e, this;
  }
  /**
   * TODO
   */
  updateDispatchCount() {
    const { count: e, workgroupSize: t } = this;
    let s = t[0];
    for (let n = 1; n < t.length; n++)
      s *= t[n];
    this.dispatchCount = Math.ceil(e / s);
  }
  /**
   * TODO
   *
   * @param {Function} callback - TODO.
   * @return {ComputeNode} A reference to this node.
   */
  onInit(e) {
    return this.onInitFunction = e, this;
  }
  /**
   * The method execute the compute for this node.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateBefore({ renderer: e }) {
    e.compute(this);
  }
  generate(e) {
    const { shaderStage: t } = e;
    if (t === "compute") {
      const s = this.computeNode.build(e, "void");
      s !== "" && e.addLineFlowCode(s, this);
    }
  }
}
const dh = (o, e, t) => E(new py(E(o), e, t));
R("compute", dh);
class fy extends G {
  static get type() {
    return "CacheNode";
  }
  /**
   * Constructs a new cache node.
   *
   * @param {Node} node - The node that should be cached.
   * @param {Boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
   */
  constructor(e, t = !0) {
    super(), this.node = e, this.parent = t, this.isCacheNode = !0;
  }
  getNodeType(e) {
    const t = e.getCache(), s = e.getCacheFromNode(this, this.parent);
    e.setCache(s);
    const n = this.node.getNodeType(e);
    return e.setCache(t), n;
  }
  build(e, ...t) {
    const s = e.getCache(), n = e.getCacheFromNode(this, this.parent);
    e.setCache(n);
    const r = this.node.build(e, ...t);
    return e.setCache(s), r;
  }
}
const vn = (o, e) => E(new fy(E(o), e));
R("cache", vn);
class gy extends G {
  static get type() {
    return "BypassNode";
  }
  /**
   * Constructs a new bypass node.
   *
   * @param {Node} outputNode - The output node.
   * @param {Node} callNode - The call node.
   */
  constructor(e, t) {
    super(), this.isBypassNode = !0, this.outputNode = e, this.callNode = t;
  }
  getNodeType(e) {
    return this.outputNode.getNodeType(e);
  }
  generate(e) {
    const t = this.callNode.build(e, "void");
    return t !== "" && e.addLineFlowCode(t, this), this.outputNode.build(e);
  }
}
const hh = /* @__PURE__ */ C(gy);
R("bypass", hh);
class ph extends G {
  static get type() {
    return "RemapNode";
  }
  /**
   * Constructs a new remap node.
   *
   * @param {Node} node - The node that should be remapped.
   * @param {Node} inLowNode - The source or current lower bound of the range.
   * @param {Node} inHighNode - The source or current upper bound of the range.
   * @param {Node} [outLowNode=float(0)] - The target lower bound of the range.
   * @param {Node} [outHighNode=float(1)] - The target upper bound of the range.
   */
  constructor(e, t, s, n = g(0), r = g(1)) {
    super(), this.node = e, this.inLowNode = t, this.inHighNode = s, this.outLowNode = n, this.outHighNode = r, this.doClamp = !0;
  }
  setup() {
    const { node: e, inLowNode: t, inHighNode: s, outLowNode: n, outHighNode: r, doClamp: i } = this;
    let a = e.sub(t).div(s.sub(t));
    return i === !0 && (a = a.clamp()), a.mul(r.sub(n)).add(n);
  }
}
const fh = /* @__PURE__ */ C(ph, null, null, { doClamp: !1 }), gh = /* @__PURE__ */ C(ph);
R("remap", fh);
R("remapClamp", gh);
class Mr extends G {
  static get type() {
    return "ExpressionNode";
  }
  /**
   * Constructs a new expression node.
   *
   * @param {String} [snippet=''] - The native code snippet.
   * @param {String} [nodeType='void'] - The node type.
   */
  constructor(e = "", t = "void") {
    super(t), this.snippet = e;
  }
  generate(e, t) {
    const s = this.getNodeType(e), n = this.snippet;
    if (s === "void")
      e.addLineFlowCode(n, this);
    else
      return e.format(`( ${n} )`, s, t);
  }
}
const Qt = /* @__PURE__ */ C(Mr), mh = (o) => (o ? Me(o, Qt("discard")) : Qt("discard")).append(), my = () => Qt("return").append();
R("discard", mh);
class yy extends Ne {
  static get type() {
    return "RenderOutputNode";
  }
  /**
   * Constructs a new render output node.
   *
   * @param {Node} colorNode - The color node to process.
   * @param {Number} toneMapping - The tone mapping type.
   * @param {String} outputColorSpace - The output color space.
   */
  constructor(e, t, s) {
    super("vec4"), this.colorNode = e, this.toneMapping = t, this.outputColorSpace = s, this.isRenderOutputNode = !0;
  }
  setup({ context: e }) {
    let t = this.colorNode || e.color;
    const s = (this.toneMapping !== null ? this.toneMapping : e.toneMapping) || $s, n = (this.outputColorSpace !== null ? this.outputColorSpace : e.outputColorSpace) || wn;
    return s !== $s && (t = t.toneMapping(s)), n !== wn && n !== ht.workingColorSpace && (t = t.workingToColorSpace(n)), t;
  }
}
const yh = (o, e = null, t = null) => E(new yy(E(o), e, t));
R("renderOutput", yh);
function xy(o) {
  console.warn("THREE.TSLBase: AddNodeElement has been removed in favor of tree-shaking. Trying add", o);
}
class xh extends G {
  static get type() {
    return "AttributeNode";
  }
  /**
   * Constructs a new attribute node.
   *
   * @param {String} attributeName - The name of the attribute.
   * @param {String?} nodeType - The node type.
   */
  constructor(e, t = null) {
    super(t), this.global = !0, this._attributeName = e;
  }
  getHash(e) {
    return this.getAttributeName(e);
  }
  getNodeType(e) {
    let t = this.nodeType;
    if (t === null) {
      const s = this.getAttributeName(e);
      if (e.hasGeometryAttribute(s)) {
        const n = e.geometry.getAttribute(s);
        t = e.getTypeFromAttribute(n);
      } else
        t = "float";
    }
    return t;
  }
  /**
   * Sets the attribute name to the given value. The method can be
   * overwritten in derived classes if the final name must be computed
   * analytically.
   *
   * @param {String} attributeName - The name of the attribute.
   * @return {AttributeNode} A reference to this node.
   */
  setAttributeName(e) {
    return this._attributeName = e, this;
  }
  /**
   * Returns the attribute name of this node. The method can be
   * overwritten in derived classes if the final name must be computed
   * analytically.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The attribute name.
   */
  getAttributeName() {
    return this._attributeName;
  }
  generate(e) {
    const t = this.getAttributeName(e), s = this.getNodeType(e);
    if (e.hasGeometryAttribute(t) === !0) {
      const r = e.geometry.getAttribute(t), i = e.getTypeFromAttribute(r), a = e.getAttribute(t, i);
      return e.shaderStage === "vertex" ? e.format(a.name, i, s) : qe(this).build(e, s);
    } else
      return console.warn(`AttributeNode: Vertex attribute "${t}" not found on geometry.`), e.generateConst(s);
  }
  serialize(e) {
    super.serialize(e), e.global = this.global, e._attributeName = this._attributeName;
  }
  deserialize(e) {
    super.deserialize(e), this.global = e.global, this._attributeName = e._attributeName;
  }
}
const Nt = (o, e) => E(new xh(o, e)), le = (o = 0) => Nt("uv" + (o > 0 ? o : ""), "vec2");
class Ty extends G {
  static get type() {
    return "TextureSizeNode";
  }
  /**
   * Constructs a new texture size node.
   *
   * @param {TextureNode} textureNode - A texture node which size should be retrieved.
   * @param {Node<int>?} [levelNode=null] - A level node which defines the requested mip.
   */
  constructor(e, t = null) {
    super("uvec2"), this.isTextureSizeNode = !0, this.textureNode = e, this.levelNode = t;
  }
  generate(e, t) {
    const s = this.textureNode.build(e, "property"), n = this.levelNode === null ? "0" : this.levelNode.build(e, "int");
    return e.format(`${e.getMethod("textureDimensions")}( ${s}, ${n} )`, this.getNodeType(e), t);
  }
}
const jt = /* @__PURE__ */ C(Ty);
class _y extends Xn {
  static get type() {
    return "MaxMipLevelNode";
  }
  /**
   * Constructs a new max mip level node.
   *
   * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
   */
  constructor(e) {
    super(0), this._textureNode = e, this.updateType = z.FRAME;
  }
  /**
   * The texture node to compute the max mip level for.
   *
   * @readonly
   * @type {TextureNode}
   */
  get textureNode() {
    return this._textureNode;
  }
  /**
   * The texture.
   *
   * @readonly
   * @type {Texture}
   */
  get texture() {
    return this._textureNode.value;
  }
  update() {
    const e = this.texture, t = e.images, s = t && t.length > 0 ? t[0] && t[0].image || t[0] : e.image;
    if (s && s.width !== void 0) {
      const { width: n, height: r } = s;
      this.value = Math.log2(Math.max(n, r));
    }
  }
}
const Th = /* @__PURE__ */ C(_y);
class bt extends Xn {
  static get type() {
    return "TextureNode";
  }
  /**
   * Constructs a new texture node.
   *
   * @param {Texture} value - The texture.
   * @param {Node<vec2|vec3>?} [uvNode=null] - The uv node.
   * @param {Node<int>?} [levelNode=null] - The level node.
   * @param {Node<float>?} [biasNode=null] - The bias node.
   */
  constructor(e, t = null, s = null, n = null) {
    super(e), this.isTextureNode = !0, this.uvNode = t, this.levelNode = s, this.biasNode = n, this.compareNode = null, this.depthNode = null, this.gradNode = null, this.sampler = !0, this.updateMatrix = !1, this.updateType = z.NONE, this.referenceNode = null, this._value = e, this._matrixUniform = null, this.setUpdateMatrix(t === null);
  }
  set value(e) {
    this.referenceNode ? this.referenceNode.value = e : this._value = e;
  }
  /**
   * The texture value.
   *
   * @type {Texture}
   */
  get value() {
    return this.referenceNode ? this.referenceNode.value : this._value;
  }
  /**
   * Overwritten since the uniform hash is defined by the texture's UUID.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The uniform hash.
   */
  getUniformHash() {
    return this.value.uuid;
  }
  /**
   * Overwritten since the node type is inferred from the texture type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    return this.value.isDepthTexture === !0 ? "float" : this.value.type === Pe ? "uvec4" : this.value.type === Ve ? "ivec4" : "vec4";
  }
  /**
   * Overwrites the default implementation to return a fixed value `'texture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return "texture";
  }
  /**
   * Returns a default uvs based on the current texture's channel.
   *
   * @return {AttributeNode<vec2>} The default uvs.
   */
  getDefaultUV() {
    return le(this.value.channel);
  }
  /**
   * Overwritten to always return the texture reference of the node.
   *
   * @param {Any} state - This method can be invocated in different contexts so `state` can refer to any object type.
   * @return {Texture} The texture reference.
   */
  updateReference() {
    return this.value;
  }
  /**
   * Transforms the given uv node with the texture transformation matrix.
   *
   * @param {Node} uvNode - The uv node to transform.
   * @return {Node} The transformed uv node.
   */
  getTransformedUV(e) {
    return this._matrixUniform === null && (this._matrixUniform = L(this.value.matrix)), this._matrixUniform.mul(T(e, 1)).xy;
  }
  /**
   * Defines whether the uv transformation matrix should automatically be updated or not.
   *
   * @param {Boolean} value - The update toggle.
   * @return {TextureNode} A reference to this node.
   */
  setUpdateMatrix(e) {
    return this.updateMatrix = e, this.updateType = e ? z.RENDER : z.NONE, this;
  }
  /**
   * Setups the uv node. Depending on the backend as well as texture's image and type, it might be necessary
   * to modify the uv node for correct sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The updated uv node.
   */
  setupUV(e, t) {
    const s = this.value;
    return e.isFlipY() && (s.image instanceof ImageBitmap && s.flipY === !0 || s.isRenderTargetTexture === !0 || s.isFramebufferTexture === !0 || s.isDepthTexture === !0) && (this.sampler ? t = t.flipY() : t = t.setY(y(jt(this, this.levelNode).y).sub(t.y).sub(1))), t;
  }
  /**
   * Setups texture node by preparing the internal nodes for code generation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    const t = e.getNodeProperties(this);
    t.referenceNode = this.referenceNode;
    const s = this.value;
    if (!s || s.isTexture !== !0)
      throw new Error("THREE.TSL: `texture( value )` function expects a valid instance of THREE.Texture().");
    let n = this.uvNode;
    (n === null || e.context.forceUVContext === !0) && e.context.getUV && (n = e.context.getUV(this)), n || (n = this.getDefaultUV()), this.updateMatrix === !0 && (n = this.getTransformedUV(n)), n = this.setupUV(e, n);
    let r = this.levelNode;
    r === null && e.context.getTextureLevel && (r = e.context.getTextureLevel(this)), t.uvNode = n, t.levelNode = r, t.biasNode = this.biasNode, t.compareNode = this.compareNode, t.gradNode = this.gradNode, t.depthNode = this.depthNode;
  }
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {String} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, this.sampler === !0 ? "vec2" : "ivec2");
  }
  /**
   * Generates the snippet for the texture sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String} textureProperty - The texture property.
   * @param {String} uvSnippet - The uv snippet.
   * @param {String} levelSnippet - The level snippet.
   * @param {String} biasSnippet - The bias snippet.
   * @param {String} depthSnippet - The depth snippet.
   * @param {String} compareSnippet - The compare snippet.
   * @param {String} gradSnippet - The grad snippet.
   * @return {String} The generated code snippet.
   */
  generateSnippet(e, t, s, n, r, i, a, u) {
    const c = this.value;
    let l;
    return n ? l = e.generateTextureLevel(c, t, s, n, i) : r ? l = e.generateTextureBias(c, t, s, r, i) : u ? l = e.generateTextureGrad(c, t, s, u, i) : a ? l = e.generateTextureCompare(c, t, s, a, i) : this.sampler === !1 ? l = e.generateTextureLoad(c, t, s, i) : l = e.generateTexture(c, t, s, i), l;
  }
  /**
   * Generates the code snippet of the texture node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String} output - The current output.
   * @return {String} The generated code snippet.
   */
  generate(e, t) {
    const s = this.value, n = e.getNodeProperties(this), r = super.generate(e, "property");
    if (t === "sampler")
      return r + "_sampler";
    if (e.isReference(t))
      return r;
    {
      const i = e.getDataFromNode(this);
      let a = i.propertyName;
      if (a === void 0) {
        const { uvNode: l, levelNode: d, biasNode: h, compareNode: p, depthNode: f, gradNode: m } = n, _ = this.generateUV(e, l), S = d ? d.build(e, "float") : null, A = h ? h.build(e, "float") : null, M = f ? f.build(e, "int") : null, F = p ? p.build(e, "float") : null, D = m ? [m[0].build(e, "vec2"), m[1].build(e, "vec2")] : null, P = e.getVarFromNode(this);
        a = e.getPropertyName(P);
        const V = this.generateSnippet(e, r, _, S, A, M, F, D);
        e.addLineFlowCode(`${a} = ${V}`, this), i.snippet = V, i.propertyName = a;
      }
      let u = a;
      const c = this.getNodeType(e);
      return e.needsToWorkingColorSpace(s) && (u = Ia(Qt(u, c), s.colorSpace).setup(e).build(e, c)), e.format(u, c, t);
    }
  }
  /**
   * Sets the sampler value.
   *
   * @param {Boolean} value - The sampler value to set.
   * @return {TextureNode} A reference to this texture node.
   */
  setSampler(e) {
    return this.sampler = e, this;
  }
  /**
   * Returns the sampler value.
   *
   * @return {Boolean} The sampler value.
   */
  getSampler() {
    return this.sampler;
  }
  // @TODO: Move to TSL
  uv(e) {
    return console.warn("THREE.TextureNode: .uv() has been renamed. Use .sample() instead."), this.sample(e);
  }
  /**
   * Samples the texture with the given uv node.
   *
   * @param {Node} uvNode - The uv node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  sample(e) {
    const t = this.clone();
    return t.uvNode = E(e), t.referenceNode = this.getSelf(), E(t);
  }
  /**
   * Samples a blurred version of the texture by defining an internal bias.
   *
   * @param {Node<float>} amountNode - How blurred the texture should be.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  blur(e) {
    const t = this.clone();
    return t.biasNode = E(e).mul(Th(t)), t.referenceNode = this.getSelf(), E(t);
  }
  /**
   * Samples a specific mip of the texture.
   *
   * @param {Node<int>} levelNode - The mip level to sample.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  level(e) {
    const t = this.clone();
    return t.levelNode = E(e), t.referenceNode = this.getSelf(), E(t);
  }
  /**
   * Returns the texture size of the requested level.
   *
   * @param {Node<int>} levelNode - The level to compute the size for.
   * @return {TextureSizeNode} The texture size.
   */
  size(e) {
    return jt(this, e);
  }
  /**
   * Samples the texture with the given bias.
   *
   * @param {Node<float>} biasNode - The bias node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  bias(e) {
    const t = this.clone();
    return t.biasNode = E(e), t.referenceNode = this.getSelf(), E(t);
  }
  /**
   * Samples the texture by executing a compare operation.
   *
   * @param {Node<float>} compareNode - The node that defines the compare value.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  compare(e) {
    const t = this.clone();
    return t.compareNode = E(e), t.referenceNode = this.getSelf(), E(t);
  }
  /**
   * Samples the texture using an explicit gradient.
   *
   * @param {Node<vec2>} gradNodeX - The gradX node.
   * @param {Node<vec2>} gradNodeY - The gradY node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  grad(e, t) {
    const s = this.clone();
    return s.gradNode = [E(e), E(t)], s.referenceNode = this.getSelf(), E(s);
  }
  /**
   * Samples the texture by defining a depth node.
   *
   * @param {Node<int>} depthNode - The depth node.
   * @return {TextureNode} A texture node representing the texture sample.
   */
  depth(e) {
    const t = this.clone();
    return t.depthNode = E(e), t.referenceNode = this.getSelf(), E(t);
  }
  // --
  serialize(e) {
    super.serialize(e), e.value = this.value.toJSON(e.meta).uuid, e.sampler = this.sampler, e.updateMatrix = this.updateMatrix, e.updateType = this.updateType;
  }
  deserialize(e) {
    super.deserialize(e), this.value = e.meta.textures[e.value], this.sampler = e.sampler, this.updateMatrix = e.updateMatrix, this.updateType = e.updateType;
  }
  /**
   * The update is used to implement the update of the uv transformation matrix.
   */
  update() {
    const e = this.value, t = this._matrixUniform;
    t !== null && (t.value = e.matrix), e.matrixAutoUpdate === !0 && e.updateMatrix();
  }
  /**
   * Clones the texture node.
   *
   * @return {TextureNode} The cloned texture node.
   */
  clone() {
    const e = new this.constructor(this.value, this.uvNode, this.levelNode, this.biasNode);
    return e.sampler = this.sampler, e;
  }
}
const X = /* @__PURE__ */ C(bt), de = (...o) => X(...o).setSampler(!1), Ny = (o) => (o.isNode === !0 ? o : X(o)).convert("sampler"), qt = /* @__PURE__ */ L("float").label("cameraNear").setGroup(O).onRenderUpdate(({ camera: o }) => o.near), Xt = /* @__PURE__ */ L("float").label("cameraFar").setGroup(O).onRenderUpdate(({ camera: o }) => o.far), _s = /* @__PURE__ */ L("mat4").label("cameraProjectionMatrix").setGroup(O).onRenderUpdate(({ camera: o }) => o.projectionMatrix), by = /* @__PURE__ */ L("mat4").label("cameraProjectionMatrixInverse").setGroup(O).onRenderUpdate(({ camera: o }) => o.projectionMatrixInverse), Xe = /* @__PURE__ */ L("mat4").label("cameraViewMatrix").setGroup(O).onRenderUpdate(({ camera: o }) => o.matrixWorldInverse), Sy = /* @__PURE__ */ L("mat4").label("cameraWorldMatrix").setGroup(O).onRenderUpdate(({ camera: o }) => o.matrixWorld), vy = /* @__PURE__ */ L("mat3").label("cameraNormalMatrix").setGroup(O).onRenderUpdate(({ camera: o }) => o.normalMatrix), _h = /* @__PURE__ */ L(new Y()).label("cameraPosition").setGroup(O).onRenderUpdate(({ camera: o }, e) => e.value.setFromMatrixPosition(o.matrixWorld));
class j extends G {
  static get type() {
    return "Object3DNode";
  }
  /**
   * Constructs a new object 3D node.
   *
   * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
   * @param {Object3D?} [object3d=null] - The 3D object.
   */
  constructor(e, t = null) {
    super(), this.scope = e, this.object3d = t, this.updateType = z.OBJECT, this._uniformNode = new Xn(null);
  }
  /**
   * Overwritten since the node type is inferred from the scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    const e = this.scope;
    if (e === j.WORLD_MATRIX)
      return "mat4";
    if (e === j.POSITION || e === j.VIEW_POSITION || e === j.DIRECTION || e === j.SCALE)
      return "vec3";
  }
  /**
   * Updates the uniform value depending on the scope.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update(e) {
    const t = this.object3d, s = this._uniformNode, n = this.scope;
    if (n === j.WORLD_MATRIX)
      s.value = t.matrixWorld;
    else if (n === j.POSITION)
      s.value = s.value || new Y(), s.value.setFromMatrixPosition(t.matrixWorld);
    else if (n === j.SCALE)
      s.value = s.value || new Y(), s.value.setFromMatrixScale(t.matrixWorld);
    else if (n === j.DIRECTION)
      s.value = s.value || new Y(), t.getWorldDirection(s.value);
    else if (n === j.VIEW_POSITION) {
      const r = e.camera;
      s.value = s.value || new Y(), s.value.setFromMatrixPosition(t.matrixWorld), s.value.applyMatrix4(r.matrixWorldInverse);
    }
  }
  /**
   * Generates the code snippet of the uniform node. The node type of the uniform
   * node also depends on the selected scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The generated code snippet.
   */
  generate(e) {
    const t = this.scope;
    return t === j.WORLD_MATRIX ? this._uniformNode.nodeType = "mat4" : (t === j.POSITION || t === j.VIEW_POSITION || t === j.DIRECTION || t === j.SCALE) && (this._uniformNode.nodeType = "vec3"), this._uniformNode.build(e);
  }
  serialize(e) {
    super.serialize(e), e.scope = this.scope;
  }
  deserialize(e) {
    super.deserialize(e), this.scope = e.scope;
  }
}
j.WORLD_MATRIX = "worldMatrix";
j.POSITION = "position";
j.SCALE = "scale";
j.VIEW_POSITION = "viewPosition";
j.DIRECTION = "direction";
const Ay = /* @__PURE__ */ C(j, j.DIRECTION), Ry = /* @__PURE__ */ C(j, j.WORLD_MATRIX), Nh = /* @__PURE__ */ C(j, j.POSITION), Cy = /* @__PURE__ */ C(j, j.SCALE), Ey = /* @__PURE__ */ C(j, j.VIEW_POSITION);
class St extends j {
  static get type() {
    return "ModelNode";
  }
  /**
   * Constructs a new object model node.
   *
   * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Extracts the model reference from the frame state and then
   * updates the uniform value depending on the scope.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update(e) {
    this.object3d = e.object, super.update(e);
  }
}
const wy = /* @__PURE__ */ B(St, St.DIRECTION), nt = /* @__PURE__ */ B(St, St.WORLD_MATRIX), My = /* @__PURE__ */ B(St, St.POSITION), By = /* @__PURE__ */ B(St, St.SCALE), Fy = /* @__PURE__ */ B(St, St.VIEW_POSITION), bh = /* @__PURE__ */ L(new $n()).onObjectUpdate(({ object: o }, e) => e.value.getNormalMatrix(o.matrixWorld)), Uy = /* @__PURE__ */ L(new Ue()).onObjectUpdate(({ object: o }, e) => e.value.copy(o.matrixWorld).invert()), rn = /* @__PURE__ */ b((o) => o.renderer.nodes.modelViewMatrix || Sh).once()().toVar("modelViewMatrix"), Sh = /* @__PURE__ */ Xe.mul(nt), Py = /* @__PURE__ */ b((o) => (o.context.isHighPrecisionModelViewMatrix = !0, L("mat4").onObjectUpdate(({ object: e, camera: t }) => e.modelViewMatrix.multiplyMatrices(t.matrixWorldInverse, e.matrixWorld)))).once()().toVar("highpModelViewMatrix"), Dy = /* @__PURE__ */ b((o) => {
  const e = o.context.isHighPrecisionModelViewMatrix;
  return L("mat3").onObjectUpdate(({ object: t, camera: s }) => (e !== !0 && t.modelViewMatrix.multiplyMatrices(s.matrixWorldInverse, t.matrixWorld), t.normalMatrix.getNormalMatrix(t.modelViewMatrix)));
}).once()().toVar("highpModelNormalViewMatrix"), fi = /* @__PURE__ */ Nt("position", "vec3"), pe = /* @__PURE__ */ fi.varying("positionLocal"), Hr = /* @__PURE__ */ fi.varying("positionPrevious"), It = /* @__PURE__ */ nt.mul(pe).xyz.varying("v_positionWorld").context({ needsPositionReassign: !0 }), La = /* @__PURE__ */ pe.transformDirection(nt).varying("v_positionWorldDirection").normalize().toVar("positionWorldDirection").context({ needsPositionReassign: !0 }), xe = /* @__PURE__ */ b((o) => o.context.setupPositionView(), "vec3").once()().varying("v_positionView").context({ needsPositionReassign: !0 }), oe = /* @__PURE__ */ xe.negate().varying("v_positionViewDirection").normalize().toVar("positionViewDirection");
class Iy extends G {
  static get type() {
    return "FrontFacingNode";
  }
  /**
   * Constructs a new front facing node.
   */
  constructor() {
    super("bool"), this.isFrontFacingNode = !0;
  }
  generate(e) {
    const { renderer: t, material: s } = e;
    return t.coordinateSystem === En && s.side === Tt ? "false" : e.getFrontFacing();
  }
}
const vh = /* @__PURE__ */ B(Iy), Qn = /* @__PURE__ */ g(vh).mul(2).sub(1), gi = /* @__PURE__ */ Nt("normal", "vec3"), We = /* @__PURE__ */ b((o) => o.geometry.hasAttribute("normal") === !1 ? (console.warn('TSL.NormalNode: Vertex attribute "normal" not found on geometry.'), T(0, 1, 0)) : gi, "vec3").once()().toVar("normalLocal"), Ah = /* @__PURE__ */ xe.dFdx().cross(xe.dFdy()).normalize().toVar("normalFlat"), it = /* @__PURE__ */ b((o) => {
  let e;
  return o.material.flatShading === !0 ? e = Ah : e = qe(Va(We), "v_normalView").normalize(), e;
}, "vec3").once()().toVar("normalView"), mi = /* @__PURE__ */ qe(it.transformDirection(Xe), "v_normalWorld").normalize().toVar("normalWorld"), he = /* @__PURE__ */ b((o) => o.context.setupNormal(), "vec3").once()().mul(Qn).toVar("transformedNormalView"), yi = /* @__PURE__ */ he.transformDirection(Xe).toVar("transformedNormalWorld"), Gs = /* @__PURE__ */ b((o) => o.context.setupClearcoatNormal(), "vec3").once()().mul(Qn).toVar("transformedClearcoatNormalView"), Rh = /* @__PURE__ */ b(([o, e = nt]) => {
  const t = Le(e), s = o.div(T(t[0].dot(t[0]), t[1].dot(t[1]), t[2].dot(t[2])));
  return t.mul(s).xyz;
}), Va = /* @__PURE__ */ b(([o], e) => {
  const t = e.renderer.nodes.modelNormalViewMatrix;
  if (t !== null)
    return t.transformDirection(o);
  const s = bh.mul(o);
  return Xe.transformDirection(s);
}), Ch = /* @__PURE__ */ L(0).onReference(({ material: o }) => o).onRenderUpdate(({ material: o }) => o.refractionRatio), Eh = /* @__PURE__ */ oe.negate().reflect(he), wh = /* @__PURE__ */ oe.negate().refract(he, Ch), Mh = /* @__PURE__ */ Eh.transformDirection(Xe).toVar("reflectVector"), Bh = /* @__PURE__ */ wh.transformDirection(Xe).toVar("reflectVector");
class Ly extends bt {
  static get type() {
    return "CubeTextureNode";
  }
  /**
   * Constructs a new cube texture node.
   *
   * @param {CubeTexture} value - The cube texture.
   * @param {Node<vec3>?} [uvNode=null] - The uv node.
   * @param {Node<int>?} [levelNode=null] - The level node.
   * @param {Node<float>?} [biasNode=null] - The bias node.
   */
  constructor(e, t = null, s = null, n = null) {
    super(e, t, s, n), this.isCubeTextureNode = !0;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'cubeTexture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return "cubeTexture";
  }
  /**
   * Returns a default uvs based on the mapping type of the cube texture.
   *
   * @return {Node<vec3>} The default uv attribute.
   */
  getDefaultUV() {
    const e = this.value;
    return e.mapping === Ks ? Mh : e.mapping === Ys ? Bh : (console.error('THREE.CubeTextureNode: Mapping "%s" not supported.', e.mapping), T(0, 0, 0));
  }
  /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for cube textures. The uv transformation matrix is not applied to cube textures.
   *
   * @param {Boolean} value - The update toggle.
   */
  setUpdateMatrix() {
  }
  // Ignore .updateMatrix for CubeTextureNode
  /**
   * Setups the uv node. Depending on the backend as well as the texture type, it might be necessary
   * to modify the uv node for correct sampling.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The updated uv node.
   */
  setupUV(e, t) {
    const s = this.value;
    return e.renderer.coordinateSystem === sn || !s.isRenderTargetTexture ? T(t.x.negate(), t.yz) : t;
  }
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} cubeUV - The uv node to generate code for.
   * @return {String} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, "vec3");
  }
}
const Js = /* @__PURE__ */ C(Ly);
class Ga extends Xn {
  static get type() {
    return "BufferNode";
  }
  /**
   * Constructs a new buffer node.
   *
   * @param {Array<Number>} value - Array-like buffer data.
   * @param {String} bufferType - The data type of the buffer.
   * @param {Number} [bufferCount=0] - The count of buffer elements.
   */
  constructor(e, t, s = 0) {
    super(e, t), this.isBufferNode = !0, this.bufferType = t, this.bufferCount = s;
  }
  /**
   * The data type of the buffer elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The element type.
   */
  getElementType(e) {
    return this.getNodeType(e);
  }
  /**
   * Overwrites the default implementation to return a fixed value `'buffer'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return "buffer";
  }
}
const Zn = (o, e, t) => E(new Ga(o, e, t));
class Vy extends Ts {
  static get type() {
    return "UniformArrayElementNode";
  }
  /**
   * Constructs a new buffer node.
   *
   * @param {UniformArrayNode} uniformArrayNode - The uniform array node to access.
   * @param {IndexNode} indexNode - The index data that define the position of the accessed element in the array.
   */
  constructor(e, t) {
    super(e, t), this.isArrayBufferElementNode = !0;
  }
  generate(e) {
    const t = super.generate(e), s = this.getNodeType(), n = this.node.getPaddedType();
    return e.format(t, n, s);
  }
}
class Fh extends Ga {
  static get type() {
    return "UniformArrayNode";
  }
  /**
   * Constructs a new uniform array node.
   *
   * @param {Array<Any>} value - Array holding the buffer data.
   * @param {String?} [elementType=null] - The data type of a buffer element.
   */
  constructor(e, t = null) {
    super(null), this.array = e, this.elementType = t === null ? Yt(e[0]) : t, this.paddedType = this.getPaddedType(), this.updateType = z.RENDER, this.isArrayBufferNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from the
   * {@link module:UniformArrayNode~UniformArrayNode#paddedType}.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    return this.paddedType;
  }
  /**
   * The data type of the array elements.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The element type.
   */
  getElementType() {
    return this.elementType;
  }
  /**
   * Returns the padded type based on the element type.
   *
   * @return {String} The padded type.
   */
  getPaddedType() {
    const e = this.elementType;
    let t = "vec4";
    return e === "mat2" ? t = "mat2" : /mat/.test(e) === !0 ? t = "mat4" : e.charAt(0) === "i" ? t = "ivec4" : e.charAt(0) === "u" && (t = "uvec4"), t;
  }
  /**
   * The update makes sure to correctly transfer the data from the (complex) objects
   * in the array to the internal, correctly padded value buffer.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    const { array: e, value: t } = this, s = this.elementType;
    if (s === "float" || s === "int" || s === "uint")
      for (let n = 0; n < e.length; n++) {
        const r = n * 4;
        t[r] = e[n];
      }
    else if (s === "color")
      for (let n = 0; n < e.length; n++) {
        const r = n * 4, i = e[n];
        t[r] = i.r, t[r + 1] = i.g, t[r + 2] = i.b || 0;
      }
    else if (s === "mat2")
      for (let n = 0; n < e.length; n++) {
        const r = n * 4, i = e[n];
        t[r] = i.elements[0], t[r + 1] = i.elements[1], t[r + 2] = i.elements[2], t[r + 3] = i.elements[3];
      }
    else if (s === "mat3")
      for (let n = 0; n < e.length; n++) {
        const r = n * 16, i = e[n];
        t[r] = i.elements[0], t[r + 1] = i.elements[1], t[r + 2] = i.elements[2], t[r + 4] = i.elements[3], t[r + 5] = i.elements[4], t[r + 6] = i.elements[5], t[r + 8] = i.elements[6], t[r + 9] = i.elements[7], t[r + 10] = i.elements[8], t[r + 15] = 1;
      }
    else if (s === "mat4")
      for (let n = 0; n < e.length; n++) {
        const r = n * 16, i = e[n];
        for (let a = 0; a < i.elements.length; a++)
          t[r + a] = i.elements[a];
      }
    else
      for (let n = 0; n < e.length; n++) {
        const r = n * 4, i = e[n];
        t[r] = i.x, t[r + 1] = i.y, t[r + 2] = i.z || 0, t[r + 3] = i.w || 0;
      }
  }
  /**
   * Implement the value buffer creation based on the array data.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {null}
   */
  setup(e) {
    const t = this.array.length, s = this.elementType;
    let n = Float32Array;
    const r = this.paddedType, i = e.getTypeLength(r);
    return s.charAt(0) === "i" && (n = Int32Array), s.charAt(0) === "u" && (n = Uint32Array), this.value = new n(t * i), this.bufferCount = t, this.bufferType = r, super.setup(e);
  }
  /**
   * Overwrites the default `element()` method to provide element access
   * based on {@link module:UniformArrayNode~UniformArrayNode}.
   *
   * @param {IndexNode} indexNode - The index node.
   * @return {UniformArrayElementNode}
   */
  element(e) {
    return E(new Vy(this, E(e)));
  }
}
const Ut = (o, e) => E(new Fh(o, e)), Gy = (o, e) => (console.warn("TSL.UniformArrayNode: uniforms() has been renamed to uniformArray()."), E(new Fh(o, e)));
class Oy extends Ts {
  static get type() {
    return "ReferenceElementNode";
  }
  /**
   * Constructs a new reference element node.
   *
   * @param {Node?} referenceNode - The reference node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.referenceNode = e, this.isReferenceElementNode = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the uniform type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    return this.referenceNode.uniformType;
  }
  generate(e) {
    const t = super.generate(e), s = this.referenceNode.getNodeType(), n = this.getNodeType();
    return e.format(t, s, n);
  }
}
class xi extends G {
  static get type() {
    return "ReferenceNode";
  }
  /**
   * Constructs a new reference node.
   *
   * @param {String} property - The name of the property the node refers to.
   * @param {String} uniformType - The uniform type that should be used to represent the property value.
   * @param {Object?} [object=null] - The object the property belongs to.
   * @param {Number?} [count=null] - When the linked property is an array-like, this parameter defines its length.
   */
  constructor(e, t, s = null, n = null) {
    super(), this.property = e, this.uniformType = t, this.object = s, this.count = n, this.properties = e.split("."), this.reference = s, this.node = null, this.group = null, this.name = null, this.updateType = z.OBJECT;
  }
  /**
   * When the referred property is array-like, this method can be used
   * to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {ReferenceElementNode} A reference to an element.
   */
  element(e) {
    return E(new Oy(this, E(e)));
  }
  /**
   * Sets the uniform group for this reference node.
   *
   * @param {UniformGroupNode} group - The uniform group to set.
   * @return {ReferenceNode} A reference to this node.
   */
  setGroup(e) {
    return this.group = e, this;
  }
  /**
   * Sets the label for the internal uniform.
   *
   * @param {String} name - The label to set.
   * @return {ReferenceNode} A reference to this node.
   */
  label(e) {
    return this.name = e, this;
  }
  /**
   * Sets the node type which automatically defines the internal
   * uniform type.
   *
   * @param {String} uniformType - The type to set.
   */
  setNodeType(e) {
    let t = null;
    this.count !== null ? t = Zn(null, e, this.count) : Array.isArray(this.getValueFromReference()) ? t = Ut(null, e) : e === "texture" ? t = X(null) : e === "cubeTexture" ? t = Js(null) : t = L(null, e), this.group !== null && t.setGroup(this.group), this.name !== null && t.label(this.name), this.node = t.getSelf();
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the type of the reference node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.node === null && (this.updateReference(e), this.updateValue()), this.node.getNodeType(e);
  }
  /**
   * Returns the property value from the given referred object.
   *
   * @param {Object} [object=this.reference] - The object to retrieve the property value from.
   * @return {Any} The value.
   */
  getValueFromReference(e = this.reference) {
    const { properties: t } = this;
    let s = e[t[0]];
    for (let n = 1; n < t.length; n++)
      s = s[t[n]];
    return s;
  }
  /**
   * Allows to update the reference based on the given state. The state is only
   * evaluated {@link module:ReferenceNode~ReferenceNode#object} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.object !== null ? this.object : e.object, this.reference;
  }
  /**
   * The output of the reference node is the internal uniform node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {UniformNode} The output node.
   */
  setup() {
    return this.updateValue(), this.node;
  }
  /**
   * Overwritten to to update the internal uniform value.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    this.updateValue();
  }
  /**
   * Retrieves the value from the referred object property and uses it
   * to updated the internal uniform.
   */
  updateValue() {
    this.node === null && this.setNodeType(this.uniformType);
    const e = this.getValueFromReference();
    Array.isArray(e) ? this.node.array = e : this.node.value = e;
  }
}
const te = (o, e, t) => E(new xi(o, e, t)), Oo = (o, e, t, s) => E(new xi(o, e, s, t));
class ky extends xi {
  static get type() {
    return "MaterialReferenceNode";
  }
  /**
   * Constructs a new material reference node.
   *
   * @param {String} property - The name of the property the node refers to.
   * @param {String} inputType - The uniform type that should be used to represent the property value.
   * @param {Material?} [material=null] - The material the property belongs to. When no material is set,
   * the node refers to the material of the current rendered object.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.material = s, this.isMaterialReferenceNode = !0;
  }
  /**
   * Updates the reference based on the given state. The state is only evaluated
   * {@link module:MaterialReferenceNode~MaterialReferenceNode#material} is not set.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state.
   * @return {Object} The updated reference.
   */
  updateReference(e) {
    return this.reference = this.material !== null ? this.material : e.material, this.reference;
  }
}
const Pt = (o, e, t = null) => E(new ky(o, e, t)), Ti = /* @__PURE__ */ b((o) => (o.geometry.hasAttribute("tangent") === !1 && o.geometry.computeTangents(), Nt("tangent", "vec4")))(), Jn = /* @__PURE__ */ Ti.xyz.toVar("tangentLocal"), er = /* @__PURE__ */ rn.mul(I(Jn, 0)).xyz.varying("v_tangentView").normalize().toVar("tangentView"), Uh = /* @__PURE__ */ er.transformDirection(Xe).varying("v_tangentWorld").normalize().toVar("tangentWorld"), Oa = /* @__PURE__ */ er.toVar("transformedTangentView"), zy = /* @__PURE__ */ Oa.transformDirection(Xe).normalize().toVar("transformedTangentWorld"), tr = (o) => o.mul(Ti.w).xyz, $y = /* @__PURE__ */ qe(tr(gi.cross(Ti)), "v_bitangentGeometry").normalize().toVar("bitangentGeometry"), Wy = /* @__PURE__ */ qe(tr(We.cross(Jn)), "v_bitangentLocal").normalize().toVar("bitangentLocal"), Ph = /* @__PURE__ */ qe(tr(it.cross(er)), "v_bitangentView").normalize().toVar("bitangentView"), Hy = /* @__PURE__ */ qe(tr(mi.cross(Uh)), "v_bitangentWorld").normalize().toVar("bitangentWorld"), Dh = /* @__PURE__ */ tr(he.cross(Oa)).normalize().toVar("transformedBitangentView"), qy = /* @__PURE__ */ Dh.transformDirection(Xe).normalize().toVar("transformedBitangentWorld"), us = /* @__PURE__ */ Le(er, Ph, it), Ih = /* @__PURE__ */ oe.mul(us), Xy = (o, e) => o.sub(Ih.mul(e)), Lh = /* @__PURE__ */ (() => {
  let o = fs.cross(oe);
  return o = o.cross(fs).normalize(), o = Z(o, he, Ht.mul(ft.oneMinus()).oneMinus().pow2().pow2()).normalize(), o;
})(), Ky = /* @__PURE__ */ b((o) => {
  const { eye_pos: e, surf_norm: t, mapN: s, uv: n } = o, r = e.dFdx(), i = e.dFdy(), a = n.dFdx(), u = n.dFdy(), c = t, l = i.cross(c), d = c.cross(r), h = l.mul(a.x).add(d.mul(u.x)), p = l.mul(a.y).add(d.mul(u.y)), f = h.dot(h).max(p.dot(p)), m = Qn.mul(f.inverseSqrt());
  return _e(h.mul(s.x, m), p.mul(s.y, m), c.mul(s.z)).normalize();
});
class Yy extends Ne {
  static get type() {
    return "NormalMapNode";
  }
  /**
   * Constructs a new normal map node.
   *
   * @param {Node} node - Represents the normal map data.
   * @param {Node?} [scaleNode=null] - Controls the intensity of the effect.
   */
  constructor(e, t = null) {
    super("vec3"), this.node = e, this.scaleNode = t, this.normalMapType = Fu;
  }
  setup(e) {
    const { normalMapType: t, scaleNode: s } = this;
    let n = this.node.mul(2).sub(1);
    s !== null && (n = T(n.xy.mul(s), n.z));
    let r = null;
    return t === Vg ? r = Va(n) : t === Fu && (e.hasGeometryAttribute("tangent") === !0 ? r = us.mul(n).normalize() : r = Ky({
      eye_pos: xe,
      surf_norm: it,
      mapN: n,
      uv: le()
    })), r;
  }
}
const ko = /* @__PURE__ */ C(Yy), jy = b(({ textureNode: o, bumpScale: e }) => {
  const t = (n) => o.cache().context({ getUV: (r) => n(r.uvNode || le()), forceUVContext: !0 }), s = g(t((n) => n));
  return w(
    g(t((n) => n.add(n.dFdx()))).sub(s),
    g(t((n) => n.add(n.dFdy()))).sub(s)
  ).mul(e);
}), Qy = b((o) => {
  const { surf_pos: e, surf_norm: t, dHdxy: s } = o, n = e.dFdx().normalize(), r = e.dFdy().normalize(), i = t, a = r.cross(i), u = i.cross(n), c = n.dot(a).mul(Qn), l = c.sign().mul(s.x.mul(a).add(s.y.mul(u)));
  return c.abs().mul(t).sub(l).normalize();
});
class Zy extends Ne {
  static get type() {
    return "BumpMapNode";
  }
  /**
   * Constructs a new bump map node.
   *
   * @param {Node} textureNode - Represents the bump map data.
   * @param {Node?} [scaleNode=null] - Controls the intensity of the bump effect.
   */
  constructor(e, t = null) {
    super("vec3"), this.textureNode = e, this.scaleNode = t;
  }
  setup() {
    const e = this.scaleNode !== null ? this.scaleNode : 1, t = jy({ textureNode: this.textureNode, bumpScale: e });
    return Qy({
      surf_pos: xe,
      surf_norm: it,
      dHdxy: t
    });
  }
}
const Vh = /* @__PURE__ */ C(Zy), Vu = /* @__PURE__ */ new Map();
class v extends G {
  static get type() {
    return "MaterialNode";
  }
  /**
   * Constructs a new material node.
   *
   * @param {String} scope - The scope defines what kind of material property is referred by the node.
   */
  constructor(e) {
    super(), this.scope = e;
  }
  /**
   * Returns a cached reference node for the given property and type.
   *
   * @param {String} property - The name of the material property.
   * @param {String} type - The uniform type of the property.
   * @return {MaterialReferenceNode} A material reference node representing the property access.
   */
  getCache(e, t) {
    let s = Vu.get(e);
    return s === void 0 && (s = Pt(e, t), Vu.set(e, s)), s;
  }
  /**
   * Returns a float-typed material reference node for the given property name.
   *
   * @param {String} property - The name of the material property.
   * @return {MaterialReferenceNode<float>} A material reference node representing the property access.
   */
  getFloat(e) {
    return this.getCache(e, "float");
  }
  /**
   * Returns a color-typed material reference node for the given property name.
   *
   * @param {String} property - The name of the material property.
   * @return {MaterialReferenceNode<color>} A material reference node representing the property access.
   */
  getColor(e) {
    return this.getCache(e, "color");
  }
  /**
   * Returns a texture-typed material reference node for the given property name.
   *
   * @param {String} property - The name of the material property.
   * @return {MaterialReferenceNode} A material reference node representing the property access.
   */
  getTexture(e) {
    return this.getCache(e === "map" ? "map" : e + "Map", "texture");
  }
  /**
   * The node setup is done depending on the selected scope. Multiple material properties
   * might be grouped into a single node composition if they logically belong together.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The node representing the selected scope.
   */
  setup(e) {
    const t = e.context.material, s = this.scope;
    let n = null;
    if (s === v.COLOR) {
      const r = t.color !== void 0 ? this.getColor(s) : T();
      t.map && t.map.isTexture === !0 ? n = r.mul(this.getTexture("map")) : n = r;
    } else if (s === v.OPACITY) {
      const r = this.getFloat(s);
      t.alphaMap && t.alphaMap.isTexture === !0 ? n = r.mul(this.getTexture("alpha")) : n = r;
    } else if (s === v.SPECULAR_STRENGTH)
      t.specularMap && t.specularMap.isTexture === !0 ? n = this.getTexture("specular").r : n = g(1);
    else if (s === v.SPECULAR_INTENSITY) {
      const r = this.getFloat(s);
      t.specularIntensityMap && t.specularIntensityMap.isTexture === !0 ? n = r.mul(this.getTexture(s).a) : n = r;
    } else if (s === v.SPECULAR_COLOR) {
      const r = this.getColor(s);
      t.specularColorMap && t.specularColorMap.isTexture === !0 ? n = r.mul(this.getTexture(s).rgb) : n = r;
    } else if (s === v.ROUGHNESS) {
      const r = this.getFloat(s);
      t.roughnessMap && t.roughnessMap.isTexture === !0 ? n = r.mul(this.getTexture(s).g) : n = r;
    } else if (s === v.METALNESS) {
      const r = this.getFloat(s);
      t.metalnessMap && t.metalnessMap.isTexture === !0 ? n = r.mul(this.getTexture(s).b) : n = r;
    } else if (s === v.EMISSIVE) {
      const r = this.getFloat("emissiveIntensity"), i = this.getColor(s).mul(r);
      t.emissiveMap && t.emissiveMap.isTexture === !0 ? n = i.mul(this.getTexture(s)) : n = i;
    } else if (s === v.NORMAL)
      t.normalMap ? (n = ko(this.getTexture("normal"), this.getCache("normalScale", "vec2")), n.normalMapType = t.normalMapType) : t.bumpMap ? n = Vh(this.getTexture("bump").r, this.getFloat("bumpScale")) : n = it;
    else if (s === v.CLEARCOAT) {
      const r = this.getFloat(s);
      t.clearcoatMap && t.clearcoatMap.isTexture === !0 ? n = r.mul(this.getTexture(s).r) : n = r;
    } else if (s === v.CLEARCOAT_ROUGHNESS) {
      const r = this.getFloat(s);
      t.clearcoatRoughnessMap && t.clearcoatRoughnessMap.isTexture === !0 ? n = r.mul(this.getTexture(s).r) : n = r;
    } else if (s === v.CLEARCOAT_NORMAL)
      t.clearcoatNormalMap ? n = ko(this.getTexture(s), this.getCache(s + "Scale", "vec2")) : n = it;
    else if (s === v.SHEEN) {
      const r = this.getColor("sheenColor").mul(this.getFloat("sheen"));
      t.sheenColorMap && t.sheenColorMap.isTexture === !0 ? n = r.mul(this.getTexture("sheenColor").rgb) : n = r;
    } else if (s === v.SHEEN_ROUGHNESS) {
      const r = this.getFloat(s);
      t.sheenRoughnessMap && t.sheenRoughnessMap.isTexture === !0 ? n = r.mul(this.getTexture(s).a) : n = r, n = n.clamp(0.07, 1);
    } else if (s === v.ANISOTROPY)
      if (t.anisotropyMap && t.anisotropyMap.isTexture === !0) {
        const r = this.getTexture(s);
        n = oi(Ps.x, Ps.y, Ps.y.negate(), Ps.x).mul(r.rg.mul(2).sub(w(1)).normalize().mul(r.b));
      } else
        n = Ps;
    else if (s === v.IRIDESCENCE_THICKNESS) {
      const r = te("1", "float", t.iridescenceThicknessRange);
      if (t.iridescenceThicknessMap) {
        const i = te("0", "float", t.iridescenceThicknessRange);
        n = r.sub(i).mul(this.getTexture(s).g).add(i);
      } else
        n = r;
    } else if (s === v.TRANSMISSION) {
      const r = this.getFloat(s);
      t.transmissionMap ? n = r.mul(this.getTexture(s).r) : n = r;
    } else if (s === v.THICKNESS) {
      const r = this.getFloat(s);
      t.thicknessMap ? n = r.mul(this.getTexture(s).g) : n = r;
    } else if (s === v.IOR)
      n = this.getFloat(s);
    else if (s === v.LIGHT_MAP)
      n = this.getTexture(s).rgb.mul(this.getFloat("lightMapIntensity"));
    else if (s === v.AO)
      n = this.getTexture(s).r.sub(1).mul(this.getFloat("aoMapIntensity")).add(1);
    else {
      const r = this.getNodeType(e);
      n = this.getCache(s, r);
    }
    return n;
  }
}
v.ALPHA_TEST = "alphaTest";
v.COLOR = "color";
v.OPACITY = "opacity";
v.SHININESS = "shininess";
v.SPECULAR = "specular";
v.SPECULAR_STRENGTH = "specularStrength";
v.SPECULAR_INTENSITY = "specularIntensity";
v.SPECULAR_COLOR = "specularColor";
v.REFLECTIVITY = "reflectivity";
v.ROUGHNESS = "roughness";
v.METALNESS = "metalness";
v.NORMAL = "normal";
v.CLEARCOAT = "clearcoat";
v.CLEARCOAT_ROUGHNESS = "clearcoatRoughness";
v.CLEARCOAT_NORMAL = "clearcoatNormal";
v.EMISSIVE = "emissive";
v.ROTATION = "rotation";
v.SHEEN = "sheen";
v.SHEEN_ROUGHNESS = "sheenRoughness";
v.ANISOTROPY = "anisotropy";
v.IRIDESCENCE = "iridescence";
v.IRIDESCENCE_IOR = "iridescenceIOR";
v.IRIDESCENCE_THICKNESS = "iridescenceThickness";
v.IOR = "ior";
v.TRANSMISSION = "transmission";
v.THICKNESS = "thickness";
v.ATTENUATION_DISTANCE = "attenuationDistance";
v.ATTENUATION_COLOR = "attenuationColor";
v.LINE_SCALE = "scale";
v.LINE_DASH_SIZE = "dashSize";
v.LINE_GAP_SIZE = "gapSize";
v.LINE_WIDTH = "linewidth";
v.LINE_DASH_OFFSET = "dashOffset";
v.POINT_WIDTH = "pointWidth";
v.DISPERSION = "dispersion";
v.LIGHT_MAP = "light";
v.AO = "ao";
const Gh = /* @__PURE__ */ B(v, v.ALPHA_TEST), Oh = /* @__PURE__ */ B(v, v.COLOR), kh = /* @__PURE__ */ B(v, v.SHININESS), zh = /* @__PURE__ */ B(v, v.EMISSIVE), ka = /* @__PURE__ */ B(v, v.OPACITY), $h = /* @__PURE__ */ B(v, v.SPECULAR), zo = /* @__PURE__ */ B(v, v.SPECULAR_INTENSITY), Wh = /* @__PURE__ */ B(v, v.SPECULAR_COLOR), An = /* @__PURE__ */ B(v, v.SPECULAR_STRENGTH), Br = /* @__PURE__ */ B(v, v.REFLECTIVITY), Hh = /* @__PURE__ */ B(v, v.ROUGHNESS), qh = /* @__PURE__ */ B(v, v.METALNESS), Xh = /* @__PURE__ */ B(v, v.NORMAL).context({ getUV: null }), Kh = /* @__PURE__ */ B(v, v.CLEARCOAT), Yh = /* @__PURE__ */ B(v, v.CLEARCOAT_ROUGHNESS), jh = /* @__PURE__ */ B(v, v.CLEARCOAT_NORMAL).context({ getUV: null }), Qh = /* @__PURE__ */ B(v, v.ROTATION), Zh = /* @__PURE__ */ B(v, v.SHEEN), Jh = /* @__PURE__ */ B(v, v.SHEEN_ROUGHNESS), ep = /* @__PURE__ */ B(v, v.ANISOTROPY), tp = /* @__PURE__ */ B(v, v.IRIDESCENCE), sp = /* @__PURE__ */ B(v, v.IRIDESCENCE_IOR), np = /* @__PURE__ */ B(v, v.IRIDESCENCE_THICKNESS), rp = /* @__PURE__ */ B(v, v.TRANSMISSION), ip = /* @__PURE__ */ B(v, v.THICKNESS), op = /* @__PURE__ */ B(v, v.IOR), ap = /* @__PURE__ */ B(v, v.ATTENUATION_DISTANCE), up = /* @__PURE__ */ B(v, v.ATTENUATION_COLOR), cp = /* @__PURE__ */ B(v, v.LINE_SCALE), lp = /* @__PURE__ */ B(v, v.LINE_DASH_SIZE), dp = /* @__PURE__ */ B(v, v.LINE_GAP_SIZE), Jy = /* @__PURE__ */ B(v, v.LINE_WIDTH), hp = /* @__PURE__ */ B(v, v.LINE_DASH_OFFSET), ex = /* @__PURE__ */ B(v, v.POINT_WIDTH), pp = /* @__PURE__ */ B(v, v.DISPERSION), za = /* @__PURE__ */ B(v, v.LIGHT_MAP), fp = /* @__PURE__ */ B(v, v.AO), Ps = /* @__PURE__ */ L(new He()).onReference(function(o) {
  return o.material;
}).onRenderUpdate(function({ material: o }) {
  this.value.set(o.anisotropy * Math.cos(o.anisotropyRotation), o.anisotropy * Math.sin(o.anisotropyRotation));
}), $a = /* @__PURE__ */ b((o) => o.context.setupModelViewProjection(), "vec4").once()().varying("v_modelViewProjection");
class ae extends G {
  static get type() {
    return "IndexNode";
  }
  /**
   * Constructs a new index node.
   *
   * @param {('vertex'|'instance'|'subgroup'|'invocationLocal'|'invocationSubgroup'|'draw')} scope - The scope of the index node.
   */
  constructor(e) {
    super("uint"), this.scope = e, this.isIndexNode = !0;
  }
  generate(e) {
    const t = this.getNodeType(e), s = this.scope;
    let n;
    if (s === ae.VERTEX)
      n = e.getVertexIndex();
    else if (s === ae.INSTANCE)
      n = e.getInstanceIndex();
    else if (s === ae.DRAW)
      n = e.getDrawIndex();
    else if (s === ae.INVOCATION_LOCAL)
      n = e.getInvocationLocalIndex();
    else if (s === ae.INVOCATION_SUBGROUP)
      n = e.getInvocationSubgroupIndex();
    else if (s === ae.SUBGROUP)
      n = e.getSubgroupIndex();
    else
      throw new Error("THREE.IndexNode: Unknown scope: " + s);
    let r;
    return e.shaderStage === "vertex" || e.shaderStage === "compute" ? r = n : r = qe(this).build(e, t), r;
  }
}
ae.VERTEX = "vertex";
ae.INSTANCE = "instance";
ae.SUBGROUP = "subgroup";
ae.INVOCATION_LOCAL = "invocationLocal";
ae.INVOCATION_SUBGROUP = "invocationSubgroup";
ae.DRAW = "draw";
const gp = /* @__PURE__ */ B(ae, ae.VERTEX), sr = /* @__PURE__ */ B(ae, ae.INSTANCE), tx = /* @__PURE__ */ B(ae, ae.SUBGROUP), sx = /* @__PURE__ */ B(ae, ae.INVOCATION_SUBGROUP), nx = /* @__PURE__ */ B(ae, ae.INVOCATION_LOCAL), mp = /* @__PURE__ */ B(ae, ae.DRAW);
class yp extends G {
  static get type() {
    return "InstanceNode";
  }
  /**
   * Constructs a new instance node.
   *
   * @param {Number} count - The number of instances.
   * @param {InstancedBufferAttribute} instanceMatrix - Instanced buffer attribute representing the instance transformations.
   * @param {InstancedBufferAttribute} instanceColor - Instanced buffer attribute representing the instance colors.
   */
  constructor(e, t, s) {
    super("void"), this.count = e, this.instanceMatrix = t, this.instanceColor = s, this.instanceMatrixNode = null, this.instanceColorNode = null, this.updateType = z.FRAME, this.buffer = null, this.bufferColor = null;
  }
  /**
   * Setups the internal buffers and nodes and assigns the transformed vertex data
   * to predefined node variables for accumulation. That follows the same patterns
   * like with morph and skinning nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    const { count: t, instanceMatrix: s, instanceColor: n } = this;
    let { instanceMatrixNode: r, instanceColorNode: i } = this;
    if (r === null) {
      if (t <= 1e3)
        r = Zn(s.array, "mat4", Math.max(t, 1)).element(sr);
      else {
        const u = new Gg(s.array, 16, 1);
        this.buffer = u;
        const c = s.usage === Is ? Go : Wr, l = [
          // F.Signature -> bufferAttribute( array, type, stride, offset )
          c(u, "vec4", 16, 0),
          c(u, "vec4", 16, 4),
          c(u, "vec4", 16, 8),
          c(u, "vec4", 16, 12)
        ];
        r = ps(...l);
      }
      this.instanceMatrixNode = r;
    }
    if (n && i === null) {
      const u = new oa(n.array, 3), c = n.usage === Is ? Go : Wr;
      this.bufferColor = u, i = T(c(u, "vec3", 3, 0)), this.instanceColorNode = i;
    }
    const a = r.mul(pe).xyz;
    if (pe.assign(a), e.hasGeometryAttribute("normal")) {
      const u = Rh(We, r);
      We.assign(u);
    }
    this.instanceColorNode !== null && Dn("vec3", "vInstanceColor").assign(this.instanceColorNode);
  }
  /**
   * Checks if the internal buffers required an update.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update() {
    this.instanceMatrix.usage !== Is && this.buffer !== null && this.instanceMatrix.version !== this.buffer.version && (this.buffer.version = this.instanceMatrix.version), this.instanceColor && this.instanceColor.usage !== Is && this.bufferColor !== null && this.instanceColor.version !== this.bufferColor.version && (this.bufferColor.version = this.instanceColor.version);
  }
}
const rx = /* @__PURE__ */ C(yp);
class ix extends yp {
  static get type() {
    return "InstancedMeshNode";
  }
  /**
   * Constructs a new instanced mesh node.
   *
   * @param {InstancedMesh} instancedMesh - The instanced mesh.
   */
  constructor(e) {
    const { count: t, instanceMatrix: s, instanceColor: n } = e;
    super(t, s, n), this.instancedMesh = e;
  }
}
const xp = /* @__PURE__ */ C(ix);
class ox extends G {
  static get type() {
    return "BatchNode";
  }
  /**
   * Constructs a new batch node.
   *
   * @param {BatchedMesh} batchMesh - A reference to batched mesh.
   */
  constructor(e) {
    super("void"), this.batchMesh = e, this.batchingIdNode = null;
  }
  /**
   * Setups the internal buffers and nodes and assigns the transformed vertex data
   * to predefined node variables for accumulation. That follows the same patterns
   * like with morph and skinning nodes.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    this.batchingIdNode === null && (e.getDrawIndex() === null ? this.batchingIdNode = sr : this.batchingIdNode = mp);
    const s = b(([f]) => {
      const m = jt(de(this.batchMesh._indirectTexture), 0), _ = y(f).modInt(y(m)), S = y(f).div(y(m));
      return de(this.batchMesh._indirectTexture, Ae(_, S)).x;
    }).setLayout({
      name: "getIndirectIndex",
      type: "uint",
      inputs: [
        { name: "id", type: "int" }
      ]
    })(y(this.batchingIdNode)), n = this.batchMesh._matricesTexture, r = jt(de(n), 0), i = g(s).mul(4).toInt().toVar(), a = i.modInt(r), u = i.div(y(r)), c = ps(
      de(n, Ae(a, u)),
      de(n, Ae(a.add(1), u)),
      de(n, Ae(a.add(2), u)),
      de(n, Ae(a.add(3), u))
    ), l = this.batchMesh._colorsTexture;
    if (l !== null) {
      const m = b(([_]) => {
        const S = jt(de(l), 0).x, A = _, M = A.modInt(S), F = A.div(S);
        return de(l, Ae(M, F)).rgb;
      }).setLayout({
        name: "getBatchingColor",
        type: "vec3",
        inputs: [
          { name: "id", type: "int" }
        ]
      })(s);
      Dn("vec3", "vBatchColor").assign(m);
    }
    const d = Le(c);
    pe.assign(c.mul(pe));
    const h = We.div(T(d[0].dot(d[0]), d[1].dot(d[1]), d[2].dot(d[2]))), p = d.mul(h).xyz;
    We.assign(p), e.hasGeometryAttribute("tangent") && Jn.mulAssign(d);
  }
}
const Tp = /* @__PURE__ */ C(ox), Gu = /* @__PURE__ */ new WeakMap();
class _p extends G {
  static get type() {
    return "SkinningNode";
  }
  /**
   * Constructs a new skinning node.
   *
   * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
   * @param {Boolean} [useReference=false] - Whether to use reference nodes for internal skinned mesh related data or not.
   */
  constructor(e, t = !1) {
    super("void"), this.skinnedMesh = e, this.useReference = t, this.updateType = z.OBJECT, this.skinIndexNode = Nt("skinIndex", "uvec4"), this.skinWeightNode = Nt("skinWeight", "vec4");
    let s, n, r;
    t ? (s = te("bindMatrix", "mat4"), n = te("bindMatrixInverse", "mat4"), r = Oo("skeleton.boneMatrices", "mat4", e.skeleton.bones.length)) : (s = L(e.bindMatrix, "mat4"), n = L(e.bindMatrixInverse, "mat4"), r = Zn(e.skeleton.boneMatrices, "mat4", e.skeleton.bones.length)), this.bindMatrixNode = s, this.bindMatrixInverseNode = n, this.boneMatricesNode = r, this.previousBoneMatricesNode = null;
  }
  /**
   * Transforms the given vertex position via skinning.
   *
   * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
   * @param {Node<vec3>} [position=positionLocal] - The vertex position in local space.
   * @return {Node<vec3>} The transformed vertex position.
   */
  getSkinnedPosition(e = this.boneMatricesNode, t = pe) {
    const { skinIndexNode: s, skinWeightNode: n, bindMatrixNode: r, bindMatrixInverseNode: i } = this, a = e.element(s.x), u = e.element(s.y), c = e.element(s.z), l = e.element(s.w), d = r.mul(t), h = _e(
      a.mul(n.x).mul(d),
      u.mul(n.y).mul(d),
      c.mul(n.z).mul(d),
      l.mul(n.w).mul(d)
    );
    return i.mul(h).xyz;
  }
  /**
   * Transforms the given vertex normal via skinning.
   *
   * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
   * @param {Node<vec3>} [normal=normalLocal] - The vertex normal in local space.
   * @return {Node<vec3>} The transformed vertex normal.
   */
  getSkinnedNormal(e = this.boneMatricesNode, t = We) {
    const { skinIndexNode: s, skinWeightNode: n, bindMatrixNode: r, bindMatrixInverseNode: i } = this, a = e.element(s.x), u = e.element(s.y), c = e.element(s.z), l = e.element(s.w);
    let d = _e(
      n.x.mul(a),
      n.y.mul(u),
      n.z.mul(c),
      n.w.mul(l)
    );
    return d = i.mul(d).mul(r), d.transformDirection(t).xyz;
  }
  /**
   * Transforms the given vertex normal via skinning.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The skinned position from the previous frame.
   */
  getPreviousSkinnedPosition(e) {
    const t = e.object;
    return this.previousBoneMatricesNode === null && (t.skeleton.previousBoneMatrices = new Float32Array(t.skeleton.boneMatrices), this.previousBoneMatricesNode = Oo("skeleton.previousBoneMatrices", "mat4", t.skeleton.bones.length)), this.getSkinnedPosition(this.previousBoneMatricesNode, Hr);
  }
  /**
   * Returns `true` if bone matrices from the previous frame are required.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Boolean} Whether bone matrices from the previous frame are required or not.
   */
  needsPreviousBoneMatrices(e) {
    const t = e.renderer.getMRT();
    return t && t.has("velocity") || Dl(e.object).useVelocity === !0;
  }
  /**
   * Setups the skinning node by assigning the transformed vertex data to predefined node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    this.needsPreviousBoneMatrices(e) && Hr.assign(this.getPreviousSkinnedPosition(e));
    const t = this.getSkinnedPosition();
    if (pe.assign(t), e.hasGeometryAttribute("normal")) {
      const s = this.getSkinnedNormal();
      We.assign(s), e.hasGeometryAttribute("tangent") && Jn.assign(s);
    }
  }
  /**
   * Generates the code snippet of the skinning node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String} output - The current output.
   * @return {String} The generated code snippet.
   */
  generate(e, t) {
    if (t !== "void")
      return pe.build(e, t);
  }
  /**
   * Updates the state of the skinned mesh by updating the skeleton once per frame.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update(e) {
    const s = (this.useReference ? e.object : this.skinnedMesh).skeleton;
    Gu.get(s) !== e.frameId && (Gu.set(s, e.frameId), this.previousBoneMatricesNode !== null && s.previousBoneMatrices.set(s.boneMatrices), s.update());
  }
}
const ax = (o) => E(new _p(o)), Np = (o) => E(new _p(o, !0));
class ux extends G {
  static get type() {
    return "LoopNode";
  }
  /**
   * Constructs a new loop node.
   *
   * @param {Array<Any>} params - Depending on the loop type, array holds different parameterization values for the loop.
   */
  constructor(e = []) {
    super(), this.params = e;
  }
  /**
   * Returns a loop variable name based on an index. The pattern is
   * `0` = `i`, `1`= `j`, `2`= `k` and so on.
   *
   * @param {Number} index - The index.
   * @return {String} The loop variable name.
   */
  getVarName(e) {
    return String.fromCharCode(105 + e);
  }
  /**
   * Returns properties about this node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Object} The node properties.
   */
  getProperties(e) {
    const t = e.getNodeProperties(this);
    if (t.stackNode !== void 0) return t;
    const s = {};
    for (let r = 0, i = this.params.length - 1; r < i; r++) {
      const a = this.params[r], u = a.isNode !== !0 && a.name || this.getVarName(r), c = a.isNode !== !0 && a.type || "int";
      s[u] = Qt(u, c);
    }
    const n = e.addStack();
    return t.returnsNode = this.params[this.params.length - 1](s, n, e), t.stackNode = n, e.removeStack(), t;
  }
  /**
   * This method is overwritten since the node type is inferred based on the loop configuration.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    const { returnsNode: t } = this.getProperties(e);
    return t ? t.getNodeType(e) : "void";
  }
  setup(e) {
    this.getProperties(e);
  }
  generate(e) {
    const t = this.getProperties(e), s = this.params, n = t.stackNode;
    for (let a = 0, u = s.length - 1; a < u; a++) {
      const c = s[a];
      let l = null, d = null, h = null, p = null, f = null, m = null;
      c.isNode ? (p = "int", h = this.getVarName(a), l = "0", d = c.build(e, p), f = "<") : (p = c.type || "int", h = c.name || this.getVarName(a), l = c.start, d = c.end, f = c.condition, m = c.update, typeof l == "number" ? l = e.generateConst(p, l) : l && l.isNode && (l = l.build(e, p)), typeof d == "number" ? d = e.generateConst(p, d) : d && d.isNode && (d = d.build(e, p)), l !== void 0 && d === void 0 ? (l = l + " - 1", d = "0", f = ">=") : d !== void 0 && l === void 0 && (l = "0", f = "<"), f === void 0 && (Number(l) > Number(d) ? f = ">=" : f = "<"));
      const _ = { start: l, end: d, condition: f }, S = _.start, A = _.end;
      let M = "", F = "", D = "";
      m || (p === "int" || p === "uint" ? f.includes("<") ? m = "++" : m = "--" : f.includes("<") ? m = "+= 1." : m = "-= 1."), M += e.getVar(p, h) + " = " + S, F += h + " " + f + " " + A, D += h + " " + m;
      const P = `for ( ${M}; ${F}; ${D} )`;
      e.addFlowCode((a === 0 ? `
` : "") + e.tab + P + ` {

`).addFlowTab();
    }
    const r = n.build(e, "void"), i = t.returnsNode ? t.returnsNode.build(e) : "";
    e.removeFlowTab().addFlowCode(`
` + e.tab + r);
    for (let a = 0, u = this.params.length - 1; a < u; a++)
      e.addFlowCode((a === 0 ? "" : e.tab) + `}

`).removeFlowTab();
    return e.addFlowTab(), i;
  }
}
const J = (...o) => E(new ux(hs(o, "int"))).append(), cx = () => Qt("continue").append(), bp = () => Qt("break").append(), lx = (...o) => (console.warn("TSL.LoopNode: loop() has been renamed to Loop()."), J(...o)), Bi = /* @__PURE__ */ new WeakMap(), je = /* @__PURE__ */ new Ce(), Ou = /* @__PURE__ */ b(({ bufferMap: o, influence: e, stride: t, width: s, depth: n, offset: r }) => {
  const i = y(gp).mul(t).add(r), a = i.div(s), u = i.sub(a.mul(s));
  return de(o, Ae(u, a)).depth(n).mul(e);
});
function dx(o) {
  const e = o.morphAttributes.position !== void 0, t = o.morphAttributes.normal !== void 0, s = o.morphAttributes.color !== void 0, n = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color, r = n !== void 0 ? n.length : 0;
  let i = Bi.get(o);
  if (i === void 0 || i.count !== r) {
    let S = function() {
      m.dispose(), Bi.delete(o), o.removeEventListener("dispose", S);
    };
    i !== void 0 && i.texture.dispose();
    const a = o.morphAttributes.position || [], u = o.morphAttributes.normal || [], c = o.morphAttributes.color || [];
    let l = 0;
    e === !0 && (l = 1), t === !0 && (l = 2), s === !0 && (l = 3);
    let d = o.attributes.position.count * l, h = 1;
    const p = 4096;
    d > p && (h = Math.ceil(d / p), d = p);
    const f = new Float32Array(d * h * 4 * r), m = new bm(f, d, h, r);
    m.type = st, m.needsUpdate = !0;
    const _ = l * 4;
    for (let A = 0; A < r; A++) {
      const M = a[A], F = u[A], D = c[A], P = d * h * 4 * A;
      for (let V = 0; V < M.count; V++) {
        const k = V * _;
        e === !0 && (je.fromBufferAttribute(M, V), f[P + k + 0] = je.x, f[P + k + 1] = je.y, f[P + k + 2] = je.z, f[P + k + 3] = 0), t === !0 && (je.fromBufferAttribute(F, V), f[P + k + 4] = je.x, f[P + k + 5] = je.y, f[P + k + 6] = je.z, f[P + k + 7] = 0), s === !0 && (je.fromBufferAttribute(D, V), f[P + k + 8] = je.x, f[P + k + 9] = je.y, f[P + k + 10] = je.z, f[P + k + 11] = D.itemSize === 4 ? je.w : 1);
      }
    }
    i = {
      count: r,
      texture: m,
      stride: l,
      size: new He(d, h)
    }, Bi.set(o, i), o.addEventListener("dispose", S);
  }
  return i;
}
class hx extends G {
  static get type() {
    return "MorphNode";
  }
  /**
   * Constructs a new morph node.
   *
   * @param {Mesh} mesh - The mesh holding the morph targets.
   */
  constructor(e) {
    super("void"), this.mesh = e, this.morphBaseInfluence = L(1), this.updateType = z.OBJECT;
  }
  /**
   * Setups the morph node by assigning the transformed vertex data to predefined node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    const { geometry: t } = e, s = t.morphAttributes.position !== void 0, n = t.hasAttribute("normal") && t.morphAttributes.normal !== void 0, r = t.morphAttributes.position || t.morphAttributes.normal || t.morphAttributes.color, i = r !== void 0 ? r.length : 0, { texture: a, stride: u, size: c } = dx(t);
    s === !0 && pe.mulAssign(this.morphBaseInfluence), n === !0 && We.mulAssign(this.morphBaseInfluence);
    const l = y(c.width);
    J(i, ({ i: d }) => {
      const h = g(0).toVar();
      this.mesh.count > 1 && this.mesh.morphTexture !== null && this.mesh.morphTexture !== void 0 ? h.assign(de(this.mesh.morphTexture, Ae(y(d).add(1), y(sr))).r) : h.assign(te("morphTargetInfluences", "float").element(d).toVar()), s === !0 && pe.addAssign(Ou({
        bufferMap: a,
        influence: h,
        stride: u,
        width: l,
        depth: d,
        offset: y(0)
      })), n === !0 && We.addAssign(Ou({
        bufferMap: a,
        influence: h,
        stride: u,
        width: l,
        depth: d,
        offset: y(1)
      }));
    });
  }
  /**
   * Updates the state of the morphed mesh by updating the base influence.
   *
   * @param {NodeFrame} frame - The current node frame.
   */
  update() {
    const e = this.morphBaseInfluence;
    this.mesh.geometry.morphTargetsRelative ? e.value = 1 : e.value = 1 - this.mesh.morphTargetInfluences.reduce((t, s) => t + s, 0);
  }
}
const Sp = /* @__PURE__ */ C(hx);
class on extends G {
  static get type() {
    return "LightingNode";
  }
  /**
   * Constructs a new lighting node.
   */
  constructor() {
    super("vec3"), this.isLightingNode = !0;
  }
}
class px extends on {
  static get type() {
    return "AONode";
  }
  /**
   * Constructs a new AO node.
   *
   * @param {Node<float>?} [aoNode=null] - The ambient occlusion node.
   */
  constructor(e = null) {
    super(), this.aoNode = e;
  }
  setup(e) {
    e.context.ambientOcclusion.mulAssign(this.aoNode);
  }
}
class fx extends jd {
  static get type() {
    return "LightingContextNode";
  }
  /**
   * Constructs a new lighting context node.
   *
   * @param {LightsNode} node - The lights node.
   * @param {LightingModel?} [lightingModel=null] - The current lighting model.
   * @param {Node<vec3>?} [backdropNode=null] - A backdrop node.
   * @param {Node<float>?} [backdropAlphaNode=null] - A backdrop alpha node.
   */
  constructor(e, t = null, s = null, n = null) {
    super(e), this.lightingModel = t, this.backdropNode = s, this.backdropAlphaNode = n, this._value = null;
  }
  /**
   * Returns a lighting context object.
   *
   * @return {{
   * radiance: Node<vec3>,
   * irradiance: Node<vec3>,
   * iblIrradiance: Node<vec3>,
   * ambientOcclusion: Node<float>,
   * reflectedLight: {directDiffuse: Node<vec3>, directSpecular: Node<vec3>, indirectDiffuse: Node<vec3>, indirectSpecular: Node<vec3>},
   * backdrop: Node<vec3>,
   * backdropAlpha: Node<float>
   * }} The lighting context object.
   */
  getContext() {
    const { backdropNode: e, backdropAlphaNode: t } = this, s = T().toVar("directDiffuse"), n = T().toVar("directSpecular"), r = T().toVar("indirectDiffuse"), i = T().toVar("indirectSpecular"), a = {
      directDiffuse: s,
      directSpecular: n,
      indirectDiffuse: r,
      indirectSpecular: i
    };
    return {
      radiance: T().toVar("radiance"),
      irradiance: T().toVar("irradiance"),
      iblIrradiance: T().toVar("iblIrradiance"),
      ambientOcclusion: g(1).toVar("ambientOcclusion"),
      reflectedLight: a,
      backdrop: e,
      backdropAlpha: t
    };
  }
  setup(e) {
    return this.value = this._value || (this._value = this.getContext()), this.value.lightingModel = this.lightingModel || e.context.lightingModel, super.setup(e);
  }
}
const vp = /* @__PURE__ */ C(fx);
class gx extends on {
  static get type() {
    return "IrradianceNode";
  }
  /**
   * Constructs a new irradiance node.
   *
   * @param {Node<vec3>} node - A node contributing irradiance.
   */
  constructor(e) {
    super(), this.node = e;
  }
  setup(e) {
    e.context.irradiance.addAssign(this.node);
  }
}
let un, cn;
class Se extends G {
  static get type() {
    return "ScreenNode";
  }
  /**
   * Constructs a new screen node.
   *
   * @param {('coordinate'|'viewport'|'size'|'uv')} scope - The node's scope.
   */
  constructor(e) {
    super(), this.scope = e, this.isViewportNode = !0;
  }
  /**
   * This method is overwritten since the node type depends on the selected scope.
   *
   * @return {('vec2'|'vec4')} The node type.
   */
  getNodeType() {
    return this.scope === Se.VIEWPORT ? "vec4" : "vec2";
  }
  /**
   * This method is overwritten since the node's update type depends on the selected scope.
   *
   * @return {NodeUpdateType} The update type.
   */
  getUpdateType() {
    let e = z.NONE;
    return (this.scope === Se.SIZE || this.scope === Se.VIEWPORT) && (e = z.RENDER), this.updateType = e, e;
  }
  /**
   * `ScreenNode` implements {@link Node#update} to retrieve viewport and size information
   * from the current renderer.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update({ renderer: e }) {
    const t = e.getRenderTarget();
    this.scope === Se.VIEWPORT ? t !== null ? cn.copy(t.viewport) : (e.getViewport(cn), cn.multiplyScalar(e.getPixelRatio())) : t !== null ? (un.width = t.width, un.height = t.height) : e.getDrawingBufferSize(un);
  }
  setup() {
    const e = this.scope;
    let t = null;
    return e === Se.SIZE ? t = L(un || (un = new He())) : e === Se.VIEWPORT ? t = L(cn || (cn = new Ce())) : t = w(nr.div(kn)), t;
  }
  generate(e) {
    if (this.scope === Se.COORDINATE) {
      let t = e.getFragCoord();
      if (e.isFlipY()) {
        const s = e.getNodeProperties(kn).outputNode.build(e);
        t = `${e.getType("vec2")}( ${t}.x, ${s}.y - ${t}.y )`;
      }
      return t;
    }
    return super.generate(e);
  }
}
Se.COORDINATE = "coordinate";
Se.VIEWPORT = "viewport";
Se.SIZE = "size";
Se.UV = "uv";
const vt = /* @__PURE__ */ B(Se, Se.UV), kn = /* @__PURE__ */ B(Se, Se.SIZE), nr = /* @__PURE__ */ B(Se, Se.COORDINATE), Wa = /* @__PURE__ */ B(Se, Se.VIEWPORT), Ap = Wa.zw, Rp = /* @__PURE__ */ nr.sub(Wa.xy), mx = /* @__PURE__ */ Rp.div(Ap), yx = /* @__PURE__ */ b(() => (console.warn('TSL.ViewportNode: "viewportResolution" is deprecated. Use "screenSize" instead.'), kn), "vec2").once()(), xx = /* @__PURE__ */ b(() => (console.warn('TSL.ViewportNode: "viewportTopLeft" is deprecated. Use "screenUV" instead.'), vt), "vec2").once()(), Tx = /* @__PURE__ */ b(() => (console.warn('TSL.ViewportNode: "viewportBottomLeft" is deprecated. Use "screenUV.flipY()" instead.'), vt.flipY()), "vec2").once()(), ln = /* @__PURE__ */ new He();
class _i extends bt {
  static get type() {
    return "ViewportTextureNode";
  }
  /**
   * Constructs a new viewport texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {Node?} [levelNode=null] - The level node.
   * @param {Texture?} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
   */
  constructor(e = vt, t = null, s = null) {
    s === null && (s = new bl(), s.minFilter = ds), super(s, e, t), this.generateMipmaps = !1, this.isOutputTextureNode = !0, this.updateBeforeType = z.FRAME;
  }
  updateBefore(e) {
    const t = e.renderer;
    t.getDrawingBufferSize(ln);
    const s = this.value;
    (s.image.width !== ln.width || s.image.height !== ln.height) && (s.image.width = ln.width, s.image.height = ln.height, s.needsUpdate = !0);
    const n = s.generateMipmaps;
    s.generateMipmaps = this.generateMipmaps, t.copyFramebufferToTexture(s), s.generateMipmaps = n;
  }
  clone() {
    const e = new this.constructor(this.uvNode, this.levelNode, this.value);
    return e.generateMipmaps = this.generateMipmaps, e;
  }
}
const _x = /* @__PURE__ */ C(_i), Ha = /* @__PURE__ */ C(_i, null, null, { generateMipmaps: !0 });
let Fi = null;
class Nx extends _i {
  static get type() {
    return "ViewportDepthTextureNode";
  }
  /**
   * Constructs a new viewport depth texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {Node?} [levelNode=null] - The level node.
   */
  constructor(e = vt, t = null) {
    Fi === null && (Fi = new ys()), super(e, t, Fi);
  }
}
const qa = /* @__PURE__ */ C(Nx);
class ke extends G {
  static get type() {
    return "ViewportDepthNode";
  }
  /**
   * Constructs a new viewport depth node.
   *
   * @param {('depth'|'depthBase'|'linearDepth')} scope - The node's scope.
   * @param {Node?} [valueNode=null] - The value node.
   */
  constructor(e, t = null) {
    super("float"), this.scope = e, this.valueNode = t, this.isViewportDepthNode = !0;
  }
  generate(e) {
    const { scope: t } = this;
    return t === ke.DEPTH_BASE ? e.getFragDepth() : super.generate(e);
  }
  setup({ camera: e }) {
    const { scope: t } = this, s = this.valueNode;
    let n = null;
    if (t === ke.DEPTH_BASE)
      s !== null && (n = Ep().assign(s));
    else if (t === ke.DEPTH)
      e.isPerspectiveCamera ? n = Cp(xe.z, qt, Xt) : n = qs(xe.z, qt, Xt);
    else if (t === ke.LINEAR_DEPTH)
      if (s !== null)
        if (e.isPerspectiveCamera) {
          const r = Xa(s, qt, Xt);
          n = qs(r, qt, Xt);
        } else
          n = s;
      else
        n = qs(xe.z, qt, Xt);
    return n;
  }
}
ke.DEPTH_BASE = "depthBase";
ke.DEPTH = "depth";
ke.LINEAR_DEPTH = "linearDepth";
const qs = (o, e, t) => o.add(e).div(e.sub(t)), bx = (o, e, t) => e.sub(t).mul(o).sub(e), Cp = (o, e, t) => e.add(o).mul(t).div(t.sub(e).mul(o)), Xa = (o, e, t) => e.mul(t).div(t.sub(e).mul(o).sub(t)), Ka = (o, e, t) => {
  e = e.max(1e-6).toVar();
  const s = mt(o.negate().div(e)), n = mt(t.div(e));
  return s.div(n);
}, Sx = (o, e, t) => {
  const s = o.mul(ci(t.div(e)));
  return g(Math.E).pow(s).mul(e).negate();
}, Ep = /* @__PURE__ */ C(ke, ke.DEPTH_BASE), Ya = /* @__PURE__ */ B(ke, ke.DEPTH), qr = /* @__PURE__ */ C(ke, ke.LINEAR_DEPTH), vx = /* @__PURE__ */ qr(qa());
Ya.assign = (o) => Ep(o);
class Ax extends G {
  /**
   * Constructs a new builtin node.
   *
   * @param {String} name - The name of the built-in shader variable.
   */
  constructor(e) {
    super("float"), this.name = e, this.isBuiltinNode = !0;
  }
  /**
   * Generates the code snippet of the builtin node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The generated code snippet.
   */
  generate() {
    return this.name;
  }
}
const Rx = C(Ax);
class rt extends G {
  static get type() {
    return "ClippingNode";
  }
  /**
   * Constructs a new clipping node.
   *
   * @param {('default'|'hardware'|'alphaToCoverage')} [scope='default'] - The node's scope. Similar to other nodes,
   * the selected scope influences the behavior of the node and what type of code is generated.
   */
  constructor(e = rt.DEFAULT) {
    super(), this.scope = e;
  }
  /**
   * Setups the node depending on the selected scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The result node.
   */
  setup(e) {
    super.setup(e);
    const t = e.clippingContext, { intersectionPlanes: s, unionPlanes: n } = t;
    return this.hardwareClipping = e.material.hardwareClipping, this.scope === rt.ALPHA_TO_COVERAGE ? this.setupAlphaToCoverage(s, n) : this.scope === rt.HARDWARE ? this.setupHardwareClipping(n, e) : this.setupDefault(s, n);
  }
  /**
   * Setups alpha to coverage.
   *
   * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @return {Node} The result node.
   */
  setupAlphaToCoverage(e, t) {
    return b(() => {
      const s = g().toVar("distanceToPlane"), n = g().toVar("distanceToGradient"), r = g(1).toVar("clipOpacity"), i = t.length;
      if (this.hardwareClipping === !1 && i > 0) {
        const u = Ut(t);
        J(i, ({ i: c }) => {
          const l = u.element(c);
          s.assign(xe.dot(l.xyz).negate().add(l.w)), n.assign(s.fwidth().div(2)), r.mulAssign(Ot(n.negate(), n, s));
        });
      }
      const a = e.length;
      if (a > 0) {
        const u = Ut(e), c = g(1).toVar("intersectionClipOpacity");
        J(a, ({ i: l }) => {
          const d = u.element(l);
          s.assign(xe.dot(d.xyz).negate().add(d.w)), n.assign(s.fwidth().div(2)), c.mulAssign(Ot(n.negate(), n, s).oneMinus());
        }), r.mulAssign(c.oneMinus());
      }
      Q.a.mulAssign(r), Q.a.equal(0).discard();
    })();
  }
  /**
   * Setups the default clipping.
   *
   * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @return {Node} The result node.
   */
  setupDefault(e, t) {
    return b(() => {
      const s = t.length;
      if (this.hardwareClipping === !1 && s > 0) {
        const r = Ut(t);
        J(s, ({ i }) => {
          const a = r.element(i);
          xe.dot(a.xyz).greaterThan(a.w).discard();
        });
      }
      const n = e.length;
      if (n > 0) {
        const r = Ut(e), i = Vt(!0).toVar("clipped");
        J(n, ({ i: a }) => {
          const u = r.element(a);
          i.assign(xe.dot(u.xyz).greaterThan(u.w).and(i));
        }), i.discard();
      }
    })();
  }
  /**
   * Setups hardware clipping.
   *
   * @param {Array<Vector4>} unionPlanes - The union planes.
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The result node.
   */
  setupHardwareClipping(e, t) {
    const s = e.length;
    return t.enableHardwareClipping(s), b(() => {
      const n = Ut(e), r = Rx(t.getClipDistance());
      J(s, ({ i }) => {
        const a = n.element(i), u = xe.dot(a.xyz).sub(a.w).negate();
        r.element(i).assign(u);
      });
    })();
  }
}
rt.ALPHA_TO_COVERAGE = "alphaToCoverage";
rt.DEFAULT = "default";
rt.HARDWARE = "hardware";
const Cx = () => E(new rt()), Ex = () => E(new rt(rt.ALPHA_TO_COVERAGE)), wx = () => E(new rt(rt.HARDWARE)), Mx = 0.05, ku = /* @__PURE__ */ b(([o]) => kt($(1e4, Ze($(17, o.x).add($(0.1, o.y)))).mul(_e(0.1, re(Ze($(13, o.y).add(o.x))))))), zu = /* @__PURE__ */ b(([o]) => ku(w(ku(o.xy), o.z))), Bx = /* @__PURE__ */ b(([o]) => {
  const e = fe(
    Dt(Ea(o.xyz)),
    Dt(wa(o.xyz))
  ), t = g(1).div(g(Mx).mul(e)).toVar("pixScale"), s = w(
    Zs(yt(mt(t))),
    Zs(li(mt(t)))
  ), n = w(
    zu(yt(s.x.mul(o.xyz))),
    zu(yt(s.y.mul(o.xyz)))
  ), r = kt(mt(t)), i = _e($(r.oneMinus(), n.x), $(r, n.y)), a = $e(r, r.oneMinus()), u = T(
    i.mul(i).div($(2, a).mul(K(1, a))),
    i.sub($(0.5, a)).div(K(1, a)),
    K(1, K(1, i).mul(K(1, i)).div($(2, a).mul(K(1, a))))
  ), c = i.lessThan(a.oneMinus()).select(i.lessThan(a).select(u.x, u.y), u.z);
  return _t(c, 1e-6, 1);
}).setLayout({
  name: "getAlphaHashThreshold",
  type: "float",
  inputs: [
    { name: "position", type: "vec3" }
  ]
});
class ge extends bu {
  static get type() {
    return "NodeMaterial";
  }
  /**
   * Represents the type of the node material.
   *
   * @type {String}
   */
  get type() {
    return this.constructor.type;
  }
  set type(e) {
  }
  /**
   * Constructs a new node material.
   */
  constructor() {
    super(), this.isNodeMaterial = !0, this.fog = !0, this.lights = !1, this.hardwareClipping = !1, this.lightsNode = null, this.envNode = null, this.aoNode = null, this.colorNode = null, this.normalNode = null, this.opacityNode = null, this.backdropNode = null, this.backdropAlphaNode = null, this.alphaTestNode = null, this.positionNode = null, this.geometryNode = null, this.depthNode = null, this.shadowPositionNode = null, this.receivedShadowNode = null, this.castShadowNode = null, this.outputNode = null, this.mrtNode = null, this.fragmentNode = null, this.vertexNode = null;
  }
  /**
   * Allows to define a custom cache key that influence the material key computation
   * for render objects.
   *
   * @return {String} The custom cache key.
   */
  customProgramCacheKey() {
    return this.type + Ml(this);
  }
  /**
   * Builds this material with the given node builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  build(e) {
    this.setup(e);
  }
  /**
   * Setups a node material observer with the given builder.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeMaterialObserver} The node material observer.
   */
  setupObserver(e) {
    return new Em(e);
  }
  /**
   * Setups the vertex and fragment stage of this node material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    e.context.setupNormal = () => this.setupNormal(e), e.context.setupPositionView = () => this.setupPositionView(e), e.context.setupModelViewProjection = () => this.setupModelViewProjection(e);
    const t = e.renderer, s = t.getRenderTarget();
    e.addStack();
    const n = this.vertexNode || this.setupVertex(e);
    e.stack.outputNode = n, this.setupHardwareClipping(e), this.geometryNode !== null && (e.stack.outputNode = e.stack.outputNode.bypass(this.geometryNode)), e.addFlow("vertex", e.removeStack()), e.addStack();
    let r;
    const i = this.setupClipping(e);
    if ((this.depthWrite === !0 || this.depthTest === !0) && (s !== null ? s.depthBuffer === !0 && this.setupDepth(e) : t.depth === !0 && this.setupDepth(e)), this.fragmentNode === null) {
      this.setupDiffuseColor(e), this.setupVariants(e);
      const a = this.setupLighting(e);
      i !== null && e.stack.add(i);
      const u = I(a, Q.a).max(0);
      if (r = this.setupOutput(e, u), Gn.assign(r), this.outputNode !== null && (r = this.outputNode), s !== null) {
        const c = t.getMRT(), l = this.mrtNode;
        c !== null ? (r = c, l !== null && (r = c.merge(l))) : l !== null && (r = l);
      }
    } else {
      let a = this.fragmentNode;
      a.isOutputStructNode !== !0 && (a = I(a)), r = this.setupOutput(e, a);
    }
    e.stack.outputNode = r, e.addFlow("fragment", e.removeStack()), e.monitor = this.setupObserver(e);
  }
  /**
   * Setups the clipping node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {ClippingNode} The clipping node.
   */
  setupClipping(e) {
    if (e.clippingContext === null) return null;
    const { unionPlanes: t, intersectionPlanes: s } = e.clippingContext;
    let n = null;
    if (t.length > 0 || s.length > 0) {
      const r = e.renderer.samples;
      this.alphaToCoverage && r > 1 ? n = Ex() : e.stack.add(Cx());
    }
    return n;
  }
  /**
   * Setups the hardware clipping if available on the current device.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupHardwareClipping(e) {
    if (this.hardwareClipping = !1, e.clippingContext === null) return;
    const t = e.clippingContext.unionPlanes.length;
    t > 0 && t <= 8 && e.isAvailable("clipDistance") && (e.stack.add(wx()), this.hardwareClipping = !0);
  }
  /**
   * Setups the depth of this material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupDepth(e) {
    const { renderer: t, camera: s } = e;
    let n = this.depthNode;
    if (n === null) {
      const r = t.getMRT();
      r && r.has("depth") ? n = r.get("depth") : t.logarithmicDepthBuffer === !0 && (s.isPerspectiveCamera ? n = Ka(xe.z, qt, Xt) : n = qs(xe.z, qt, Xt));
    }
    n !== null && Ya.assign(n).append();
  }
  /**
   * Setups the position node in view space. This method exists
   * so derived node materials can modifiy the implementation e.g. sprite materials.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in view space.
   */
  setupPositionView() {
    return rn.mul(pe).xyz;
  }
  /**
   * Setups the position in clip space.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The position in view space.
   */
  setupModelViewProjection() {
    return _s.mul(xe);
  }
  /**
   * Setups the logic for the vertex stage.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The position in clip space.
   */
  setupVertex(e) {
    return e.addStack(), this.setupPosition(e), e.context.vertex = e.removeStack(), $a;
  }
  /**
   * Setups the computation of the position in local space.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in local space.
   */
  setupPosition(e) {
    const { object: t, geometry: s } = e;
    if ((s.morphAttributes.position || s.morphAttributes.normal || s.morphAttributes.color) && Sp(t).append(), t.isSkinnedMesh === !0 && Np(t).append(), this.displacementMap) {
      const n = Pt("displacementMap", "texture"), r = Pt("displacementScale", "float"), i = Pt("displacementBias", "float");
      pe.addAssign(We.normalize().mul(n.x.mul(r).add(i)));
    }
    return t.isBatchedMesh && Tp(t).append(), t.isInstancedMesh && t.instanceMatrix && t.instanceMatrix.isInstancedBufferAttribute === !0 && xp(t).append(), this.positionNode !== null && pe.assign(this.positionNode.context({ isPositionNodeInput: !0 })), pe;
  }
  /**
   * Setups the computation of the material's diffuse color.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {BufferGeometry} geometry - The geometry.
   */
  setupDiffuseColor({ object: e, geometry: t }) {
    let s = this.colorNode ? I(this.colorNode) : Oh;
    this.vertexColors === !0 && t.hasAttribute("color") && (s = I(s.xyz.mul(Nt("color", "vec3")), s.a)), e.instanceColor && (s = Dn("vec3", "vInstanceColor").mul(s)), e.isBatchedMesh && e._colorsTexture && (s = Dn("vec3", "vBatchColor").mul(s)), Q.assign(s);
    const n = this.opacityNode ? g(this.opacityNode) : ka;
    if (Q.a.assign(Q.a.mul(n)), this.alphaTestNode !== null || this.alphaTest > 0) {
      const r = this.alphaTestNode !== null ? g(this.alphaTestNode) : Gh;
      Q.a.lessThanEqual(r).discard();
    }
    this.alphaHash === !0 && Q.a.lessThan(Bx(pe)).discard(), this.transparent === !1 && this.blending === zs && this.alphaToCoverage === !1 && Q.a.assign(1);
  }
  /**
   * Abstract interface method that can be implemented by derived materials
   * to setup material-specific node variables.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants() {
  }
  /**
   * Setups the outgoing light node variable
   *
   * @return {Node<vec3>} The outgoing light node.
   */
  setupOutgoingLight() {
    return this.lights === !0 ? T(0) : Q.rgb;
  }
  /**
   * Setups the normal node from the material.
   *
   * @return {Node<vec3>} The normal node.
   */
  setupNormal() {
    return this.normalNode ? T(this.normalNode) : Xh;
  }
  /**
   * Setups the environment node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec4>} The environment node.
   */
  setupEnvironment() {
    let e = null;
    return this.envNode ? e = this.envNode : this.envMap && (e = this.envMap.isCubeTexture ? Pt("envMap", "cubeTexture") : Pt("envMap", "texture")), e;
  }
  /**
   * Setups the light map node from the material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The light map node.
   */
  setupLightMap(e) {
    let t = null;
    return e.material.lightMap && (t = new gx(za)), t;
  }
  /**
   * Setups the lights node based on the scene, environment and material.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {LightsNode} The lights node.
   */
  setupLights(e) {
    const t = [], s = this.setupEnvironment(e);
    s && s.isLightingNode && t.push(s);
    const n = this.setupLightMap(e);
    if (n && n.isLightingNode && t.push(n), this.aoNode !== null || e.material.aoMap) {
      const i = this.aoNode !== null ? this.aoNode : fp;
      t.push(new px(i));
    }
    let r = this.lightsNode || e.lightsNode;
    return t.length > 0 && (r = e.renderer.lighting.createNode([...r.getLights(), ...t])), r;
  }
  /**
   * This method should be implemented by most derived materials
   * since it defines the material's lighting model.
   *
   * @abstract
   * @param {NodeBuilder} builder - The current node builder.
   * @return {LightingModel} The lighting model.
   */
  setupLightingModel() {
  }
  /**
   * Setups the outgoing light node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The outgoing light node.
   */
  setupLighting(e) {
    const { material: t } = e, { backdropNode: s, backdropAlphaNode: n, emissiveNode: r } = this, a = this.lights === !0 || this.lightsNode !== null ? this.setupLights(e) : null;
    let u = this.setupOutgoingLight(e);
    if (a && a.getScope().hasLights) {
      const c = this.setupLightingModel(e);
      u = vp(a, c, s, n);
    } else s !== null && (u = T(n !== null ? Z(u, s, n) : s));
    return (r && r.isNode === !0 || t.emissive && t.emissive.isColor === !0) && (Lo.assign(T(r || zh)), u = u.add(Lo)), u;
  }
  /**
   * Setups the output node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node<vec4>} outputNode - The existing output node.
   * @return {Node<vec4>} The output node.
   */
  setupOutput(e, t) {
    if (this.fog === !0) {
      const s = e.fogNode;
      s && (Gn.assign(t), t = I(s));
    }
    return t;
  }
  /**
   * Most classic material types have a node pendant e.g. for `MeshBasicMaterial`
   * there is `MeshBasicNodeMaterial`. This utility method is intended for
   * defining all material properties of the classic type in the node type.
   *
   * @param {Material} material - The material to copy properties with their values to this node material.
   */
  setDefaultValues(e) {
    for (const s in e) {
      const n = e[s];
      this[s] === void 0 && (this[s] = n, n && n.clone && (this[s] = n.clone()));
    }
    const t = Object.getOwnPropertyDescriptors(e.constructor.prototype);
    for (const s in t)
      Object.getOwnPropertyDescriptor(this.constructor.prototype, s) === void 0 && t[s].get !== void 0 && Object.defineProperty(this.constructor.prototype, s, t[s]);
  }
  /**
   * Serializes this material to JSON.
   *
   * @param {(Object|String)?} meta - The meta information for serialization.
   * @return {Object} The serialized node.
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {},
      nodes: {}
    });
    const s = bu.prototype.toJSON.call(this, e), n = Vr(this);
    s.inputNodes = {};
    for (const { property: i, childNode: a } of n)
      s.inputNodes[i] = a.toJSON(e).uuid;
    function r(i) {
      const a = [];
      for (const u in i) {
        const c = i[u];
        delete c.metadata, a.push(c);
      }
      return a;
    }
    if (t) {
      const i = r(e.textures), a = r(e.images), u = r(e.nodes);
      i.length > 0 && (s.textures = i), a.length > 0 && (s.images = a), u.length > 0 && (s.nodes = u);
    }
    return s;
  }
  /**
   * Copies the properties of the given node material to this instance.
   *
   * @param {NodeMaterial} source - The material to copy.
   * @return {NodeMaterial} A reference to this node material.
   */
  copy(e) {
    return this.lightsNode = e.lightsNode, this.envNode = e.envNode, this.colorNode = e.colorNode, this.normalNode = e.normalNode, this.opacityNode = e.opacityNode, this.backdropNode = e.backdropNode, this.backdropAlphaNode = e.backdropAlphaNode, this.alphaTestNode = e.alphaTestNode, this.positionNode = e.positionNode, this.geometryNode = e.geometryNode, this.depthNode = e.depthNode, this.shadowPositionNode = e.shadowPositionNode, this.receivedShadowNode = e.receivedShadowNode, this.castShadowNode = e.castShadowNode, this.outputNode = e.outputNode, this.mrtNode = e.mrtNode, this.fragmentNode = e.fragmentNode, this.vertexNode = e.vertexNode, super.copy(e);
  }
}
const Fx = /* @__PURE__ */ new Og();
class Ux extends ge {
  static get type() {
    return "LineBasicNodeMaterial";
  }
  /**
   * Constructs a new line basic node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isLineBasicNodeMaterial = !0, this.setDefaultValues(Fx), this.setValues(e);
  }
}
const Px = /* @__PURE__ */ new kg();
class Dx extends ge {
  static get type() {
    return "LineDashedNodeMaterial";
  }
  /**
   * Constructs a new line dashed node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isLineDashedNodeMaterial = !0, this.setDefaultValues(Px), this.dashOffset = 0, this.offsetNode = null, this.dashScaleNode = null, this.dashSizeNode = null, this.gapSizeNode = null, this.setValues(e);
  }
  /**
   * Setups the dash specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants() {
    const e = this.offsetNode ? g(this.offsetNode) : hp, t = this.dashScaleNode ? g(this.dashScaleNode) : cp, s = this.dashSizeNode ? g(this.dashSizeNode) : lp, n = this.gapSizeNode ? g(this.gapSizeNode) : dp;
    Er.assign(s), Vo.assign(n);
    const r = qe(Nt("lineDistance").mul(t));
    (e ? r.add(e) : r).mod(Er.add(Vo)).greaterThan(Er).discard();
  }
}
let Ui = null;
class Ix extends _i {
  static get type() {
    return "ViewportSharedTextureNode";
  }
  /**
   * Constructs a new viewport shared texture node.
   *
   * @param {Node} [uvNode=screenUV] - The uv node.
   * @param {Node?} [levelNode=null] - The level node.
   */
  constructor(e = vt, t = null) {
    Ui === null && (Ui = new bl()), super(e, t, Ui);
  }
  updateReference() {
    return this;
  }
}
const Lx = /* @__PURE__ */ C(Ix), wp = (o) => E(o).mul(0.5).add(0.5), Vx = (o) => E(o).mul(2).sub(1), Gx = /* @__PURE__ */ new zg();
class Ox extends ge {
  static get type() {
    return "MeshNormalNodeMaterial";
  }
  /**
   * Constructs a new mesh normal node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshNormalNodeMaterial = !0, this.setDefaultValues(Gx), this.setValues(e);
  }
  /**
   * Overwrites the default implementation by computing the diffuse color
   * based on the normal data.
   */
  setupDiffuseColor() {
    const e = this.opacityNode ? g(this.opacityNode) : ka;
    Q.assign(I(wp(he), e));
  }
}
class kx extends Ne {
  static get type() {
    return "EquirectUVNode";
  }
  /**
   * Constructs a new equirect uv node.
   *
   * @param {Node<vec3>} [dirNode=positionWorldDirection] - A direction vector for sampling which is by default `positionWorldDirection`.
   */
  constructor(e = La) {
    super("vec2"), this.dirNode = e;
  }
  setup() {
    const e = this.dirNode, t = e.z.atan(e.x).mul(1 / (Math.PI * 2)).add(0.5), s = e.y.clamp(-1, 1).asin().mul(1 / Math.PI).add(0.5);
    return w(t, s);
  }
}
const ja = /* @__PURE__ */ C(kx);
class Mp extends Sm {
  constructor(e = 1, t = {}) {
    super(e, t), this.isCubeRenderTarget = !0;
  }
  /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {CubeRenderTarget} A reference to this cube render target.
   */
  fromEquirectangularTexture(e, t) {
    const s = t.minFilter, n = t.generateMipmaps;
    t.generateMipmaps = !0, this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
    const r = new Cl(5, 5, 5), i = ja(La), a = new ge();
    a.colorNode = X(t, i, 0), a.side = Tt, a.blending = Mn;
    const u = new js(r, a), c = new Wc();
    c.add(u), t.minFilter === ds && (t.minFilter = Lt);
    const l = new vm(1, 10, this), d = e.getMRT();
    return e.setMRT(null), l.update(e, c), e.setMRT(d), t.minFilter = s, t.currentGenerateMipmaps = n, u.geometry.dispose(), u.material.dispose(), this;
  }
}
const Rn = /* @__PURE__ */ new WeakMap();
class zx extends Ne {
  static get type() {
    return "CubeMapNode";
  }
  /**
   * Constructs a new cube map node.
   *
   * @param {Node} envNode - The node representing the environment map.
   */
  constructor(e) {
    super("vec3"), this.envNode = e, this._cubeTexture = null, this._cubeTextureNode = Js();
    const t = new Sl();
    t.isRenderTargetTexture = !0, this._defaultTexture = t, this.updateBeforeType = z.RENDER;
  }
  updateBefore(e) {
    const { renderer: t, material: s } = e, n = this.envNode;
    if (n.isTextureNode || n.isMaterialReferenceNode) {
      const r = n.isTextureNode ? n.value : s[n.property];
      if (r && r.isTexture) {
        const i = r.mapping;
        if (i === Wn || i === Hn) {
          if (Rn.has(r)) {
            const a = Rn.get(r);
            $u(a, r.mapping), this._cubeTexture = a;
          } else {
            const a = r.image;
            if ($x(a)) {
              const u = new Mp(a.height);
              u.fromEquirectangularTexture(t, r), $u(u.texture, r.mapping), this._cubeTexture = u.texture, Rn.set(r, u.texture), r.addEventListener("dispose", Bp);
            } else
              this._cubeTexture = this._defaultTexture;
          }
          this._cubeTextureNode.value = this._cubeTexture;
        } else
          this._cubeTextureNode = this.envNode;
      }
    }
  }
  setup(e) {
    return this.updateBefore(e), this._cubeTextureNode;
  }
}
function $x(o) {
  return o == null ? !1 : o.height > 0;
}
function Bp(o) {
  const e = o.target;
  e.removeEventListener("dispose", Bp);
  const t = Rn.get(e);
  t !== void 0 && (Rn.delete(e), t.dispose());
}
function $u(o, e) {
  e === Wn ? o.mapping = Ks : e === Hn && (o.mapping = Ys);
}
const Fp = /* @__PURE__ */ C(zx);
class Qa extends on {
  static get type() {
    return "BasicEnvironmentNode";
  }
  /**
   * Constructs a new basic environment node.
   *
   * @param {Node} [envNode=null] - A node representing the environment.
   */
  constructor(e = null) {
    super(), this.envNode = e;
  }
  setup(e) {
    e.context.environment = Fp(this.envNode);
  }
}
class Wx extends on {
  static get type() {
    return "BasicLightMapNode";
  }
  /**
   * Constructs a new basic light map node.
   *
   * @param {Node<vec3>?} [lightMapNode=null] - The light map node.
   */
  constructor(e = null) {
    super(), this.lightMapNode = e;
  }
  setup(e) {
    const t = g(1 / Math.PI);
    e.context.irradianceLightMap = this.lightMapNode.mul(t);
  }
}
class Ni {
  /**
   * This method is intended for setting up lighting model and context data
   * which are later used in the evaluation process.
   *
   * @abstract
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  start() {
  }
  /**
   * This method is intended for executing final tasks like final updates
   * to the outgoing light.
   *
   * @abstract
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  finish() {
  }
  /**
   * This method is intended for implementing the direct light term and
   * executed during the build process of directional, point and spot light nodes.
   *
   * @abstract
   * @param {Object} input - The input data.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  direct() {
  }
  /**
   * This method is intended for implementing the direct light term for
   * rect area light nodes.
   *
   * @abstract
   * @param {Object} input - The input data.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  directRectArea() {
  }
  /**
   * This method is intended for implementing the indirect light term.
   *
   * @abstract
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirect() {
  }
  /**
   * This method is intended for implementing the ambient occlusion term.
   * Unlike other methods, this method must be called manually by the lighting
   * model in its indirect term.
   *
   * @abstract
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  ambientOcclusion() {
  }
}
class Up extends Ni {
  /**
   * Constructs a new basic lighting model.
   */
  constructor() {
    super();
  }
  /**
   * Implements the baked indirect lighting with its modulation.
   *
   * @param {ContextNode} context - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirect(e, t, s) {
    const n = e.ambientOcclusion, r = e.reflectedLight, i = s.context.irradianceLightMap;
    r.indirectDiffuse.assign(I(0)), i ? r.indirectDiffuse.addAssign(i) : r.indirectDiffuse.addAssign(I(1, 1, 1, 0)), r.indirectDiffuse.mulAssign(n), r.indirectDiffuse.mulAssign(Q.rgb);
  }
  /**
   * Implements the environment mapping.
   *
   * @param {ContextNode} context - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  finish(e, t, s) {
    const n = s.material, r = e.outgoingLight, i = s.context.environment;
    if (i)
      switch (n.combine) {
        case og:
          r.rgb.assign(Z(r.rgb, r.rgb.mul(i.rgb), An.mul(Br)));
          break;
        case ig:
          r.rgb.assign(Z(r.rgb, i.rgb, An.mul(Br)));
          break;
        case rg:
          r.rgb.addAssign(i.rgb.mul(An.mul(Br)));
          break;
        default:
          console.warn("THREE.BasicLightingModel: Unsupported .combine value:", n.combine);
          break;
      }
  }
}
const Hx = /* @__PURE__ */ new Gc();
class qx extends ge {
  static get type() {
    return "MeshBasicNodeMaterial";
  }
  /**
   * Constructs a new mesh basic node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshBasicNodeMaterial = !0, this.lights = !0, this.setDefaultValues(Hx), this.setValues(e);
  }
  /**
   * Basic materials are not affected by normal and bump maps so we
   * return by default {@link module:Normal.normalView}.
   *
   * @return {Node<vec3>} The normal node.
   */
  setupNormal() {
    return it;
  }
  /**
   * Overwritten since this type of material uses {@link BasicEnvironmentNode}
   * to implement the default environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {BasicEnvironmentNode<vec3>?} The environment node.
   */
  setupEnvironment(e) {
    const t = super.setupEnvironment(e);
    return t ? new Qa(t) : null;
  }
  /**
   * This method must be overwriten since light maps are evaluated
   * with a special scaling factor for basic materials.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {BasicLightMapNode<vec3>?} The light map node.
   */
  setupLightMap(e) {
    let t = null;
    return e.material.lightMap && (t = new Wx(za)), t;
  }
  /**
   * The material overwrites this method because `lights` is set to `true` but
   * we still want to return the diffuse color as the outgoing light.
   *
   * @return {Node<vec3>} The outgoing light node.
   */
  setupOutgoingLight() {
    return Q.rgb;
  }
  /**
   * Setups the lighting model.
   *
   * @return {BasicLightingModel} The lighting model.
   */
  setupLightingModel() {
    return new Up();
  }
}
const en = /* @__PURE__ */ b(({ f0: o, f90: e, dotVH: t }) => {
  const s = t.mul(-5.55473).sub(6.98316).mul(t).exp2();
  return o.mul(s.oneMinus()).add(e.mul(s));
}), gs = /* @__PURE__ */ b((o) => o.diffuseColor.mul(1 / Math.PI)), Xx = () => g(0.25), Kx = /* @__PURE__ */ b(({ dotNH: o }) => kr.mul(g(0.5)).add(1).mul(g(1 / Math.PI)).mul(o.pow(kr))), Yx = /* @__PURE__ */ b(({ lightDirection: o }) => {
  const e = o.add(oe).normalize(), t = he.dot(e).clamp(), s = oe.dot(e).clamp(), n = en({ f0: Ge, f90: 1, dotVH: s }), r = Xx(), i = Kx({ dotNH: t });
  return n.mul(r).mul(i);
});
class Pp extends Up {
  /**
   * Constructs a new phong lighting model.
   *
   * @param {Boolean} [specular=true] - Whether specular is supported or not.
   */
  constructor(e = !0) {
    super(), this.specular = e;
  }
  /**
   * Implements the direct lighting. The specular portion is optional an can be controlled
   * with the {@link PhongLightingModel#specular} flag.
   *
   * @param {Object} input - The input data.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  direct({ lightDirection: e, lightColor: t, reflectedLight: s }) {
    const r = he.dot(e).clamp().mul(t);
    s.directDiffuse.addAssign(r.mul(gs({ diffuseColor: Q.rgb }))), this.specular === !0 && s.directSpecular.addAssign(r.mul(Yx({ lightDirection: e })).mul(An));
  }
  /**
   * Implements the indirect lighting.
   *
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirect({ ambientOcclusion: e, irradiance: t, reflectedLight: s }) {
    s.indirectDiffuse.addAssign(t.mul(gs({ diffuseColor: Q }))), s.indirectDiffuse.mulAssign(e);
  }
}
const jx = /* @__PURE__ */ new $g();
class Qx extends ge {
  static get type() {
    return "MeshLambertNodeMaterial";
  }
  /**
   * Constructs a new mesh lambert node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshLambertNodeMaterial = !0, this.lights = !0, this.setDefaultValues(jx), this.setValues(e);
  }
  /**
   * Overwritten since this type of material uses {@link BasicEnvironmentNode}
   * to implement the default environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {BasicEnvironmentNode<vec3>?} The environment node.
   */
  setupEnvironment(e) {
    const t = super.setupEnvironment(e);
    return t ? new Qa(t) : null;
  }
  /**
   * Setups the lighting model.
   *
   * @return {PhongLightingModel} The lighting model.
   */
  setupLightingModel() {
    return new Pp(!1);
  }
}
const Zx = /* @__PURE__ */ new Wg();
class Jx extends ge {
  static get type() {
    return "MeshPhongNodeMaterial";
  }
  /**
   * Constructs a new mesh lambert node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshPhongNodeMaterial = !0, this.lights = !0, this.shininessNode = null, this.specularNode = null, this.setDefaultValues(Zx), this.setValues(e);
  }
  /**
   * Overwritten since this type of material uses {@link BasicEnvironmentNode}
   * to implement the default environment mapping.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {BasicEnvironmentNode<vec3>?} The environment node.
   */
  setupEnvironment(e) {
    const t = super.setupEnvironment(e);
    return t ? new Qa(t) : null;
  }
  /**
   * Setups the lighting model.
   *
   * @return {PhongLightingModel} The lighting model.
   */
  setupLightingModel() {
    return new Pp();
  }
  /**
   * Setups the phong specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants() {
    const e = (this.shininessNode ? g(this.shininessNode) : kh).max(1e-4);
    kr.assign(e);
    const t = this.specularNode || $h;
    Ge.assign(t);
  }
  copy(e) {
    return this.shininessNode = e.shininessNode, this.specularNode = e.specularNode, super.copy(e);
  }
}
const Dp = /* @__PURE__ */ b((o) => {
  if (o.geometry.hasAttribute("normal") === !1)
    return g(0);
  const e = it.dFdx().abs().max(it.dFdy().abs());
  return e.x.max(e.y).max(e.z);
}), Za = /* @__PURE__ */ b((o) => {
  const { roughness: e } = o, t = Dp();
  let s = e.max(0.0525);
  return s = s.add(t), s = s.min(1), s;
}), Ip = /* @__PURE__ */ b(({ alpha: o, dotNL: e, dotNV: t }) => {
  const s = o.pow2(), n = e.mul(s.add(s.oneMinus().mul(t.pow2())).sqrt()), r = t.mul(s.add(s.oneMinus().mul(e.pow2())).sqrt());
  return ut(0.5, n.add(r).max(bd));
}).setLayout({
  name: "V_GGX_SmithCorrelated",
  type: "float",
  inputs: [
    { name: "alpha", type: "float" },
    { name: "dotNL", type: "float" },
    { name: "dotNV", type: "float" }
  ]
}), eT = /* @__PURE__ */ b(({ alphaT: o, alphaB: e, dotTV: t, dotBV: s, dotTL: n, dotBL: r, dotNV: i, dotNL: a }) => {
  const u = a.mul(T(o.mul(t), e.mul(s), i).length()), c = i.mul(T(o.mul(n), e.mul(r), a).length());
  return ut(0.5, u.add(c)).saturate();
}).setLayout({
  name: "V_GGX_SmithCorrelated_Anisotropic",
  type: "float",
  inputs: [
    { name: "alphaT", type: "float", qualifier: "in" },
    { name: "alphaB", type: "float", qualifier: "in" },
    { name: "dotTV", type: "float", qualifier: "in" },
    { name: "dotBV", type: "float", qualifier: "in" },
    { name: "dotTL", type: "float", qualifier: "in" },
    { name: "dotBL", type: "float", qualifier: "in" },
    { name: "dotNV", type: "float", qualifier: "in" },
    { name: "dotNL", type: "float", qualifier: "in" }
  ]
}), Lp = /* @__PURE__ */ b(({ alpha: o, dotNH: e }) => {
  const t = o.pow2(), s = e.pow2().mul(t.oneMinus()).oneMinus();
  return t.div(s.pow2()).mul(1 / Math.PI);
}).setLayout({
  name: "D_GGX",
  type: "float",
  inputs: [
    { name: "alpha", type: "float" },
    { name: "dotNH", type: "float" }
  ]
}), tT = /* @__PURE__ */ g(1 / Math.PI), sT = /* @__PURE__ */ b(({ alphaT: o, alphaB: e, dotNH: t, dotTH: s, dotBH: n }) => {
  const r = o.mul(e), i = T(e.mul(s), o.mul(n), r.mul(t)), a = i.dot(i), u = r.div(a);
  return tT.mul(r.mul(u.pow2()));
}).setLayout({
  name: "D_GGX_Anisotropic",
  type: "float",
  inputs: [
    { name: "alphaT", type: "float", qualifier: "in" },
    { name: "alphaB", type: "float", qualifier: "in" },
    { name: "dotNH", type: "float", qualifier: "in" },
    { name: "dotTH", type: "float", qualifier: "in" },
    { name: "dotBH", type: "float", qualifier: "in" }
  ]
}), $o = /* @__PURE__ */ b((o) => {
  const { lightDirection: e, f0: t, f90: s, roughness: n, f: r, USE_IRIDESCENCE: i, USE_ANISOTROPY: a } = o, u = o.normalView || he, c = n.pow2(), l = e.add(oe).normalize(), d = u.dot(e).clamp(), h = u.dot(oe).clamp(), p = u.dot(l).clamp(), f = oe.dot(l).clamp();
  let m = en({ f0: t, f90: s, dotVH: f }), _, S;
  if (Un(i) && (m = ui.mix(m, r)), Un(a)) {
    const A = bn.dot(e), M = bn.dot(oe), F = bn.dot(l), D = fs.dot(e), P = fs.dot(oe), V = fs.dot(l);
    _ = eT({ alphaT: Or, alphaB: c, dotTV: M, dotBV: P, dotTL: A, dotBL: D, dotNV: h, dotNL: d }), S = sT({ alphaT: Or, alphaB: c, dotNH: p, dotTH: F, dotBH: V });
  } else
    _ = Ip({ alpha: c, dotNL: d, dotNV: h }), S = Lp({ alpha: c, dotNH: p });
  return m.mul(_).mul(S);
}), Ja = /* @__PURE__ */ b(({ roughness: o, dotNV: e }) => {
  const t = I(-1, -0.0275, -0.572, 0.022), s = I(1, 0.0425, 1.04, -0.04), n = o.mul(t).add(s), r = n.x.mul(n.x).min(e.mul(-9.28).exp2()).mul(n.x).add(n.y);
  return w(-1.04, 1.04).mul(r).add(n.zw);
}).setLayout({
  name: "DFGApprox",
  type: "vec2",
  inputs: [
    { name: "roughness", type: "float" },
    { name: "dotNV", type: "vec3" }
  ]
}), Vp = /* @__PURE__ */ b((o) => {
  const { dotNV: e, specularColor: t, specularF90: s, roughness: n } = o, r = Ja({ dotNV: e, roughness: n });
  return t.mul(r.x).add(s.mul(r.y));
}), Gp = /* @__PURE__ */ b(({ f: o, f90: e, dotVH: t }) => {
  const s = t.oneMinus().saturate(), n = s.mul(s), r = s.mul(n, n).clamp(0, 0.9999);
  return o.sub(T(e).mul(r)).div(r.oneMinus());
}).setLayout({
  name: "Schlick_to_F0",
  type: "vec3",
  inputs: [
    { name: "f", type: "vec3" },
    { name: "f90", type: "float" },
    { name: "dotVH", type: "float" }
  ]
}), nT = /* @__PURE__ */ b(({ roughness: o, dotNH: e }) => {
  const t = o.pow2(), s = g(1).div(t), r = e.pow2().oneMinus().max(78125e-7);
  return g(2).add(s).mul(r.pow(s.mul(0.5))).div(2 * Math.PI);
}).setLayout({
  name: "D_Charlie",
  type: "float",
  inputs: [
    { name: "roughness", type: "float" },
    { name: "dotNH", type: "float" }
  ]
}), rT = /* @__PURE__ */ b(({ dotNV: o, dotNL: e }) => g(1).div(g(4).mul(e.add(o).sub(e.mul(o))))).setLayout({
  name: "V_Neubelt",
  type: "float",
  inputs: [
    { name: "dotNV", type: "float" },
    { name: "dotNL", type: "float" }
  ]
}), iT = /* @__PURE__ */ b(({ lightDirection: o }) => {
  const e = o.add(oe).normalize(), t = he.dot(o).clamp(), s = he.dot(oe).clamp(), n = he.dot(e).clamp(), r = nT({ roughness: ai, dotNH: n }), i = rT({ dotNV: s, dotNL: t });
  return as.mul(r).mul(i);
}), oT = /* @__PURE__ */ b(({ N: o, V: e, roughness: t }) => {
  const r = 78125e-7, i = o.dot(e).saturate(), a = w(t, i.oneMinus().sqrt());
  return a.assign(a.mul(0.984375).add(r)), a;
}).setLayout({
  name: "LTC_Uv",
  type: "vec2",
  inputs: [
    { name: "N", type: "vec3" },
    { name: "V", type: "vec3" },
    { name: "roughness", type: "float" }
  ]
}), aT = /* @__PURE__ */ b(({ f: o }) => {
  const e = o.length();
  return fe(e.mul(e).add(o.z).div(e.add(1)), 0);
}).setLayout({
  name: "LTC_ClippedSphereFormFactor",
  type: "float",
  inputs: [
    { name: "f", type: "vec3" }
  ]
}), ar = /* @__PURE__ */ b(({ v1: o, v2: e }) => {
  const t = o.dot(e), s = t.abs().toVar(), n = s.mul(0.0145206).add(0.4965155).mul(s).add(0.8543985).toVar(), r = s.add(4.1616724).mul(s).add(3.417594).toVar(), i = n.div(r), a = t.greaterThan(0).select(i, fe(t.mul(t).oneMinus(), 1e-7).inverseSqrt().mul(0.5).sub(i));
  return o.cross(e).mul(a);
}).setLayout({
  name: "LTC_EdgeVectorFormFactor",
  type: "vec3",
  inputs: [
    { name: "v1", type: "vec3" },
    { name: "v2", type: "vec3" }
  ]
}), Wu = /* @__PURE__ */ b(({ N: o, V: e, P: t, mInv: s, p0: n, p1: r, p2: i, p3: a }) => {
  const u = r.sub(n).toVar(), c = a.sub(n).toVar(), l = u.cross(c), d = T().toVar();
  return H(l.dot(t.sub(n)).greaterThanEqual(0), () => {
    const h = e.sub(o.mul(e.dot(o))).normalize(), p = o.cross(h).negate(), f = s.mul(Le(h, p, o).transpose()).toVar(), m = f.mul(n.sub(t)).normalize().toVar(), _ = f.mul(r.sub(t)).normalize().toVar(), S = f.mul(i.sub(t)).normalize().toVar(), A = f.mul(a.sub(t)).normalize().toVar(), M = T(0).toVar();
    M.addAssign(ar({ v1: m, v2: _ })), M.addAssign(ar({ v1: _, v2: S })), M.addAssign(ar({ v1: S, v2: A })), M.addAssign(ar({ v1: A, v2: m })), d.assign(T(aT({ f: M })));
  }), d;
}).setLayout({
  name: "LTC_Evaluate",
  type: "vec3",
  inputs: [
    { name: "N", type: "vec3" },
    { name: "V", type: "vec3" },
    { name: "P", type: "vec3" },
    { name: "mInv", type: "mat3" },
    { name: "p0", type: "vec3" },
    { name: "p1", type: "vec3" },
    { name: "p2", type: "vec3" },
    { name: "p3", type: "vec3" }
  ]
}), bi = 1 / 6, Op = (o) => $(bi, $(o, $(o, o.negate().add(3)).sub(3)).add(1)), Wo = (o) => $(bi, $(o, $(o, $(3, o).sub(6))).add(4)), kp = (o) => $(bi, $(o, $(o, $(-3, o).add(3)).add(3)).add(1)), Ho = (o) => $(bi, ot(o, 3)), Hu = (o) => Op(o).add(Wo(o)), qu = (o) => kp(o).add(Ho(o)), Xu = (o) => _e(-1, Wo(o).div(Op(o).add(Wo(o)))), Ku = (o) => _e(1, Ho(o).div(kp(o).add(Ho(o)))), Yu = (o, e, t) => {
  const s = o.uvNode, n = $(s, e.zw).add(0.5), r = yt(n), i = kt(n), a = Hu(i.x), u = qu(i.x), c = Xu(i.x), l = Ku(i.x), d = Xu(i.y), h = Ku(i.y), p = w(r.x.add(c), r.y.add(d)).sub(0.5).mul(e.xy), f = w(r.x.add(l), r.y.add(d)).sub(0.5).mul(e.xy), m = w(r.x.add(c), r.y.add(h)).sub(0.5).mul(e.xy), _ = w(r.x.add(l), r.y.add(h)).sub(0.5).mul(e.xy), S = Hu(i.y).mul(_e(a.mul(o.sample(p).level(t)), u.mul(o.sample(f).level(t)))), A = qu(i.y).mul(_e(a.mul(o.sample(m).level(t)), u.mul(o.sample(_).level(t))));
  return S.add(A);
}, zp = /* @__PURE__ */ b(([o, e = g(3)]) => {
  const t = w(o.size(y(e))), s = w(o.size(y(e.add(1)))), n = ut(1, t), r = ut(1, s), i = Yu(o, I(n, t), yt(e)), a = Yu(o, I(r, s), li(e));
  return kt(e).mix(i, a);
}), ju = /* @__PURE__ */ b(([o, e, t, s, n]) => {
  const r = T(Ua(e.negate(), Gt(o), ut(1, s))), i = T(
    Dt(n[0].xyz),
    Dt(n[1].xyz),
    Dt(n[2].xyz)
  );
  return Gt(r).mul(t.mul(i));
}).setLayout({
  name: "getVolumeTransmissionRay",
  type: "vec3",
  inputs: [
    { name: "n", type: "vec3" },
    { name: "v", type: "vec3" },
    { name: "thickness", type: "float" },
    { name: "ior", type: "float" },
    { name: "modelMatrix", type: "mat4" }
  ]
}), uT = /* @__PURE__ */ b(([o, e]) => o.mul(_t(e.mul(2).sub(2), 0, 1))).setLayout({
  name: "applyIorToRoughness",
  type: "float",
  inputs: [
    { name: "roughness", type: "float" },
    { name: "ior", type: "float" }
  ]
}), cT = /* @__PURE__ */ Ha(), lT = /* @__PURE__ */ Ha(), Qu = /* @__PURE__ */ b(([o, e, t], { material: s }) => {
  const r = (s.side === Tt ? cT : lT).sample(o), i = mt(kn.x).mul(uT(e, t));
  return zp(r, i);
}), Zu = /* @__PURE__ */ b(([o, e, t]) => (H(t.notEqual(0), () => {
  const s = ci(e).negate().div(t);
  return Aa(s.negate().mul(o));
}), T(1))).setLayout({
  name: "volumeAttenuation",
  type: "vec3",
  inputs: [
    { name: "transmissionDistance", type: "float" },
    { name: "attenuationColor", type: "vec3" },
    { name: "attenuationDistance", type: "float" }
  ]
}), dT = /* @__PURE__ */ b(([o, e, t, s, n, r, i, a, u, c, l, d, h, p, f]) => {
  let m, _;
  if (f) {
    m = I().toVar(), _ = T().toVar();
    const D = l.sub(1).mul(f.mul(0.025)), P = T(l.sub(D), l, l.add(D));
    J({ start: 0, end: 3 }, ({ i: V }) => {
      const k = P.element(V), ie = ju(o, e, d, k, a), me = i.add(ie), ne = c.mul(u.mul(I(me, 1))), Ke = w(ne.xy.div(ne.w)).toVar();
      Ke.addAssign(1), Ke.divAssign(2), Ke.assign(w(Ke.x, Ke.y.oneMinus()));
      const Ye = Qu(Ke, t, k);
      m.element(V).assign(Ye.element(V)), m.a.addAssign(Ye.a), _.element(V).assign(s.element(V).mul(Zu(Dt(ie), h, p).element(V)));
    }), m.a.divAssign(3);
  } else {
    const D = ju(o, e, d, l, a), P = i.add(D), V = c.mul(u.mul(I(P, 1))), k = w(V.xy.div(V.w)).toVar();
    k.addAssign(1), k.divAssign(2), k.assign(w(k.x, k.y.oneMinus())), m = Qu(k, t, l), _ = s.mul(Zu(Dt(D), h, p));
  }
  const S = _.rgb.mul(m.rgb), A = o.dot(e).clamp(), M = T(Vp({
    // n, v, specularColor, specularF90, roughness
    dotNV: A,
    specularColor: n,
    specularF90: r,
    roughness: t
  })), F = _.r.add(_.g, _.b).div(3);
  return I(M.oneMinus().mul(S), m.a.oneMinus().mul(F).oneMinus());
}), hT = /* @__PURE__ */ Le(
  3.2404542,
  -0.969266,
  0.0556434,
  -1.5371385,
  1.8760108,
  -0.2040259,
  -0.4985314,
  0.041556,
  1.0572252
), pT = (o) => {
  const e = o.sqrt();
  return T(1).add(e).div(T(1).sub(e));
}, Ju = (o, e) => o.sub(e).div(o.add(e)).pow2(), fT = (o, e) => {
  const t = o.mul(2 * Math.PI * 1e-9), s = T(54856e-17, 44201e-17, 52481e-17), n = T(1681e3, 1795300, 2208400), r = T(43278e5, 93046e5, 66121e5), i = g(9747e-17 * Math.sqrt(2 * Math.PI * 45282e5)).mul(t.mul(2239900).add(e.x).cos()).mul(t.pow2().mul(-45282e5).exp());
  let a = s.mul(r.mul(2 * Math.PI).sqrt()).mul(n.mul(t).add(e).cos()).mul(t.pow2().negate().mul(r).exp());
  return a = T(a.x.add(i), a.y, a.z).div(10685e-11), hT.mul(a);
}, gT = /* @__PURE__ */ b(({ outsideIOR: o, eta2: e, cosTheta1: t, thinFilmThickness: s, baseF0: n }) => {
  const r = Z(o, e, Ot(0, 0.03, s)), a = o.div(r).pow2().mul(t.pow2().oneMinus()).oneMinus();
  H(a.lessThan(0), () => T(1));
  const u = a.sqrt(), c = Ju(r, o), l = en({ f0: c, f90: 1, dotVH: t }), d = l.oneMinus(), h = r.lessThan(o).select(Math.PI, 0), p = g(Math.PI).sub(h), f = pT(n.clamp(0, 0.9999)), m = Ju(f, r.toVec3()), _ = en({ f0: m, f90: 1, dotVH: u }), S = T(
    f.x.lessThan(r).select(Math.PI, 0),
    f.y.lessThan(r).select(Math.PI, 0),
    f.z.lessThan(r).select(Math.PI, 0)
  ), A = r.mul(s, u, 2), M = T(p).add(S), F = l.mul(_).clamp(1e-5, 0.9999), D = F.sqrt(), P = d.pow2().mul(_).div(T(1).sub(F)), k = l.add(P).toVar(), ie = P.sub(d).toVar();
  return J({ start: 1, end: 2, condition: "<=", name: "m" }, ({ m: me }) => {
    ie.mulAssign(D);
    const ne = fT(g(me).mul(A), g(me).mul(M)).mul(2);
    k.addAssign(ie.mul(ne));
  }), k.max(T(0));
}).setLayout({
  name: "evalIridescence",
  type: "vec3",
  inputs: [
    { name: "outsideIOR", type: "float" },
    { name: "eta2", type: "float" },
    { name: "cosTheta1", type: "float" },
    { name: "thinFilmThickness", type: "float" },
    { name: "baseF0", type: "vec3" }
  ]
}), mT = /* @__PURE__ */ b(({ normal: o, viewDir: e, roughness: t }) => {
  const s = o.dot(e).saturate(), n = t.pow2(), r = Me(
    t.lessThan(0.25),
    g(-339.2).mul(n).add(g(161.4).mul(t)).sub(25.9),
    g(-8.48).mul(n).add(g(14.3).mul(t)).sub(9.95)
  ), i = Me(
    t.lessThan(0.25),
    g(44).mul(n).sub(g(23.7).mul(t)).add(3.26),
    g(1.97).mul(n).sub(g(3.27).mul(t)).add(0.72)
  );
  return Me(t.lessThan(0.25), 0, g(0.1).mul(t).sub(0.025)).add(r.mul(s).add(i).exp()).mul(1 / Math.PI).saturate();
}), Pi = T(0.04), Di = g(1);
class $p extends Ni {
  /**
   * Constructs a new physical lighting model.
   *
   * @param {Boolean} [clearcoat=false] - Whether clearcoat is supported or not.
   * @param {Boolean} [sheen=false] - Whether sheen is supported or not.
   * @param {Boolean} [iridescence=false] - Whether iridescence is supported or not.
   * @param {Boolean} [anisotropy=false] - Whether anisotropy is supported or not.
   * @param {Boolean} [transmission=false] - Whether transmission is supported or not.
   * @param {Boolean} [dispersion=false] - Whether dispersion is supported or not.
   */
  constructor(e = !1, t = !1, s = !1, n = !1, r = !1, i = !1) {
    super(), this.clearcoat = e, this.sheen = t, this.iridescence = s, this.anisotropy = n, this.transmission = r, this.dispersion = i, this.clearcoatRadiance = null, this.clearcoatSpecularDirect = null, this.clearcoatSpecularIndirect = null, this.sheenSpecularDirect = null, this.sheenSpecularIndirect = null, this.iridescenceFresnel = null, this.iridescenceF0 = null;
  }
  /**
   * Depending on what features are requested, the method prepares certain node variables
   * which are later used for lighting computations.
   *
   * @param {ContextNode} context - The current node context.
   */
  start(e) {
    if (this.clearcoat === !0 && (this.clearcoatRadiance = T().toVar("clearcoatRadiance"), this.clearcoatSpecularDirect = T().toVar("clearcoatSpecularDirect"), this.clearcoatSpecularIndirect = T().toVar("clearcoatSpecularIndirect")), this.sheen === !0 && (this.sheenSpecularDirect = T().toVar("sheenSpecularDirect"), this.sheenSpecularIndirect = T().toVar("sheenSpecularIndirect")), this.iridescence === !0) {
      const t = he.dot(oe).clamp();
      this.iridescenceFresnel = gT({
        outsideIOR: g(1),
        eta2: ma,
        cosTheta1: t,
        thinFilmThickness: ya,
        baseF0: Ge
      }), this.iridescenceF0 = Gp({ f: this.iridescenceFresnel, f90: 1, dotVH: t });
    }
    if (this.transmission === !0) {
      const t = It, s = _h.sub(It).normalize(), n = yi;
      e.backdrop = dT(
        n,
        s,
        ft,
        Q,
        Ge,
        Vn,
        // specularF90
        t,
        // positionWorld
        nt,
        // modelMatrix
        Xe,
        // viewMatrix
        _s,
        // projMatrix
        Sn,
        xa,
        _a,
        Ta,
        this.dispersion ? Na : null
      ), e.backdropAlpha = zr, Q.a.mulAssign(Z(1, e.backdrop.a, zr));
    }
  }
  // Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
  // Approximates multi-scattering in order to preserve energy.
  // http://www.jcgt.org/published/0008/01/03/
  computeMultiscattering(e, t, s) {
    const n = he.dot(oe).clamp(), r = Ja({ roughness: ft, dotNV: n }), a = (this.iridescenceF0 ? ui.mix(Ge, this.iridescenceF0) : Ge).mul(r.x).add(s.mul(r.y)), c = r.x.add(r.y).oneMinus(), l = Ge.add(Ge.oneMinus().mul(0.047619)), d = a.mul(l).div(c.mul(l).oneMinus());
    e.addAssign(a), t.addAssign(d.mul(c));
  }
  /**
   * Implements the direct light.
   *
   * @param {Object} input - The input data.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  direct({ lightDirection: e, lightColor: t, reflectedLight: s }) {
    const r = he.dot(e).clamp().mul(t);
    if (this.sheen === !0 && this.sheenSpecularDirect.addAssign(r.mul(iT({ lightDirection: e }))), this.clearcoat === !0) {
      const a = Gs.dot(e).clamp().mul(t);
      this.clearcoatSpecularDirect.addAssign(a.mul($o({ lightDirection: e, f0: Pi, f90: Di, roughness: Ln, normalView: Gs })));
    }
    s.directDiffuse.addAssign(r.mul(gs({ diffuseColor: Q.rgb }))), s.directSpecular.addAssign(r.mul($o({ lightDirection: e, f0: Ge, f90: 1, roughness: ft, iridescence: this.iridescence, f: this.iridescenceFresnel, USE_IRIDESCENCE: this.iridescence, USE_ANISOTROPY: this.anisotropy })));
  }
  /**
   * This method is intended for implementing the direct light term for
   * rect area light nodes.
   *
   * @param {Object} input - The input data.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  directRectArea({ lightColor: e, lightPosition: t, halfWidth: s, halfHeight: n, reflectedLight: r, ltc_1: i, ltc_2: a }) {
    const u = t.add(s).sub(n), c = t.sub(s).sub(n), l = t.sub(s).add(n), d = t.add(s).add(n), h = he, p = oe, f = xe.toVar(), m = oT({ N: h, V: p, roughness: ft }), _ = i.sample(m).toVar(), S = a.sample(m).toVar(), A = Le(
      T(_.x, 0, _.y),
      T(0, 1, 0),
      T(_.z, 0, _.w)
    ).toVar(), M = Ge.mul(S.x).add(Ge.oneMinus().mul(S.y)).toVar();
    r.directSpecular.addAssign(e.mul(M).mul(Wu({ N: h, V: p, P: f, mInv: A, p0: u, p1: c, p2: l, p3: d }))), r.directDiffuse.addAssign(e.mul(Q).mul(Wu({ N: h, V: p, P: f, mInv: Le(1, 0, 0, 0, 1, 0, 0, 0, 1), p0: u, p1: c, p2: l, p3: d })));
  }
  /**
   * Implements the indirect lighting.
   *
   * @param {ContextNode} context - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirect(e, t, s) {
    this.indirectDiffuse(e, t, s), this.indirectSpecular(e, t, s), this.ambientOcclusion(e, t, s);
  }
  /**
   * Implements the indirect diffuse term.
   *
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirectDiffuse({ irradiance: e, reflectedLight: t }) {
    t.indirectDiffuse.addAssign(e.mul(gs({ diffuseColor: Q })));
  }
  /**
   * Implements the indirect specular term.
   *
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirectSpecular({ radiance: e, iblIrradiance: t, reflectedLight: s }) {
    if (this.sheen === !0 && this.sheenSpecularIndirect.addAssign(t.mul(
      as,
      mT({
        normal: he,
        viewDir: oe,
        roughness: ai
      })
    )), this.clearcoat === !0) {
      const c = Gs.dot(oe).clamp(), l = Vp({
        dotNV: c,
        specularColor: Pi,
        specularF90: Di,
        roughness: Ln
      });
      this.clearcoatSpecularIndirect.addAssign(this.clearcoatRadiance.mul(l));
    }
    const n = T().toVar("singleScattering"), r = T().toVar("multiScattering"), i = t.mul(1 / Math.PI);
    this.computeMultiscattering(n, r, Vn);
    const a = n.add(r), u = Q.mul(a.r.max(a.g).max(a.b).oneMinus());
    s.indirectSpecular.addAssign(e.mul(n)), s.indirectSpecular.addAssign(r.mul(i)), s.indirectDiffuse.addAssign(u.mul(i));
  }
  /**
   * Implements the ambient occlusion term.
   *
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  ambientOcclusion({ ambientOcclusion: e, reflectedLight: t }) {
    const n = he.dot(oe).clamp().add(e), r = ft.mul(-16).oneMinus().negate().exp2(), i = e.sub(n.pow(r).oneMinus()).clamp();
    this.clearcoat === !0 && this.clearcoatSpecularIndirect.mulAssign(e), this.sheen === !0 && this.sheenSpecularIndirect.mulAssign(e), t.indirectDiffuse.mulAssign(e), t.indirectSpecular.mulAssign(i);
  }
  /**
   * Used for final lighting accumulations depending on the requested features.
   *
   * @param {ContextNode} context - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  finish(e) {
    const { outgoingLight: t } = e;
    if (this.clearcoat === !0) {
      const s = Gs.dot(oe).clamp(), n = en({
        dotVH: s,
        f0: Pi,
        f90: Di
      }), r = t.mul(Gr.mul(n).oneMinus()).add(this.clearcoatSpecularDirect.add(this.clearcoatSpecularIndirect).mul(Gr));
      t.assign(r);
    }
    if (this.sheen === !0) {
      const s = as.r.max(as.g).max(as.b).mul(0.157).oneMinus(), n = t.mul(s).add(this.sheenSpecularDirect, this.sheenSpecularIndirect);
      t.assign(n);
    }
  }
}
const ec = /* @__PURE__ */ g(1), qo = /* @__PURE__ */ g(-2), ur = /* @__PURE__ */ g(0.8), Ii = /* @__PURE__ */ g(-1), cr = /* @__PURE__ */ g(0.4), Li = /* @__PURE__ */ g(2), lr = /* @__PURE__ */ g(0.305), Vi = /* @__PURE__ */ g(3), tc = /* @__PURE__ */ g(0.21), yT = /* @__PURE__ */ g(4), sc = /* @__PURE__ */ g(4), xT = /* @__PURE__ */ g(16), TT = /* @__PURE__ */ b(([o]) => {
  const e = T(re(o)).toVar(), t = g(-1).toVar();
  return H(e.x.greaterThan(e.z), () => {
    H(e.x.greaterThan(e.y), () => {
      t.assign(Me(o.x.greaterThan(0), 0, 3));
    }).Else(() => {
      t.assign(Me(o.y.greaterThan(0), 1, 4));
    });
  }).Else(() => {
    H(e.z.greaterThan(e.y), () => {
      t.assign(Me(o.z.greaterThan(0), 2, 5));
    }).Else(() => {
      t.assign(Me(o.y.greaterThan(0), 1, 4));
    });
  }), t;
}).setLayout({
  name: "getFace",
  type: "float",
  inputs: [
    { name: "direction", type: "vec3" }
  ]
}), _T = /* @__PURE__ */ b(([o, e]) => {
  const t = w().toVar();
  return H(e.equal(0), () => {
    t.assign(w(o.z, o.y).div(re(o.x)));
  }).ElseIf(e.equal(1), () => {
    t.assign(w(o.x.negate(), o.z.negate()).div(re(o.y)));
  }).ElseIf(e.equal(2), () => {
    t.assign(w(o.x.negate(), o.y).div(re(o.z)));
  }).ElseIf(e.equal(3), () => {
    t.assign(w(o.z.negate(), o.y).div(re(o.x)));
  }).ElseIf(e.equal(4), () => {
    t.assign(w(o.x.negate(), o.z).div(re(o.y)));
  }).Else(() => {
    t.assign(w(o.x, o.y).div(re(o.z)));
  }), $(0.5, t.add(1));
}).setLayout({
  name: "getUV",
  type: "vec2",
  inputs: [
    { name: "direction", type: "vec3" },
    { name: "face", type: "float" }
  ]
}), NT = /* @__PURE__ */ b(([o]) => {
  const e = g(0).toVar();
  return H(o.greaterThanEqual(ur), () => {
    e.assign(ec.sub(o).mul(Ii.sub(qo)).div(ec.sub(ur)).add(qo));
  }).ElseIf(o.greaterThanEqual(cr), () => {
    e.assign(ur.sub(o).mul(Li.sub(Ii)).div(ur.sub(cr)).add(Ii));
  }).ElseIf(o.greaterThanEqual(lr), () => {
    e.assign(cr.sub(o).mul(Vi.sub(Li)).div(cr.sub(lr)).add(Li));
  }).ElseIf(o.greaterThanEqual(tc), () => {
    e.assign(lr.sub(o).mul(yT.sub(Vi)).div(lr.sub(tc)).add(Vi));
  }).Else(() => {
    e.assign(g(-2).mul(mt($(1.16, o))));
  }), e;
}).setLayout({
  name: "roughnessToMip",
  type: "float",
  inputs: [
    { name: "roughness", type: "float" }
  ]
}), Wp = /* @__PURE__ */ b(([o, e]) => {
  const t = o.toVar();
  t.assign($(2, t).sub(1));
  const s = T(t, 1).toVar();
  return H(e.equal(0), () => {
    s.assign(s.zyx);
  }).ElseIf(e.equal(1), () => {
    s.assign(s.xzy), s.xz.mulAssign(-1);
  }).ElseIf(e.equal(2), () => {
    s.x.mulAssign(-1);
  }).ElseIf(e.equal(3), () => {
    s.assign(s.zyx), s.xz.mulAssign(-1);
  }).ElseIf(e.equal(4), () => {
    s.assign(s.xzy), s.xy.mulAssign(-1);
  }).ElseIf(e.equal(5), () => {
    s.z.mulAssign(-1);
  }), s;
}).setLayout({
  name: "getDirection",
  type: "vec3",
  inputs: [
    { name: "uv", type: "vec2" },
    { name: "face", type: "float" }
  ]
}), Hp = /* @__PURE__ */ b(([o, e, t, s, n, r]) => {
  const i = g(t), a = T(e), u = _t(NT(i), qo, r), c = kt(u), l = yt(u), d = T(Xo(o, a, l, s, n, r)).toVar();
  return H(c.notEqual(0), () => {
    const h = T(Xo(o, a, l.add(1), s, n, r)).toVar();
    d.assign(Z(d, h, c));
  }), d;
}), Xo = /* @__PURE__ */ b(([o, e, t, s, n, r]) => {
  const i = g(t).toVar(), a = T(e), u = g(TT(a)).toVar(), c = g(fe(sc.sub(i), 0)).toVar();
  i.assign(fe(i, sc));
  const l = g(Zs(i)).toVar(), d = w(_T(a, u).mul(l.sub(2)).add(1)).toVar();
  return H(u.greaterThan(2), () => {
    d.y.addAssign(l), u.subAssign(3);
  }), d.x.addAssign(u.mul(l)), d.x.addAssign(c.mul($(3, xT))), d.y.addAssign($(4, Zs(r).sub(l))), d.x.mulAssign(s), d.y.mulAssign(n), o.sample(d).grad(w(), w());
}), Gi = /* @__PURE__ */ b(({ envMap: o, mipInt: e, outputDirection: t, theta: s, axis: n, CUBEUV_TEXEL_WIDTH: r, CUBEUV_TEXEL_HEIGHT: i, CUBEUV_MAX_MIP: a }) => {
  const u = Bt(s), c = t.mul(u).add(n.cross(t).mul(Ze(s))).add(n.mul(n.dot(t).mul(u.oneMinus())));
  return Xo(o, c, e, r, i, a);
}), qp = /* @__PURE__ */ b(({ n: o, latitudinal: e, poleAxis: t, outputDirection: s, weights: n, samples: r, dTheta: i, mipInt: a, envMap: u, CUBEUV_TEXEL_WIDTH: c, CUBEUV_TEXEL_HEIGHT: l, CUBEUV_MAX_MIP: d }) => {
  const h = T(Me(e, t, hi(t, s))).toVar();
  H(va(h.equals(T(0))), () => {
    h.assign(T(s.z, 0, s.x.negate()));
  }), h.assign(Gt(h));
  const p = T().toVar();
  return p.addAssign(n.element(y(0)).mul(Gi({ theta: 0, axis: h, outputDirection: s, mipInt: a, envMap: u, CUBEUV_TEXEL_WIDTH: c, CUBEUV_TEXEL_HEIGHT: l, CUBEUV_MAX_MIP: d }))), J({ start: y(1), end: o }, ({ i: f }) => {
    H(f.greaterThanEqual(r), () => {
      bp();
    });
    const m = g(i.mul(g(f))).toVar();
    p.addAssign(n.element(f).mul(Gi({ theta: m.mul(-1), axis: h, outputDirection: s, mipInt: a, envMap: u, CUBEUV_TEXEL_WIDTH: c, CUBEUV_TEXEL_HEIGHT: l, CUBEUV_MAX_MIP: d }))), p.addAssign(n.element(f).mul(Gi({ theta: m, axis: h, outputDirection: s, mipInt: a, envMap: u, CUBEUV_TEXEL_WIDTH: c, CUBEUV_TEXEL_HEIGHT: l, CUBEUV_MAX_MIP: d })));
  }), I(p, 1);
});
let Xr = null;
const nc = /* @__PURE__ */ new WeakMap();
function bT(o) {
  const e = Math.log2(o) - 2, t = 1 / o;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 7 * 16)), texelHeight: t, maxMip: e };
}
function ST(o) {
  let e = nc.get(o);
  if ((e !== void 0 ? e.pmremVersion : -1) !== o.pmremVersion) {
    const s = o.image;
    if (o.isCubeTexture)
      if (AT(s))
        e = Xr.fromCubemap(o, e);
      else
        return null;
    else if (RT(s))
      e = Xr.fromEquirectangular(o, e);
    else
      return null;
    e.pmremVersion = o.pmremVersion, nc.set(o, e);
  }
  return e.texture;
}
class vT extends Ne {
  static get type() {
    return "PMREMNode";
  }
  /**
   * Constructs a new function overloading node.
   *
   * @param {Texture} value - The input texture.
   * @param {Node<vec2>} [uvNode=null] - The uv node.
   * @param {Node<float>} [levelNode=null] - The level node.
   */
  constructor(e, t = null, s = null) {
    super("vec3"), this._value = e, this._pmrem = null, this.uvNode = t, this.levelNode = s, this._generator = null;
    const n = new vl();
    n.isRenderTargetTexture = !0, this._texture = X(n), this._width = L(0), this._height = L(0), this._maxMip = L(0), this.updateBeforeType = z.RENDER;
  }
  set value(e) {
    this._value = e, this._pmrem = null;
  }
  /**
   * The node's texture value.
   *
   * @type {Texture}
   */
  get value() {
    return this._value;
  }
  /**
   * Uses the given PMREM texture to update internal values.
   *
   * @param {Texture} texture - The PMREM texture.
   */
  updateFromTexture(e) {
    const t = bT(e.image.height);
    this._texture.value = e, this._width.value = t.texelWidth, this._height.value = t.texelHeight, this._maxMip.value = t.maxMip;
  }
  updateBefore() {
    let e = this._pmrem;
    const t = e ? e.pmremVersion : -1, s = this._value;
    t !== s.pmremVersion && (s.isPMREMTexture === !0 ? e = s : e = ST(s), e !== null && (this._pmrem = e, this.updateFromTexture(e)));
  }
  setup(e) {
    Xr === null && (Xr = e.createPMREMGenerator()), this.updateBefore(e);
    let t = this.uvNode;
    t === null && e.context.getUV && (t = e.context.getUV(this));
    const s = this.value;
    e.renderer.coordinateSystem === En && s.isPMREMTexture !== !0 && s.isRenderTargetTexture === !0 && (t = T(t.x.negate(), t.yz)), t = T(t.x, t.y.negate(), t.z);
    let n = this.levelNode;
    return n === null && e.context.getTextureLevel && (n = e.context.getTextureLevel(this)), Hp(this._texture, t, n, this._width, this._height, this._maxMip);
  }
}
function AT(o) {
  if (o == null) return !1;
  let e = 0;
  const t = 6;
  for (let s = 0; s < t; s++)
    o[s] !== void 0 && e++;
  return e === t;
}
function RT(o) {
  return o == null ? !1 : o.height > 0;
}
const eu = /* @__PURE__ */ C(vT), rc = /* @__PURE__ */ new WeakMap();
class CT extends on {
  static get type() {
    return "EnvironmentNode";
  }
  /**
   * Constructs a new environment node.
   *
   * @param {Node} [envNode=null] - A node representing the environment.
   */
  constructor(e = null) {
    super(), this.envNode = e;
  }
  setup(e) {
    const { material: t } = e;
    let s = this.envNode;
    if (s.isTextureNode || s.isMaterialReferenceNode) {
      const p = s.isTextureNode ? s.value : t[s.property];
      let f = rc.get(p);
      f === void 0 && (f = eu(p), rc.set(p, f)), s = f;
    }
    const r = t.envMap ? te("envMapIntensity", "float", e.material) : te("environmentIntensity", "float", e.scene), a = t.useAnisotropy === !0 || t.anisotropy > 0 ? Lh : he, u = s.context(ic(ft, a)).mul(r), c = s.context(ET(yi)).mul(Math.PI).mul(r), l = vn(u), d = vn(c);
    e.context.radiance.addAssign(l), e.context.iblIrradiance.addAssign(d);
    const h = e.context.lightingModel.clearcoatRadiance;
    if (h) {
      const p = s.context(ic(Ln, Gs)).mul(r), f = vn(p);
      h.addAssign(f);
    }
  }
}
const ic = (o, e) => {
  let t = null;
  return {
    getUV: () => (t === null && (t = oe.negate().reflect(e), t = o.mul(o).mix(t, e).normalize(), t = t.transformDirection(Xe)), t),
    getTextureLevel: () => o
  };
}, ET = (o) => ({
  getUV: () => o,
  getTextureLevel: () => g(1)
}), wT = /* @__PURE__ */ new Hg();
class Xp extends ge {
  static get type() {
    return "MeshStandardNodeMaterial";
  }
  /**
   * Constructs a new mesh standard node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshStandardNodeMaterial = !0, this.lights = !0, this.emissiveNode = null, this.metalnessNode = null, this.roughnessNode = null, this.setDefaultValues(wT), this.setValues(e);
  }
  /**
   * Overwritten since this type of material uses {@link EnvironmentNode}
   * to implement the PBR (PMREM based) environment mapping. Besides, the
   * method honors `Scene.environment`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {EnvironmentNode<vec3>?} The environment node.
   */
  setupEnvironment(e) {
    let t = super.setupEnvironment(e);
    return t === null && e.environmentNode && (t = e.environmentNode), t ? new CT(t) : null;
  }
  /**
   * Setups the lighting model.
   *
   * @return {PhysicalLightingModel} The lighting model.
   */
  setupLightingModel() {
    return new $p();
  }
  /**
   * Setups the specular related node variables.
   */
  setupSpecular() {
    const e = Z(T(0.04), Q.rgb, In);
    Ge.assign(e), Vn.assign(1);
  }
  /**
   * Setups the standard specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants() {
    const e = this.metalnessNode ? g(this.metalnessNode) : qh;
    In.assign(e);
    let t = this.roughnessNode ? g(this.roughnessNode) : Hh;
    t = Za({ roughness: t }), ft.assign(t), this.setupSpecular(), Q.assign(I(Q.rgb.mul(e.oneMinus()), Q.a));
  }
  copy(e) {
    return this.emissiveNode = e.emissiveNode, this.metalnessNode = e.metalnessNode, this.roughnessNode = e.roughnessNode, super.copy(e);
  }
}
const MT = /* @__PURE__ */ new qg();
class BT extends Xp {
  static get type() {
    return "MeshPhysicalNodeMaterial";
  }
  /**
   * Constructs a new mesh physical node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshPhysicalNodeMaterial = !0, this.clearcoatNode = null, this.clearcoatRoughnessNode = null, this.clearcoatNormalNode = null, this.sheenNode = null, this.sheenRoughnessNode = null, this.iridescenceNode = null, this.iridescenceIORNode = null, this.iridescenceThicknessNode = null, this.specularIntensityNode = null, this.specularColorNode = null, this.iorNode = null, this.transmissionNode = null, this.thicknessNode = null, this.attenuationDistanceNode = null, this.attenuationColorNode = null, this.dispersionNode = null, this.anisotropyNode = null, this.setDefaultValues(MT), this.setValues(e);
  }
  /**
   * Whether the lighting model should use clearcoat or not.
   *
   * @type {Boolean}
   * @default true
   */
  get useClearcoat() {
    return this.clearcoat > 0 || this.clearcoatNode !== null;
  }
  /**
   * Whether the lighting model should use iridescence or not.
   *
   * @type {Boolean}
   * @default true
   */
  get useIridescence() {
    return this.iridescence > 0 || this.iridescenceNode !== null;
  }
  /**
   * Whether the lighting model should use sheen or not.
   *
   * @type {Boolean}
   * @default true
   */
  get useSheen() {
    return this.sheen > 0 || this.sheenNode !== null;
  }
  /**
   * Whether the lighting model should use anisotropy or not.
   *
   * @type {Boolean}
   * @default true
   */
  get useAnisotropy() {
    return this.anisotropy > 0 || this.anisotropyNode !== null;
  }
  /**
   * Whether the lighting model should use transmission or not.
   *
   * @type {Boolean}
   * @default true
   */
  get useTransmission() {
    return this.transmission > 0 || this.transmissionNode !== null;
  }
  /**
   * Whether the lighting model should use dispersion or not.
   *
   * @type {Boolean}
   * @default true
   */
  get useDispersion() {
    return this.dispersion > 0 || this.dispersionNode !== null;
  }
  /**
   * Setups the specular related node variables.
   */
  setupSpecular() {
    const e = this.iorNode ? g(this.iorNode) : op;
    Sn.assign(e), Ge.assign(Z($e(Fa(Sn.sub(1).div(Sn.add(1))).mul(Wh), T(1)).mul(zo), Q.rgb, In)), Vn.assign(Z(zo, 1, In));
  }
  /**
   * Setups the lighting model.
   *
   * @return {PhysicalLightingModel} The lighting model.
   */
  setupLightingModel() {
    return new $p(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion);
  }
  /**
   * Setups the physical specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants(e) {
    if (super.setupVariants(e), this.useClearcoat) {
      const t = this.clearcoatNode ? g(this.clearcoatNode) : Kh, s = this.clearcoatRoughnessNode ? g(this.clearcoatRoughnessNode) : Yh;
      Gr.assign(t), Ln.assign(Za({ roughness: s }));
    }
    if (this.useSheen) {
      const t = this.sheenNode ? T(this.sheenNode) : Zh, s = this.sheenRoughnessNode ? g(this.sheenRoughnessNode) : Jh;
      as.assign(t), ai.assign(s);
    }
    if (this.useIridescence) {
      const t = this.iridescenceNode ? g(this.iridescenceNode) : tp, s = this.iridescenceIORNode ? g(this.iridescenceIORNode) : sp, n = this.iridescenceThicknessNode ? g(this.iridescenceThicknessNode) : np;
      ui.assign(t), ma.assign(s), ya.assign(n);
    }
    if (this.useAnisotropy) {
      const t = (this.anisotropyNode ? w(this.anisotropyNode) : ep).toVar();
      Ht.assign(t.length()), H(Ht.equal(0), () => {
        t.assign(w(1, 0));
      }).Else(() => {
        t.divAssign(w(Ht)), Ht.assign(Ht.saturate());
      }), Or.assign(Ht.pow2().mix(ft.pow2(), 1)), bn.assign(us[0].mul(t.x).add(us[1].mul(t.y))), fs.assign(us[1].mul(t.x).sub(us[0].mul(t.y)));
    }
    if (this.useTransmission) {
      const t = this.transmissionNode ? g(this.transmissionNode) : rp, s = this.thicknessNode ? g(this.thicknessNode) : ip, n = this.attenuationDistanceNode ? g(this.attenuationDistanceNode) : ap, r = this.attenuationColorNode ? T(this.attenuationColorNode) : up;
      if (zr.assign(t), xa.assign(s), Ta.assign(n), _a.assign(r), this.useDispersion) {
        const i = this.dispersionNode ? g(this.dispersionNode) : pp;
        Na.assign(i);
      }
    }
  }
  /**
   * Setups the clearcoat normal node.
   *
   * @return {Node<vec3>} The clearcoat noraml.
   */
  setupClearcoatNormal() {
    return this.clearcoatNormalNode ? T(this.clearcoatNormalNode) : jh;
  }
  setup(e) {
    e.context.setupClearcoatNormal = () => this.setupClearcoatNormal(e), super.setup(e);
  }
  copy(e) {
    return this.clearcoatNode = e.clearcoatNode, this.clearcoatRoughnessNode = e.clearcoatRoughnessNode, this.clearcoatNormalNode = e.clearcoatNormalNode, this.sheenNode = e.sheenNode, this.sheenRoughnessNode = e.sheenRoughnessNode, this.iridescenceNode = e.iridescenceNode, this.iridescenceIORNode = e.iridescenceIORNode, this.iridescenceThicknessNode = e.iridescenceThicknessNode, this.specularIntensityNode = e.specularIntensityNode, this.specularColorNode = e.specularColorNode, this.transmissionNode = e.transmissionNode, this.thicknessNode = e.thicknessNode, this.attenuationDistanceNode = e.attenuationDistanceNode, this.attenuationColorNode = e.attenuationColorNode, this.dispersionNode = e.dispersionNode, this.anisotropyNode = e.anisotropyNode, super.copy(e);
  }
}
const FT = /* @__PURE__ */ b(({ normal: o, lightDirection: e, builder: t }) => {
  const s = o.dot(e), n = w(s.mul(0.5).add(0.5), 0);
  if (t.material.gradientMap) {
    const r = Pt("gradientMap", "texture").context({ getUV: () => n });
    return T(r.r);
  } else {
    const r = n.fwidth().mul(0.5);
    return Z(T(0.7), T(1), Ot(g(0.7).sub(r.x), g(0.7).add(r.x), n.x));
  }
});
class UT extends Ni {
  /**
   * Implements the direct lighting. Instead of using a conventional smooth irradiance, the irradiance is
   * reduced to a small number of discrete shades to create a comic-like, flat look.
   *
   * @param {Object} input - The input data.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  direct({ lightDirection: e, lightColor: t, reflectedLight: s }, n, r) {
    const i = FT({ normal: gi, lightDirection: e, builder: r }).mul(t);
    s.directDiffuse.addAssign(i.mul(gs({ diffuseColor: Q.rgb })));
  }
  /**
   * Implements the indirect lighting.
   *
   * @param {ContextNode} input - The current node context.
   * @param {StackNode} stack - The current stack.
   * @param {NodeBuilder} builder - The current node builder.
   */
  indirect({ ambientOcclusion: e, irradiance: t, reflectedLight: s }) {
    s.indirectDiffuse.addAssign(t.mul(gs({ diffuseColor: Q }))), s.indirectDiffuse.mulAssign(e);
  }
}
const PT = /* @__PURE__ */ new Xg();
class DT extends ge {
  static get type() {
    return "MeshToonNodeMaterial";
  }
  /**
   * Constructs a new mesh toon node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshToonNodeMaterial = !0, this.lights = !0, this.setDefaultValues(PT), this.setValues(e);
  }
  /**
   * Setups the lighting model.
   *
   * @return {ToonLightingModel} The lighting model.
   */
  setupLightingModel() {
    return new UT();
  }
}
class IT extends Ne {
  static get type() {
    return "MatcapUVNode";
  }
  /**
   * Constructs a new matcap uv node.
   */
  constructor() {
    super("vec2");
  }
  setup() {
    const e = T(oe.z, 0, oe.x.negate()).normalize(), t = oe.cross(e);
    return w(e.dot(he), t.dot(he)).mul(0.495).add(0.5);
  }
}
const Kp = /* @__PURE__ */ B(IT), LT = /* @__PURE__ */ new Kg();
class VT extends ge {
  static get type() {
    return "MeshMatcapNodeMaterial";
  }
  /**
   * Constructs a new mesh normal node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isMeshMatcapNodeMaterial = !0, this.setDefaultValues(LT), this.setValues(e);
  }
  /**
   * Setups the matcap specific node variables.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupVariants(e) {
    const t = Kp;
    let s;
    e.material.matcap ? s = Pt("matcap", "texture").context({ getUV: () => t }) : s = T(Z(0.2, 0.8, t.y)), Q.rgb.mulAssign(s.rgb);
  }
}
const GT = /* @__PURE__ */ new Yg();
class OT extends ge {
  static get type() {
    return "PointsNodeMaterial";
  }
  /**
   * Constructs a new points node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isPointsNodeMaterial = !0, this.setDefaultValues(GT), this.setValues(e);
  }
}
class kT extends Ne {
  static get type() {
    return "RotateNode";
  }
  /**
   * Constructs a new rotate node.
   *
   * @param {Node} positionNode - The position node.
   * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
   * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
   */
  constructor(e, t) {
    super(), this.positionNode = e, this.rotationNode = t;
  }
  /**
   * The type of the {@link RotateNode#positionNode} defines the node's type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node's type.
   */
  getNodeType(e) {
    return this.positionNode.getNodeType(e);
  }
  setup(e) {
    const { rotationNode: t, positionNode: s } = this;
    if (this.getNodeType(e) === "vec2") {
      const r = t.cos(), i = t.sin();
      return oi(
        r,
        i,
        i.negate(),
        r
      ).mul(s);
    } else {
      const r = t, i = ps(I(1, 0, 0, 0), I(0, Bt(r.x), Ze(r.x).negate(), 0), I(0, Ze(r.x), Bt(r.x), 0), I(0, 0, 0, 1)), a = ps(I(Bt(r.y), 0, Ze(r.y), 0), I(0, 1, 0, 0), I(Ze(r.y).negate(), 0, Bt(r.y), 0), I(0, 0, 0, 1)), u = ps(I(Bt(r.z), Ze(r.z).negate(), 0, 0), I(Ze(r.z), Bt(r.z), 0, 0), I(0, 0, 1, 0), I(0, 0, 0, 1));
      return i.mul(a).mul(u).mul(I(s, 1)).xyz;
    }
  }
}
const tu = /* @__PURE__ */ C(kT), zT = /* @__PURE__ */ new jg();
class $T extends ge {
  static get type() {
    return "SpriteNodeMaterial";
  }
  /**
   * Constructs a new sprite node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isSpriteNodeMaterial = !0, this._useSizeAttenuation = !0, this.positionNode = null, this.rotationNode = null, this.scaleNode = null, this.setDefaultValues(zT), this.setValues(e);
  }
  /**
   * Setups the position node in view space. This method implements
   * the sprite specific vertex shader.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node<vec3>} The position in view space.
   */
  setupPositionView(e) {
    const { object: t, camera: s } = e, n = this.sizeAttenuation, { positionNode: r, rotationNode: i, scaleNode: a } = this, u = rn.mul(T(r || 0));
    let c = w(nt[0].xyz.length(), nt[1].xyz.length());
    if (a !== null && (c = c.mul(a)), n === !1)
      if (s.isPerspectiveCamera)
        c = c.mul(u.z.negate());
      else {
        const p = g(2).div(_s.element(1).element(1));
        c = c.mul(p.mul(2));
      }
    let l = fi.xy;
    if (t.center && t.center.isVector2 === !0) {
      const p = cy("center", "vec2", t);
      l = l.sub(p.sub(0.5));
    }
    l = l.mul(c);
    const d = g(i || Qh), h = tu(l, d);
    return I(u.xy.add(h), u.zw);
  }
  copy(e) {
    return this.positionNode = e.positionNode, this.rotationNode = e.rotationNode, this.scaleNode = e.scaleNode, super.copy(e);
  }
  /**
   * Whether to use size attenuation or not.
   *
   * @type {Boolean}
   * @default true
   */
  get sizeAttenuation() {
    return this._useSizeAttenuation;
  }
  set sizeAttenuation(e) {
    this._useSizeAttenuation !== e && (this._useSizeAttenuation = e, this.needsUpdate = !0);
  }
}
class WT extends Ni {
  /**
   * Constructs a new shadow mask model.
   */
  constructor() {
    super(), this.shadowNode = g(1).toVar("shadowMask");
  }
  /**
   * Only used to save the shadow mask.
   *
   * @param {Object} input - The input data.
   */
  direct({ shadowMask: e }) {
    this.shadowNode.mulAssign(e);
  }
  /**
   * Uses the shadow mask to produce the final color.
   *
   * @param {ContextNode} context - The current node context.
   */
  finish(e) {
    Q.a.mulAssign(this.shadowNode.oneMinus()), e.outgoingLight.rgb.assign(Q.rgb);
  }
}
const HT = /* @__PURE__ */ new Qg();
class qT extends ge {
  static get type() {
    return "ShadowNodeMaterial";
  }
  /**
   * Constructs a new shadow node material.
   *
   * @param {Object?} parameters - The configuration parameter.
   */
  constructor(e) {
    super(), this.isShadowNodeMaterial = !0, this.lights = !0, this.setDefaultValues(HT), this.setValues(e);
  }
  /**
   * Setups the lighting model.
   *
   * @return {ShadowMaskModel} The lighting model.
   */
  setupLightingModel() {
    return new WT();
  }
}
const XT = b(({ texture: o, uv: e }) => {
  const s = T().toVar();
  return H(e.x.lessThan(1e-4), () => {
    s.assign(T(1, 0, 0));
  }).ElseIf(e.y.lessThan(1e-4), () => {
    s.assign(T(0, 1, 0));
  }).ElseIf(e.z.lessThan(1e-4), () => {
    s.assign(T(0, 0, 1));
  }).ElseIf(e.x.greaterThan(1 - 1e-4), () => {
    s.assign(T(-1, 0, 0));
  }).ElseIf(e.y.greaterThan(1 - 1e-4), () => {
    s.assign(T(0, -1, 0));
  }).ElseIf(e.z.greaterThan(1 - 1e-4), () => {
    s.assign(T(0, 0, -1));
  }).Else(() => {
    const r = o.sample(e.add(T(-0.01, 0, 0))).r.sub(o.sample(e.add(T(0.01, 0, 0))).r), i = o.sample(e.add(T(0, -0.01, 0))).r.sub(o.sample(e.add(T(0, 0.01, 0))).r), a = o.sample(e.add(T(0, 0, -0.01))).r.sub(o.sample(e.add(T(0, 0, 0.01))).r);
    s.assign(T(r, i, a));
  }), s.normalize();
});
class KT extends bt {
  static get type() {
    return "Texture3DNode";
  }
  /**
   * Constructs a new 3D texture node.
   *
   * @param {Data3DTexture} value - The 3D texture.
   * @param {Node<vec2|vec3>?} [uvNode=null] - The uv node.
   * @param {Node<int>?} [levelNode=null] - The level node.
   */
  constructor(e, t = null, s = null) {
    super(e, t, s), this.isTexture3DNode = !0;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'texture3D'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return "texture3D";
  }
  /**
   * Returns a default uv node which is in context of 3D textures a three-dimensional
   * uv node.
   *
   * @return {Node<vec3>} The default uv node.
   */
  getDefaultUV() {
    return T(0.5, 0.5, 0.5);
  }
  /**
   * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
   * for 3D textures. The uv transformation matrix is not applied to 3D textures.
   *
   * @param {Boolean} value - The update toggle.
   */
  setUpdateMatrix() {
  }
  // Ignore .updateMatrix for 3d TextureNode
  /**
   * Overwrites the default implementation to return the unmodified uv node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to setup.
   * @return {Node} The unmodified uv node.
   */
  setupUV(e, t) {
    const s = this.value;
    return e.isFlipY() && (s.isRenderTargetTexture === !0 || s.isFramebufferTexture === !0) && (this.sampler ? t = t.flipY() : t = t.setY(y(jt(this, this.levelNode).y).sub(t.y).sub(1))), t;
  }
  /**
   * Generates the uv code snippet.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {Node} uvNode - The uv node to generate code for.
   * @return {String} The generated code snippet.
   */
  generateUV(e, t) {
    return t.build(e, "vec3");
  }
  /**
   * TODO.
   *
   * @param {Node<vec3>} uvNode - The uv node .
   * @return {Node<vec3>} TODO.
   */
  normal(e) {
    return XT({ texture: this, uv: e });
  }
}
const YT = /* @__PURE__ */ C(KT);
class jT {
  /**
   * Constructs a new animation loop management component.
   *
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */
  constructor(e, t) {
    this.nodes = e, this.info = t, this._context = self, this._animationLoop = null, this._requestId = null;
  }
  /**
   * Starts the internal animation loop.
   */
  start() {
    const e = (t, s) => {
      this._requestId = this._context.requestAnimationFrame(e), this.info.autoReset === !0 && this.info.reset(), this.nodes.nodeFrame.update(), this.info.frame = this.nodes.nodeFrame.frameId, this._animationLoop !== null && this._animationLoop(t, s);
    };
    e();
  }
  /**
   * Stops the internal animation loop.
   */
  stop() {
    this._context.cancelAnimationFrame(this._requestId), this._requestId = null;
  }
  /**
   * Defines the user-level animation loop.
   *
   * @param {Function} callback - The animation loop.
   */
  setAnimationLoop(e) {
    this._animationLoop = e;
  }
  /**
   * Defines the context in which `requestAnimationFrame()` is executed.
   *
   * @param {Window|XRSession} context - The context to set.
   */
  setContext(e) {
    this._context = e;
  }
  /**
   * Frees all internal resources and stops the animation loop.
   */
  dispose() {
    this.stop();
  }
}
class At {
  /**
   * Constructs a new chained map.
   */
  constructor() {
    this.weakMap = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Returns the value for the given array of keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @return {Any} The value. Returns `undefined` if no value was found.
   */
  get(e) {
    let t = this.weakMap;
    for (let s = 0; s < e.length; s++)
      if (t = t.get(e[s]), t === void 0) return;
    return t.get(e[e.length - 1]);
  }
  /**
   * Sets the value for the given keys.
   *
   * @param {Array<Object>} keys - List of keys.
   * @param {Any} value - The value to set.
   * @return {ChainMap} A reference to this chain map.
   */
  set(e, t) {
    let s = this.weakMap;
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      s.has(r) === !1 && s.set(r, /* @__PURE__ */ new WeakMap()), s = s.get(r);
    }
    return s.set(e[e.length - 1], t), this;
  }
  /**
   * Deletes a value for the given keys.
   *
   * @param {Array<Object>} keys - The keys.
   * @return {Boolean} Returns `true` if the value has been removed successfully and `false` if the value has not be found.
   */
  delete(e) {
    let t = this.weakMap;
    for (let s = 0; s < e.length; s++)
      if (t = t.get(e[s]), t === void 0) return !1;
    return t.delete(e[e.length - 1]);
  }
}
let QT = 0;
function ZT(o) {
  const e = Object.keys(o);
  let t = Object.getPrototypeOf(o);
  for (; t; ) {
    const s = Object.getOwnPropertyDescriptors(t);
    for (const n in s)
      if (s[n] !== void 0) {
        const r = s[n];
        r && typeof r.get == "function" && e.push(n);
      }
    t = Object.getPrototypeOf(t);
  }
  return e;
}
class JT {
  /**
   * Constructs a new render object.
   *
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Geometries} geometries - Renderer component for managing geometries.
   * @param {Renderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The 3D object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The lights node.
   * @param {RenderContext} renderContext - The render context.
   * @param {ClippingContext} clippingContext - The clipping context.
   */
  constructor(e, t, s, n, r, i, a, u, c, l) {
    this.id = QT++, this._nodes = e, this._geometries = t, this.renderer = s, this.object = n, this.material = r, this.scene = i, this.camera = a, this.lightsNode = u, this.context = c, this.geometry = n.geometry, this.version = r.version, this.drawRange = null, this.attributes = null, this.pipeline = null, this.vertexBuffers = null, this.drawParams = null, this.bundle = null, this.clippingContext = l, this.clippingContextCacheKey = l !== null ? l.cacheKey : "", this.initialNodesCacheKey = this.getDynamicCacheKey(), this.initialCacheKey = this.getCacheKey(), this._nodeBuilderState = null, this._bindings = null, this._monitor = null, this.onDispose = null, this.isRenderObject = !0, this.onMaterialDispose = () => {
      this.dispose();
    }, this.material.addEventListener("dispose", this.onMaterialDispose);
  }
  /**
   * Updates the clipping context.
   *
   * @param {ClippingContext} context - The clipping context to set.
   */
  updateClipping(e) {
    this.clippingContext = e;
  }
  /**
   * Whether the clipping requires an update or not.
   *
   * @type {Boolean}
   * @readonly
   */
  get clippingNeedsUpdate() {
    return this.clippingContext === null || this.clippingContext.cacheKey === this.clippingContextCacheKey ? !1 : (this.clippingContextCacheKey = this.clippingContext.cacheKey, !0);
  }
  /**
   * The number of clipping planes defined in context of hardware clipping.
   *
   * @type {Number}
   * @readonly
   */
  get hardwareClippingPlanes() {
    return this.material.hardwareClipping === !0 ? this.clippingContext.unionClippingCount : 0;
  }
  /**
   * Returns the node builder state of this render object.
   *
   * @return {NodeBuilderState} The node buider state.
   */
  getNodeBuilderState() {
    return this._nodeBuilderState || (this._nodeBuilderState = this._nodes.getForRender(this));
  }
  /**
   * Returns the node material observer of this render object.
   *
   * @return {NodeMaterialObserver} The node material observer.
   */
  getMonitor() {
    return this._monitor || (this._monitor = this.getNodeBuilderState().monitor);
  }
  /**
   * Returns an array of bind groups of this render object.
   *
   * @return {Array<BindGroup>} The bindings.
   */
  getBindings() {
    return this._bindings || (this._bindings = this.getNodeBuilderState().createBindings());
  }
  /**
   * Returns the index of the render object's geometry.
   *
   * @return {BufferAttribute?} The index. Returns `null` for non-indexed geometries.
   */
  getIndex() {
    return this._geometries.getIndex(this);
  }
  /**
   * Returns the indirect buffer attribute.
   *
   * @return {BufferAttribute?} The indirect attribute. `null` if no indirect drawing is used.
   */
  getIndirect() {
    return this._geometries.getIndirect(this);
  }
  /**
   * Returns an array that acts as a key for identifying the render object in a chain map.
   *
   * @return {Array<Object>} An array with object references.
   */
  getChainArray() {
    return [this.object, this.material, this.context, this.lightsNode];
  }
  /**
   * This method is used when the geometry of a 3D object has been exchanged and the
   * respective render object now requires an update.
   *
   * @param {BufferGeometry} geometry - The geometry to set.
   */
  setGeometry(e) {
    this.geometry = e, this.attributes = null;
  }
  /**
   * Returns the buffer attributes of the render object. The returned array holds
   * attribute definitions on geometry and node level.
   *
   * @return {Array<BufferAttribute>} An array with buffer attributes.
   */
  getAttributes() {
    if (this.attributes !== null) return this.attributes;
    const e = this.getNodeBuilderState().nodeAttributes, t = this.geometry, s = [], n = /* @__PURE__ */ new Set();
    for (const r of e) {
      const i = r.node && r.node.attribute ? r.node.attribute : t.getAttribute(r.name);
      if (i === void 0) continue;
      s.push(i);
      const a = i.isInterleavedBufferAttribute ? i.data : i;
      n.add(a);
    }
    return this.attributes = s, this.vertexBuffers = Array.from(n.values()), s;
  }
  /**
   * Returns the vertex buffers of the render object.
   *
   * @return {Array<BufferAttribute|InterleavedBuffer>} An array with buffer attribute or interleaved buffers.
   */
  getVertexBuffers() {
    return this.vertexBuffers === null && this.getAttributes(), this.vertexBuffers;
  }
  /**
   * Returns the draw parameters for the render object.
   *
   * @return {{vertexCount: Number, firstVertex: Number, instanceCount: Number, firstInstance: Number}} The draw parameters.
   */
  getDrawParameters() {
    const { object: e, material: t, geometry: s, group: n, drawRange: r } = this, i = this.drawParams || (this.drawParams = {
      vertexCount: 0,
      firstVertex: 0,
      instanceCount: 0,
      firstInstance: 0
    }), a = this.getIndex(), u = a !== null, c = s.isInstancedBufferGeometry ? s.instanceCount : e.count > 1 ? e.count : 1;
    if (c === 0) return null;
    if (i.instanceCount = c, e.isBatchedMesh === !0) return i;
    let l = 1;
    t.wireframe === !0 && !e.isPoints && !e.isLineSegments && !e.isLine && !e.isLineLoop && (l = 2);
    let d = r.start * l, h = (r.start + r.count) * l;
    n !== null && (d = Math.max(d, n.start * l), h = Math.min(h, (n.start + n.count) * l));
    const p = s.attributes.position;
    let f = 1 / 0;
    u ? f = a.count : p != null && (f = p.count), d = Math.max(d, 0), h = Math.min(h, f);
    const m = h - d;
    return m < 0 || m === 1 / 0 ? null : (i.vertexCount = m, i.firstVertex = d, i);
  }
  /**
   * Returns the render object's geometry cache key.
   *
   * The geometry cache key is part of the material cache key.
   *
   * @return {String} The geometry cache key.
   */
  getGeometryCacheKey() {
    const { geometry: e } = this;
    let t = "";
    for (const s of Object.keys(e.attributes).sort()) {
      const n = e.attributes[s];
      t += s + ",", n.data && (t += n.data.stride + ","), n.offset && (t += n.offset + ","), n.itemSize && (t += n.itemSize + ","), n.normalized && (t += "n,");
    }
    return e.index && (t += "index,"), t;
  }
  /**
   * Returns the render object's material cache key.
   *
   * The material cache key is part of the render object cache key.
   *
   * @return {String} The material cache key.
   */
  getMaterialCacheKey() {
    const { object: e, material: t } = this;
    let s = t.customProgramCacheKey();
    for (const n of ZT(t)) {
      if (/^(is[A-Z]|_)|^(visible|version|uuid|name|opacity|userData)$/.test(n)) continue;
      const r = t[n];
      let i;
      if (r !== null) {
        const a = typeof r;
        a === "number" ? i = r !== 0 ? "1" : "0" : a === "object" ? (i = "{", r.isTexture && (i += r.mapping), i += "}") : i = String(r);
      } else
        i = String(r);
      s += /*property + ':' +*/
      i + ",";
    }
    return s += this.clippingContextCacheKey + ",", e.geometry && (s += this.getGeometryCacheKey()), e.skeleton && (s += e.skeleton.bones.length + ","), e.morphTargetInfluences && (s += e.morphTargetInfluences.length + ","), e.isBatchedMesh && (s += e._matricesTexture.uuid + ",", e._colorsTexture !== null && (s += e._colorsTexture.uuid + ",")), e.count > 1 && (s += e.uuid + ","), s += e.receiveShadow + ",", wl(s);
  }
  /**
   * Whether the geometry requires an update or not.
   *
   * @type {Boolean}
   * @readonly
   */
  get needsGeometryUpdate() {
    return this.geometry.id !== this.object.geometry.id;
  }
  /**
   * Whether the render object requires an update or not.
   *
   * Note: There are two distinct places where render objects are checked for an update.
   *
   * 1. In `RenderObjects.get()` which is executed when the render object is request. This
   * method checks the `needsUpdate` flag and recreates the render object if necessary.
   * 2. In `Renderer._renderObjectDirect()` right after getting the render object via
   * `RenderObjects.get()`. The render object's NodeMaterialObserver is then used to detect
   * a need for a refresh due to material, geometry or object related value changes.
   *
   * TODO: Investigate if it's possible to merge boths steps so there is only a single place
   * that performs the 'needsUpdate' check.
   *
   * @type {Boolean}
   * @readonly
   */
  get needsUpdate() {
    return (
      /*this.object.static !== true &&*/
      this.initialNodesCacheKey !== this.getDynamicCacheKey() || this.clippingNeedsUpdate
    );
  }
  /**
   * Returns the dynamic cache key which represents a key that is computed per draw command.
   *
   * @return {String} The cache key.
   */
  getDynamicCacheKey() {
    let e = this._nodes.getCacheKey(this.scene, this.lightsNode);
    return this.object.receiveShadow && (e += 1), e;
  }
  /**
   * Returns the render object's cache key.
   *
   * @return {String} The cache key.
   */
  getCacheKey() {
    return this.getMaterialCacheKey() + this.getDynamicCacheKey();
  }
  /**
   * Frees internal resources.
   */
  dispose() {
    this.material.removeEventListener("dispose", this.onMaterialDispose), this.onDispose();
  }
}
const As = [];
class e_ {
  /**
   * Constructs a new render object management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Geometries} geometries - Renderer component for managing geometries.
   * @param {Pipelines} pipelines - Renderer component for managing pipelines.
   * @param {Bindings} bindings - Renderer component for managing bindings.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */
  constructor(e, t, s, n, r, i) {
    this.renderer = e, this.nodes = t, this.geometries = s, this.pipelines = n, this.bindings = r, this.info = i, this.chainMaps = {};
  }
  /**
   * Returns a render object for the given object and state data.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The 3D object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the 3D object should be rendered with.
   * @param {LightsNode} lightsNode - The lights node.
   * @param {RenderContext} renderContext - The render context.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {String?} passId - An optional ID for identifying the pass.
   * @return {RenderObject} The render object.
   */
  get(e, t, s, n, r, i, a, u) {
    const c = this.getChainMap(u);
    As[0] = e, As[1] = t, As[2] = i, As[3] = r;
    let l = c.get(As);
    return l === void 0 ? (l = this.createRenderObject(this.nodes, this.geometries, this.renderer, e, t, s, n, r, i, a, u), c.set(As, l)) : (l.updateClipping(a), l.needsGeometryUpdate && l.setGeometry(e.geometry), (l.version !== t.version || l.needsUpdate) && (l.initialCacheKey !== l.getCacheKey() ? (l.dispose(), l = this.get(e, t, s, n, r, i, a, u)) : l.version = t.version)), l;
  }
  /**
   * Returns a chain map for the given pass ID.
   *
   * @param {String} [passId='default'] - The pass ID.
   * @return {ChainMap} The chain map.
   */
  getChainMap(e = "default") {
    return this.chainMaps[e] || (this.chainMaps[e] = new At());
  }
  /**
   * Frees internal resources.
   */
  dispose() {
    this.chainMaps = {};
  }
  /**
   * Factory method for creating render objects with the given list of parameters.
   *
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Geometries} geometries - Renderer component for managing geometries.
   * @param {Renderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The lights node.
   * @param {RenderContext} renderContext - The render context.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {String?} passId - An optional ID for identifying the pass.
   * @return {RenderObject} The render object.
   */
  createRenderObject(e, t, s, n, r, i, a, u, c, l, d) {
    const h = this.getChainMap(d), p = new JT(e, t, s, n, r, i, a, u, c, l);
    return p.onDispose = () => {
      this.pipelines.delete(p), this.bindings.delete(p), this.nodes.delete(p), h.delete(p.getChainArray());
    }, p;
  }
}
class Jt {
  /**
   * Constructs a new data map.
   */
  constructor() {
    this.data = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Returns the dictionary for the given object.
   *
   * @param {Object} object - The object.
   * @return {Object} The dictionary.
   */
  get(e) {
    let t = this.data.get(e);
    return t === void 0 && (t = {}, this.data.set(e, t)), t;
  }
  /**
   * Deletes the dictionary for the given object.
   *
   * @param {Object} object - The object.
   * @return {Object?} The deleted dictionary.
   */
  delete(e) {
    let t = null;
    return this.data.has(e) && (t = this.data.get(e), this.data.delete(e)), t;
  }
  /**
   * Returns `true` if the given object has a dictionary defined.
   *
   * @param {Object} object - The object to test.
   * @return {Boolean} Whether a dictionary is defined or not.
   */
  has(e) {
    return this.data.has(e);
  }
  /**
   * Frees internal resources.
   */
  dispose() {
    this.data = /* @__PURE__ */ new WeakMap();
  }
}
const gt = {
  VERTEX: 1,
  INDEX: 2,
  STORAGE: 3,
  INDIRECT: 4
}, Kt = 16, t_ = 211, s_ = 212;
class n_ extends Jt {
  /**
   * Constructs a new attribute management component.
   *
   * @param {Backend} backend - The renderer's backend.
   */
  constructor(e) {
    super(), this.backend = e;
  }
  /**
   * Deletes the data for the given attribute.
   *
   * @param {BufferAttribute} attribute - The attribute.
   * @return {Object} The deleted attribute data.
   */
  delete(e) {
    const t = super.delete(e);
    return t !== void 0 && this.backend.destroyAttribute(e), t;
  }
  /**
   * Updates the given attribute. This method creates attribute buffers
   * for new attributes and updates data for existing ones.
   *
   * @param {BufferAttribute} attribute - The attribute to update.
   * @param {Number} type - The attribute type.
   */
  update(e, t) {
    const s = this.get(e);
    if (s.version === void 0)
      t === gt.VERTEX ? this.backend.createAttribute(e) : t === gt.INDEX ? this.backend.createIndexAttribute(e) : t === gt.STORAGE ? this.backend.createStorageAttribute(e) : t === gt.INDIRECT && this.backend.createIndirectStorageAttribute(e), s.version = this._getBufferAttribute(e).version;
    else {
      const n = this._getBufferAttribute(e);
      (s.version < n.version || n.usage === Is) && (this.backend.updateAttribute(e), s.version = n.version);
    }
  }
  /**
   * Utility method for handling interleaved buffer attributes correctly.
   * To process them, their `InterleavedBuffer` is returned.
   *
   * @param {BufferAttribute} attribute - The attribute.
   * @return {BufferAttribute|InterleavedBuffer}
   */
  _getBufferAttribute(e) {
    return e.isInterleavedBufferAttribute && (e = e.data), e;
  }
}
function r_(o) {
  for (let e = o.length - 1; e >= 0; --e)
    if (o[e] >= 65535) return !0;
  return !1;
}
function Yp(o) {
  return o.index !== null ? o.index.version : o.attributes.position.version;
}
function oc(o) {
  const e = [], t = o.index, s = o.attributes.position;
  if (t !== null) {
    const r = t.array;
    for (let i = 0, a = r.length; i < a; i += 3) {
      const u = r[i + 0], c = r[i + 1], l = r[i + 2];
      e.push(u, c, c, l, l, u);
    }
  } else {
    const r = s.array;
    for (let i = 0, a = r.length / 3 - 1; i < a; i += 3) {
      const u = i + 0, c = i + 1, l = i + 2;
      e.push(u, c, c, l, l, u);
    }
  }
  const n = new (r_(e) ? Zg : Jg)(e, 1);
  return n.version = Yp(o), n;
}
class i_ extends Jt {
  /**
   * Constructs a new geometry management component.
   *
   * @param {Attributes} attributes - Renderer component for managing attributes.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */
  constructor(e, t) {
    super(), this.attributes = e, this.info = t, this.wireframes = /* @__PURE__ */ new WeakMap(), this.attributeCall = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Returns `true` if the given render object has an initialized geometry.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether if the given render object has an initialized geometry or not.
   */
  has(e) {
    const t = e.geometry;
    return super.has(t) && this.get(t).initialized === !0;
  }
  /**
   * Prepares the geometry of the given render object for rendering.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateForRender(e) {
    this.has(e) === !1 && this.initGeometry(e), this.updateAttributes(e);
  }
  /**
   * Initializes the geometry of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  initGeometry(e) {
    const t = e.geometry, s = this.get(t);
    s.initialized = !0, this.info.memory.geometries++;
    const n = () => {
      this.info.memory.geometries--;
      const r = t.index, i = e.getAttributes();
      r !== null && this.attributes.delete(r);
      for (const u of i)
        this.attributes.delete(u);
      const a = this.wireframes.get(t);
      a !== void 0 && this.attributes.delete(a), t.removeEventListener("dispose", n);
    };
    t.addEventListener("dispose", n);
  }
  /**
   * Updates the geometry attributes of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateAttributes(e) {
    const t = e.getAttributes();
    for (const r of t)
      r.isStorageBufferAttribute || r.isStorageInstancedBufferAttribute ? this.updateAttribute(r, gt.STORAGE) : this.updateAttribute(r, gt.VERTEX);
    const s = this.getIndex(e);
    s !== null && this.updateAttribute(s, gt.INDEX);
    const n = e.geometry.indirect;
    n !== null && this.updateAttribute(n, gt.INDIRECT);
  }
  /**
   * Updates the given attribute.
   *
   * @param {BufferAttribute} attribute - The attribute to update.
   * @param {Number} type - The attribute type.
   */
  updateAttribute(e, t) {
    const s = this.info.render.calls;
    e.isInterleavedBufferAttribute ? this.attributeCall.get(e) === void 0 ? (this.attributes.update(e, t), this.attributeCall.set(e, s)) : this.attributeCall.get(e.data) !== s && (this.attributes.update(e, t), this.attributeCall.set(e.data, s), this.attributeCall.set(e, s)) : this.attributeCall.get(e) !== s && (this.attributes.update(e, t), this.attributeCall.set(e, s));
  }
  /**
   * Returns the indirect buffer attribute of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {BufferAttribute?} The indirect attribute. `null` if no indirect drawing is used.
   */
  getIndirect(e) {
    return e.geometry.indirect;
  }
  /**
   * Returns the index of the given render object's geometry. This is implemented
   * in a method to return a wireframe index if necessary.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {BufferAttribute?} The index. Returns `null` for non-indexed geometries.
   */
  getIndex(e) {
    const { geometry: t, material: s } = e;
    let n = t.index;
    if (s.wireframe === !0) {
      const r = this.wireframes;
      let i = r.get(t);
      i === void 0 ? (i = oc(t), r.set(t, i)) : i.version !== Yp(t) && (this.attributes.delete(i), i = oc(t), r.set(t, i)), n = i;
    }
    return n;
  }
}
class o_ {
  /**
   * Constructs a new info component.
   */
  constructor() {
    this.autoReset = !0, this.frame = 0, this.calls = 0, this.render = {
      calls: 0,
      frameCalls: 0,
      drawCalls: 0,
      triangles: 0,
      points: 0,
      lines: 0,
      timestamp: 0,
      previousFrameCalls: 0,
      timestampCalls: 0
    }, this.compute = {
      calls: 0,
      frameCalls: 0,
      timestamp: 0,
      previousFrameCalls: 0,
      timestampCalls: 0
    }, this.memory = {
      geometries: 0,
      textures: 0
    };
  }
  /**
   * This method should be executed per draw call and updates the corresponding metrics.
   *
   * @param {Object3D} object - The 3D object that is going to be rendered.
   * @param {Number} count - The vertex or index count.
   * @param {Number} instanceCount - The instance count.
   */
  update(e, t, s) {
    this.render.drawCalls++, e.isMesh || e.isSprite ? this.render.triangles += s * (t / 3) : e.isPoints ? this.render.points += s * t : e.isLineSegments ? this.render.lines += s * (t / 2) : e.isLine ? this.render.lines += s * (t - 1) : console.error("THREE.WebGPUInfo: Unknown object type.");
  }
  /**
   * Used by async render methods to updated timestamp metrics.
   *
   * @param {('render'|'compute')} type - The type of render call.
   * @param {Number} time - The duration of the compute/render call in milliseconds.
   */
  updateTimestamp(e, t) {
    this[e].timestampCalls === 0 && (this[e].timestamp = 0), this[e].timestamp += t, this[e].timestampCalls++, this[e].timestampCalls >= this[e].previousFrameCalls && (this[e].timestampCalls = 0);
  }
  /**
   * Resets frame related metrics.
   */
  reset() {
    const e = this.render.frameCalls;
    this.render.previousFrameCalls = e;
    const t = this.compute.frameCalls;
    this.compute.previousFrameCalls = t, this.render.drawCalls = 0, this.render.frameCalls = 0, this.compute.frameCalls = 0, this.render.triangles = 0, this.render.points = 0, this.render.lines = 0;
  }
  /**
   * Performs a complete reset of the object.
   */
  dispose() {
    this.reset(), this.calls = 0, this.render.calls = 0, this.compute.calls = 0, this.render.timestamp = 0, this.compute.timestamp = 0, this.memory.geometries = 0, this.memory.textures = 0;
  }
}
class jp {
  /**
   * Constructs a new pipeline.
   *
   * @param {String} cacheKey - The pipeline's cache key.
   */
  constructor(e) {
    this.cacheKey = e, this.usedTimes = 0;
  }
}
class a_ extends jp {
  /**
   * Constructs a new render pipeline.
   *
   * @param {String} cacheKey - The pipeline's cache key.
   * @param {ProgrammableStage} vertexProgram - The pipeline's vertex shader.
   * @param {ProgrammableStage} fragmentProgram - The pipeline's fragment shader.
   */
  constructor(e, t, s) {
    super(e), this.vertexProgram = t, this.fragmentProgram = s;
  }
}
class u_ extends jp {
  /**
   * Constructs a new render pipeline.
   *
   * @param {String} cacheKey - The pipeline's cache key.
   * @param {ProgrammableStage} computeProgram - The pipeline's compute shader.
   */
  constructor(e, t) {
    super(e), this.computeProgram = t, this.isComputePipeline = !0;
  }
}
let c_ = 0;
class Oi {
  /**
   * Constructs a new programmable stage.
   *
   * @param {String} code - The shader code.
   * @param {('vertex'|'fragment'|'compute')} stage - The type of stage.
   * @param {String} name - The name of the shader.
   * @param {Array<Object>?} [transforms=null] - The transforms (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
   * @param {Array<Object>?} [attributes=null] - The attributes (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
   */
  constructor(e, t, s, n = null, r = null) {
    this.id = c_++, this.code = e, this.stage = t, this.name = s, this.transforms = n, this.attributes = r, this.usedTimes = 0;
  }
}
class l_ extends Jt {
  /**
   * Constructs a new pipeline management component.
   *
   * @param {Backend} backend - The renderer's backend.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   */
  constructor(e, t) {
    super(), this.backend = e, this.nodes = t, this.bindings = null, this.caches = /* @__PURE__ */ new Map(), this.programs = {
      vertex: /* @__PURE__ */ new Map(),
      fragment: /* @__PURE__ */ new Map(),
      compute: /* @__PURE__ */ new Map()
    };
  }
  /**
   * Returns a compute pipeline for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @return {ComputePipeline} The compute pipeline.
   */
  getForCompute(e, t) {
    const { backend: s } = this, n = this.get(e);
    if (this._needsComputeUpdate(e)) {
      const r = n.pipeline;
      r && (r.usedTimes--, r.computeProgram.usedTimes--);
      const i = this.nodes.getForCompute(e);
      let a = this.programs.compute.get(i.computeShader);
      a === void 0 && (r && r.computeProgram.usedTimes === 0 && this._releaseProgram(r.computeProgram), a = new Oi(i.computeShader, "compute", e.name, i.transforms, i.nodeAttributes), this.programs.compute.set(i.computeShader, a), s.createProgram(a));
      const u = this._getComputeCacheKey(e, a);
      let c = this.caches.get(u);
      c === void 0 && (r && r.usedTimes === 0 && this._releasePipeline(r), c = this._getComputePipeline(e, a, u, t)), c.usedTimes++, a.usedTimes++, n.version = e.version, n.pipeline = c;
    }
    return n.pipeline;
  }
  /**
   * Returns a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>?} [promises=null] - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
   * @return {RenderPipeline} The render pipeline.
   */
  getForRender(e, t = null) {
    const { backend: s } = this, n = this.get(e);
    if (this._needsRenderUpdate(e)) {
      const r = n.pipeline;
      r && (r.usedTimes--, r.vertexProgram.usedTimes--, r.fragmentProgram.usedTimes--);
      const i = e.getNodeBuilderState(), a = e.material ? e.material.name : "";
      let u = this.programs.vertex.get(i.vertexShader);
      u === void 0 && (r && r.vertexProgram.usedTimes === 0 && this._releaseProgram(r.vertexProgram), u = new Oi(i.vertexShader, "vertex", a), this.programs.vertex.set(i.vertexShader, u), s.createProgram(u));
      let c = this.programs.fragment.get(i.fragmentShader);
      c === void 0 && (r && r.fragmentProgram.usedTimes === 0 && this._releaseProgram(r.fragmentProgram), c = new Oi(i.fragmentShader, "fragment", a), this.programs.fragment.set(i.fragmentShader, c), s.createProgram(c));
      const l = this._getRenderCacheKey(e, u, c);
      let d = this.caches.get(l);
      d === void 0 ? (r && r.usedTimes === 0 && this._releasePipeline(r), d = this._getRenderPipeline(e, u, c, l, t)) : e.pipeline = d, d.usedTimes++, u.usedTimes++, c.usedTimes++, n.pipeline = d;
    }
    return n.pipeline;
  }
  /**
   * Deletes the pipeline for the given render object.
   *
   * @param {RenderObject} object - The render object.
   * @return {Object?} The deleted dictionary.
   */
  delete(e) {
    const t = this.get(e).pipeline;
    return t && (t.usedTimes--, t.usedTimes === 0 && this._releasePipeline(t), t.isComputePipeline ? (t.computeProgram.usedTimes--, t.computeProgram.usedTimes === 0 && this._releaseProgram(t.computeProgram)) : (t.fragmentProgram.usedTimes--, t.vertexProgram.usedTimes--, t.vertexProgram.usedTimes === 0 && this._releaseProgram(t.vertexProgram), t.fragmentProgram.usedTimes === 0 && this._releaseProgram(t.fragmentProgram))), super.delete(e);
  }
  /**
   * Frees internal resources.
   */
  dispose() {
    super.dispose(), this.caches = /* @__PURE__ */ new Map(), this.programs = {
      vertex: /* @__PURE__ */ new Map(),
      fragment: /* @__PURE__ */ new Map(),
      compute: /* @__PURE__ */ new Map()
    };
  }
  /**
   * Updates the pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateForRender(e) {
    this.getForRender(e);
  }
  /**
   * Returns a compute pipeline for the given parameters.
   *
   * @private
   * @param {Node} computeNode - The compute node.
   * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
   * @param {String} cacheKey - The cache key.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @return {ComputePipeline} The compute pipeline.
   */
  _getComputePipeline(e, t, s, n) {
    s = s || this._getComputeCacheKey(e, t);
    let r = this.caches.get(s);
    return r === void 0 && (r = new u_(s, t), this.caches.set(s, r), this.backend.createComputePipeline(r, n)), r;
  }
  /**
   * Returns a render pipeline for the given parameters.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
   * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
   * @param {String} cacheKey - The cache key.
   * @param {Array} promises - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
   * @return {ComputePipeline} The compute pipeline.
   */
  _getRenderPipeline(e, t, s, n, r) {
    n = n || this._getRenderCacheKey(e, t, s);
    let i = this.caches.get(n);
    return i === void 0 && (i = new a_(n, t, s), this.caches.set(n, i), e.pipeline = i, this.backend.createRenderPipeline(e, r)), i;
  }
  /**
   * Computes a cache key representing a compute pipeline.
   *
   * @private
   * @param {Node} computeNode - The compute node.
   * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
   * @return {String} The cache key.
   */
  _getComputeCacheKey(e, t) {
    return e.id + "," + t.id;
  }
  /**
   * Computes a cache key representing a render pipeline.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
   * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
   * @return {String} The cache key.
   */
  _getRenderCacheKey(e, t, s) {
    return t.id + "," + s.id + "," + this.backend.getRenderCacheKey(e);
  }
  /**
   * Releases the given pipeline.
   *
   * @private
   * @param {Pipeline} pipeline - The pipeline to release.
   */
  _releasePipeline(e) {
    this.caches.delete(e.cacheKey);
  }
  /**
   * Releases the shader program.
   *
   * @private
   * @param {Object} program - The shdaer program to release.
   */
  _releaseProgram(e) {
    const t = e.code, s = e.stage;
    this.programs[s].delete(t);
  }
  /**
   * Returns `true` if the compute pipeline for the given compute node requires an update.
   *
   * @private
   * @param {Node} computeNode - The compute node.
   * @return {Boolean} Whether the compute pipeline for the given compute node requires an update or not.
   */
  _needsComputeUpdate(e) {
    const t = this.get(e);
    return t.pipeline === void 0 || t.version !== e.version;
  }
  /**
   * Returns `true` if the render pipeline for the given render object requires an update.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the render object for the given render object requires an update or not.
   */
  _needsRenderUpdate(e) {
    return this.get(e).pipeline === void 0 || this.backend.needsRenderUpdate(e);
  }
}
class d_ extends Jt {
  /**
   * Constructs a new bindings management component.
   *
   * @param {Backend} backend - The renderer's backend.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   * @param {Textures} textures - Renderer component for managing textures.
   * @param {Attributes} attributes - Renderer component for managing attributes.
   * @param {Pipelines} pipelines - Renderer component for managing pipelines.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */
  constructor(e, t, s, n, r, i) {
    super(), this.backend = e, this.textures = s, this.pipelines = r, this.attributes = n, this.nodes = t, this.info = i, this.pipelines.bindings = this;
  }
  /**
   * Returns the bind groups for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Array<BindGroup>} The bind groups.
   */
  getForRender(e) {
    const t = e.getBindings();
    for (const s of t) {
      const n = this.get(s);
      n.bindGroup === void 0 && (this._init(s), this.backend.createBindings(s, t, 0), n.bindGroup = s);
    }
    return t;
  }
  /**
   * Returns the bind groups for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   * @return {Array<BindGroup>} The bind groups.
   */
  getForCompute(e) {
    const t = this.nodes.getForCompute(e).bindings;
    for (const s of t) {
      const n = this.get(s);
      n.bindGroup === void 0 && (this._init(s), this.backend.createBindings(s, t, 0), n.bindGroup = s);
    }
    return t;
  }
  /**
   * Updates the bindings for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   */
  updateForCompute(e) {
    this._updateBindings(this.getForCompute(e));
  }
  /**
   * Updates the bindings for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateForRender(e) {
    this._updateBindings(this.getForRender(e));
  }
  /**
   * Updates the given array of bindings.
   *
   * @param {Array<BindGroup>} bindings - The bind groups.
   */
  _updateBindings(e) {
    for (const t of e)
      this._update(t, e);
  }
  /**
   * Initializes the given bind group.
   *
   * @param {BindGroup} bindGroup - The bind group to initialize.
   */
  _init(e) {
    for (const t of e.bindings)
      if (t.isSampledTexture)
        this.textures.updateTexture(t.texture);
      else if (t.isStorageBuffer) {
        const s = t.attribute, n = s.isIndirectStorageBufferAttribute ? gt.INDIRECT : gt.STORAGE;
        this.attributes.update(s, n);
      }
  }
  /**
   * Updates the given bind group.
   *
   * @param {BindGroup} bindGroup - The bind group to update.
   * @param {Array<BindGroup>} bindings - The bind groups.
   */
  _update(e, t) {
    const { backend: s } = this;
    let n = !1, r = !0, i = 0, a = 0;
    for (const u of e.bindings)
      if (!(u.isNodeUniformsGroup && this.nodes.updateGroup(u) === !1)) {
        if (u.isUniformBuffer)
          u.update() && s.updateBinding(u);
        else if (u.isSampler)
          u.update();
        else if (u.isSampledTexture) {
          const c = this.textures.get(u.texture);
          u.needsBindingsUpdate(c.generation) && (n = !0);
          const l = u.update(), d = u.texture;
          l && this.textures.updateTexture(d);
          const h = s.get(d);
          if (h.externalTexture !== void 0 || c.isDefaultTexture ? r = !1 : (i = i * 10 + d.id, a += d.version), s.isWebGPUBackend === !0 && h.texture === void 0 && h.externalTexture === void 0 && (console.error("Bindings._update: binding should be available:", u, l, d, u.textureNode.value, n), this.textures.updateTexture(d), n = !0), d.isStorageTexture === !0) {
            const p = this.get(d);
            u.store === !0 ? p.needsMipmap = !0 : this.textures.needsMipmaps(d) && p.needsMipmap === !0 && (this.backend.generateMipmaps(d), p.needsMipmap = !1);
          }
        }
      }
    n === !0 && this.backend.updateBindings(e, t, r ? i : 0, a);
  }
}
function h_(o, e) {
  return o.groupOrder !== e.groupOrder ? o.groupOrder - e.groupOrder : o.renderOrder !== e.renderOrder ? o.renderOrder - e.renderOrder : o.material.id !== e.material.id ? o.material.id - e.material.id : o.z !== e.z ? o.z - e.z : o.id - e.id;
}
function ac(o, e) {
  return o.groupOrder !== e.groupOrder ? o.groupOrder - e.groupOrder : o.renderOrder !== e.renderOrder ? o.renderOrder - e.renderOrder : o.z !== e.z ? e.z - o.z : o.id - e.id;
}
function uc(o) {
  return (o.transmission > 0 || o.transmissionNode) && o.side === Ws && o.forceSinglePass === !1;
}
class p_ {
  /**
   * Constructs a render list.
   *
   * @param {Lighting} lighting - The lighting management component.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera the scene is rendered with.
   */
  constructor(e, t, s) {
    this.renderItems = [], this.renderItemsIndex = 0, this.opaque = [], this.transparentDoublePass = [], this.transparent = [], this.bundles = [], this.lightsNode = e.getNode(t, s), this.lightsArray = [], this.scene = t, this.camera = s, this.occlusionQueryCount = 0;
  }
  /**
   * This method is called right at the beginning of a render call
   * before the scene is analyzed. It prepares the internal data
   * structures for the upcoming render lists generation.
   *
   * @return {RenderList} A reference to this render list.
   */
  begin() {
    return this.renderItemsIndex = 0, this.opaque.length = 0, this.transparentDoublePass.length = 0, this.transparent.length = 0, this.bundles.length = 0, this.lightsArray.length = 0, this.occlusionQueryCount = 0, this;
  }
  /**
   * Returns a render item for the giving render item state. The state is defined
   * by a series of object-related parameters.
   *
   * The method avoids object creation by holding render items and reusing them in
   * subsequent render calls (just with different property values).
   *
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Number} groupOrder - The current group order.
   * @param {Number} z - Th 3D object's depth value (z value in clip space).
   * @param {Number?} group - {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The current clipping context.
   * @return {Object} The render item.
   */
  getNextRenderItem(e, t, s, n, r, i, a) {
    let u = this.renderItems[this.renderItemsIndex];
    return u === void 0 ? (u = {
      id: e.id,
      object: e,
      geometry: t,
      material: s,
      groupOrder: n,
      renderOrder: e.renderOrder,
      z: r,
      group: i,
      clippingContext: a
    }, this.renderItems[this.renderItemsIndex] = u) : (u.id = e.id, u.object = e, u.geometry = t, u.material = s, u.groupOrder = n, u.renderOrder = e.renderOrder, u.z = r, u.group = i, u.clippingContext = a), this.renderItemsIndex++, u;
  }
  /**
   * Pushes the given object as a render item to the internal render lists.
   * The selected lists depend on the object properties.
   *
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Number} groupOrder - The current group order.
   * @param {Number} z - Th 3D object's depth value (z value in clip space).
   * @param {Number?} group - {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The current clipping context.
   */
  push(e, t, s, n, r, i, a) {
    const u = this.getNextRenderItem(e, t, s, n, r, i, a);
    e.occlusionTest === !0 && this.occlusionQueryCount++, s.transparent === !0 || s.transmission > 0 ? (uc(s) && this.transparentDoublePass.push(u), this.transparent.push(u)) : this.opaque.push(u);
  }
  /**
   * Inserts the given object as a render item at the start of the internal render lists.
   * The selected lists depend on the object properties.
   *
   * @param {Object3D} object - The 3D object.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Number} groupOrder - The current group order.
   * @param {Number} z - Th 3D object's depth value (z value in clip space).
   * @param {Number?} group - {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The current clipping context.
   */
  unshift(e, t, s, n, r, i, a) {
    const u = this.getNextRenderItem(e, t, s, n, r, i, a);
    s.transparent === !0 || s.transmission > 0 ? (uc(s) && this.transparentDoublePass.unshift(u), this.transparent.unshift(u)) : this.opaque.unshift(u);
  }
  /**
   * Pushes render bundle group data into the render list.
   *
   * @param {Object} group - Bundle group data.
   */
  pushBundle(e) {
    this.bundles.push(e);
  }
  /**
   * Pushes a light into the render list.
   *
   * @param {Light} light - The light.
   */
  pushLight(e) {
    this.lightsArray.push(e);
  }
  /**
   * Sorts the internal render lists.
   *
   * @param {Function} customOpaqueSort - A custom sort function for opaque objects.
   * @param {Function} customTransparentSort -  A custom sort function for transparent objects.
   */
  sort(e, t) {
    this.opaque.length > 1 && this.opaque.sort(e || h_), this.transparentDoublePass.length > 1 && this.transparentDoublePass.sort(t || ac), this.transparent.length > 1 && this.transparent.sort(t || ac);
  }
  /**
   * This method performs finalizing tasks right after the render lists
   * have been generated.
   */
  finish() {
    this.lightsNode.setLights(this.lightsArray);
    for (let e = this.renderItemsIndex, t = this.renderItems.length; e < t; e++) {
      const s = this.renderItems[e];
      if (s.id === null) break;
      s.id = null, s.object = null, s.geometry = null, s.material = null, s.groupOrder = null, s.renderOrder = null, s.z = null, s.group = null, s.clippingContext = null;
    }
  }
}
class f_ {
  /**
   * Constructs a render lists management component.
   *
   * @param {Lighting} lighting - The lighting management component.
   */
  constructor(e) {
    this.lighting = e, this.lists = new At();
  }
  /**
   * Returns a render list for the given scene and camera.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera.
   * @return {RenderList} The render list.
   */
  get(e, t) {
    const s = this.lists, n = [e, t];
    let r = s.get(n);
    return r === void 0 && (r = new p_(this.lighting, e, t), s.set(n, r)), r;
  }
  /**
   * Frees all internal resources.
   */
  dispose() {
    this.lists = new At();
  }
}
let g_ = 0;
class m_ {
  /**
   * Constructs a new render context.
   */
  constructor() {
    this.id = g_++, this.color = !0, this.clearColor = !0, this.clearColorValue = { r: 0, g: 0, b: 0, a: 1 }, this.depth = !0, this.clearDepth = !0, this.clearDepthValue = 1, this.stencil = !1, this.clearStencil = !0, this.clearStencilValue = 1, this.viewport = !1, this.viewportValue = new Ce(), this.scissor = !1, this.scissorValue = new Ce(), this.textures = null, this.depthTexture = null, this.activeCubeFace = 0, this.sampleCount = 1, this.width = 0, this.height = 0, this.isRenderContext = !0;
  }
  /**
   * Returns the cache key of this render context.
   *
   * @return {Number} The cache key.
   */
  getCacheKey() {
    return Qp(this);
  }
}
function Qp(o) {
  const { textures: e, activeCubeFace: t } = o, s = [t];
  for (const n of e)
    s.push(n.id);
  return ni(s);
}
class y_ {
  /**
   * Constructs a new render context management component.
   */
  constructor() {
    this.chainMaps = {};
  }
  /**
   * Returns a render context for the given scene, camera and render target.
   *
   * @param {Scene?} [scene=null] - The scene. The parameter can become `null` e.g. when the renderer clears a render target.
   * @param {Camera?} [camera=null] - The camera that is used to render the scene. The parameter can become `null` e.g. when the renderer clears a render target.
   * @param {RenderTarget?} [renderTarget=null] - The active render target.
   * @return {RenderContext} The render context.
   */
  get(e = null, t = null, s = null) {
    const n = [];
    e !== null && n.push(e), t !== null && n.push(t), n.length === 0 && n.push({ id: "default" });
    let r;
    if (s === null)
      r = "default";
    else {
      const u = s.texture.format;
      r = `${s.textures.length}:${u}:${s.samples}:${s.depthBuffer}:${s.stencilBuffer}`;
    }
    const i = this.getChainMap(r);
    let a = i.get(n);
    return a === void 0 && (a = new m_(), i.set(n, a)), s !== null && (a.sampleCount = s.samples === 0 ? 1 : s.samples), a;
  }
  /**
   * Returns a chain map for the given attachment state.
   *
   * @param {String} attachmentState - The attachment state.
   * @return {ChainMap} The chain map.
   */
  getChainMap(e) {
    return this.chainMaps[e] || (this.chainMaps[e] = new At());
  }
  /**
   * Frees internal resources.
   */
  dispose() {
    this.chainMaps = {};
  }
}
const x_ = /* @__PURE__ */ new Y();
class T_ extends Jt {
  /**
   * Constructs a new texture management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Backend} backend - The renderer's backend.
   * @param {Info} info - Renderer component for managing metrics and monitoring data.
   */
  constructor(e, t, s) {
    super(), this.renderer = e, this.backend = t, this.info = s;
  }
  /**
   * Updates the given render target. Based on the given render target configuration,
   * it updates the texture states representing the attachments of the framebuffer.
   *
   * @param {RenderTarget} renderTarget - The render target to update.
   * @param {Number} [activeMipmapLevel=0] - The active mipmap level.
   */
  updateRenderTarget(e, t = 0) {
    const s = this.get(e), n = e.samples === 0 ? 1 : e.samples, r = s.depthTextureMips || (s.depthTextureMips = {}), i = e.textures, a = this.getSize(i[0]), u = a.width >> t, c = a.height >> t;
    let l = e.depthTexture || r[t];
    const d = e.depthBuffer === !0 || e.stencilBuffer === !0;
    let h = !1;
    l === void 0 && d && (l = new ys(), l.format = e.stencilBuffer ? Zr : Jr, l.type = e.stencilBuffer ? ei : Pe, l.image.width = u, l.image.height = c, r[t] = l), (s.width !== a.width || a.height !== s.height) && (h = !0, l && (l.needsUpdate = !0, l.image.width = u, l.image.height = c)), s.width = a.width, s.height = a.height, s.textures = i, s.depthTexture = l || null, s.depth = e.depthBuffer, s.stencil = e.stencilBuffer, s.renderTarget = e, s.sampleCount !== n && (h = !0, l && (l.needsUpdate = !0), s.sampleCount = n);
    const p = { sampleCount: n };
    for (let f = 0; f < i.length; f++) {
      const m = i[f];
      h && (m.needsUpdate = !0), this.updateTexture(m, p);
    }
    if (l && this.updateTexture(l, p), s.initialized !== !0) {
      s.initialized = !0;
      const f = () => {
        e.removeEventListener("dispose", f);
        for (let m = 0; m < i.length; m++)
          this._destroyTexture(i[m]);
        l && this._destroyTexture(l), this.delete(e);
      };
      e.addEventListener("dispose", f);
    }
  }
  /**
   * Updates the given texture. Depending on the texture state, this method
   * triggers the upload of texture data to the GPU memory. If the texture data are
   * not yet ready for the upload, it uses default texture data for as a placeholder.
   *
   * @param {Texture} texture - The texture to update.
   * @param {Object} [options={}] - The options.
   */
  updateTexture(e, t = {}) {
    const s = this.get(e);
    if (s.initialized === !0 && s.version === e.version) return;
    const n = e.isRenderTargetTexture || e.isDepthTexture || e.isFramebufferTexture, r = this.backend;
    if (n && s.initialized === !0 && (r.destroySampler(e), r.destroyTexture(e)), e.isFramebufferTexture) {
      const c = this.renderer.getRenderTarget();
      c ? e.type = c.texture.type : e.type = ls;
    }
    const { width: i, height: a, depth: u } = this.getSize(e);
    if (t.width = i, t.height = a, t.depth = u, t.needsMipmaps = this.needsMipmaps(e), t.levels = t.needsMipmaps ? this.getMipLevels(e, i, a) : 1, n || e.isStorageTexture === !0)
      r.createSampler(e), r.createTexture(e, t), s.generation = e.version;
    else if (s.initialized !== !0 && r.createSampler(e), e.version > 0) {
      const l = e.image;
      if (l === void 0)
        console.warn("THREE.Renderer: Texture marked for update but image is undefined.");
      else if (l.complete === !1)
        console.warn("THREE.Renderer: Texture marked for update but image is incomplete.");
      else {
        if (e.images) {
          const d = [];
          for (const h of e.images)
            d.push(h);
          t.images = d;
        } else
          t.image = l;
        (s.isDefaultTexture === void 0 || s.isDefaultTexture === !0) && (r.createTexture(e, t), s.isDefaultTexture = !1, s.generation = e.version), e.source.dataReady === !0 && r.updateTexture(e, t), t.needsMipmaps && e.mipmaps.length === 0 && r.generateMipmaps(e);
      }
    } else
      r.createDefaultTexture(e), s.isDefaultTexture = !0, s.generation = e.version;
    if (s.initialized !== !0) {
      s.initialized = !0, s.generation = e.version, this.info.memory.textures++;
      const c = () => {
        e.removeEventListener("dispose", c), this._destroyTexture(e), this.info.memory.textures--;
      };
      e.addEventListener("dispose", c);
    }
    s.version = e.version;
  }
  /**
   * Computes the size of the given texture and writes the result
   * into the target vector. This vector is also returned by the
   * method.
   *
   * If no texture data are available for the compute yet, the method
   * returns default size values.
   *
   * @param {Texture} texture - The texture to compute the size for.
   * @param {Vector3} target - The target vector.
   * @return {Vector3} The target vector.
   */
  getSize(e, t = x_) {
    let s = e.images ? e.images[0] : e.image;
    return s ? (s.image !== void 0 && (s = s.image), t.width = s.width || 1, t.height = s.height || 1, t.depth = e.isCubeTexture ? 6 : s.depth || 1) : t.width = t.height = t.depth = 1, t;
  }
  /**
   * Computes the number of mipmap levels for the given texture.
   *
   * @param {Texture} texture - The texture.
   * @param {Number} width - The texture's width.
   * @param {Number} height - The texture's height.
   * @return {Number} The number of mipmap levels.
   */
  getMipLevels(e, t, s) {
    let n;
    return e.isCompressedTexture ? e.mipmaps ? n = e.mipmaps.length : n = 1 : n = Math.floor(Math.log2(Math.max(t, s))) + 1, n;
  }
  /**
   * Returns `true` if the given texture requires mipmaps.
   *
   * @param {Texture} texture - The texture.
   * @return {Boolean} Whether mipmaps are required or not.
   */
  needsMipmaps(e) {
    return this.isEnvironmentTexture(e) || e.isCompressedTexture === !0 || e.generateMipmaps;
  }
  /**
   * Returns `true` if the given texture is an environment map.
   *
   * @param {Texture} texture - The texture.
   * @return {Boolean} Whether the given texture is an environment map or not.
   */
  isEnvironmentTexture(e) {
    const t = e.mapping;
    return t === Wn || t === Hn || t === Ks || t === Ys;
  }
  /**
   * Frees internal resource when the given texture isn't
   * required anymore.
   *
   * @param {Texture} texture - The texture to destroy.
   */
  _destroyTexture(e) {
    this.backend.destroySampler(e), this.backend.destroyTexture(e), this.delete(e);
  }
}
class su extends Ct {
  /**
   * Constructs a new four-component color.
   *
   * @param {Number|String} r - The red value.
   * @param {Number} g - The green value.
   * @param {Number} b - The blue value.
   * @param {Number} [a=1] - The alpha value.
   */
  constructor(e, t, s, n = 1) {
    super(e, t, s), this.a = n;
  }
  /**
   * Overwrites the default to honor alpha.
   *
   * @param {Number|String} r - The red value.
   * @param {Number} g - The green value.
   * @param {Number} b - The blue value.
   * @param {Number} [a=1] - The alpha value.
   * @return {Color4} A reference to this object.
   */
  set(e, t, s, n = 1) {
    return this.a = n, super.set(e, t, s);
  }
  /**
   * Overwrites the default to honor alpha.
   *
   * @param {Color4} color - The color to copy.
   * @return {Color4} A reference to this object.
   */
  copy(e) {
    return e.a !== void 0 && (this.a = e.a), super.copy(e);
  }
  /**
   * Overwrites the default to honor alpha.
   *
   * @return {Color4} The cloned color.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b, this.a);
  }
}
class Zp extends ee {
  static get type() {
    return "ParameterNode";
  }
  /**
   * Constructs a new parameter node.
   *
   * @param {String} nodeType - The type of the node.
   * @param {String?} [name=null] - The name of the parameter in the shader.
   */
  constructor(e, t = null) {
    super(e, t), this.isParameterNode = !0;
  }
  getHash() {
    return this.uuid;
  }
  generate() {
    return this.name;
  }
}
const __ = (o, e) => E(new Zp(o, e));
class N_ extends G {
  static get type() {
    return "StackNode";
  }
  /**
   * Constructs a new stack node.
   *
   * @param {StackNode?} [parent=null] - The parent stack node.
   */
  constructor(e = null) {
    super(), this.nodes = [], this.outputNode = null, this.parent = e, this._currentCond = null, this.isStackNode = !0;
  }
  getNodeType(e) {
    return this.outputNode ? this.outputNode.getNodeType(e) : "void";
  }
  /**
   * Adds a node to this stack.
   *
   * @param {Node} node - The node to add.
   * @return {StackNode} A reference to this stack node.
   */
  add(e) {
    return this.nodes.push(e), this;
  }
  /**
   * Represent an `if` statement in TSL.
   *
   * @param {Node} boolNode - Represents the condition.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */
  If(e, t) {
    const s = new Nn(t);
    return this._currentCond = Me(e, s), this.add(this._currentCond);
  }
  /**
   * Represent an `elseif` statement in TSL.
   *
   * @param {Node} boolNode - Represents the condition.
   * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
   * @return {StackNode} A reference to this stack node.
   */
  ElseIf(e, t) {
    const s = new Nn(t), n = Me(e, s);
    return this._currentCond.elseNode = n, this._currentCond = n, this;
  }
  /**
   * Represent an `else` statement in TSL.
   *
   * @param {Function} method - TSL code which is executed in the `else` case.
   * @return {StackNode} A reference to this stack node.
   */
  Else(e) {
    return this._currentCond.elseNode = new Nn(e), this;
  }
  build(e, ...t) {
    const s = ha();
    Pn(this);
    for (const n of this.nodes)
      n.build(e, "void");
    return Pn(s), this.outputNode ? this.outputNode.build(e, ...t) : super.build(e, ...t);
  }
  //
  else(...e) {
    return console.warn("TSL.StackNode: .else() has been renamed to .Else()."), this.Else(...e);
  }
  elseif(...e) {
    return console.warn("TSL.StackNode: .elseif() has been renamed to .ElseIf()."), this.ElseIf(...e);
  }
}
const Fr = /* @__PURE__ */ C(N_);
class Jp extends G {
  static get type() {
    return "OutputStructNode";
  }
  /**
   * Constructs a new output struct node. The constructor can be invoked with an
   * arbitrary number of nodes representing the members.
   *
   * @param {...Node} members - A parameter list of nodes.
   */
  constructor(...e) {
    super(), this.members = e, this.isOutputStructNode = !0;
  }
  setup(e) {
    super.setup(e);
    const t = this.members, s = [];
    for (let n = 0; n < t.length; n++)
      s.push(t[n].getNodeType(e));
    this.nodeType = e.getStructTypeFromNode(this, s).name;
  }
  generate(e, t) {
    const s = e.getOutputStructName(), n = this.members, r = s !== "" ? s + "." : "";
    for (let i = 0; i < n.length; i++) {
      const a = n[i].build(e, t);
      e.addLineFlowCode(`${r}m${i} = ${a}`, this);
    }
    return s;
  }
}
const b_ = /* @__PURE__ */ C(Jp);
function ef(o, e) {
  for (let t = 0; t < o.length; t++)
    if (o[t].name === e)
      return t;
  return -1;
}
class S_ extends Jp {
  static get type() {
    return "MRTNode";
  }
  /**
   * Constructs a new output struct node.
   *
   * @param {Object<String, Node>} outputNodes - The MRT outputs.
   */
  constructor(e) {
    super(), this.outputNodes = e, this.isMRTNode = !0;
  }
  /**
   * Returns `true` if the MRT node has an output with the given name.
   *
   * @param {String} name - The name of the output.
   * @return {NodeBuilder} Whether the MRT node has an output for the given name or not.
   */
  has(e) {
    return this.outputNodes[e] !== void 0;
  }
  /**
   * Returns the output node for the given name.
   *
   * @param {String} name - The name of the output.
   * @return {Node} The output node.
   */
  get(e) {
    return this.outputNodes[e];
  }
  /**
   * Merges the outputs of the given MRT node with the outputs of this node.
   *
   * @param {MRTNode} mrtNode - The MRT to merge.
   * @return {MRTNode} A new MRT node with merged outputs..
   */
  merge(e) {
    const t = { ...this.outputNodes, ...e.outputNodes };
    return tf(t);
  }
  setup(e) {
    const t = this.outputNodes, s = e.renderer.getRenderTarget(), n = [], r = s.textures;
    for (const i in t) {
      const a = ef(r, i);
      n[a] = I(t[i]);
    }
    return this.members = n, super.setup(e);
  }
}
const tf = /* @__PURE__ */ C(S_), v_ = /* @__PURE__ */ b(([o]) => {
  const e = o.toUint().mul(747796405).add(2891336453), t = e.shiftRight(e.shiftRight(28).add(4)).bitXor(e).mul(277803737);
  return t.shiftRight(22).bitXor(t).toFloat().mul(1 / 2 ** 32);
}), Ko = (o, e) => ot($(4, o.mul(K(1, o))), e), A_ = (o, e) => o.lessThan(0.5) ? Ko(o.mul(2), e).div(2) : K(1, Ko($(K(1, o), 2), e).div(2)), R_ = (o, e, t) => ot(ut(ot(o, e), _e(ot(o, e), ot(K(1, o), t))), 1 / e), C_ = (o, e) => Ze($r.mul(e.mul(o).sub(1))).div($r.mul(e.mul(o).sub(1))), Ft = /* @__PURE__ */ b(([o]) => o.fract().sub(0.5).abs()).setLayout({
  name: "tri",
  type: "float",
  inputs: [
    { name: "x", type: "float" }
  ]
}), E_ = /* @__PURE__ */ b(([o]) => T(Ft(o.z.add(Ft(o.y.mul(1)))), Ft(o.z.add(Ft(o.x.mul(1)))), Ft(o.y.add(Ft(o.x.mul(1)))))).setLayout({
  name: "tri3",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), w_ = /* @__PURE__ */ b(([o, e, t]) => {
  const s = T(o).toVar(), n = g(1.4).toVar(), r = g(0).toVar(), i = T(s).toVar();
  return J({ start: g(0), end: g(3), type: "float", condition: "<=" }, () => {
    const a = T(E_(i.mul(2))).toVar();
    s.addAssign(a.add(t.mul(g(0.1).mul(e)))), i.mulAssign(1.8), n.mulAssign(1.5), s.mulAssign(1.2);
    const u = g(Ft(s.z.add(Ft(s.x.add(Ft(s.y)))))).toVar();
    r.addAssign(u.div(n)), i.addAssign(0.14);
  }), r;
}).setLayout({
  name: "triNoise3D",
  type: "float",
  inputs: [
    { name: "position", type: "vec3" },
    { name: "speed", type: "float" },
    { name: "time", type: "float" }
  ]
});
class M_ extends G {
  static get type() {
    return "FunctionOverloadingNode";
  }
  /**
   * Constructs a new function overloading node.
   *
   * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
   * @param {...Node} parametersNodes - A list of parameter nodes.
   */
  constructor(e = [], ...t) {
    super(), this.functionNodes = e, this.parametersNodes = t, this._candidateFnCall = null, this.global = !0;
  }
  /**
   * This method is overwritten since the node type is inferred from
   * the function's return type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    return this.functionNodes[0].shaderNode.layout.type;
  }
  setup(e) {
    const t = this.parametersNodes;
    let s = this._candidateFnCall;
    if (s === null) {
      let n = null, r = -1;
      for (const i of this.functionNodes) {
        const u = i.shaderNode.layout;
        if (u === null)
          throw new Error("FunctionOverloadingNode: FunctionNode must be a layout.");
        const c = u.inputs;
        if (t.length === c.length) {
          let l = 0;
          for (let d = 0; d < t.length; d++) {
            const h = t[d], p = c[d];
            h.getNodeType(e) === p.type ? l++ : l = 0;
          }
          l > r && (n = i, r = l);
        }
      }
      this._candidateFnCall = s = n(...t);
    }
    return s;
  }
}
const B_ = /* @__PURE__ */ C(M_), Be = (o) => (...e) => B_(o, ...e), Ns = /* @__PURE__ */ L(0).setGroup(O).onRenderUpdate((o) => o.time), sf = /* @__PURE__ */ L(0).setGroup(O).onRenderUpdate((o) => o.deltaTime), F_ = /* @__PURE__ */ L(0, "uint").setGroup(O).onRenderUpdate((o) => o.frameId), U_ = (o = 1) => (console.warn('TSL: timerLocal() is deprecated. Use "time" instead.'), Ns.mul(o)), P_ = (o = 1) => (console.warn('TSL: timerGlobal() is deprecated. Use "time" instead.'), Ns.mul(o)), D_ = (o = 1) => (console.warn('TSL: timerDelta() is deprecated. Use "deltaTime" instead.'), sf.mul(o)), I_ = (o = Ns) => o.add(0.75).mul(Math.PI * 2).sin().mul(0.5).add(0.5), L_ = (o = Ns) => o.fract().round(), V_ = (o = Ns) => o.add(0.5).fract().mul(2).sub(1).abs(), G_ = (o = Ns) => o.fract(), O_ = /* @__PURE__ */ b(([o, e, t = w(0.5)]) => tu(o.sub(t), e).add(t)), k_ = /* @__PURE__ */ b(([o, e, t = w(0.5)]) => {
  const s = o.sub(t), n = s.dot(s), i = n.mul(n).mul(e);
  return o.add(s.mul(i));
}), z_ = /* @__PURE__ */ b(({ position: o = null, horizontal: e = !0, vertical: t = !1 }) => {
  let s;
  o !== null ? (s = nt.toVar(), s[3][0] = o.x, s[3][1] = o.y, s[3][2] = o.z) : s = nt;
  const n = Xe.mul(s);
  return Un(e) && (n[0][0] = nt[0].length(), n[0][1] = 0, n[0][2] = 0), Un(t) && (n[1][0] = 0, n[1][1] = nt[1].length(), n[1][2] = 0), n[2][0] = 0, n[2][1] = 0, n[2][2] = 1, _s.mul(n).mul(pe);
}), $_ = /* @__PURE__ */ b(([o = null]) => {
  const e = qr();
  return qr(qa(o)).sub(e).lessThan(0).select(vt, o);
});
class W_ extends G {
  static get type() {
    return "SpriteSheetUVNode";
  }
  /**
   * Constructs a new sprite sheet uv node.
   *
   * @param {Node<vec2>} countNode - The node that defines the number of sprites in the x and y direction (e.g 6x6).
   * @param {Node<vec2>} [uvNode=uv()] - The uv node.
   * @param {Node<float>} [frameNode=float()] - The node that defines the current frame/sprite.
   */
  constructor(e, t = le(), s = g(0)) {
    super("vec2"), this.countNode = e, this.uvNode = t, this.frameNode = s;
  }
  setup() {
    const { frameNode: e, uvNode: t, countNode: s } = this, { width: n, height: r } = s, i = e.mod(n.mul(r)).floor(), a = i.mod(n), u = r.sub(i.add(1).div(n).ceil()), c = s.reciprocal(), l = w(a, u);
    return t.add(l).mul(c);
  }
}
const H_ = /* @__PURE__ */ C(W_);
class q_ extends G {
  static get type() {
    return "TriplanarTexturesNode";
  }
  /**
   * Constructs a new triplanar textures node.
   *
   * @param {Node} textureXNode - First texture node.
   * @param {Node?} [textureYNode=null] - Second texture node. When not set, the shader will sample from `textureXNode` instead.
   * @param {Node?} [textureZNode=null] - Third texture node. When not set, the shader will sample from `textureXNode` instead.
   * @param {Node<float>?} [scaleNode=float(1)] - The scale node.
   * @param {Node<vec3>?} [positionNode=positionLocal] - Vertex positions in local space.
   * @param {Node<vec3>?} [normalNode=normalLocal] - Normals in local space.
   */
  constructor(e, t = null, s = null, n = g(1), r = pe, i = We) {
    super("vec4"), this.textureXNode = e, this.textureYNode = t, this.textureZNode = s, this.scaleNode = n, this.positionNode = r, this.normalNode = i;
  }
  setup() {
    const { textureXNode: e, textureYNode: t, textureZNode: s, scaleNode: n, positionNode: r, normalNode: i } = this;
    let a = i.abs().normalize();
    a = a.div(a.dot(T(1)));
    const u = r.yz.mul(n), c = r.zx.mul(n), l = r.xy.mul(n), d = e.value, h = t !== null ? t.value : d, p = s !== null ? s.value : d, f = X(d, u).mul(a.x), m = X(h, c).mul(a.y), _ = X(p, l).mul(a.z);
    return _e(f, m, _);
  }
}
const nf = /* @__PURE__ */ C(q_), X_ = (...o) => nf(...o), Rs = new Oc(), es = new Y(), Cs = new Y(), ki = new Y(), dn = new Ue(), dr = new Y(0, 0, -1), lt = new Ce(), hn = new Y(), hr = new Y(), pn = new Ce(), pr = new He(), Kr = new ms(), K_ = vt.flipX();
Kr.depthTexture = new ys(1, 1);
let zi = !1;
class nu extends bt {
  static get type() {
    return "ReflectorNode";
  }
  /**
   * Constructs a new reflector node.
   *
   * @param {Object} [parameters={}] - An object holding configuration parameters.
   * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
   * @param {Number} [parameters.resolution=1] - The resolution scale.
   * @param {Boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
   * @param {Boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
   * @param {Boolean} [parameters.depth=false] - Whether depth data should be generated or not.
   * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
   * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
   */
  constructor(e = {}) {
    super(e.defaultTexture || Kr.texture, K_), this._reflectorBaseNode = e.reflector || new Y_(this, e), this._depthNode = null, this.setUpdateMatrix(!1);
  }
  /**
   * A reference to the internal reflector node.
   *
   * @type {ReflectorBaseNode}
   */
  get reflector() {
    return this._reflectorBaseNode;
  }
  /**
   * A reference to 3D object the reflector is linked to.
   *
   * @type {Object3D}
   */
  get target() {
    return this._reflectorBaseNode.target;
  }
  /**
   * Returns a node representing the mirror's depth. That can be used
   * to implement more advanced reflection effects like distance attenuation.
   *
   * @return {Node} The depth node.
   */
  getDepthNode() {
    if (this._depthNode === null) {
      if (this._reflectorBaseNode.depth !== !0)
        throw new Error("THREE.ReflectorNode: Depth node can only be requested when the reflector is created with { depth: true }. ");
      this._depthNode = E(new nu({
        defaultTexture: Kr.depthTexture,
        reflector: this._reflectorBaseNode
      }));
    }
    return this._depthNode;
  }
  setup(e) {
    return e.object.isQuadMesh || this._reflectorBaseNode.build(e), super.setup(e);
  }
  clone() {
    const e = new this.constructor(this.reflectorNode);
    return e._reflectorBaseNode = this._reflectorBaseNode, e;
  }
}
class Y_ extends G {
  static get type() {
    return "ReflectorBaseNode";
  }
  /**
   * Constructs a new reflector base node.
   *
   * @param {TextureNode} textureNode - Represents the rendered reflections as a texture node.
   * @param {Object} [parameters={}] - An object holding configuration parameters.
   * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
   * @param {Number} [parameters.resolution=1] - The resolution scale.
   * @param {Boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
   * @param {Boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
   * @param {Boolean} [parameters.depth=false] - Whether depth data should be generated or not.
   */
  constructor(e, t = {}) {
    super();
    const {
      target: s = new em(),
      resolution: n = 1,
      generateMipmaps: r = !1,
      bounces: i = !0,
      depth: a = !1
    } = t;
    this.textureNode = e, this.target = s, this.resolution = n, this.generateMipmaps = r, this.bounces = i, this.depth = a, this.updateBeforeType = i ? z.RENDER : z.FRAME, this.virtualCameras = /* @__PURE__ */ new WeakMap(), this.renderTargets = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Updates the resolution of the internal render target.
   *
   * @private
   * @param {RenderTarget} renderTarget - The render target to resize.
   * @param {Renderer} renderer - The renderer that is used to determine the new size.
   */
  _updateResolution(e, t) {
    const s = this.resolution;
    t.getDrawingBufferSize(pr), e.setSize(Math.round(pr.width * s), Math.round(pr.height * s));
  }
  setup(e) {
    return this._updateResolution(Kr, e.renderer), super.setup(e);
  }
  /**
   * Returns a virtual camera for the given camera. The virtual camera is used to
   * render the scene from the reflector's view so correct reflections can be produced.
   *
   * @param {Camera} camera - The scene's camera.
   * @return {Camera} The corresponding virtual camera.
   */
  getVirtualCamera(e) {
    let t = this.virtualCameras.get(e);
    return t === void 0 && (t = e.clone(), this.virtualCameras.set(e, t)), t;
  }
  /**
   * Returns a render target for the given camera. The reflections are rendered
   * into this render target.
   *
   * @param {Camera} camera - The scene's camera.
   * @return {RenderTarget} The render target.
   */
  getRenderTarget(e) {
    let t = this.renderTargets.get(e);
    return t === void 0 && (t = new ms(0, 0, { type: at }), this.generateMipmaps === !0 && (t.texture.minFilter = tm, t.texture.generateMipmaps = !0), this.depth === !0 && (t.depthTexture = new ys()), this.renderTargets.set(e, t)), t;
  }
  updateBefore(e) {
    if (this.bounces === !1 && zi) return !1;
    zi = !0;
    const { scene: t, camera: s, renderer: n, material: r } = e, { target: i } = this, a = this.getVirtualCamera(s), u = this.getRenderTarget(a);
    if (n.getDrawingBufferSize(pr), this._updateResolution(u, n), Cs.setFromMatrixPosition(i.matrixWorld), ki.setFromMatrixPosition(s.matrixWorld), dn.extractRotation(i.matrixWorld), es.set(0, 0, 1), es.applyMatrix4(dn), hn.subVectors(Cs, ki), hn.dot(es) > 0) return;
    hn.reflect(es).negate(), hn.add(Cs), dn.extractRotation(s.matrixWorld), dr.set(0, 0, -1), dr.applyMatrix4(dn), dr.add(ki), hr.subVectors(Cs, dr), hr.reflect(es).negate(), hr.add(Cs), a.coordinateSystem = s.coordinateSystem, a.position.copy(hn), a.up.set(0, 1, 0), a.up.applyMatrix4(dn), a.up.reflect(es), a.lookAt(hr), a.near = s.near, a.far = s.far, a.updateMatrixWorld(), a.projectionMatrix.copy(s.projectionMatrix), Rs.setFromNormalAndCoplanarPoint(es, Cs), Rs.applyMatrix4(a.matrixWorldInverse), lt.set(Rs.normal.x, Rs.normal.y, Rs.normal.z, Rs.constant);
    const c = a.projectionMatrix;
    pn.x = (Math.sign(lt.x) + c.elements[8]) / c.elements[0], pn.y = (Math.sign(lt.y) + c.elements[9]) / c.elements[5], pn.z = -1, pn.w = (1 + c.elements[10]) / c.elements[14], lt.multiplyScalar(1 / lt.dot(pn));
    const l = 0;
    c.elements[2] = lt.x, c.elements[6] = lt.y, c.elements[10] = n.coordinateSystem === sn ? lt.z - l : lt.z + 1 - l, c.elements[14] = lt.w, this.textureNode.value = u.texture, this.depth === !0 && (this.textureNode.getDepthNode().value = u.depthTexture), r.visible = !1;
    const d = n.getRenderTarget(), h = n.getMRT(), p = n.autoClear;
    n.setMRT(null), n.setRenderTarget(u), n.autoClear = !0, n.render(t, a), n.setMRT(h), n.setRenderTarget(d), n.autoClear = p, r.visible = !0, zi = !1;
  }
}
const j_ = (o) => E(new nu(o)), $i = /* @__PURE__ */ new Al(-1, 1, 1, -1, 0, 1);
class Q_ extends El {
  /**
   * Constructs a new quad geometry.
   *
   * @param {Boolean} [flipY=false] - Whether the uv coordinates should be flipped along the vertical axis or not.
   */
  constructor(e = !1) {
    super();
    const t = e === !1 ? [0, -1, 0, 1, 2, 1] : [0, 2, 0, 0, 2, 0];
    this.setAttribute("position", new Uu([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)), this.setAttribute("uv", new Uu(t, 2));
  }
}
const Z_ = /* @__PURE__ */ new Q_();
class ru extends js {
  /**
   * Constructs a new quad mesh.
   *
   * @param {Material?} [material=null] - The material to render the quad mesh with.
   */
  constructor(e = null) {
    super(Z_, e), this.camera = $i, this.isQuadMesh = !0;
  }
  /**
   * Async version of `render()`.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the render has been finished.
   */
  async renderAsync(e) {
    return e.renderAsync(this, $i);
  }
  /**
   * Renders the quad mesh
   *
   * @param {Renderer} renderer - The renderer.
   */
  render(e) {
    e.render(this, $i);
  }
}
const J_ = /* @__PURE__ */ new He();
class eN extends bt {
  static get type() {
    return "RTTNode";
  }
  /**
   * Constructs a new RTT node.
   *
   * @param {Node} node - The node to render a texture with.
   * @param {Number?} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
   * @param {Number?} [height=null] - The height of the internal render target.
   * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
   */
  constructor(e, t = null, s = null, n = { type: at }) {
    const r = new ms(t, s, n);
    super(r.texture, le()), this.node = e, this.width = t, this.height = s, this.pixelRatio = 1, this.renderTarget = r, this.textureNeedsUpdate = !0, this.autoUpdate = !0, this._rttNode = null, this._quadMesh = new ru(new ge()), this.updateBeforeType = z.RENDER;
  }
  /**
   * Whether the internal render target should automatically be resized or not.
   *
   * @type {Boolean}
   * @readonly
   * @default true
   */
  get autoSize() {
    return this.width === null;
  }
  setup(e) {
    return this._rttNode = this.node.context(e.getSharedContext()), this._quadMesh.material.name = "RTT", this._quadMesh.material.needsUpdate = !0, super.setup(e);
  }
  /**
   * Sets the size of the internal render target
   *
   * @param {Number} width - The width to set.
   * @param {Number} height - The width to set.
   */
  setSize(e, t) {
    this.width = e, this.height = t;
    const s = e * this.pixelRatio, n = t * this.pixelRatio;
    this.renderTarget.setSize(s, n), this.textureNeedsUpdate = !0;
  }
  /**
   * Sets the pixel ratio. This will also resize the render target.
   *
   * @param {Number} pixelRatio - The pixel ratio to set.
   */
  setPixelRatio(e) {
    this.pixelRatio = e, this.setSize(this.width, this.height);
  }
  updateBefore({ renderer: e }) {
    if (this.textureNeedsUpdate === !1 && this.autoUpdate === !1) return;
    if (this.textureNeedsUpdate = !1, this.autoSize === !0) {
      this.pixelRatio = e.getPixelRatio();
      const s = e.getSize(J_);
      this.setSize(s.width, s.height);
    }
    this._quadMesh.material.fragmentNode = this._rttNode;
    const t = e.getRenderTarget();
    e.setRenderTarget(this.renderTarget), this._quadMesh.render(e), e.setRenderTarget(t);
  }
  clone() {
    const e = new bt(this.value, this.uvNode, this.levelNode);
    return e.sampler = this.sampler, e.referenceNode = this, e;
  }
}
const rf = (o, ...e) => E(new eN(E(o), ...e)), tN = (o, ...e) => o.isTextureNode ? o : o.isPassNode ? o.getTextureNode() : rf(o, ...e), Ds = /* @__PURE__ */ b(([o, e, t], s) => {
  let n;
  s.renderer.coordinateSystem === sn ? (o = w(o.x, o.y.oneMinus()).mul(2).sub(1), n = I(T(o, e), 1)) : n = I(T(o.x, o.y.oneMinus(), e).mul(2).sub(1), 1);
  const r = I(t.mul(n));
  return r.xyz.div(r.w);
}), sN = /* @__PURE__ */ b(([o, e]) => {
  const t = e.mul(I(o, 1)), s = t.xy.div(t.w).mul(0.5).add(0.5).toVar();
  return w(s.x, s.y.oneMinus());
}), nN = /* @__PURE__ */ b(([o, e, t]) => {
  const s = jt(de(e)), n = Ae(o.mul(s)).toVar(), r = de(e, n).toVar(), i = de(e, n.sub(Ae(2, 0))).toVar(), a = de(e, n.sub(Ae(1, 0))).toVar(), u = de(e, n.add(Ae(1, 0))).toVar(), c = de(e, n.add(Ae(2, 0))).toVar(), l = de(e, n.add(Ae(0, 2))).toVar(), d = de(e, n.add(Ae(0, 1))).toVar(), h = de(e, n.sub(Ae(0, 1))).toVar(), p = de(e, n.sub(Ae(0, 2))).toVar(), f = re(K(g(2).mul(a).sub(i), r)).toVar(), m = re(K(g(2).mul(u).sub(c), r)).toVar(), _ = re(K(g(2).mul(d).sub(l), r)).toVar(), S = re(K(g(2).mul(h).sub(p), r)).toVar(), A = Ds(o, r, t).toVar(), M = f.lessThan(m).select(A.sub(Ds(o.sub(w(g(1).div(s.x), 0)), a, t)), A.negate().add(Ds(o.add(w(g(1).div(s.x), 0)), u, t))), F = _.lessThan(S).select(A.sub(Ds(o.add(w(0, g(1).div(s.y))), d, t)), A.negate().add(Ds(o.sub(w(0, g(1).div(s.y))), h, t)));
  return Gt(hi(M, F));
});
class rN extends oa {
  /**
   * Constructs a new storage instanced buffer attribute.
   *
   * @param {Number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
   * The subsequent parameters are then obsolete.
   * @param {Number} itemSize - The item size.
   * @param {TypedArray.contructor} [typeClass=Float32Array] - A typed array constructor.
   */
  constructor(e, t, s = Float32Array) {
    const n = ArrayBuffer.isView(e) ? e : new s(e * t);
    super(n, t), this.isStorageInstancedBufferAttribute = !0;
  }
}
class iN extends Cr {
  /**
   * Constructs a new storage buffer attribute.
   *
   * @param {Number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
   * The subsequent parameters are then obsolete.
   * @param {Number} itemSize - The item size.
   * @param {TypedArray.contructor} [typeClass=Float32Array] - A typed array constructor.
   */
  constructor(e, t, s = Float32Array) {
    const n = ArrayBuffer.isView(e) ? e : new s(e * t);
    super(n, t), this.isStorageBufferAttribute = !0;
  }
}
class oN extends Ts {
  static get type() {
    return "StorageArrayElementNode";
  }
  /**
   * Constructs storage buffer element node.
   *
   * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.isStorageArrayElementNode = !0;
  }
  /**
   * The storage buffer node.
   *
   * @param {Node} value
   * @type {StorageBufferNode}
   */
  set storageBufferNode(e) {
    this.node = e;
  }
  get storageBufferNode() {
    return this.node;
  }
  setup(e) {
    return e.isAvailable("storageBuffer") === !1 && this.node.isPBO === !0 && e.setupPBO(this.node), super.setup(e);
  }
  generate(e, t) {
    let s;
    const n = e.context.assign;
    if (e.isAvailable("storageBuffer") === !1 ? this.node.isPBO === !0 && n !== !0 && (this.node.value.isInstancedBufferAttribute || e.shaderStage !== "compute") ? s = e.generatePBO(this) : s = this.node.build(e) : s = super.generate(e), n !== !0) {
      const r = this.getNodeType(e);
      s = e.format(s, r, t);
    }
    return s;
  }
}
const aN = /* @__PURE__ */ C(oN);
class uN extends Ga {
  static get type() {
    return "StorageBufferNode";
  }
  /**
   * Constructs a new storage buffer node.
   *
   * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
   * @param {String?} [bufferType=null] - The buffer type (e.g. `'vec3'`).
   * @param {Number} [bufferCount=0] - The buffer count.
   */
  constructor(e, t = null, s = 0) {
    t === null && (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) && (t = Bl(e.itemSize), s = e.count), super(e, t, s), this.isStorageBufferNode = !0, this.access = De.READ_WRITE, this.isAtomic = !1, this.isPBO = !1, this._attribute = null, this._varying = null, this.global = !0, e.isStorageBufferAttribute !== !0 && e.isStorageInstancedBufferAttribute !== !0 && (e.isInstancedBufferAttribute ? e.isStorageInstancedBufferAttribute = !0 : e.isStorageBufferAttribute = !0);
  }
  /**
   * This method is overwritten since the buffer data might be shared
   * and thus the hash should be shared as well.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The hash.
   */
  getHash(e) {
    if (this.bufferCount === 0) {
      let t = e.globalCache.getData(this.value);
      return t === void 0 && (t = {
        node: this
      }, e.globalCache.setData(this.value, t)), t.node.uuid;
    }
    return this.uuid;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'indirectStorageBuffer'` or `'storageBuffer'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return this.value.isIndirectStorageBufferAttribute ? "indirectStorageBuffer" : "storageBuffer";
  }
  /**
   * Enables element access with the given index node.
   *
   * @param {IndexNode} indexNode - The index node.
   * @return {StorageArrayElementNode} A node representing the element access.
   */
  element(e) {
    return aN(this, e);
  }
  /**
   * Defines whether this node is a PBO or not. Only relevant for WebGL.
   *
   * @param {Boolean} value - The value so set.
   * @return {StorageBufferNode} A reference to this node.
   */
  setPBO(e) {
    return this.isPBO = e, this;
  }
  /**
   * Returns the `isPBO` value.
   *
   * @return {Boolean} Whether the node represents a PBO or not.
   */
  getPBO() {
    return this.isPBO;
  }
  /**
   * Defines the node access.
   *
   * @param {String} value - The node access.
   * @return {StorageBufferNode} A reference to this node.
   */
  setAccess(e) {
    return this.access = e, this;
  }
  /**
   * Convenience method for configuring a read-only node access.
   *
   * @return {StorageBufferNode} A reference to this node.
   */
  toReadOnly() {
    return this.setAccess(De.READ_ONLY);
  }
  /**
   * Defines whether the node is atomic or not.
   *
   * @param {Boolean} value - The atomic flag.
   * @return {StorageBufferNode} A reference to this node.
   */
  setAtomic(e) {
    return this.isAtomic = e, this;
  }
  /**
   * Convenience method for making this node atomic.
   *
   * @return {StorageBufferNode} A reference to this node.
   */
  toAtomic() {
    return this.setAtomic(!0);
  }
  /**
   * Returns attribute data for this storage buffer node.
   *
   * @return {{attribute: BufferAttributeNode, varying: VaryingNode}} The attribute data.
   */
  getAttributeData() {
    return this._attribute === null && (this._attribute = jn(this.value), this._varying = qe(this._attribute)), {
      attribute: this._attribute,
      varying: this._varying
    };
  }
  /**
   * This method is overwritten since the node type from the availability of storage buffers
   * and the attribute data.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    if (e.isAvailable("storageBuffer") || e.isAvailable("indirectStorageBuffer"))
      return super.getNodeType(e);
    const { attribute: t } = this.getAttributeData();
    return t.getNodeType(e);
  }
  /**
   * Generates the code snippet of the storage buffer node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The generated code snippet.
   */
  generate(e) {
    if (e.isAvailable("storageBuffer") || e.isAvailable("indirectStorageBuffer"))
      return super.generate(e);
    const { attribute: t, varying: s } = this.getAttributeData(), n = s.build(e);
    return e.registerTransform(n, t), n;
  }
}
const Si = (o, e = null, t = 0) => E(new uN(o, e, t)), cN = (o, e, t) => (console.warn('THREE.TSL: "storageObject()" is deprecated. Use "storage().setPBO( true )" instead.'), Si(o, e, t).setPBO(!0)), lN = (o, e = "float") => {
  const t = Ul(e), s = Fl(e), n = new iN(o, t, s);
  return Si(n, e, o);
}, dN = (o, e = "float") => {
  const t = Ul(e), s = Fl(e), n = new rN(o, t, s);
  return Si(n, e, o);
};
class hN extends xh {
  static get type() {
    return "VertexColorNode";
  }
  /**
   * Constructs a new vertex color node.
   *
   * @param {Number} [index=0] - The attribute index.
   */
  constructor(e = 0) {
    super(null, "vec4"), this.isVertexColorNode = !0, this.index = e;
  }
  /**
   * Overwrites the default implementation by honoring the attribute index.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The attribute name.
   */
  getAttributeName() {
    const e = this.index;
    return "color" + (e > 0 ? e : "");
  }
  generate(e) {
    const t = this.getAttributeName(e), s = e.hasGeometryAttribute(t);
    let n;
    return s === !0 ? n = super.generate(e) : n = e.generateConst(this.nodeType, new Ce(1, 1, 1, 1)), n;
  }
  serialize(e) {
    super.serialize(e), e.index = this.index;
  }
  deserialize(e) {
    super.deserialize(e), this.index = e.index;
  }
}
const pN = (o) => E(new hN(o));
class fN extends G {
  static get type() {
    return "PointUVNode";
  }
  /**
   * Constructs a new point uv node.
   */
  constructor() {
    super("vec2"), this.isPointUVNode = !0;
  }
  generate() {
    return "vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y )";
  }
}
const gN = /* @__PURE__ */ B(fN), fn = /* @__PURE__ */ new bg(), Wi = /* @__PURE__ */ new Ue();
class ze extends G {
  static get type() {
    return "SceneNode";
  }
  /**
   * Constructs a new scene node.
   *
   * @param {('backgroundBlurriness'|'backgroundIntensity'|'backgroundRotation')} scope - The scope defines the type of scene property that is accessed.
   * @param {Scene?} [scene=null] - A reference to the scene.
   */
  constructor(e = ze.BACKGROUND_BLURRINESS, t = null) {
    super(), this.scope = e, this.scene = t;
  }
  /**
   * Depending on the scope, the method returns a different type of node that represents
   * the respective scene property.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Node} The output node.
   */
  setup(e) {
    const t = this.scope, s = this.scene !== null ? this.scene : e.scene;
    let n;
    return t === ze.BACKGROUND_BLURRINESS ? n = te("backgroundBlurriness", "float", s) : t === ze.BACKGROUND_INTENSITY ? n = te("backgroundIntensity", "float", s) : t === ze.BACKGROUND_ROTATION ? n = L("mat4").label("backgroundRotation").setGroup(O).onRenderUpdate(() => {
      const r = s.background;
      return r !== null && r.isTexture && r.mapping !== ag ? (fn.copy(s.backgroundRotation), fn.x *= -1, fn.y *= -1, fn.z *= -1, Wi.makeRotationFromEuler(fn)) : Wi.identity(), Wi;
    }) : console.error("THREE.SceneNode: Unknown scope:", t), n;
  }
}
ze.BACKGROUND_BLURRINESS = "backgroundBlurriness";
ze.BACKGROUND_INTENSITY = "backgroundIntensity";
ze.BACKGROUND_ROTATION = "backgroundRotation";
const of = /* @__PURE__ */ B(ze, ze.BACKGROUND_BLURRINESS), Yo = /* @__PURE__ */ B(ze, ze.BACKGROUND_INTENSITY), af = /* @__PURE__ */ B(ze, ze.BACKGROUND_ROTATION);
class mN extends bt {
  static get type() {
    return "StorageTextureNode";
  }
  /**
   * Constructs a new storage texture node.
   *
   * @param {StorageTexture} value - The storage texture.
   * @param {Node<vec2|vec3>} uvNode - The uv node.
   * @param {Node?} [storeNode=null] - The value node that should be stored in the texture.
   */
  constructor(e, t, s = null) {
    super(e, t), this.storeNode = s, this.isStorageTextureNode = !0, this.access = De.WRITE_ONLY;
  }
  /**
   * Overwrites the default implementation to return a fixed value `'storageTexture'`.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return "storageTexture";
  }
  setup(e) {
    super.setup(e);
    const t = e.getNodeProperties(this);
    t.storeNode = this.storeNode;
  }
  /**
   * Defines the node access.
   *
   * @param {String} value - The node access.
   * @return {StorageTextureNode} A reference to this node.
   */
  setAccess(e) {
    return this.access = e, this;
  }
  /**
   * Generates the code snippet of the stroge node. If no `storeNode`
   * is defined, the texture node is generated as normal texture.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @param {String} output - The current output.
   * @return {String} The generated code snippet.
   */
  generate(e, t) {
    let s;
    return this.storeNode !== null ? s = this.generateStore(e) : s = super.generate(e, t), s;
  }
  /**
   * Convenience method for configuring a read/write node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */
  toReadWrite() {
    return this.setAccess(De.READ_WRITE);
  }
  /**
   * Convenience method for configuring a read-only node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */
  toReadOnly() {
    return this.setAccess(De.READ_ONLY);
  }
  /**
   * Convenience method for configuring a write-only node access.
   *
   * @return {StorageTextureNode} A reference to this node.
   */
  toWriteOnly() {
    return this.setAccess(De.WRITE_ONLY);
  }
  /**
   * Generates the code snippet of the storage texture node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  generateStore(e) {
    const t = e.getNodeProperties(this), { uvNode: s, storeNode: n } = t, r = super.generate(e, "property"), i = s.build(e, "uvec2"), a = n.build(e, "vec4"), u = e.generateTextureStore(e, r, i, a);
    e.addLineFlowCode(u, this);
  }
}
const uf = /* @__PURE__ */ C(mN), yN = (o, e, t) => {
  const s = uf(o, e, t);
  return t !== null && s.append(), s;
};
class xN extends xi {
  static get type() {
    return "UserDataNode";
  }
  /**
   * Constructs a new user data node.
   *
   * @param {String} property - The property name that should be referenced by the node.
   * @param {String} inputType - The node data type of the reference.
   * @param {Object?} [userData=null] - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
   */
  constructor(e, t, s = null) {
    super(e, t, s), this.userData = s;
  }
  /**
   * Overwritten to make sure {@link module:ReferenceNode~ReferenceNode#reference} points to the correct
   * `userData` field.
   *
   * @param {(NodeFrame|NodeBuilder)} state - The current state to evaluate.
   * @return {Object} A reference to the `userData` field.
   */
  updateReference(e) {
    return this.reference = this.userData !== null ? this.userData : e.object.userData, this.reference;
  }
}
const TN = (o, e, t) => E(new xN(o, e, t)), cc = /* @__PURE__ */ new WeakMap();
class _N extends Ne {
  static get type() {
    return "VelocityNode";
  }
  /**
   * Constructs a new vertex color node.
   *
   * @param {Number} [index=0] - The attribute index.
   */
  constructor() {
    super("vec2"), this.projectionMatrix = null, this.updateType = z.OBJECT, this.updateAfterType = z.OBJECT, this.previousModelWorldMatrix = L(new Ue()), this.previousProjectionMatrix = L(new Ue()).setGroup(O), this.previousCameraViewMatrix = L(new Ue());
  }
  /**
   * Sets the given projection matrix.
   *
   * @param {Matrix4} projectionMatrix - The projection matrix to set.
   */
  setProjectionMatrix(e) {
    this.projectionMatrix = e;
  }
  /**
   * Updates velocity specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update({ frameId: e, camera: t, object: s }) {
    const n = lc(s);
    this.previousModelWorldMatrix.value.copy(n);
    const r = cf(t);
    r.frameId !== e && (r.frameId = e, r.previousProjectionMatrix === void 0 ? (r.previousProjectionMatrix = new Ue(), r.previousCameraViewMatrix = new Ue(), r.currentProjectionMatrix = new Ue(), r.currentCameraViewMatrix = new Ue(), r.previousProjectionMatrix.copy(this.projectionMatrix || t.projectionMatrix), r.previousCameraViewMatrix.copy(t.matrixWorldInverse)) : (r.previousProjectionMatrix.copy(r.currentProjectionMatrix), r.previousCameraViewMatrix.copy(r.currentCameraViewMatrix)), r.currentProjectionMatrix.copy(this.projectionMatrix || t.projectionMatrix), r.currentCameraViewMatrix.copy(t.matrixWorldInverse), this.previousProjectionMatrix.value.copy(r.previousProjectionMatrix), this.previousCameraViewMatrix.value.copy(r.previousCameraViewMatrix));
  }
  /**
   * Overwritten to updated velocity specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateAfter({ object: e }) {
    lc(e).copy(e.matrixWorld);
  }
  /**
   * Implements the velocity computation based on the previous and current vertex data.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec2>} The motion vector.
   */
  setup() {
    const e = this.projectionMatrix === null ? _s : L(this.projectionMatrix), t = this.previousCameraViewMatrix.mul(this.previousModelWorldMatrix), s = e.mul(rn).mul(pe), n = this.previousProjectionMatrix.mul(t).mul(Hr), r = s.xy.div(s.w), i = n.xy.div(n.w);
    return K(r, i);
  }
}
function cf(o) {
  let e = cc.get(o);
  return e === void 0 && (e = {}, cc.set(o, e)), e;
}
function lc(o, e = 0) {
  const t = cf(o);
  let s = t[e];
  return s === void 0 && (t[e] = s = new Ue()), s;
}
const NN = /* @__PURE__ */ B(_N), lf = /* @__PURE__ */ b(([o, e]) => $e(1, o.oneMinus().div(e)).oneMinus()).setLayout({
  name: "blendBurn",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), df = /* @__PURE__ */ b(([o, e]) => $e(o.div(e.oneMinus()), 1)).setLayout({
  name: "blendDodge",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), hf = /* @__PURE__ */ b(([o, e]) => o.oneMinus().mul(e.oneMinus()).oneMinus()).setLayout({
  name: "blendScreen",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), pf = /* @__PURE__ */ b(([o, e]) => Z(o.mul(2).mul(e), o.oneMinus().mul(2).mul(e.oneMinus()).oneMinus(), di(0.5, o))).setLayout({
  name: "blendOverlay",
  type: "vec3",
  inputs: [
    { name: "base", type: "vec3" },
    { name: "blend", type: "vec3" }
  ]
}), bN = /* @__PURE__ */ b(([o, e]) => {
  const t = e.a.add(o.a.mul(e.a.oneMinus()));
  return I(e.rgb.mul(e.a).add(o.rgb.mul(o.a).mul(e.a.oneMinus())).div(t), t);
}).setLayout({
  name: "blendColor",
  type: "vec4",
  inputs: [
    { name: "base", type: "vec4" },
    { name: "blend", type: "vec4" }
  ]
}), SN = (...o) => (console.warn('THREE.TSL: "burn" has been renamed. Use "blendBurn" instead.'), lf(o)), vN = (...o) => (console.warn('THREE.TSL: "dodge" has been renamed. Use "blendDodge" instead.'), df(o)), AN = (...o) => (console.warn('THREE.TSL: "screen" has been renamed. Use "blendScreen" instead.'), hf(o)), RN = (...o) => (console.warn('THREE.TSL: "overlay" has been renamed. Use "blendOverlay" instead.'), pf(o)), CN = /* @__PURE__ */ b(([o]) => iu(o.rgb)), EN = /* @__PURE__ */ b(([o, e = g(1)]) => e.mix(iu(o.rgb), o.rgb)), wN = /* @__PURE__ */ b(([o, e = g(1)]) => {
  const t = _e(o.r, o.g, o.b).div(3), s = o.r.max(o.g.max(o.b)), n = s.sub(t).mul(e).mul(-3);
  return Z(o.rgb, s, n);
}), MN = /* @__PURE__ */ b(([o, e = g(1)]) => {
  const t = T(0.57735, 0.57735, 0.57735), s = e.cos();
  return T(o.rgb.mul(s).add(t.cross(o.rgb).mul(e.sin()).add(t.mul(Zt(t, o.rgb).mul(s.oneMinus())))));
}), iu = (o, e = T(ht.getLuminanceCoefficients(new Y()))) => Zt(o, e), BN = /* @__PURE__ */ b(([
  o,
  e = T(1),
  t = T(0),
  s = T(1),
  n = g(1),
  // ASC CDL v1.2 explicitly requires Rec. 709 luminance coefficients.
  r = T(ht.getLuminanceCoefficients(new Y(), cs))
]) => {
  const i = o.rgb.dot(T(r)), a = fe(o.rgb.mul(e).add(t), 0).toVar(), u = a.pow(s).toVar();
  return H(a.r.greaterThan(0), () => {
    a.r.assign(u.r);
  }), H(a.g.greaterThan(0), () => {
    a.g.assign(u.g);
  }), H(a.b.greaterThan(0), () => {
    a.b.assign(u.b);
  }), a.assign(i.add(a.sub(i).mul(n))), I(a.rgb, o.a);
});
class FN extends Ne {
  static get type() {
    return "PosterizeNode";
  }
  /**
   * Constructs a new posterize node.
   *
   * @param {Node} sourceNode - The input color.
   * @param {Node} stepsNode - Controls the intensity of the posterization effect. A lower number results in a more blocky appearance.
   */
  constructor(e, t) {
    super(), this.sourceNode = e, this.stepsNode = t;
  }
  setup() {
    const { sourceNode: e, stepsNode: t } = this;
    return e.mul(t).floor().div(t);
  }
}
const UN = /* @__PURE__ */ C(FN), PN = /* @__PURE__ */ new He();
class ff extends bt {
  static get type() {
    return "PassTextureNode";
  }
  /**
   * Constructs a new pass texture node.
   *
   * @param {PassNode} passNode - The pass node.
   * @param {Texture} texture - The output texture.
   */
  constructor(e, t) {
    super(t), this.passNode = e, this.setUpdateMatrix(!1);
  }
  setup(e) {
    return e.object.isQuadMesh && this.passNode.build(e), super.setup(e);
  }
  clone() {
    return new this.constructor(this.passNode, this.value);
  }
}
class dc extends ff {
  static get type() {
    return "PassMultipleTextureNode";
  }
  /**
   * Constructs a new pass texture node.
   *
   * @param {PassNode} passNode - The pass node.
   * @param {String} textureName - The output texture name.
   * @param {Boolean} [previousTexture=false] - Whether previous frame data should be used or not.
   */
  constructor(e, t, s = !1) {
    super(e, null), this.textureName = t, this.previousTexture = s;
  }
  /**
   * Updates the texture reference of this node.
   */
  updateTexture() {
    this.value = this.previousTexture ? this.passNode.getPreviousTexture(this.textureName) : this.passNode.getTexture(this.textureName);
  }
  setup(e) {
    return this.updateTexture(), super.setup(e);
  }
  clone() {
    return new this.constructor(this.passNode, this.textureName, this.previousTexture);
  }
}
class Rt extends Ne {
  static get type() {
    return "PassNode";
  }
  /**
   * Constructs a new pass node.
   *
   * @param {('color'|'depth')} scope - The scope of the pass. The scope determines whether the node outputs color or depth.
   * @param {Scene} scene - A reference to the scene.
   * @param {Camera} camera - A reference to the camera.
   * @param {Object} options - Options for the internal render target.
   */
  constructor(e, t, s, n = {}) {
    super("vec4"), this.scope = e, this.scene = t, this.camera = s, this.options = n, this._pixelRatio = 1, this._width = 1, this._height = 1;
    const r = new ys();
    r.isRenderTargetTexture = !0, r.name = "depth";
    const i = new ms(this._width * this._pixelRatio, this._height * this._pixelRatio, { type: at, ...n });
    i.texture.name = "output", i.depthTexture = r, this.renderTarget = i, this._textures = {
      output: i.texture,
      depth: r
    }, this._textureNodes = {}, this._linearDepthNodes = {}, this._viewZNodes = {}, this._previousTextures = {}, this._previousTextureNodes = {}, this._cameraNear = L(0), this._cameraFar = L(0), this._mrt = null, this.isPassNode = !0, this.updateBeforeType = z.FRAME;
  }
  /**
   * Sets the given MRT node to setup MRT for this pass.
   *
   * @param {MRTNode} mrt - The MRT object.
   * @return {PassNode} A reference to this pass.
   */
  setMRT(e) {
    return this._mrt = e, this;
  }
  /**
   * Returns the current MRT node.
   *
   * @return {MRTNode} The current MRT node.
   */
  getMRT() {
    return this._mrt;
  }
  /**
   * The method is overwritten so it always returns `true`.
   *
   * @return {Boolean} Whether this node is global or not.
   */
  isGlobal() {
    return !0;
  }
  /**
   * Returns the texture for the given output name.
   *
   * @param {String} name - The output name to get the texture for.
   * @return {Texture} The texture.
   */
  getTexture(e) {
    let t = this._textures[e];
    return t === void 0 && (t = this.renderTarget.texture.clone(), t.name = e, this._textures[e] = t, this.renderTarget.textures.push(t)), t;
  }
  /**
   * Returns the texture holding the data of the previous frame for the given output name.
   *
   * @param {String} name - The output name to get the texture for.
   * @return {Texture} The texture holding the data of the previous frame.
   */
  getPreviousTexture(e) {
    let t = this._previousTextures[e];
    return t === void 0 && (t = this.getTexture(e).clone(), this._previousTextures[e] = t), t;
  }
  /**
   * Switches current and previous textures for the given output name.
   *
   * @param {String} name - The output name.
   */
  toggleTexture(e) {
    const t = this._previousTextures[e];
    if (t !== void 0) {
      const s = this._textures[e], n = this.renderTarget.textures.indexOf(s);
      this.renderTarget.textures[n] = t, this._textures[e] = t, this._previousTextures[e] = s, this._textureNodes[e].updateTexture(), this._previousTextureNodes[e].updateTexture();
    }
  }
  /**
   * Returns the texture node for the given output name.
   *
   * @param {String} [name='output'] - The output name to get the texture node for.
   * @return {TextureNode} The texture node.
   */
  getTextureNode(e = "output") {
    let t = this._textureNodes[e];
    return t === void 0 && (t = E(new dc(this, e)), t.updateTexture(), this._textureNodes[e] = t), t;
  }
  /**
   * Returns the previous texture node for the given output name.
   *
   * @param {String} [name='output'] - The output name to get the previous texture node for.
   * @return {TextureNode} The previous texture node.
   */
  getPreviousTextureNode(e = "output") {
    let t = this._previousTextureNodes[e];
    return t === void 0 && (this._textureNodes[e] === void 0 && this.getTextureNode(e), t = E(new dc(this, e, !0)), t.updateTexture(), this._previousTextureNodes[e] = t), t;
  }
  /**
   * Returns a viewZ node of this pass.
   *
   * @param {String} [name='depth'] - The output name to get the viewZ node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
   * @return {Node} The viewZ node.
   */
  getViewZNode(e = "depth") {
    let t = this._viewZNodes[e];
    if (t === void 0) {
      const s = this._cameraNear, n = this._cameraFar;
      this._viewZNodes[e] = t = Xa(this.getTextureNode(e), s, n);
    }
    return t;
  }
  /**
   * Returns a linear depth node of this pass.
   *
   * @param {String} [name='depth'] - The output name to get the linear depth node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
   * @return {Node} The linear depth node.
   */
  getLinearDepthNode(e = "depth") {
    let t = this._linearDepthNodes[e];
    if (t === void 0) {
      const s = this._cameraNear, n = this._cameraFar, r = this.getViewZNode(e);
      this._linearDepthNodes[e] = t = qs(r, s, n);
    }
    return t;
  }
  setup({ renderer: e }) {
    return this.renderTarget.samples = this.options.samples === void 0 ? e.samples : this.options.samples, e.backend.isWebGLBackend === !0 && (this.renderTarget.samples = 0), this.scope === Rt.COLOR ? this.getTextureNode() : this.getLinearDepthNode();
  }
  updateBefore(e) {
    const { renderer: t } = e, { scene: s, camera: n } = this;
    this._pixelRatio = t.getPixelRatio();
    const r = t.getSize(PN);
    this.setSize(r.width, r.height);
    const i = t.getRenderTarget(), a = t.getMRT();
    this._cameraNear.value = n.near, this._cameraFar.value = n.far;
    for (const u in this._previousTextures)
      this.toggleTexture(u);
    t.setRenderTarget(this.renderTarget), t.setMRT(this._mrt), t.render(s, n), t.setRenderTarget(i), t.setMRT(a);
  }
  /**
   * Sets the size of the pass's render target. Honors the pixel ratio.
   *
   * @param {Number} width - The width to set.
   * @param {Number} height - The height to set.
   */
  setSize(e, t) {
    this._width = e, this._height = t;
    const s = this._width * this._pixelRatio, n = this._height * this._pixelRatio;
    this.renderTarget.setSize(s, n);
  }
  /**
   * Sets the pixel ratio the pass's render target and updates the size.
   *
   * @param {Number} pixelRatio - The pixel ratio to set.
   */
  setPixelRatio(e) {
    this._pixelRatio = e, this.setSize(this._width, this._height);
  }
  /**
   * Frees internal resources. Should be called when the node is no longer in use.
   */
  dispose() {
    this.renderTarget.dispose();
  }
}
Rt.COLOR = "color";
Rt.DEPTH = "depth";
const DN = (o, e, t) => E(new Rt(Rt.COLOR, o, e, t)), IN = (o, e) => E(new ff(o, e)), LN = (o, e, t) => E(new Rt(Rt.DEPTH, o, e, t));
class VN extends Rt {
  static get type() {
    return "ToonOutlinePassNode";
  }
  /**
   * Constructs a new outline pass node.
   *
   * @param {Scene} scene - A reference to the scene.
   * @param {Camera} camera - A reference to the camera.
   * @param {Node} colorNode - Defines the outline's color.
   * @param {Node} thicknessNode - Defines the outline's thickness.
   * @param {Node} alphaNode - Defines the outline's alpha.
   */
  constructor(e, t, s, n, r) {
    super(Rt.COLOR, e, t), this.colorNode = s, this.thicknessNode = n, this.alphaNode = r, this._materialCache = /* @__PURE__ */ new WeakMap();
  }
  updateBefore(e) {
    const { renderer: t } = e, s = t.getRenderObjectFunction();
    t.setRenderObjectFunction((n, r, i, a, u, c, l, d) => {
      if ((u.isMeshToonMaterial || u.isMeshToonNodeMaterial) && u.wireframe === !1) {
        const h = this._getOutlineMaterial(u);
        t.renderObject(n, r, i, a, h, c, l, d);
      }
      t.renderObject(n, r, i, a, u, c, l, d);
    }), super.updateBefore(e), t.setRenderObjectFunction(s);
  }
  /**
   * Creates the material used for outline rendering.
   *
   * @private
   * @return {NodeMaterial} The outline material.
   */
  _createMaterial() {
    const e = new ge();
    e.isMeshToonOutlineMaterial = !0, e.name = "Toon_Outline", e.side = Tt;
    const t = We.negate(), s = _s.mul(rn), n = g(1), r = s.mul(I(pe, 1)), i = s.mul(I(pe.add(t), 1)), a = Gt(r.sub(i));
    return e.vertexNode = r.add(a.mul(this.thicknessNode).mul(r.w).mul(n)), e.colorNode = I(this.colorNode, this.alphaNode), e;
  }
  /**
   * For the given toon material, this method returns a corresponding
   * outline material.
   *
   * @private
   * @param {(MeshToonMaterial|MeshToonNodeMaterial)} originalMaterial - The toon material.
   * @return {NodeMaterial} The outline material.
   */
  _getOutlineMaterial(e) {
    let t = this._materialCache.get(e);
    return t === void 0 && (t = this._createMaterial(), this._materialCache.set(e, t)), t;
  }
}
const GN = (o, e, t = new Ct(0, 0, 0), s = 3e-3, n = 1) => E(new VN(o, e, E(t), E(s), E(n))), gf = /* @__PURE__ */ b(([o, e]) => o.mul(e).clamp()).setLayout({
  name: "linearToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), mf = /* @__PURE__ */ b(([o, e]) => (o = o.mul(e), o.div(o.add(1)).clamp())).setLayout({
  name: "reinhardToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), yf = /* @__PURE__ */ b(([o, e]) => {
  o = o.mul(e), o = o.sub(4e-3).max(0);
  const t = o.mul(o.mul(6.2).add(0.5)), s = o.mul(o.mul(6.2).add(1.7)).add(0.06);
  return t.div(s).pow(2.2);
}).setLayout({
  name: "cineonToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), ON = /* @__PURE__ */ b(([o]) => {
  const e = o.mul(o.add(0.0245786)).sub(90537e-9), t = o.mul(o.add(0.432951).mul(0.983729)).add(0.238081);
  return e.div(t);
}), xf = /* @__PURE__ */ b(([o, e]) => {
  const t = Le(
    0.59719,
    0.35458,
    0.04823,
    0.076,
    0.90834,
    0.01566,
    0.0284,
    0.13383,
    0.83777
  ), s = Le(
    1.60475,
    -0.53108,
    -0.07367,
    -0.10208,
    1.10813,
    -605e-5,
    -327e-5,
    -0.07276,
    1.07602
  );
  return o = o.mul(e).div(0.6), o = t.mul(o), o = ON(o), o = s.mul(o), o.clamp();
}).setLayout({
  name: "acesFilmicToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), kN = /* @__PURE__ */ Le(T(1.6605, -0.1246, -0.0182), T(-0.5876, 1.1329, -0.1006), T(-0.0728, -83e-4, 1.1187)), zN = /* @__PURE__ */ Le(T(0.6274, 0.0691, 0.0164), T(0.3293, 0.9195, 0.088), T(0.0433, 0.0113, 0.8956)), $N = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = T(e.mul(e)).toVar(), s = T(t.mul(t)).toVar();
  return g(15.5).mul(s.mul(t)).sub($(40.14, s.mul(e))).add($(31.96, s).sub($(6.868, t.mul(e))).add($(0.4298, t).add($(0.1191, e).sub(232e-5))));
}), Tf = /* @__PURE__ */ b(([o, e]) => {
  const t = T(o).toVar(), s = Le(T(0.856627153315983, 0.137318972929847, 0.11189821299995), T(0.0951212405381588, 0.761241990602591, 0.0767994186031903), T(0.0482516061458583, 0.101439036467562, 0.811302368396859)), n = Le(T(1.1271005818144368, -0.1413297634984383, -0.14132976349843826), T(-0.11060664309660323, 1.157823702216272, -0.11060664309660294), T(-0.016493938717834573, -0.016493938717834257, 1.2519364065950405)), r = g(-12.47393), i = g(4.026069);
  return t.mulAssign(e), t.assign(zN.mul(t)), t.assign(s.mul(t)), t.assign(fe(t, 1e-10)), t.assign(mt(t)), t.assign(t.sub(r).div(i.sub(r))), t.assign(_t(t, 0, 1)), t.assign($N(t)), t.assign(n.mul(t)), t.assign(ot(fe(T(0), t), T(2.2))), t.assign(kN.mul(t)), t.assign(_t(t, 0, 1)), t;
}).setLayout({
  name: "agxToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
}), _f = /* @__PURE__ */ b(([o, e]) => {
  const t = g(0.76), s = g(0.15);
  o = o.mul(e);
  const n = $e(o.r, $e(o.g, o.b)), r = Me(n.lessThan(0.08), n.sub($(6.25, n.mul(n))), 0.04);
  o.subAssign(r);
  const i = fe(o.r, fe(o.g, o.b));
  H(i.lessThan(t), () => o);
  const a = K(1, t), u = K(1, a.mul(a).div(i.add(a.sub(t))));
  o.mulAssign(u.div(i));
  const c = K(1, ut(1, s.mul(i.sub(u)).add(1)));
  return Z(o, T(u), c);
}).setLayout({
  name: "neutralToneMapping",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" },
    { name: "exposure", type: "float" }
  ]
});
class be extends G {
  static get type() {
    return "CodeNode";
  }
  /**
   * Constructs a new code node.
   *
   * @param {String} [code=''] - The native code.
   * @param {Array<Node>} [includes=[]] - An array of includes.
   * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
   */
  constructor(e = "", t = [], s = "") {
    super("code"), this.isCodeNode = !0, this.code = e, this.includes = t, this.language = s;
  }
  /**
   * The method is overwritten so it always returns `true`.
   *
   * @return {Boolean} Whether this node is global or not.
   */
  isGlobal() {
    return !0;
  }
  /**
   * Sets the includes of this code node.
   *
   * @param {Array<Node>} includes - The includes to set.
   * @return {CodeNode} A reference to this node.
   */
  setIncludes(e) {
    return this.includes = e, this;
  }
  /**
   * Returns the includes of this code node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Array<Node>} The includes.
   */
  getIncludes() {
    return this.includes;
  }
  generate(e) {
    const t = this.getIncludes(e);
    for (const n of t)
      n.build(e);
    const s = e.getCodeFromNode(this, this.getNodeType(e));
    return s.code = this.code, s.code;
  }
  serialize(e) {
    super.serialize(e), e.code = this.code, e.language = this.language;
  }
  deserialize(e) {
    super.deserialize(e), this.code = e.code, this.language = e.language;
  }
}
const vi = /* @__PURE__ */ C(be), WN = (o, e) => vi(o, e, "js"), HN = (o, e) => vi(o, e, "wgsl"), qN = (o, e) => vi(o, e, "glsl");
class Nf extends be {
  static get type() {
    return "FunctionNode";
  }
  /**
   * Constructs a new function node.
   *
   * @param {String} [code=''] - The native code.
   * @param {Array<Node>} [includes=[]] - An array of includes.
   * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
   */
  constructor(e = "", t = [], s = "") {
    super(e, t, s);
  }
  getNodeType(e) {
    return this.getNodeFunction(e).type;
  }
  /**
   * Returns the inputs of this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Array<NodeFunctionInput>} The inputs.
   */
  getInputs(e) {
    return this.getNodeFunction(e).inputs;
  }
  /**
   * Returns the node function for this function node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {NodeFunction} The node function.
   */
  getNodeFunction(e) {
    const t = e.getDataFromNode(this);
    let s = t.nodeFunction;
    return s === void 0 && (s = e.parser.parseFunction(this.code), t.nodeFunction = s), s;
  }
  generate(e, t) {
    super.generate(e);
    const s = this.getNodeFunction(e), n = s.name, r = s.type, i = e.getCodeFromNode(this, r);
    n !== "" && (i.name = n);
    const a = e.getPropertyName(i), u = this.getNodeFunction(e).getCode(a);
    return i.code = u + `
`, t === "property" ? a : e.format(`${a}()`, r, t);
  }
}
const bf = (o, e = [], t = "") => {
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    typeof i == "function" && (e[r] = i.functionNode);
  }
  const s = E(new Nf(o, e, t)), n = (...r) => s.call(...r);
  return n.functionNode = s, n;
}, XN = (o, e) => bf(o, e, "glsl"), KN = (o, e) => bf(o, e, "wgsl");
class YN extends G {
  static get type() {
    return "ScriptableValueNode";
  }
  /**
   * Constructs a new scriptable node.
   *
   * @param {Any} [value=null] - The value.
   */
  constructor(e = null) {
    super(), this._value = e, this._cache = null, this.inputType = null, this.outputType = null, this.events = new zc(), this.isScriptableValueNode = !0;
  }
  /**
   * Whether this node represents an output or not.
   *
   * @type {Boolean}
   * @readonly
   * @default true
   */
  get isScriptableOutputNode() {
    return this.outputType !== null;
  }
  set value(e) {
    this._value !== e && (this._cache && this.inputType === "URL" && this.value.value instanceof ArrayBuffer && (URL.revokeObjectURL(this._cache), this._cache = null), this._value = e, this.events.dispatchEvent({ type: "change" }), this.refresh());
  }
  /**
   * The node's value.
   *
   * @type {Any}
   */
  get value() {
    return this._value;
  }
  /**
   * Dispatches the `refresh` event.
   */
  refresh() {
    this.events.dispatchEvent({ type: "refresh" });
  }
  /**
   * The `value` property usually represents a node or even binary data in form of array buffers.
   * In this case, this method tries to return the actual value behind the complex type.
   *
   * @return {Any} The value.
   */
  getValue() {
    const e = this.value;
    if (e && this._cache === null && this.inputType === "URL" && e.value instanceof ArrayBuffer)
      this._cache = URL.createObjectURL(new Blob([e.value]));
    else if (e && e.value !== null && e.value !== void 0 && ((this.inputType === "URL" || this.inputType === "String") && typeof e.value == "string" || this.inputType === "Number" && typeof e.value == "number" || this.inputType === "Vector2" && e.value.isVector2 || this.inputType === "Vector3" && e.value.isVector3 || this.inputType === "Vector4" && e.value.isVector4 || this.inputType === "Color" && e.value.isColor || this.inputType === "Matrix3" && e.value.isMatrix3 || this.inputType === "Matrix4" && e.value.isMatrix4))
      return e.value;
    return this._cache || e;
  }
  /**
   * Overwritten since the node type is inferred from the value.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.value && this.value.isNode ? this.value.getNodeType(e) : "float";
  }
  setup() {
    return this.value && this.value.isNode ? this.value : g();
  }
  serialize(e) {
    super.serialize(e), this.value !== null ? this.inputType === "ArrayBuffer" ? e.value = Il(this.value) : e.value = this.value ? this.value.toJSON(e.meta).uuid : null : e.value = null, e.inputType = this.inputType, e.outputType = this.outputType;
  }
  deserialize(e) {
    super.deserialize(e);
    let t = null;
    e.value !== null && (e.inputType === "ArrayBuffer" ? t = Ll(e.value) : e.inputType === "Texture" ? t = e.meta.textures[e.value] : t = e.meta.nodes[e.value] || null), this.value = t, this.inputType = e.inputType, this.outputType = e.outputType;
  }
}
const Ur = /* @__PURE__ */ C(YN);
class Sf extends Map {
  get(e, t = null, ...s) {
    if (this.has(e)) return super.get(e);
    if (t !== null) {
      const n = t(...s);
      return this.set(e, n), n;
    }
  }
}
class jN {
  constructor(e) {
    this.scriptableNode = e;
  }
  get parameters() {
    return this.scriptableNode.parameters;
  }
  get layout() {
    return this.scriptableNode.getLayout();
  }
  getInputLayout(e) {
    return this.scriptableNode.getInputLayout(e);
  }
  get(e) {
    const t = this.parameters[e];
    return t ? t.getValue() : null;
  }
}
const Pr = new Sf();
class QN extends G {
  static get type() {
    return "ScriptableNode";
  }
  /**
   * Constructs a new scriptable node.
   *
   * @param {CodeNode?} [codeNode=null] - The code node.
   * @param {Object} [parameters={}] - The parameters definition.
   */
  constructor(e = null, t = {}) {
    super(), this.codeNode = e, this.parameters = t, this._local = new Sf(), this._output = Ur(), this._outputs = {}, this._source = this.source, this._method = null, this._object = null, this._value = null, this._needsOutputUpdate = !0, this.onRefresh = this.onRefresh.bind(this), this.isScriptableNode = !0;
  }
  /**
   * The source code of the scriptable node.
   *
   * @type {String}
   */
  get source() {
    return this.codeNode ? this.codeNode.code : "";
  }
  /**
   * Sets the reference of a local script variable.
   *
   * @param {String} name - The variable name.
   * @param {Object} value - The reference to set.
   * @return {Resources} The resource map
   */
  setLocal(e, t) {
    return this._local.set(e, t);
  }
  /**
   * Gets the value of a local script variable.
   *
   * @param {String} name - The variable name.
   * @return {Object} The value.
   */
  getLocal(e) {
    return this._local.get(e);
  }
  /**
   * Event listener for the `refresh` event.
   */
  onRefresh() {
    this._refresh();
  }
  /**
   * Returns an input from the layout with the given id/name.
   *
   * @param {String} id - The id/name of the input.
   * @return {Object} The element entry.
   */
  getInputLayout(e) {
    for (const t of this.getLayout())
      if (t.inputType && (t.id === e || t.name === e))
        return t;
  }
  /**
   * Returns an output from the layout with the given id/name.
   *
   * @param {String} id - The id/name of the output.
   * @return {Object} The element entry.
   */
  getOutputLayout(e) {
    for (const t of this.getLayout())
      if (t.outputType && (t.id === e || t.name === e))
        return t;
  }
  /**
   * Defines a script output for the given name and value.
   *
   * @param {String} name - The name of the output.
   * @param {Node} value - The node value.
   * @return {ScriptableNode} A reference to this node.
   */
  setOutput(e, t) {
    const s = this._outputs;
    return s[e] === void 0 ? s[e] = Ur(t) : s[e].value = t, this;
  }
  /**
   * Returns a script output for the given name.
   *
   * @param {String} name - The name of the output.
   * @return {ScriptableValueNode} The node value.
   */
  getOutput(e) {
    return this._outputs[e];
  }
  /**
   * Returns a paramater for the given name
   *
   * @param {String} name - The name of the parameter.
   * @return {ScriptableValueNode} The node value.
   */
  getParameter(e) {
    return this.parameters[e];
  }
  /**
   * Sets a value for the given parameter name.
   *
   * @param {String} name - The parameter name.
   * @param {Any} value - The parameter value.
   * @return {ScriptableNode} A reference to this node.
   */
  setParameter(e, t) {
    const s = this.parameters;
    return t && t.isScriptableNode ? (this.deleteParameter(e), s[e] = t, s[e].getDefaultOutput().events.addEventListener("refresh", this.onRefresh)) : t && t.isScriptableValueNode ? (this.deleteParameter(e), s[e] = t, s[e].events.addEventListener("refresh", this.onRefresh)) : s[e] === void 0 ? (s[e] = Ur(t), s[e].events.addEventListener("refresh", this.onRefresh)) : s[e].value = t, this;
  }
  /**
   * Returns the value of this node which is the value of
   * the default output.
   *
   * @return {Node} The value.
   */
  getValue() {
    return this.getDefaultOutput().getValue();
  }
  /**
   * Deletes a parameter from the script.
   *
   * @param {String} name - The parameter to remove.
   * @return {ScriptableNode} A reference to this node.
   */
  deleteParameter(e) {
    let t = this.parameters[e];
    return t && (t.isScriptableNode && (t = t.getDefaultOutput()), t.events.removeEventListener("refresh", this.onRefresh)), this;
  }
  /**
   * Deletes all parameters from the script.
   *
   * @return {ScriptableNode} A reference to this node.
   */
  clearParameters() {
    for (const e of Object.keys(this.parameters))
      this.deleteParameter(e);
    return this.needsUpdate = !0, this;
  }
  /**
   * Calls a function from the script.
   *
   * @param {String} name - The function name.
   * @param {...Any} params - A list of parameters.
   * @return {Any} The result of the function call.
   */
  call(e, ...t) {
    const n = this.getObject()[e];
    if (typeof n == "function")
      return n(...t);
  }
  /**
   * Asynchronously calls a function from the script.
   *
   * @param {String} name - The function name.
   * @param {...Any} params - A list of parameters.
   * @return {Any} The result of the function call.
   */
  async callAsync(e, ...t) {
    const n = this.getObject()[e];
    if (typeof n == "function")
      return n.constructor.name === "AsyncFunction" ? await n(...t) : n(...t);
  }
  /**
   * Overwritten since the node types is inferred from the script's output.
   *
   * @param {NodeBuilder} builder - The current node builder
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.getDefaultOutputNode().getNodeType(e);
  }
  /**
   * Refreshes the script node.
   *
   * @param {String?} [output=null] - An optional output.
   */
  refresh(e = null) {
    e !== null ? this.getOutput(e).refresh() : this._refresh();
  }
  /**
   * Returns an object representation of the script.
   *
   * @return {Object} The result object.
   */
  getObject() {
    if (this.needsUpdate && this.dispose(), this._object !== null) return this._object;
    const e = () => this.refresh(), t = (c, l) => this.setOutput(c, l), s = new jN(this), n = Pr.get("THREE"), r = Pr.get("TSL"), i = this.getMethod(), a = [s, this._local, Pr, e, t, n, r];
    this._object = i(...a);
    const u = this._object.layout;
    if (u && (u.cache === !1 && this._local.clear(), this._output.outputType = u.outputType || null, Array.isArray(u.elements)))
      for (const c of u.elements) {
        const l = c.id || c.name;
        c.inputType && (this.getParameter(l) === void 0 && this.setParameter(l, null), this.getParameter(l).inputType = c.inputType), c.outputType && (this.getOutput(l) === void 0 && this.setOutput(l, null), this.getOutput(l).outputType = c.outputType);
      }
    return this._object;
  }
  deserialize(e) {
    super.deserialize(e);
    for (const t in this.parameters) {
      let s = this.parameters[t];
      s.isScriptableNode && (s = s.getDefaultOutput()), s.events.addEventListener("refresh", this.onRefresh);
    }
  }
  /**
   * Returns the layout of the script.
   *
   * @return {Object} The script's layout.
   */
  getLayout() {
    return this.getObject().layout;
  }
  /**
   * Returns default node output of the script.
   *
   * @return {Node} The default node output.
   */
  getDefaultOutputNode() {
    const e = this.getDefaultOutput().value;
    return e && e.isNode ? e : g();
  }
  /**
   * Returns default output of the script.
   *
   * @return {ScriptableValueNode} The default output.
   */
  getDefaultOutput() {
    return this._exec()._output;
  }
  /**
   * Returns a function created from the node's script.
   *
   * @return {Function} The function representing the node's code.
   */
  getMethod() {
    if (this.needsUpdate && this.dispose(), this._method !== null) return this._method;
    const e = ["parameters", "local", "global", "refresh", "setOutput", "THREE", "TSL"], s = ["layout", "init", "main", "dispose"].join(", "), n = "var " + s + `; var output = {};
`, r = `
return { ...output, ` + s + " };", i = n + this.codeNode.code + r;
    return this._method = new Function(...e, i), this._method;
  }
  /**
   * Frees all internal resources.
   */
  dispose() {
    this._method !== null && (this._object && typeof this._object.dispose == "function" && this._object.dispose(), this._method = null, this._object = null, this._source = null, this._value = null, this._needsOutputUpdate = !0, this._output.value = null, this._outputs = {});
  }
  setup() {
    return this.getDefaultOutputNode();
  }
  getCacheKey(e) {
    const t = [wl(this.source), this.getDefaultOutputNode().getCacheKey(e)];
    for (const s in this.parameters)
      t.push(this.parameters[s].getCacheKey(e));
    return ni(t);
  }
  set needsUpdate(e) {
    e === !0 && this.dispose();
  }
  get needsUpdate() {
    return this.source !== this._source;
  }
  /**
   * Executes the `main` function of the script.
   *
   * @private
   * @return {ScriptableNode} A reference to this node.
   */
  _exec() {
    return this.codeNode === null ? this : (this._needsOutputUpdate === !0 && (this._value = this.call("main"), this._needsOutputUpdate = !1), this._output.value = this._value, this);
  }
  /**
   * Executes the refresh.
   *
   * @private
   */
  _refresh() {
    this.needsUpdate = !0, this._exec(), this._output.refresh();
  }
}
const ZN = /* @__PURE__ */ C(QN);
function vf(o) {
  let e;
  const t = o.context.getViewZ;
  return t !== void 0 && (e = t(this)), (e || xe.z).negate();
}
const ou = b(([o, e], t) => {
  const s = vf(t);
  return Ot(o, e, s);
}), au = b(([o], e) => {
  const t = vf(e);
  return o.mul(o, t, t).negate().exp().oneMinus();
}), zn = b(([o, e]) => I(e.toFloat().mix(Gn.rgb, o.toVec3()), Gn.a));
function JN(o, e, t) {
  return console.warn('THREE.TSL: "rangeFog( color, near, far )" is deprecated. Use "fog( color, rangeFogFactor( near, far ) )" instead.'), zn(o, ou(e, t));
}
function eb(o, e) {
  return console.warn('THREE.TSL: "densityFog( color, density )" is deprecated. Use "fog( color, densityFogFactor( density ) )" instead.'), zn(o, au(e));
}
let ts = null, ss = null;
class tb extends G {
  static get type() {
    return "RangeNode";
  }
  /**
   * Constructs a new range node.
   *
   * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
   * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
   */
  constructor(e = g(), t = g()) {
    super(), this.minNode = e, this.maxNode = t;
  }
  /**
   * Returns the vector length which is computed based on the range definition.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {Number} The vector length.
   */
  getVectorLength(e) {
    const t = e.getTypeLength(Yt(this.minNode.value)), s = e.getTypeLength(Yt(this.maxNode.value));
    return t > s ? t : s;
  }
  /**
   * This method is overwritten since the node type is inferred from range definition.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return e.object.count > 1 ? e.getTypeFromLength(this.getVectorLength(e)) : "float";
  }
  setup(e) {
    const t = e.object;
    let s = null;
    if (t.count > 1) {
      const n = this.minNode.value, r = this.maxNode.value, i = e.getTypeLength(Yt(n)), a = e.getTypeLength(Yt(r));
      ts = ts || new Ce(), ss = ss || new Ce(), ts.setScalar(0), ss.setScalar(0), i === 1 ? ts.setScalar(n) : n.isColor ? ts.set(n.r, n.g, n.b, 1) : ts.set(n.x, n.y, n.z || 0, n.w || 0), a === 1 ? ss.setScalar(r) : r.isColor ? ss.set(r.r, r.g, r.b, 1) : ss.set(r.x, r.y, r.z || 0, r.w || 0);
      const u = 4, c = u * t.count, l = new Float32Array(c);
      for (let h = 0; h < c; h++) {
        const p = h % u, f = ts.getComponent(p), m = ss.getComponent(p);
        l[h] = $c.lerp(f, m, Math.random());
      }
      const d = this.getNodeType(e);
      if (t.count <= 4096)
        s = Zn(l, "vec4", t.count).element(sr).convert(d);
      else {
        const h = new oa(l, 4);
        e.geometry.setAttribute("__range" + this.id, h), s = Wr(h).convert(d);
      }
    } else
      s = g(0);
    return s;
  }
}
const sb = /* @__PURE__ */ C(tb);
class nb extends G {
  static get type() {
    return "ComputeBuiltinNode";
  }
  /**
   * Constructs a new compute builtin node.
   *
   * @param {String} builtinName - The built-in name.
   * @param {String} nodeType - The node type.
   */
  constructor(e, t) {
    super(t), this._builtinName = e;
  }
  /**
   * This method is overwritten since hash is derived from the built-in name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The hash.
   */
  getHash(e) {
    return this.getBuiltinName(e);
  }
  /**
   * This method is overwritten since the node type is simply derived from `nodeType`..
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType() {
    return this.nodeType;
  }
  /**
   * Sets the builtin name.
   *
   * @param {String} builtinName - The built-in name.
   * @return {ComputeBuiltinNode} A reference to this node.
   */
  setBuiltinName(e) {
    return this._builtinName = e, this;
  }
  /**
   * Returns the builtin name.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The builtin name.
   */
  getBuiltinName() {
    return this._builtinName;
  }
  /**
   * Whether the current node builder has the builtin or not.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  hasBuiltin(e) {
    e.hasBuiltin(this._builtinName);
  }
  generate(e, t) {
    const s = this.getBuiltinName(e), n = this.getNodeType(e);
    return e.shaderStage === "compute" ? e.format(s, n, t) : (console.warn(`ComputeBuiltinNode: Compute built-in value ${s} can not be accessed in the ${e.shaderStage} stage`), e.generateConst(n));
  }
  serialize(e) {
    super.serialize(e), e.global = this.global, e._builtinName = this._builtinName;
  }
  deserialize(e) {
    super.deserialize(e), this.global = e.global, this._builtinName = e._builtinName;
  }
}
const Ai = (o, e) => E(new nb(o, e)), rb = /* @__PURE__ */ Ai("numWorkgroups", "uvec3"), ib = /* @__PURE__ */ Ai("workgroupId", "uvec3"), ob = /* @__PURE__ */ Ai("localId", "uvec3"), ab = /* @__PURE__ */ Ai("subgroupSize", "uint");
class ub extends G {
  /**
   * Constructs a new barrier node.
   *
   * @param {String} scope - The scope defines the behavior of the node.
   */
  constructor(e) {
    super(), this.scope = e;
  }
  generate(e) {
    const { scope: t } = this, { renderer: s } = e;
    s.backend.isWebGLBackend === !0 ? e.addFlowCode(`	// ${t}Barrier 
`) : e.addLineFlowCode(`${t}Barrier()`, this);
  }
}
const uu = C(ub), cb = () => uu("workgroup").append(), lb = () => uu("storage").append(), db = () => uu("texture").append();
class hb extends Ts {
  /**
   * Constructs a new workgroup info element node.
   *
   * @param {Node} workgroupInfoNode - The workgroup info node.
   * @param {Node} indexNode - The index node that defines the element access.
   */
  constructor(e, t) {
    super(e, t), this.isWorkgroupInfoElementNode = !0;
  }
  generate(e, t) {
    let s;
    const n = e.context.assign;
    if (s = super.generate(e), n !== !0) {
      const r = this.getNodeType(e);
      s = e.format(s, r, t);
    }
    return s;
  }
}
class pb extends G {
  /**
   * Constructs a new buffer scoped to type scope.
   *
   * @param {String} scope - TODO.
   * @param {String} bufferType - The data type of a 'workgroup' scoped buffer element.
   * @param {Number} [bufferCount=0] - The number of elements in the buffer.
   */
  constructor(e, t, s = 0) {
    super(t), this.bufferType = t, this.bufferCount = s, this.isWorkgroupInfoNode = !0, this.elementType = t, this.scope = e;
  }
  /**
   * Sets the name/label of this node.
   *
   * @param {String} name - The name to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */
  label(e) {
    return this.name = e, this;
  }
  /**
   * Sets the scope of this node.
   *
   * @param {String} scope - The scope to set.
   * @return {WorkgroupInfoNode} A reference to this node.
   */
  setScope(e) {
    return this.scope = e, this;
  }
  /**
   * The data type of the array buffer.
   *
   * @return {String} The element type.
   */
  getElementType() {
    return this.elementType;
  }
  /**
   * Overwrites the default implementation since the input type
   * is inferred from the scope.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType() {
    return `${this.scope}Array`;
  }
  /**
   * This method can be used to access elements via an index node.
   *
   * @param {IndexNode} indexNode - indexNode.
   * @return {WorkgroupInfoElementNode} A reference to an element.
   */
  element(e) {
    return E(new hb(this, e));
  }
  generate(e) {
    return e.getScopedArray(this.name || `${this.scope}Array_${this.id}`, this.scope.toLowerCase(), this.bufferType, this.bufferCount);
  }
}
const fb = (o, e) => E(new pb("Workgroup", o, e));
class Ee extends Ne {
  static get type() {
    return "AtomicFunctionNode";
  }
  /**
   * Constructs a new atomic function node.
   *
   * @param {String} method - The signature of the atomic function to construct.
   * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
   * @param {Node} valueNode - The value that mutates the atomic variable.
   * @param {Node?} [storeNode=null] - A variable storing the return value of an atomic operation, typically the value of the atomic variable before the operation.
   */
  constructor(e, t, s, n = null) {
    super("uint"), this.method = e, this.pointerNode = t, this.valueNode = s, this.storeNode = n;
  }
  /**
   * Overwrites the default implementation to return the type of
   * the pointer node.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The input type.
   */
  getInputType(e) {
    return this.pointerNode.getNodeType(e);
  }
  /**
   * Overwritten since the node type is inferred from the input type.
   *
   * @param {NodeBuilder} builder - The current node builder.
   * @return {String} The node type.
   */
  getNodeType(e) {
    return this.getInputType(e);
  }
  generate(e) {
    const t = this.method, s = this.getNodeType(e), n = this.getInputType(e), r = this.pointerNode, i = this.valueNode, a = [];
    a.push(`&${r.build(e, n)}`), a.push(i.build(e, n));
    const u = `${e.getMethod(t, s)}( ${a.join(", ")} )`;
    if (this.storeNode !== null) {
      const c = this.storeNode.build(e, n);
      e.addLineFlowCode(`${c} = ${u}`, this);
    } else
      e.addLineFlowCode(u, this);
  }
}
Ee.ATOMIC_LOAD = "atomicLoad";
Ee.ATOMIC_STORE = "atomicStore";
Ee.ATOMIC_ADD = "atomicAdd";
Ee.ATOMIC_SUB = "atomicSub";
Ee.ATOMIC_MAX = "atomicMax";
Ee.ATOMIC_MIN = "atomicMin";
Ee.ATOMIC_AND = "atomicAnd";
Ee.ATOMIC_OR = "atomicOr";
Ee.ATOMIC_XOR = "atomicXor";
const gb = C(Ee), zt = (o, e, t, s = null) => {
  const n = gb(o, e, t, s);
  return n.append(), n;
}, mb = (o, e, t = null) => zt(Ee.ATOMIC_STORE, o, e, t), yb = (o, e, t = null) => zt(Ee.ATOMIC_ADD, o, e, t), xb = (o, e, t = null) => zt(Ee.ATOMIC_SUB, o, e, t), Tb = (o, e, t = null) => zt(Ee.ATOMIC_MAX, o, e, t), _b = (o, e, t = null) => zt(Ee.ATOMIC_MIN, o, e, t), Nb = (o, e, t = null) => zt(Ee.ATOMIC_AND, o, e, t), bb = (o, e, t = null) => zt(Ee.ATOMIC_OR, o, e, t), Sb = (o, e, t = null) => zt(Ee.ATOMIC_XOR, o, e, t);
let fr;
function rr(o) {
  fr = fr || /* @__PURE__ */ new WeakMap();
  let e = fr.get(o);
  return e === void 0 && fr.set(o, e = {}), e;
}
function cu(o) {
  const e = rr(o);
  return e.shadowMatrix || (e.shadowMatrix = L("mat4").setGroup(O).onRenderUpdate(() => (o.castShadow !== !0 && o.shadow.updateMatrices(o), o.shadow.matrix)));
}
function Af(o) {
  const e = rr(o);
  if (e.projectionUV === void 0) {
    const t = cu(o).mul(It);
    e.projectionUV = t.xyz.div(t.w);
  }
  return e.projectionUV;
}
function lu(o) {
  const e = rr(o);
  return e.position || (e.position = L(new Y()).setGroup(O).onRenderUpdate((t, s) => s.value.setFromMatrixPosition(o.matrixWorld)));
}
function Rf(o) {
  const e = rr(o);
  return e.targetPosition || (e.targetPosition = L(new Y()).setGroup(O).onRenderUpdate((t, s) => s.value.setFromMatrixPosition(o.target.matrixWorld)));
}
function Ri(o) {
  const e = rr(o);
  return e.viewPosition || (e.viewPosition = L(new Y()).setGroup(O).onRenderUpdate(({ camera: t }, s) => {
    s.value = s.value || new Y(), s.value.setFromMatrixPosition(o.matrixWorld), s.value.applyMatrix4(t.matrixWorldInverse);
  }));
}
const du = (o) => Xe.transformDirection(lu(o).sub(Rf(o))), vb = (o) => o.sort((e, t) => e.id - t.id), Ab = (o, e) => {
  for (const t of e)
    if (t.isAnalyticLightNode && t.light.id === o)
      return t;
  return null;
}, Hi = /* @__PURE__ */ new WeakMap();
class hu extends G {
  static get type() {
    return "LightsNode";
  }
  /**
   * Constructs a new lights node.
   */
  constructor() {
    super("vec3"), this.totalDiffuseNode = T().toVar("totalDiffuse"), this.totalSpecularNode = T().toVar("totalSpecular"), this.outgoingLightNode = T().toVar("outgoingLight"), this._lights = [], this._lightNodes = null, this._lightNodesHash = null, this.global = !0;
  }
  /**
   * Overwrites the default {@link Node#customCacheKey} implementation by including the
   * light IDs into the cache key.
   *
   * @return {Number} The custom cache key.
   */
  customCacheKey() {
    const e = [], t = this._lights;
    for (let s = 0; s < t.length; s++)
      e.push(t[s].id);
    return ni(e);
  }
  /**
   * Computes a hash value for identifying the current light nodes setup.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {String} The computed hash.
   */
  getHash(e) {
    if (this._lightNodesHash === null) {
      this._lightNodes === null && this.setupLightsNode(e);
      const t = [];
      for (const s of this._lightNodes)
        t.push(s.getSelf().getHash());
      this._lightNodesHash = "lights-" + t.join(",");
    }
    return this._lightNodesHash;
  }
  analyze(e) {
    const t = e.getDataFromNode(this);
    for (const s of t.nodes)
      s.build(e);
  }
  /**
   * Creates lighting nodes for each scene light. This makes it possible to further
   * process lights in the node system.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   */
  setupLightsNode(e) {
    const t = [], s = this._lightNodes, n = vb(this._lights), r = e.renderer.library;
    for (const i of n)
      if (i.isNode)
        t.push(E(i));
      else {
        let a = null;
        if (s !== null && (a = Ab(i.id, s)), a === null) {
          const u = r.getLightNodeClass(i.constructor);
          if (u === null) {
            console.warn(`LightsNode.setupNodeLights: Light node not found for ${i.constructor.name}`);
            continue;
          }
          let c = null;
          Hi.has(i) ? c = Hi.get(i) : (c = E(new u(i)), Hi.set(i, c)), t.push(c);
        }
      }
    this._lightNodes = t;
  }
  /**
   * Setups the internal lights by building all respective
   * light nodes.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Array<LightingNode>} lightNodes - An array of lighting nodes.
   */
  setupLights(e, t) {
    for (const s of t)
      s.build(e);
  }
  /**
   * The implementation makes sure that for each light in the scene
   * there is a corresponding light node. By building the light nodes
   * and evaluating the lighting model the outgoing light is computed.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec3>} A node representing the outgoing light.
   */
  setup(e) {
    this._lightNodes === null && this.setupLightsNode(e);
    const t = e.context, s = t.lightingModel;
    let n = this.outgoingLightNode;
    if (s) {
      const { _lightNodes: r, totalDiffuseNode: i, totalSpecularNode: a } = this;
      t.outgoingLight = n;
      const u = e.addStack(), c = e.getDataFromNode(this);
      c.nodes = u.nodes, s.start(t, u, e), this.setupLights(e, r), s.indirect(t, u, e);
      const { backdrop: l, backdropAlpha: d } = t, { directDiffuse: h, directSpecular: p, indirectDiffuse: f, indirectSpecular: m } = t.reflectedLight;
      let _ = h.add(f);
      l !== null && (d !== null ? _ = T(d.mix(_, l)) : _ = T(l), t.material.transparent = !0), i.assign(_), a.assign(p.add(m)), n.assign(i.add(a)), s.finish(t, u, e), n = n.bypass(e.removeStack());
    }
    return n;
  }
  /**
   * Configures this node with an array of lights.
   *
   * @param {Array<Light>} lights - An array of lights.
   * @return {LightsNode} A reference to this node.
   */
  setLights(e) {
    return this._lights = e, this._lightNodes = null, this._lightNodesHash = null, this;
  }
  /**
   * Returns an array of the scene's lights.
   *
   * @return {Array<Light>} The scene's lights.
   */
  getLights() {
    return this._lights;
  }
  /**
   * Whether the scene has lights or not.
   *
   * @type {Boolean}
   */
  get hasLights() {
    return this._lights.length > 0;
  }
}
const Rb = (o = []) => E(new hu()).setLights(o);
class Cb extends G {
  static get type() {
    return "ShadowBaseNode";
  }
  /**
   * Constructs a new shadow base node.
   *
   * @param {Light} light - The shadow casting light.
   */
  constructor(e) {
    super(), this.light = e, this.updateBeforeType = z.RENDER, this.isShadowBaseNode = !0;
  }
  /**
   * Setups the shadow position node which is by default the predefined TSL node object `shadowPositionWorld`.
   *
   * @param {(NodeBuilder|{Material})} object - A configuration object that must at least hold a material reference.
   */
  setupShadowPosition({ material: e }) {
    pu.assign(e.shadowPositionNode || It);
  }
  /**
   * Can be called when the shadow isn't required anymore. That can happen when
   * a lighting node stops casting shadows by setting {@link Object3D#castShadow}
   * to `false`.
   */
  dispose() {
    this.updateBeforeType = z.NONE;
  }
}
const pu = /* @__PURE__ */ T().toVar("shadowPositionWorld");
function Eb(o, e = {}) {
  return e.toneMapping = o.toneMapping, e.toneMappingExposure = o.toneMappingExposure, e.outputColorSpace = o.outputColorSpace, e.renderTarget = o.getRenderTarget(), e.activeCubeFace = o.getActiveCubeFace(), e.activeMipmapLevel = o.getActiveMipmapLevel(), e.renderObjectFunction = o.getRenderObjectFunction(), e.pixelRatio = o.getPixelRatio(), e.mrt = o.getMRT(), e.clearColor = o.getClearColor(e.clearColor || new Ct()), e.clearAlpha = o.getClearAlpha(), e.autoClear = o.autoClear, e.scissorTest = o.getScissorTest(), e;
}
function wb(o, e) {
  return e = Eb(o, e), o.setMRT(null), o.setRenderObjectFunction(null), o.setClearColor(0, 1), o.autoClear = !0, e;
}
function Mb(o, e) {
  o.toneMapping = e.toneMapping, o.toneMappingExposure = e.toneMappingExposure, o.outputColorSpace = e.outputColorSpace, o.setRenderTarget(e.renderTarget, e.activeCubeFace, e.activeMipmapLevel), o.setRenderObjectFunction(e.renderObjectFunction), o.setPixelRatio(e.pixelRatio), o.setMRT(e.mrt), o.setClearColor(e.clearColor, e.clearAlpha), o.autoClear = e.autoClear, o.setScissorTest(e.scissorTest);
}
function Bb(o, e = {}) {
  return e.background = o.background, e.backgroundNode = o.backgroundNode, e.overrideMaterial = o.overrideMaterial, e;
}
function Fb(o, e) {
  return e = Bb(o, e), o.background = null, o.backgroundNode = null, o.overrideMaterial = null, e;
}
function Ub(o, e) {
  o.background = e.background, o.backgroundNode = e.backgroundNode, o.overrideMaterial = e.overrideMaterial;
}
function Pb(o, e, t) {
  return t = wb(o, t), t = Fb(e, t), t;
}
function Db(o, e, t) {
  Mb(o, t), Ub(e, t);
}
const hc = /* @__PURE__ */ new WeakMap(), Ib = /* @__PURE__ */ b(([o, e, t]) => {
  let s = It.sub(o).length();
  return s = s.sub(e).div(t.sub(e)), s = s.saturate(), s;
}), Lb = (o) => {
  const e = o.shadow.camera, t = te("near", "float", e).setGroup(O), s = te("far", "float", e).setGroup(O), n = Nh(o);
  return Ib(n, t, s);
}, Vb = (o) => {
  let e = hc.get(o);
  if (e === void 0) {
    const t = o.isPointLight ? Lb(o) : null;
    e = new ge(), e.colorNode = I(0, 0, 0, 1), e.depthNode = t, e.isShadowNodeMaterial = !0, e.name = "ShadowMaterial", e.fog = !1, hc.set(o, e);
  }
  return e;
}, Cf = /* @__PURE__ */ b(({ depthTexture: o, shadowCoord: e }) => X(o, e.xy).compare(e.z)), Ef = /* @__PURE__ */ b(({ depthTexture: o, shadowCoord: e, shadow: t }) => {
  const s = (m, _) => X(o, m).compare(_), n = te("mapSize", "vec2", t).setGroup(O), r = te("radius", "float", t).setGroup(O), i = w(1).div(n), a = i.x.negate().mul(r), u = i.y.negate().mul(r), c = i.x.mul(r), l = i.y.mul(r), d = a.div(2), h = u.div(2), p = c.div(2), f = l.div(2);
  return _e(
    s(e.xy.add(w(a, u)), e.z),
    s(e.xy.add(w(0, u)), e.z),
    s(e.xy.add(w(c, u)), e.z),
    s(e.xy.add(w(d, h)), e.z),
    s(e.xy.add(w(0, h)), e.z),
    s(e.xy.add(w(p, h)), e.z),
    s(e.xy.add(w(a, 0)), e.z),
    s(e.xy.add(w(d, 0)), e.z),
    s(e.xy, e.z),
    s(e.xy.add(w(p, 0)), e.z),
    s(e.xy.add(w(c, 0)), e.z),
    s(e.xy.add(w(d, f)), e.z),
    s(e.xy.add(w(0, f)), e.z),
    s(e.xy.add(w(p, f)), e.z),
    s(e.xy.add(w(a, l)), e.z),
    s(e.xy.add(w(0, l)), e.z),
    s(e.xy.add(w(c, l)), e.z)
  ).mul(1 / 17);
}), wf = /* @__PURE__ */ b(({ depthTexture: o, shadowCoord: e, shadow: t }) => {
  const s = (l, d) => X(o, l).compare(d), n = te("mapSize", "vec2", t).setGroup(O), r = w(1).div(n), i = r.x, a = r.y, u = e.xy, c = kt(u.mul(n).add(0.5));
  return u.subAssign(c.mul(r)), _e(
    s(u, e.z),
    s(u.add(w(i, 0)), e.z),
    s(u.add(w(0, a)), e.z),
    s(u.add(r), e.z),
    Z(
      s(u.add(w(i.negate(), 0)), e.z),
      s(u.add(w(i.mul(2), 0)), e.z),
      c.x
    ),
    Z(
      s(u.add(w(i.negate(), a)), e.z),
      s(u.add(w(i.mul(2), a)), e.z),
      c.x
    ),
    Z(
      s(u.add(w(0, a.negate())), e.z),
      s(u.add(w(0, a.mul(2))), e.z),
      c.y
    ),
    Z(
      s(u.add(w(i, a.negate())), e.z),
      s(u.add(w(i, a.mul(2))), e.z),
      c.y
    ),
    Z(
      Z(
        s(u.add(w(i.negate(), a.negate())), e.z),
        s(u.add(w(i.mul(2), a.negate())), e.z),
        c.x
      ),
      Z(
        s(u.add(w(i.negate(), a.mul(2))), e.z),
        s(u.add(w(i.mul(2), a.mul(2))), e.z),
        c.x
      ),
      c.y
    )
  ).mul(1 / 9);
}), Mf = /* @__PURE__ */ b(({ depthTexture: o, shadowCoord: e }) => {
  const t = g(1).toVar(), s = X(o).sample(e.xy).rg, n = di(e.z, s.x);
  return H(n.notEqual(g(1)), () => {
    const r = e.z.sub(s.x), i = fe(0, s.y.mul(s.y));
    let a = i.div(i.add(r.mul(r)));
    a = _t(K(a, 0.3).div(0.95 - 0.3)), t.assign(_t(fe(n, a)));
  }), t;
}), Gb = /* @__PURE__ */ b(({ samples: o, radius: e, size: t, shadowPass: s }) => {
  const n = g(0).toVar(), r = g(0).toVar(), i = o.lessThanEqual(g(1)).select(g(0), g(2).div(o.sub(1))), a = o.lessThanEqual(g(1)).select(g(0), g(-1));
  J({ start: y(0), end: y(o), type: "int", condition: "<" }, ({ i: c }) => {
    const l = a.add(g(c).mul(i)), d = s.sample(_e(nr.xy, w(0, l).mul(e)).div(t)).x;
    n.addAssign(d), r.addAssign(d.mul(d));
  }), n.divAssign(o), r.divAssign(o);
  const u = Et(r.sub(n.mul(n)));
  return w(n, u);
}), Ob = /* @__PURE__ */ b(({ samples: o, radius: e, size: t, shadowPass: s }) => {
  const n = g(0).toVar(), r = g(0).toVar(), i = o.lessThanEqual(g(1)).select(g(0), g(2).div(o.sub(1))), a = o.lessThanEqual(g(1)).select(g(0), g(-1));
  J({ start: y(0), end: y(o), type: "int", condition: "<" }, ({ i: c }) => {
    const l = a.add(g(c).mul(i)), d = s.sample(_e(nr.xy, w(l, 0).mul(e)).div(t));
    n.addAssign(d.x), r.addAssign(_e(d.y.mul(d.y), d.x.mul(d.x)));
  }), n.divAssign(o), r.divAssign(o);
  const u = Et(r.sub(n.mul(n)));
  return w(n, u);
}), kb = [Cf, Ef, wf, Mf];
let qi;
const gr = /* @__PURE__ */ new ru();
class Bf extends Cb {
  static get type() {
    return "ShadowNode";
  }
  /**
   * Constructs a new shadow node.
   *
   * @param {Light} light - The shadow casting light.
   * @param {LightShadow?} [shadow=null] - An optional light shadow.
   */
  constructor(e, t = null) {
    super(e), this.shadow = t || e.shadow, this.shadowMap = null, this.vsmShadowMapVertical = null, this.vsmShadowMapHorizontal = null, this.vsmMaterialVertical = null, this.vsmMaterialHorizontal = null, this._node = null, this.isShadowNode = !0;
  }
  /**
   * Setups the shadow filtering.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Object} inputs - A configuration object that defines the shadow filtering.
   * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
   * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
   * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
   * @param {LightShadow} inputs.shadow - The light shadow.
   * @return {Node<float>} The result node of the shadow filtering.
   */
  setupShadowFilter(e, { filterFn: t, depthTexture: s, shadowCoord: n, shadow: r }) {
    const i = n.x.greaterThanEqual(0).and(n.x.lessThanEqual(1)).and(n.y.greaterThanEqual(0)).and(n.y.lessThanEqual(1)).and(n.z.lessThanEqual(1)), a = t({ depthTexture: s, shadowCoord: n, shadow: r });
    return i.select(a, g(1));
  }
  /**
   * Setups the shadow coordinates.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
   * @return {Node<vec3>} The shadow coordinates.
   */
  setupShadowCoord(e, t) {
    const { shadow: s } = this, { renderer: n } = e, r = te("bias", "float", s).setGroup(O);
    let i = t, a;
    if (s.camera.isOrthographicCamera || n.logarithmicDepthBuffer !== !0)
      i = i.xyz.div(i.w), a = i.z, n.coordinateSystem === sn && (a = a.mul(2).sub(1));
    else {
      const u = i.w;
      i = i.xy.div(u);
      const c = te("near", "float", s.camera).setGroup(O), l = te("far", "float", s.camera).setGroup(O);
      a = Ka(u.negate(), c, l);
    }
    return i = T(
      i.x,
      i.y.oneMinus(),
      // follow webgpu standards
      a.add(r)
    ), i;
  }
  /**
   * Returns the shadow filtering function for the given shadow type.
   *
   * @param {Number} type - The shadow type.
   * @return {Function} The filtering function.
   */
  getShadowFilterFn(e) {
    return kb[e];
  }
  /**
   * Setups the shadow output node.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {Node<vec3>} The shadow output node.
   */
  setupShadow(e) {
    const { renderer: t } = e, { light: s, shadow: n } = this, r = t.shadowMap.type, i = new ys(n.mapSize.width, n.mapSize.height);
    i.compareFunction = ia;
    const a = e.createRenderTarget(n.mapSize.width, n.mapSize.height);
    if (a.depthTexture = i, n.camera.updateProjectionMatrix(), r === or) {
      i.compareFunction = null, this.vsmShadowMapVertical = e.createRenderTarget(n.mapSize.width, n.mapSize.height, { format: Bn, type: at }), this.vsmShadowMapHorizontal = e.createRenderTarget(n.mapSize.width, n.mapSize.height, { format: Bn, type: at });
      const S = X(i), A = X(this.vsmShadowMapVertical.texture), M = te("blurSamples", "float", n).setGroup(O), F = te("radius", "float", n).setGroup(O), D = te("mapSize", "vec2", n).setGroup(O);
      let P = this.vsmMaterialVertical || (this.vsmMaterialVertical = new ge());
      P.fragmentNode = Gb({ samples: M, radius: F, size: D, shadowPass: S }).context(e.getSharedContext()), P.name = "VSMVertical", P = this.vsmMaterialHorizontal || (this.vsmMaterialHorizontal = new ge()), P.fragmentNode = Ob({ samples: M, radius: F, size: D, shadowPass: A }).context(e.getSharedContext()), P.name = "VSMHorizontal";
    }
    const u = te("intensity", "float", n).setGroup(O), c = te("normalBias", "float", n).setGroup(O), l = cu(s).mul(pu.add(yi.mul(c))), d = this.setupShadowCoord(e, l), h = n.filterNode || this.getShadowFilterFn(t.shadowMap.type) || null;
    if (h === null)
      throw new Error("THREE.WebGPURenderer: Shadow map type not supported yet.");
    const p = r === or ? this.vsmShadowMapHorizontal.texture : i, f = this.setupShadowFilter(e, { filterFn: h, shadowTexture: a.texture, depthTexture: p, shadowCoord: d, shadow: n }), m = X(a.texture, d), _ = Z(1, f.rgb.mix(m, 1), u.mul(m.a)).toVar();
    return this.shadowMap = a, this.shadow.map = a, _;
  }
  /**
   * The implementation performs the setup of the output node. An output is only
   * produces if shadow mapping is globally enabled in the renderer.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @return {ShaderCallNodeInternal} The output node.
   */
  setup(e) {
    if (e.renderer.shadowMap.enabled !== !1)
      return b(() => {
        let t = this._node;
        return this.setupShadowPosition(e), t === null && (this._node = t = this.setupShadow(e)), e.material.shadowNode && console.warn('THREE.NodeMaterial: ".shadowNode" is deprecated. Use ".castShadowNode" instead.'), e.material.receivedShadowNode && (t = e.material.receivedShadowNode(t)), t;
      })();
  }
  /**
   * Renders the shadow. The logic of this function could be included
   * into {@link ShadowNode#updateShadow} however more specialized shadow
   * nodes might require a custom shadow map rendering. By having a
   * dedicated method, it's easier to overwrite the default behavior.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  renderShadow(e) {
    const { shadow: t, shadowMap: s, light: n } = this, { renderer: r, scene: i } = e;
    t.updateMatrices(n), s.setSize(t.mapSize.width, t.mapSize.height), r.render(i, t.camera);
  }
  /**
   * Updates the shadow.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateShadow(e) {
    const { shadowMap: t, light: s, shadow: n } = this, { renderer: r, scene: i, camera: a } = e, u = r.shadowMap.type, c = t.depthTexture.version;
    this._depthVersionCached = c, n.camera.layers.mask = a.layers.mask;
    const l = r.getRenderObjectFunction(), d = r.getMRT(), h = d ? d.has("velocity") : !1;
    qi = Pb(r, i, qi), i.overrideMaterial = Vb(s), r.setRenderObjectFunction((p, f, m, _, S, A, ...M) => {
      (p.castShadow === !0 || p.receiveShadow && u === or) && (h && (Dl(p).useVelocity = !0), p.onBeforeShadow(r, p, a, n.camera, _, f.overrideMaterial, A), r.renderObject(p, f, m, _, S, A, ...M), p.onAfterShadow(r, p, a, n.camera, _, f.overrideMaterial, A));
    }), r.setRenderTarget(t), this.renderShadow(e), r.setRenderObjectFunction(l), s.isPointLight !== !0 && u === or && this.vsmPass(r), Db(r, i, qi);
  }
  /**
   * For VSM additional render passes are required.
   *
   * @param {Renderer} renderer - A reference to the current renderer.
   */
  vsmPass(e) {
    const { shadow: t } = this;
    this.vsmShadowMapVertical.setSize(t.mapSize.width, t.mapSize.height), this.vsmShadowMapHorizontal.setSize(t.mapSize.width, t.mapSize.height), e.setRenderTarget(this.vsmShadowMapVertical), gr.material = this.vsmMaterialVertical, gr.render(e), e.setRenderTarget(this.vsmShadowMapHorizontal), gr.material = this.vsmMaterialHorizontal, gr.render(e);
  }
  /**
   * Frees the internal resources of this shadow node.
   */
  dispose() {
    this.shadowMap.dispose(), this.shadowMap = null, this.vsmShadowMapVertical !== null && (this.vsmShadowMapVertical.dispose(), this.vsmShadowMapVertical = null, this.vsmMaterialVertical.dispose(), this.vsmMaterialVertical = null), this.vsmShadowMapHorizontal !== null && (this.vsmShadowMapHorizontal.dispose(), this.vsmShadowMapHorizontal = null, this.vsmMaterialHorizontal.dispose(), this.vsmMaterialHorizontal = null), super.dispose();
  }
  /**
   * The implementation performs the update of the shadow map if necessary.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  updateBefore(e) {
    const { shadow: t } = this;
    (t.needsUpdate || t.autoUpdate) && (this.updateShadow(e), this.shadowMap.depthTexture.version === this._depthVersionCached && (t.needsUpdate = !1));
  }
}
const Ff = (o, e) => E(new Bf(o, e));
class bs extends on {
  static get type() {
    return "AnalyticLightNode";
  }
  /**
   * Constructs a new analytic light node.
   *
   * @param {Light?} [light=null] - The light source.
   */
  constructor(e = null) {
    super(), this.light = e, this.color = new Ct(), this.colorNode = e && e.colorNode || L(this.color).setGroup(O), this.baseColorNode = null, this.shadowNode = null, this.shadowColorNode = null, this.isAnalyticLightNode = !0, this.updateType = z.FRAME;
  }
  /**
   * Overwrites the default {@link Node#customCacheKey} implementation by including the
   * `light.id` and `light.castShadow` into the cache key.
   *
   * @return {Number} The custom cache key.
   */
  customCacheKey() {
    return aa(this.light.id, this.light.castShadow ? 1 : 0);
  }
  getHash() {
    return this.light.uuid;
  }
  /**
   * Setups the shadow node for this light. The method exists so concrete light classes
   * can setup different types of shadow nodes.
   *
   * @return {ShadowNode} The created shadow node.
   */
  setupShadowNode() {
    return Ff(this.light);
  }
  /**
   * Setups the shadow for this light. This method is only executed if the light
   * cast shadows and the current build object receives shadows. It incorporates
   * shadows into the lighting computation.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setupShadow(e) {
    const { renderer: t } = e;
    if (t.shadowMap.enabled === !1) return;
    let s = this.shadowColorNode;
    if (s === null) {
      const n = this.light.shadow.shadowNode;
      let r;
      n !== void 0 ? r = E(n) : r = this.setupShadowNode(e), this.shadowNode = r, this.shadowColorNode = s = this.colorNode.mul(r), this.baseColorNode = this.colorNode;
    }
    this.colorNode = s;
  }
  /**
   * Unlike most other nodes, lighting nodes do not return a output node in {@link Node#setup}.
   * The main purpose of lighting nodes is to configure the current {@link LightingModel} and/or
   * invocate the respective interface methods.
   *
   * @param {NodeBuilder} builder - The current node builder.
   */
  setup(e) {
    this.colorNode = this.baseColorNode || this.colorNode, this.light.castShadow ? e.object.receiveShadow && this.setupShadow(e) : this.shadowNode !== null && (this.shadowNode.dispose(), this.shadowNode = null, this.shadowColorNode = null);
  }
  /**
   * The update method is used to update light uniforms per frame.
   * Potentially overwritten in concrete light nodes to update light
   * specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update() {
    const { light: e } = this;
    this.color.copy(e.color).multiplyScalar(e.intensity);
  }
}
const fu = /* @__PURE__ */ b((o) => {
  const { lightDistance: e, cutoffDistance: t, decayExponent: s } = o, n = e.pow(s).max(0.01).reciprocal();
  return t.greaterThan(0).select(
    n.mul(e.div(t).pow4().oneMinus().clamp().pow2()),
    n
  );
}), zb = /* @__PURE__ */ new Ct(), dt = /* @__PURE__ */ b(([o, e]) => {
  const t = o.toVar(), s = re(t), n = ut(1, fe(s.x, fe(s.y, s.z)));
  s.mulAssign(n), t.mulAssign(n.mul(e.mul(2).oneMinus()));
  const r = w(t.xy).toVar(), a = e.mul(1.5).oneMinus();
  return H(s.z.greaterThanEqual(a), () => {
    H(t.z.greaterThan(0), () => {
      r.x.assign(K(4, t.x));
    });
  }).ElseIf(s.x.greaterThanEqual(a), () => {
    const u = On(t.x);
    r.x.assign(t.z.mul(u).add(u.mul(2)));
  }).ElseIf(s.y.greaterThanEqual(a), () => {
    const u = On(t.y);
    r.x.assign(t.x.add(u.mul(2)).add(2)), r.y.assign(t.z.mul(u).sub(2));
  }), w(0.125, 0.25).mul(r).add(w(0.375, 0.75)).flipY();
}).setLayout({
  name: "cubeToUV",
  type: "vec2",
  inputs: [
    { name: "pos", type: "vec3" },
    { name: "texelSizeY", type: "float" }
  ]
}), $b = /* @__PURE__ */ b(({ depthTexture: o, bd3D: e, dp: t, texelSize: s }) => X(o, dt(e, s.y)).compare(t)), Wb = /* @__PURE__ */ b(({ depthTexture: o, bd3D: e, dp: t, texelSize: s, shadow: n }) => {
  const r = te("radius", "float", n).setGroup(O), i = w(-1, 1).mul(r).mul(s.y);
  return X(o, dt(e.add(i.xyy), s.y)).compare(t).add(X(o, dt(e.add(i.yyy), s.y)).compare(t)).add(X(o, dt(e.add(i.xyx), s.y)).compare(t)).add(X(o, dt(e.add(i.yyx), s.y)).compare(t)).add(X(o, dt(e, s.y)).compare(t)).add(X(o, dt(e.add(i.xxy), s.y)).compare(t)).add(X(o, dt(e.add(i.yxy), s.y)).compare(t)).add(X(o, dt(e.add(i.xxx), s.y)).compare(t)).add(X(o, dt(e.add(i.yxx), s.y)).compare(t)).mul(1 / 9);
}), Hb = /* @__PURE__ */ b(({ filterFn: o, depthTexture: e, shadowCoord: t, shadow: s }) => {
  const n = t.xyz.toVar(), r = n.length(), i = L("float").setGroup(O).onRenderUpdate(() => s.camera.near), a = L("float").setGroup(O).onRenderUpdate(() => s.camera.far), u = te("bias", "float", s).setGroup(O), c = L(s.mapSize).setGroup(O), l = g(1).toVar();
  return H(r.sub(a).lessThanEqual(0).and(r.sub(i).greaterThanEqual(0)), () => {
    const d = r.sub(i).div(a.sub(i)).toVar();
    d.addAssign(u);
    const h = n.normalize(), p = w(1).div(c.mul(w(4, 2)));
    l.assign(o({ depthTexture: e, bd3D: h, dp: d, texelSize: p, shadow: s }));
  }), l;
}), pc = /* @__PURE__ */ new Ce(), Es = /* @__PURE__ */ new He(), gn = /* @__PURE__ */ new He();
class qb extends Bf {
  static get type() {
    return "PointShadowNode";
  }
  /**
   * Constructs a new point shadow node.
   *
   * @param {PointLight} light - The shadow casting point light.
   * @param {PointLightShadow?} [shadow=null] - An optional point light shadow.
   */
  constructor(e, t = null) {
    super(e, t);
  }
  /**
   * Overwrites the default implementation to return point light shadow specific
   * filtering functions.
   *
   * @param {Number} type - The shadow type.
   * @return {Function} The filtering function.
   */
  getShadowFilterFn(e) {
    return e === Am ? $b : Wb;
  }
  /**
   * Overwrites the default implementation so the unaltered shadow position is used.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
   * @return {Node<vec3>} The shadow coordinates.
   */
  setupShadowCoord(e, t) {
    return t;
  }
  /**
   * Overwrites the default implementation to only use point light specific
   * shadow filter functions.
   *
   * @param {NodeBuilder} builder - A reference to the current node builder.
   * @param {Object} inputs - A configuration object that defines the shadow filtering.
   * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
   * @param {Texture} inputs.shadowTexture - A reference to the shadow map's texture.
   * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
   * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
   * @param {LightShadow} inputs.shadow - The light shadow.
   * @return {Node<float>} The result node of the shadow filtering.
   */
  setupShadowFilter(e, { filterFn: t, shadowTexture: s, depthTexture: n, shadowCoord: r, shadow: i }) {
    return Hb({ filterFn: t, shadowTexture: s, depthTexture: n, shadowCoord: r, shadow: i });
  }
  /**
   * Overwrites the default implementation with point light specific
   * rendering code.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  renderShadow(e) {
    const { shadow: t, shadowMap: s, light: n } = this, { renderer: r, scene: i } = e, a = t.getFrameExtents();
    gn.copy(t.mapSize), gn.multiply(a), s.setSize(gn.width, gn.height), Es.copy(t.mapSize);
    const u = r.autoClear, c = r.getClearColor(zb), l = r.getClearAlpha();
    r.autoClear = !1, r.setClearColor(t.clearColor, t.clearAlpha), r.clear();
    const d = t.getViewportCount();
    for (let h = 0; h < d; h++) {
      const p = t.getViewport(h), f = Es.x * p.x, m = gn.y - Es.y - Es.y * p.y;
      pc.set(
        f,
        m,
        Es.x * p.z,
        Es.y * p.w
      ), s.viewport.copy(pc), t.updateMatrices(n, h), r.render(i, t.camera);
    }
    r.autoClear = u, r.setClearColor(c, l);
  }
}
const Xb = (o, e) => E(new qb(o, e)), Uf = b(({ color: o, lightViewPosition: e, cutoffDistance: t, decayExponent: s }, n) => {
  const r = n.context.lightingModel, i = e.sub(xe), a = i.normalize(), u = i.length(), c = fu({
    lightDistance: u,
    cutoffDistance: t,
    decayExponent: s
  }), l = o.mul(c), d = n.context.reflectedLight;
  r.direct({
    lightDirection: a,
    lightColor: l,
    reflectedLight: d
  }, n.stack, n);
});
class Kb extends bs {
  static get type() {
    return "PointLightNode";
  }
  /**
   * Constructs a new point light node.
   *
   * @param {PointLight?} [light=null] - The point light source.
   */
  constructor(e = null) {
    super(e), this.cutoffDistanceNode = L(0).setGroup(O), this.decayExponentNode = L(2).setGroup(O);
  }
  /**
   * Overwritten to updated point light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update(e) {
    const { light: t } = this;
    super.update(e), this.cutoffDistanceNode.value = t.distance, this.decayExponentNode.value = t.decay;
  }
  /**
   * Overwritten to setup point light specific shadow.
   *
   * @return {PointShadowNode}
   */
  setupShadowNode() {
    return Xb(this.light);
  }
  setup(e) {
    super.setup(e), Uf({
      color: this.colorNode,
      lightViewPosition: Ri(this.light),
      cutoffDistance: this.cutoffDistanceNode,
      decayExponent: this.decayExponentNode
    }).append();
  }
}
const Yb = /* @__PURE__ */ b(([o = le()]) => {
  const e = o.mul(2), t = e.x.floor(), s = e.y.floor();
  return t.add(s).mod(2).sign();
}), Cn = /* @__PURE__ */ b(([o, e, t]) => {
  const s = g(t).toVar(), n = g(e).toVar(), r = Vt(o).toVar();
  return Me(r, n, s);
}).setLayout({
  name: "mx_select",
  type: "float",
  inputs: [
    { name: "b", type: "bool" },
    { name: "t", type: "float" },
    { name: "f", type: "float" }
  ]
}), Yr = /* @__PURE__ */ b(([o, e]) => {
  const t = Vt(e).toVar(), s = g(o).toVar();
  return Me(t, s.negate(), s);
}).setLayout({
  name: "mx_negate_if",
  type: "float",
  inputs: [
    { name: "val", type: "float" },
    { name: "b", type: "bool" }
  ]
}), Te = /* @__PURE__ */ b(([o]) => {
  const e = g(o).toVar();
  return y(yt(e));
}).setLayout({
  name: "mx_floor",
  type: "int",
  inputs: [
    { name: "x", type: "float" }
  ]
}), ue = /* @__PURE__ */ b(([o, e]) => {
  const t = g(o).toVar();
  return e.assign(Te(t)), t.sub(g(e));
}), jb = /* @__PURE__ */ b(([o, e, t, s, n, r]) => {
  const i = g(r).toVar(), a = g(n).toVar(), u = g(s).toVar(), c = g(t).toVar(), l = g(e).toVar(), d = g(o).toVar(), h = g(K(1, a)).toVar();
  return K(1, i).mul(d.mul(h).add(l.mul(a))).add(i.mul(c.mul(h).add(u.mul(a))));
}).setLayout({
  name: "mx_bilerp_0",
  type: "float",
  inputs: [
    { name: "v0", type: "float" },
    { name: "v1", type: "float" },
    { name: "v2", type: "float" },
    { name: "v3", type: "float" },
    { name: "s", type: "float" },
    { name: "t", type: "float" }
  ]
}), Qb = /* @__PURE__ */ b(([o, e, t, s, n, r]) => {
  const i = g(r).toVar(), a = g(n).toVar(), u = T(s).toVar(), c = T(t).toVar(), l = T(e).toVar(), d = T(o).toVar(), h = g(K(1, a)).toVar();
  return K(1, i).mul(d.mul(h).add(l.mul(a))).add(i.mul(c.mul(h).add(u.mul(a))));
}).setLayout({
  name: "mx_bilerp_1",
  type: "vec3",
  inputs: [
    { name: "v0", type: "vec3" },
    { name: "v1", type: "vec3" },
    { name: "v2", type: "vec3" },
    { name: "v3", type: "vec3" },
    { name: "s", type: "float" },
    { name: "t", type: "float" }
  ]
}), Pf = /* @__PURE__ */ Be([jb, Qb]), Zb = /* @__PURE__ */ b(([o, e, t, s, n, r, i, a, u, c, l]) => {
  const d = g(l).toVar(), h = g(c).toVar(), p = g(u).toVar(), f = g(a).toVar(), m = g(i).toVar(), _ = g(r).toVar(), S = g(n).toVar(), A = g(s).toVar(), M = g(t).toVar(), F = g(e).toVar(), D = g(o).toVar(), P = g(K(1, p)).toVar(), V = g(K(1, h)).toVar();
  return g(K(1, d)).toVar().mul(V.mul(D.mul(P).add(F.mul(p))).add(h.mul(M.mul(P).add(A.mul(p))))).add(d.mul(V.mul(S.mul(P).add(_.mul(p))).add(h.mul(m.mul(P).add(f.mul(p))))));
}).setLayout({
  name: "mx_trilerp_0",
  type: "float",
  inputs: [
    { name: "v0", type: "float" },
    { name: "v1", type: "float" },
    { name: "v2", type: "float" },
    { name: "v3", type: "float" },
    { name: "v4", type: "float" },
    { name: "v5", type: "float" },
    { name: "v6", type: "float" },
    { name: "v7", type: "float" },
    { name: "s", type: "float" },
    { name: "t", type: "float" },
    { name: "r", type: "float" }
  ]
}), Jb = /* @__PURE__ */ b(([o, e, t, s, n, r, i, a, u, c, l]) => {
  const d = g(l).toVar(), h = g(c).toVar(), p = g(u).toVar(), f = T(a).toVar(), m = T(i).toVar(), _ = T(r).toVar(), S = T(n).toVar(), A = T(s).toVar(), M = T(t).toVar(), F = T(e).toVar(), D = T(o).toVar(), P = g(K(1, p)).toVar(), V = g(K(1, h)).toVar();
  return g(K(1, d)).toVar().mul(V.mul(D.mul(P).add(F.mul(p))).add(h.mul(M.mul(P).add(A.mul(p))))).add(d.mul(V.mul(S.mul(P).add(_.mul(p))).add(h.mul(m.mul(P).add(f.mul(p))))));
}).setLayout({
  name: "mx_trilerp_1",
  type: "vec3",
  inputs: [
    { name: "v0", type: "vec3" },
    { name: "v1", type: "vec3" },
    { name: "v2", type: "vec3" },
    { name: "v3", type: "vec3" },
    { name: "v4", type: "vec3" },
    { name: "v5", type: "vec3" },
    { name: "v6", type: "vec3" },
    { name: "v7", type: "vec3" },
    { name: "s", type: "float" },
    { name: "t", type: "float" },
    { name: "r", type: "float" }
  ]
}), Df = /* @__PURE__ */ Be([Zb, Jb]), eS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = g(t).toVar(), n = g(e).toVar(), r = U(o).toVar(), i = U(r.bitAnd(U(7))).toVar(), a = g(Cn(i.lessThan(U(4)), n, s)).toVar(), u = g($(2, Cn(i.lessThan(U(4)), s, n))).toVar();
  return Yr(a, Vt(i.bitAnd(U(1)))).add(Yr(u, Vt(i.bitAnd(U(2)))));
}).setLayout({
  name: "mx_gradient_float_0",
  type: "float",
  inputs: [
    { name: "hash", type: "uint" },
    { name: "x", type: "float" },
    { name: "y", type: "float" }
  ]
}), tS = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = g(s).toVar(), r = g(t).toVar(), i = g(e).toVar(), a = U(o).toVar(), u = U(a.bitAnd(U(15))).toVar(), c = g(Cn(u.lessThan(U(8)), i, r)).toVar(), l = g(Cn(u.lessThan(U(4)), r, Cn(u.equal(U(12)).or(u.equal(U(14))), i, n))).toVar();
  return Yr(c, Vt(u.bitAnd(U(1)))).add(Yr(l, Vt(u.bitAnd(U(2)))));
}).setLayout({
  name: "mx_gradient_float_1",
  type: "float",
  inputs: [
    { name: "hash", type: "uint" },
    { name: "x", type: "float" },
    { name: "y", type: "float" },
    { name: "z", type: "float" }
  ]
}), Re = /* @__PURE__ */ Be([eS, tS]), sS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = g(t).toVar(), n = g(e).toVar(), r = nn(o).toVar();
  return T(Re(r.x, n, s), Re(r.y, n, s), Re(r.z, n, s));
}).setLayout({
  name: "mx_gradient_vec3_0",
  type: "vec3",
  inputs: [
    { name: "hash", type: "uvec3" },
    { name: "x", type: "float" },
    { name: "y", type: "float" }
  ]
}), nS = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = g(s).toVar(), r = g(t).toVar(), i = g(e).toVar(), a = nn(o).toVar();
  return T(Re(a.x, i, r, n), Re(a.y, i, r, n), Re(a.z, i, r, n));
}).setLayout({
  name: "mx_gradient_vec3_1",
  type: "vec3",
  inputs: [
    { name: "hash", type: "uvec3" },
    { name: "x", type: "float" },
    { name: "y", type: "float" },
    { name: "z", type: "float" }
  ]
}), Je = /* @__PURE__ */ Be([sS, nS]), rS = /* @__PURE__ */ b(([o]) => {
  const e = g(o).toVar();
  return $(0.6616, e);
}).setLayout({
  name: "mx_gradient_scale2d_0",
  type: "float",
  inputs: [
    { name: "v", type: "float" }
  ]
}), iS = /* @__PURE__ */ b(([o]) => {
  const e = g(o).toVar();
  return $(0.982, e);
}).setLayout({
  name: "mx_gradient_scale3d_0",
  type: "float",
  inputs: [
    { name: "v", type: "float" }
  ]
}), oS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar();
  return $(0.6616, e);
}).setLayout({
  name: "mx_gradient_scale2d_1",
  type: "vec3",
  inputs: [
    { name: "v", type: "vec3" }
  ]
}), If = /* @__PURE__ */ Be([rS, oS]), aS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar();
  return $(0.982, e);
}).setLayout({
  name: "mx_gradient_scale3d_1",
  type: "vec3",
  inputs: [
    { name: "v", type: "vec3" }
  ]
}), Lf = /* @__PURE__ */ Be([iS, aS]), Qe = /* @__PURE__ */ b(([o, e]) => {
  const t = y(e).toVar(), s = U(o).toVar();
  return s.shiftLeft(t).bitOr(s.shiftRight(y(32).sub(t)));
}).setLayout({
  name: "mx_rotl32",
  type: "uint",
  inputs: [
    { name: "x", type: "uint" },
    { name: "k", type: "int" }
  ]
}), Vf = /* @__PURE__ */ b(([o, e, t]) => {
  o.subAssign(t), o.bitXorAssign(Qe(t, y(4))), t.addAssign(e), e.subAssign(o), e.bitXorAssign(Qe(o, y(6))), o.addAssign(t), t.subAssign(e), t.bitXorAssign(Qe(e, y(8))), e.addAssign(o), o.subAssign(t), o.bitXorAssign(Qe(t, y(16))), t.addAssign(e), e.subAssign(o), e.bitXorAssign(Qe(o, y(19))), o.addAssign(t), t.subAssign(e), t.bitXorAssign(Qe(e, y(4))), e.addAssign(o);
}), ir = /* @__PURE__ */ b(([o, e, t]) => {
  const s = U(t).toVar(), n = U(e).toVar(), r = U(o).toVar();
  return s.bitXorAssign(n), s.subAssign(Qe(n, y(14))), r.bitXorAssign(s), r.subAssign(Qe(s, y(11))), n.bitXorAssign(r), n.subAssign(Qe(r, y(25))), s.bitXorAssign(n), s.subAssign(Qe(n, y(16))), r.bitXorAssign(s), r.subAssign(Qe(s, y(4))), n.bitXorAssign(r), n.subAssign(Qe(r, y(14))), s.bitXorAssign(n), s.subAssign(Qe(n, y(24))), s;
}).setLayout({
  name: "mx_bjfinal",
  type: "uint",
  inputs: [
    { name: "a", type: "uint" },
    { name: "b", type: "uint" },
    { name: "c", type: "uint" }
  ]
}), Ie = /* @__PURE__ */ b(([o]) => {
  const e = U(o).toVar();
  return g(e).div(g(U(y(4294967295))));
}).setLayout({
  name: "mx_bits_to_01",
  type: "float",
  inputs: [
    { name: "bits", type: "uint" }
  ]
}), xt = /* @__PURE__ */ b(([o]) => {
  const e = g(o).toVar();
  return e.mul(e).mul(e).mul(e.mul(e.mul(6).sub(15)).add(10));
}).setLayout({
  name: "mx_fade",
  type: "float",
  inputs: [
    { name: "t", type: "float" }
  ]
}), uS = /* @__PURE__ */ b(([o]) => {
  const e = y(o).toVar(), t = U(U(1)).toVar(), s = U(U(y(3735928559)).add(t.shiftLeft(U(2))).add(U(13))).toVar();
  return ir(s.add(U(e)), s, s);
}).setLayout({
  name: "mx_hash_int_0",
  type: "uint",
  inputs: [
    { name: "x", type: "int" }
  ]
}), cS = /* @__PURE__ */ b(([o, e]) => {
  const t = y(e).toVar(), s = y(o).toVar(), n = U(U(2)).toVar(), r = U().toVar(), i = U().toVar(), a = U().toVar();
  return r.assign(i.assign(a.assign(U(y(3735928559)).add(n.shiftLeft(U(2))).add(U(13))))), r.addAssign(U(s)), i.addAssign(U(t)), ir(r, i, a);
}).setLayout({
  name: "mx_hash_int_1",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" }
  ]
}), lS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = y(e).toVar(), r = y(o).toVar(), i = U(U(3)).toVar(), a = U().toVar(), u = U().toVar(), c = U().toVar();
  return a.assign(u.assign(c.assign(U(y(3735928559)).add(i.shiftLeft(U(2))).add(U(13))))), a.addAssign(U(r)), u.addAssign(U(n)), c.addAssign(U(s)), ir(a, u, c);
}).setLayout({
  name: "mx_hash_int_2",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" }
  ]
}), dS = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = y(s).toVar(), r = y(t).toVar(), i = y(e).toVar(), a = y(o).toVar(), u = U(U(4)).toVar(), c = U().toVar(), l = U().toVar(), d = U().toVar();
  return c.assign(l.assign(d.assign(U(y(3735928559)).add(u.shiftLeft(U(2))).add(U(13))))), c.addAssign(U(a)), l.addAssign(U(i)), d.addAssign(U(r)), Vf(c, l, d), c.addAssign(U(n)), ir(c, l, d);
}).setLayout({
  name: "mx_hash_int_3",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" },
    { name: "xx", type: "int" }
  ]
}), hS = /* @__PURE__ */ b(([o, e, t, s, n]) => {
  const r = y(n).toVar(), i = y(s).toVar(), a = y(t).toVar(), u = y(e).toVar(), c = y(o).toVar(), l = U(U(5)).toVar(), d = U().toVar(), h = U().toVar(), p = U().toVar();
  return d.assign(h.assign(p.assign(U(y(3735928559)).add(l.shiftLeft(U(2))).add(U(13))))), d.addAssign(U(c)), h.addAssign(U(u)), p.addAssign(U(a)), Vf(d, h, p), d.addAssign(U(i)), h.addAssign(U(r)), ir(d, h, p);
}).setLayout({
  name: "mx_hash_int_4",
  type: "uint",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" },
    { name: "xx", type: "int" },
    { name: "yy", type: "int" }
  ]
}), se = /* @__PURE__ */ Be([uS, cS, lS, dS, hS]), pS = /* @__PURE__ */ b(([o, e]) => {
  const t = y(e).toVar(), s = y(o).toVar(), n = U(se(s, t)).toVar(), r = nn().toVar();
  return r.x.assign(n.bitAnd(y(255))), r.y.assign(n.shiftRight(y(8)).bitAnd(y(255))), r.z.assign(n.shiftRight(y(16)).bitAnd(y(255))), r;
}).setLayout({
  name: "mx_hash_vec3_0",
  type: "uvec3",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" }
  ]
}), fS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = y(e).toVar(), r = y(o).toVar(), i = U(se(r, n, s)).toVar(), a = nn().toVar();
  return a.x.assign(i.bitAnd(y(255))), a.y.assign(i.shiftRight(y(8)).bitAnd(y(255))), a.z.assign(i.shiftRight(y(16)).bitAnd(y(255))), a;
}).setLayout({
  name: "mx_hash_vec3_1",
  type: "uvec3",
  inputs: [
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" }
  ]
}), et = /* @__PURE__ */ Be([pS, fS]), gS = /* @__PURE__ */ b(([o]) => {
  const e = w(o).toVar(), t = y().toVar(), s = y().toVar(), n = g(ue(e.x, t)).toVar(), r = g(ue(e.y, s)).toVar(), i = g(xt(n)).toVar(), a = g(xt(r)).toVar(), u = g(Pf(Re(se(t, s), n, r), Re(se(t.add(y(1)), s), n.sub(1), r), Re(se(t, s.add(y(1))), n, r.sub(1)), Re(se(t.add(y(1)), s.add(y(1))), n.sub(1), r.sub(1)), i, a)).toVar();
  return If(u);
}).setLayout({
  name: "mx_perlin_noise_float_0",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), mS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = y().toVar(), s = y().toVar(), n = y().toVar(), r = g(ue(e.x, t)).toVar(), i = g(ue(e.y, s)).toVar(), a = g(ue(e.z, n)).toVar(), u = g(xt(r)).toVar(), c = g(xt(i)).toVar(), l = g(xt(a)).toVar(), d = g(Df(Re(se(t, s, n), r, i, a), Re(se(t.add(y(1)), s, n), r.sub(1), i, a), Re(se(t, s.add(y(1)), n), r, i.sub(1), a), Re(se(t.add(y(1)), s.add(y(1)), n), r.sub(1), i.sub(1), a), Re(se(t, s, n.add(y(1))), r, i, a.sub(1)), Re(se(t.add(y(1)), s, n.add(y(1))), r.sub(1), i, a.sub(1)), Re(se(t, s.add(y(1)), n.add(y(1))), r, i.sub(1), a.sub(1)), Re(se(t.add(y(1)), s.add(y(1)), n.add(y(1))), r.sub(1), i.sub(1), a.sub(1)), u, c, l)).toVar();
  return Lf(d);
}).setLayout({
  name: "mx_perlin_noise_float_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), gu = /* @__PURE__ */ Be([gS, mS]), yS = /* @__PURE__ */ b(([o]) => {
  const e = w(o).toVar(), t = y().toVar(), s = y().toVar(), n = g(ue(e.x, t)).toVar(), r = g(ue(e.y, s)).toVar(), i = g(xt(n)).toVar(), a = g(xt(r)).toVar(), u = T(Pf(Je(et(t, s), n, r), Je(et(t.add(y(1)), s), n.sub(1), r), Je(et(t, s.add(y(1))), n, r.sub(1)), Je(et(t.add(y(1)), s.add(y(1))), n.sub(1), r.sub(1)), i, a)).toVar();
  return If(u);
}).setLayout({
  name: "mx_perlin_noise_vec3_0",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), xS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = y().toVar(), s = y().toVar(), n = y().toVar(), r = g(ue(e.x, t)).toVar(), i = g(ue(e.y, s)).toVar(), a = g(ue(e.z, n)).toVar(), u = g(xt(r)).toVar(), c = g(xt(i)).toVar(), l = g(xt(a)).toVar(), d = T(Df(Je(et(t, s, n), r, i, a), Je(et(t.add(y(1)), s, n), r.sub(1), i, a), Je(et(t, s.add(y(1)), n), r, i.sub(1), a), Je(et(t.add(y(1)), s.add(y(1)), n), r.sub(1), i.sub(1), a), Je(et(t, s, n.add(y(1))), r, i, a.sub(1)), Je(et(t.add(y(1)), s, n.add(y(1))), r.sub(1), i, a.sub(1)), Je(et(t, s.add(y(1)), n.add(y(1))), r, i.sub(1), a.sub(1)), Je(et(t.add(y(1)), s.add(y(1)), n.add(y(1))), r.sub(1), i.sub(1), a.sub(1)), u, c, l)).toVar();
  return Lf(d);
}).setLayout({
  name: "mx_perlin_noise_vec3_1",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), mu = /* @__PURE__ */ Be([yS, xS]), TS = /* @__PURE__ */ b(([o]) => {
  const e = g(o).toVar(), t = y(Te(e)).toVar();
  return Ie(se(t));
}).setLayout({
  name: "mx_cell_noise_float_0",
  type: "float",
  inputs: [
    { name: "p", type: "float" }
  ]
}), _S = /* @__PURE__ */ b(([o]) => {
  const e = w(o).toVar(), t = y(Te(e.x)).toVar(), s = y(Te(e.y)).toVar();
  return Ie(se(t, s));
}).setLayout({
  name: "mx_cell_noise_float_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), NS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = y(Te(e.x)).toVar(), s = y(Te(e.y)).toVar(), n = y(Te(e.z)).toVar();
  return Ie(se(t, s, n));
}).setLayout({
  name: "mx_cell_noise_float_2",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), bS = /* @__PURE__ */ b(([o]) => {
  const e = I(o).toVar(), t = y(Te(e.x)).toVar(), s = y(Te(e.y)).toVar(), n = y(Te(e.z)).toVar(), r = y(Te(e.w)).toVar();
  return Ie(se(t, s, n, r));
}).setLayout({
  name: "mx_cell_noise_float_3",
  type: "float",
  inputs: [
    { name: "p", type: "vec4" }
  ]
}), SS = /* @__PURE__ */ Be([TS, _S, NS, bS]), vS = /* @__PURE__ */ b(([o]) => {
  const e = g(o).toVar(), t = y(Te(e)).toVar();
  return T(Ie(se(t, y(0))), Ie(se(t, y(1))), Ie(se(t, y(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_0",
  type: "vec3",
  inputs: [
    { name: "p", type: "float" }
  ]
}), AS = /* @__PURE__ */ b(([o]) => {
  const e = w(o).toVar(), t = y(Te(e.x)).toVar(), s = y(Te(e.y)).toVar();
  return T(Ie(se(t, s, y(0))), Ie(se(t, s, y(1))), Ie(se(t, s, y(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_1",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec2" }
  ]
}), RS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = y(Te(e.x)).toVar(), s = y(Te(e.y)).toVar(), n = y(Te(e.z)).toVar();
  return T(Ie(se(t, s, n, y(0))), Ie(se(t, s, n, y(1))), Ie(se(t, s, n, y(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_2",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" }
  ]
}), CS = /* @__PURE__ */ b(([o]) => {
  const e = I(o).toVar(), t = y(Te(e.x)).toVar(), s = y(Te(e.y)).toVar(), n = y(Te(e.z)).toVar(), r = y(Te(e.w)).toVar();
  return T(Ie(se(t, s, n, r, y(0))), Ie(se(t, s, n, r, y(1))), Ie(se(t, s, n, r, y(2))));
}).setLayout({
  name: "mx_cell_noise_vec3_3",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec4" }
  ]
}), Gf = /* @__PURE__ */ Be([vS, AS, RS, CS]), jr = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = g(s).toVar(), r = g(t).toVar(), i = y(e).toVar(), a = T(o).toVar(), u = g(0).toVar(), c = g(1).toVar();
  return J(i, () => {
    u.addAssign(c.mul(gu(a))), c.mulAssign(n), a.mulAssign(r);
  }), u;
}).setLayout({
  name: "mx_fractal_noise_float",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), Of = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = g(s).toVar(), r = g(t).toVar(), i = y(e).toVar(), a = T(o).toVar(), u = T(0).toVar(), c = g(1).toVar();
  return J(i, () => {
    u.addAssign(c.mul(mu(a))), c.mulAssign(n), a.mulAssign(r);
  }), u;
}).setLayout({
  name: "mx_fractal_noise_vec3",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), ES = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = g(s).toVar(), r = g(t).toVar(), i = y(e).toVar(), a = T(o).toVar();
  return w(jr(a, i, r, n), jr(a.add(T(y(19), y(193), y(17))), i, r, n));
}).setLayout({
  name: "mx_fractal_noise_vec2",
  type: "vec2",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), wS = /* @__PURE__ */ b(([o, e, t, s]) => {
  const n = g(s).toVar(), r = g(t).toVar(), i = y(e).toVar(), a = T(o).toVar(), u = T(Of(a, i, r, n)).toVar(), c = g(jr(a.add(T(y(19), y(193), y(17))), i, r, n)).toVar();
  return I(u, c);
}).setLayout({
  name: "mx_fractal_noise_vec4",
  type: "vec4",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "octaves", type: "int" },
    { name: "lacunarity", type: "float" },
    { name: "diminish", type: "float" }
  ]
}), MS = /* @__PURE__ */ b(([o, e, t, s, n, r, i]) => {
  const a = y(i).toVar(), u = g(r).toVar(), c = y(n).toVar(), l = y(s).toVar(), d = y(t).toVar(), h = y(e).toVar(), p = w(o).toVar(), f = T(Gf(w(h.add(l), d.add(c)))).toVar(), m = w(f.x, f.y).toVar();
  m.subAssign(0.5), m.mulAssign(u), m.addAssign(0.5);
  const _ = w(w(g(h), g(d)).add(m)).toVar(), S = w(_.sub(p)).toVar();
  return H(a.equal(y(2)), () => re(S.x).add(re(S.y))), H(a.equal(y(3)), () => fe(re(S.x), re(S.y))), Zt(S, S);
}).setLayout({
  name: "mx_worley_distance_0",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "xoff", type: "int" },
    { name: "yoff", type: "int" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), BS = /* @__PURE__ */ b(([o, e, t, s, n, r, i, a, u]) => {
  const c = y(u).toVar(), l = g(a).toVar(), d = y(i).toVar(), h = y(r).toVar(), p = y(n).toVar(), f = y(s).toVar(), m = y(t).toVar(), _ = y(e).toVar(), S = T(o).toVar(), A = T(Gf(T(_.add(p), m.add(h), f.add(d)))).toVar();
  A.subAssign(0.5), A.mulAssign(l), A.addAssign(0.5);
  const M = T(T(g(_), g(m), g(f)).add(A)).toVar(), F = T(M.sub(S)).toVar();
  return H(c.equal(y(2)), () => re(F.x).add(re(F.y)).add(re(F.z))), H(c.equal(y(3)), () => fe(fe(re(F.x), re(F.y)), re(F.z))), Zt(F, F);
}).setLayout({
  name: "mx_worley_distance_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "x", type: "int" },
    { name: "y", type: "int" },
    { name: "z", type: "int" },
    { name: "xoff", type: "int" },
    { name: "yoff", type: "int" },
    { name: "zoff", type: "int" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), an = /* @__PURE__ */ Be([MS, BS]), FS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = g(e).toVar(), r = w(o).toVar(), i = y().toVar(), a = y().toVar(), u = w(ue(r.x, i), ue(r.y, a)).toVar(), c = g(1e6).toVar();
  return J({ start: -1, end: y(1), name: "x", condition: "<=" }, ({ x: l }) => {
    J({ start: -1, end: y(1), name: "y", condition: "<=" }, ({ y: d }) => {
      const h = g(an(u, l, d, i, a, n, s)).toVar();
      c.assign($e(c, h));
    });
  }), H(s.equal(y(0)), () => {
    c.assign(Et(c));
  }), c;
}).setLayout({
  name: "mx_worley_noise_float_0",
  type: "float",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), US = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = g(e).toVar(), r = w(o).toVar(), i = y().toVar(), a = y().toVar(), u = w(ue(r.x, i), ue(r.y, a)).toVar(), c = w(1e6, 1e6).toVar();
  return J({ start: -1, end: y(1), name: "x", condition: "<=" }, ({ x: l }) => {
    J({ start: -1, end: y(1), name: "y", condition: "<=" }, ({ y: d }) => {
      const h = g(an(u, l, d, i, a, n, s)).toVar();
      H(h.lessThan(c.x), () => {
        c.y.assign(c.x), c.x.assign(h);
      }).ElseIf(h.lessThan(c.y), () => {
        c.y.assign(h);
      });
    });
  }), H(s.equal(y(0)), () => {
    c.assign(Et(c));
  }), c;
}).setLayout({
  name: "mx_worley_noise_vec2_0",
  type: "vec2",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), PS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = g(e).toVar(), r = w(o).toVar(), i = y().toVar(), a = y().toVar(), u = w(ue(r.x, i), ue(r.y, a)).toVar(), c = T(1e6, 1e6, 1e6).toVar();
  return J({ start: -1, end: y(1), name: "x", condition: "<=" }, ({ x: l }) => {
    J({ start: -1, end: y(1), name: "y", condition: "<=" }, ({ y: d }) => {
      const h = g(an(u, l, d, i, a, n, s)).toVar();
      H(h.lessThan(c.x), () => {
        c.z.assign(c.y), c.y.assign(c.x), c.x.assign(h);
      }).ElseIf(h.lessThan(c.y), () => {
        c.z.assign(c.y), c.y.assign(h);
      }).ElseIf(h.lessThan(c.z), () => {
        c.z.assign(h);
      });
    });
  }), H(s.equal(y(0)), () => {
    c.assign(Et(c));
  }), c;
}).setLayout({
  name: "mx_worley_noise_vec3_0",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec2" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), DS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = g(e).toVar(), r = T(o).toVar(), i = y().toVar(), a = y().toVar(), u = y().toVar(), c = T(ue(r.x, i), ue(r.y, a), ue(r.z, u)).toVar(), l = g(1e6).toVar();
  return J({ start: -1, end: y(1), name: "x", condition: "<=" }, ({ x: d }) => {
    J({ start: -1, end: y(1), name: "y", condition: "<=" }, ({ y: h }) => {
      J({ start: -1, end: y(1), name: "z", condition: "<=" }, ({ z: p }) => {
        const f = g(an(c, d, h, p, i, a, u, n, s)).toVar();
        l.assign($e(l, f));
      });
    });
  }), H(s.equal(y(0)), () => {
    l.assign(Et(l));
  }), l;
}).setLayout({
  name: "mx_worley_noise_float_1",
  type: "float",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), IS = /* @__PURE__ */ Be([FS, DS]), LS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = g(e).toVar(), r = T(o).toVar(), i = y().toVar(), a = y().toVar(), u = y().toVar(), c = T(ue(r.x, i), ue(r.y, a), ue(r.z, u)).toVar(), l = w(1e6, 1e6).toVar();
  return J({ start: -1, end: y(1), name: "x", condition: "<=" }, ({ x: d }) => {
    J({ start: -1, end: y(1), name: "y", condition: "<=" }, ({ y: h }) => {
      J({ start: -1, end: y(1), name: "z", condition: "<=" }, ({ z: p }) => {
        const f = g(an(c, d, h, p, i, a, u, n, s)).toVar();
        H(f.lessThan(l.x), () => {
          l.y.assign(l.x), l.x.assign(f);
        }).ElseIf(f.lessThan(l.y), () => {
          l.y.assign(f);
        });
      });
    });
  }), H(s.equal(y(0)), () => {
    l.assign(Et(l));
  }), l;
}).setLayout({
  name: "mx_worley_noise_vec2_1",
  type: "vec2",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), VS = /* @__PURE__ */ Be([US, LS]), GS = /* @__PURE__ */ b(([o, e, t]) => {
  const s = y(t).toVar(), n = g(e).toVar(), r = T(o).toVar(), i = y().toVar(), a = y().toVar(), u = y().toVar(), c = T(ue(r.x, i), ue(r.y, a), ue(r.z, u)).toVar(), l = T(1e6, 1e6, 1e6).toVar();
  return J({ start: -1, end: y(1), name: "x", condition: "<=" }, ({ x: d }) => {
    J({ start: -1, end: y(1), name: "y", condition: "<=" }, ({ y: h }) => {
      J({ start: -1, end: y(1), name: "z", condition: "<=" }, ({ z: p }) => {
        const f = g(an(c, d, h, p, i, a, u, n, s)).toVar();
        H(f.lessThan(l.x), () => {
          l.z.assign(l.y), l.y.assign(l.x), l.x.assign(f);
        }).ElseIf(f.lessThan(l.y), () => {
          l.z.assign(l.y), l.y.assign(f);
        }).ElseIf(f.lessThan(l.z), () => {
          l.z.assign(f);
        });
      });
    });
  }), H(s.equal(y(0)), () => {
    l.assign(Et(l));
  }), l;
}).setLayout({
  name: "mx_worley_noise_vec3_1",
  type: "vec3",
  inputs: [
    { name: "p", type: "vec3" },
    { name: "jitter", type: "float" },
    { name: "metric", type: "int" }
  ]
}), OS = /* @__PURE__ */ Be([PS, GS]), kS = /* @__PURE__ */ b(([o]) => {
  const e = o.y, t = o.z, s = T().toVar();
  return H(e.lessThan(1e-4), () => {
    s.assign(T(t, t, t));
  }).Else(() => {
    let n = o.x;
    n = n.sub(yt(n)).mul(6).toVar();
    const r = y(Ma(n)), i = n.sub(g(r)), a = t.mul(e.oneMinus()), u = t.mul(e.mul(i).oneMinus()), c = t.mul(e.mul(i.oneMinus()).oneMinus());
    H(r.equal(y(0)), () => {
      s.assign(T(t, c, a));
    }).ElseIf(r.equal(y(1)), () => {
      s.assign(T(u, t, a));
    }).ElseIf(r.equal(y(2)), () => {
      s.assign(T(a, t, c));
    }).ElseIf(r.equal(y(3)), () => {
      s.assign(T(a, u, t));
    }).ElseIf(r.equal(y(4)), () => {
      s.assign(T(c, a, t));
    }).Else(() => {
      s.assign(T(t, a, u));
    });
  }), s;
}).setLayout({
  name: "mx_hsvtorgb",
  type: "vec3",
  inputs: [
    { name: "hsv", type: "vec3" }
  ]
}), zS = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = g(e.x).toVar(), s = g(e.y).toVar(), n = g(e.z).toVar(), r = g($e(t, $e(s, n))).toVar(), i = g(fe(t, fe(s, n))).toVar(), a = g(i.sub(r)).toVar(), u = g().toVar(), c = g().toVar(), l = g().toVar();
  return l.assign(i), H(i.greaterThan(0), () => {
    c.assign(a.div(i));
  }).Else(() => {
    c.assign(0);
  }), H(c.lessThanEqual(0), () => {
    u.assign(0);
  }).Else(() => {
    H(t.greaterThanEqual(i), () => {
      u.assign(s.sub(n).div(a));
    }).ElseIf(s.greaterThanEqual(i), () => {
      u.assign(_e(2, n.sub(t).div(a)));
    }).Else(() => {
      u.assign(_e(4, t.sub(s).div(a)));
    }), u.mulAssign(1 / 6), H(u.lessThan(0), () => {
      u.addAssign(1);
    });
  }), T(u, c, l);
}).setLayout({
  name: "mx_rgbtohsv",
  type: "vec3",
  inputs: [
    { name: "c", type: "vec3" }
  ]
}), $S = /* @__PURE__ */ b(([o]) => {
  const e = T(o).toVar(), t = pa(Sa(e, T(0.04045))).toVar(), s = T(e.div(12.92)).toVar(), n = T(ot(fe(e.add(T(0.055)), T(0)).div(1.055), T(2.4))).toVar();
  return Z(s, n, t);
}).setLayout({
  name: "mx_srgb_texture_to_lin_rec709",
  type: "vec3",
  inputs: [
    { name: "color", type: "vec3" }
  ]
}), kf = (o, e) => {
  o = g(o), e = g(e);
  const t = w(e.dFdx(), e.dFdy()).length().mul(0.7071067811865476);
  return Ot(o.sub(t), o.add(t), e);
}, zf = (o, e, t, s) => Z(o, e, t[s].clamp()), WS = (o, e, t = le()) => zf(o, e, t, "x"), HS = (o, e, t = le()) => zf(o, e, t, "y"), $f = (o, e, t, s, n) => Z(o, e, kf(t, s[n])), qS = (o, e, t, s = le()) => $f(o, e, t, s, "x"), XS = (o, e, t, s = le()) => $f(o, e, t, s, "y"), KS = (o = 1, e = 0, t = le()) => t.mul(o).add(e), YS = (o, e = 1) => (o = g(o), o.abs().pow(e).mul(o.sign())), jS = (o, e = 1, t = 0.5) => g(o).sub(t).mul(e).add(t), QS = (o = le(), e = 1, t = 0) => gu(o.convert("vec2|vec3")).mul(e).add(t), ZS = (o = le(), e = 1, t = 0) => mu(o.convert("vec2|vec3")).mul(e).add(t), JS = (o = le(), e = 1, t = 0) => (o = o.convert("vec2|vec3"), I(mu(o), gu(o.add(w(19, 73)))).mul(e).add(t)), ev = (o = le(), e = 1) => IS(o.convert("vec2|vec3"), e, y(1)), tv = (o = le(), e = 1) => VS(o.convert("vec2|vec3"), e, y(1)), sv = (o = le(), e = 1) => OS(o.convert("vec2|vec3"), e, y(1)), nv = (o = le()) => SS(o.convert("vec2|vec3")), rv = (o = le(), e = 3, t = 2, s = 0.5, n = 1) => jr(o, y(e), t, s).mul(n), iv = (o = le(), e = 3, t = 2, s = 0.5, n = 1) => ES(o, y(e), t, s).mul(n), ov = (o = le(), e = 3, t = 2, s = 0.5, n = 1) => Of(o, y(e), t, s).mul(n), av = (o = le(), e = 3, t = 2, s = 0.5, n = 1) => wS(o, y(e), t, s).mul(n), uv = /* @__PURE__ */ b(([o, e, t]) => {
  const s = Gt(o).toVar("nDir"), n = K(g(0.5).mul(e.sub(t)), It).div(s).toVar("rbmax"), r = K(g(-0.5).mul(e.sub(t)), It).div(s).toVar("rbmin"), i = T().toVar("rbminmax");
  i.x = s.x.greaterThan(g(0)).select(n.x, r.x), i.y = s.y.greaterThan(g(0)).select(n.y, r.y), i.z = s.z.greaterThan(g(0)).select(n.z, r.z);
  const a = $e($e(i.x, i.y), i.z).toVar("correction");
  return It.add(s.mul(a)).toVar("boxIntersection").sub(t);
}), Wf = /* @__PURE__ */ b(([o, e]) => {
  const t = o.x, s = o.y, n = o.z;
  let r = e.element(0).mul(0.886227);
  return r = r.add(e.element(1).mul(2 * 0.511664).mul(s)), r = r.add(e.element(2).mul(2 * 0.511664).mul(n)), r = r.add(e.element(3).mul(2 * 0.511664).mul(t)), r = r.add(e.element(4).mul(2 * 0.429043).mul(t).mul(s)), r = r.add(e.element(5).mul(2 * 0.429043).mul(s).mul(n)), r = r.add(e.element(6).mul(n.mul(n).mul(0.743125).sub(0.247708))), r = r.add(e.element(7).mul(2 * 0.429043).mul(t).mul(n)), r = r.add(e.element(8).mul(0.429043).mul($(t, t).sub($(s, s)))), r;
});
var QA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BRDF_GGX: $o,
  BRDF_Lambert: gs,
  BasicShadowFilter: Cf,
  Break: bp,
  Continue: cx,
  DFGApprox: Ja,
  D_GGX: Lp,
  Discard: mh,
  EPSILON: bd,
  F_Schlick: en,
  Fn: b,
  INFINITY: ey,
  If: H,
  Loop: J,
  NodeAccess: De,
  NodeShaderStage: Fo,
  NodeType: Mm,
  NodeUpdateType: z,
  PCFShadowFilter: Ef,
  PCFSoftShadowFilter: wf,
  PI: $r,
  PI2: ty,
  Return: my,
  Schlick_to_F0: Gp,
  ScriptableNodeResources: Pr,
  ShaderNode: Nn,
  TBNViewMatrix: us,
  VSMShadowFilter: Mf,
  V_GGX_SmithCorrelated: Ip,
  abs: re,
  acesFilmicToneMapping: xf,
  acos: Ed,
  add: _e,
  addMethodChaining: R,
  addNodeElement: xy,
  agxToneMapping: Tf,
  all: va,
  alphaT: Or,
  and: dd,
  anisotropy: Ht,
  anisotropyB: fs,
  anisotropyT: bn,
  any: Sd,
  append: Wl,
  arrayBuffer: Ym,
  asin: Cd,
  assign: rd,
  atan: Ca,
  atan2: Kd,
  atomicAdd: yb,
  atomicAnd: Nb,
  atomicFunc: zt,
  atomicMax: Tb,
  atomicMin: _b,
  atomicOr: bb,
  atomicStore: mb,
  atomicSub: xb,
  atomicXor: Sb,
  attenuationColor: _a,
  attenuationDistance: Ta,
  attribute: Nt,
  attributeArray: lN,
  backgroundBlurriness: of,
  backgroundIntensity: Yo,
  backgroundRotation: af,
  batch: Tp,
  billboarding: z_,
  bitAnd: gd,
  bitNot: md,
  bitOr: yd,
  bitXor: xd,
  bitangentGeometry: $y,
  bitangentLocal: Wy,
  bitangentView: Ph,
  bitangentWorld: Hy,
  bitcast: sy,
  blendBurn: lf,
  blendColor: bN,
  blendDodge: df,
  blendOverlay: pf,
  blendScreen: hf,
  blur: qp,
  bool: Vt,
  buffer: Zn,
  bufferAttribute: jn,
  bumpMap: Vh,
  burn: SN,
  bvec2: Xl,
  bvec3: pa,
  bvec4: Ql,
  bypass: hh,
  cache: vn,
  call: id,
  cameraFar: Xt,
  cameraNear: qt,
  cameraNormalMatrix: vy,
  cameraPosition: _h,
  cameraProjectionMatrix: _s,
  cameraProjectionMatrixInverse: by,
  cameraViewMatrix: Xe,
  cameraWorldMatrix: Sy,
  cbrt: zd,
  cdl: BN,
  ceil: li,
  checker: Yb,
  cineonToneMapping: yf,
  clamp: _t,
  clearcoat: Gr,
  clearcoatRoughness: Ln,
  code: vi,
  color: Hl,
  colorSpaceToWorking: Ia,
  colorToDirection: Vx,
  compute: dh,
  cond: Yd,
  context: pi,
  convert: Jl,
  convertColorSpace: ay,
  convertToTexture: tN,
  cos: Bt,
  cross: hi,
  cubeTexture: Js,
  dFdx: Ea,
  dFdy: wa,
  dashSize: Er,
  defaultBuildStages: Uo,
  defaultShaderStages: Vl,
  defined: Un,
  degrees: Ad,
  deltaTime: sf,
  densityFog: eb,
  densityFogFactor: au,
  depth: Ya,
  depthPass: LN,
  difference: Vd,
  diffuseColor: Q,
  directPointLight: Uf,
  directionToColor: wp,
  dispersion: Na,
  distance: Ld,
  div: ut,
  dodge: vN,
  dot: Zt,
  drawIndex: mp,
  dynamicBufferAttribute: lh,
  element: Zl,
  emissive: Lo,
  equal: od,
  equals: Dd,
  equirectUV: ja,
  exp: Aa,
  exp2: Zs,
  expression: Qt,
  faceDirection: Qn,
  faceForward: Pa,
  faceforward: ny,
  float: g,
  floor: yt,
  fog: zn,
  fract: kt,
  frameGroup: sd,
  frameId: F_,
  frontFacing: vh,
  fwidth: Ud,
  gain: A_,
  gapSize: Vo,
  getConstNodeType: $l,
  getCurrentStack: ha,
  getDirection: Wp,
  getDistanceAttenuation: fu,
  getGeometryRoughness: Dp,
  getNormalFromDepth: nN,
  getParallaxCorrectNormal: uv,
  getRoughness: Za,
  getScreenPosition: sN,
  getShIrradianceAt: Wf,
  getTextureIndex: ef,
  getViewPosition: Ds,
  glsl: qN,
  glslFn: XN,
  grayscale: CN,
  greaterThan: Sa,
  greaterThanEqual: ld,
  hash: v_,
  highpModelNormalViewMatrix: Dy,
  highpModelViewMatrix: Py,
  hue: MN,
  instance: rx,
  instanceIndex: sr,
  instancedArray: dN,
  instancedBufferAttribute: Wr,
  instancedDynamicBufferAttribute: Go,
  instancedMesh: xp,
  int: y,
  inverseSqrt: Ra,
  inversesqrt: ry,
  invocationLocalIndex: nx,
  invocationSubgroupIndex: sx,
  ior: Sn,
  iridescence: ui,
  iridescenceIOR: ma,
  iridescenceThickness: ya,
  ivec2: Ae,
  ivec3: Kl,
  ivec4: Yl,
  js: WN,
  label: Qd,
  length: Dt,
  lengthSq: $d,
  lessThan: ud,
  lessThanEqual: cd,
  lightPosition: lu,
  lightProjectionUV: Af,
  lightShadowMatrix: cu,
  lightTargetDirection: du,
  lightTargetPosition: Rf,
  lightViewPosition: Ri,
  lightingContext: vp,
  lights: Rb,
  linearDepth: qr,
  linearToneMapping: gf,
  localId: ob,
  log: ci,
  log2: mt,
  logarithmicDepthToViewZ: Sx,
  loop: lx,
  luminance: iu,
  mat2: oi,
  mat3: Le,
  mat4: ps,
  matcapUV: Kp,
  materialAO: fp,
  materialAlphaTest: Gh,
  materialAnisotropy: ep,
  materialAnisotropyVector: Ps,
  materialAttenuationColor: up,
  materialAttenuationDistance: ap,
  materialClearcoat: Kh,
  materialClearcoatNormal: jh,
  materialClearcoatRoughness: Yh,
  materialColor: Oh,
  materialDispersion: pp,
  materialEmissive: zh,
  materialIOR: op,
  materialIridescence: tp,
  materialIridescenceIOR: sp,
  materialIridescenceThickness: np,
  materialLightMap: za,
  materialLineDashOffset: hp,
  materialLineDashSize: lp,
  materialLineGapSize: dp,
  materialLineScale: cp,
  materialLineWidth: Jy,
  materialMetalness: qh,
  materialNormal: Xh,
  materialOpacity: ka,
  materialPointWidth: ex,
  materialReference: Pt,
  materialReflectivity: Br,
  materialRefractionRatio: Ch,
  materialRotation: Qh,
  materialRoughness: Hh,
  materialSheen: Zh,
  materialSheenRoughness: Jh,
  materialShininess: kh,
  materialSpecular: $h,
  materialSpecularColor: Wh,
  materialSpecularIntensity: zo,
  materialSpecularStrength: An,
  materialThickness: ip,
  materialTransmission: rp,
  max: fe,
  maxMipLevel: Th,
  mediumpModelViewMatrix: Sh,
  metalness: In,
  min: $e,
  mix: Z,
  mixElement: qd,
  mod: Ba,
  modInt: ba,
  modelDirection: wy,
  modelNormalMatrix: bh,
  modelPosition: My,
  modelScale: By,
  modelViewMatrix: rn,
  modelViewPosition: Fy,
  modelViewProjection: $a,
  modelWorldMatrix: nt,
  modelWorldMatrixInverse: Uy,
  morphReference: Sp,
  mrt: tf,
  mul: $,
  mx_aastep: kf,
  mx_cell_noise_float: nv,
  mx_contrast: jS,
  mx_fractal_noise_float: rv,
  mx_fractal_noise_vec2: iv,
  mx_fractal_noise_vec3: ov,
  mx_fractal_noise_vec4: av,
  mx_hsvtorgb: kS,
  mx_noise_float: QS,
  mx_noise_vec3: ZS,
  mx_noise_vec4: JS,
  mx_ramplr: WS,
  mx_ramptb: HS,
  mx_rgbtohsv: zS,
  mx_safepower: YS,
  mx_splitlr: qS,
  mx_splittb: XS,
  mx_srgb_texture_to_lin_rec709: $S,
  mx_transform_uv: KS,
  mx_worley_noise_float: ev,
  mx_worley_noise_vec2: tv,
  mx_worley_noise_vec3: sv,
  negate: wd,
  neutralToneMapping: _f,
  nodeArray: hs,
  nodeImmutable: B,
  nodeObject: E,
  nodeObjects: qn,
  nodeProxy: C,
  normalFlat: Ah,
  normalGeometry: gi,
  normalLocal: We,
  normalMap: ko,
  normalView: it,
  normalWorld: mi,
  normalize: Gt,
  not: pd,
  notEqual: ad,
  numWorkgroups: rb,
  objectDirection: Ay,
  objectGroup: ga,
  objectPosition: Nh,
  objectScale: Cy,
  objectViewPosition: Ey,
  objectWorldMatrix: Ry,
  oneMinus: Md,
  or: hd,
  orthographicDepthToViewZ: bx,
  oscSawtooth: G_,
  oscSine: I_,
  oscSquare: L_,
  oscTriangle: V_,
  output: Gn,
  outputStruct: b_,
  overlay: RN,
  overloadingFn: Be,
  parabola: Ko,
  parallaxDirection: Ih,
  parallaxUV: Xy,
  parameter: __,
  pass: DN,
  passTexture: IN,
  pcurve: R_,
  perspectiveDepthToViewZ: Xa,
  pmremTexture: eu,
  pointUV: gN,
  pointWidth: Qm,
  positionGeometry: fi,
  positionLocal: pe,
  positionPrevious: Hr,
  positionView: xe,
  positionViewDirection: oe,
  positionWorld: It,
  positionWorldDirection: La,
  posterize: UN,
  pow: ot,
  pow2: Fa,
  pow3: Gd,
  pow4: Od,
  property: nd,
  radians: vd,
  rand: Hd,
  range: sb,
  rangeFog: JN,
  rangeFogFactor: ou,
  reciprocal: Fd,
  reference: te,
  referenceBuffer: Oo,
  reflect: Id,
  reflectVector: Mh,
  reflectView: Eh,
  reflector: j_,
  refract: Ua,
  refractVector: Bh,
  refractView: wh,
  reinhardToneMapping: mf,
  remainder: Nd,
  remap: fh,
  remapClamp: gh,
  renderGroup: O,
  renderOutput: yh,
  rendererReference: ah,
  rotate: tu,
  rotateUV: O_,
  roughness: ft,
  round: Bd,
  rtt: rf,
  sRGBTransferEOTF: th,
  sRGBTransferOETF: sh,
  sampler: Ny,
  saturate: Wd,
  saturation: EN,
  screen: AN,
  screenCoordinate: nr,
  screenSize: kn,
  screenUV: vt,
  scriptable: ZN,
  scriptableValue: Ur,
  select: Me,
  setCurrentStack: Pn,
  shaderStages: Po,
  shadow: Ff,
  shadowPositionWorld: pu,
  sharedUniformGroup: fa,
  sheen: as,
  sheenRoughness: ai,
  shiftLeft: Td,
  shiftRight: _d,
  shininess: kr,
  sign: On,
  sin: Ze,
  sinc: C_,
  skinning: ax,
  skinningReference: Np,
  smoothstep: Ot,
  smoothstepElement: Xd,
  specularColor: Ge,
  specularF90: Vn,
  spherizeUV: k_,
  split: jm,
  spritesheetUV: H_,
  sqrt: Et,
  stack: Fr,
  step: di,
  storage: Si,
  storageBarrier: lb,
  storageObject: cN,
  storageTexture: uf,
  string: Km,
  sub: K,
  subgroupIndex: tx,
  subgroupSize: ab,
  tan: Rd,
  tangentGeometry: Ti,
  tangentLocal: Jn,
  tangentView: er,
  tangentWorld: Uh,
  temp: Jd,
  texture: X,
  texture3D: YT,
  textureBarrier: db,
  textureBicubic: zp,
  textureCubeUV: Hp,
  textureLoad: de,
  textureSize: jt,
  textureStore: yN,
  thickness: xa,
  time: Ns,
  timerDelta: D_,
  timerGlobal: P_,
  timerLocal: U_,
  toOutputColorSpace: nh,
  toWorkingColorSpace: rh,
  toneMapping: uh,
  toneMappingExposure: ch,
  toonOutlinePass: GN,
  transformDirection: kd,
  transformNormal: Rh,
  transformNormalToView: Va,
  transformedBentNormalView: Lh,
  transformedBitangentView: Dh,
  transformedBitangentWorld: qy,
  transformedClearcoatNormalView: Gs,
  transformedNormalView: he,
  transformedNormalWorld: yi,
  transformedTangentView: Oa,
  transformedTangentWorld: zy,
  transmission: zr,
  transpose: Pd,
  triNoise3D: w_,
  triplanarTexture: X_,
  triplanarTextures: nf,
  trunc: Ma,
  tslFn: Xm,
  uint: U,
  uniform: L,
  uniformArray: Ut,
  uniformGroup: td,
  uniforms: Gy,
  userData: TN,
  uv: le,
  uvec2: ql,
  uvec3: nn,
  uvec4: jl,
  varying: qe,
  varyingProperty: Dn,
  vec2: w,
  vec3: T,
  vec4: I,
  vectorComponents: xs,
  velocity: NN,
  vertexColor: pN,
  vertexIndex: gp,
  vertexStage: eh,
  vibrance: wN,
  viewZToLogarithmicDepth: Ka,
  viewZToOrthographicDepth: qs,
  viewZToPerspectiveDepth: Cp,
  viewport: Wa,
  viewportBottomLeft: Tx,
  viewportCoordinate: Rp,
  viewportDepthTexture: qa,
  viewportLinearDepth: vx,
  viewportMipTexture: Ha,
  viewportResolution: yx,
  viewportSafeUV: $_,
  viewportSharedTexture: Lx,
  viewportSize: Ap,
  viewportTexture: _x,
  viewportTopLeft: xx,
  viewportUV: mx,
  wgsl: HN,
  wgslFn: KN,
  workgroupArray: fb,
  workgroupBarrier: cb,
  workgroupId: ib,
  workingToColorSpace: ih,
  xor: fd
});
const Mt = /* @__PURE__ */ new su();
class cv extends Jt {
  /**
   * Constructs a new background management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Nodes} nodes - Renderer component for managing nodes related logic.
   */
  constructor(e, t) {
    super(), this.renderer = e, this.nodes = t;
  }
  /**
   * Updates the background for the given scene. Depending on how `Scene.background`
   * or `Scene.backgroundNode` are configured, this method might configure a simple clear
   * or add a mesh to the render list for rendering the background as a textured plane
   * or skybox.
   *
   * @param {Scene} scene - The scene.
   * @param {RenderList} renderList - The current render list.
   * @param {RenderContext} renderContext - The current render context.
   */
  update(e, t, s) {
    const n = this.renderer, r = this.nodes.getBackgroundNode(e) || e.background;
    let i = !1;
    if (r === null)
      n._clearColor.getRGB(Mt, cs), Mt.a = n._clearColor.a;
    else if (r.isColor === !0)
      r.getRGB(Mt, cs), Mt.a = 1, i = !0;
    else if (r.isNode === !0) {
      const a = this.get(e), u = r;
      Mt.copy(n._clearColor);
      let c = a.backgroundMesh;
      if (c === void 0) {
        const d = pi(I(u).mul(Yo), {
          // @TODO: Add Texture2D support using node context
          getUV: () => af.mul(mi),
          getTextureLevel: () => of
        });
        let h = $a;
        h = h.setZ(h.w);
        const p = new ge();
        p.name = "Background.material", p.side = Tt, p.depthTest = !1, p.depthWrite = !1, p.fog = !1, p.lights = !1, p.vertexNode = h, p.colorNode = d, a.backgroundMeshNode = d, a.backgroundMesh = c = new js(new Sg(1, 32, 32), p), c.frustumCulled = !1, c.name = "Background.mesh", c.onBeforeRender = function(f, m, _) {
          this.matrixWorld.copyPosition(_.matrixWorld);
        };
      }
      const l = u.getCacheKey();
      a.backgroundCacheKey !== l && (a.backgroundMeshNode.node = I(u).mul(Yo), a.backgroundMeshNode.needsUpdate = !0, c.material.needsUpdate = !0, a.backgroundCacheKey = l), t.unshift(c, c.geometry, c.material, 0, 0, null, null);
    } else
      console.error("THREE.Renderer: Unsupported background configuration.", r);
    if (n.autoClear === !0 || i === !0) {
      const a = s.clearColorValue;
      a.r = Mt.r, a.g = Mt.g, a.b = Mt.b, a.a = Mt.a, (n.backend.isWebGLBackend === !0 || n.alpha === !0) && (a.r *= a.a, a.g *= a.a, a.b *= a.a), s.depthClearValue = n._clearDepth, s.stencilClearValue = n._clearStencil, s.clearColor = n.autoClearColor === !0, s.clearDepth = n.autoClearDepth === !0, s.clearStencil = n.autoClearStencil === !0;
    } else
      s.clearColor = !1, s.clearDepth = !1, s.clearStencil = !1;
  }
}
let lv = 0;
class jo {
  /**
   * Constructs a new bind group.
   *
   * @param {String} name - The bind group's name.
   * @param {Array<Binding>} bindings - An array of bindings.
   * @param {Number} index - The group index.
   * @param {Array<Binding>} bindingsReference - An array of reference bindings.
   */
  constructor(e = "", t = [], s = 0, n = []) {
    this.name = e, this.bindings = t, this.index = s, this.bindingsReference = n, this.id = lv++;
  }
}
class dv {
  /**
   * Constructs a new node builder state.
   *
   * @param {String?} vertexShader - The native vertex shader code.
   * @param {String?} fragmentShader - The native fragment shader code.
   * @param {String?} computeShader - The native compute shader code.
   * @param {Array<NodeAttribute>} nodeAttributes - An array of node attributes.
   * @param {Array<BindGroup>} bindings - An array of bind groups.
   * @param {Array<Node>} updateNodes - An array of nodes that implement their `update()` method.
   * @param {Array<Node>} updateBeforeNodes - An array of nodes that implement their `updateBefore()` method.
   * @param {Array<Node>} updateAfterNodes - An array of nodes that implement their `updateAfter()` method.
   * @param {NodeMaterialObserver} monitor - A node material observer.
   * @param {Array<Object>} transforms - An array with transform attribute objects. Only relevant when using compute shaders with WebGL 2.
   */
  constructor(e, t, s, n, r, i, a, u, c, l = []) {
    this.vertexShader = e, this.fragmentShader = t, this.computeShader = s, this.transforms = l, this.nodeAttributes = n, this.bindings = r, this.updateNodes = i, this.updateBeforeNodes = a, this.updateAfterNodes = u, this.monitor = c, this.usedTimes = 0;
  }
  /**
   * This method is used to create a array of bind groups based
   * on the existing bind groups of this state. Shared groups are
   * not cloned.
   *
   * @return {Array<BindGroup>} A array of bind groups.
   */
  createBindings() {
    const e = [];
    for (const t of this.bindings)
      if (t.bindings[0].groupNode.shared !== !0) {
        const n = new jo(t.name, [], t.index, t);
        e.push(n);
        for (const r of t.bindings)
          n.bindings.push(r.clone());
      } else
        e.push(t);
    return e;
  }
}
class fc {
  /**
   * Constructs a new node attribute.
   *
   * @param {String} name - The name of the attribute.
   * @param {String} type - The type of the attribute.
   * @param {Node?} node - An optional reference to the node.
   */
  constructor(e, t, s = null) {
    this.isNodeAttribute = !0, this.name = e, this.type = t, this.node = s;
  }
}
class hv {
  /**
   * Constructs a new node uniform.
   *
   * @param {String} name - The name of the uniform.
   * @param {String} type - The type of the uniform.
   * @param {UniformNode} node - An reference to the node.
   */
  constructor(e, t, s) {
    this.isNodeUniform = !0, this.name = e, this.type = t, this.node = s.getSelf();
  }
  /**
   * The value of the uniform node.
   *
   * @type {Any}
   */
  get value() {
    return this.node.value;
  }
  set value(e) {
    this.node.value = e;
  }
  /**
   * The id of the uniform node.
   *
   * @type {Number}
   */
  get id() {
    return this.node.id;
  }
  /**
   * The uniform node's group.
   *
   * @type {UniformGroupNode}
   */
  get groupNode() {
    return this.node.groupNode;
  }
}
class Hf {
  /**
   * Constructs a new node variable.
   *
   * @param {String} name - The name of the variable.
   * @param {String} type - The type of the variable.
   */
  constructor(e, t) {
    this.isNodeVar = !0, this.name = e, this.type = t;
  }
}
class pv extends Hf {
  /**
   * Constructs a new node varying.
   *
   * @param {String} name - The name of the varying.
   * @param {String} type - The type of the varying.
   */
  constructor(e, t) {
    super(e, t), this.needsInterpolation = !1, this.isNodeVarying = !0;
  }
}
class fv {
  /**
   * Constructs a new code node.
   *
   * @param {String} name - The name of the code.
   * @param {String} type - The node type.
   * @param {String} [code=''] - The native shader code.
   */
  constructor(e, t, s = "") {
    this.name = e, this.type = t, this.code = s, Object.defineProperty(this, "isNodeCode", { value: !0 });
  }
}
let gv = 0;
class Xi {
  /**
   * Constructs a new node cache.
   *
   * @param {NodeCache?} parent - A reference to a parent cache.
   */
  constructor(e = null) {
    this.id = gv++, this.nodesData = /* @__PURE__ */ new WeakMap(), this.parent = e;
  }
  /**
   * Returns the data for the given node.
   *
   * @param {Node} node - The node.
   * @return {Object?} The data for the node.
   */
  getData(e) {
    let t = this.nodesData.get(e);
    return t === void 0 && this.parent !== null && (t = this.parent.getData(e)), t;
  }
  /**
   * Sets the data for a given node.
   *
   * @param {Node} node - The node.
   * @param {Object} data - The data that should be cached.
   */
  setData(e, t) {
    this.nodesData.set(e, t);
  }
}
class mv extends G {
  static get type() {
    return "StructTypeNode";
  }
  /**
   * Constructs a new struct type node.
   *
   * @param {String} name - The name of the struct.
   * @param {Array<String>} types - An array of types.
   */
  constructor(e, t) {
    super(), this.name = e, this.types = t, this.isStructTypeNode = !0;
  }
  /**
   * Returns the member types.
   *
   * @return {Array<String>} The types.
   */
  getMemberTypes() {
    return this.types;
  }
}
class Ss {
  /**
   * Constructs a new uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Any} value - The uniform's value.
   */
  constructor(e, t) {
    this.name = e, this.value = t, this.boundary = 0, this.itemSize = 0, this.offset = 0;
  }
  /**
   * Sets the uniform's value.
   *
   * @param {Any} value - The value to set.
   */
  setValue(e) {
    this.value = e;
  }
  /**
   * Returns the uniform's value.
   *
   * @return {Any} The value.
   */
  getValue() {
    return this.value;
  }
}
class yv extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Number} value - The uniform's value.
   */
  constructor(e, t = 0) {
    super(e, t), this.isNumberUniform = !0, this.boundary = 4, this.itemSize = 1;
  }
}
class xv extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Vector2} value - The uniform's value.
   */
  constructor(e, t = new He()) {
    super(e, t), this.isVector2Uniform = !0, this.boundary = 8, this.itemSize = 2;
  }
}
class Tv extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Vector3} value - The uniform's value.
   */
  constructor(e, t = new Y()) {
    super(e, t), this.isVector3Uniform = !0, this.boundary = 16, this.itemSize = 3;
  }
}
class _v extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Vector4} value - The uniform's value.
   */
  constructor(e, t = new Ce()) {
    super(e, t), this.isVector4Uniform = !0, this.boundary = 16, this.itemSize = 4;
  }
}
class Nv extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Color} value - The uniform's value.
   */
  constructor(e, t = new Ct()) {
    super(e, t), this.isColorUniform = !0, this.boundary = 16, this.itemSize = 3;
  }
}
class bv extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Matrix3} value - The uniform's value.
   */
  constructor(e, t = new $n()) {
    super(e, t), this.isMatrix3Uniform = !0, this.boundary = 48, this.itemSize = 12;
  }
}
class Sv extends Ss {
  /**
   * Constructs a new Number uniform.
   *
   * @param {String} name - The uniform's name.
   * @param {Matrix4} value - The uniform's value.
   */
  constructor(e, t = new Ue()) {
    super(e, t), this.isMatrix4Uniform = !0, this.boundary = 64, this.itemSize = 16;
  }
}
class vv extends yv {
  /**
   * Constructs a new node-based Number uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Number} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
class Av extends xv {
  /**
   * Constructs a new node-based Vector2 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Vector2} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
class Rv extends Tv {
  /**
   * Constructs a new node-based Vector3 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Vector3} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
class Cv extends _v {
  /**
   * Constructs a new node-based Vector4 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Vector4} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
class Ev extends Nv {
  /**
   * Constructs a new node-based Color uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Color} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
class wv extends bv {
  /**
   * Constructs a new node-based Matrix3 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Matrix3} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
class Mv extends Sv {
  /**
   * Constructs a new node-based Matrix4 uniform.
   *
   * @param {NodeUniform} nodeUniform - The node uniform.
   */
  constructor(e) {
    super(e.name, e.value), this.nodeUniform = e;
  }
  /**
   * Overwritten to return the value of the node uniform.
   *
   * @return {Matrix4} The value.
   */
  getValue() {
    return this.nodeUniform.value;
  }
  /**
   * Returns the node uniform data type.
   *
   * @return {String} The data type.
   */
  getType() {
    return this.nodeUniform.type;
  }
}
const Os = 4, gc = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], is = 20, Ki = /* @__PURE__ */ new Al(-1, 1, 1, -1, 0, 1), Bv = /* @__PURE__ */ new Rm(90, 1), mc = /* @__PURE__ */ new Ct();
let Yi = null, ji = 0, Qi = 0;
const rs = (1 + Math.sqrt(5)) / 2, ws = 1 / rs, yc = [
  /* @__PURE__ */ new Y(-rs, ws, 0),
  /* @__PURE__ */ new Y(rs, ws, 0),
  /* @__PURE__ */ new Y(-ws, 0, rs),
  /* @__PURE__ */ new Y(ws, 0, rs),
  /* @__PURE__ */ new Y(0, rs, -ws),
  /* @__PURE__ */ new Y(0, rs, ws),
  /* @__PURE__ */ new Y(-1, 1, -1),
  /* @__PURE__ */ new Y(1, 1, -1),
  /* @__PURE__ */ new Y(-1, 1, 1),
  /* @__PURE__ */ new Y(1, 1, 1)
], Fv = [
  3,
  1,
  5,
  0,
  4,
  2
], Zi = Wp(le(), Nt("faceIndex")).normalize(), yu = T(Zi.x, Zi.y, Zi.z);
class Uv {
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._backgroundBox = null;
  }
  get _hasInitialized() {
    return this._renderer.hasInitialized();
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {Number} [sigma=0] - The blur radius in radians.
   * @param {Number} [near=0.1] - The near plane distance.
   * @param {Number} [far=100] - The far plane distance.
   * @param {RenderTarget?} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   */
  fromScene(e, t = 0, s = 0.1, n = 100, r = null) {
    if (this._setSize(256), this._hasInitialized === !1) {
      console.warn("THREE.PMREMGenerator: .fromScene() called before the backend is initialized. Try using .fromSceneAsync() instead.");
      const a = r || this._allocateTargets();
      return this.fromSceneAsync(e, t, s, n, a), a;
    }
    Yi = this._renderer.getRenderTarget(), ji = this._renderer.getActiveCubeFace(), Qi = this._renderer.getActiveMipmapLevel();
    const i = r || this._allocateTargets();
    return i.depthBuffer = !0, this._sceneToCubeUV(e, s, n, i), t > 0 && this._blur(i, 0, 0, t), this._applyPMREM(i), this._cleanup(i), i;
  }
  async fromSceneAsync(e, t = 0, s = 0.1, n = 100, r = null) {
    return this._hasInitialized === !1 && await this._renderer.init(), this.fromScene(e, t, s, n, r);
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {RenderTarget?} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   */
  fromEquirectangular(e, t = null) {
    if (this._hasInitialized === !1) {
      console.warn("THREE.PMREMGenerator: .fromEquirectangular() called before the backend is initialized. Try using .fromEquirectangularAsync() instead."), this._setSizeFromTexture(e);
      const s = t || this._allocateTargets();
      return this.fromEquirectangularAsync(e, s), s;
    }
    return this._fromTexture(e, t);
  }
  async fromEquirectangularAsync(e, t = null) {
    return this._hasInitialized === !1 && await this._renderer.init(), this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {RenderTarget?} [renderTarget=null] - The render target to use.
   * @return {RenderTarget} The resulting PMREM.
   */
  fromCubemap(e, t = null) {
    if (this._hasInitialized === !1) {
      console.warn("THREE.PMREMGenerator: .fromCubemap() called before the backend is initialized. Try using .fromCubemapAsync() instead."), this._setSizeFromTexture(e);
      const s = t || this._allocateTargets();
      return this.fromCubemapAsync(e, t), s;
    }
    return this._fromTexture(e, t);
  }
  async fromCubemapAsync(e, t = null) {
    return this._hasInitialized === !1 && await this._renderer.init(), this._fromTexture(e, t);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  async compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = Tc(), await this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  async compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = _c(), await this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
  }
  // private interface
  _setSizeFromTexture(e) {
    e.mapping === Ks || e.mapping === Ys ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4);
  }
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(Yi, ji, Qi), e.scissorTest = !1, mr(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    this._setSizeFromTexture(e), Yi = this._renderer.getRenderTarget(), ji = this._renderer.getActiveCubeFace(), Qi = this._renderer.getActiveMipmapLevel();
    const s = t || this._allocateTargets();
    return this._textureToCubeUV(e, s), this._applyPMREM(s), this._cleanup(s), s;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, s = {
      magFilter: Lt,
      minFilter: Lt,
      generateMipmaps: !1,
      type: at,
      format: Xs,
      colorSpace: cs
      //depthBuffer: false
    }, n = xc(e, t, s);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = xc(e, t, s);
      const { _lodMax: r } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas, lodMeshes: this._lodMeshes } = Pv(r)), this._blurMaterial = Dv(r, e, t);
    }
    return n;
  }
  async _compileMaterial(e) {
    const t = new js(this._lodPlanes[0], e);
    await this._renderer.compile(t, Ki);
  }
  _sceneToCubeUV(e, t, s, n) {
    const r = Bv;
    r.near = t, r.far = s;
    const i = [1, 1, 1, 1, -1, 1], a = [1, -1, 1, -1, 1, -1], u = this._renderer, c = u.autoClear;
    u.getClearColor(mc), u.autoClear = !1;
    let l = this._backgroundBox;
    if (l === null) {
      const p = new Gc({
        name: "PMREM.Background",
        side: Tt,
        depthWrite: !1,
        depthTest: !1
      });
      l = new js(new Cl(), p);
    }
    let d = !1;
    const h = e.background;
    h ? h.isColor && (l.material.color.copy(h), e.background = null, d = !0) : (l.material.color.copy(mc), d = !0), u.setRenderTarget(n), u.clear(), d && u.render(l, r);
    for (let p = 0; p < 6; p++) {
      const f = p % 3;
      f === 0 ? (r.up.set(0, i[p], 0), r.lookAt(a[p], 0, 0)) : f === 1 ? (r.up.set(0, 0, i[p]), r.lookAt(0, a[p], 0)) : (r.up.set(0, i[p], 0), r.lookAt(0, 0, a[p]));
      const m = this._cubeSize;
      mr(n, f * m, p > 2 ? m : 0, m, m), u.render(e, r);
    }
    u.autoClear = c, e.background = h;
  }
  _textureToCubeUV(e, t) {
    const s = this._renderer, n = e.mapping === Ks || e.mapping === Ys;
    n ? this._cubemapMaterial === null && (this._cubemapMaterial = Tc(e)) : this._equirectMaterial === null && (this._equirectMaterial = _c(e));
    const r = n ? this._cubemapMaterial : this._equirectMaterial;
    r.fragmentNode.value = e;
    const i = this._lodMeshes[0];
    i.material = r;
    const a = this._cubeSize;
    mr(t, 0, 0, 3 * a, 2 * a), s.setRenderTarget(t), s.render(i, Ki);
  }
  _applyPMREM(e) {
    const t = this._renderer, s = t.autoClear;
    t.autoClear = !1;
    const n = this._lodPlanes.length;
    for (let r = 1; r < n; r++) {
      const i = Math.sqrt(this._sigmas[r] * this._sigmas[r] - this._sigmas[r - 1] * this._sigmas[r - 1]), a = yc[(n - r - 1) % yc.length];
      this._blur(e, r - 1, r, i, a);
    }
    t.autoClear = s;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * @param {RenderTarget} cubeUVRenderTarget - The cubemap render target.
   * @param {Number} lodIn - The input level-of-detail.
   * @param {Number} lodOut - The output level-of-detail.
   * @param {Number} sigma - The blur radius in radians.
   * @param {Vector3} [poleAxis] - The pole axis.
   */
  _blur(e, t, s, n, r) {
    const i = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      i,
      t,
      s,
      n,
      "latitudinal",
      r
    ), this._halfBlur(
      i,
      e,
      s,
      s,
      n,
      "longitudinal",
      r
    );
  }
  _halfBlur(e, t, s, n, r, i, a) {
    const u = this._renderer, c = this._blurMaterial;
    i !== "latitudinal" && i !== "longitudinal" && console.error("blur direction must be either latitudinal or longitudinal!");
    const l = 3, d = this._lodMeshes[n];
    d.material = c;
    const h = c.uniforms, p = this._sizeLods[s] - 1, f = isFinite(r) ? Math.PI / (2 * p) : 2 * Math.PI / (2 * is - 1), m = r / f, _ = isFinite(r) ? 1 + Math.floor(l * m) : is;
    _ > is && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${_} samples when the maximum is set to ${is}`);
    const S = [];
    let A = 0;
    for (let V = 0; V < is; ++V) {
      const k = V / m, ie = Math.exp(-k * k / 2);
      S.push(ie), V === 0 ? A += ie : V < _ && (A += 2 * ie);
    }
    for (let V = 0; V < S.length; V++)
      S[V] = S[V] / A;
    e.texture.frame = (e.texture.frame || 0) + 1, h.envMap.value = e.texture, h.samples.value = _, h.weights.array = S, h.latitudinal.value = i === "latitudinal" ? 1 : 0, a && (h.poleAxis.value = a);
    const { _lodMax: M } = this;
    h.dTheta.value = f, h.mipInt.value = M - s;
    const F = this._sizeLods[n], D = 3 * F * (n > M - Os ? n - M + Os : 0), P = 4 * (this._cubeSize - F);
    mr(t, D, P, 3 * F, 2 * F), u.setRenderTarget(t), u.render(d, Ki);
  }
}
function Pv(o) {
  const e = [], t = [], s = [], n = [];
  let r = o;
  const i = o - Os + 1 + gc.length;
  for (let a = 0; a < i; a++) {
    const u = Math.pow(2, r);
    t.push(u);
    let c = 1 / u;
    a > o - Os ? c = gc[a - o + Os - 1] : a === 0 && (c = 0), s.push(c);
    const l = 1 / (u - 2), d = -l, h = 1 + l, p = [d, d, h, d, h, h, d, d, h, h, d, h], f = 6, m = 6, _ = 3, S = 2, A = 1, M = new Float32Array(_ * m * f), F = new Float32Array(S * m * f), D = new Float32Array(A * m * f);
    for (let V = 0; V < f; V++) {
      const k = V % 3 * 2 / 3 - 1, ie = V > 2 ? 0 : -1, me = [
        k,
        ie,
        0,
        k + 2 / 3,
        ie,
        0,
        k + 2 / 3,
        ie + 1,
        0,
        k,
        ie,
        0,
        k + 2 / 3,
        ie + 1,
        0,
        k,
        ie + 1,
        0
      ], ne = Fv[V];
      M.set(me, _ * m * ne), F.set(p, S * m * ne);
      const Ke = [ne, ne, ne, ne, ne, ne];
      D.set(Ke, A * m * ne);
    }
    const P = new El();
    P.setAttribute("position", new Cr(M, _)), P.setAttribute("uv", new Cr(F, S)), P.setAttribute("faceIndex", new Cr(D, A)), e.push(P), n.push(new js(P, null)), r > Os && r--;
  }
  return { lodPlanes: e, sizeLods: t, sigmas: s, lodMeshes: n };
}
function xc(o, e, t) {
  const s = new ms(o, e, t);
  return s.texture.mapping = po, s.texture.name = "PMREM.cubeUv", s.texture.isPMREMTexture = !0, s.scissorTest = !0, s;
}
function mr(o, e, t, s, n) {
  o.viewport.set(e, t, s, n), o.scissor.set(e, t, s, n);
}
function xu(o) {
  const e = new ge();
  return e.depthTest = !1, e.depthWrite = !1, e.blending = Mn, e.name = `PMREM_${o}`, e;
}
function Dv(o, e, t) {
  const s = Ut(new Array(is).fill(0)), n = L(new Y(0, 1, 0)), r = L(0), i = g(is), a = L(0), u = L(1), c = X(null), l = L(0), d = g(1 / e), h = g(1 / t), p = g(o), f = {
    n: i,
    latitudinal: a,
    weights: s,
    poleAxis: n,
    outputDirection: yu,
    dTheta: r,
    samples: u,
    envMap: c,
    mipInt: l,
    CUBEUV_TEXEL_WIDTH: d,
    CUBEUV_TEXEL_HEIGHT: h,
    CUBEUV_MAX_MIP: p
  }, m = xu("blur");
  return m.uniforms = f, m.fragmentNode = qp({ ...f, latitudinal: a.equal(1) }), m;
}
function Tc(o) {
  const e = xu("cubemap");
  return e.fragmentNode = Js(o, yu), e;
}
function _c(o) {
  const e = xu("equirect");
  return e.fragmentNode = X(o, ja(yu), 0), e;
}
const Nc = /* @__PURE__ */ new WeakMap(), Iv = /* @__PURE__ */ new Map([
  [Int8Array, "int"],
  [Int16Array, "int"],
  [Int32Array, "int"],
  [Uint8Array, "uint"],
  [Uint16Array, "uint"],
  [Uint32Array, "uint"],
  [Float32Array, "float"]
]), yr = (o) => /e/g.test(o) ? String(o).replace(/\+/g, "") : (o = Number(o), o + (o % 1 ? "" : ".0"));
class qf {
  /**
   * Constructs a new node builder.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Renderer} renderer - The current renderer.
   * @param {NodeParser} parser - A reference to a node parser.
   */
  constructor(e, t, s) {
    this.object = e, this.material = e && e.material || null, this.geometry = e && e.geometry || null, this.renderer = t, this.parser = s, this.scene = null, this.camera = null, this.nodes = [], this.sequentialNodes = [], this.updateNodes = [], this.updateBeforeNodes = [], this.updateAfterNodes = [], this.hashNodes = {}, this.monitor = null, this.lightsNode = null, this.environmentNode = null, this.fogNode = null, this.clippingContext = null, this.vertexShader = null, this.fragmentShader = null, this.computeShader = null, this.flowNodes = { vertex: [], fragment: [], compute: [] }, this.flowCode = { vertex: "", fragment: "", compute: "" }, this.uniforms = { vertex: [], fragment: [], compute: [], index: 0 }, this.structs = { vertex: [], fragment: [], compute: [], index: 0 }, this.bindings = { vertex: {}, fragment: {}, compute: {} }, this.bindingsIndexes = {}, this.bindGroups = null, this.attributes = [], this.bufferAttributes = [], this.varyings = [], this.codes = {}, this.vars = {}, this.flow = { code: "" }, this.chaining = [], this.stack = Fr(), this.stacks = [], this.tab = "	", this.currentFunctionNode = null, this.context = {
      material: this.material
    }, this.cache = new Xi(), this.globalCache = this.cache, this.flowsData = /* @__PURE__ */ new WeakMap(), this.shaderStage = null, this.buildStage = null, this.useComparisonMethod = !1;
  }
  /**
   * Returns the bind groups of the current renderer.
   *
   * @return {ChainMap} The cache.
   */
  getBindGroupsCache() {
    let e = Nc.get(this.renderer);
    return e === void 0 && (e = new At(), Nc.set(this.renderer, e)), e;
  }
  /**
   * Factory method for creating an instance of {@link RenderTarget} with the given
   * dimensions and options.
   *
   * @param {Number} width - The width of the render target.
   * @param {Number} height - The height of the render target.
   * @param {Object} options - The options of the render target.
   * @return {RenderTarget} The render target.
   */
  createRenderTarget(e, t, s) {
    return new ms(e, t, s);
  }
  /**
   * Factory method for creating an instance of {@link CubeRenderTarget} with the given
   * dimensions and options.
   *
   * @param {Number} size - The size of the cube render target.
   * @param {Object} options - The options of the cube render target.
   * @return {CubeRenderTarget} The cube render target.
   */
  createCubeRenderTarget(e, t) {
    return new Mp(e, t);
  }
  /**
   * Factory method for creating an instance of {@link PMREMGenerator}.
   *
   * @return {PMREMGenerator} The PMREM generator.
   */
  createPMREMGenerator() {
    return new Uv(this.renderer);
  }
  /**
   * Whether the given node is included in the internal array of nodes or not.
   *
   * @param {Node} node - The node to test.
   * @return {Boolean} Whether the given node is included in the internal array of nodes or not.
   */
  includes(e) {
    return this.nodes.includes(e);
  }
  /**
   * Returns a bind group for the given group name and binding.
   *
   * @private
   * @param {String} groupName - The group name.
   * @param {Array<NodeUniformsGroup>} bindings - List of bindings.
   * @return {BindGroup} The bind group
   */
  _getBindGroup(e, t) {
    const s = this.getBindGroupsCache(), n = [];
    let r = !0;
    for (const a of t)
      n.push(a), r = r && a.groupNode.shared !== !0;
    let i;
    return r ? (i = s.get(n), i === void 0 && (i = new jo(e, n, this.bindingsIndexes[e].group, n), s.set(n, i))) : i = new jo(e, n, this.bindingsIndexes[e].group, n), i;
  }
  /**
   * Returns an array of node uniform groups for the given group name and shader stage.
   *
   * @param {String} groupName - The group name.
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {Array<NodeUniformsGroup>} The array of node uniform groups.
   */
  getBindGroupArray(e, t) {
    const s = this.bindings[t];
    let n = s[e];
    return n === void 0 && (this.bindingsIndexes[e] === void 0 && (this.bindingsIndexes[e] = { binding: 0, group: Object.keys(this.bindingsIndexes).length }), s[e] = n = []), n;
  }
  /**
   * Returns a list bindings of all shader stages separated by groups.
   *
   * @return {Array<BindGroup>} The list of bindings.
   */
  getBindings() {
    let e = this.bindGroups;
    if (e === null) {
      const t = {}, s = this.bindings;
      for (const n of Po)
        for (const r in s[n]) {
          const i = s[n][r];
          (t[r] || (t[r] = [])).push(...i);
        }
      e = [];
      for (const n in t) {
        const r = t[n], i = this._getBindGroup(n, r);
        e.push(i);
      }
      this.bindGroups = e;
    }
    return e;
  }
  /**
   * Sorts the bind groups and updates {@link NodeBuilder#bindingsIndexes}.
   */
  sortBindingGroups() {
    const e = this.getBindings();
    e.sort((t, s) => t.bindings[0].groupNode.order - s.bindings[0].groupNode.order);
    for (let t = 0; t < e.length; t++) {
      const s = e[t];
      this.bindingsIndexes[s.name].group = t, s.index = t;
    }
  }
  /**
   * The builder maintains each node in a hash-based dictionary.
   * This method sets the given node (value) with the given hash (key) into this dictionary.
   *
   * @param {Node} node - The node to add.
   * @param {Number} hash - The hash of the node.
   */
  setHashNode(e, t) {
    this.hashNodes[t] = e;
  }
  /**
   * Adds a node to this builder.
   *
   * @param {Node} node - The node to add.
   */
  addNode(e) {
    this.nodes.includes(e) === !1 && (this.nodes.push(e), this.setHashNode(e, e.getHash(this)));
  }
  /**
   * It is used to add Nodes that will be used as FRAME and RENDER events,
   * and need to follow a certain sequence in the calls to work correctly.
   * This function should be called after 'setup()' in the 'build()' process to ensure that the child nodes are processed first.
   *
   * @param {Node} node - The node to add.
   */
  addSequentialNode(e) {
    this.sequentialNodes.includes(e) === !1 && this.sequentialNodes.push(e);
  }
  /**
   * Checks the update types of nodes
   */
  buildUpdateNodes() {
    for (const e of this.nodes)
      e.getUpdateType() !== z.NONE && this.updateNodes.push(e.getSelf());
    for (const e of this.sequentialNodes) {
      const t = e.getUpdateBeforeType(), s = e.getUpdateAfterType();
      t !== z.NONE && this.updateBeforeNodes.push(e.getSelf()), s !== z.NONE && this.updateAfterNodes.push(e.getSelf());
    }
  }
  /**
   * A reference the current node which is the
   * last node in the chain of nodes.
   *
   * @type {Node}
   */
  get currentNode() {
    return this.chaining[this.chaining.length - 1];
  }
  /**
   * Whether the given texture is filtered or not.
   *
   * @param {Texture} texture - The texture to check.
   * @return {Boolean} Whether the given texture is filtered or not.
   */
  isFilteredTexture(e) {
    return e.magFilter === Lt || e.magFilter === Bo || e.magFilter === Hs || e.magFilter === ds || e.minFilter === Lt || e.minFilter === Bo || e.minFilter === Hs || e.minFilter === ds;
  }
  /**
   * Adds the given node to the internal node chain.
   * This is used to check recursive calls in node-graph.
   *
   * @param {Node} node - The node to add.
   */
  addChain(e) {
    this.chaining.push(e);
  }
  /**
   * Removes the given node from the internal node chain.
   *
   * @param {Node} node - The node to remove.
   */
  removeChain(e) {
    if (this.chaining.pop() !== e)
      throw new Error("NodeBuilder: Invalid node chaining!");
  }
  /**
   * Returns the native shader method name for a given generic name. E.g.
   * the method name `textureDimensions` matches the WGSL name but must be
   * resolved to `textureSize` in GLSL.
   *
   * @abstract
   * @param {String} method - The method name to resolve.
   * @return {String} The resolved method name.
   */
  getMethod(e) {
    return e;
  }
  /**
   * Returns a node for the given hash, see {@link NodeBuilder#setHashNode}.
   *
   * @param {Number} hash - The hash of the node.
   * @return {Node} The found node.
   */
  getNodeFromHash(e) {
    return this.hashNodes[e];
  }
  /**
   * Adds the Node to a target flow so that it can generate code in the 'generate' process.
   *
   * @param {('vertex'|'fragment'|'compute')} shaderStage - The shader stage.
   * @param {Node} node - The node to add.
   * @return {Node} The node.
   */
  addFlow(e, t) {
    return this.flowNodes[e].push(t), t;
  }
  /**
   * Sets builder's context.
   *
   * @param {Object} context - The context to set.
   */
  setContext(e) {
    this.context = e;
  }
  /**
   * Returns the builder's current context.
   *
   * @return {Object} The builder's current context.
   */
  getContext() {
    return this.context;
  }
  /**
   * Gets a context used in shader construction that can be shared across different materials.
   * This is necessary since the renderer cache can reuse shaders generated in one material and use them in another.
   *
   * @return {Object} The builder's current context without material.
   */
  getSharedContext() {
    return { ...this.context }, this.context;
  }
  /**
   * Sets builder's cache.
   *
   * @param {NodeCache} cache - The cache to set.
   */
  setCache(e) {
    this.cache = e;
  }
  /**
   * Returns the builder's current cache.
   *
   * @return {NodeCache} The builder's current cache.
   */
  getCache() {
    return this.cache;
  }
  /**
   * Returns a cache for the given node.
   *
   * @param {Node} node - The node.
   * @param {Boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
   * @return {NodeCache} The cache.
   */
  getCacheFromNode(e, t = !0) {
    const s = this.getDataFromNode(e);
    return s.cache === void 0 && (s.cache = new Xi(t ? this.getCache() : null)), s.cache;
  }
  /**
   * Whether the requested feature is available or not.
   *
   * @abstract
   * @param {String} name - The requested feature.
   * @return {Boolean} Whether the requested feature is supported or not.
   */
  isAvailable() {
    return !1;
  }
  /**
   * Returns the vertexIndex input variable as a native shader string.
   *
   * @abstract
   * @return {String} The instanceIndex shader string.
   */
  getVertexIndex() {
    console.warn("Abstract function.");
  }
  /**
   * Returns the instanceIndex input variable as a native shader string.
   *
   * @abstract
   * @return {String} The instanceIndex shader string.
   */
  getInstanceIndex() {
    console.warn("Abstract function.");
  }
  /**
   * Returns the drawIndex input variable as a native shader string.
   * Only relevant for WebGL and its `WEBGL_multi_draw` extension.
   *
   * @abstract
   * @return {String} The drawIndex shader string.
   */
  getDrawIndex() {
    console.warn("Abstract function.");
  }
  /**
   * Returns the frontFacing input variable as a native shader string.
   *
   * @abstract
   * @return {String} The frontFacing shader string.
   */
  getFrontFacing() {
    console.warn("Abstract function.");
  }
  /**
   * Returns the fragCoord input variable as a native shader string.
   *
   * @abstract
   * @return {String} The fragCoord shader string.
   */
  getFragCoord() {
    console.warn("Abstract function.");
  }
  /**
   * Whether to flip texture data along its vertical axis or not. WebGL needs
   * this method evaluate to `true`, WebGPU to `false`.
   *
   * @abstract
   * @return {Boolean} Whether to flip texture data along its vertical axis or not.
   */
  isFlipY() {
    return !1;
  }
  /**
   * Calling this method increases the usage count for the given node by one.
   *
   * @param {Node} node - The node to increase the usage count for.
   * @return {Number} The updated usage count.
   */
  increaseUsage(e) {
    const t = this.getDataFromNode(e);
    return t.usageCount = t.usageCount === void 0 ? 1 : t.usageCount + 1, t.usageCount;
  }
  /**
   * Generates a texture sample shader string for the given texture data.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {String} textureProperty - The texture property name.
   * @param {String} uvSnippet - Snippet defining the texture coordinates.
   * @return {String} The generated shader string.
   */
  generateTexture() {
    console.warn("Abstract function.");
  }
  /**
   * Generates a texture LOD shader string for the given texture data.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {String} textureProperty - The texture property name.
   * @param {String} uvSnippet - Snippet defining the texture coordinates.
   * @param {String} levelSnippet - Snippet defining the mip level.
   * @return {String} The generated shader string.
   */
  generateTextureLod() {
    console.warn("Abstract function.");
  }
  /**
   * Generates the shader string for the given type and value.
   *
   * @param {String} type - The type.
   * @param {Any?} [value=null] - The value.
   * @return {String} The generated value as a shader string.
   */
  generateConst(e, t = null) {
    if (t === null && (e === "float" || e === "int" || e === "uint" ? t = 0 : e === "bool" ? t = !1 : e === "color" ? t = new Ct() : e === "vec2" ? t = new He() : e === "vec3" ? t = new Y() : e === "vec4" && (t = new Ce())), e === "float") return yr(t);
    if (e === "int") return `${Math.round(t)}`;
    if (e === "uint") return t >= 0 ? `${Math.round(t)}u` : "0u";
    if (e === "bool") return t ? "true" : "false";
    if (e === "color") return `${this.getType("vec3")}( ${yr(t.r)}, ${yr(t.g)}, ${yr(t.b)} )`;
    const s = this.getTypeLength(e), n = this.getComponentType(e), r = (i) => this.generateConst(n, i);
    if (s === 2)
      return `${this.getType(e)}( ${r(t.x)}, ${r(t.y)} )`;
    if (s === 3)
      return `${this.getType(e)}( ${r(t.x)}, ${r(t.y)}, ${r(t.z)} )`;
    if (s === 4)
      return `${this.getType(e)}( ${r(t.x)}, ${r(t.y)}, ${r(t.z)}, ${r(t.w)} )`;
    if (s > 4 && t && (t.isMatrix3 || t.isMatrix4))
      return `${this.getType(e)}( ${t.elements.map(r).join(", ")} )`;
    if (s > 4)
      return `${this.getType(e)}()`;
    throw new Error(`NodeBuilder: Type '${e}' not found in generate constant attempt.`);
  }
  /**
   * It might be necessary to convert certain data types to different ones
   * so this method can be used to hide the conversion.
   *
   * @param {String} type - The type.
   * @return {String} The updated type.
   */
  getType(e) {
    return e === "color" ? "vec3" : e;
  }
  /**
   * Whether the given attribute name is defined in the geometry or not.
   *
   * @param {String} name - The attribute name.
   * @return {Boolean} Whether the given attribute name is defined in the geometry.
   */
  hasGeometryAttribute(e) {
    return this.geometry && this.geometry.getAttribute(e) !== void 0;
  }
  /**
   * Returns a node attribute for the given name and type.
   *
   * @param {String} name - The attribute's name.
   * @param {String} type - The attribute's type.
   * @return {NodeAttribute} The node attribute.
   */
  getAttribute(e, t) {
    const s = this.attributes;
    for (const r of s)
      if (r.name === e)
        return r;
    const n = new fc(e, t);
    return s.push(n), n;
  }
  /**
   * Returns for the given node and shader stage the property name for the shader.
   *
   * @param {Node} node - The node.
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {String} The property name.
   */
  getPropertyName(e) {
    return e.name;
  }
  /**
   * Whether the given type is a vector type or not.
   *
   * @param {String} type - The type to check.
   * @return {Boolean} Whether the given type is a vector type or not.
   */
  isVector(e) {
    return /vec\d/.test(e);
  }
  /**
   * Whether the given type is a matrix type or not.
   *
   * @param {String} type - The type to check.
   * @return {Boolean} Whether the given type is a matrix type or not.
   */
  isMatrix(e) {
    return /mat\d/.test(e);
  }
  /**
   * Whether the given type is a reference type or not.
   *
   * @param {String} type - The type to check.
   * @return {Boolean} Whether the given type is a reference type or not.
   */
  isReference(e) {
    return e === "void" || e === "property" || e === "sampler" || e === "texture" || e === "cubeTexture" || e === "storageTexture" || e === "depthTexture" || e === "texture3D";
  }
  /**
   * Whether the given texture needs a conversion to working color space.
   *
   * @abstract
   * @param {Texture} texture - The texture to check.
   * @return {Boolean} Whether a color space conversion is required or not.
   */
  needsToWorkingColorSpace() {
    return !1;
  }
  /**
   * Returns the component type of a given texture.
   *
   * @param {Texture} texture - The texture.
   * @return {String} The component type.
   */
  getComponentTypeFromTexture(e) {
    const t = e.type;
    if (e.isDataTexture) {
      if (t === Ve) return "int";
      if (t === Pe) return "uint";
    }
    return "float";
  }
  /**
   * Returns the element type for a given type.
   *
   * @param {String} type - The type.
   * @return {String} The element type.
   */
  getElementType(e) {
    return e === "mat2" ? "vec2" : e === "mat3" ? "vec3" : e === "mat4" ? "vec4" : this.getComponentType(e);
  }
  /**
   * Returns the component type for a given type.
   *
   * @param {String} type - The type.
   * @return {String} The component type.
   */
  getComponentType(e) {
    if (e = this.getVectorType(e), e === "float" || e === "bool" || e === "int" || e === "uint") return e;
    const t = /(b|i|u|)(vec|mat)([2-4])/.exec(e);
    return t === null ? null : t[1] === "b" ? "bool" : t[1] === "i" ? "int" : t[1] === "u" ? "uint" : "float";
  }
  /**
   * Returns the vector type for a given type.
   *
   * @param {String} type - The type.
   * @return {String} The vector type.
   */
  getVectorType(e) {
    return e === "color" ? "vec3" : e === "texture" || e === "cubeTexture" || e === "storageTexture" || e === "texture3D" ? "vec4" : e;
  }
  /**
   * Returns the data type for the given the length and component type.
   *
   * @param {Number} length - The length.
   * @param {String} [componentType='float'] - The component type.
   * @return {String} The type.
   */
  getTypeFromLength(e, t = "float") {
    if (e === 1) return t;
    const s = Bl(e);
    return (t === "float" ? "" : t[0]) + s;
  }
  /**
   * Returns the type for a given typed array.
   *
   * @param {TypedArray} array - The typed array.
   * @return {String} The type.
   */
  getTypeFromArray(e) {
    return Iv.get(e.constructor);
  }
  /**
   * Returns the type for a given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   * @return {String} The type.
   */
  getTypeFromAttribute(e) {
    let t = e;
    e.isInterleavedBufferAttribute && (t = e.data);
    const s = t.array, n = e.itemSize, r = e.normalized;
    let i;
    return !(e instanceof Rl) && r !== !0 && (i = this.getTypeFromArray(s)), this.getTypeFromLength(n, i);
  }
  /**
   * Returns the length for the given data type.
   *
   * @param {String} type - The data type.
   * @return {Number} The length.
   */
  getTypeLength(e) {
    const t = this.getVectorType(e), s = /vec([2-4])/.exec(t);
    return s !== null ? Number(s[1]) : t === "float" || t === "bool" || t === "int" || t === "uint" ? 1 : /mat2/.test(e) === !0 ? 4 : /mat3/.test(e) === !0 ? 9 : /mat4/.test(e) === !0 ? 16 : 0;
  }
  /**
   * Returns the vector type for a given matrix type.
   *
   * @param {String} type - The matrix type.
   * @return {String} The vector type.
   */
  getVectorFromMatrix(e) {
    return e.replace("mat", "vec");
  }
  /**
   * For a given type this method changes the component type to the
   * given value. E.g. `vec4` should be changed to the new component type
   * `uint` which results in `uvec4`.
   *
   * @param {String} type - The type.
   * @param {String} newComponentType - The new component type.
   * @return {String} The new type.
   */
  changeComponentType(e, t) {
    return this.getTypeFromLength(this.getTypeLength(e), t);
  }
  /**
   * Returns the integer type pendant for the given type.
   *
   * @param {String} type - The type.
   * @return {String} The integer type.
   */
  getIntegerType(e) {
    const t = this.getComponentType(e);
    return t === "int" || t === "uint" ? e : this.changeComponentType(e, "int");
  }
  /**
   * Adds a stack node to the internal stack.
   *
   * @return {StackNode} The added stack node.
   */
  addStack() {
    return this.stack = Fr(this.stack), this.stacks.push(ha() || this.stack), Pn(this.stack), this.stack;
  }
  /**
   * Removes the last stack node from the internal stack.
   *
   * @return {StackNode} The removed stack node.
   */
  removeStack() {
    const e = this.stack;
    return this.stack = e.parent, Pn(this.stacks.pop()), e;
  }
  /**
   * The builder maintains (cached) data for each node during the building process. This method
   * can be used to get these data for a specific shader stage and cache.
   *
   * @param {Node} node - The node to get the data for.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @param {NodeCache?} cache - An optional cache.
   * @return {Object} The node data.
   */
  getDataFromNode(e, t = this.shaderStage, s = null) {
    s = s === null ? e.isGlobal(this) ? this.globalCache : this.cache : s;
    let n = s.getData(e);
    return n === void 0 && (n = {}, s.setData(e, n)), n[t] === void 0 && (n[t] = {}), n[t];
  }
  /**
   * Returns the properties for the given node and shader stage.
   *
   * @param {Node} node - The node to get the properties for.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage='any'] - The shader stage.
   * @return {Object} The node properties.
   */
  getNodeProperties(e, t = "any") {
    const s = this.getDataFromNode(e, t);
    return s.properties || (s.properties = { outputNode: null });
  }
  /**
   * Returns an instance of {@link NodeAttribute} for the given buffer attribute node.
   *
   * @param {BufferAttributeNode} node - The buffer attribute node.
   * @param {String} type - The node type.
   * @return {NodeAttribute} The node attribute.
   */
  getBufferAttributeFromNode(e, t) {
    const s = this.getDataFromNode(e);
    let n = s.bufferAttribute;
    if (n === void 0) {
      const r = this.uniforms.index++;
      n = new fc("nodeAttribute" + r, t, e), this.bufferAttributes.push(n), s.bufferAttribute = n;
    }
    return n;
  }
  /**
   * Returns an instance of {@link StructTypeNode} for the given output struct node.
   *
   * @param {OutputStructNode} node - The output struct node.
   * @param {Array<String>} types - The output struct types.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @return {StructTypeNode} The struct type attribute.
   */
  getStructTypeFromNode(e, t, s = this.shaderStage) {
    const n = this.getDataFromNode(e, s);
    let r = n.structType;
    if (r === void 0) {
      const i = this.structs.index++;
      r = new mv("StructType" + i, t), this.structs[s].push(r), n.structType = r;
    }
    return r;
  }
  /**
   * Returns an instance of {@link NodeUniform} for the given uniform node.
   *
   * @param {UniformNode} node - The uniform node.
   * @param {String} type - The uniform type.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @param {String?} name - The name of the uniform.
   * @return {NodeUniform} The node uniform.
   */
  getUniformFromNode(e, t, s = this.shaderStage, n = null) {
    const r = this.getDataFromNode(e, s, this.globalCache);
    let i = r.uniform;
    if (i === void 0) {
      const a = this.uniforms.index++;
      i = new hv(n || "nodeUniform" + a, t, e), this.uniforms[s].push(i), r.uniform = i;
    }
    return i;
  }
  /**
   * Returns an instance of {@link NodeVar} for the given variable node.
   *
   * @param {VarNode} node - The variable node.
   * @param {String?} name - The variable's name.
   * @param {String} [type=node.getNodeType( this )] - The variable's type.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @return {NodeVar} The node variable.
   */
  getVarFromNode(e, t = null, s = e.getNodeType(this), n = this.shaderStage) {
    const r = this.getDataFromNode(e, n);
    let i = r.variable;
    if (i === void 0) {
      const a = this.vars[n] || (this.vars[n] = []);
      t === null && (t = "nodeVar" + a.length), i = new Hf(t, s), a.push(i), r.variable = i;
    }
    return i;
  }
  /**
   * Returns an instance of {@link NodeVarying} for the given varying node.
   *
   * @param {(VaryingNode|PropertyNode)} node - The varying node.
   * @param {String?} name - The varying's name.
   * @param {String} [type=node.getNodeType( this )] - The varying's type.
   * @return {NodeVar} The node varying.
   */
  getVaryingFromNode(e, t = null, s = e.getNodeType(this)) {
    const n = this.getDataFromNode(e, "any");
    let r = n.varying;
    if (r === void 0) {
      const i = this.varyings, a = i.length;
      t === null && (t = "nodeVarying" + a), r = new pv(t, s), i.push(r), n.varying = r;
    }
    return r;
  }
  /**
   * Returns an instance of {@link NodeCode} for the given code node.
   *
   * @param {CodeNode} node - The code node.
   * @param {String} type - The node type.
   * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
   * @return {NodeCode} The node code.
   */
  getCodeFromNode(e, t, s = this.shaderStage) {
    const n = this.getDataFromNode(e);
    let r = n.code;
    if (r === void 0) {
      const i = this.codes[s] || (this.codes[s] = []), a = i.length;
      r = new fv("nodeCode" + a, t), i.push(r), n.code = r;
    }
    return r;
  }
  /**
  	 * Adds a code flow based on the code-block hierarchy.
  
  	 * This is used so that code-blocks like If,Else create their variables locally if the Node
  	 * is only used inside one of these conditionals in the current shader stage.
  	 *
  	 * @param {Node} node - The node to add.
  	 * @param {Node} nodeBlock - Node-based code-block. Usually 'ConditionalNode'.
  	 */
  addFlowCodeHierarchy(e, t) {
    const { flowCodes: s, flowCodeBlock: n } = this.getDataFromNode(e);
    let r = !0, i = t;
    for (; i; ) {
      if (n.get(i) === !0) {
        r = !1;
        break;
      }
      i = this.getDataFromNode(i).parentNodeBlock;
    }
    if (r)
      for (const a of s)
        this.addLineFlowCode(a);
  }
  /**
   * Add a inline-code to the current flow code-block.
   *
   * @param {Node} node - The node to add.
   * @param {String} code - The code to add.
   * @param {Node} nodeBlock - Current ConditionalNode
   */
  addLineFlowCodeBlock(e, t, s) {
    const n = this.getDataFromNode(e), r = n.flowCodes || (n.flowCodes = []), i = n.flowCodeBlock || (n.flowCodeBlock = /* @__PURE__ */ new WeakMap());
    r.push(t), i.set(s, !0);
  }
  /**
   * Add a inline-code to the current flow.
   *
   * @param {String} code - The code to add.
   * @param {Node?} [node= null] - Optional Node, can help the system understand if the Node is part of a code-block.
   * @return {NodeBuilder} A reference to this node builder.
   */
  addLineFlowCode(e, t = null) {
    return e === "" ? this : (t !== null && this.context.nodeBlock && this.addLineFlowCodeBlock(t, e, this.context.nodeBlock), e = this.tab + e, /;\s*$/.test(e) || (e = e + `;
`), this.flow.code += e, this);
  }
  /**
   * Adds a code to the current code flow.
   *
   * @param {String} code - Shader code.
   * @return {NodeBuilder} A reference to this node builder.
   */
  addFlowCode(e) {
    return this.flow.code += e, this;
  }
  /**
   * Add tab in the code that will be generated so that other snippets respect the current tabulation.
   * Typically used in codes with If,Else.
   *
   * @return {NodeBuilder} A reference to this node builder.
   */
  addFlowTab() {
    return this.tab += "	", this;
  }
  /**
   * Removes a tab.
   *
   * @return {NodeBuilder} A reference to this node builder.
   */
  removeFlowTab() {
    return this.tab = this.tab.slice(0, -1), this;
  }
  /**
   * Gets the current flow data based on a Node.
   *
   * @param {Node} node - Node that the flow was started.
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {Object} The flow data.
   */
  getFlowData(e) {
    return this.flowsData.get(e);
  }
  /**
   * Executes the node flow based on a root node to generate the final shader code.
   *
   * @param {Node} node - The node to execute.
   * @return {Object} The code flow.
   */
  flowNode(e) {
    const t = e.getNodeType(this), s = this.flowChildNode(e, t);
    return this.flowsData.set(e, s), s;
  }
  /**
   * Returns the native shader operator name for a given generic name.
   * It is a similar type of method like {@link NodeBuilder#getMethod}.
   *
   * @param {ShaderNodeInternal} shaderNode - The shader node to build the function node with.
   * @return {FunctionNode} The build function node.
   */
  buildFunctionNode(e) {
    const t = new Nf(), s = this.currentFunctionNode;
    return this.currentFunctionNode = t, t.code = this.buildFunctionCode(e), this.currentFunctionNode = s, t;
  }
  /**
   * Generates a code flow based on a TSL function: Fn().
   *
   * @param {ShaderNodeInternal} shaderNode - A function code will be generated based on the input.
   * @return {Object}
   */
  flowShaderNode(e) {
    const t = e.layout, s = {
      [Symbol.iterator]() {
        let i = 0;
        const a = Object.values(this);
        return {
          next: () => ({
            value: a[i],
            done: i++ >= a.length
          })
        };
      }
    };
    for (const i of t.inputs)
      s[i.name] = new Zp(i.type, i.name);
    e.layout = null;
    const n = e.call(s), r = this.flowStagesNode(n, t.type);
    return e.layout = t, r;
  }
  /**
   * Runs the node flow through all the steps of creation, 'setup', 'analyze', 'generate'.
   *
   * @param {Node} node - The node to execute.
   * @param {String?} output - Expected output type. For example 'vec3'.
   * @return {Object}
   */
  flowStagesNode(e, t = null) {
    const s = this.flow, n = this.vars, r = this.cache, i = this.buildStage, a = this.stack, u = {
      code: ""
    };
    this.flow = u, this.vars = {}, this.cache = new Xi(), this.stack = Fr();
    for (const c of Uo)
      this.setBuildStage(c), u.result = e.build(this, t);
    return u.vars = this.getVars(this.shaderStage), this.flow = s, this.vars = n, this.cache = r, this.stack = a, this.setBuildStage(i), u;
  }
  /**
   * Returns the native shader operator name for a given generic name.
   * It is a similar type of method like {@link NodeBuilder#getMethod}.
   *
   * @abstract
   * @param {String} op - The operator name to resolve.
   * @return {String} The resolved operator name.
   */
  getFunctionOperator() {
    return null;
  }
  /**
   * Generates a code flow based on a child Node.
   *
   * @param {Node} node - The node to execute.
   * @param {String?} output - Expected output type. For example 'vec3'.
   * @return {Object} The code flow.
   */
  flowChildNode(e, t = null) {
    const s = this.flow, n = {
      code: ""
    };
    return this.flow = n, n.result = e.build(this, t), this.flow = s, n;
  }
  /**
   * Executes a flow of code in a different stage.
   *
   * Some nodes like `varying()` have the ability to compute code in vertex-stage and
   * return the value in fragment-stage even if it is being executed in an input fragment.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @param {Node} node - The node to execute.
   * @param {String?} output - Expected output type. For example 'vec3'.
   * @param {String?} propertyName - The property name to assign the result.
   * @return {Object}
   */
  flowNodeFromShaderStage(e, t, s = null, n = null) {
    const r = this.shaderStage;
    this.setShaderStage(e);
    const i = this.flowChildNode(t, s);
    return n !== null && (i.code += `${this.tab + n} = ${i.result};
`), this.flowCode[e] = this.flowCode[e] + i.code, this.setShaderStage(r), i;
  }
  /**
   * Returns an array holding all node attributes of this node builder.
   *
   * @return {Array<NodeAttribute>} The node attributes of this builder.
   */
  getAttributesArray() {
    return this.attributes.concat(this.bufferAttributes);
  }
  /**
   * Returns the attribute definitions as a shader string for the given shader stage.
   *
   * @abstract
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {String} The attribute code section.
   */
  getAttributes() {
    console.warn("Abstract function.");
  }
  /**
   * Returns the varying definitions as a shader string for the given shader stage.
   *
   * @abstract
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {String} The varying code section.
   */
  getVaryings() {
    console.warn("Abstract function.");
  }
  /**
   * Returns a single variable definition as a shader string for the given variable type and name.
   *
   * @param {String} type - The variable's type.
   * @param {String} name - The variable's name.
   * @return {String} The shader string.
   */
  getVar(e, t) {
    return `${this.getType(e)} ${t}`;
  }
  /**
   * Returns the variable definitions as a shader string for the given shader stage.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {String} The variable code section.
   */
  getVars(e) {
    let t = "";
    const s = this.vars[e];
    if (s !== void 0)
      for (const n of s)
        t += `${this.getVar(n.type, n.name)}; `;
    return t;
  }
  /**
   * Returns the uniform definitions as a shader string for the given shader stage.
   *
   * @abstract
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {String} The uniform code section.
   */
  getUniforms() {
    console.warn("Abstract function.");
  }
  /**
   * Returns the native code definitions as a shader string for the given shader stage.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
   * @return {String} The native code section.
   */
  getCodes(e) {
    const t = this.codes[e];
    let s = "";
    if (t !== void 0)
      for (const n of t)
        s += n.code + `
`;
    return s;
  }
  /**
   * Returns the hash of this node builder.
   *
   * @return {String} The hash.
   */
  getHash() {
    return this.vertexShader + this.fragmentShader + this.computeShader;
  }
  /**
   * Sets the current shader stage.
   *
   * @param {('vertex'|'fragment'|'compute'|'any')?} shaderStage - The shader stage to set.
   */
  setShaderStage(e) {
    this.shaderStage = e;
  }
  /**
   * Returns the current shader stage.
   *
   * @return {('vertex'|'fragment'|'compute'|'any')?} The current shader stage.
   */
  getShaderStage() {
    return this.shaderStage;
  }
  /**
   * Sets the current build stage.
   *
   * @param {('setup'|'analyze'|'generate')?} buildStage - The build stage to set.
   */
  setBuildStage(e) {
    this.buildStage = e;
  }
  /**
   * Returns the current build stage.
   *
   * @return {('setup'|'analyze'|'generate')?} The current build stage.
   */
  getBuildStage() {
    return this.buildStage;
  }
  /**
   * Controls the code build of the shader stages.
   *
   * @abstract
   */
  buildCode() {
    console.warn("Abstract function.");
  }
  /**
   * Central build method which controls the build for the given object.
   *
   * @return {NodeBuilder} A reference to this node builder.
   */
  build() {
    const { object: e, material: t, renderer: s } = this;
    if (t !== null) {
      let n = s.library.fromMaterial(t);
      n === null && (console.error(`NodeMaterial: Material "${t.type}" is not compatible.`), n = new ge()), n.build(this);
    } else
      this.addFlow("compute", e);
    for (const n of Uo) {
      this.setBuildStage(n), this.context.vertex && this.context.vertex.isNode && this.flowNodeFromShaderStage("vertex", this.context.vertex);
      for (const r of Po) {
        this.setShaderStage(r);
        const i = this.flowNodes[r];
        for (const a of i)
          n === "generate" ? this.flowNode(a) : a.build(this);
      }
    }
    return this.setBuildStage(null), this.setShaderStage(null), this.buildCode(), this.buildUpdateNodes(), this;
  }
  /**
   * Returns a uniform representation which is later used for UBO generation and rendering.
   *
   * @param {NodeUniform} uniformNode - The uniform node.
   * @param {String} type - The requested type.
   * @return {Uniform} The uniform.
   */
  getNodeUniform(e, t) {
    if (t === "float" || t === "int" || t === "uint") return new vv(e);
    if (t === "vec2" || t === "ivec2" || t === "uvec2") return new Av(e);
    if (t === "vec3" || t === "ivec3" || t === "uvec3") return new Rv(e);
    if (t === "vec4" || t === "ivec4" || t === "uvec4") return new Cv(e);
    if (t === "color") return new Ev(e);
    if (t === "mat3") return new wv(e);
    if (t === "mat4") return new Mv(e);
    throw new Error(`Uniform "${t}" not declared.`);
  }
  /**
   * Formats the given shader snippet from a given type into another one. E.g.
   * this method might be used to convert a simple float string `"1.0"` into a
   * `vec3` representation: `"vec3<f32>( 1.0 )"`.
   *
   * @param {String} snippet - The shader snippet.
   * @param {String} fromType - The source type.
   * @param {String} toType - The target type.
   * @return {String} The updated shader string.
   */
  format(e, t, s) {
    if (t = this.getVectorType(t), s = this.getVectorType(s), t === s || s === null || this.isReference(s))
      return e;
    const n = this.getTypeLength(t), r = this.getTypeLength(s);
    return n === 16 && r === 9 ? `${this.getType(s)}(${e}[0].xyz, ${e}[1].xyz, ${e}[2].xyz)` : n === 9 && r === 4 ? `${this.getType(s)}(${e}[0].xy, ${e}[1].xy)` : n > 4 || r > 4 || r === 0 ? e : n === r ? `${this.getType(s)}( ${e} )` : n > r ? this.format(`${e}.${"xyz".slice(0, r)}`, this.getTypeFromLength(r, this.getComponentType(t)), s) : r === 4 && n > 1 ? `${this.getType(s)}( ${this.format(e, t, "vec3")}, 1.0 )` : n === 2 ? `${this.getType(s)}( ${this.format(e, t, "vec2")}, 0.0 )` : (n === 1 && r > 1 && t !== this.getComponentType(s) && (e = `${this.getType(this.getComponentType(s))}( ${e} )`), `${this.getType(s)}( ${e} )`);
  }
  /**
   * Returns a signature with the engine's current revision.
   *
   * @return {String} The signature.
   */
  getSignature() {
    return `// Three.js r${Hc} - Node System
`;
  }
  // deprecated
  createNodeMaterial(e = "NodeMaterial") {
    throw new Error(`THREE.NodeBuilder: createNodeMaterial() was deprecated. Use new ${e}() instead.`);
  }
}
class bc {
  /**
   * Constructs a new node fame.
   */
  constructor() {
    this.time = 0, this.deltaTime = 0, this.frameId = 0, this.renderId = 0, this.updateMap = /* @__PURE__ */ new WeakMap(), this.updateBeforeMap = /* @__PURE__ */ new WeakMap(), this.updateAfterMap = /* @__PURE__ */ new WeakMap(), this.renderer = null, this.material = null, this.camera = null, this.object = null, this.scene = null;
  }
  /**
   * Returns a dictionary for a given node and update map which
   * is used to correctly call node update methods per frame or render.
   *
   * @private
   * @param {WeakMap<Node, Object>} referenceMap - The reference weak map.
   * @param {Node} nodeRef - The reference to the current node.
   * @return {Object<String,WeakMap>} The dictionary.
   */
  _getMaps(e, t) {
    let s = e.get(t);
    return s === void 0 && (s = {
      renderMap: /* @__PURE__ */ new WeakMap(),
      frameMap: /* @__PURE__ */ new WeakMap()
    }, e.set(t, s)), s;
  }
  /**
   * This method executes the {@link Node#updateBefore} for the given node.
   * It makes sure {@link Node#updateBeforeType} is honored meaning the update
   * is only executed once per frame, render or object depending on the update
   * type.
   *
   * @param {Node} node - The node that should be updated.
   */
  updateBeforeNode(e) {
    const t = e.getUpdateBeforeType(), s = e.updateReference(this);
    if (t === z.FRAME) {
      const { frameMap: n } = this._getMaps(this.updateBeforeMap, s);
      n.get(s) !== this.frameId && e.updateBefore(this) !== !1 && n.set(s, this.frameId);
    } else if (t === z.RENDER) {
      const { renderMap: n } = this._getMaps(this.updateBeforeMap, s);
      n.get(s) !== this.renderId && e.updateBefore(this) !== !1 && n.set(s, this.renderId);
    } else t === z.OBJECT && e.updateBefore(this);
  }
  /**
   * This method executes the {@link Node#updateAfter} for the given node.
   * It makes sure {@link Node#updateAfterType} is honored meaning the update
   * is only executed once per frame, render or object depending on the update
   * type.
   *
   * @param {Node} node - The node that should be updated.
   */
  updateAfterNode(e) {
    const t = e.getUpdateAfterType(), s = e.updateReference(this);
    if (t === z.FRAME) {
      const { frameMap: n } = this._getMaps(this.updateAfterMap, s);
      n.get(s) !== this.frameId && e.updateAfter(this) !== !1 && n.set(s, this.frameId);
    } else if (t === z.RENDER) {
      const { renderMap: n } = this._getMaps(this.updateAfterMap, s);
      n.get(s) !== this.renderId && e.updateAfter(this) !== !1 && n.set(s, this.renderId);
    } else t === z.OBJECT && e.updateAfter(this);
  }
  /**
   * This method executes the {@link Node#update} for the given node.
   * It makes sure {@link Node#updateType} is honored meaning the update
   * is only executed once per frame, render or object depending on the update
   * type.
   *
   * @param {Node} node - The node that should be updated.
   */
  updateNode(e) {
    const t = e.getUpdateType(), s = e.updateReference(this);
    if (t === z.FRAME) {
      const { frameMap: n } = this._getMaps(this.updateMap, s);
      n.get(s) !== this.frameId && e.update(this) !== !1 && n.set(s, this.frameId);
    } else if (t === z.RENDER) {
      const { renderMap: n } = this._getMaps(this.updateMap, s);
      n.get(s) !== this.renderId && e.update(this) !== !1 && n.set(s, this.renderId);
    } else t === z.OBJECT && e.update(this);
  }
  /**
   * Updates the internal state of the node frame. This method is
   * called by the renderer in its internal animation loop.
   */
  update() {
    this.frameId++, this.lastTime === void 0 && (this.lastTime = performance.now()), this.deltaTime = (performance.now() - this.lastTime) / 1e3, this.lastTime = performance.now(), this.time += this.deltaTime;
  }
}
class Tu {
  /**
   * Constructs a new node function input.
   *
   * @param {String} type - The input type.
   * @param {String} name - The input name.
   * @param {Number?} [count=null] - If the input is an Array, count will be the length.
   * @param {('in'|'out'|'inout')} [qualifier=''] - The parameter qualifier (only relevant for GLSL).
   * @param {Boolean} [isConst=false] - Whether the input uses a const qualifier or not (only relevant for GLSL).
   */
  constructor(e, t, s = null, n = "", r = !1) {
    this.type = e, this.name = t, this.count = s, this.qualifier = n, this.isConst = r;
  }
}
Tu.isNodeFunctionInput = !0;
class Lv extends bs {
  static get type() {
    return "DirectionalLightNode";
  }
  /**
   * Constructs a new directional light node.
   *
   * @param {DirectionalLight?} [light=null] - The directional light source.
   */
  constructor(e = null) {
    super(e);
  }
  setup(e) {
    super.setup(e);
    const t = e.context.lightingModel, s = this.colorNode, n = du(this.light), r = e.context.reflectedLight;
    t.direct({
      lightDirection: n,
      lightColor: s,
      reflectedLight: r
    }, e.stack, e);
  }
}
const Ji = /* @__PURE__ */ new Ue(), xr = /* @__PURE__ */ new Ue();
let mn = null;
class Vv extends bs {
  static get type() {
    return "RectAreaLightNode";
  }
  /**
   * Constructs a new rect area light node.
   *
   * @param {RectAreaLight?} [light=null] - The rect area light source.
   */
  constructor(e = null) {
    super(e), this.halfHeight = L(new Y()).setGroup(O), this.halfWidth = L(new Y()).setGroup(O), this.updateType = z.RENDER;
  }
  /**
   * Overwritten to updated rect area light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update(e) {
    super.update(e);
    const { light: t } = this, s = e.camera.matrixWorldInverse;
    xr.identity(), Ji.copy(t.matrixWorld), Ji.premultiply(s), xr.extractRotation(Ji), this.halfWidth.value.set(t.width * 0.5, 0, 0), this.halfHeight.value.set(0, t.height * 0.5, 0), this.halfWidth.value.applyMatrix4(xr), this.halfHeight.value.applyMatrix4(xr);
  }
  setup(e) {
    super.setup(e);
    let t, s;
    e.isAvailable("float32Filterable") ? (t = X(mn.LTC_FLOAT_1), s = X(mn.LTC_FLOAT_2)) : (t = X(mn.LTC_HALF_1), s = X(mn.LTC_HALF_2));
    const { colorNode: n, light: r } = this, i = e.context.lightingModel, a = Ri(r), u = e.context.reflectedLight;
    i.directRectArea({
      lightColor: n,
      lightPosition: a,
      halfWidth: this.halfWidth,
      halfHeight: this.halfHeight,
      reflectedLight: u,
      ltc_1: t,
      ltc_2: s
    }, e.stack, e);
  }
  /**
   * Used to configure the internal BRDF approximation texture data.
   *
   * @param {RectAreaLightTexturesLib} ltc - The BRDF approximation texture data.
   */
  static setLTC(e) {
    mn = e;
  }
}
class Xf extends bs {
  static get type() {
    return "SpotLightNode";
  }
  /**
   * Constructs a new spot light node.
   *
   * @param {SpotLight?} [light=null] - The spot light source.
   */
  constructor(e = null) {
    super(e), this.coneCosNode = L(0).setGroup(O), this.penumbraCosNode = L(0).setGroup(O), this.cutoffDistanceNode = L(0).setGroup(O), this.decayExponentNode = L(0).setGroup(O);
  }
  /**
   * Overwritten to updated spot light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update(e) {
    super.update(e);
    const { light: t } = this;
    this.coneCosNode.value = Math.cos(t.angle), this.penumbraCosNode.value = Math.cos(t.angle * (1 - t.penumbra)), this.cutoffDistanceNode.value = t.distance, this.decayExponentNode.value = t.decay;
  }
  /**
   * Computes the spot attenuation for the given angle.
   *
   * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
   * @return {Node<float>} The spot attenuation.
   */
  getSpotAttenuation(e) {
    const { coneCosNode: t, penumbraCosNode: s } = this;
    return Ot(t, s, e);
  }
  setup(e) {
    super.setup(e);
    const t = e.context.lightingModel, { colorNode: s, cutoffDistanceNode: n, decayExponentNode: r, light: i } = this, a = Ri(i).sub(xe), u = a.normalize(), c = u.dot(du(i)), l = this.getSpotAttenuation(c), d = a.length(), h = fu({
      lightDistance: d,
      cutoffDistance: n,
      decayExponent: r
    });
    let p = s.mul(l).mul(h);
    if (i.map) {
      const m = Af(i), _ = X(i.map, m.xy).onRenderUpdate(() => i.map);
      p = m.mul(2).sub(1).abs().lessThan(1).all().select(p.mul(_), p);
    }
    const f = e.context.reflectedLight;
    t.direct({
      lightDirection: u,
      lightColor: p,
      reflectedLight: f
    }, e.stack, e);
  }
}
class Gv extends Xf {
  static get type() {
    return "IESSpotLightNode";
  }
  /**
   * Overwrites the default implementation to compute an IES conform spot attenuation.
   *
   * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
   * @return {Node<float>} The spot attenuation.
   */
  getSpotAttenuation(e) {
    const t = this.light.iesMap;
    let s = null;
    if (t && t.isTexture === !0) {
      const n = e.acos().mul(1 / Math.PI);
      s = X(t, w(n, 0), 0).r;
    } else
      s = super.getSpotAttenuation(e);
    return s;
  }
}
class Ov extends bs {
  static get type() {
    return "AmbientLightNode";
  }
  /**
   * Constructs a new ambient light node.
   *
   * @param {AmbientLight?} [light=null] - The ambient light source.
   */
  constructor(e = null) {
    super(e);
  }
  setup({ context: e }) {
    e.irradiance.addAssign(this.colorNode);
  }
}
class kv extends bs {
  static get type() {
    return "HemisphereLightNode";
  }
  /**
   * Constructs a new hemisphere light node.
   *
   * @param {HemisphereLight?} [light=null] - The hemisphere light source.
   */
  constructor(e = null) {
    super(e), this.lightPositionNode = lu(e), this.lightDirectionNode = this.lightPositionNode.normalize(), this.groundColorNode = L(new Ct()).setGroup(O);
  }
  /**
   * Overwritten to updated hemisphere light specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update(e) {
    const { light: t } = this;
    super.update(e), this.lightPositionNode.object3d = t, this.groundColorNode.value.copy(t.groundColor).multiplyScalar(t.intensity);
  }
  setup(e) {
    const { colorNode: t, groundColorNode: s, lightDirectionNode: n } = this, i = it.dot(n).mul(0.5).add(0.5), a = Z(s, t, i);
    e.context.irradiance.addAssign(a);
  }
}
class zv extends bs {
  static get type() {
    return "LightProbeNode";
  }
  /**
   * Constructs a new light probe node.
   *
   * @param {LightProbe?} [light=null] - The light probe.
   */
  constructor(e = null) {
    super(e);
    const t = [];
    for (let s = 0; s < 9; s++) t.push(new Y());
    this.lightProbe = Ut(t);
  }
  /**
   * Overwritten to updated light probe specific uniforms.
   *
   * @param {NodeFrame} frame - A reference to the current node frame.
   */
  update(e) {
    const { light: t } = this;
    super.update(e);
    for (let s = 0; s < 9; s++)
      this.lightProbe.array[s].copy(t.sh.coefficients[s]).multiplyScalar(t.intensity);
  }
  setup(e) {
    const t = Wf(mi, this.lightProbe);
    e.context.irradiance.addAssign(t);
  }
}
class Kf {
  /**
   * The method parses the given native code an returns a node function.
   *
   * @abstract
   * @param {String} source - The native shader code.
   * @return {NodeFunction} A node function.
   */
  parseFunction() {
    console.warn("Abstract function.");
  }
}
class _u {
  /**
   * Constructs a new node function.
   *
   * @param {String} type - The node type. This type is the return type of the node function.
   * @param {Array<NodeFunctionInput>} inputs - The function's inputs.
   * @param {String} [name=''] - The function's name.
   * @param {String} [precision=''] - The precision qualifier.
   */
  constructor(e, t, s = "", n = "") {
    this.type = e, this.inputs = t, this.name = s, this.precision = n;
  }
  /**
   * This method returns the native code of the node function.
   *
   * @abstract
   * @param {String} name - The function's name.
   * @return {String} A shader code.
   */
  getCode() {
    console.warn("Abstract function.");
  }
}
_u.isNodeFunction = !0;
const $v = /^\s*(highp|mediump|lowp)?\s*([a-z_0-9]+)\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)/i, Wv = /[a-z_0-9]+/ig, Sc = "#pragma main", Hv = (o) => {
  o = o.trim();
  const e = o.indexOf(Sc), t = e !== -1 ? o.slice(e + Sc.length) : o, s = t.match($v);
  if (s !== null && s.length === 5) {
    const n = s[4], r = [];
    let i = null;
    for (; (i = Wv.exec(n)) !== null; )
      r.push(i);
    const a = [];
    let u = 0;
    for (; u < r.length; ) {
      const f = r[u][0] === "const";
      f === !0 && u++;
      let m = r[u][0];
      m === "in" || m === "out" || m === "inout" ? u++ : m = "";
      const _ = r[u++][0];
      let S = Number.parseInt(r[u][0]);
      Number.isNaN(S) === !1 ? u++ : S = null;
      const A = r[u++][0];
      a.push(new Tu(_, A, S, m, f));
    }
    const c = t.substring(s[0].length), l = s[3] !== void 0 ? s[3] : "", d = s[2], h = s[1] !== void 0 ? s[1] : "", p = e !== -1 ? o.slice(0, e) : "";
    return {
      type: d,
      inputs: a,
      name: l,
      precision: h,
      inputsCode: n,
      blockCode: c,
      headerCode: p
    };
  } else
    throw new Error("FunctionNode: Function is not a GLSL code.");
};
class qv extends _u {
  /**
   * Constructs a new GLSL node function.
   *
   * @param {String} source - The GLSL source.
   */
  constructor(e) {
    const { type: t, inputs: s, name: n, precision: r, inputsCode: i, blockCode: a, headerCode: u } = Hv(e);
    super(t, s, n, r), this.inputsCode = i, this.blockCode = a, this.headerCode = u;
  }
  /**
   * This method returns the GLSL code of the node function.
   *
   * @param {String} [name=this.name] - The function's name.
   * @return {String} The shader code.
   */
  getCode(e = this.name) {
    let t;
    const s = this.blockCode;
    if (s !== "") {
      const { type: n, inputsCode: r, headerCode: i, precision: a } = this;
      let u = `${n} ${e} ( ${r.trim()} )`;
      a !== "" && (u = `${a} ${u}`), t = i + u + s;
    } else
      t = "";
    return t;
  }
}
class Xv extends Kf {
  /**
   * The method parses the given GLSL code an returns a node function.
   *
   * @param {String} source - The GLSL code.
   * @return {GLSLNodeFunction} A node function.
   */
  parseFunction(e) {
    return new qv(e);
  }
}
const vc = /* @__PURE__ */ new WeakMap();
class Kv extends Jt {
  /**
   * Constructs a new nodes management component.
   *
   * @param {Renderer} renderer - The renderer.
   * @param {Backend} backend - The renderer's backend.
   */
  constructor(e, t) {
    super(), this.renderer = e, this.backend = t, this.nodeFrame = new bc(), this.nodeBuilderCache = /* @__PURE__ */ new Map(), this.callHashCache = new At(), this.groupsData = new At(), this.cacheLib = {};
  }
  /**
   * Returns `true` if the given node uniforms group must be updated or not.
   *
   * @param {NodeUniformsGroup} nodeUniformsGroup - The node uniforms group.
   * @return {Boolean} Whether the node uniforms group requires an update or not.
   */
  updateGroup(e) {
    const t = e.groupNode, s = t.name;
    if (s === ga.name) return !0;
    if (s === O.name) {
      const i = this.get(e), a = this.nodeFrame.renderId;
      return i.renderId !== a ? (i.renderId = a, !0) : !1;
    }
    if (s === sd.name) {
      const i = this.get(e), a = this.nodeFrame.frameId;
      return i.frameId !== a ? (i.frameId = a, !0) : !1;
    }
    const n = [t, e];
    let r = this.groupsData.get(n);
    return r === void 0 && this.groupsData.set(n, r = {}), r.version !== t.version ? (r.version = t.version, !0) : !1;
  }
  /**
   * Returns the cache key for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Number} The cache key.
   */
  getForRenderCacheKey(e) {
    return e.initialCacheKey;
  }
  /**
   * Returns a node builder state for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {NodeBuilderState} The node builder state.
   */
  getForRender(e) {
    const t = this.get(e);
    let s = t.nodeBuilderState;
    if (s === void 0) {
      const { nodeBuilderCache: n } = this, r = this.getForRenderCacheKey(e);
      if (s = n.get(r), s === void 0) {
        const i = this.backend.createNodeBuilder(e.object, this.renderer);
        i.scene = e.scene, i.material = e.material, i.camera = e.camera, i.context.material = e.material, i.lightsNode = e.lightsNode, i.environmentNode = this.getEnvironmentNode(e.scene), i.fogNode = this.getFogNode(e.scene), i.clippingContext = e.clippingContext, i.build(), s = this._createNodeBuilderState(i), n.set(r, s);
      }
      s.usedTimes++, t.nodeBuilderState = s;
    }
    return s;
  }
  /**
   * Deletes the given object from the internal data map
   *
   * @param {Any} object - The object to delete.
   * @return {Object?} The deleted dictionary.
   */
  delete(e) {
    if (e.isRenderObject) {
      const t = this.get(e).nodeBuilderState;
      t.usedTimes--, t.usedTimes === 0 && this.nodeBuilderCache.delete(this.getForRenderCacheKey(e));
    }
    return super.delete(e);
  }
  /**
   * Returns a node builder state for the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   * @return {NodeBuilderState} The node builder state.
   */
  getForCompute(e) {
    const t = this.get(e);
    let s = t.nodeBuilderState;
    if (s === void 0) {
      const n = this.backend.createNodeBuilder(e, this.renderer);
      n.build(), s = this._createNodeBuilderState(n), t.nodeBuilderState = s;
    }
    return s;
  }
  /**
   * Creates a node builder state for the given node builder.
   *
   * @private
   * @param {NodeBuilder} nodeBuilder - The node builder.
   * @return {NodeBuilderState} The node builder state.
   */
  _createNodeBuilderState(e) {
    return new dv(
      e.vertexShader,
      e.fragmentShader,
      e.computeShader,
      e.getAttributesArray(),
      e.getBindings(),
      e.updateNodes,
      e.updateBeforeNodes,
      e.updateAfterNodes,
      e.monitor,
      e.transforms
    );
  }
  /**
   * Returns an environment node for the current configured
   * scene environment.
   *
   * @param {Scene} scene - The scene.
   * @return {Node} A node representing the current scene environment.
   */
  getEnvironmentNode(e) {
    this.updateEnvironment(e);
    let t = null;
    if (e.environmentNode && e.environmentNode.isNode)
      t = e.environmentNode;
    else {
      const s = this.get(e);
      s.environmentNode && (t = s.environmentNode);
    }
    return t;
  }
  /**
   * Returns a background node for the current configured
   * scene background.
   *
   * @param {Scene} scene - The scene.
   * @return {Node} A node representing the current scene background.
   */
  getBackgroundNode(e) {
    this.updateBackground(e);
    let t = null;
    if (e.backgroundNode && e.backgroundNode.isNode)
      t = e.backgroundNode;
    else {
      const s = this.get(e);
      s.backgroundNode && (t = s.backgroundNode);
    }
    return t;
  }
  /**
   * Returns a fog node for the current configured scene fog.
   *
   * @param {Scene} scene - The scene.
   * @return {Node} A node representing the current scene fog.
   */
  getFogNode(e) {
    return this.updateFog(e), e.fogNode || this.get(e).fogNode || null;
  }
  /**
   * Returns a cache key for the given scene and lights node.
   * This key is used by `RenderObject` as a part of the dynamic
   * cache key (a key that must be checked every time the render
   * objects is drawn).
   *
   * @param {Scene} scene - The scene.
   * @param {LightsNode} lightsNode - The lights node.
   * @return {Number} The cache key.
   */
  getCacheKey(e, t) {
    const s = [e, t], n = this.renderer.info.calls;
    let r = this.callHashCache.get(s);
    if (r === void 0 || r.callId !== n) {
      const i = this.getEnvironmentNode(e), a = this.getFogNode(e), u = [];
      t && u.push(t.getCacheKey(!0)), i && u.push(i.getCacheKey()), a && u.push(a.getCacheKey()), u.push(this.renderer.shadowMap.enabled ? 1 : 0), r = {
        callId: n,
        cacheKey: ni(u)
      }, this.callHashCache.set(s, r);
    }
    return r.cacheKey;
  }
  /**
   * A boolean that indicates whether tone mapping should be enabled
   * or not.
   *
   * @type {Boolean}
   */
  get isToneMappingState() {
    return !this.renderer.getRenderTarget();
  }
  /**
   * If a scene background is configured, this method makes sure to
   * represent the background with a corresponding node-based implementation.
   *
   * @param {Scene} scene - The scene.
   */
  updateBackground(e) {
    const t = this.get(e), s = e.background;
    if (s) {
      const n = e.backgroundBlurriness === 0 && t.backgroundBlurriness > 0 || e.backgroundBlurriness > 0 && t.backgroundBlurriness === 0;
      if (t.background !== s || n) {
        const r = this.getCacheNode("background", s, () => {
          if (s.isCubeTexture === !0 || s.mapping === Wn || s.mapping === Hn || s.mapping === po) {
            if (e.backgroundBlurriness > 0 || s.mapping === po)
              return eu(s);
            {
              let i;
              return s.isCubeTexture === !0 ? i = Js(s) : i = X(s), Fp(i);
            }
          } else {
            if (s.isTexture === !0)
              return X(s, vt.flipY()).setUpdateMatrix(!0);
            s.isColor !== !0 && console.error("WebGPUNodes: Unsupported background configuration.", s);
          }
        }, n);
        t.backgroundNode = r, t.background = s, t.backgroundBlurriness = e.backgroundBlurriness;
      }
    } else t.backgroundNode && (delete t.backgroundNode, delete t.background);
  }
  /**
   * This method is part of the caching of nodes which are used to represents the
   * scene's background, fog or environment.
   *
   * @param {String} type - The type of object to cache.
   * @param {Object} object - The object.
   * @param {Function} callback - A callback that produces a node representation for the given object.
   * @param {Boolean} [forceUpdate=false] - Whether an update should be enforced or not.
   * @return {Node} The node representation.
   */
  getCacheNode(e, t, s, n = !1) {
    const r = this.cacheLib[e] || (this.cacheLib[e] = /* @__PURE__ */ new WeakMap());
    let i = r.get(t);
    return (i === void 0 || n) && (i = s(), r.set(t, i)), i;
  }
  /**
   * If a scene fog is configured, this method makes sure to
   * represent the fog with a corresponding node-based implementation.
   *
   * @param {Scene} scene - The scene.
   */
  updateFog(e) {
    const t = this.get(e), s = e.fog;
    if (s) {
      if (t.fog !== s) {
        const n = this.getCacheNode("fog", s, () => {
          if (s.isFogExp2) {
            const r = te("color", "color", s).setGroup(O), i = te("density", "float", s).setGroup(O);
            return zn(r, au(i));
          } else if (s.isFog) {
            const r = te("color", "color", s).setGroup(O), i = te("near", "float", s).setGroup(O), a = te("far", "float", s).setGroup(O);
            return zn(r, ou(i, a));
          } else
            console.error("THREE.Renderer: Unsupported fog configuration.", s);
        });
        t.fogNode = n, t.fog = s;
      }
    } else
      delete t.fogNode, delete t.fog;
  }
  /**
   * If a scene environment is configured, this method makes sure to
   * represent the environment with a corresponding node-based implementation.
   *
   * @param {Scene} scene - The scene.
   */
  updateEnvironment(e) {
    const t = this.get(e), s = e.environment;
    if (s) {
      if (t.environment !== s) {
        const n = this.getCacheNode("environment", s, () => {
          if (s.isCubeTexture === !0)
            return Js(s);
          if (s.isTexture === !0)
            return X(s);
          console.error("Nodes: Unsupported environment configuration.", s);
        });
        t.environmentNode = n, t.environment = s;
      }
    } else t.environmentNode && (delete t.environmentNode, delete t.environment);
  }
  getNodeFrame(e = this.renderer, t = null, s = null, n = null, r = null) {
    const i = this.nodeFrame;
    return i.renderer = e, i.scene = t, i.object = s, i.camera = n, i.material = r, i;
  }
  getNodeFrameForRender(e) {
    return this.getNodeFrame(e.renderer, e.scene, e.object, e.camera, e.material);
  }
  /**
   * Returns the current output cache key.
   *
   * @return {String} The output cache key.
   */
  getOutputCacheKey() {
    const e = this.renderer;
    return e.toneMapping + "," + e.currentColorSpace;
  }
  /**
   * Checks if the output configuration (tone mapping and color space) for
   * the given target has changed.
   *
   * @param {Texture} outputTarget - The output target.
   * @return {Boolean} Whether the output configuration has changed or not.
   */
  hasOutputChange(e) {
    return vc.get(e) !== this.getOutputCacheKey();
  }
  /**
   * Returns a node that represents the output configuration (tone mapping and
   * color space) for the current target.
   *
   * @param {Texture} outputTarget - The output target.
   * @return {Node} The output node.
   */
  getOutputNode(e) {
    const t = this.renderer, s = this.getOutputCacheKey(), n = X(e, vt).renderOutput(t.toneMapping, t.currentColorSpace);
    return vc.set(e, s), n;
  }
  /**
   * Triggers the call of `updateBefore()` methods
   * for all nodes of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateBefore(e) {
    const t = e.getNodeBuilderState();
    for (const s of t.updateBeforeNodes)
      this.getNodeFrameForRender(e).updateBeforeNode(s);
  }
  /**
   * Triggers the call of `updateAfter()` methods
   * for all nodes of the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateAfter(e) {
    const t = e.getNodeBuilderState();
    for (const s of t.updateAfterNodes)
      this.getNodeFrameForRender(e).updateAfterNode(s);
  }
  /**
   * Triggers the call of `update()` methods
   * for all nodes of the given compute node.
   *
   * @param {Node} computeNode - The compute node.
   */
  updateForCompute(e) {
    const t = this.getNodeFrame(), s = this.getForCompute(e);
    for (const n of s.updateNodes)
      t.updateNode(n);
  }
  /**
   * Triggers the call of `update()` methods
   * for all nodes of the given compute node.
   *
   * @param {RenderObject} renderObject - The render object.
   */
  updateForRender(e) {
    const t = this.getNodeFrameForRender(e), s = e.getNodeBuilderState();
    for (const n of s.updateNodes)
      t.updateNode(n);
  }
  /**
   * Returns `true` if the given render object requires a refresh.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the given render object requires a refresh or not.
   */
  needsRefresh(e) {
    const t = this.getNodeFrameForRender(e);
    return e.getMonitor().needsRefresh(e, t);
  }
  /**
   * Frees the intenral resources.
   */
  dispose() {
    super.dispose(), this.nodeFrame = new bc(), this.nodeBuilderCache = /* @__PURE__ */ new Map(), this.cacheLib = {};
  }
}
const eo = /* @__PURE__ */ new Oc();
class Qr {
  /**
   * Constructs a new clipping context.
   *
   * @param {ClippingContext?} [parentContext=null] - A reference to the parent clipping context.
   */
  constructor(e = null) {
    this.version = 0, this.clipIntersection = null, this.cacheKey = "", this.shadowPass = !1, this.viewNormalMatrix = new $n(), this.clippingGroupContexts = /* @__PURE__ */ new WeakMap(), this.intersectionPlanes = [], this.unionPlanes = [], this.parentVersion = null, e !== null && (this.viewNormalMatrix = e.viewNormalMatrix, this.clippingGroupContexts = e.clippingGroupContexts, this.shadowPass = e.shadowPass, this.viewMatrix = e.viewMatrix);
  }
  /**
   * Projects the given source clipping planes and writes the result into the
   * destination array.
   *
   * @param {Array<Plane>} source - The source clipping planes.
   * @param {Array<Vector4>} destination - The destination.
   * @param {Number} offset - The offset.
   */
  projectPlanes(e, t, s) {
    const n = e.length;
    for (let r = 0; r < n; r++) {
      eo.copy(e[r]).applyMatrix4(this.viewMatrix, this.viewNormalMatrix);
      const i = t[s + r], a = eo.normal;
      i.x = -a.x, i.y = -a.y, i.z = -a.z, i.w = eo.constant;
    }
  }
  /**
   * Updates the root clipping context of a scene.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   */
  updateGlobal(e, t) {
    this.shadowPass = e.overrideMaterial !== null && e.overrideMaterial.isShadowNodeMaterial, this.viewMatrix = t.matrixWorldInverse, this.viewNormalMatrix.getNormalMatrix(this.viewMatrix);
  }
  /**
   * Updates the clipping context.
   *
   * @param {ClippingContext} parentContext - The parent context.
   * @param {ClippingGroup} clippingGroup - The clipping group this context belongs to.
   */
  update(e, t) {
    let s = !1;
    e.version !== this.parentVersion && (this.intersectionPlanes = Array.from(e.intersectionPlanes), this.unionPlanes = Array.from(e.unionPlanes), this.parentVersion = e.version), this.clipIntersection !== t.clipIntersection && (this.clipIntersection = t.clipIntersection, this.clipIntersection ? this.unionPlanes.length = e.unionPlanes.length : this.intersectionPlanes.length = e.intersectionPlanes.length);
    const n = t.clippingPlanes, r = n.length;
    let i, a;
    if (this.clipIntersection ? (i = this.intersectionPlanes, a = e.intersectionPlanes.length) : (i = this.unionPlanes, a = e.unionPlanes.length), i.length !== a + r) {
      i.length = a + r;
      for (let u = 0; u < r; u++)
        i[a + u] = new Ce();
      s = !0;
    }
    this.projectPlanes(n, i, a), s && (this.version++, this.cacheKey = `${this.intersectionPlanes.length}:${this.unionPlanes.length}`);
  }
  /**
   * Returns a clipping context for the given clipping group.
   *
   * @param {ClippingGroup} clippingGroup - The clipping group.
   * @return {ClippingContext} The clipping context.
   */
  getGroupContext(e) {
    if (this.shadowPass && !e.clipShadows) return this;
    let t = this.clippingGroupContexts.get(e);
    return t === void 0 && (t = new Qr(this), this.clippingGroupContexts.set(e, t)), t.update(this, e), t;
  }
  /**
   * The count of union clipping planes.
   *
   * @type {Number}
   * @readonly
   */
  get unionClippingCount() {
    return this.unionPlanes.length;
  }
}
class Yv {
  /**
   * Constructs a new bundle group.
   *
   * @param {BundleGroup} bundleGroup - The bundle group.
   * @param {Camera} camera - The camera the bundle group is rendered with.
   */
  constructor(e, t) {
    this.bundleGroup = e, this.camera = t;
  }
}
class jv {
  /**
   * Constructs a new render bundle management component.
   */
  constructor() {
    this.bundles = new At();
  }
  /**
   * Returns a render bundle for the given bundle group and camera.
   *
   * @param {BundleGroup} bundleGroup - The bundle group.
   * @param {Camera} camera - The camera the bundle group is rendered with.
   * @return {RenderBundle} The render bundle.
   */
  get(e, t) {
    const s = this.bundles, n = [e, t];
    let r = s.get(n);
    return r === void 0 && (r = new Yv(e, t), s.set(n, r)), r;
  }
  /**
   * Frees all internal resources.
   */
  dispose() {
    this.bundles = new At();
  }
}
class Yf {
  /**
   * Constructs a new node library.
   */
  constructor() {
    this.lightNodes = /* @__PURE__ */ new WeakMap(), this.materialNodes = /* @__PURE__ */ new Map(), this.toneMappingNodes = /* @__PURE__ */ new Map();
  }
  /**
   * Returns a matching node material instance for the given material object.
   *
   * This method also assigns/copies the properties of the given material object
   * to the node material. This is done to make sure the current material
   * configuration carries over to the node version.
   *
   * @param {Material} material - A material.
   * @return {NodeMaterial} The corresponding node material.
   */
  fromMaterial(e) {
    if (e.isNodeMaterial) return e;
    let t = null;
    const s = this.getMaterialNodeClass(e.type);
    if (s !== null) {
      t = new s();
      for (const n in e)
        t[n] = e[n];
    }
    return t;
  }
  /**
   * Adds a tone mapping node function for a tone mapping technique (constant).
   *
   * @param {Function} toneMappingNode - The tone mapping node function.
   * @param {Number} toneMapping - The tone mapping.
   */
  addToneMapping(e, t) {
    this.addType(e, t, this.toneMappingNodes);
  }
  /**
   * Returns a tone mapping node function for a tone mapping technique (constant).
   *
   * @param {Number} toneMapping - The tone mapping.
   * @return {Function?} The tone mapping node function. Returns `null` if no node function is found.
   */
  getToneMappingFunction(e) {
    return this.toneMappingNodes.get(e) || null;
  }
  /**
   * Returns a node material class definition for a material type.
   *
   * @param {Sring} materialType - The material type.
   * @return {NodeMaterial.constructor?} The node material class definition. Returns `null` if no node material is found.
   */
  getMaterialNodeClass(e) {
    return this.materialNodes.get(e) || null;
  }
  /**
   * Adds a node material class definition for a given material type.
   *
   * @param {NodeMaterial.constructor} materialNodeClass - The node material class definition.
   * @param {Sring} materialClassType - The material type.
   */
  addMaterial(e, t) {
    this.addType(e, t, this.materialNodes);
  }
  /**
   * Returns a light node class definition for a light class definition.
   *
   * @param {Light.constructor} light - The light class definition.
   * @return {AnalyticLightNode.constructor?} The light node class definition. Returns `null` if no light node is found.
   */
  getLightNodeClass(e) {
    return this.lightNodes.get(e) || null;
  }
  /**
   * Adds a light node class definition for a given light class definition.
   *
   * @param {AnalyticLightNode.constructor} lightNodeClass - The light node class definition.
   * @param {Light.constructor} lightClass - The light class definition.
   */
  addLight(e, t) {
    this.addClass(e, t, this.lightNodes);
  }
  /**
   * Adds a node class definition for the given type to the provided type library.
   *
   * @param {Any} nodeClass - The node class definition.
   * @param {String} type - The object type.
   * @param {Map} library - The type library.
   */
  addType(e, t, s) {
    if (s.has(t)) {
      console.warn(`Redefinition of node ${t}`);
      return;
    }
    if (typeof e != "function") throw new Error(`Node class ${e.name} is not a class.`);
    if (typeof t == "function" || typeof t == "object") throw new Error(`Base class ${t} is not a class.`);
    s.set(t, e);
  }
  /**
   * Adds a node class definition for the given class definition to the provided type library.
   *
   * @param {Any} nodeClass - The node class definition.
   * @param {Any} baseClass - The class definition.
   * @param {WeakMap} library - The type library.
   */
  addClass(e, t, s) {
    if (s.has(t)) {
      console.warn(`Redefinition of node ${t.name}`);
      return;
    }
    if (typeof e != "function") throw new Error(`Node class ${e.name} is not a class.`);
    if (typeof t != "function") throw new Error(`Base class ${t.name} is not a class.`);
    s.set(t, e);
  }
}
const Qv = /* @__PURE__ */ new hu();
class Zv extends At {
  /**
   * Constructs a lighting management component.
   */
  constructor() {
    super();
  }
  /**
   * Creates a new lights node for the given array of lights.
   *
   * @param {Array<Light>} lights - The render object.
   * @return {Boolean} Whether if the given render object has an initialized geometry or not.
   */
  createNode(e = []) {
    return new hu().setLights(e);
  }
  /**
   * Returns a lights node for the given scene and camera.
   *
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera.
   * @return {LightsNode} The lights node.
   */
  getNode(e, t) {
    if (e.isQuadMesh) return Qv;
    const s = [e, t];
    let n = this.get(s);
    return n === void 0 && (n = this.createNode(), this.set(s, n)), n;
  }
}
const Ac = /* @__PURE__ */ new Wc(), Tr = /* @__PURE__ */ new He(), to = /* @__PURE__ */ new Ce(), so = /* @__PURE__ */ new vg(), _r = /* @__PURE__ */ new Ue(), $t = /* @__PURE__ */ new Ce();
class Jv {
  /**
   * Constructs a new renderer.
   *
   * @param {Backend} backend - The backend the renderer is targeting (e.g. WebGPU or WebGL 2).
   * @param {Object} parameters - The configuration parameter.
   * @param {Boolean} [parameters.logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @param {Boolean} [parameters.alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @param {Boolean} [parameters.depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @param {Boolean} [parameters.stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @param {Boolean} [parameters.antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @param {Number} [parameters.samples=0] - When `antialias` is `true`, `4` samples are used by default. This parameter can set to any other integer value than 0
   * to overwrite the default.
   * @param {Function?} [parameters.getFallback=null] - This callback function can be used to provide a fallback backend, if the primary backend can't be targeted.
   */
  constructor(e, t = {}) {
    this.isRenderer = !0;
    const {
      logarithmicDepthBuffer: s = !1,
      alpha: n = !0,
      depth: r = !0,
      stencil: i = !1,
      antialias: a = !1,
      samples: u = 0,
      getFallback: c = null
    } = t;
    this.domElement = e.getDomElement(), this.backend = e, this.samples = u || a === !0 ? 4 : 0, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.alpha = n, this.logarithmicDepthBuffer = s, this.outputColorSpace = q, this.toneMapping = $s, this.toneMappingExposure = 1, this.sortObjects = !0, this.depth = r, this.stencil = i, this.info = new o_(), this.nodes = {
      modelViewMatrix: null,
      modelNormalViewMatrix: null
    }, this.library = new Yf(), this.lighting = new Zv(), this._getFallback = c, this._pixelRatio = 1, this._width = this.domElement.width, this._height = this.domElement.height, this._viewport = new Ce(0, 0, this._width, this._height), this._scissor = new Ce(0, 0, this._width, this._height), this._scissorTest = !1, this._attributes = null, this._geometries = null, this._nodes = null, this._animation = null, this._bindings = null, this._objects = null, this._pipelines = null, this._bundles = null, this._renderLists = null, this._renderContexts = null, this._textures = null, this._background = null, this._quad = new ru(new ge()), this._quad.material.name = "Renderer_output", this._currentRenderContext = null, this._opaqueSort = null, this._transparentSort = null, this._frameBufferTarget = null;
    const l = this.alpha === !0 ? 0 : 1;
    this._clearColor = new su(0, 0, 0, l), this._clearDepth = 1, this._clearStencil = 0, this._renderTarget = null, this._activeCubeFace = 0, this._activeMipmapLevel = 0, this._mrt = null, this._renderObjectFunction = null, this._currentRenderObjectFunction = null, this._currentRenderBundle = null, this._handleObjectFunction = this._renderObjectDirect, this._isDeviceLost = !1, this.onDeviceLost = this._onDeviceLost, this._initialized = !1, this._initPromise = null, this._compilationPromises = null, this.transparent = !0, this.opaque = !0, this.shadowMap = {
      enabled: !1,
      type: ug
    }, this.xr = {
      enabled: !1
    }, this.debug = {
      checkShaderErrors: !0,
      onShaderError: null,
      getShaderAsync: async (d, h, p) => {
        await this.compileAsync(d, h);
        const f = this._renderLists.get(d, h), m = this._renderContexts.get(d, h, this._renderTarget), _ = d.overrideMaterial || p.material, S = this._objects.get(p, _, d, h, f.lightsNode, m, m.clippingContext), { fragmentShader: A, vertexShader: M } = S.getNodeBuilderState();
        return { fragmentShader: A, vertexShader: M };
      }
    };
  }
  /**
   * Initializes the renderer so it is ready for usage.
   *
   * @async
   * @return {Promise} A Promise that resolves when the renderer has been initialized.
   */
  async init() {
    if (this._initialized)
      throw new Error("Renderer: Backend has already been initialized.");
    return this._initPromise !== null ? this._initPromise : (this._initPromise = new Promise(async (e, t) => {
      let s = this.backend;
      try {
        await s.init(this);
      } catch (n) {
        if (this._getFallback !== null)
          try {
            this.backend = s = this._getFallback(n), await s.init(this);
          } catch (r) {
            t(r);
            return;
          }
        else {
          t(n);
          return;
        }
      }
      this._nodes = new Kv(this, s), this._animation = new jT(this._nodes, this.info), this._attributes = new n_(s), this._background = new cv(this, this._nodes), this._geometries = new i_(this._attributes, this.info), this._textures = new T_(this, s, this.info), this._pipelines = new l_(s, this._nodes), this._bindings = new d_(s, this._nodes, this._textures, this._attributes, this._pipelines, this.info), this._objects = new e_(this, this._nodes, this._geometries, this._pipelines, this._bindings, this.info), this._renderLists = new f_(this.lighting), this._bundles = new jv(), this._renderContexts = new y_(), this._animation.start(), this._initialized = !0, e();
    }), this._initPromise);
  }
  /**
   * The coordinate system of the renderer. The value of this property
   * depends on the selected backend. Either `THREE.WebGLCoordinateSystem` or
   * `THREE.WebGPUCoordinateSystem`.
   *
   * @readonly
   * @type {Number}
   */
  get coordinateSystem() {
    return this.backend.coordinateSystem;
  }
  /**
   * Compiles all materials in the given scene. This can be useful to avoid a
   * phenomenon which is called "shader compilation stutter", which occurs when
   * rendering an object with a new shader for the first time.
   *
   * If you want to add a 3D object to an existing scene, use the third optional
   * parameter for applying the target scene. Note that the (target) scene's lighting
   * and environment must be configured before calling this method.
   *
   * @async
   * @param {Object3D} scene - The scene or 3D object to precompile.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
   * @return {Promise} A Promise that resolves when the compile has been finished.
   */
  async compileAsync(e, t, s = null) {
    if (this._isDeviceLost === !0) return;
    this._initialized === !1 && await this.init();
    const n = this._nodes.nodeFrame, r = n.renderId, i = this._currentRenderContext, a = this._currentRenderObjectFunction, u = this._compilationPromises, c = e.isScene === !0 ? e : Ac;
    s === null && (s = e);
    const l = this._renderTarget, d = this._renderContexts.get(s, t, l), h = this._activeMipmapLevel, p = [];
    this._currentRenderContext = d, this._currentRenderObjectFunction = this.renderObject, this._handleObjectFunction = this._createObjectPipeline, this._compilationPromises = p, n.renderId++, n.update(), d.depth = this.depth, d.stencil = this.stencil, d.clippingContext || (d.clippingContext = new Qr()), d.clippingContext.updateGlobal(c, t), c.onBeforeRender(this, e, t, l);
    const f = this._renderLists.get(e, t);
    if (f.begin(), this._projectObject(e, t, 0, f, d.clippingContext), s !== e && s.traverseVisible(function(M) {
      M.isLight && M.layers.test(t.layers) && f.pushLight(M);
    }), f.finish(), l !== null) {
      this._textures.updateRenderTarget(l, h);
      const M = this._textures.get(l);
      d.textures = M.textures, d.depthTexture = M.depthTexture;
    } else
      d.textures = null, d.depthTexture = null;
    this._background.update(c, f, d);
    const m = f.opaque, _ = f.transparent, S = f.transparentDoublePass, A = f.lightsNode;
    this.opaque === !0 && m.length > 0 && this._renderObjects(m, t, c, A), this.transparent === !0 && _.length > 0 && this._renderTransparents(_, S, t, c, A), n.renderId = r, this._currentRenderContext = i, this._currentRenderObjectFunction = a, this._compilationPromises = u, this._handleObjectFunction = this._renderObjectDirect, await Promise.all(p);
  }
  /**
   * Renders the scene in an async fashion.
   *
   * @async
   * @param {Object3D} scene - The scene or 3D object to render.
   * @param {Camera} camera - The camera.
   * @return {Promise} A Promise that resolves when the render has been finished.
   */
  async renderAsync(e, t) {
    this._initialized === !1 && await this.init();
    const s = this._renderScene(e, t);
    await this.backend.resolveTimestampAsync(s, "render");
  }
  /**
   * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
   * the CPU waits for the GPU to complete its operation (e.g. a compute task).
   *
   * @async
   * @return {Promise} A Promise that resolves when synchronization has been finished.
   */
  async waitForGPU() {
    await this.backend.waitForGPU();
  }
  /**
   * Sets the given MRT configuration.
   *
   * @param {MRTNode} mrt - The MRT node to set.
   * @return {Renderer} A reference to this renderer.
   */
  setMRT(e) {
    return this._mrt = e, this;
  }
  /**
   * Returns the MRT configuration.
   *
   * @return {MRTNode} The MRT configuration.
   */
  getMRT() {
    return this._mrt;
  }
  /**
   * Default implementation of the device lost callback.
   *
   * @private
   * @param {Object} info - Information about the context lost.
   */
  _onDeviceLost(e) {
    let t = `THREE.WebGPURenderer: ${e.api} Device Lost:

Message: ${e.message}`;
    e.reason && (t += `
Reason: ${e.reason}`), console.error(t), this._isDeviceLost = !0;
  }
  /**
   * Renders the given render bundle.
   *
   * @private
   * @param {Object} bundle - Render bundle data.
   * @param {Scene} sceneRef - The scene the render bundle belongs to.
   * @param {LightsNode} lightsNode - The current lights node.
   */
  _renderBundle(e, t, s) {
    const { bundleGroup: n, camera: r, renderList: i } = e, a = this._currentRenderContext, u = this._bundles.get(n, r), c = this.backend.get(u);
    c.renderContexts === void 0 && (c.renderContexts = /* @__PURE__ */ new Set());
    const l = n.version !== c.version, d = c.renderContexts.has(a) === !1 || l;
    if (c.renderContexts.add(a), d) {
      this.backend.beginBundle(a), (c.renderObjects === void 0 || l) && (c.renderObjects = []), this._currentRenderBundle = u;
      const h = i.opaque;
      this.opaque === !0 && h.length > 0 && this._renderObjects(h, r, t, s), this._currentRenderBundle = null, this.backend.finishBundle(a, u), c.version = n.version;
    } else {
      const { renderObjects: h } = c;
      for (let p = 0, f = h.length; p < f; p++) {
        const m = h[p];
        this._nodes.needsRefresh(m) && (this._nodes.updateBefore(m), this._nodes.updateForRender(m), this._bindings.updateForRender(m), this._nodes.updateAfter(m));
      }
    }
    this.backend.addBundle(a, u);
  }
  /**
   * Renders the scene or 3D object with the given camera. This method can only be called
   * if the renderer has been initialized.
   *
   * The target of the method is the default framebuffer (meaning the canvas)
   * or alternatively a render target when specified via `setRenderTarget()`.
   *
   * @param {Object3D} scene - The scene or 3D object to render.
   * @param {Camera} camera - The camera to render the scene with.
   * @return {Promise?} A Promise that resolve when the scene has been rendered.
   * Only returned when the renderer has not been initialized.
   */
  render(e, t) {
    if (this._initialized === !1)
      return console.warn("THREE.Renderer: .render() called before the backend is initialized. Try using .renderAsync() instead."), this.renderAsync(e, t);
    this._renderScene(e, t);
  }
  /**
   * Returns an internal render target which is used when computing the output tone mapping
   * and color space conversion. Unlike in `WebGLRenderer`, this is done in a separate render
   * pass and not inline to achieve more correct results.
   *
   * @private
   * @return {RenderTarget?} The render target. The method returns `null` if no output conversion should be applied.
   */
  _getFrameBufferTarget() {
    const { currentToneMapping: e, currentColorSpace: t } = this;
    if (e !== $s === !1 && t !== cs === !1) return null;
    const { width: r, height: i } = this.getDrawingBufferSize(Tr), { depth: a, stencil: u } = this;
    let c = this._frameBufferTarget;
    return c === null && (c = new ms(r, i, {
      depthBuffer: a,
      stencilBuffer: u,
      type: at,
      // FloatType
      format: Xs,
      colorSpace: cs,
      generateMipmaps: !1,
      minFilter: Lt,
      magFilter: Lt,
      samples: this.samples
    }), c.isPostProcessingRenderTarget = !0, this._frameBufferTarget = c), c.depthBuffer = a, c.stencilBuffer = u, c.setSize(r, i), c.viewport.copy(this._viewport), c.scissor.copy(this._scissor), c.viewport.multiplyScalar(this._pixelRatio), c.scissor.multiplyScalar(this._pixelRatio), c.scissorTest = this._scissorTest, c;
  }
  /**
   * Renders the scene or 3D object with the given camera.
   *
   * @private
   * @param {Object3D} scene - The scene or 3D object to render.
   * @param {Camera} camera - The camera to render the scene with.
   * @param {Boolean} [useFrameBufferTarget=true] - Whether to use a framebuffer target or not.
   * @return {RenderContext} The current render context.
   */
  _renderScene(e, t, s = !0) {
    if (this._isDeviceLost === !0) return;
    const n = s ? this._getFrameBufferTarget() : null, r = this._nodes.nodeFrame, i = r.renderId, a = this._currentRenderContext, u = this._currentRenderObjectFunction, c = e.isScene === !0 ? e : Ac, l = this._renderTarget, d = this._activeCubeFace, h = this._activeMipmapLevel;
    let p;
    n !== null ? (p = n, this.setRenderTarget(p)) : p = l;
    const f = this._renderContexts.get(e, t, p);
    this._currentRenderContext = f, this._currentRenderObjectFunction = this._renderObjectFunction || this.renderObject, this.info.calls++, this.info.render.calls++, this.info.render.frameCalls++, r.renderId = this.info.calls;
    const m = this.coordinateSystem;
    t.coordinateSystem !== m && (t.coordinateSystem = m, t.updateProjectionMatrix()), e.matrixWorldAutoUpdate === !0 && e.updateMatrixWorld(), t.parent === null && t.matrixWorldAutoUpdate === !0 && t.updateMatrixWorld();
    let _ = this._viewport, S = this._scissor, A = this._pixelRatio;
    p !== null && (_ = p.viewport, S = p.scissor, A = 1), this.getDrawingBufferSize(Tr), to.set(0, 0, Tr.width, Tr.height);
    const M = _.minDepth === void 0 ? 0 : _.minDepth, F = _.maxDepth === void 0 ? 1 : _.maxDepth;
    f.viewportValue.copy(_).multiplyScalar(A).floor(), f.viewportValue.width >>= h, f.viewportValue.height >>= h, f.viewportValue.minDepth = M, f.viewportValue.maxDepth = F, f.viewport = f.viewportValue.equals(to) === !1, f.scissorValue.copy(S).multiplyScalar(A).floor(), f.scissor = this._scissorTest && f.scissorValue.equals(to) === !1, f.scissorValue.width >>= h, f.scissorValue.height >>= h, f.clippingContext || (f.clippingContext = new Qr()), f.clippingContext.updateGlobal(c, t), c.onBeforeRender(this, e, t, p), _r.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), so.setFromProjectionMatrix(_r, m);
    const D = this._renderLists.get(e, t);
    if (D.begin(), this._projectObject(e, t, 0, D, f.clippingContext), D.finish(), this.sortObjects === !0 && D.sort(this._opaqueSort, this._transparentSort), p !== null) {
      this._textures.updateRenderTarget(p, h);
      const ne = this._textures.get(p);
      f.textures = ne.textures, f.depthTexture = ne.depthTexture, f.width = ne.width, f.height = ne.height, f.renderTarget = p, f.depth = p.depthBuffer, f.stencil = p.stencilBuffer;
    } else
      f.textures = null, f.depthTexture = null, f.width = this.domElement.width, f.height = this.domElement.height, f.depth = this.depth, f.stencil = this.stencil;
    f.width >>= h, f.height >>= h, f.activeCubeFace = d, f.activeMipmapLevel = h, f.occlusionQueryCount = D.occlusionQueryCount, this._background.update(c, D, f), this.backend.beginRender(f);
    const {
      bundles: P,
      lightsNode: V,
      transparentDoublePass: k,
      transparent: ie,
      opaque: me
    } = D;
    if (P.length > 0 && this._renderBundles(P, c, V), this.opaque === !0 && me.length > 0 && this._renderObjects(me, t, c, V), this.transparent === !0 && ie.length > 0 && this._renderTransparents(ie, k, t, c, V), this.backend.finishRender(f), r.renderId = i, this._currentRenderContext = a, this._currentRenderObjectFunction = u, n !== null) {
      this.setRenderTarget(l, d, h);
      const ne = this._quad;
      this._nodes.hasOutputChange(p.texture) && (ne.material.fragmentNode = this._nodes.getOutputNode(p.texture), ne.material.needsUpdate = !0), this._renderScene(ne, ne.camera, !1);
    }
    return c.onAfterRender(this, e, t, p), f;
  }
  /**
   * Returns the maximum available anisotropy for texture filtering.
   *
   * @return {Number} The maximum available anisotropy.
   */
  getMaxAnisotropy() {
    return this.backend.getMaxAnisotropy();
  }
  /**
   * Returns the active cube face.
   *
   * @return {Number} The active cube face.
   */
  getActiveCubeFace() {
    return this._activeCubeFace;
  }
  /**
   * Returns the active mipmap level.
   *
   * @return {Number} The active mipmap level.
   */
  getActiveMipmapLevel() {
    return this._activeMipmapLevel;
  }
  /**
   * Applications are advised to always define the animation loop
   * with this method and not manually with `requestAnimationFrame()`
   * for best compatibility.
   *
   * @async
   * @param {Function} callback - The application's animation loop.
   * @return {Promise} A Promise that resolves when the set has been exeucted.
   */
  async setAnimationLoop(e) {
    this._initialized === !1 && await this.init(), this._animation.setAnimationLoop(e);
  }
  /**
   * Can be used to transfer buffer data from a storage buffer attribute
   * from the GPU to the CPU in context of compute shaders.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */
  async getArrayBufferAsync(e) {
    return await this.backend.getArrayBufferAsync(e);
  }
  /**
   * Returns the rendering context.
   *
   * @return {GPUCanvasContext|WebGL2RenderingContext} The rendering context.
   */
  getContext() {
    return this.backend.getContext();
  }
  /**
   * Returns the pixel ratio.
   *
   * @return {Number} The pixel ratio.
   */
  getPixelRatio() {
    return this._pixelRatio;
  }
  /**
   * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
   *
   * @param {Vector2} target - The method writes the result in this target object.
   * @return {Vector2} The drawing buffer size.
   */
  getDrawingBufferSize(e) {
    return e.set(this._width * this._pixelRatio, this._height * this._pixelRatio).floor();
  }
  /**
   * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
   *
   * @param {Vector2} target - The method writes the result in this target object.
   * @return {Vector2} The drawing buffer size.
   */
  getSize(e) {
    return e.set(this._width, this._height);
  }
  /**
   * Sets the given pixel ration and resizes the canvas if necessary.
   *
   * @param {Number} [value=1] - The pixel ratio.
   */
  setPixelRatio(e = 1) {
    this._pixelRatio !== e && (this._pixelRatio = e, this.setSize(this._width, this._height, !1));
  }
  /**
   * This method allows to define the drawing buffer size by specifying
   * width, height and pixel ratio all at once. The size of the drawing
   * buffer is computed with this formula:
   * ````
   * size.x = width * pixelRatio;
   * size.y = height * pixelRatio;
   *```
   *
   * @param {Number} width - The width in logical pixels.
   * @param {Number} height - The height in logical pixels.
   * @param {Number} pixelRatio - The pixel ratio.
   */
  setDrawingBufferSize(e, t, s) {
    this._width = e, this._height = t, this._pixelRatio = s, this.domElement.width = Math.floor(e * s), this.domElement.height = Math.floor(t * s), this.setViewport(0, 0, e, t), this._initialized && this.backend.updateSize();
  }
  /**
   * Sets the size of the renderer.
   *
   * @param {Number} width - The width in logical pixels.
   * @param {Number} height - The height in logical pixels.
   * @param {Boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
   */
  setSize(e, t, s = !0) {
    this._width = e, this._height = t, this.domElement.width = Math.floor(e * this._pixelRatio), this.domElement.height = Math.floor(t * this._pixelRatio), s === !0 && (this.domElement.style.width = e + "px", this.domElement.style.height = t + "px"), this.setViewport(0, 0, e, t), this._initialized && this.backend.updateSize();
  }
  /**
   * Defines a manual sort function for the opaque render list.
   * Pass `null` to use the default sort.
   *
   * @param {Function} method - The sort function.
   */
  setOpaqueSort(e) {
    this._opaqueSort = e;
  }
  /**
   * Defines a manual sort function for the transparent render list.
   * Pass `null` to use the default sort.
   *
   * @param {Function} method - The sort function.
   */
  setTransparentSort(e) {
    this._transparentSort = e;
  }
  /**
   * Returns the scissor rectangle.
   *
   * @param {Vector4} target - The method writes the result in this target object.
   * @return {Vector4} The scissor rectangle.
   */
  getScissor(e) {
    const t = this._scissor;
    return e.x = t.x, e.y = t.y, e.width = t.width, e.height = t.height, e;
  }
  /**
   * Defines the scissor rectangle.
   *
   * @param {Number | Vector4} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
   * Instead of passing four arguments, the method also works with a single four-dimensional vector.
   * @param {Number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
   * @param {Number} width - The width of the scissor box in logical pixel unit.
   * @param {Number} height - The height of the scissor box in logical pixel unit.
   */
  setScissor(e, t, s, n) {
    const r = this._scissor;
    e.isVector4 ? r.copy(e) : r.set(e, t, s, n);
  }
  /**
   * Returns the scissor test value.
   *
   * @return {Boolean} Whether the scissor test should be enabled or not.
   */
  getScissorTest() {
    return this._scissorTest;
  }
  /**
   * Defines the scissor test.
   *
   * @param {Boolean} boolean - Whether the scissor test should be enabled or not.
   */
  setScissorTest(e) {
    this._scissorTest = e, this.backend.setScissorTest(e);
  }
  /**
   * Returns the viewport definition.
   *
   * @param {Vector4} target - The method writes the result in this target object.
   * @return {Vector4} The viewport definition.
   */
  getViewport(e) {
    return e.copy(this._viewport);
  }
  /**
   * Defines the viewport.
   *
   * @param {Number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
   * @param {Number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
   * @param {Number} width - The width of the viewport in logical pixel unit.
   * @param {Number} height - The height of the viewport in logical pixel unit.
   * @param {Number} minDepth - The minimum depth value of the viewport. WebGPU only.
   * @param {Number} maxDepth - The maximum depth value of the viewport. WebGPU only.
   */
  setViewport(e, t, s, n, r = 0, i = 1) {
    const a = this._viewport;
    e.isVector4 ? a.copy(e) : a.set(e, t, s, n), a.minDepth = r, a.maxDepth = i;
  }
  /**
   * Returns the clear color.
   *
   * @param {Color} target - The method writes the result in this target object.
   * @return {Color} The clear color.
   */
  getClearColor(e) {
    return e.copy(this._clearColor);
  }
  /**
   * Defines the clear color and optionally the clear alpha.
   *
   * @param {Color} color - The clear color.
   * @param {Number} [alpha=1] - The clear alpha.
   */
  setClearColor(e, t = 1) {
    this._clearColor.set(e), this._clearColor.a = t;
  }
  /**
   * Returns the clear alpha.
   *
   * @return {Number} The clear alpha.
   */
  getClearAlpha() {
    return this._clearColor.a;
  }
  /**
   * Defines the clear alpha.
   *
   * @param {Number} alpha - The clear alpha.
   */
  setClearAlpha(e) {
    this._clearColor.a = e;
  }
  /**
   * Returns the clear depth.
   *
   * @return {Number} The clear depth.
   */
  getClearDepth() {
    return this._clearDepth;
  }
  /**
   * Defines the clear depth.
   *
   * @param {Number} depth - The clear depth.
   */
  setClearDepth(e) {
    this._clearDepth = e;
  }
  /**
   * Returns the clear stencil.
   *
   * @return {Number} The clear stencil.
   */
  getClearStencil() {
    return this._clearStencil;
  }
  /**
   * Defines the clear stencil.
   *
   * @param {Number} stencil - The clear stencil.
   */
  setClearStencil(e) {
    this._clearStencil = e;
  }
  /**
   * This method performs an occlusion query for the given 3D object.
   * It returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {Boolean} Whether the 3D object is fully occluded or not.
   */
  isOccluded(e) {
    const t = this._currentRenderContext;
    return t && this.backend.isOccluded(t, e);
  }
  /**
   * Performs a manual clear operation. This method ignores `autoClear` properties.
   *
   * @param {Boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {Boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {Boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   * Only returned when the renderer has not been initialized.
   */
  clear(e = !0, t = !0, s = !0) {
    if (this._initialized === !1)
      return console.warn("THREE.Renderer: .clear() called before the backend is initialized. Try using .clearAsync() instead."), this.clearAsync(e, t, s);
    const n = this._renderTarget || this._getFrameBufferTarget();
    let r = null;
    if (n !== null) {
      this._textures.updateRenderTarget(n);
      const i = this._textures.get(n);
      r = this._renderContexts.get(null, null, n), r.textures = i.textures, r.depthTexture = i.depthTexture, r.width = i.width, r.height = i.height, r.renderTarget = n, r.depth = n.depthBuffer, r.stencil = n.stencilBuffer;
    }
    if (this.backend.clear(e, t, s, r), n !== null && this._renderTarget === null) {
      const i = this._quad;
      this._nodes.hasOutputChange(n.texture) && (i.material.fragmentNode = this._nodes.getOutputNode(n.texture), i.material.needsUpdate = !0), this._renderScene(i, i.camera, !1);
    }
  }
  /**
   * Performs a manual clear operation of the color buffer. This method ignores `autoClear` properties.
   *
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   * Only returned when the renderer has not been initialized.
   */
  clearColor() {
    return this.clear(!0, !1, !1);
  }
  /**
   * Performs a manual clear operation of the depth buffer. This method ignores `autoClear` properties.
   *
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   * Only returned when the renderer has not been initialized.
   */
  clearDepth() {
    return this.clear(!1, !0, !1);
  }
  /**
   * Performs a manual clear operation of the stencil buffer. This method ignores `autoClear` properties.
   *
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   * Only returned when the renderer has not been initialized.
   */
  clearStencil() {
    return this.clear(!1, !1, !0);
  }
  /**
   * Async version of {@link module:Renderer~Renderer#clear}.
   *
   * @async
   * @param {Boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {Boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {Boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */
  async clearAsync(e = !0, t = !0, s = !0) {
    this._initialized === !1 && await this.init(), this.clear(e, t, s);
  }
  /**
   * Async version of {@link module:Renderer~Renderer#clearColor}.
   *
   * @async
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */
  async clearColorAsync() {
    this.clearAsync(!0, !1, !1);
  }
  /**
   * Async version of {@link module:Renderer~Renderer#clearDepth}.
   *
   * @async
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */
  async clearDepthAsync() {
    this.clearAsync(!1, !0, !1);
  }
  /**
   * Async version of {@link module:Renderer~Renderer#clearStencil}.
   *
   * @async
   * @return {Promise} A Promise that resolves when the clear operation has been executed.
   */
  async clearStencilAsync() {
    this.clearAsync(!1, !1, !0);
  }
  /**
   * The current output tone mapping of the renderer. When a render target is set,
   * the output tone mapping is always `NoToneMapping`.
   *
   * @type {Number}
   */
  get currentToneMapping() {
    return this._renderTarget !== null ? $s : this.toneMapping;
  }
  /**
   * The current output color space of the renderer. When a render target is set,
   * the output color space is always `LinearSRGBColorSpace`.
   *
   * @type {String}
   */
  get currentColorSpace() {
    return this._renderTarget !== null ? cs : this.outputColorSpace;
  }
  /**
   * Frees all internal resources of the renderer. Call this method if the renderer
   * is no longer in use by your app.
   */
  dispose() {
    this.info.dispose(), this.backend.dispose(), this._animation.dispose(), this._objects.dispose(), this._pipelines.dispose(), this._nodes.dispose(), this._bindings.dispose(), this._renderLists.dispose(), this._renderContexts.dispose(), this._textures.dispose(), this.setRenderTarget(null), this.setAnimationLoop(null);
  }
  /**
   * Sets the given render target. Calling this method means the renderer does not
   * target the default framebuffer (meaning the canvas) anymore but a custom framebuffer.
   * Use `null` as the first argument to reset the state.
   *
   * @param {RenderTarget?} renderTarget - The render target to set.
   * @param {Number} [activeCubeFace=0] - The active cube face.
   * @param {Number} [activeMipmapLevel=0] - The active mipmap level.
   */
  setRenderTarget(e, t = 0, s = 0) {
    this._renderTarget = e, this._activeCubeFace = t, this._activeMipmapLevel = s;
  }
  /**
   * Returns the current render target.
   *
   * @return {RenderTarget?} The render target. Returns `null` if no render target is set.
   */
  getRenderTarget() {
    return this._renderTarget;
  }
  /**
   * Callback for {@link module:Renderer~Renderer#setRenderObjectFunction}.
   *
   * @callback renderObjectFunction
   * @param {Object3D} object - The 3D object.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {BufferGeometry} geometry - The object's geometry.
   * @param {Material} material - The object's material.
   * @param {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {String?} [passId=null] - An optional ID for identifying the pass.
   */
  /**
   * Sets the given render object function. Calling this method overwrites the default implementation
   * which is {@link module:Renderer~Renderer#renderObject}. Defining a custom function can be useful
   * if you want to modify the way objects are rendered. For example you can define things like "every
   * object that has material of a certain type should perform a pre-pass with a special overwrite material".
   * The custom function must always call `renderObject()` in its implementation.
   *
   * Use `null` as the first argument to reset the state.
   *
   * @param {module:Renderer~renderObjectFunction?} renderObjectFunction - The render object function.
   */
  setRenderObjectFunction(e) {
    this._renderObjectFunction = e;
  }
  /**
   * Returns the current render object function.
   *
   * @return {Function?} The current render object function. Returns `null` if no function is set.
   */
  getRenderObjectFunction() {
    return this._renderObjectFunction;
  }
  /**
   * Execute a single or an array of compute nodes. This method can only be called
   * if the renderer has been initialized.
   *
   * @param {Node|Array<Node>} computeNodes - The compute node(s).
   * @return {Promise?} A Promise that resolve when the compute has finished. Only returned when the renderer has not been initialized.
   */
  compute(e) {
    if (this.isDeviceLost === !0) return;
    if (this._initialized === !1)
      return console.warn("THREE.Renderer: .compute() called before the backend is initialized. Try using .computeAsync() instead."), this.computeAsync(e);
    const t = this._nodes.nodeFrame, s = t.renderId;
    this.info.calls++, this.info.compute.calls++, this.info.compute.frameCalls++, t.renderId = this.info.calls;
    const n = this.backend, r = this._pipelines, i = this._bindings, a = this._nodes, u = Array.isArray(e) ? e : [e];
    if (u[0] === void 0 || u[0].isComputeNode !== !0)
      throw new Error("THREE.Renderer: .compute() expects a ComputeNode.");
    n.beginCompute(e);
    for (const c of u) {
      if (r.has(c) === !1) {
        const h = () => {
          c.removeEventListener("dispose", h), r.delete(c), i.delete(c), a.delete(c);
        };
        c.addEventListener("dispose", h);
        const p = c.onInitFunction;
        p !== null && p.call(c, { renderer: this });
      }
      a.updateForCompute(c), i.updateForCompute(c);
      const l = i.getForCompute(c), d = r.getForCompute(c, l);
      n.compute(e, c, l, d);
    }
    n.finishCompute(e), t.renderId = s;
  }
  /**
   * Execute a single or an array of compute nodes.
   *
   * @async
   * @param {Node|Array<Node>} computeNodes - The compute node(s).
   * @return {Promise?} A Promise that resolve when the compute has finished.
   */
  async computeAsync(e) {
    this._initialized === !1 && await this.init(), this.compute(e), await this.backend.resolveTimestampAsync(e, "compute");
  }
  /**
   * Checks if the given feature is supported by the selected backend.
   *
   * @async
   * @param {String} name - The feature's name.
   * @return {Promise<Boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
   */
  async hasFeatureAsync(e) {
    return this._initialized === !1 && await this.init(), this.backend.hasFeature(e);
  }
  /**
   * Checks if the given feature is supported by the selected backend. If the
   * renderer has not been initialized, this method always returns `false`.
   *
   * @param {String} name - The feature's name.
   * @return {Boolean} Whether the feature is supported or not.
   */
  hasFeature(e) {
    return this._initialized === !1 ? (console.warn("THREE.Renderer: .hasFeature() called before the backend is initialized. Try using .hasFeatureAsync() instead."), !1) : this.backend.hasFeature(e);
  }
  /**
   * Returns `true` when the renderer has been initialized.
   *
   * @return {Boolean} Whether the renderer has been initialized or not.
   */
  hasInitialized() {
    return this._initialized;
  }
  /**
   * Initializes the given textures. Useful for preloading a texture rather than waiting until first render
   * (which can cause noticeable lags due to decode and GPU upload overhead).
   *
   * @async
   * @param {Texture} texture - The texture.
   * @return {Promise} A Promise that resolves when the texture has been initialized.
   */
  async initTextureAsync(e) {
    this._initialized === !1 && await this.init(), this._textures.updateTexture(e);
  }
  /**
   * Initializes the given textures. Useful for preloading a texture rather than waiting until first render
   * (which can cause noticeable lags due to decode and GPU upload overhead).
   *
   * This method can only be used if the renderer has been initialized.
   *
   * @param {Texture} texture - The texture.
   */
  initTexture(e) {
    this._initialized === !1 && console.warn("THREE.Renderer: .initTexture() called before the backend is initialized. Try using .initTextureAsync() instead."), this._textures.updateTexture(e);
  }
  /**
   * Copies the current bound framebuffer into the given texture.
   *
   * @param {FramebufferTexture} framebufferTexture - The texture.
   * @param {Vector2|Vector4} rectangle - A two or four dimensional vector that defines the rectangular portion of the framebuffer that should be copied.
   */
  copyFramebufferToTexture(e, t = null) {
    if (t !== null)
      if (t.isVector2)
        t = $t.set(t.x, t.y, e.image.width, e.image.height).floor();
      else if (t.isVector4)
        t = $t.copy(t).floor();
      else {
        console.error("THREE.Renderer.copyFramebufferToTexture: Invalid rectangle.");
        return;
      }
    else
      t = $t.set(0, 0, e.image.width, e.image.height);
    let s = this._currentRenderContext, n;
    s !== null ? n = s.renderTarget : (n = this._renderTarget || this._getFrameBufferTarget(), n !== null && (this._textures.updateRenderTarget(n), s = this._textures.get(n))), this._textures.updateTexture(e, { renderTarget: n }), this.backend.copyFramebufferToTexture(e, s, t);
  }
  /**
   * Copies data of source texture into a destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {Box2|Box3} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
   * @param {Vector2|Vector3} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
   * @param {Number} level - The mipmap level to copy.
   */
  copyTextureToTexture(e, t, s = null, n = null, r = 0) {
    this._textures.updateTexture(e), this._textures.updateTexture(t), this.backend.copyTextureToTexture(e, t, s, n, r);
  }
  /**
   * Reads pixel data from the given render target.
   *
   * @async
   * @param {RenderTarget} renderTarget - The render target to read from.
   * @param {Number} x - The `x` coordinate of the copy region's origin.
   * @param {Number} y - The `y` coordinate of the copy region's origin.
   * @param {Number} width - The width of the copy region.
   * @param {Number} height - The height of the copy region.
   * @param {Number} [textureIndex=0] - The texture index of a MRT render target.
   * @param {Number} [faceIndex=0] - The active cube face index.
   * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
   */
  async readRenderTargetPixelsAsync(e, t, s, n, r, i = 0, a = 0) {
    return this.backend.copyTextureToBuffer(e.textures[i], t, s, n, r, a);
  }
  /**
   * Analyzes the given 3D object's hierarchy and builds render lists from the
   * processed hierarchy.
   *
   * @param {Object3D} object - The 3D object to process (usually a scene).
   * @param {Camera} camera - The camera the object is rendered with.
   * @param {Number} groupOrder - The group order is derived from the `renderOrder` of groups and is used to group 3D objects within groups.
   * @param {RenderList} renderList - The current render list.
   * @param {ClippingContext} clippingContext - The current clipping context.
   */
  _projectObject(e, t, s, n, r) {
    if (e.visible === !1) return;
    if (e.layers.test(t.layers)) {
      if (e.isGroup)
        s = e.renderOrder, e.isClippingGroup && e.enabled && (r = r.getGroupContext(e));
      else if (e.isLOD)
        e.autoUpdate === !0 && e.update(t);
      else if (e.isLight)
        n.pushLight(e);
      else if (e.isSprite) {
        if (!e.frustumCulled || so.intersectsSprite(e)) {
          this.sortObjects === !0 && $t.setFromMatrixPosition(e.matrixWorld).applyMatrix4(_r);
          const { geometry: u, material: c } = e;
          c.visible && n.push(e, u, c, s, $t.z, null, r);
        }
      } else if (e.isLineLoop)
        console.error("THREE.Renderer: Objects of type THREE.LineLoop are not supported. Please use THREE.Line or THREE.LineSegments.");
      else if ((e.isMesh || e.isLine || e.isPoints) && (!e.frustumCulled || so.intersectsObject(e))) {
        const { geometry: u, material: c } = e;
        if (this.sortObjects === !0 && (u.boundingSphere === null && u.computeBoundingSphere(), $t.copy(u.boundingSphere.center).applyMatrix4(e.matrixWorld).applyMatrix4(_r)), Array.isArray(c)) {
          const l = u.groups;
          for (let d = 0, h = l.length; d < h; d++) {
            const p = l[d], f = c[p.materialIndex];
            f && f.visible && n.push(e, u, f, s, $t.z, p, r);
          }
        } else c.visible && n.push(e, u, c, s, $t.z, null, r);
      }
    }
    if (e.isBundleGroup === !0 && this.backend.beginBundle !== void 0) {
      const u = n;
      n = this._renderLists.get(e, t), n.begin(), u.pushBundle({
        bundleGroup: e,
        camera: t,
        renderList: n
      }), n.finish();
    }
    const a = e.children;
    for (let u = 0, c = a.length; u < c; u++)
      this._projectObject(a[u], t, s, n, r);
  }
  /**
   * Renders the given render bundles.
   *
   * @private
   * @param {Array<Object>} bundles - Array with render bundle data.
   * @param {Scene} sceneRef - The scene the render bundles belong to.
   * @param {LightsNode} lightsNode - The current lights node.
   */
  _renderBundles(e, t, s) {
    for (const n of e)
      this._renderBundle(n, t, s);
  }
  /**
   * Renders the transparent objects from the given render lists.
   *
   * @private
   * @param {Array<Object>} renderList - The transparent render list.
   * @param {Array<Object>} doublePassList - The list of transparent objects which require a double pass (e.g. because of transmission).
   * @param {Camera} camera - The camera the render list should be rendered with.
   * @param {Scene} scene - The scene the render list belongs to.
   * @param {LightsNode} lightsNode - The current lights node.
   */
  _renderTransparents(e, t, s, n, r) {
    if (t.length > 0) {
      for (const { material: i } of t)
        i.side = Tt;
      this._renderObjects(t, s, n, r, "backSide");
      for (const { material: i } of t)
        i.side = ho;
      this._renderObjects(e, s, n, r);
      for (const { material: i } of t)
        i.side = Ws;
    } else
      this._renderObjects(e, s, n, r);
  }
  /**
   * Renders the objects from the given render list.
   *
   * @private
   * @param {Array<Object>} renderList - The render list.
   * @param {Camera} camera - The camera the render list should be rendered with.
   * @param {Scene} scene - The scene the render list belongs to.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {String?} [passId=null] - An optional ID for identifying the pass.
   */
  _renderObjects(e, t, s, n, r = null) {
    for (let i = 0, a = e.length; i < a; i++) {
      const u = e[i], { object: c, geometry: l, material: d, group: h, clippingContext: p } = u;
      if (t.isArrayCamera) {
        const f = t.cameras;
        for (let m = 0, _ = f.length; m < _; m++) {
          const S = f[m];
          if (c.layers.test(S.layers)) {
            const A = S.viewport, M = A.minDepth === void 0 ? 0 : A.minDepth, F = A.maxDepth === void 0 ? 1 : A.maxDepth, D = this._currentRenderContext.viewportValue;
            D.copy(A).multiplyScalar(this._pixelRatio).floor(), D.minDepth = M, D.maxDepth = F, this.backend.updateViewport(this._currentRenderContext), this._currentRenderObjectFunction(c, s, S, l, d, h, n, p, r);
          }
        }
      } else
        this._currentRenderObjectFunction(c, s, t, l, d, h, n, p, r);
    }
  }
  /**
   * This method represents the default render object function that manages the render lifecycle
   * of the object.
   *
   * @param {Object3D} object - The 3D object.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {BufferGeometry} geometry - The object's geometry.
   * @param {Material} material - The object's material.
   * @param {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {String?} [passId=null] - An optional ID for identifying the pass.
   */
  renderObject(e, t, s, n, r, i, a, u = null, c = null) {
    let l, d, h;
    if (e.onBeforeRender(this, t, s, n, r, i), t.overrideMaterial !== null) {
      const p = t.overrideMaterial;
      r.positionNode && r.positionNode.isNode && (l = p.positionNode, p.positionNode = r.positionNode), p.alphaTest = r.alphaTest, p.alphaMap = r.alphaMap, p.transparent = r.transparent || r.transmission > 0, p.isShadowNodeMaterial && (p.side = r.shadowSide === null ? r.side : r.shadowSide, r.depthNode && r.depthNode.isNode && (h = p.depthNode, p.depthNode = r.depthNode), r.castShadowNode && r.castShadowNode.isNode && (d = p.colorNode, p.colorNode = r.castShadowNode)), r = p;
    }
    r.transparent === !0 && r.side === Ws && r.forceSinglePass === !1 ? (r.side = Tt, this._handleObjectFunction(e, r, t, s, a, i, u, "backSide"), r.side = ho, this._handleObjectFunction(e, r, t, s, a, i, u, c), r.side = Ws) : this._handleObjectFunction(e, r, t, s, a, i, u, c), l !== void 0 && (t.overrideMaterial.positionNode = l), h !== void 0 && (t.overrideMaterial.depthNode = h), d !== void 0 && (t.overrideMaterial.colorNode = d), e.onAfterRender(this, t, s, n, r, i);
  }
  /**
   * This method represents the default `_handleObjectFunction` implementation which creates
   * a render object from the given data and performs the draw command with the selected backend.
   *
   * @private
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {String?} [passId=null] - An optional ID for identifying the pass.
   */
  _renderObjectDirect(e, t, s, n, r, i, a, u) {
    const c = this._objects.get(e, t, s, n, r, this._currentRenderContext, a, u);
    c.drawRange = e.geometry.drawRange, c.group = i;
    const l = this._nodes.needsRefresh(c);
    l && (this._nodes.updateBefore(c), this._geometries.updateForRender(c), this._nodes.updateForRender(c), this._bindings.updateForRender(c)), this._pipelines.updateForRender(c), this._currentRenderBundle !== null && (this.backend.get(this._currentRenderBundle).renderObjects.push(c), c.bundle = this._currentRenderBundle.bundleGroup), this.backend.draw(c, this.info), l && this._nodes.updateAfter(c);
  }
  /**
   * A different implementation for `_handleObjectFunction` which only makes sure the object is ready for rendering.
   * Used in `compileAsync()`.
   *
   * @private
   * @param {Object3D} object - The 3D object.
   * @param {Material} material - The object's material.
   * @param {Scene} scene - The scene the 3D object belongs to.
   * @param {Camera} camera - The camera the object should be rendered with.
   * @param {LightsNode} lightsNode - The current lights node.
   * @param {Object?} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
   * @param {ClippingContext} clippingContext - The clipping context.
   * @param {String?} [passId=null] - An optional ID for identifying the pass.
   */
  _createObjectPipeline(e, t, s, n, r, i, a, u) {
    const c = this._objects.get(e, t, s, n, r, this._currentRenderContext, a, u);
    c.drawRange = e.geometry.drawRange, c.group = i, this._nodes.updateBefore(c), this._geometries.updateForRender(c), this._nodes.updateForRender(c), this._bindings.updateForRender(c), this._pipelines.getForRender(c, this._compilationPromises), this._nodes.updateAfter(c);
  }
  /**
   * Alias for `compileAsync()`.
   *
   * @method
   * @param {Object3D} scene - The scene or 3D object to precompile.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
   * @return {Promise} A Promise that resolves when the compile has been finished.
   */
  get compile() {
    return this.compileAsync;
  }
}
class Nu {
  /**
   * Constructs a new binding.
   *
   * @param {String} [name=''] - The binding's name.
   */
  constructor(e = "") {
    this.name = e, this.visibility = 0;
  }
  /**
   * Makes sure binding's resource is visible for the given shader stage.
   *
   * @param {Number} visibility - The shader stage.
   */
  setVisibility(e) {
    this.visibility |= e;
  }
  /**
   * Clones the binding.
   *
   * @return {Binding} The cloned binding.
   */
  clone() {
    return Object.assign(new this.constructor(), this);
  }
}
function eA(o) {
  return o + (Kt - o % Kt) % Kt;
}
class jf extends Nu {
  /**
   * Constructs a new buffer.
   *
   * @param {String} name - The buffer's name.
   * @param {TypedArray} [buffer=null] - The buffer.
   */
  constructor(e, t = null) {
    super(e), this.isBuffer = !0, this.bytesPerElement = Float32Array.BYTES_PER_ELEMENT, this._buffer = t;
  }
  /**
   * The buffer's byte length.
   *
   * @type {Number}
   * @readonly
   */
  get byteLength() {
    return eA(this._buffer.byteLength);
  }
  /**
   * A reference to the internal buffer.
   *
   * @type {Float32Array}
   * @readonly
   */
  get buffer() {
    return this._buffer;
  }
  /**
   * Updates the binding.
   *
   * @return {Boolean} Whether the buffer has been updated and must be
   * uploaded to the GPU.
   */
  update() {
    return !0;
  }
}
class Qf extends jf {
  /**
   * Constructs a new uniform buffer.
   *
   * @param {String} name - The buffer's name.
   * @param {TypedArray} [buffer=null] - The buffer.
   */
  constructor(e, t = null) {
    super(e, t), this.isUniformBuffer = !0;
  }
}
let tA = 0;
class Zf extends Qf {
  /**
   * Constructs a new node-based uniform buffer.
   *
   * @param {BufferNode} nodeUniform - The uniform buffer node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */
  constructor(e, t) {
    super("UniformBuffer_" + tA++, e ? e.value : null), this.nodeUniform = e, this.groupNode = t;
  }
  /**
   * The uniform buffer.
   *
   * @type {Float32Array}
   */
  get buffer() {
    return this.nodeUniform.value;
  }
}
class sA extends Qf {
  /**
   * Constructs a new uniforms group.
   *
   * @param {String} name - The group's name.
   */
  constructor(e) {
    super(e), this.isUniformsGroup = !0, this._values = null, this.uniforms = [];
  }
  /**
   * Adds a uniform to this group.
   *
   * @param {Uniform} uniform - The uniform to add.
   * @return {UniformsGroup} A reference to this group.
   */
  addUniform(e) {
    return this.uniforms.push(e), this;
  }
  /**
   * Removes a uniform from this group.
   *
   * @param {Uniform} uniform - The uniform to remove.
   * @return {UniformsGroup} A reference to this group.
   */
  removeUniform(e) {
    const t = this.uniforms.indexOf(e);
    return t !== -1 && this.uniforms.splice(t, 1), this;
  }
  /**
   * An array with the raw uniform values.
   *
   * @type {Array<Number>}
   */
  get values() {
    return this._values === null && (this._values = Array.from(this.buffer)), this._values;
  }
  /**
   * A Float32 array buffer with the uniform values.
   *
   * @type {Float32Array}
   */
  get buffer() {
    let e = this._buffer;
    if (e === null) {
      const t = this.byteLength;
      e = new Float32Array(new ArrayBuffer(t)), this._buffer = e;
    }
    return e;
  }
  /**
   * The byte length of the buffer with correct buffer alignment.
   *
   * @type {Number}
   */
  get byteLength() {
    let e = 0;
    for (let t = 0, s = this.uniforms.length; t < s; t++) {
      const n = this.uniforms[t], { boundary: r, itemSize: i } = n, a = e % Kt, u = Kt - a;
      a !== 0 && u - r < 0 ? e += Kt - a : a % r !== 0 && (e += a % r), n.offset = e / this.bytesPerElement, e += i * this.bytesPerElement;
    }
    return Math.ceil(e / Kt) * Kt;
  }
  /**
   * Updates this group by updating each uniform object of
   * the internal uniform list. The uniform objects check if their
   * values has actually changed so this method only returns
   * `true` if there is a real value change.
   *
   * @return {Boolean} Whether the uniforms have been updated and
   * must be uploaded to the GPU.
   */
  update() {
    let e = !1;
    for (const t of this.uniforms)
      this.updateByType(t) === !0 && (e = !0);
    return e;
  }
  /**
   * Updates a given uniform by calling an update method matching
   * the uniforms type.
   *
   * @param {Uniform} uniform - The uniform to update.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateByType(e) {
    if (e.isNumberUniform) return this.updateNumber(e);
    if (e.isVector2Uniform) return this.updateVector2(e);
    if (e.isVector3Uniform) return this.updateVector3(e);
    if (e.isVector4Uniform) return this.updateVector4(e);
    if (e.isColorUniform) return this.updateColor(e);
    if (e.isMatrix3Uniform) return this.updateMatrix3(e);
    if (e.isMatrix4Uniform) return this.updateMatrix4(e);
    console.error("THREE.WebGPUUniformsGroup: Unsupported uniform type.", e);
  }
  /**
   * Updates a given Number uniform.
   *
   * @param {NumberUniform} uniform - The Number uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateNumber(e) {
    let t = !1;
    const s = this.values, n = e.getValue(), r = e.offset, i = e.getType();
    if (s[r] !== n) {
      const a = this._getBufferForType(i);
      a[r] = s[r] = n, t = !0;
    }
    return t;
  }
  /**
   * Updates a given Vector2 uniform.
   *
   * @param {Vector2Uniform} uniform - The Vector2 uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateVector2(e) {
    let t = !1;
    const s = this.values, n = e.getValue(), r = e.offset, i = e.getType();
    if (s[r + 0] !== n.x || s[r + 1] !== n.y) {
      const a = this._getBufferForType(i);
      a[r + 0] = s[r + 0] = n.x, a[r + 1] = s[r + 1] = n.y, t = !0;
    }
    return t;
  }
  /**
   * Updates a given Vector3 uniform.
   *
   * @param {Vector3Uniform} uniform - The Vector3 uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateVector3(e) {
    let t = !1;
    const s = this.values, n = e.getValue(), r = e.offset, i = e.getType();
    if (s[r + 0] !== n.x || s[r + 1] !== n.y || s[r + 2] !== n.z) {
      const a = this._getBufferForType(i);
      a[r + 0] = s[r + 0] = n.x, a[r + 1] = s[r + 1] = n.y, a[r + 2] = s[r + 2] = n.z, t = !0;
    }
    return t;
  }
  /**
   * Updates a given Vector4 uniform.
   *
   * @param {Vector4Uniform} uniform - The Vector4 uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateVector4(e) {
    let t = !1;
    const s = this.values, n = e.getValue(), r = e.offset, i = e.getType();
    if (s[r + 0] !== n.x || s[r + 1] !== n.y || s[r + 2] !== n.z || s[r + 4] !== n.w) {
      const a = this._getBufferForType(i);
      a[r + 0] = s[r + 0] = n.x, a[r + 1] = s[r + 1] = n.y, a[r + 2] = s[r + 2] = n.z, a[r + 3] = s[r + 3] = n.w, t = !0;
    }
    return t;
  }
  /**
   * Updates a given Color uniform.
   *
   * @param {ColorUniform} uniform - The Color uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateColor(e) {
    let t = !1;
    const s = this.values, n = e.getValue(), r = e.offset;
    if (s[r + 0] !== n.r || s[r + 1] !== n.g || s[r + 2] !== n.b) {
      const i = this.buffer;
      i[r + 0] = s[r + 0] = n.r, i[r + 1] = s[r + 1] = n.g, i[r + 2] = s[r + 2] = n.b, t = !0;
    }
    return t;
  }
  /**
   * Updates a given Matrix3 uniform.
   *
   * @param {Matrix3Uniform} uniform - The Matrix3 uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateMatrix3(e) {
    let t = !1;
    const s = this.values, n = e.getValue().elements, r = e.offset;
    if (s[r + 0] !== n[0] || s[r + 1] !== n[1] || s[r + 2] !== n[2] || s[r + 4] !== n[3] || s[r + 5] !== n[4] || s[r + 6] !== n[5] || s[r + 8] !== n[6] || s[r + 9] !== n[7] || s[r + 10] !== n[8]) {
      const i = this.buffer;
      i[r + 0] = s[r + 0] = n[0], i[r + 1] = s[r + 1] = n[1], i[r + 2] = s[r + 2] = n[2], i[r + 4] = s[r + 4] = n[3], i[r + 5] = s[r + 5] = n[4], i[r + 6] = s[r + 6] = n[5], i[r + 8] = s[r + 8] = n[6], i[r + 9] = s[r + 9] = n[7], i[r + 10] = s[r + 10] = n[8], t = !0;
    }
    return t;
  }
  /**
   * Updates a given Matrix4 uniform.
   *
   * @param {Matrix4Uniform} uniform - The Matrix4 uniform.
   * @return {Boolean} Whether the uniform has been updated or not.
   */
  updateMatrix4(e) {
    let t = !1;
    const s = this.values, n = e.getValue().elements, r = e.offset;
    return rA(s, n, r) === !1 && (this.buffer.set(n, r), nA(s, n, r), t = !0), t;
  }
  /**
   * Returns a typed array that matches the given data type.
   *
   * @param {String} type - The data type.
   * @return {TypedArray} The typed array.
   */
  _getBufferForType(e) {
    return e === "int" || e === "ivec2" || e === "ivec3" || e === "ivec4" ? new Int32Array(this.buffer.buffer) : e === "uint" || e === "uvec2" || e === "uvec3" || e === "uvec4" ? new Uint32Array(this.buffer.buffer) : this.buffer;
  }
}
function nA(o, e, t) {
  for (let s = 0, n = e.length; s < n; s++)
    o[t + s] = e[s];
}
function rA(o, e, t) {
  for (let s = 0, n = e.length; s < n; s++)
    if (o[t + s] !== e[s]) return !1;
  return !0;
}
let iA = 0;
class Jf extends sA {
  /**
   * Constructs a new node-based uniforms group.
   *
   * @param {String} name - The group's name.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */
  constructor(e, t) {
    super(e), this.id = iA++, this.groupNode = t, this.isNodeUniformsGroup = !0;
  }
}
let oA = 0;
class aA extends Nu {
  /**
   * Constructs a new sampled texture.
   *
   * @param {String} name - The sampled texture's name.
   * @param {Texture?} texture - The texture this binding is referring to.
   */
  constructor(e, t) {
    super(e), this.id = oA++, this.texture = t, this.version = t ? t.version : 0, this.store = !1, this.generation = null, this.isSampledTexture = !0;
  }
  /**
   * Returns `true` whether this binding requires an update for the
   * given generation.
   *
   * @param {Number} generation - The generation.
   * @return {Boolean} Whether an update is required or not.
   */
  needsBindingsUpdate(e) {
    const { texture: t } = this;
    return e !== this.generation ? (this.generation = e, !0) : t.isVideoTexture;
  }
  /**
   * Updates the binding.
   *
   * @param {Number} generation - The generation.
   * @return {Boolean} Whether the texture has been updated and must be
   * uploaded to the GPU.
   */
  update() {
    const { texture: e, version: t } = this;
    return t !== e.version ? (this.version = e.version, !0) : !1;
  }
}
class Ci extends aA {
  /**
   * Constructs a new node-based sampled texture.
   *
   * @param {String} name - The textures's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   * @param {String?} [access=null] - The access type.
   */
  constructor(e, t, s, n = null) {
    super(e, t ? t.value : null), this.textureNode = t, this.groupNode = s, this.access = n;
  }
  /**
   * Overwrites the default to additionally check if the node value has changed.
   *
   * @param {Number} generation - The generation.
   * @return {Boolean} Whether an update is required or not.
   */
  needsBindingsUpdate(e) {
    return this.textureNode.value !== this.texture || super.needsBindingsUpdate(e);
  }
  /**
   * Updates the binding.
   *
   * @param {Number} generation - The generation.
   * @return {Boolean} Whether the texture has been updated and must be
   * uploaded to the GPU.
   */
  update() {
    const { textureNode: e } = this;
    return this.texture !== e.value ? (this.texture = e.value, !0) : super.update();
  }
}
class eg extends Ci {
  /**
   * Constructs a new node-based sampled cube texture.
   *
   * @param {String} name - The textures's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   * @param {String?} [access=null] - The access type.
   */
  constructor(e, t, s, n = null) {
    super(e, t, s, n), this.isSampledCubeTexture = !0;
  }
}
class tg extends Ci {
  /**
   * Constructs a new node-based sampled 3D texture.
   *
   * @param {String} name - The textures's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   * @param {String?} [access=null] - The access type.
   */
  constructor(e, t, s, n = null) {
    super(e, t, s, n), this.isSampledTexture3D = !0;
  }
}
const uA = {
  textureDimensions: "textureSize",
  equals: "equal"
}, cA = {
  low: "lowp",
  medium: "mediump",
  high: "highp"
}, Rc = {
  swizzleAssign: !0,
  storageBuffer: !1
}, Cc = `
precision highp float;
precision highp int;
precision highp sampler2D;
precision highp sampler3D;
precision highp samplerCube;
precision highp sampler2DArray;

precision highp usampler2D;
precision highp usampler3D;
precision highp usamplerCube;
precision highp usampler2DArray;

precision highp isampler2D;
precision highp isampler3D;
precision highp isamplerCube;
precision highp isampler2DArray;

precision lowp sampler2DShadow;
`;
class lA extends qf {
  constructor(e, t) {
    super(e, t, new Xv()), this.uniformGroups = {}, this.transforms = [], this.extensions = {}, this.builtins = { vertex: [], fragment: [], compute: [] }, this.useComparisonMethod = !0;
  }
  needsToWorkingColorSpace(e) {
    return e.isVideoTexture === !0 && e.colorSpace !== wn;
  }
  getMethod(e) {
    return uA[e] || e;
  }
  getOutputStructName() {
    return "";
  }
  buildFunctionCode(e) {
    const t = e.layout, s = this.flowShaderNode(e), n = [];
    for (const i of t.inputs)
      n.push(this.getType(i.type) + " " + i.name);
    return `${this.getType(t.type)} ${t.name}( ${n.join(", ")} ) {

	${s.vars}

${s.code}
	return ${s.result};

}`;
  }
  setupPBO(e) {
    const t = e.value;
    if (t.pbo === void 0) {
      const s = t.array, n = t.count * t.itemSize, { itemSize: r } = t, i = t.array.constructor.name.toLowerCase().includes("int");
      let a = i ? ta : ea;
      r === 2 ? a = i ? sa : Bn : r === 3 ? a = i ? sm : Jo : r === 4 && (a = i ? na : Xs);
      const u = {
        Float32Array: st,
        Uint8Array: ls,
        Uint16Array: Ls,
        Uint32Array: Pe,
        Int8Array: Tn,
        Int16Array: _n,
        Int32Array: Ve,
        Uint8ClampedArray: ls
      }, c = Math.pow(2, Math.ceil(Math.log2(Math.sqrt(n / r))));
      let l = Math.ceil(n / r / c);
      c * l * r < n && l++;
      const d = c * l * r, h = new s.constructor(d);
      h.set(s, 0), t.array = h;
      const p = new Ag(t.array, c, l, a, u[t.array.constructor.name] || st);
      p.needsUpdate = !0, p.isPBOTexture = !0;
      const f = new bt(p, null, null);
      f.setPrecision("high"), t.pboNode = f, t.pbo = f.value, this.getUniformFromNode(t.pboNode, "texture", this.shaderStage, this.context.label);
    }
  }
  getPropertyName(e, t = this.shaderStage) {
    return e.isNodeUniform && e.node.isTextureNode !== !0 && e.node.isBufferNode !== !0 ? t.charAt(0) + "_" + e.name : super.getPropertyName(e, t);
  }
  generatePBO(e) {
    const { node: t, indexNode: s } = e, n = t.value;
    if (this.renderer.backend.has(n)) {
      const l = this.renderer.backend.get(n);
      l.pbo = n.pbo;
    }
    const r = this.getUniformFromNode(n.pboNode, "texture", this.shaderStage, this.context.label), i = this.getPropertyName(r);
    this.increaseUsage(s);
    const a = s.build(this, "uint"), u = this.getDataFromNode(e);
    let c = u.propertyName;
    if (c === void 0) {
      const l = this.getVarFromNode(e);
      c = this.getPropertyName(l);
      const d = this.getDataFromNode(t);
      let h = d.propertySizeName;
      h === void 0 && (h = c + "Size", this.getVarFromNode(t, h, "uint"), this.addLineFlowCode(`${h} = uint( textureSize( ${i}, 0 ).x )`, e), d.propertySizeName = h);
      const { itemSize: p } = n, f = "." + xs.join("").slice(0, p), m = `ivec2(${a} % ${h}, ${a} / ${h})`, _ = this.generateTextureLoad(null, i, m, null, "0");
      let S = "vec4";
      n.pbo.type === Pe ? S = "uvec4" : n.pbo.type === Ve && (S = "ivec4"), this.addLineFlowCode(`${c} = ${S}(${_})${f}`, e), u.propertyName = c;
    }
    return c;
  }
  generateTextureLoad(e, t, s, n, r = "0") {
    return n ? `texelFetch( ${t}, ivec3( ${s}, ${n} ), ${r} )` : `texelFetch( ${t}, ${s}, ${r} )`;
  }
  generateTexture(e, t, s, n) {
    return e.isDepthTexture ? `texture( ${t}, ${s} ).x` : (n && (s = `vec3( ${s}, ${n} )`), `texture( ${t}, ${s} )`);
  }
  generateTextureLevel(e, t, s, n) {
    return `textureLod( ${t}, ${s}, ${n} )`;
  }
  generateTextureBias(e, t, s, n) {
    return `texture( ${t}, ${s}, ${n} )`;
  }
  generateTextureGrad(e, t, s, n) {
    return `textureGrad( ${t}, ${s}, ${n[0]}, ${n[1]} )`;
  }
  generateTextureCompare(e, t, s, n, r, i = this.shaderStage) {
    if (i === "fragment")
      return `texture( ${t}, vec3( ${s}, ${n} ) )`;
    console.error(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${i} shader.`);
  }
  getVars(e) {
    const t = [], s = this.vars[e];
    if (s !== void 0)
      for (const n of s)
        t.push(`${this.getVar(n.type, n.name)};`);
    return t.join(`
	`);
  }
  getUniforms(e) {
    const t = this.uniforms[e], s = [], n = {};
    for (const i of t) {
      let a = null, u = !1;
      if (i.type === "texture") {
        const l = i.node.value;
        let d = "";
        l.isDataTexture === !0 && (l.type === Pe ? d = "u" : l.type === Ve && (d = "i")), l.compareFunction ? a = `sampler2DShadow ${i.name};` : l.isDataArrayTexture === !0 || l.isCompressedArrayTexture === !0 ? a = `${d}sampler2DArray ${i.name};` : a = `${d}sampler2D ${i.name};`;
      } else if (i.type === "cubeTexture")
        a = `samplerCube ${i.name};`;
      else if (i.type === "texture3D")
        a = `sampler3D ${i.name};`;
      else if (i.type === "buffer") {
        const l = i.node, d = this.getType(l.bufferType), h = l.bufferCount, p = h > 0 ? h : "";
        a = `${l.name} {
	${d} ${i.name}[${p}];
};
`;
      } else
        a = `${this.getVectorType(i.type)} ${this.getPropertyName(i, e)};`, u = !0;
      const c = i.node.precision;
      if (c !== null && (a = cA[c] + " " + a), u) {
        a = "	" + a;
        const l = i.groupNode.name;
        (n[l] || (n[l] = [])).push(a);
      } else
        a = "uniform " + a, s.push(a);
    }
    let r = "";
    for (const i in n) {
      const a = n[i];
      r += this._getGLSLUniformStruct(e + "_" + i, a.join(`
`)) + `
`;
    }
    return r += s.join(`
`), r;
  }
  getTypeFromAttribute(e) {
    let t = super.getTypeFromAttribute(e);
    if (/^[iu]/.test(t) && e.gpuType !== Ve) {
      let s = e;
      e.isInterleavedBufferAttribute && (s = e.data);
      const n = s.array;
      n instanceof Uint32Array || n instanceof Int32Array || (t = t.slice(1));
    }
    return t;
  }
  getAttributes(e) {
    let t = "";
    if (e === "vertex" || e === "compute") {
      const s = this.getAttributesArray();
      let n = 0;
      for (const r of s)
        t += `layout( location = ${n++} ) in ${r.type} ${r.name};
`;
    }
    return t;
  }
  getStructMembers(e) {
    const t = [], s = e.getMemberTypes();
    for (let n = 0; n < s.length; n++) {
      const r = s[n];
      t.push(`layout( location = ${n} ) out ${r} m${n};`);
    }
    return t.join(`
`);
  }
  getStructs(e) {
    const t = [], s = this.structs[e];
    if (s.length === 0)
      return `layout( location = 0 ) out vec4 fragColor;
`;
    for (let n = 0, r = s.length; n < r; n++) {
      const i = s[n];
      let a = `
`;
      a += this.getStructMembers(i), a += `
`, t.push(a);
    }
    return t.join(`

`);
  }
  getVaryings(e) {
    let t = "";
    const s = this.varyings;
    if (e === "vertex" || e === "compute")
      for (const n of s) {
        e === "compute" && (n.needsInterpolation = !0);
        const r = this.getType(n.type), i = r.includes("int") || r.includes("uv") || r.includes("iv") ? "flat " : "";
        t += `${i}${n.needsInterpolation ? "out" : "/*out*/"} ${r} ${n.name};
`;
      }
    else if (e === "fragment") {
      for (const n of s)
        if (n.needsInterpolation) {
          const r = this.getType(n.type), i = r.includes("int") || r.includes("uv") || r.includes("iv") ? "flat " : "";
          t += `${i}in ${r} ${n.name};
`;
        }
    }
    for (const n of this.builtins[e])
      t += `${n};
`;
    return t;
  }
  getVertexIndex() {
    return "uint( gl_VertexID )";
  }
  getInstanceIndex() {
    return "uint( gl_InstanceID )";
  }
  getInvocationLocalIndex() {
    return `uint( gl_InstanceID ) % ${this.object.workgroupSize.reduce((s, n) => s * n, 1)}u`;
  }
  getDrawIndex() {
    return this.renderer.backend.extensions.has("WEBGL_multi_draw") ? "uint( gl_DrawID )" : null;
  }
  getFrontFacing() {
    return "gl_FrontFacing";
  }
  getFragCoord() {
    return "gl_FragCoord.xy";
  }
  getFragDepth() {
    return "gl_FragDepth";
  }
  enableExtension(e, t, s = this.shaderStage) {
    const n = this.extensions[s] || (this.extensions[s] = /* @__PURE__ */ new Map());
    n.has(e) === !1 && n.set(e, {
      name: e,
      behavior: t
    });
  }
  getExtensions(e) {
    const t = [];
    if (e === "vertex") {
      const n = this.renderer.backend.extensions;
      this.object.isBatchedMesh && n.has("WEBGL_multi_draw") && this.enableExtension("GL_ANGLE_multi_draw", "require", e);
    }
    const s = this.extensions[e];
    if (s !== void 0)
      for (const { name: n, behavior: r } of s.values())
        t.push(`#extension ${n} : ${r}`);
    return t.join(`
`);
  }
  getClipDistance() {
    return "gl_ClipDistance";
  }
  isAvailable(e) {
    let t = Rc[e];
    if (t === void 0) {
      let s;
      switch (t = !1, e) {
        case "float32Filterable":
          s = "OES_texture_float_linear";
          break;
        case "clipDistance":
          s = "WEBGL_clip_cull_distance";
          break;
      }
      if (s !== void 0) {
        const n = this.renderer.backend.extensions;
        n.has(s) && (n.get(s), t = !0);
      }
      Rc[e] = t;
    }
    return t;
  }
  isFlipY() {
    return !0;
  }
  enableHardwareClipping(e) {
    this.enableExtension("GL_ANGLE_clip_cull_distance", "require"), this.builtins.vertex.push(`out float gl_ClipDistance[ ${e} ]`);
  }
  registerTransform(e, t) {
    this.transforms.push({ varyingName: e, attributeNode: t });
  }
  getTransforms() {
    const e = this.transforms;
    let t = "";
    for (let s = 0; s < e.length; s++) {
      const n = e[s], r = this.getPropertyName(n.attributeNode);
      t += `${n.varyingName} = ${r};
	`;
    }
    return t;
  }
  _getGLSLUniformStruct(e, t) {
    return `
layout( std140 ) uniform ${e} {
${t}
};`;
  }
  _getGLSLVertexCode(e) {
    return `#version 300 es

${this.getSignature()}

// extensions 
${e.extensions}

// precision
${Cc}

// uniforms
${e.uniforms}

// varyings
${e.varyings}

// attributes
${e.attributes}

// codes
${e.codes}

void main() {

	// vars
	${e.vars}

	// transforms
	${e.transforms}

	// flow
	${e.flow}

	gl_PointSize = 1.0;

}
`;
  }
  _getGLSLFragmentCode(e) {
    return `#version 300 es

${this.getSignature()}

// precision
${Cc}

// uniforms
${e.uniforms}

// varyings
${e.varyings}

// codes
${e.codes}

${e.structs}

void main() {

	// vars
	${e.vars}

	// flow
	${e.flow}

}
`;
  }
  buildCode() {
    const e = this.material !== null ? { fragment: {}, vertex: {} } : { compute: {} };
    this.sortBindingGroups();
    for (const t in e) {
      let s = `// code

`;
      s += this.flowCode[t];
      const n = this.flowNodes[t], r = n[n.length - 1];
      for (const a of n) {
        const u = this.getFlowData(
          a
          /*, shaderStage*/
        ), c = a.name;
        c && (s.length > 0 && (s += `
`), s += `	// flow -> ${c}
	`), s += `${u.code}
	`, a === r && t !== "compute" && (s += `// result
	`, t === "vertex" ? (s += "gl_Position = ", s += `${u.result};`) : t === "fragment" && (a.outputNode.isOutputStructNode || (s += "fragColor = ", s += `${u.result};`)));
      }
      const i = e[t];
      i.extensions = this.getExtensions(t), i.uniforms = this.getUniforms(t), i.attributes = this.getAttributes(t), i.varyings = this.getVaryings(t), i.vars = this.getVars(t), i.structs = this.getStructs(t), i.codes = this.getCodes(t), i.transforms = this.getTransforms(t), i.flow = s;
    }
    this.material !== null ? (this.vertexShader = this._getGLSLVertexCode(e.vertex), this.fragmentShader = this._getGLSLFragmentCode(e.fragment)) : this.computeShader = this._getGLSLVertexCode(e.compute);
  }
  getUniformFromNode(e, t, s, n = null) {
    const r = super.getUniformFromNode(e, t, s, n), i = this.getDataFromNode(e, s, this.globalCache);
    let a = i.uniformGPU;
    if (a === void 0) {
      const u = e.groupNode, c = u.name, l = this.getBindGroupArray(c, s);
      if (t === "texture")
        a = new Ci(r.name, r.node, u), l.push(a);
      else if (t === "cubeTexture")
        a = new eg(r.name, r.node, u), l.push(a);
      else if (t === "texture3D")
        a = new tg(r.name, r.node, u), l.push(a);
      else if (t === "buffer") {
        e.name = `NodeBuffer_${e.id}`, r.name = `buffer${e.id}`;
        const d = new Zf(e, u);
        d.name = e.name, l.push(d), a = d;
      } else {
        const d = this.uniformGroups[s] || (this.uniformGroups[s] = {});
        let h = d[c];
        h === void 0 && (h = new Jf(s + "_" + c, u), d[c] = h, l.push(h)), a = this.getNodeUniform(r, t), h.addUniform(a);
      }
      i.uniformGPU = a;
    }
    return r;
  }
}
let no = null, Ms = null;
class sg {
  /**
   * Constructs a new backend.
   *
   * @param {Object} parameters - An object holding parameters for the backend.
   */
  constructor(e = {}) {
    this.parameters = Object.assign({}, e), this.data = /* @__PURE__ */ new WeakMap(), this.renderer = null, this.domElement = null;
  }
  /**
   * Initializes the backend so it is ready for usage. Concrete backends
   * are supposed to implement their rendering context creation and related
   * operations in this method.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the backend has been initialized.
   */
  async init(e) {
    this.renderer = e;
  }
  /**
   * The coordinate system of the backend.
   *
   * @abstract
   * @type {Number}
   * @readonly
   */
  get coordinateSystem() {
  }
  // render context
  /**
   * This method is executed at the beginning of a render call and
   * can be used by the backend to prepare the state for upcoming
   * draw calls.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   */
  beginRender() {
  }
  /**
   * This method is executed at the end of a render call and
   * can be used by the backend to finalize work after draw
   * calls.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   */
  finishRender() {
  }
  /**
   * This method is executed at the beginning of a compute call and
   * can be used by the backend to prepare the state for upcoming
   * compute tasks.
   *
   * @abstract
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */
  beginCompute() {
  }
  /**
   * This method is executed at the end of a compute call and
   * can be used by the backend to finalize work after compute
   * tasks.
   *
   * @abstract
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */
  finishCompute() {
  }
  // render object
  /**
   * Executes a draw command for the given render object.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object to draw.
   * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
   */
  draw() {
  }
  // compute node
  /**
   * Executes a compute command for the given compute node.
   *
   * @abstract
   * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   */
  compute() {
  }
  // program
  /**
   * Creates a shader program from the given programmable stage.
   *
   * @abstract
   * @param {ProgrammableStage} program - The programmable stage.
   */
  createProgram() {
  }
  /**
   * Destroys the shader program of the given programmable stage.
   *
   * @abstract
   * @param {ProgrammableStage} program - The programmable stage.
   */
  destroyProgram() {
  }
  // bindings
  /**
   * Creates bindings from the given bind group definition.
   *
   * @abstract
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {Number} cacheIndex - The cache index.
   * @param {Number} version - The version.
   */
  createBindings() {
  }
  /**
   * Updates the given bind group definition.
   *
   * @abstract
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {Number} cacheIndex - The cache index.
   * @param {Number} version - The version.
   */
  updateBindings() {
  }
  /**
   * Updates a buffer binding.
   *
   * @abstract
   * @param {Buffer} binding - The buffer binding to update.
   */
  updateBinding() {
  }
  // pipeline
  /**
   * Creates a render pipeline for the given render object.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */
  createRenderPipeline() {
  }
  /**
   * Creates a compute pipeline for the given compute node.
   *
   * @abstract
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */
  createComputePipeline() {
  }
  // cache key
  /**
   * Returns `true` if the render pipeline requires an update.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the render pipeline requires an update or not.
   */
  needsRenderUpdate() {
  }
  /**
   * Returns a cache key that is used to identify render pipelines.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @return {String} The cache key.
   */
  getRenderCacheKey() {
  }
  // node builder
  /**
   * Returns a node builder for the given render object.
   *
   * @abstract
   * @param {RenderObject} renderObject - The render object.
   * @param {Renderer} renderer - The renderer.
   * @return {NodeBuilder} The node builder.
   */
  createNodeBuilder() {
  }
  // textures
  /**
   * Creates a sampler for the given texture.
   *
   * @abstract
   * @param {Texture} texture - The texture to create the sampler for.
   */
  createSampler() {
  }
  /**
   * Destroys the sampler for the given texture.
   *
   * @abstract
   * @param {Texture} texture - The texture to destroy the sampler for.
   */
  destroySampler() {
  }
  /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @abstract
   * @param {Texture} texture - The texture to create a default texture for.
   */
  createDefaultTexture() {
  }
  /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */
  createTexture() {
  }
  /**
   * Uploads the updated texture data to the GPU.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */
  updateTexture() {
  }
  /**
   * Generates mipmaps for the given texture
   *
   * @abstract
   * @param {Texture} texture - The texture.
   */
  generateMipmaps() {
  }
  /**
   * Destroys the GPU data for the given texture object.
   *
   * @abstract
   * @param {Texture} texture - The texture.
   */
  destroyTexture() {
  }
  /**
   * Returns texture data as a typed array.
   *
   * @abstract
   * @param {Texture} texture - The texture to copy.
   * @param {Number} x - The x coordinate of the copy origin.
   * @param {Number} y - The y coordinate of the copy origin.
   * @param {Number} width - The width of the copy.
   * @param {Number} height - The height of the copy.
   * @param {Number} faceIndex - The face index.
   * @return {TypedArray} The texture data as a typed array.
   */
  copyTextureToBuffer() {
  }
  /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @abstract
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {Vector4?} [srcRegion=null] - The region of the source texture to copy.
   * @param {(Vector2|Vector3)?} [dstPosition=null] - The destination position of the copy.
   * @param {Number} [level=0] - The mip level to copy.
   */
  copyTextureToTexture() {
  }
  /**
  * Copies the current bound framebuffer to the given texture.
  *
  * @abstract
  * @param {Texture} texture - The destination texture.
  * @param {RenderContext} renderContext - The render context.
  * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
  */
  copyFramebufferToTexture() {
  }
  // attributes
  /**
   * Creates the buffer of a shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createAttribute() {
  }
  /**
   * Creates the buffer of an indexed shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The indexed buffer attribute.
   */
  createIndexAttribute() {
  }
  /**
   * Creates the buffer of a storage attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createStorageAttribute() {
  }
  /**
   * Updates the buffer of a shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute to update.
   */
  updateAttribute() {
  }
  /**
   * Destroys the buffer of a shader attribute.
   *
   * @abstract
   * @param {BufferAttribute} attribute - The buffer attribute to destroy.
   */
  destroyAttribute() {
  }
  // canvas
  /**
   * Returns the backend's rendering context.
   *
   * @abstract
   * @return {Object} The rendering context.
   */
  getContext() {
  }
  /**
   * Backends can use this method if they have to run
   * logic when the renderer gets resized.
   *
   * @abstract
   */
  updateSize() {
  }
  /**
   * Updates the viewport with the values from the given render context.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   */
  updateViewport() {
  }
  // utils
  /**
   * Returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene. Backends must implement this method by using
   * a Occlusion Query API.
   *
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   * @param {Object3D} object - The 3D object to test.
   * @return {Boolean} Whether the 3D object is fully occluded or not.
   */
  isOccluded() {
  }
  /**
   * Resolves the time stamp for the given render context and type.
   *
   * @async
   * @abstract
   * @param {RenderContext} renderContext - The render context.
   * @param {String} type - The render context.
   * @return {Promise} A Promise that resolves when the time stamp has been computed.
   */
  async resolveTimestampAsync() {
  }
  /**
   * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
   * the CPU waits for the GPU to complete its operation (e.g. a compute task).
   *
   * @async
   * @abstract
   * @return {Promise} A Promise that resolves when synchronization has been finished.
   */
  async waitForGPU() {
  }
  /**
   * Checks if the given feature is supported by the backend.
   *
   * @async
   * @abstract
   * @param {String} name - The feature's name.
   * @return {Promise<Boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
   */
  async hasFeatureAsync() {
  }
  /**
   * Checks if the given feature is supported  by the backend.
   *
   * @abstract
   * @param {String} name - The feature's name.
   * @return {Boolean} Whether the feature is supported or not.
   */
  hasFeature() {
  }
  /**
   * Returns the maximum anisotropy texture filtering value.
   *
   * @abstract
   * @return {Number} The maximum anisotropy texture filtering value.
   */
  getMaxAnisotropy() {
  }
  /**
   * Returns the drawing buffer size.
   *
   * @return {Vector2} The drawing buffer size.
   */
  getDrawingBufferSize() {
    return no = no || new He(), this.renderer.getDrawingBufferSize(no);
  }
  /**
   * Defines the scissor test.
   *
   * @abstract
   * @param {Boolean} boolean - Whether the scissor test should be enabled or not.
   */
  setScissorTest() {
  }
  /**
   * Returns the clear color and alpha into a single
   * color object.
   *
   * @return {Color4} The clear color.
   */
  getClearColor() {
    const e = this.renderer;
    return Ms = Ms || new su(), e.getClearColor(Ms), Ms.getRGB(Ms, this.renderer.currentColorSpace), Ms;
  }
  /**
   * Returns the DOM element. If no DOM element exists, the backend
   * creates a new one.
   *
   * @return {HTMLCanvasElement} The DOM element.
   */
  getDomElement() {
    let e = this.domElement;
    return e === null && (e = this.parameters.canvas !== void 0 ? this.parameters.canvas : Rg(), "setAttribute" in e && e.setAttribute("data-engine", `three.js r${Hc} webgpu`), this.domElement = e), e;
  }
  /**
   * Sets a dictionary for the given object into the
   * internal data structure.
   *
   * @param {Object} object - The object.
   * @param {Object} value - The dictionary to set.
   */
  set(e, t) {
    this.data.set(e, t);
  }
  /**
   * Returns the dictionary for the given object.
   *
   * @param {Object} object - The object.
   * @return {Object} The object's dictionary.
   */
  get(e) {
    let t = this.data.get(e);
    return t === void 0 && (t = {}, this.data.set(e, t)), t;
  }
  /**
   * Checks if the given object has a dictionary
   * with data defined.
   *
   * @param {Object} object - The object.
   * @return {Boolean} Whether a dictionary for the given object as been defined or not.
   */
  has(e) {
    return this.data.has(e);
  }
  /**
   * Deletes an object from the internal data structure.
   *
   * @param {Object} object - The object to delete.
   */
  delete(e) {
    this.data.delete(e);
  }
  /**
   * Frees internal resources.
   *
   * @abstract
   */
  dispose() {
  }
}
let dA = 0;
class hA {
  constructor(e, t) {
    this.buffers = [e.bufferGPU, t], this.type = e.type, this.bufferType = e.bufferType, this.pbo = e.pbo, this.byteLength = e.byteLength, this.bytesPerElement = e.BYTES_PER_ELEMENT, this.version = e.version, this.isInteger = e.isInteger, this.activeBufferIndex = 0, this.baseId = e.id;
  }
  get id() {
    return `${this.baseId}|${this.activeBufferIndex}`;
  }
  get bufferGPU() {
    return this.buffers[this.activeBufferIndex];
  }
  get transformBuffer() {
    return this.buffers[this.activeBufferIndex ^ 1];
  }
  switchBuffers() {
    this.activeBufferIndex ^= 1;
  }
}
class pA {
  constructor(e) {
    this.backend = e;
  }
  createAttribute(e, t) {
    const s = this.backend, { gl: n } = s, r = e.array, i = e.usage || n.STATIC_DRAW, a = e.isInterleavedBufferAttribute ? e.data : e, u = s.get(a);
    let c = u.bufferGPU;
    c === void 0 && (c = this._createBuffer(n, t, r, i), u.bufferGPU = c, u.bufferType = t, u.version = a.version);
    let l;
    if (r instanceof Float32Array)
      l = n.FLOAT;
    else if (r instanceof Uint16Array)
      e.isFloat16BufferAttribute ? l = n.HALF_FLOAT : l = n.UNSIGNED_SHORT;
    else if (r instanceof Int16Array)
      l = n.SHORT;
    else if (r instanceof Uint32Array)
      l = n.UNSIGNED_INT;
    else if (r instanceof Int32Array)
      l = n.INT;
    else if (r instanceof Int8Array)
      l = n.BYTE;
    else if (r instanceof Uint8Array)
      l = n.UNSIGNED_BYTE;
    else if (r instanceof Uint8ClampedArray)
      l = n.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLBackend: Unsupported buffer data format: " + r);
    let d = {
      bufferGPU: c,
      bufferType: t,
      type: l,
      byteLength: r.byteLength,
      bytesPerElement: r.BYTES_PER_ELEMENT,
      version: e.version,
      pbo: e.pbo,
      isInteger: l === n.INT || l === n.UNSIGNED_INT || e.gpuType === Ve,
      id: dA++
    };
    if (e.isStorageBufferAttribute || e.isStorageInstancedBufferAttribute) {
      const h = this._createBuffer(n, t, r, i);
      d = new hA(d, h);
    }
    s.set(e, d);
  }
  updateAttribute(e) {
    const t = this.backend, { gl: s } = t, n = e.array, r = e.isInterleavedBufferAttribute ? e.data : e, i = t.get(r), a = i.bufferType, u = e.isInterleavedBufferAttribute ? e.data.updateRanges : e.updateRanges;
    if (s.bindBuffer(a, i.bufferGPU), u.length === 0)
      s.bufferSubData(a, 0, n);
    else {
      for (let c = 0, l = u.length; c < l; c++) {
        const d = u[c];
        s.bufferSubData(
          a,
          d.start * n.BYTES_PER_ELEMENT,
          n,
          d.start,
          d.count
        );
      }
      r.clearUpdateRanges();
    }
    s.bindBuffer(a, null), i.version = r.version;
  }
  destroyAttribute(e) {
    const t = this.backend, { gl: s } = t;
    e.isInterleavedBufferAttribute && t.delete(e.data);
    const n = t.get(e);
    s.deleteBuffer(n.bufferGPU), t.delete(e);
  }
  async getArrayBufferAsync(e) {
    const t = this.backend, { gl: s } = t, n = e.isInterleavedBufferAttribute ? e.data : e, { bufferGPU: r } = t.get(n), i = e.array, a = i.byteLength;
    s.bindBuffer(s.COPY_READ_BUFFER, r);
    const u = s.createBuffer();
    s.bindBuffer(s.COPY_WRITE_BUFFER, u), s.bufferData(s.COPY_WRITE_BUFFER, a, s.STREAM_READ), s.copyBufferSubData(s.COPY_READ_BUFFER, s.COPY_WRITE_BUFFER, 0, 0, a), await t.utils._clientWaitAsync();
    const c = new e.array.constructor(i.length);
    return s.bindBuffer(s.COPY_WRITE_BUFFER, u), s.getBufferSubData(s.COPY_WRITE_BUFFER, 0, c), s.deleteBuffer(u), s.bindBuffer(s.COPY_READ_BUFFER, null), s.bindBuffer(s.COPY_WRITE_BUFFER, null), c.buffer;
  }
  _createBuffer(e, t, s, n) {
    const r = e.createBuffer();
    return e.bindBuffer(t, r), e.bufferData(t, s, n), e.bindBuffer(t, null), r;
  }
}
let Ec = !1, ro, yn;
class fA {
  constructor(e) {
    this.backend = e, this.gl = this.backend.gl, this.enabled = {}, this.currentFlipSided = null, this.currentCullFace = null, this.currentProgram = null, this.currentBlendingEnabled = !1, this.currentBlending = null, this.currentBlendSrc = null, this.currentBlendDst = null, this.currentBlendSrcAlpha = null, this.currentBlendDstAlpha = null, this.currentPremultipledAlpha = null, this.currentPolygonOffsetFactor = null, this.currentPolygonOffsetUnits = null, this.currentColorMask = null, this.currentDepthFunc = null, this.currentDepthMask = null, this.currentStencilFunc = null, this.currentStencilRef = null, this.currentStencilFuncMask = null, this.currentStencilFail = null, this.currentStencilZFail = null, this.currentStencilZPass = null, this.currentStencilMask = null, this.currentLineWidth = null, this.currentClippingPlanes = 0, this.currentBoundFramebuffers = {}, this.currentDrawbuffers = /* @__PURE__ */ new WeakMap(), this.maxTextures = this.gl.getParameter(this.gl.MAX_TEXTURE_IMAGE_UNITS), this.currentTextureSlot = null, this.currentBoundTextures = {}, this.currentBoundBufferBases = {}, Ec === !1 && (this._init(this.gl), Ec = !0);
  }
  _init(e) {
    ro = {
      [Us]: e.FUNC_ADD,
      [qc]: e.FUNC_SUBTRACT,
      [Xc]: e.FUNC_REVERSE_SUBTRACT
    }, yn = {
      [Kc]: e.ZERO,
      [Yc]: e.ONE,
      [jc]: e.SRC_COLOR,
      [Qc]: e.SRC_ALPHA,
      [Zc]: e.SRC_ALPHA_SATURATE,
      [Jc]: e.DST_COLOR,
      [el]: e.DST_ALPHA,
      [tl]: e.ONE_MINUS_SRC_COLOR,
      [sl]: e.ONE_MINUS_SRC_ALPHA,
      [nl]: e.ONE_MINUS_DST_COLOR,
      [rl]: e.ONE_MINUS_DST_ALPHA
    };
  }
  enable(e) {
    const { enabled: t } = this;
    t[e] !== !0 && (this.gl.enable(e), t[e] = !0);
  }
  disable(e) {
    const { enabled: t } = this;
    t[e] !== !1 && (this.gl.disable(e), t[e] = !1);
  }
  setFlipSided(e) {
    if (this.currentFlipSided !== e) {
      const { gl: t } = this;
      e ? t.frontFace(t.CW) : t.frontFace(t.CCW), this.currentFlipSided = e;
    }
  }
  setCullFace(e) {
    const { gl: t } = this;
    e !== Cg ? (this.enable(t.CULL_FACE), e !== this.currentCullFace && (e === Eg ? t.cullFace(t.BACK) : e === wg ? t.cullFace(t.FRONT) : t.cullFace(t.FRONT_AND_BACK))) : this.disable(t.CULL_FACE), this.currentCullFace = e;
  }
  setLineWidth(e) {
    const { currentLineWidth: t, gl: s } = this;
    e !== t && (s.lineWidth(e), this.currentLineWidth = e);
  }
  setBlending(e, t, s, n, r, i, a, u) {
    const { gl: c } = this;
    if (e === Mn) {
      this.currentBlendingEnabled === !0 && (this.disable(c.BLEND), this.currentBlendingEnabled = !1);
      return;
    }
    if (this.currentBlendingEnabled === !1 && (this.enable(c.BLEND), this.currentBlendingEnabled = !0), e !== il) {
      if (e !== this.currentBlending || u !== this.currentPremultipledAlpha) {
        if ((this.currentBlendEquation !== Us || this.currentBlendEquationAlpha !== Us) && (c.blendEquation(c.FUNC_ADD), this.currentBlendEquation = Us, this.currentBlendEquationAlpha = Us), u)
          switch (e) {
            case zs:
              c.blendFuncSeparate(c.ONE, c.ONE_MINUS_SRC_ALPHA, c.ONE, c.ONE_MINUS_SRC_ALPHA);
              break;
            case Lr:
              c.blendFunc(c.ONE, c.ONE);
              break;
            case Ir:
              c.blendFuncSeparate(c.ZERO, c.ONE_MINUS_SRC_COLOR, c.ZERO, c.ONE);
              break;
            case Dr:
              c.blendFuncSeparate(c.ZERO, c.SRC_COLOR, c.ZERO, c.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", e);
              break;
          }
        else
          switch (e) {
            case zs:
              c.blendFuncSeparate(c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA, c.ONE, c.ONE_MINUS_SRC_ALPHA);
              break;
            case Lr:
              c.blendFunc(c.SRC_ALPHA, c.ONE);
              break;
            case Ir:
              c.blendFuncSeparate(c.ZERO, c.ONE_MINUS_SRC_COLOR, c.ZERO, c.ONE);
              break;
            case Dr:
              c.blendFunc(c.ZERO, c.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", e);
              break;
          }
        this.currentBlendSrc = null, this.currentBlendDst = null, this.currentBlendSrcAlpha = null, this.currentBlendDstAlpha = null, this.currentBlending = e, this.currentPremultipledAlpha = u;
      }
      return;
    }
    r = r || t, i = i || s, a = a || n, (t !== this.currentBlendEquation || r !== this.currentBlendEquationAlpha) && (c.blendEquationSeparate(ro[t], ro[r]), this.currentBlendEquation = t, this.currentBlendEquationAlpha = r), (s !== this.currentBlendSrc || n !== this.currentBlendDst || i !== this.currentBlendSrcAlpha || a !== this.currentBlendDstAlpha) && (c.blendFuncSeparate(yn[s], yn[n], yn[i], yn[a]), this.currentBlendSrc = s, this.currentBlendDst = n, this.currentBlendSrcAlpha = i, this.currentBlendDstAlpha = a), this.currentBlending = e, this.currentPremultipledAlpha = !1;
  }
  setColorMask(e) {
    this.currentColorMask !== e && (this.gl.colorMask(e, e, e, e), this.currentColorMask = e);
  }
  setDepthTest(e) {
    const { gl: t } = this;
    e ? this.enable(t.DEPTH_TEST) : this.disable(t.DEPTH_TEST);
  }
  setDepthMask(e) {
    this.currentDepthMask !== e && (this.gl.depthMask(e), this.currentDepthMask = e);
  }
  setDepthFunc(e) {
    if (this.currentDepthFunc !== e) {
      const { gl: t } = this;
      switch (e) {
        case pl:
          t.depthFunc(t.NEVER);
          break;
        case hl:
          t.depthFunc(t.ALWAYS);
          break;
        case dl:
          t.depthFunc(t.LESS);
          break;
        case ll:
          t.depthFunc(t.LEQUAL);
          break;
        case cl:
          t.depthFunc(t.EQUAL);
          break;
        case ul:
          t.depthFunc(t.GEQUAL);
          break;
        case al:
          t.depthFunc(t.GREATER);
          break;
        case ol:
          t.depthFunc(t.NOTEQUAL);
          break;
        default:
          t.depthFunc(t.LEQUAL);
      }
      this.currentDepthFunc = e;
    }
  }
  setStencilTest(e) {
    const { gl: t } = this;
    e ? this.enable(t.STENCIL_TEST) : this.disable(t.STENCIL_TEST);
  }
  setStencilMask(e) {
    this.currentStencilMask !== e && (this.gl.stencilMask(e), this.currentStencilMask = e);
  }
  setStencilFunc(e, t, s) {
    (this.currentStencilFunc !== e || this.currentStencilRef !== t || this.currentStencilFuncMask !== s) && (this.gl.stencilFunc(e, t, s), this.currentStencilFunc = e, this.currentStencilRef = t, this.currentStencilFuncMask = s);
  }
  setStencilOp(e, t, s) {
    (this.currentStencilFail !== e || this.currentStencilZFail !== t || this.currentStencilZPass !== s) && (this.gl.stencilOp(e, t, s), this.currentStencilFail = e, this.currentStencilZFail = t, this.currentStencilZPass = s);
  }
  setMaterial(e, t, s) {
    const { gl: n } = this;
    e.side === Ws ? this.disable(n.CULL_FACE) : this.enable(n.CULL_FACE);
    let r = e.side === Tt;
    t && (r = !r), this.setFlipSided(r), e.blending === zs && e.transparent === !1 ? this.setBlending(Mn) : this.setBlending(e.blending, e.blendEquation, e.blendSrc, e.blendDst, e.blendEquationAlpha, e.blendSrcAlpha, e.blendDstAlpha, e.premultipliedAlpha), this.setDepthFunc(e.depthFunc), this.setDepthTest(e.depthTest), this.setDepthMask(e.depthWrite), this.setColorMask(e.colorWrite);
    const i = e.stencilWrite;
    if (this.setStencilTest(i), i && (this.setStencilMask(e.stencilWriteMask), this.setStencilFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask), this.setStencilOp(e.stencilFail, e.stencilZFail, e.stencilZPass)), this.setPolygonOffset(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits), e.alphaToCoverage === !0 && this.backend.renderer.samples > 1 ? this.enable(n.SAMPLE_ALPHA_TO_COVERAGE) : this.disable(n.SAMPLE_ALPHA_TO_COVERAGE), s > 0 && this.currentClippingPlanes !== s)
      for (let u = 0; u < 8; u++)
        u < s ? this.enable(12288 + u) : this.disable(12288 + u);
  }
  setPolygonOffset(e, t, s) {
    const { gl: n } = this;
    e ? (this.enable(n.POLYGON_OFFSET_FILL), (this.currentPolygonOffsetFactor !== t || this.currentPolygonOffsetUnits !== s) && (n.polygonOffset(t, s), this.currentPolygonOffsetFactor = t, this.currentPolygonOffsetUnits = s)) : this.disable(n.POLYGON_OFFSET_FILL);
  }
  useProgram(e) {
    return this.currentProgram !== e ? (this.gl.useProgram(e), this.currentProgram = e, !0) : !1;
  }
  // framebuffer
  bindFramebuffer(e, t) {
    const { gl: s, currentBoundFramebuffers: n } = this;
    return n[e] !== t ? (s.bindFramebuffer(e, t), n[e] = t, e === s.DRAW_FRAMEBUFFER && (n[s.FRAMEBUFFER] = t), e === s.FRAMEBUFFER && (n[s.DRAW_FRAMEBUFFER] = t), !0) : !1;
  }
  drawBuffers(e, t) {
    const { gl: s } = this;
    let n = [], r = !1;
    if (e.textures !== null) {
      n = this.currentDrawbuffers.get(t), n === void 0 && (n = [], this.currentDrawbuffers.set(t, n));
      const i = e.textures;
      if (n.length !== i.length || n[0] !== s.COLOR_ATTACHMENT0) {
        for (let a = 0, u = i.length; a < u; a++)
          n[a] = s.COLOR_ATTACHMENT0 + a;
        n.length = i.length, r = !0;
      }
    } else
      n[0] !== s.BACK && (n[0] = s.BACK, r = !0);
    r && s.drawBuffers(n);
  }
  // texture
  activeTexture(e) {
    const { gl: t, currentTextureSlot: s, maxTextures: n } = this;
    e === void 0 && (e = t.TEXTURE0 + n - 1), s !== e && (t.activeTexture(e), this.currentTextureSlot = e);
  }
  bindTexture(e, t, s) {
    const { gl: n, currentTextureSlot: r, currentBoundTextures: i, maxTextures: a } = this;
    s === void 0 && (r === null ? s = n.TEXTURE0 + a - 1 : s = r);
    let u = i[s];
    u === void 0 && (u = { type: void 0, texture: void 0 }, i[s] = u), (u.type !== e || u.texture !== t) && (r !== s && (n.activeTexture(s), this.currentTextureSlot = s), n.bindTexture(e, t), u.type = e, u.texture = t);
  }
  bindBufferBase(e, t, s) {
    const { gl: n } = this, r = `${e}-${t}`;
    return this.currentBoundBufferBases[r] !== s ? (n.bindBufferBase(e, t, s), this.currentBoundBufferBases[r] = s, !0) : !1;
  }
  unbindTexture() {
    const { gl: e, currentTextureSlot: t, currentBoundTextures: s } = this, n = s[t];
    n !== void 0 && n.type !== void 0 && (e.bindTexture(n.type, null), n.type = void 0, n.texture = void 0);
  }
}
class gA {
  constructor(e) {
    this.backend = e, this.gl = this.backend.gl, this.extensions = e.extensions;
  }
  convert(e, t = wn) {
    const { gl: s, extensions: n } = this;
    let r;
    if (e === ls) return s.UNSIGNED_BYTE;
    if (e === Mg) return s.UNSIGNED_SHORT_4_4_4_4;
    if (e === Bg) return s.UNSIGNED_SHORT_5_5_5_1;
    if (e === fl) return s.UNSIGNED_INT_5_9_9_9_REV;
    if (e === Tn) return s.BYTE;
    if (e === _n) return s.SHORT;
    if (e === Ls) return s.UNSIGNED_SHORT;
    if (e === Ve) return s.INT;
    if (e === Pe) return s.UNSIGNED_INT;
    if (e === st) return s.FLOAT;
    if (e === at)
      return s.HALF_FLOAT;
    if (e === Fg) return s.ALPHA;
    if (e === Jo) return s.RGB;
    if (e === Xs) return s.RGBA;
    if (e === Ug) return s.LUMINANCE;
    if (e === Pg) return s.LUMINANCE_ALPHA;
    if (e === Jr) return s.DEPTH_COMPONENT;
    if (e === Zr) return s.DEPTH_STENCIL;
    if (e === ea) return s.RED;
    if (e === ta) return s.RED_INTEGER;
    if (e === Bn) return s.RG;
    if (e === sa) return s.RG_INTEGER;
    if (e === na) return s.RGBA_INTEGER;
    if (e === Ei || e === vr || e === Ar || e === Rr)
      if (t === q)
        if (r = n.get("WEBGL_compressed_texture_s3tc_srgb"), r !== null) {
          if (e === Ei) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (e === vr) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (e === Ar) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (e === Rr) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (r = n.get("WEBGL_compressed_texture_s3tc"), r !== null) {
        if (e === Ei) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (e === vr) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (e === Ar) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (e === Rr) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (e === Su || e === vu || e === Au || e === Ru)
      if (r = n.get("WEBGL_compressed_texture_pvrtc"), r !== null) {
        if (e === Su) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (e === vu) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (e === Au) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (e === Ru) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (e === Cu || e === fo || e === go)
      if (r = n.get("WEBGL_compressed_texture_etc"), r !== null) {
        if (e === Cu || e === fo) return t === q ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
        if (e === go) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (e === mo || e === yo || e === xo || e === To || e === _o || e === No || e === bo || e === So || e === vo || e === Ao || e === Ro || e === Co || e === Eo || e === wo)
      if (r = n.get("WEBGL_compressed_texture_astc"), r !== null) {
        if (e === mo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (e === yo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (e === xo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (e === To) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (e === _o) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (e === No) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (e === bo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (e === So) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (e === vo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (e === Ao) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (e === Ro) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (e === Co) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (e === Eo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (e === wo) return t === q ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (e === wi)
      if (r = n.get("EXT_texture_compression_bptc"), r !== null) {
        if (e === wi) return t === q ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      } else
        return null;
    if (e === Dg || e === Eu || e === wu || e === Mu)
      if (r = n.get("EXT_texture_compression_rgtc"), r !== null) {
        if (e === wi) return r.COMPRESSED_RED_RGTC1_EXT;
        if (e === Eu) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (e === wu) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (e === Mu) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return e === ei ? s.UNSIGNED_INT_24_8 : s[e] !== void 0 ? s[e] : null;
  }
  _clientWaitAsync() {
    const { gl: e } = this, t = e.fenceSync(e.SYNC_GPU_COMMANDS_COMPLETE, 0);
    return e.flush(), new Promise((s, n) => {
      function r() {
        const i = e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0);
        if (i === e.WAIT_FAILED) {
          e.deleteSync(t), n();
          return;
        }
        if (i === e.TIMEOUT_EXPIRED) {
          requestAnimationFrame(r);
          return;
        }
        e.deleteSync(t), s();
      }
      r();
    });
  }
}
let wc = !1, Nr, io, Mc;
class mA {
  constructor(e) {
    this.backend = e, this.gl = e.gl, this.extensions = e.extensions, this.defaultTextures = {}, wc === !1 && (this._init(this.gl), wc = !0);
  }
  _init(e) {
    Nr = {
      [ti]: e.REPEAT,
      [ra]: e.CLAMP_TO_EDGE,
      [si]: e.MIRRORED_REPEAT
    }, io = {
      [pt]: e.NEAREST,
      [Mo]: e.NEAREST_MIPMAP_NEAREST,
      [Hs]: e.NEAREST_MIPMAP_LINEAR,
      [Lt]: e.LINEAR,
      [Bo]: e.LINEAR_MIPMAP_NEAREST,
      [ds]: e.LINEAR_MIPMAP_LINEAR
    }, Mc = {
      [gl]: e.NEVER,
      [ml]: e.ALWAYS,
      [ia]: e.LESS,
      [yl]: e.LEQUAL,
      [xl]: e.EQUAL,
      [Tl]: e.GEQUAL,
      [_l]: e.GREATER,
      [Nl]: e.NOTEQUAL
    };
  }
  filterFallback(e) {
    const { gl: t } = this;
    return e === pt || e === Mo || e === Hs ? t.NEAREST : t.LINEAR;
  }
  getGLTextureType(e) {
    const { gl: t } = this;
    let s;
    return e.isCubeTexture === !0 ? s = t.TEXTURE_CUBE_MAP : e.isDataArrayTexture === !0 || e.isCompressedArrayTexture === !0 ? s = t.TEXTURE_2D_ARRAY : e.isData3DTexture === !0 ? s = t.TEXTURE_3D : s = t.TEXTURE_2D, s;
  }
  getInternalFormat(e, t, s, n, r = !1) {
    const { gl: i, extensions: a } = this;
    if (e !== null) {
      if (i[e] !== void 0) return i[e];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + e + "'");
    }
    let u = t;
    return t === i.RED && (s === i.FLOAT && (u = i.R32F), s === i.HALF_FLOAT && (u = i.R16F), s === i.UNSIGNED_BYTE && (u = i.R8), s === i.UNSIGNED_SHORT && (u = i.R16), s === i.UNSIGNED_INT && (u = i.R32UI), s === i.BYTE && (u = i.R8I), s === i.SHORT && (u = i.R16I), s === i.INT && (u = i.R32I)), t === i.RED_INTEGER && (s === i.UNSIGNED_BYTE && (u = i.R8UI), s === i.UNSIGNED_SHORT && (u = i.R16UI), s === i.UNSIGNED_INT && (u = i.R32UI), s === i.BYTE && (u = i.R8I), s === i.SHORT && (u = i.R16I), s === i.INT && (u = i.R32I)), t === i.RG && (s === i.FLOAT && (u = i.RG32F), s === i.HALF_FLOAT && (u = i.RG16F), s === i.UNSIGNED_BYTE && (u = i.RG8), s === i.UNSIGNED_SHORT && (u = i.RG16), s === i.UNSIGNED_INT && (u = i.RG32UI), s === i.BYTE && (u = i.RG8I), s === i.SHORT && (u = i.RG16I), s === i.INT && (u = i.RG32I)), t === i.RG_INTEGER && (s === i.UNSIGNED_BYTE && (u = i.RG8UI), s === i.UNSIGNED_SHORT && (u = i.RG16UI), s === i.UNSIGNED_INT && (u = i.RG32UI), s === i.BYTE && (u = i.RG8I), s === i.SHORT && (u = i.RG16I), s === i.INT && (u = i.RG32I)), t === i.RGB && (s === i.FLOAT && (u = i.RGB32F), s === i.HALF_FLOAT && (u = i.RGB16F), s === i.UNSIGNED_BYTE && (u = i.RGB8), s === i.UNSIGNED_SHORT && (u = i.RGB16), s === i.UNSIGNED_INT && (u = i.RGB32UI), s === i.BYTE && (u = i.RGB8I), s === i.SHORT && (u = i.RGB16I), s === i.INT && (u = i.RGB32I), s === i.UNSIGNED_BYTE && (u = n === q && r === !1 ? i.SRGB8 : i.RGB8), s === i.UNSIGNED_SHORT_5_6_5 && (u = i.RGB565), s === i.UNSIGNED_SHORT_5_5_5_1 && (u = i.RGB5_A1), s === i.UNSIGNED_SHORT_4_4_4_4 && (u = i.RGB4), s === i.UNSIGNED_INT_5_9_9_9_REV && (u = i.RGB9_E5)), t === i.RGB_INTEGER && (s === i.UNSIGNED_BYTE && (u = i.RGB8UI), s === i.UNSIGNED_SHORT && (u = i.RGB16UI), s === i.UNSIGNED_INT && (u = i.RGB32UI), s === i.BYTE && (u = i.RGB8I), s === i.SHORT && (u = i.RGB16I), s === i.INT && (u = i.RGB32I)), t === i.RGBA && (s === i.FLOAT && (u = i.RGBA32F), s === i.HALF_FLOAT && (u = i.RGBA16F), s === i.UNSIGNED_BYTE && (u = i.RGBA8), s === i.UNSIGNED_SHORT && (u = i.RGBA16), s === i.UNSIGNED_INT && (u = i.RGBA32UI), s === i.BYTE && (u = i.RGBA8I), s === i.SHORT && (u = i.RGBA16I), s === i.INT && (u = i.RGBA32I), s === i.UNSIGNED_BYTE && (u = n === q && r === !1 ? i.SRGB8_ALPHA8 : i.RGBA8), s === i.UNSIGNED_SHORT_4_4_4_4 && (u = i.RGBA4), s === i.UNSIGNED_SHORT_5_5_5_1 && (u = i.RGB5_A1)), t === i.RGBA_INTEGER && (s === i.UNSIGNED_BYTE && (u = i.RGBA8UI), s === i.UNSIGNED_SHORT && (u = i.RGBA16UI), s === i.UNSIGNED_INT && (u = i.RGBA32UI), s === i.BYTE && (u = i.RGBA8I), s === i.SHORT && (u = i.RGBA16I), s === i.INT && (u = i.RGBA32I)), t === i.DEPTH_COMPONENT && (s === i.UNSIGNED_INT && (u = i.DEPTH24_STENCIL8), s === i.FLOAT && (u = i.DEPTH_COMPONENT32F)), t === i.DEPTH_STENCIL && s === i.UNSIGNED_INT_24_8 && (u = i.DEPTH24_STENCIL8), (u === i.R16F || u === i.R32F || u === i.RG16F || u === i.RG32F || u === i.RGBA16F || u === i.RGBA32F) && a.get("EXT_color_buffer_float"), u;
  }
  setTextureParameters(e, t) {
    const { gl: s, extensions: n, backend: r } = this;
    s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, t.flipY), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), s.pixelStorei(s.UNPACK_ALIGNMENT, t.unpackAlignment), s.pixelStorei(s.UNPACK_COLORSPACE_CONVERSION_WEBGL, s.NONE), s.texParameteri(e, s.TEXTURE_WRAP_S, Nr[t.wrapS]), s.texParameteri(e, s.TEXTURE_WRAP_T, Nr[t.wrapT]), (e === s.TEXTURE_3D || e === s.TEXTURE_2D_ARRAY) && s.texParameteri(e, s.TEXTURE_WRAP_R, Nr[t.wrapR]), s.texParameteri(e, s.TEXTURE_MAG_FILTER, io[t.magFilter]);
    const i = t.mipmaps !== void 0 && t.mipmaps.length > 0, a = t.minFilter === Lt && i ? ds : t.minFilter;
    if (s.texParameteri(e, s.TEXTURE_MIN_FILTER, io[a]), t.compareFunction && (s.texParameteri(e, s.TEXTURE_COMPARE_MODE, s.COMPARE_REF_TO_TEXTURE), s.texParameteri(e, s.TEXTURE_COMPARE_FUNC, Mc[t.compareFunction])), n.has("EXT_texture_filter_anisotropic") === !0) {
      if (t.magFilter === pt || t.minFilter !== Hs && t.minFilter !== ds || t.type === st && n.has("OES_texture_float_linear") === !1) return;
      if (t.anisotropy > 1) {
        const u = n.get("EXT_texture_filter_anisotropic");
        s.texParameterf(e, u.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(t.anisotropy, r.getMaxAnisotropy()));
      }
    }
  }
  createDefaultTexture(e) {
    const { gl: t, backend: s, defaultTextures: n } = this, r = this.getGLTextureType(e);
    let i = n[r];
    i === void 0 && (i = t.createTexture(), s.state.bindTexture(r, i), t.texParameteri(r, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(r, t.TEXTURE_MAG_FILTER, t.NEAREST), n[r] = i), s.set(e, {
      textureGPU: i,
      glTextureType: r,
      isDefault: !0
    });
  }
  createTexture(e, t) {
    const { gl: s, backend: n } = this, { levels: r, width: i, height: a, depth: u } = t, c = n.utils.convert(e.format, e.colorSpace), l = n.utils.convert(e.type), d = this.getInternalFormat(e.internalFormat, c, l, e.colorSpace, e.isVideoTexture), h = s.createTexture(), p = this.getGLTextureType(e);
    n.state.bindTexture(p, h), this.setTextureParameters(p, e), e.isDataArrayTexture || e.isCompressedArrayTexture ? s.texStorage3D(s.TEXTURE_2D_ARRAY, r, d, i, a, u) : e.isData3DTexture ? s.texStorage3D(s.TEXTURE_3D, r, d, i, a, u) : e.isVideoTexture || s.texStorage2D(p, r, d, i, a), n.set(e, {
      textureGPU: h,
      glTextureType: p,
      glFormat: c,
      glType: l,
      glInternalFormat: d
    });
  }
  copyBufferToTexture(e, t) {
    const { gl: s, backend: n } = this, { textureGPU: r, glTextureType: i, glFormat: a, glType: u } = n.get(t), { width: c, height: l } = t.source.data;
    s.bindBuffer(s.PIXEL_UNPACK_BUFFER, e), n.state.bindTexture(i, r), s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, !1), s.pixelStorei(s.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), s.texSubImage2D(i, 0, 0, 0, c, l, a, u, 0), s.bindBuffer(s.PIXEL_UNPACK_BUFFER, null), n.state.unbindTexture();
  }
  updateTexture(e, t) {
    const { gl: s } = this, { width: n, height: r } = t, { textureGPU: i, glTextureType: a, glFormat: u, glType: c, glInternalFormat: l } = this.backend.get(e);
    if (e.isRenderTargetTexture || i === void 0)
      return;
    const d = (h) => h.isDataTexture ? h.image.data : typeof HTMLImageElement < "u" && h instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && h instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && h instanceof ImageBitmap || h instanceof OffscreenCanvas ? h : h.data;
    if (this.backend.state.bindTexture(a, i), this.setTextureParameters(a, e), e.isCompressedTexture) {
      const h = e.mipmaps, p = t.image;
      for (let f = 0; f < h.length; f++) {
        const m = h[f];
        e.isCompressedArrayTexture ? e.format !== s.RGBA ? u !== null ? s.compressedTexSubImage3D(s.TEXTURE_2D_ARRAY, f, 0, 0, 0, m.width, m.height, p.depth, u, m.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : s.texSubImage3D(s.TEXTURE_2D_ARRAY, f, 0, 0, 0, m.width, m.height, p.depth, u, c, m.data) : u !== null ? s.compressedTexSubImage2D(s.TEXTURE_2D, f, 0, 0, m.width, m.height, u, m.data) : console.warn("Unsupported compressed texture format");
      }
    } else if (e.isCubeTexture) {
      const h = t.images;
      for (let p = 0; p < 6; p++) {
        const f = d(h[p]);
        s.texSubImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + p, 0, 0, 0, n, r, u, c, f);
      }
    } else if (e.isDataArrayTexture) {
      const h = t.image;
      s.texSubImage3D(s.TEXTURE_2D_ARRAY, 0, 0, 0, 0, h.width, h.height, h.depth, u, c, h.data);
    } else if (e.isData3DTexture) {
      const h = t.image;
      s.texSubImage3D(s.TEXTURE_3D, 0, 0, 0, 0, h.width, h.height, h.depth, u, c, h.data);
    } else if (e.isVideoTexture)
      e.update(), s.texImage2D(a, 0, l, u, c, t.image);
    else {
      const h = d(t.image);
      s.texSubImage2D(a, 0, 0, 0, n, r, u, c, h);
    }
  }
  generateMipmaps(e) {
    const { gl: t, backend: s } = this, { textureGPU: n, glTextureType: r } = s.get(e);
    s.state.bindTexture(r, n), t.generateMipmap(r);
  }
  deallocateRenderBuffers(e) {
    const { gl: t, backend: s } = this;
    if (e) {
      const n = s.get(e);
      if (n.renderBufferStorageSetup = void 0, n.framebuffers) {
        for (const r in n.framebuffers)
          t.deleteFramebuffer(n.framebuffers[r]);
        delete n.framebuffers;
      }
      if (n.depthRenderbuffer && (t.deleteRenderbuffer(n.depthRenderbuffer), delete n.depthRenderbuffer), n.stencilRenderbuffer && (t.deleteRenderbuffer(n.stencilRenderbuffer), delete n.stencilRenderbuffer), n.msaaFrameBuffer && (t.deleteFramebuffer(n.msaaFrameBuffer), delete n.msaaFrameBuffer), n.msaaRenderbuffers) {
        for (let r = 0; r < n.msaaRenderbuffers.length; r++)
          t.deleteRenderbuffer(n.msaaRenderbuffers[r]);
        delete n.msaaRenderbuffers;
      }
    }
  }
  destroyTexture(e) {
    const { gl: t, backend: s } = this, { textureGPU: n, renderTarget: r } = s.get(e);
    this.deallocateRenderBuffers(r), t.deleteTexture(n), s.delete(e);
  }
  copyTextureToTexture(e, t, s = null, n = null, r = 0) {
    const { gl: i, backend: a } = this, { state: u } = this.backend, { textureGPU: c, glTextureType: l, glType: d, glFormat: h } = a.get(t);
    let p, f, m, _, S, A;
    s !== null ? (p = s.max.x - s.min.x, f = s.max.y - s.min.y, m = s.min.x, _ = s.min.y) : (p = e.image.width, f = e.image.height, m = 0, _ = 0), n !== null ? (S = n.x, A = n.y) : (S = 0, A = 0), u.bindTexture(l, c), i.pixelStorei(i.UNPACK_ALIGNMENT, t.unpackAlignment), i.pixelStorei(i.UNPACK_FLIP_Y_WEBGL, t.flipY), i.pixelStorei(i.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), i.pixelStorei(i.UNPACK_ALIGNMENT, t.unpackAlignment);
    const M = i.getParameter(i.UNPACK_ROW_LENGTH), F = i.getParameter(i.UNPACK_IMAGE_HEIGHT), D = i.getParameter(i.UNPACK_SKIP_PIXELS), P = i.getParameter(i.UNPACK_SKIP_ROWS), V = i.getParameter(i.UNPACK_SKIP_IMAGES), k = e.isCompressedTexture ? e.mipmaps[r] : e.image;
    if (i.pixelStorei(i.UNPACK_ROW_LENGTH, k.width), i.pixelStorei(i.UNPACK_IMAGE_HEIGHT, k.height), i.pixelStorei(i.UNPACK_SKIP_PIXELS, m), i.pixelStorei(i.UNPACK_SKIP_ROWS, _), e.isRenderTargetTexture || e.isDepthTexture) {
      const ie = a.get(e), me = a.get(t), ne = a.get(ie.renderTarget), Ke = a.get(me.renderTarget), Ye = ne.framebuffers[ie.cacheKey], wt = Ke.framebuffers[me.cacheKey];
      u.bindFramebuffer(i.READ_FRAMEBUFFER, Ye), u.bindFramebuffer(i.DRAW_FRAMEBUFFER, wt);
      let vs = i.COLOR_BUFFER_BIT;
      e.isDepthTexture && (vs = i.DEPTH_BUFFER_BIT), i.blitFramebuffer(m, _, p, f, S, A, p, f, vs, i.NEAREST), u.bindFramebuffer(i.READ_FRAMEBUFFER, null), u.bindFramebuffer(i.DRAW_FRAMEBUFFER, null);
    } else
      e.isDataTexture ? i.texSubImage2D(i.TEXTURE_2D, r, S, A, p, f, h, d, k.data) : e.isCompressedTexture ? i.compressedTexSubImage2D(i.TEXTURE_2D, r, S, A, k.width, k.height, h, k.data) : i.texSubImage2D(i.TEXTURE_2D, r, S, A, p, f, h, d, k);
    i.pixelStorei(i.UNPACK_ROW_LENGTH, M), i.pixelStorei(i.UNPACK_IMAGE_HEIGHT, F), i.pixelStorei(i.UNPACK_SKIP_PIXELS, D), i.pixelStorei(i.UNPACK_SKIP_ROWS, P), i.pixelStorei(i.UNPACK_SKIP_IMAGES, V), r === 0 && t.generateMipmaps && i.generateMipmap(i.TEXTURE_2D), u.unbindTexture();
  }
  copyFramebufferToTexture(e, t, s) {
    const { gl: n } = this, { state: r } = this.backend, { textureGPU: i } = this.backend.get(e), { x: a, y: u, z: c, w: l } = s, d = e.isDepthTexture === !0 || t.renderTarget && t.renderTarget.samples > 0, h = t.renderTarget ? t.renderTarget.height : this.backend.getDrawingBufferSize().y;
    if (d) {
      const p = a !== 0 || u !== 0;
      let f, m;
      if (e.isDepthTexture === !0 ? (f = n.DEPTH_BUFFER_BIT, m = n.DEPTH_ATTACHMENT, t.stencil && (f |= n.STENCIL_BUFFER_BIT)) : (f = n.COLOR_BUFFER_BIT, m = n.COLOR_ATTACHMENT0), p) {
        const _ = this.backend.get(t.renderTarget), S = _.framebuffers[t.getCacheKey()], A = _.msaaFrameBuffer;
        r.bindFramebuffer(n.DRAW_FRAMEBUFFER, S), r.bindFramebuffer(n.READ_FRAMEBUFFER, A);
        const M = h - u - l;
        n.blitFramebuffer(a, M, a + c, M + l, a, M, a + c, M + l, f, n.NEAREST), r.bindFramebuffer(n.READ_FRAMEBUFFER, S), r.bindTexture(n.TEXTURE_2D, i), n.copyTexSubImage2D(n.TEXTURE_2D, 0, 0, 0, a, M, c, l), r.unbindTexture();
      } else {
        const _ = n.createFramebuffer();
        r.bindFramebuffer(n.DRAW_FRAMEBUFFER, _), n.framebufferTexture2D(n.DRAW_FRAMEBUFFER, m, n.TEXTURE_2D, i, 0), n.blitFramebuffer(0, 0, c, l, 0, 0, c, l, f, n.NEAREST), n.deleteFramebuffer(_);
      }
    } else
      r.bindTexture(n.TEXTURE_2D, i), n.copyTexSubImage2D(n.TEXTURE_2D, 0, 0, 0, a, h - l - u, c, l), r.unbindTexture();
    e.generateMipmaps && this.generateMipmaps(e), this.backend._setFramebuffer(t);
  }
  // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
  setupRenderBufferStorage(e, t) {
    const { gl: s } = this, n = t.renderTarget, { samples: r, depthTexture: i, depthBuffer: a, stencilBuffer: u, width: c, height: l } = n;
    if (s.bindRenderbuffer(s.RENDERBUFFER, e), a && !u) {
      let d = s.DEPTH_COMPONENT24;
      r > 0 ? (i && i.isDepthTexture && i.type === s.FLOAT && (d = s.DEPTH_COMPONENT32F), s.renderbufferStorageMultisample(s.RENDERBUFFER, r, d, c, l)) : s.renderbufferStorage(s.RENDERBUFFER, d, c, l), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.DEPTH_ATTACHMENT, s.RENDERBUFFER, e);
    } else a && u && (r > 0 ? s.renderbufferStorageMultisample(s.RENDERBUFFER, r, s.DEPTH24_STENCIL8, c, l) : s.renderbufferStorage(s.RENDERBUFFER, s.DEPTH_STENCIL, c, l), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.DEPTH_STENCIL_ATTACHMENT, s.RENDERBUFFER, e));
  }
  async copyTextureToBuffer(e, t, s, n, r, i) {
    const { backend: a, gl: u } = this, { textureGPU: c, glFormat: l, glType: d } = this.backend.get(e), h = u.createFramebuffer();
    u.bindFramebuffer(u.READ_FRAMEBUFFER, h);
    const p = e.isCubeTexture ? u.TEXTURE_CUBE_MAP_POSITIVE_X + i : u.TEXTURE_2D;
    u.framebufferTexture2D(u.READ_FRAMEBUFFER, u.COLOR_ATTACHMENT0, p, c, 0);
    const f = this._getTypedArrayType(d), m = this._getBytesPerTexel(d, l), S = n * r * m, A = u.createBuffer();
    u.bindBuffer(u.PIXEL_PACK_BUFFER, A), u.bufferData(u.PIXEL_PACK_BUFFER, S, u.STREAM_READ), u.readPixels(t, s, n, r, l, d, 0), u.bindBuffer(u.PIXEL_PACK_BUFFER, null), await a.utils._clientWaitAsync();
    const M = new f(S / f.BYTES_PER_ELEMENT);
    return u.bindBuffer(u.PIXEL_PACK_BUFFER, A), u.getBufferSubData(u.PIXEL_PACK_BUFFER, 0, M), u.bindBuffer(u.PIXEL_PACK_BUFFER, null), u.deleteFramebuffer(h), M;
  }
  _getTypedArrayType(e) {
    const { gl: t } = this;
    if (e === t.UNSIGNED_BYTE) return Uint8Array;
    if (e === t.UNSIGNED_SHORT_4_4_4_4 || e === t.UNSIGNED_SHORT_5_5_5_1 || e === t.UNSIGNED_SHORT_5_6_5 || e === t.UNSIGNED_SHORT) return Uint16Array;
    if (e === t.UNSIGNED_INT) return Uint32Array;
    if (e === t.HALF_FLOAT) return Uint16Array;
    if (e === t.FLOAT) return Float32Array;
    throw new Error(`Unsupported WebGL type: ${e}`);
  }
  _getBytesPerTexel(e, t) {
    const { gl: s } = this;
    let n = 0;
    if (e === s.UNSIGNED_BYTE && (n = 1), (e === s.UNSIGNED_SHORT_4_4_4_4 || e === s.UNSIGNED_SHORT_5_5_5_1 || e === s.UNSIGNED_SHORT_5_6_5 || e === s.UNSIGNED_SHORT || e === s.HALF_FLOAT) && (n = 2), (e === s.UNSIGNED_INT || e === s.FLOAT) && (n = 4), t === s.RGBA) return n * 4;
    if (t === s.RGB) return n * 3;
    if (t === s.ALPHA) return n;
  }
}
class yA {
  constructor(e) {
    this.backend = e, this.gl = this.backend.gl, this.availableExtensions = this.gl.getSupportedExtensions(), this.extensions = {};
  }
  get(e) {
    let t = this.extensions[e];
    return t === void 0 && (t = this.gl.getExtension(e), this.extensions[e] = t), t;
  }
  has(e) {
    return this.availableExtensions.includes(e);
  }
}
class xA {
  constructor(e) {
    this.backend = e, this.maxAnisotropy = null;
  }
  getMaxAnisotropy() {
    if (this.maxAnisotropy !== null) return this.maxAnisotropy;
    const e = this.backend.gl, t = this.backend.extensions;
    if (t.has("EXT_texture_filter_anisotropic") === !0) {
      const s = t.get("EXT_texture_filter_anisotropic");
      this.maxAnisotropy = e.getParameter(s.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      this.maxAnisotropy = 0;
    return this.maxAnisotropy;
  }
}
const Bc = {
  WEBGL_multi_draw: "WEBGL_multi_draw",
  WEBGL_compressed_texture_astc: "texture-compression-astc",
  WEBGL_compressed_texture_etc: "texture-compression-etc2",
  WEBGL_compressed_texture_etc1: "texture-compression-etc1",
  WEBGL_compressed_texture_pvrtc: "texture-compression-pvrtc",
  WEBKIT_WEBGL_compressed_texture_pvrtc: "texture-compression-pvrtc",
  WEBGL_compressed_texture_s3tc: "texture-compression-bc",
  EXT_texture_compression_bptc: "texture-compression-bptc",
  EXT_disjoint_timer_query_webgl2: "timestamp-query"
};
class TA {
  constructor(e) {
    this.gl = e.gl, this.extensions = e.extensions, this.info = e.renderer.info, this.mode = null, this.index = 0, this.type = null, this.object = null;
  }
  render(e, t) {
    const { gl: s, mode: n, object: r, type: i, info: a, index: u } = this;
    u !== 0 ? s.drawElements(n, t, i, e) : s.drawArrays(n, e, t), a.update(r, t, n, 1);
  }
  renderInstances(e, t, s) {
    const { gl: n, mode: r, type: i, index: a, object: u, info: c } = this;
    s !== 0 && (a !== 0 ? n.drawElementsInstanced(r, t, i, e, s) : n.drawArraysInstanced(r, e, t, s), c.update(u, t, r, s));
  }
  renderMultiDraw(e, t, s) {
    const { extensions: n, mode: r, object: i, info: a } = this;
    if (s === 0) return;
    const u = n.get("WEBGL_multi_draw");
    if (u === null)
      for (let c = 0; c < s; c++)
        this.render(e[c], t[c]);
    else {
      this.index !== 0 ? u.multiDrawElementsWEBGL(r, t, 0, this.type, e, 0, s) : u.multiDrawArraysWEBGL(r, e, 0, t, 0, s);
      let c = 0;
      for (let l = 0; l < s; l++)
        c += t[l];
      a.update(i, c, r, 1);
    }
  }
  renderMultiDrawInstances(e, t, s, n) {
    const { extensions: r, mode: i, object: a, info: u } = this;
    if (s === 0) return;
    const c = r.get("WEBGL_multi_draw");
    if (c === null)
      for (let l = 0; l < s; l++)
        this.renderInstances(e[l], t[l], n[l]);
    else {
      this.index !== 0 ? c.multiDrawElementsInstancedWEBGL(i, t, 0, this.type, e, 0, n, 0, s) : c.multiDrawArraysInstancedWEBGL(i, e, 0, t, 0, n, 0, s);
      let l = 0;
      for (let d = 0; d < s; d++)
        l += t[d] * n[d];
      u.update(a, l, i, 1);
    }
  }
  //
}
class Fc extends sg {
  /**
   * Constructs a new WebGPU backend.
   *
   * @param {Object} parameters - The configuration parameter.
   * @param {Boolean} [parameters.logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @param {Boolean} [parameters.alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @param {Boolean} [parameters.depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @param {Boolean} [parameters.stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @param {Boolean} [parameters.antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @param {Number} [parameters.samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
   * @param {Boolean} [parameters.forceWebGL=false] - If set to `true`, the renderer uses it WebGL 2 backend no matter if WebGPU is supported or not.
   * @param {WebGL2RenderingContext} [parameters.context=undefined] - A WebGL 2 rendering context.
   */
  constructor(e = {}) {
    super(e), this.isWebGLBackend = !0, this.attributeUtils = null, this.extensions = null, this.capabilities = null, this.textureUtils = null, this.bufferRenderer = null, this.gl = null, this.state = null, this.utils = null, this.vaoCache = {}, this.transformFeedbackCache = {}, this.discard = !1, this.disjoint = null, this.parallel = null, this.trackTimestamp = e.trackTimestamp === !0, this._currentContext = null, this._knownBindings = /* @__PURE__ */ new WeakSet();
  }
  /**
   * Initializes the backend so it is ready for usage.
   *
   * @param {Renderer} renderer - The renderer.
   */
  init(e) {
    super.init(e);
    const t = this.parameters, s = t.context !== void 0 ? t.context : e.domElement.getContext("webgl2");
    function n(r) {
      r.preventDefault();
      const i = {
        api: "WebGL",
        message: r.statusMessage || "Unknown reason",
        reason: null,
        originalEvent: r
      };
      e.onDeviceLost(i);
    }
    this._onContextLost = n, e.domElement.addEventListener("webglcontextlost", n, !1), this.gl = s, this.extensions = new yA(this), this.capabilities = new xA(this), this.attributeUtils = new pA(this), this.textureUtils = new mA(this), this.bufferRenderer = new TA(this), this.state = new fA(this), this.utils = new gA(this), this.extensions.get("EXT_color_buffer_float"), this.extensions.get("WEBGL_clip_cull_distance"), this.extensions.get("OES_texture_float_linear"), this.extensions.get("EXT_color_buffer_half_float"), this.extensions.get("WEBGL_multisampled_render_to_texture"), this.extensions.get("WEBGL_render_shared_exponent"), this.extensions.get("WEBGL_multi_draw"), this.disjoint = this.extensions.get("EXT_disjoint_timer_query_webgl2"), this.parallel = this.extensions.get("KHR_parallel_shader_compile");
  }
  /**
   * The coordinate system of the backend.
   *
   * @type {Number}
   * @readonly
   */
  get coordinateSystem() {
    return En;
  }
  /**
   * Transfers buffer data from a storage buffer attribute
   * from the GPU to the CPU in context of compute shaders.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */
  async getArrayBufferAsync(e) {
    return await this.attributeUtils.getArrayBufferAsync(e);
  }
  /**
   * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
   * the CPU waits for the GPU to complete its operation (e.g. a compute task).
   *
   * @async
   * @return {Promise} A Promise that resolves when synchronization has been finished.
   */
  async waitForGPU() {
    await this.utils._clientWaitAsync();
  }
  /**
   * Inits a time stamp query for the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  initTimestampQuery(e) {
    if (!this.disjoint || !this.trackTimestamp) return;
    const t = this.get(e);
    if (this.queryRunning) {
      t.queryQueue || (t.queryQueue = []), t.queryQueue.push(e);
      return;
    }
    t.activeQuery && (this.gl.endQuery(this.disjoint.TIME_ELAPSED_EXT), t.activeQuery = null), t.activeQuery = this.gl.createQuery(), t.activeQuery !== null && (this.gl.beginQuery(this.disjoint.TIME_ELAPSED_EXT, t.activeQuery), this.queryRunning = !0);
  }
  // timestamp utils
  /**
   * Prepares the timestamp buffer.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  prepareTimestampBuffer(e) {
    if (!this.disjoint || !this.trackTimestamp) return;
    const t = this.get(e);
    if (t.activeQuery && (this.gl.endQuery(this.disjoint.TIME_ELAPSED_EXT), t.gpuQueries || (t.gpuQueries = []), t.gpuQueries.push({ query: t.activeQuery }), t.activeQuery = null, this.queryRunning = !1, t.queryQueue && t.queryQueue.length > 0)) {
      const s = t.queryQueue.shift();
      this.initTimestampQuery(s);
    }
  }
  /**
   * Resolves the time stamp for the given render context and type.
   *
   * @async
   * @param {RenderContext} renderContext - The render context.
   * @param {String} type - The render context.
   * @return {Promise} A Promise that resolves when the time stamp has been computed.
   */
  async resolveTimestampAsync(e, t = "render") {
    if (!this.disjoint || !this.trackTimestamp) return;
    const s = this.get(e);
    s.gpuQueries || (s.gpuQueries = []);
    for (let n = 0; n < s.gpuQueries.length; n++) {
      const r = s.gpuQueries[n], i = this.gl.getQueryParameter(r.query, this.gl.QUERY_RESULT_AVAILABLE), a = this.gl.getParameter(this.disjoint.GPU_DISJOINT_EXT);
      if (i && !a) {
        const u = this.gl.getQueryParameter(r.query, this.gl.QUERY_RESULT), c = Number(u) / 1e6;
        this.gl.deleteQuery(r.query), s.gpuQueries.splice(n, 1), n--, this.renderer.info.updateTimestamp(t, c);
      }
    }
  }
  /**
   * Returns the backend's rendering context.
   *
   * @return {WebGL2RenderingContext} The rendering context.
   */
  getContext() {
    return this.gl;
  }
  /**
   * This method is executed at the beginning of a render call and prepares
   * the WebGL state for upcoming render calls
   *
   * @param {RenderContext} renderContext - The render context.
   */
  beginRender(e) {
    const { gl: t } = this, s = this.get(e);
    if (this.initTimestampQuery(e), s.previousContext = this._currentContext, this._currentContext = e, this._setFramebuffer(e), this.clear(e.clearColor, e.clearDepth, e.clearStencil, e, !1), e.viewport ? this.updateViewport(e) : t.viewport(0, 0, t.drawingBufferWidth, t.drawingBufferHeight), e.scissor) {
      const { x: r, y: i, width: a, height: u } = e.scissorValue;
      t.scissor(r, e.height - u - i, a, u);
    }
    const n = e.occlusionQueryCount;
    n > 0 && (s.currentOcclusionQueries = s.occlusionQueries, s.currentOcclusionQueryObjects = s.occlusionQueryObjects, s.lastOcclusionObject = null, s.occlusionQueries = new Array(n), s.occlusionQueryObjects = new Array(n), s.occlusionQueryIndex = 0);
  }
  /**
   * This method is executed at the end of a render call and finalizes work
   * after draw calls.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  finishRender(e) {
    const { gl: t, state: s } = this, n = this.get(e), r = n.previousContext, i = e.occlusionQueryCount;
    i > 0 && (i > n.occlusionQueryIndex && t.endQuery(t.ANY_SAMPLES_PASSED), this.resolveOccludedAsync(e));
    const a = e.textures;
    if (a !== null)
      for (let u = 0; u < a.length; u++) {
        const c = a[u];
        c.generateMipmaps && this.generateMipmaps(c);
      }
    if (this._currentContext = r, e.textures !== null && e.renderTarget) {
      const u = this.get(e.renderTarget), { samples: c } = e.renderTarget;
      if (c > 0) {
        const l = u.framebuffers[e.getCacheKey()], d = t.COLOR_BUFFER_BIT, h = u.msaaFrameBuffer, p = e.textures;
        s.bindFramebuffer(t.READ_FRAMEBUFFER, h), s.bindFramebuffer(t.DRAW_FRAMEBUFFER, l);
        for (let f = 0; f < p.length; f++)
          if (e.scissor) {
            const { x: m, y: _, width: S, height: A } = e.scissorValue, M = e.height - A - _;
            t.blitFramebuffer(m, M, m + S, M + A, m, M, m + S, M + A, d, t.NEAREST), t.invalidateSubFramebuffer(t.READ_FRAMEBUFFER, u.invalidationArray, m, M, S, A);
          } else
            t.blitFramebuffer(0, 0, e.width, e.height, 0, 0, e.width, e.height, d, t.NEAREST), t.invalidateFramebuffer(t.READ_FRAMEBUFFER, u.invalidationArray);
      }
    }
    r !== null && (this._setFramebuffer(r), r.viewport ? this.updateViewport(r) : t.viewport(0, 0, t.drawingBufferWidth, t.drawingBufferHeight)), this.prepareTimestampBuffer(e);
  }
  /**
   * This method processes the result of occlusion queries and writes it
   * into render context data.
   *
   * @async
   * @param {RenderContext} renderContext - The render context.
   */
  resolveOccludedAsync(e) {
    const t = this.get(e), { currentOcclusionQueries: s, currentOcclusionQueryObjects: n } = t;
    if (s && n) {
      const r = /* @__PURE__ */ new WeakSet(), { gl: i } = this;
      t.currentOcclusionQueryObjects = null, t.currentOcclusionQueries = null;
      const a = () => {
        let u = 0;
        for (let c = 0; c < s.length; c++) {
          const l = s[c];
          l !== null && i.getQueryParameter(l, i.QUERY_RESULT_AVAILABLE) && (i.getQueryParameter(l, i.QUERY_RESULT) > 0 && r.add(n[c]), s[c] = null, i.deleteQuery(l), u++);
        }
        u < s.length ? requestAnimationFrame(a) : t.occluded = r;
      };
      a();
    }
  }
  /**
   * Returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object3D} object - The 3D object to test.
   * @return {Boolean} Whether the 3D object is fully occluded or not.
   */
  isOccluded(e, t) {
    const s = this.get(e);
    return s.occluded && s.occluded.has(t);
  }
  /**
   * Updates the viewport with the values from the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  updateViewport(e) {
    const t = this.gl, { x: s, y: n, width: r, height: i } = e.viewportValue;
    t.viewport(s, e.height - i - n, r, i);
  }
  /**
   * Defines the scissor test.
   *
   * @param {Boolean} boolean - Whether the scissor test should be enabled or not.
   */
  setScissorTest(e) {
    const t = this.gl;
    e ? t.enable(t.SCISSOR_TEST) : t.disable(t.SCISSOR_TEST);
  }
  /**
   * Performs a clear operation.
   *
   * @param {Boolean} color - Whether the color buffer should be cleared or not.
   * @param {Boolean} depth - Whether the depth buffer should be cleared or not.
   * @param {Boolean} stencil - Whether the stencil buffer should be cleared or not.
   * @param {Object?} [descriptor=null] - The render context of the current set render target.
   * @param {Boolean} [setFrameBuffer=true] - TODO.
   */
  clear(e, t, s, n = null, r = !0) {
    const { gl: i } = this;
    if (n === null) {
      const u = this.getClearColor();
      u.r *= u.a, u.g *= u.a, u.b *= u.a, n = {
        textures: null,
        clearColorValue: u
      };
    }
    let a = 0;
    if (e && (a |= i.COLOR_BUFFER_BIT), t && (a |= i.DEPTH_BUFFER_BIT), s && (a |= i.STENCIL_BUFFER_BIT), a !== 0) {
      let u;
      if (n.clearColorValue ? u = n.clearColorValue : (u = this.getClearColor(), u.r *= u.a, u.g *= u.a, u.b *= u.a), t && this.state.setDepthMask(!0), n.textures === null)
        i.clearColor(u.r, u.g, u.b, u.a), i.clear(a);
      else {
        if (r && this._setFramebuffer(n), e)
          for (let c = 0; c < n.textures.length; c++)
            i.clearBufferfv(i.COLOR, c, [u.r, u.g, u.b, u.a]);
        t && s ? i.clearBufferfi(i.DEPTH_STENCIL, 0, 1, 0) : t ? i.clearBufferfv(i.DEPTH, 0, [1]) : s && i.clearBufferiv(i.STENCIL, 0, [0]);
      }
    }
  }
  /**
   * This method is executed at the beginning of a compute call and
   * prepares the state for upcoming compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */
  beginCompute(e) {
    const { state: t, gl: s } = this;
    t.bindFramebuffer(s.FRAMEBUFFER, null), this.initTimestampQuery(e);
  }
  /**
   * Executes a compute command for the given compute node.
   *
   * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {ComputePipeline} pipeline - The compute pipeline.
   */
  compute(e, t, s, n) {
    const { state: r, gl: i } = this;
    this.discard === !1 && (i.enable(i.RASTERIZER_DISCARD), this.discard = !0);
    const { programGPU: a, transformBuffers: u, attributes: c } = this.get(n), l = this._getVaoKey(null, c), d = this.vaoCache[l];
    d === void 0 ? this._createVao(null, c) : i.bindVertexArray(d), r.useProgram(a), this._bindUniforms(s);
    const h = this._getTransformFeedback(u);
    i.bindTransformFeedback(i.TRANSFORM_FEEDBACK, h), i.beginTransformFeedback(i.POINTS), c[0].isStorageInstancedBufferAttribute ? i.drawArraysInstanced(i.POINTS, 0, 1, t.count) : i.drawArrays(i.POINTS, 0, t.count), i.endTransformFeedback(), i.bindTransformFeedback(i.TRANSFORM_FEEDBACK, null);
    for (let p = 0; p < u.length; p++) {
      const f = u[p];
      f.pbo && this.textureUtils.copyBufferToTexture(f.transformBuffer, f.pbo), f.switchBuffers();
    }
  }
  /**
   * This method is executed at the end of a compute call and
   * finalizes work after compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */
  finishCompute(e) {
    const t = this.gl;
    this.discard = !1, t.disable(t.RASTERIZER_DISCARD), this.prepareTimestampBuffer(e), this._currentContext && this._setFramebuffer(this._currentContext);
  }
  /**
   * Executes a draw command for the given render object.
   *
   * @param {RenderObject} renderObject - The render object to draw.
   * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
   */
  draw(e) {
    const { object: t, pipeline: s, material: n, context: r, hardwareClippingPlanes: i } = e, { programGPU: a } = this.get(s), { gl: u, state: c } = this, l = this.get(r), d = e.getDrawParameters();
    if (d === null) return;
    this._bindUniforms(e.getBindings());
    const h = t.isMesh && t.matrixWorld.determinant() < 0;
    c.setMaterial(n, h, i), c.useProgram(a);
    const p = this.get(e);
    let f = p.staticVao;
    if (f === void 0 || p.geometryId !== e.geometry.id) {
      const D = this._getVaoKey(e.getIndex(), e.getAttributes());
      if (f = this.vaoCache[D], f === void 0) {
        let P;
        ({ vaoGPU: f, staticVao: P } = this._createVao(e.getIndex(), e.getAttributes())), P && (p.staticVao = f, p.geometryId = e.geometry.id);
      }
    }
    u.bindVertexArray(f);
    const m = e.getIndex(), _ = l.lastOcclusionObject;
    if (_ !== t && _ !== void 0) {
      if (_ !== null && _.occlusionTest === !0 && (u.endQuery(u.ANY_SAMPLES_PASSED), l.occlusionQueryIndex++), t.occlusionTest === !0) {
        const D = u.createQuery();
        u.beginQuery(u.ANY_SAMPLES_PASSED, D), l.occlusionQueries[l.occlusionQueryIndex] = D, l.occlusionQueryObjects[l.occlusionQueryIndex] = t;
      }
      l.lastOcclusionObject = t;
    }
    const S = this.bufferRenderer;
    t.isPoints ? S.mode = u.POINTS : t.isLineSegments ? S.mode = u.LINES : t.isLine ? S.mode = u.LINE_STRIP : t.isLineLoop ? S.mode = u.LINE_LOOP : n.wireframe === !0 ? (c.setLineWidth(n.wireframeLinewidth * this.renderer.getPixelRatio()), S.mode = u.LINES) : S.mode = u.TRIANGLES;
    const { vertexCount: A, instanceCount: M } = d;
    let { firstVertex: F } = d;
    if (S.object = t, m !== null) {
      F *= m.array.BYTES_PER_ELEMENT;
      const D = this.get(m);
      S.index = m.count, S.type = D.type;
    } else
      S.index = 0;
    t.isBatchedMesh ? t._multiDrawInstances !== null ? S.renderMultiDrawInstances(t._multiDrawStarts, t._multiDrawCounts, t._multiDrawCount, t._multiDrawInstances) : this.hasFeature("WEBGL_multi_draw") ? S.renderMultiDraw(t._multiDrawStarts, t._multiDrawCounts, t._multiDrawCount) : cg("THREE.WebGLRenderer: WEBGL_multi_draw not supported.") : M > 1 ? S.renderInstances(F, A, M) : S.render(F, A), u.bindVertexArray(null);
  }
  /**
   * Explain why always null is returned.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the render pipeline requires an update or not.
   */
  needsRenderUpdate() {
    return !1;
  }
  /**
   * Explain why no cache key is computed.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {String} The cache key.
   */
  getRenderCacheKey() {
    return "";
  }
  // textures
  /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @param {Texture} texture - The texture to create a default texture for.
   */
  createDefaultTexture(e) {
    this.textureUtils.createDefaultTexture(e);
  }
  /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */
  createTexture(e, t) {
    this.textureUtils.createTexture(e, t);
  }
  /**
   * Uploads the updated texture data to the GPU.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */
  updateTexture(e, t) {
    this.textureUtils.updateTexture(e, t);
  }
  /**
   * Generates mipmaps for the given texture
   *
   * @param {Texture} texture - The texture.
   */
  generateMipmaps(e) {
    this.textureUtils.generateMipmaps(e);
  }
  /**
   * Destroys the GPU data for the given texture object.
   *
   * @param {Texture} texture - The texture.
   */
  destroyTexture(e) {
    this.textureUtils.destroyTexture(e);
  }
  /**
   * Returns texture data as a typed array.
   *
   * @param {Texture} texture - The texture to copy.
   * @param {Number} x - The x coordinate of the copy origin.
   * @param {Number} y - The y coordinate of the copy origin.
   * @param {Number} width - The width of the copy.
   * @param {Number} height - The height of the copy.
   * @param {Number} faceIndex - The face index.
   * @return {TypedArray} The texture data as a typed array.
   */
  copyTextureToBuffer(e, t, s, n, r, i) {
    return this.textureUtils.copyTextureToBuffer(e, t, s, n, r, i);
  }
  /**
   * This method does nothing since WebGL 2 has no concept of samplers.
   *
   * @param {Texture} texture - The texture to create the sampler for.
   */
  createSampler() {
  }
  /**
   * This method does nothing since WebGL 2 has no concept of samplers.
   *
   * @param {Texture} texture - The texture to destroy the sampler for.
   */
  destroySampler() {
  }
  // node builder
  /**
   * Returns a node builder for the given render object.
   *
   * @param {RenderObject} object - The render object.
   * @param {Renderer} renderer - The renderer.
   * @return {GLSLNodeBuilder} The node builder.
   */
  createNodeBuilder(e, t) {
    return new lA(e, t);
  }
  // program
  /**
   * Creates a shader program from the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */
  createProgram(e) {
    const t = this.gl, { stage: s, code: n } = e, r = s === "fragment" ? t.createShader(t.FRAGMENT_SHADER) : t.createShader(t.VERTEX_SHADER);
    t.shaderSource(r, n), t.compileShader(r), this.set(e, {
      shaderGPU: r
    });
  }
  /**
   * Destroys the shader program of the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */
  destroyProgram(e) {
    this.delete(e);
  }
  /**
   * Creates a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */
  createRenderPipeline(e, t) {
    const s = this.gl, n = e.pipeline, { fragmentProgram: r, vertexProgram: i } = n, a = s.createProgram(), u = this.get(r).shaderGPU, c = this.get(i).shaderGPU;
    if (s.attachShader(a, u), s.attachShader(a, c), s.linkProgram(a), this.set(n, {
      programGPU: a,
      fragmentShader: u,
      vertexShader: c
    }), t !== null && this.parallel) {
      const l = new Promise((d) => {
        const h = this.parallel, p = () => {
          s.getProgramParameter(a, h.COMPLETION_STATUS_KHR) ? (this._completeCompile(e, n), d()) : requestAnimationFrame(p);
        };
        p();
      });
      t.push(l);
      return;
    }
    this._completeCompile(e, n);
  }
  /**
   * Formats the source code of error messages.
   *
   * @private
   * @param {String} string - The code.
   * @param {Number} errorLine - The error line.
   * @return {String} The formatted code.
   */
  _handleSource(e, t) {
    const s = e.split(`
`), n = [], r = Math.max(t - 6, 0), i = Math.min(t + 6, s.length);
    for (let a = r; a < i; a++) {
      const u = a + 1;
      n.push(`${u === t ? ">" : " "} ${u}: ${s[a]}`);
    }
    return n.join(`
`);
  }
  /**
   * Gets the shader compilation errors from the info log.
   *
   * @private
   * @param {WebGL2RenderingContext} gl - The rendering context.
   * @param {WebGLShader} shader - The WebGL shader object.
   * @param {String} type - The shader type.
   * @return {String} The shader errors.
   */
  _getShaderErrors(e, t, s) {
    const n = e.getShaderParameter(t, e.COMPILE_STATUS), r = e.getShaderInfoLog(t).trim();
    if (n && r === "") return "";
    const i = /ERROR: 0:(\d+)/.exec(r);
    if (i) {
      const a = parseInt(i[1]);
      return s.toUpperCase() + `

` + r + `

` + this._handleSource(e.getShaderSource(t), a);
    } else
      return r;
  }
  /**
   * Logs shader compilation errors.
   *
   * @private
   * @param {WebGLProgram} programGPU - The WebGL program.
   * @param {WebGLShader} glFragmentShader - The fragment shader as a native WebGL shader object.
   * @param {WebGLShader} glVertexShader - The vertex shader as a native WebGL shader object.
   */
  _logProgramError(e, t, s) {
    if (this.renderer.debug.checkShaderErrors) {
      const n = this.gl, r = n.getProgramInfoLog(e).trim();
      if (n.getProgramParameter(e, n.LINK_STATUS) === !1)
        if (typeof this.renderer.debug.onShaderError == "function")
          this.renderer.debug.onShaderError(n, e, s, t);
        else {
          const i = this._getShaderErrors(n, s, "vertex"), a = this._getShaderErrors(n, t, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + n.getError() + " - VALIDATE_STATUS " + n.getProgramParameter(e, n.VALIDATE_STATUS) + `

Program Info Log: ` + r + `
` + i + `
` + a
          );
        }
      else r !== "" && console.warn("THREE.WebGLProgram: Program Info Log:", r);
    }
  }
  /**
   * Completes the shader program setup for the given render object.
   *
   * @private
   * @param {RenderObject} renderObject - The render object.
   * @param {RenderPipeline} pipeline - The render pipeline.
   */
  _completeCompile(e, t) {
    const { state: s, gl: n } = this, r = this.get(t), { programGPU: i, fragmentShader: a, vertexShader: u } = r;
    n.getProgramParameter(i, n.LINK_STATUS) === !1 && this._logProgramError(i, a, u), s.useProgram(i);
    const c = e.getBindings();
    this._setupBindings(c, i), this.set(t, {
      programGPU: i
    });
  }
  /**
   * Creates a compute pipeline for the given compute node.
   *
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */
  createComputePipeline(e, t) {
    const { state: s, gl: n } = this, r = {
      stage: "fragment",
      code: `#version 300 es
precision highp float;
void main() {}`
    };
    this.createProgram(r);
    const { computeProgram: i } = e, a = n.createProgram(), u = this.get(r).shaderGPU, c = this.get(i).shaderGPU, l = i.transforms, d = [], h = [];
    for (let _ = 0; _ < l.length; _++) {
      const S = l[_];
      d.push(S.varyingName), h.push(S.attributeNode);
    }
    n.attachShader(a, u), n.attachShader(a, c), n.transformFeedbackVaryings(
      a,
      d,
      n.SEPARATE_ATTRIBS
    ), n.linkProgram(a), n.getProgramParameter(a, n.LINK_STATUS) === !1 && this._logProgramError(a, u, c), s.useProgram(a), this._setupBindings(t, a);
    const p = i.attributes, f = [], m = [];
    for (let _ = 0; _ < p.length; _++) {
      const S = p[_].node.attribute;
      f.push(S), this.has(S) || this.attributeUtils.createAttribute(S, n.ARRAY_BUFFER);
    }
    for (let _ = 0; _ < h.length; _++) {
      const S = h[_].attribute;
      this.has(S) || this.attributeUtils.createAttribute(S, n.ARRAY_BUFFER);
      const A = this.get(S);
      m.push(A);
    }
    this.set(e, {
      programGPU: a,
      transformBuffers: m,
      attributes: f
    });
  }
  /**
   * Creates bindings from the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {Number} cacheIndex - The cache index.
   * @param {Number} version - The version.
   */
  createBindings(e, t) {
    if (this._knownBindings.has(t) === !1) {
      this._knownBindings.add(t);
      let s = 0, n = 0;
      for (const r of t) {
        this.set(r, {
          textures: n,
          uniformBuffers: s
        });
        for (const i of r.bindings)
          i.isUniformBuffer && s++, i.isSampledTexture && n++;
      }
    }
    this.updateBindings(e, t);
  }
  /**
   * Updates the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {Number} cacheIndex - The cache index.
   * @param {Number} version - The version.
   */
  updateBindings(e) {
    const { gl: t } = this, s = this.get(e);
    let n = s.uniformBuffers, r = s.textures;
    for (const i of e.bindings)
      if (i.isUniformsGroup || i.isUniformBuffer) {
        const a = i.buffer, u = t.createBuffer();
        t.bindBuffer(t.UNIFORM_BUFFER, u), t.bufferData(t.UNIFORM_BUFFER, a, t.DYNAMIC_DRAW), this.set(i, {
          index: n++,
          bufferGPU: u
        });
      } else if (i.isSampledTexture) {
        const { textureGPU: a, glTextureType: u } = this.get(i.texture);
        this.set(i, {
          index: r++,
          textureGPU: a,
          glTextureType: u
        });
      }
  }
  /**
   * Updates a buffer binding.
   *
   *  @param {Buffer} binding - The buffer binding to update.
   */
  updateBinding(e) {
    const t = this.gl;
    if (e.isUniformsGroup || e.isUniformBuffer) {
      const n = this.get(e).bufferGPU, r = e.buffer;
      t.bindBuffer(t.UNIFORM_BUFFER, n), t.bufferData(t.UNIFORM_BUFFER, r, t.DYNAMIC_DRAW);
    }
  }
  // attributes
  /**
   * Creates the buffer of an indexed shader attribute.
   *
   * @param {BufferAttribute} attribute - The indexed buffer attribute.
   */
  createIndexAttribute(e) {
    const t = this.gl;
    this.attributeUtils.createAttribute(e, t.ELEMENT_ARRAY_BUFFER);
  }
  /**
   * Creates the buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createAttribute(e) {
    if (this.has(e)) return;
    const t = this.gl;
    this.attributeUtils.createAttribute(e, t.ARRAY_BUFFER);
  }
  /**
   * Creates the buffer of a storage attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createStorageAttribute(e) {
    if (this.has(e)) return;
    const t = this.gl;
    this.attributeUtils.createAttribute(e, t.ARRAY_BUFFER);
  }
  /**
   * Updates the buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to update.
   */
  updateAttribute(e) {
    this.attributeUtils.updateAttribute(e);
  }
  /**
   * Destroys the buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to destroy.
   */
  destroyAttribute(e) {
    this.attributeUtils.destroyAttribute(e);
  }
  /**
   * Checks if the given feature is supported  by the backend.
   *
   * @param {String} name - The feature's name.
   * @return {Boolean} Whether the feature is supported or not.
   */
  hasFeature(e) {
    const t = Object.keys(Bc).filter((n) => Bc[n] === e), s = this.extensions;
    for (let n = 0; n < t.length; n++)
      if (s.has(t[n])) return !0;
    return !1;
  }
  /**
   * Returns the maximum anisotropy texture filtering value.
   *
   * @return {Number} The maximum anisotropy texture filtering value.
   */
  getMaxAnisotropy() {
    return this.capabilities.getMaxAnisotropy();
  }
  /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {Vector4?} [srcRegion=null] - The region of the source texture to copy.
   * @param {(Vector2|Vector3)?} [dstPosition=null] - The destination position of the copy.
   * @param {Number} [level=0] - The mip level to copy.
   */
  copyTextureToTexture(e, t, s = null, n = null, r = 0) {
    this.textureUtils.copyTextureToTexture(e, t, s, n, r);
  }
  /**
   * Copies the current bound framebuffer to the given texture.
   *
   * @param {Texture} texture - The destination texture.
   * @param {RenderContext} renderContext - The render context.
   * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
   */
  copyFramebufferToTexture(e, t, s) {
    this.textureUtils.copyFramebufferToTexture(e, t, s);
  }
  /**
   * Configures the active framebuffer from the given render context.
   *
   * @private
   * @param {RenderContext} descriptor - The render context.
   */
  _setFramebuffer(e) {
    const { gl: t, state: s } = this;
    let n = null;
    if (e.textures !== null) {
      const r = e.renderTarget, i = this.get(r), { samples: a, depthBuffer: u, stencilBuffer: c } = r, l = r.isWebGLCubeRenderTarget === !0, d = r.isRenderTarget3D === !0, h = r.isRenderTargetArray === !0;
      let p = i.msaaFrameBuffer, f = i.depthRenderbuffer;
      const m = Qp(e);
      let _;
      if (l ? (i.cubeFramebuffers || (i.cubeFramebuffers = {}), _ = i.cubeFramebuffers[m]) : (i.framebuffers || (i.framebuffers = {}), _ = i.framebuffers[m]), _ === void 0) {
        _ = t.createFramebuffer(), s.bindFramebuffer(t.FRAMEBUFFER, _);
        const S = e.textures;
        if (l) {
          i.cubeFramebuffers[m] = _;
          const { textureGPU: A } = this.get(S[0]), M = this.renderer._activeCubeFace;
          t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_CUBE_MAP_POSITIVE_X + M, A, 0);
        } else {
          i.framebuffers[m] = _;
          for (let A = 0; A < S.length; A++) {
            const M = S[A], F = this.get(M);
            F.renderTarget = e.renderTarget, F.cacheKey = m;
            const D = t.COLOR_ATTACHMENT0 + A;
            if (d || h) {
              const P = this.renderer._activeCubeFace;
              t.framebufferTextureLayer(t.FRAMEBUFFER, D, F.textureGPU, 0, P);
            } else
              t.framebufferTexture2D(t.FRAMEBUFFER, D, t.TEXTURE_2D, F.textureGPU, 0);
          }
          s.drawBuffers(e, _);
        }
        if (e.depthTexture !== null) {
          const A = this.get(e.depthTexture), M = c ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
          A.renderTarget = e.renderTarget, A.cacheKey = m, t.framebufferTexture2D(t.FRAMEBUFFER, M, t.TEXTURE_2D, A.textureGPU, 0);
        }
      }
      if (a > 0) {
        if (p === void 0) {
          const S = [];
          p = t.createFramebuffer(), s.bindFramebuffer(t.FRAMEBUFFER, p);
          const A = [], M = e.textures;
          for (let F = 0; F < M.length; F++) {
            if (A[F] = t.createRenderbuffer(), t.bindRenderbuffer(t.RENDERBUFFER, A[F]), S.push(t.COLOR_ATTACHMENT0 + F), u) {
              const V = c ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
              S.push(V);
            }
            const D = e.textures[F], P = this.get(D);
            t.renderbufferStorageMultisample(t.RENDERBUFFER, a, P.glInternalFormat, e.width, e.height), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0 + F, t.RENDERBUFFER, A[F]);
          }
          if (i.msaaFrameBuffer = p, i.msaaRenderbuffers = A, f === void 0) {
            f = t.createRenderbuffer(), this.textureUtils.setupRenderBufferStorage(f, e), i.depthRenderbuffer = f;
            const F = c ? t.DEPTH_STENCIL_ATTACHMENT : t.DEPTH_ATTACHMENT;
            S.push(F);
          }
          i.invalidationArray = S;
        }
        n = i.msaaFrameBuffer;
      } else
        n = _;
    }
    s.bindFramebuffer(t.FRAMEBUFFER, n);
  }
  /**
   * Computes the VAO key for the given index and attributes.
   *
   * @private
   * @param {BufferAttribute?} index - The index. `null` for non-indexed geometries.
   * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
   * @return {String} The VAO key.
   */
  _getVaoKey(e, t) {
    let s = "";
    if (e !== null) {
      const n = this.get(e);
      s += ":" + n.id;
    }
    for (let n = 0; n < t.length; n++) {
      const r = this.get(t[n]);
      s += ":" + r.id;
    }
    return s;
  }
  /**
   * Creates a VAO from the index and attributes.
   *
   * @private
   * @param {BufferAttribute?} index - The index. `null` for non-indexed geometries.
   * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
   * @return {Object} The VAO data.
   */
  _createVao(e, t) {
    const { gl: s } = this, n = s.createVertexArray();
    let r = "", i = !0;
    if (s.bindVertexArray(n), e !== null) {
      const a = this.get(e);
      s.bindBuffer(s.ELEMENT_ARRAY_BUFFER, a.bufferGPU), r += ":" + a.id;
    }
    for (let a = 0; a < t.length; a++) {
      const u = t[a], c = this.get(u);
      r += ":" + c.id, s.bindBuffer(s.ARRAY_BUFFER, c.bufferGPU), s.enableVertexAttribArray(a), (u.isStorageBufferAttribute || u.isStorageInstancedBufferAttribute) && (i = !1);
      let l, d;
      u.isInterleavedBufferAttribute === !0 ? (l = u.data.stride * c.bytesPerElement, d = u.offset * c.bytesPerElement) : (l = 0, d = 0), c.isInteger ? s.vertexAttribIPointer(a, u.itemSize, c.type, l, d) : s.vertexAttribPointer(a, u.itemSize, c.type, u.normalized, l, d), u.isInstancedBufferAttribute && !u.isInterleavedBufferAttribute ? s.vertexAttribDivisor(a, u.meshPerAttribute) : u.isInterleavedBufferAttribute && u.data.isInstancedInterleavedBuffer && s.vertexAttribDivisor(a, u.data.meshPerAttribute);
    }
    return s.bindBuffer(s.ARRAY_BUFFER, null), this.vaoCache[r] = n, { vaoGPU: n, staticVao: i };
  }
  /**
   * Creates a tranform feedback from the given transform buffers.
   *
   * @private
   * @param {Array<DualAttributeData>} transformBuffers - The tranform buffers.
   * @return {WebGLTransformFeedback} The tranform feedback.
   */
  _getTransformFeedback(e) {
    let t = "";
    for (let r = 0; r < e.length; r++)
      t += ":" + e[r].id;
    let s = this.transformFeedbackCache[t];
    if (s !== void 0)
      return s;
    const { gl: n } = this;
    s = n.createTransformFeedback(), n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, s);
    for (let r = 0; r < e.length; r++) {
      const i = e[r];
      n.bindBufferBase(n.TRANSFORM_FEEDBACK_BUFFER, r, i.transformBuffer);
    }
    return n.bindTransformFeedback(n.TRANSFORM_FEEDBACK, null), this.transformFeedbackCache[t] = s, s;
  }
  /**
   * Setups the given bindings.
   *
   * @private
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {WebGLProgram} programGPU - The WebGL program.
   */
  _setupBindings(e, t) {
    const s = this.gl;
    for (const n of e)
      for (const r of n.bindings) {
        const a = this.get(r).index;
        if (r.isUniformsGroup || r.isUniformBuffer) {
          const u = s.getUniformBlockIndex(t, r.name);
          s.uniformBlockBinding(t, u, a);
        } else if (r.isSampledTexture) {
          const u = s.getUniformLocation(t, r.name);
          s.uniform1i(u, a);
        }
      }
  }
  /**
   * Binds the given uniforms.
   *
   * @private
   * @param {Array<BindGroup>} bindings - The bindings.
   */
  _bindUniforms(e) {
    const { gl: t, state: s } = this;
    for (const n of e)
      for (const r of n.bindings) {
        const i = this.get(r), a = i.index;
        r.isUniformsGroup || r.isUniformBuffer ? s.bindBufferBase(t.UNIFORM_BUFFER, a, i.bufferGPU) : r.isSampledTexture && s.bindTexture(i.glTextureType, i.textureGPU, t.TEXTURE0 + a);
      }
  }
  /**
   * Frees internal resources.
   */
  dispose() {
    this.renderer.domElement.removeEventListener("webglcontextlost", this._onContextLost);
  }
}
const ks = {
  PointList: "point-list",
  LineList: "line-list",
  LineStrip: "line-strip",
  TriangleList: "triangle-list",
  TriangleStrip: "triangle-strip"
}, we = {
  Never: "never",
  Less: "less",
  Equal: "equal",
  LessEqual: "less-equal",
  Greater: "greater",
  NotEqual: "not-equal",
  GreaterEqual: "greater-equal",
  Always: "always"
}, Fe = {
  Store: "store",
  Discard: "discard"
}, ye = {
  Load: "load",
  Clear: "clear"
}, oo = {
  CCW: "ccw",
  CW: "cw"
}, ao = {
  None: "none",
  Front: "front",
  Back: "back"
}, tn = {
  Uint16: "uint16",
  Uint32: "uint32"
}, x = {
  // 8-bit formats
  R8Unorm: "r8unorm",
  R8Snorm: "r8snorm",
  R8Uint: "r8uint",
  R8Sint: "r8sint",
  // 16-bit formats
  R16Uint: "r16uint",
  R16Sint: "r16sint",
  R16Float: "r16float",
  RG8Unorm: "rg8unorm",
  RG8Snorm: "rg8snorm",
  RG8Uint: "rg8uint",
  RG8Sint: "rg8sint",
  // 32-bit formats
  R32Uint: "r32uint",
  R32Sint: "r32sint",
  R32Float: "r32float",
  RG16Uint: "rg16uint",
  RG16Sint: "rg16sint",
  RG16Float: "rg16float",
  RGBA8Unorm: "rgba8unorm",
  RGBA8UnormSRGB: "rgba8unorm-srgb",
  RGBA8Snorm: "rgba8snorm",
  RGBA8Uint: "rgba8uint",
  RGBA8Sint: "rgba8sint",
  BGRA8Unorm: "bgra8unorm",
  BGRA8UnormSRGB: "bgra8unorm-srgb",
  // Packed 32-bit formats
  RGB9E5UFloat: "rgb9e5ufloat",
  RGB10A2Unorm: "rgb10a2unorm",
  RG11B10uFloat: "rgb10a2unorm",
  // 64-bit formats
  RG32Uint: "rg32uint",
  RG32Sint: "rg32sint",
  RG32Float: "rg32float",
  RGBA16Uint: "rgba16uint",
  RGBA16Sint: "rgba16sint",
  RGBA16Float: "rgba16float",
  // 128-bit formats
  RGBA32Uint: "rgba32uint",
  RGBA32Sint: "rgba32sint",
  RGBA32Float: "rgba32float",
  // Depth and stencil formats
  Stencil8: "stencil8",
  Depth16Unorm: "depth16unorm",
  Depth24Plus: "depth24plus",
  Depth24PlusStencil8: "depth24plus-stencil8",
  Depth32Float: "depth32float",
  // 'depth32float-stencil8' extension
  Depth32FloatStencil8: "depth32float-stencil8",
  // BC compressed formats usable if 'texture-compression-bc' is both
  // supported by the device/user agent and enabled in requestDevice.
  BC1RGBAUnorm: "bc1-rgba-unorm",
  BC1RGBAUnormSRGB: "bc1-rgba-unorm-srgb",
  BC2RGBAUnorm: "bc2-rgba-unorm",
  BC2RGBAUnormSRGB: "bc2-rgba-unorm-srgb",
  BC3RGBAUnorm: "bc3-rgba-unorm",
  BC3RGBAUnormSRGB: "bc3-rgba-unorm-srgb",
  BC4RUnorm: "bc4-r-unorm",
  BC4RSnorm: "bc4-r-snorm",
  BC5RGUnorm: "bc5-rg-unorm",
  BC5RGSnorm: "bc5-rg-snorm",
  BC6HRGBUFloat: "bc6h-rgb-ufloat",
  BC6HRGBFloat: "bc6h-rgb-float",
  BC7RGBAUnorm: "bc7-rgba-unorm",
  BC7RGBAUnormSRGB: "bc7-rgba-srgb",
  // ETC2 compressed formats usable if 'texture-compression-etc2' is both
  // supported by the device/user agent and enabled in requestDevice.
  ETC2RGB8Unorm: "etc2-rgb8unorm",
  ETC2RGB8UnormSRGB: "etc2-rgb8unorm-srgb",
  ETC2RGB8A1Unorm: "etc2-rgb8a1unorm",
  ETC2RGB8A1UnormSRGB: "etc2-rgb8a1unorm-srgb",
  ETC2RGBA8Unorm: "etc2-rgba8unorm",
  ETC2RGBA8UnormSRGB: "etc2-rgba8unorm-srgb",
  EACR11Unorm: "eac-r11unorm",
  EACR11Snorm: "eac-r11snorm",
  EACRG11Unorm: "eac-rg11unorm",
  EACRG11Snorm: "eac-rg11snorm",
  // ASTC compressed formats usable if 'texture-compression-astc' is both
  // supported by the device/user agent and enabled in requestDevice.
  ASTC4x4Unorm: "astc-4x4-unorm",
  ASTC4x4UnormSRGB: "astc-4x4-unorm-srgb",
  ASTC5x4Unorm: "astc-5x4-unorm",
  ASTC5x4UnormSRGB: "astc-5x4-unorm-srgb",
  ASTC5x5Unorm: "astc-5x5-unorm",
  ASTC5x5UnormSRGB: "astc-5x5-unorm-srgb",
  ASTC6x5Unorm: "astc-6x5-unorm",
  ASTC6x5UnormSRGB: "astc-6x5-unorm-srgb",
  ASTC6x6Unorm: "astc-6x6-unorm",
  ASTC6x6UnormSRGB: "astc-6x6-unorm-srgb",
  ASTC8x5Unorm: "astc-8x5-unorm",
  ASTC8x5UnormSRGB: "astc-8x5-unorm-srgb",
  ASTC8x6Unorm: "astc-8x6-unorm",
  ASTC8x6UnormSRGB: "astc-8x6-unorm-srgb",
  ASTC8x8Unorm: "astc-8x8-unorm",
  ASTC8x8UnormSRGB: "astc-8x8-unorm-srgb",
  ASTC10x5Unorm: "astc-10x5-unorm",
  ASTC10x5UnormSRGB: "astc-10x5-unorm-srgb",
  ASTC10x6Unorm: "astc-10x6-unorm",
  ASTC10x6UnormSRGB: "astc-10x6-unorm-srgb",
  ASTC10x8Unorm: "astc-10x8-unorm",
  ASTC10x8UnormSRGB: "astc-10x8-unorm-srgb",
  ASTC10x10Unorm: "astc-10x10-unorm",
  ASTC10x10UnormSRGB: "astc-10x10-unorm-srgb",
  ASTC12x10Unorm: "astc-12x10-unorm",
  ASTC12x10UnormSRGB: "astc-12x10-unorm-srgb",
  ASTC12x12Unorm: "astc-12x12-unorm",
  ASTC12x12UnormSRGB: "astc-12x12-unorm-srgb"
}, uo = {
  ClampToEdge: "clamp-to-edge",
  Repeat: "repeat",
  MirrorRepeat: "mirror-repeat"
}, os = {
  Linear: "linear",
  Nearest: "nearest"
}, W = {
  Zero: "zero",
  One: "one",
  Src: "src",
  OneMinusSrc: "one-minus-src",
  SrcAlpha: "src-alpha",
  OneMinusSrcAlpha: "one-minus-src-alpha",
  Dst: "dst",
  OneMinusDstColor: "one-minus-dst",
  DstAlpha: "dst-alpha",
  OneMinusDstAlpha: "one-minus-dst-alpha",
  SrcAlphaSaturated: "src-alpha-saturated",
  Constant: "constant",
  OneMinusConstant: "one-minus-constant"
}, ns = {
  Add: "add",
  Subtract: "subtract",
  ReverseSubtract: "reverse-subtract",
  Min: "min",
  Max: "max"
}, Uc = {
  None: 0,
  Red: 1,
  Green: 2,
  Blue: 4,
  Alpha: 8,
  All: 15
}, Wt = {
  Keep: "keep",
  Zero: "zero",
  Replace: "replace",
  Invert: "invert",
  IncrementClamp: "increment-clamp",
  DecrementClamp: "decrement-clamp",
  IncrementWrap: "increment-wrap",
  DecrementWrap: "decrement-wrap"
}, co = {
  Uniform: "uniform",
  Storage: "storage",
  ReadOnlyStorage: "read-only-storage"
}, lo = {
  WriteOnly: "write-only",
  ReadOnly: "read-only",
  ReadWrite: "read-write"
}, Bs = {
  Float: "float",
  UnfilterableFloat: "unfilterable-float",
  Depth: "depth",
  SInt: "sint",
  UInt: "uint"
}, Pc = {
  OneD: "1d",
  TwoD: "2d",
  ThreeD: "3d"
}, Oe = {
  OneD: "1d",
  TwoD: "2d",
  TwoDArray: "2d-array",
  Cube: "cube",
  CubeArray: "cube-array",
  ThreeD: "3d"
}, _A = {
  All: "all",
  StencilOnly: "stencil-only",
  DepthOnly: "depth-only"
}, br = {
  Vertex: "vertex",
  Instance: "instance"
}, Qo = {
  DepthClipControl: "depth-clip-control",
  Depth32FloatStencil8: "depth32float-stencil8",
  TextureCompressionBC: "texture-compression-bc",
  TextureCompressionETC2: "texture-compression-etc2",
  TextureCompressionASTC: "texture-compression-astc",
  TimestampQuery: "timestamp-query",
  IndirectFirstInstance: "indirect-first-instance",
  ShaderF16: "shader-f16",
  RG11B10UFloat: "rg11b10ufloat-renderable",
  BGRA8UNormStorage: "bgra8unorm-storage",
  Float32Filterable: "float32-filterable",
  ClipDistances: "clip-distances",
  DualSourceBlending: "dual-source-blending",
  Subgroups: "subgroups"
};
class NA extends Nu {
  /**
   * Constructs a new sampler.
   *
   * @param {String} name - The samplers's name.
   * @param {Texture?} texture - The texture this binding is referring to.
   */
  constructor(e, t) {
    super(e), this.texture = t, this.version = t ? t.version : 0, this.isSampler = !0;
  }
}
class bA extends NA {
  /**
   * Constructs a new node-based sampler.
   *
   * @param {String} name - The samplers's name.
   * @param {TextureNode} textureNode - The texture node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */
  constructor(e, t, s) {
    super(e, t ? t.value : null), this.textureNode = t, this.groupNode = s;
  }
  /**
   * Updates the texture value of this sampler.
   */
  update() {
    this.texture = this.textureNode.value;
  }
}
class SA extends jf {
  /**
   * Constructs a new uniform buffer.
   *
   * @param {String} name - The buffer's name.
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  constructor(e, t) {
    super(e, t ? t.array : null), this.attribute = t, this.isStorageBuffer = !0;
  }
}
let vA = 0;
class AA extends SA {
  /**
   * Constructs a new node-based storage buffer.
   *
   * @param {StorageBufferNode} nodeUniform - The storage buffer node.
   * @param {UniformGroupNode} groupNode - The uniform group node.
   */
  constructor(e, t) {
    super("StorageBuffer_" + vA++, e ? e.value : null), this.nodeUniform = e, this.access = e ? e.access : De.READ_WRITE, this.groupNode = t;
  }
  /**
   * The storage buffer.
   *
   * @type {BufferAttribute}
   */
  get buffer() {
    return this.nodeUniform.value;
  }
}
class RA extends Jt {
  constructor(e) {
    super(), this.device = e;
    const t = `
struct VarysStruct {
	@builtin( position ) Position: vec4<f32>,
	@location( 0 ) vTex : vec2<f32>
};

@vertex
fn main( @builtin( vertex_index ) vertexIndex : u32 ) -> VarysStruct {

	var Varys : VarysStruct;

	var pos = array< vec2<f32>, 4 >(
		vec2<f32>( -1.0,  1.0 ),
		vec2<f32>(  1.0,  1.0 ),
		vec2<f32>( -1.0, -1.0 ),
		vec2<f32>(  1.0, -1.0 )
	);

	var tex = array< vec2<f32>, 4 >(
		vec2<f32>( 0.0, 0.0 ),
		vec2<f32>( 1.0, 0.0 ),
		vec2<f32>( 0.0, 1.0 ),
		vec2<f32>( 1.0, 1.0 )
	);

	Varys.vTex = tex[ vertexIndex ];
	Varys.Position = vec4<f32>( pos[ vertexIndex ], 0.0, 1.0 );

	return Varys;

}
`, s = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vTex );

}
`, n = `
@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img : texture_2d<f32>;

@fragment
fn main( @location( 0 ) vTex : vec2<f32> ) -> @location( 0 ) vec4<f32> {

	return textureSample( img, imgSampler, vec2( vTex.x, 1.0 - vTex.y ) );

}
`;
    this.mipmapSampler = e.createSampler({ minFilter: os.Linear }), this.flipYSampler = e.createSampler({ minFilter: os.Nearest }), this.transferPipelines = {}, this.flipYPipelines = {}, this.mipmapVertexShaderModule = e.createShaderModule({
      label: "mipmapVertex",
      code: t
    }), this.mipmapFragmentShaderModule = e.createShaderModule({
      label: "mipmapFragment",
      code: s
    }), this.flipYFragmentShaderModule = e.createShaderModule({
      label: "flipYFragment",
      code: n
    });
  }
  getTransferPipeline(e) {
    let t = this.transferPipelines[e];
    return t === void 0 && (t = this.device.createRenderPipeline({
      label: `mipmap-${e}`,
      vertex: {
        module: this.mipmapVertexShaderModule,
        entryPoint: "main"
      },
      fragment: {
        module: this.mipmapFragmentShaderModule,
        entryPoint: "main",
        targets: [{ format: e }]
      },
      primitive: {
        topology: ks.TriangleStrip,
        stripIndexFormat: tn.Uint32
      },
      layout: "auto"
    }), this.transferPipelines[e] = t), t;
  }
  getFlipYPipeline(e) {
    let t = this.flipYPipelines[e];
    return t === void 0 && (t = this.device.createRenderPipeline({
      label: `flipY-${e}`,
      vertex: {
        module: this.mipmapVertexShaderModule,
        entryPoint: "main"
      },
      fragment: {
        module: this.flipYFragmentShaderModule,
        entryPoint: "main",
        targets: [{ format: e }]
      },
      primitive: {
        topology: ks.TriangleStrip,
        stripIndexFormat: tn.Uint32
      },
      layout: "auto"
    }), this.flipYPipelines[e] = t), t;
  }
  flipY(e, t, s = 0) {
    const n = t.format, { width: r, height: i } = t.size, a = this.getTransferPipeline(n), u = this.getFlipYPipeline(n), c = this.device.createTexture({
      size: { width: r, height: i, depthOrArrayLayers: 1 },
      format: n,
      usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
    }), l = e.createView({
      baseMipLevel: 0,
      mipLevelCount: 1,
      dimension: Oe.TwoD,
      baseArrayLayer: s
    }), d = c.createView({
      baseMipLevel: 0,
      mipLevelCount: 1,
      dimension: Oe.TwoD,
      baseArrayLayer: 0
    }), h = this.device.createCommandEncoder({}), p = (f, m, _) => {
      const S = f.getBindGroupLayout(0), A = this.device.createBindGroup({
        layout: S,
        entries: [{
          binding: 0,
          resource: this.flipYSampler
        }, {
          binding: 1,
          resource: m
        }]
      }), M = h.beginRenderPass({
        colorAttachments: [{
          view: _,
          loadOp: ye.Clear,
          storeOp: Fe.Store,
          clearValue: [0, 0, 0, 0]
        }]
      });
      M.setPipeline(f), M.setBindGroup(0, A), M.draw(4, 1, 0, 0), M.end();
    };
    p(a, l, d), p(u, d, l), this.device.queue.submit([h.finish()]), c.destroy();
  }
  generateMipmaps(e, t, s = 0) {
    const n = this.get(e);
    n.useCount === void 0 && (n.useCount = 0, n.layers = []);
    const r = n.layers[s] || this._mipmapCreateBundles(e, t, s), i = this.device.createCommandEncoder({});
    this._mipmapRunBundles(i, r), this.device.queue.submit([i.finish()]), n.useCount !== 0 && (n.layers[s] = r), n.useCount++;
  }
  _mipmapCreateBundles(e, t, s) {
    const n = this.getTransferPipeline(t.format), r = n.getBindGroupLayout(0);
    let i = e.createView({
      baseMipLevel: 0,
      mipLevelCount: 1,
      dimension: Oe.TwoD,
      baseArrayLayer: s
    });
    const a = [];
    for (let u = 1; u < t.mipLevelCount; u++) {
      const c = this.device.createBindGroup({
        layout: r,
        entries: [{
          binding: 0,
          resource: this.mipmapSampler
        }, {
          binding: 1,
          resource: i
        }]
      }), l = e.createView({
        baseMipLevel: u,
        mipLevelCount: 1,
        dimension: Oe.TwoD,
        baseArrayLayer: s
      }), d = {
        colorAttachments: [{
          view: l,
          loadOp: ye.Clear,
          storeOp: Fe.Store,
          clearValue: [0, 0, 0, 0]
        }]
      }, h = this.device.createRenderBundleEncoder({
        colorFormats: [t.format]
      });
      h.setPipeline(n), h.setBindGroup(0, c), h.draw(4, 1, 0, 0), a.push({
        renderBundles: [h.finish()],
        passDescriptor: d
      }), i = l;
    }
    return a;
  }
  _mipmapRunBundles(e, t) {
    const s = t.length;
    for (let n = 0; n < s; n++) {
      const r = t[n], i = e.beginRenderPass(r.passDescriptor);
      i.executeBundles(r.renderBundles), i.end();
    }
  }
}
const CA = {
  [gl]: "never",
  [ia]: "less",
  [xl]: "equal",
  [yl]: "less-equal",
  [_l]: "greater",
  [Tl]: "greater-equal",
  [ml]: "always",
  [Nl]: "not-equal"
}, EA = [0, 1, 3, 2, 4, 5];
class wA {
  constructor(e) {
    this.backend = e, this._passUtils = null, this.defaultTexture = {}, this.defaultCubeTexture = {}, this.defaultVideoFrame = null, this.colorBuffer = null, this.depthTexture = new ys(), this.depthTexture.name = "depthBuffer";
  }
  createSampler(e) {
    const t = this.backend, s = t.device, n = t.get(e), r = {
      addressModeU: this._convertAddressMode(e.wrapS),
      addressModeV: this._convertAddressMode(e.wrapT),
      addressModeW: this._convertAddressMode(e.wrapR),
      magFilter: this._convertFilterMode(e.magFilter),
      minFilter: this._convertFilterMode(e.minFilter),
      mipmapFilter: this._convertFilterMode(e.minFilter),
      maxAnisotropy: 1
    };
    r.magFilter === os.Linear && r.minFilter === os.Linear && r.mipmapFilter === os.Linear && (r.maxAnisotropy = e.anisotropy), e.isDepthTexture && e.compareFunction !== null && (r.compare = CA[e.compareFunction]), n.sampler = s.createSampler(r);
  }
  createDefaultTexture(e) {
    let t;
    const s = Zo(e);
    e.isCubeTexture ? t = this._getDefaultCubeTextureGPU(s) : e.isVideoTexture ? this.backend.get(e).externalTexture = this._getDefaultVideoFrame() : t = this._getDefaultTextureGPU(s), this.backend.get(e).texture = t;
  }
  createTexture(e, t = {}) {
    const s = this.backend, n = s.get(e);
    if (n.initialized)
      throw new Error("WebGPUTextureUtils: Texture already initialized.");
    t.needsMipmaps === void 0 && (t.needsMipmaps = !1), t.levels === void 0 && (t.levels = 1), t.depth === void 0 && (t.depth = 1);
    const { width: r, height: i, depth: a, levels: u } = t;
    e.isFramebufferTexture && (t.renderTarget ? t.format = this.backend.utils.getCurrentColorFormat(t.renderTarget) : t.format = this.backend.utils.getPreferredCanvasFormat());
    const c = this._getDimension(e), l = e.internalFormat || t.format || Zo(e, s.device);
    n.format = l;
    const { samples: d, primarySamples: h, isMSAA: p } = s.utils.getTextureSampleData(e);
    let f = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC;
    e.isStorageTexture === !0 && (f |= GPUTextureUsage.STORAGE_BINDING), e.isCompressedTexture !== !0 && e.isCompressedArrayTexture !== !0 && (f |= GPUTextureUsage.RENDER_ATTACHMENT);
    const m = {
      label: e.name,
      size: {
        width: r,
        height: i,
        depthOrArrayLayers: a
      },
      mipLevelCount: u,
      sampleCount: h,
      dimension: c,
      format: l,
      usage: f
    };
    if (e.isVideoTexture) {
      const _ = e.source.data, S = new VideoFrame(_);
      m.size.width = S.displayWidth, m.size.height = S.displayHeight, S.close(), n.externalTexture = _;
    } else {
      if (l === void 0)
        return console.warn("WebGPURenderer: Texture format not supported."), this.createDefaultTexture(e);
      n.texture = s.device.createTexture(m);
    }
    if (p) {
      const _ = Object.assign({}, m);
      _.label = _.label + "-msaa", _.sampleCount = d, n.msaaTexture = s.device.createTexture(_);
    }
    n.initialized = !0, n.textureDescriptorGPU = m;
  }
  destroyTexture(e) {
    const t = this.backend, s = t.get(e);
    s.texture !== void 0 && s.texture.destroy(), s.msaaTexture !== void 0 && s.msaaTexture.destroy(), t.delete(e);
  }
  destroySampler(e) {
    const s = this.backend.get(e);
    delete s.sampler;
  }
  generateMipmaps(e) {
    const t = this.backend.get(e);
    if (e.isCubeTexture)
      for (let s = 0; s < 6; s++)
        this._generateMipmaps(t.texture, t.textureDescriptorGPU, s);
    else {
      const s = e.image.depth || 1;
      for (let n = 0; n < s; n++)
        this._generateMipmaps(t.texture, t.textureDescriptorGPU, n);
    }
  }
  getColorBuffer() {
    this.colorBuffer && this.colorBuffer.destroy();
    const e = this.backend, { width: t, height: s } = e.getDrawingBufferSize();
    return this.colorBuffer = e.device.createTexture({
      label: "colorBuffer",
      size: {
        width: t,
        height: s,
        depthOrArrayLayers: 1
      },
      sampleCount: e.utils.getSampleCount(e.renderer.samples),
      format: e.utils.getPreferredCanvasFormat(),
      usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC
    }), this.colorBuffer;
  }
  getDepthBuffer(e = !0, t = !1) {
    const s = this.backend, { width: n, height: r } = s.getDrawingBufferSize(), i = this.depthTexture, a = s.get(i).texture;
    let u, c;
    if (t ? (u = Zr, c = ei) : e && (u = Jr, c = Pe), a !== void 0) {
      if (i.image.width === n && i.image.height === r && i.format === u && i.type === c)
        return a;
      this.destroyTexture(i);
    }
    return i.name = "depthBuffer", i.format = u, i.type = c, i.image.width = n, i.image.height = r, this.createTexture(i, { width: n, height: r }), s.get(i).texture;
  }
  updateTexture(e, t) {
    const s = this.backend.get(e), { textureDescriptorGPU: n } = s;
    if (!(e.isRenderTargetTexture || n === void 0)) {
      if (e.isDataTexture)
        this._copyBufferToTexture(t.image, s.texture, n, 0, e.flipY);
      else if (e.isDataArrayTexture || e.isData3DTexture)
        for (let r = 0; r < t.image.depth; r++)
          this._copyBufferToTexture(t.image, s.texture, n, r, e.flipY, r);
      else if (e.isCompressedTexture || e.isCompressedArrayTexture)
        this._copyCompressedBufferToTexture(e.mipmaps, s.texture, n);
      else if (e.isCubeTexture)
        this._copyCubeMapToTexture(t.images, s.texture, n, e.flipY);
      else if (e.isVideoTexture) {
        const r = e.source.data;
        s.externalTexture = r;
      } else
        this._copyImageToTexture(t.image, s.texture, n, 0, e.flipY);
      s.version = e.version, e.onUpdate && e.onUpdate(e);
    }
  }
  async copyTextureToBuffer(e, t, s, n, r, i) {
    const a = this.backend.device, u = this.backend.get(e), c = u.texture, l = u.textureDescriptorGPU.format, d = this._getBytesPerTexel(l);
    let h = n * d;
    h = Math.ceil(h / 256) * 256;
    const p = a.createBuffer(
      {
        size: n * r * d,
        usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
      }
    ), f = a.createCommandEncoder();
    f.copyTextureToBuffer(
      {
        texture: c,
        origin: { x: t, y: s, z: i }
      },
      {
        buffer: p,
        bytesPerRow: h
      },
      {
        width: n,
        height: r
      }
    );
    const m = this._getTypedArrayType(l);
    a.queue.submit([f.finish()]), await p.mapAsync(GPUMapMode.READ);
    const _ = p.getMappedRange();
    return new m(_);
  }
  _isEnvironmentTexture(e) {
    const t = e.mapping;
    return t === Wn || t === Hn || t === Ks || t === Ys;
  }
  _getDefaultTextureGPU(e) {
    let t = this.defaultTexture[e];
    if (t === void 0) {
      const s = new vl();
      s.minFilter = pt, s.magFilter = pt, this.createTexture(s, { width: 1, height: 1, format: e }), this.defaultTexture[e] = t = s;
    }
    return this.backend.get(t).texture;
  }
  _getDefaultCubeTextureGPU(e) {
    let t = this.defaultTexture[e];
    if (t === void 0) {
      const s = new Sl();
      s.minFilter = pt, s.magFilter = pt, this.createTexture(s, { width: 1, height: 1, depth: 6 }), this.defaultCubeTexture[e] = t = s;
    }
    return this.backend.get(t).texture;
  }
  _getDefaultVideoFrame() {
    let e = this.defaultVideoFrame;
    if (e === null) {
      const t = {
        timestamp: 0,
        codedWidth: 1,
        codedHeight: 1,
        format: "RGBA"
      };
      this.defaultVideoFrame = e = new VideoFrame(new Uint8Array([0, 0, 0, 255]), t);
    }
    return e;
  }
  _copyCubeMapToTexture(e, t, s, n) {
    for (let r = 0; r < 6; r++) {
      const i = e[r], a = n === !0 ? EA[r] : r;
      i.isDataTexture ? this._copyBufferToTexture(i.image, t, s, a, n) : this._copyImageToTexture(i, t, s, a, n);
    }
  }
  _copyImageToTexture(e, t, s, n, r) {
    this.backend.device.queue.copyExternalImageToTexture(
      {
        source: e
      },
      {
        texture: t,
        mipLevel: 0,
        origin: { x: 0, y: 0, z: n }
      },
      {
        width: e.width,
        height: e.height,
        depthOrArrayLayers: 1
      }
    ), r === !0 && this._flipY(t, s, n);
  }
  _getPassUtils() {
    let e = this._passUtils;
    return e === null && (this._passUtils = e = new RA(this.backend.device)), e;
  }
  _generateMipmaps(e, t, s = 0) {
    this._getPassUtils().generateMipmaps(e, t, s);
  }
  _flipY(e, t, s = 0) {
    this._getPassUtils().flipY(e, t, s);
  }
  _copyBufferToTexture(e, t, s, n, r, i = 0) {
    const a = this.backend.device, u = e.data, c = this._getBytesPerTexel(s.format), l = e.width * c;
    a.queue.writeTexture(
      {
        texture: t,
        mipLevel: 0,
        origin: { x: 0, y: 0, z: n }
      },
      u,
      {
        offset: e.width * e.height * c * i,
        bytesPerRow: l
      },
      {
        width: e.width,
        height: e.height,
        depthOrArrayLayers: 1
      }
    ), r === !0 && this._flipY(t, s, n);
  }
  _copyCompressedBufferToTexture(e, t, s) {
    const n = this.backend.device, r = this._getBlockData(s.format), i = s.size.depthOrArrayLayers > 1;
    for (let a = 0; a < e.length; a++) {
      const u = e[a], c = u.width, l = u.height, d = i ? s.size.depthOrArrayLayers : 1, h = Math.ceil(c / r.width) * r.byteLength, p = h * Math.ceil(l / r.height);
      for (let f = 0; f < d; f++)
        n.queue.writeTexture(
          {
            texture: t,
            mipLevel: a,
            origin: { x: 0, y: 0, z: f }
          },
          u.data,
          {
            offset: f * p,
            bytesPerRow: h,
            rowsPerImage: Math.ceil(l / r.height)
          },
          {
            width: Math.ceil(c / r.width) * r.width,
            height: Math.ceil(l / r.height) * r.height,
            depthOrArrayLayers: 1
          }
        );
    }
  }
  _getBlockData(e) {
    if (e === x.BC1RGBAUnorm || e === x.BC1RGBAUnormSRGB) return { byteLength: 8, width: 4, height: 4 };
    if (e === x.BC2RGBAUnorm || e === x.BC2RGBAUnormSRGB) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.BC3RGBAUnorm || e === x.BC3RGBAUnormSRGB) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.BC4RUnorm || e === x.BC4RSNorm) return { byteLength: 8, width: 4, height: 4 };
    if (e === x.BC5RGUnorm || e === x.BC5RGSnorm) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.BC6HRGBUFloat || e === x.BC6HRGBFloat) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.BC7RGBAUnorm || e === x.BC7RGBAUnormSRGB) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.ETC2RGB8Unorm || e === x.ETC2RGB8UnormSRGB) return { byteLength: 8, width: 4, height: 4 };
    if (e === x.ETC2RGB8A1Unorm || e === x.ETC2RGB8A1UnormSRGB) return { byteLength: 8, width: 4, height: 4 };
    if (e === x.ETC2RGBA8Unorm || e === x.ETC2RGBA8UnormSRGB) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.EACR11Unorm) return { byteLength: 8, width: 4, height: 4 };
    if (e === x.EACR11Snorm) return { byteLength: 8, width: 4, height: 4 };
    if (e === x.EACRG11Unorm) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.EACRG11Snorm) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.ASTC4x4Unorm || e === x.ASTC4x4UnormSRGB) return { byteLength: 16, width: 4, height: 4 };
    if (e === x.ASTC5x4Unorm || e === x.ASTC5x4UnormSRGB) return { byteLength: 16, width: 5, height: 4 };
    if (e === x.ASTC5x5Unorm || e === x.ASTC5x5UnormSRGB) return { byteLength: 16, width: 5, height: 5 };
    if (e === x.ASTC6x5Unorm || e === x.ASTC6x5UnormSRGB) return { byteLength: 16, width: 6, height: 5 };
    if (e === x.ASTC6x6Unorm || e === x.ASTC6x6UnormSRGB) return { byteLength: 16, width: 6, height: 6 };
    if (e === x.ASTC8x5Unorm || e === x.ASTC8x5UnormSRGB) return { byteLength: 16, width: 8, height: 5 };
    if (e === x.ASTC8x6Unorm || e === x.ASTC8x6UnormSRGB) return { byteLength: 16, width: 8, height: 6 };
    if (e === x.ASTC8x8Unorm || e === x.ASTC8x8UnormSRGB) return { byteLength: 16, width: 8, height: 8 };
    if (e === x.ASTC10x5Unorm || e === x.ASTC10x5UnormSRGB) return { byteLength: 16, width: 10, height: 5 };
    if (e === x.ASTC10x6Unorm || e === x.ASTC10x6UnormSRGB) return { byteLength: 16, width: 10, height: 6 };
    if (e === x.ASTC10x8Unorm || e === x.ASTC10x8UnormSRGB) return { byteLength: 16, width: 10, height: 8 };
    if (e === x.ASTC10x10Unorm || e === x.ASTC10x10UnormSRGB) return { byteLength: 16, width: 10, height: 10 };
    if (e === x.ASTC12x10Unorm || e === x.ASTC12x10UnormSRGB) return { byteLength: 16, width: 12, height: 10 };
    if (e === x.ASTC12x12Unorm || e === x.ASTC12x12UnormSRGB) return { byteLength: 16, width: 12, height: 12 };
  }
  _convertAddressMode(e) {
    let t = uo.ClampToEdge;
    return e === ti ? t = uo.Repeat : e === si && (t = uo.MirrorRepeat), t;
  }
  _convertFilterMode(e) {
    let t = os.Linear;
    return (e === pt || e === Mo || e === Hs) && (t = os.Nearest), t;
  }
  _getBytesPerTexel(e) {
    if (e === x.R8Unorm || e === x.R8Snorm || e === x.R8Uint || e === x.R8Sint) return 1;
    if (e === x.R16Uint || e === x.R16Sint || e === x.R16Float || e === x.RG8Unorm || e === x.RG8Snorm || e === x.RG8Uint || e === x.RG8Sint) return 2;
    if (e === x.R32Uint || e === x.R32Sint || e === x.R32Float || e === x.RG16Uint || e === x.RG16Sint || e === x.RG16Float || e === x.RGBA8Unorm || e === x.RGBA8UnormSRGB || e === x.RGBA8Snorm || e === x.RGBA8Uint || e === x.RGBA8Sint || e === x.BGRA8Unorm || e === x.BGRA8UnormSRGB || // Packed 32-bit formats
    e === x.RGB9E5UFloat || e === x.RGB10A2Unorm || e === x.RG11B10UFloat || e === x.Depth32Float || e === x.Depth24Plus || e === x.Depth24PlusStencil8 || e === x.Depth32FloatStencil8) return 4;
    if (e === x.RG32Uint || e === x.RG32Sint || e === x.RG32Float || e === x.RGBA16Uint || e === x.RGBA16Sint || e === x.RGBA16Float) return 8;
    if (e === x.RGBA32Uint || e === x.RGBA32Sint || e === x.RGBA32Float) return 16;
  }
  _getTypedArrayType(e) {
    if (e === x.R8Uint) return Uint8Array;
    if (e === x.R8Sint) return Int8Array;
    if (e === x.R8Unorm) return Uint8Array;
    if (e === x.R8Snorm) return Int8Array;
    if (e === x.RG8Uint) return Uint8Array;
    if (e === x.RG8Sint) return Int8Array;
    if (e === x.RG8Unorm) return Uint8Array;
    if (e === x.RG8Snorm) return Int8Array;
    if (e === x.RGBA8Uint) return Uint8Array;
    if (e === x.RGBA8Sint) return Int8Array;
    if (e === x.RGBA8Unorm) return Uint8Array;
    if (e === x.RGBA8Snorm) return Int8Array;
    if (e === x.R16Uint) return Uint16Array;
    if (e === x.R16Sint) return Int16Array;
    if (e === x.RG16Uint) return Uint16Array;
    if (e === x.RG16Sint) return Int16Array;
    if (e === x.RGBA16Uint) return Uint16Array;
    if (e === x.RGBA16Sint) return Int16Array;
    if (e === x.R16Float || e === x.RG16Float || e === x.RGBA16Float) return Uint16Array;
    if (e === x.R32Uint) return Uint32Array;
    if (e === x.R32Sint) return Int32Array;
    if (e === x.R32Float) return Float32Array;
    if (e === x.RG32Uint) return Uint32Array;
    if (e === x.RG32Sint) return Int32Array;
    if (e === x.RG32Float) return Float32Array;
    if (e === x.RGBA32Uint) return Uint32Array;
    if (e === x.RGBA32Sint) return Int32Array;
    if (e === x.RGBA32Float) return Float32Array;
    if (e === x.BGRA8Unorm || e === x.BGRA8UnormSRGB) return Uint8Array;
    if (e === x.RGB10A2Unorm || e === x.RGB9E5UFloat || e === x.RG11B10UFloat) return Uint32Array;
    if (e === x.Depth32Float) return Float32Array;
    if (e === x.Depth24Plus || e === x.Depth24PlusStencil8) return Uint32Array;
    if (e === x.Depth32FloatStencil8) return Float32Array;
  }
  _getDimension(e) {
    let t;
    return e.isData3DTexture ? t = Pc.ThreeD : t = Pc.TwoD, t;
  }
}
function Zo(o, e = null) {
  const t = o.format, s = o.type, n = o.colorSpace;
  let r;
  if (o.isCompressedTexture === !0 || o.isCompressedArrayTexture === !0)
    switch (t) {
      case vr:
        r = n === q ? x.BC1RGBAUnormSRGB : x.BC1RGBAUnorm;
        break;
      case Ar:
        r = n === q ? x.BC2RGBAUnormSRGB : x.BC2RGBAUnorm;
        break;
      case Rr:
        r = n === q ? x.BC3RGBAUnormSRGB : x.BC3RGBAUnorm;
        break;
      case fo:
        r = n === q ? x.ETC2RGB8UnormSRGB : x.ETC2RGB8Unorm;
        break;
      case go:
        r = n === q ? x.ETC2RGBA8UnormSRGB : x.ETC2RGBA8Unorm;
        break;
      case mo:
        r = n === q ? x.ASTC4x4UnormSRGB : x.ASTC4x4Unorm;
        break;
      case yo:
        r = n === q ? x.ASTC5x4UnormSRGB : x.ASTC5x4Unorm;
        break;
      case xo:
        r = n === q ? x.ASTC5x5UnormSRGB : x.ASTC5x5Unorm;
        break;
      case To:
        r = n === q ? x.ASTC6x5UnormSRGB : x.ASTC6x5Unorm;
        break;
      case _o:
        r = n === q ? x.ASTC6x6UnormSRGB : x.ASTC6x6Unorm;
        break;
      case No:
        r = n === q ? x.ASTC8x5UnormSRGB : x.ASTC8x5Unorm;
        break;
      case bo:
        r = n === q ? x.ASTC8x6UnormSRGB : x.ASTC8x6Unorm;
        break;
      case So:
        r = n === q ? x.ASTC8x8UnormSRGB : x.ASTC8x8Unorm;
        break;
      case vo:
        r = n === q ? x.ASTC10x5UnormSRGB : x.ASTC10x5Unorm;
        break;
      case Ao:
        r = n === q ? x.ASTC10x6UnormSRGB : x.ASTC10x6Unorm;
        break;
      case Ro:
        r = n === q ? x.ASTC10x8UnormSRGB : x.ASTC10x8Unorm;
        break;
      case Co:
        r = n === q ? x.ASTC10x10UnormSRGB : x.ASTC10x10Unorm;
        break;
      case Eo:
        r = n === q ? x.ASTC12x10UnormSRGB : x.ASTC12x10Unorm;
        break;
      case wo:
        r = n === q ? x.ASTC12x12UnormSRGB : x.ASTC12x12Unorm;
        break;
      case Xs:
        r = n === q ? x.RGBA8UnormSRGB : x.RGBA8Unorm;
        break;
      default:
        console.error("WebGPURenderer: Unsupported texture format.", t);
    }
  else
    switch (t) {
      case Xs:
        switch (s) {
          case Tn:
            r = x.RGBA8Snorm;
            break;
          case _n:
            r = x.RGBA16Sint;
            break;
          case Ls:
            r = x.RGBA16Uint;
            break;
          case Pe:
            r = x.RGBA32Uint;
            break;
          case Ve:
            r = x.RGBA32Sint;
            break;
          case ls:
            r = n === q ? x.RGBA8UnormSRGB : x.RGBA8Unorm;
            break;
          case at:
            r = x.RGBA16Float;
            break;
          case st:
            r = x.RGBA32Float;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RGBAFormat.", s);
        }
        break;
      case Jo:
        switch (s) {
          case fl:
            r = x.RGB9E5UFloat;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RGBFormat.", s);
        }
        break;
      case ea:
        switch (s) {
          case Tn:
            r = x.R8Snorm;
            break;
          case _n:
            r = x.R16Sint;
            break;
          case Ls:
            r = x.R16Uint;
            break;
          case Pe:
            r = x.R32Uint;
            break;
          case Ve:
            r = x.R32Sint;
            break;
          case ls:
            r = x.R8Unorm;
            break;
          case at:
            r = x.R16Float;
            break;
          case st:
            r = x.R32Float;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RedFormat.", s);
        }
        break;
      case Bn:
        switch (s) {
          case Tn:
            r = x.RG8Snorm;
            break;
          case _n:
            r = x.RG16Sint;
            break;
          case Ls:
            r = x.RG16Uint;
            break;
          case Pe:
            r = x.RG32Uint;
            break;
          case Ve:
            r = x.RG32Sint;
            break;
          case ls:
            r = x.RG8Unorm;
            break;
          case at:
            r = x.RG16Float;
            break;
          case st:
            r = x.RG32Float;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RGFormat.", s);
        }
        break;
      case Jr:
        switch (s) {
          case Ls:
            r = x.Depth16Unorm;
            break;
          case Pe:
            r = x.Depth24Plus;
            break;
          case st:
            r = x.Depth32Float;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with DepthFormat.", s);
        }
        break;
      case Zr:
        switch (s) {
          case ei:
            r = x.Depth24PlusStencil8;
            break;
          case st:
            e && e.features.has(Qo.Depth32FloatStencil8) === !1 && console.error('WebGPURenderer: Depth textures with DepthStencilFormat + FloatType can only be used with the "depth32float-stencil8" GPU feature.'), r = x.Depth32FloatStencil8;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with DepthStencilFormat.", s);
        }
        break;
      case ta:
        switch (s) {
          case Ve:
            r = x.R32Sint;
            break;
          case Pe:
            r = x.R32Uint;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RedIntegerFormat.", s);
        }
        break;
      case sa:
        switch (s) {
          case Ve:
            r = x.RG32Sint;
            break;
          case Pe:
            r = x.RG32Uint;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RGIntegerFormat.", s);
        }
        break;
      case na:
        switch (s) {
          case Ve:
            r = x.RGBA32Sint;
            break;
          case Pe:
            r = x.RGBA32Uint;
            break;
          default:
            console.error("WebGPURenderer: Unsupported texture type with RGBAIntegerFormat.", s);
        }
        break;
      default:
        console.error("WebGPURenderer: Unsupported texture format.", t);
    }
  return r;
}
const MA = /^[fn]*\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)\s*[\-\>]*\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/i, BA = /([a-z_0-9]+)\s*:\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/ig, Dc = {
  f32: "float",
  i32: "int",
  u32: "uint",
  bool: "bool",
  "vec2<f32>": "vec2",
  "vec2<i32>": "ivec2",
  "vec2<u32>": "uvec2",
  "vec2<bool>": "bvec2",
  vec2f: "vec2",
  vec2i: "ivec2",
  vec2u: "uvec2",
  vec2b: "bvec2",
  "vec3<f32>": "vec3",
  "vec3<i32>": "ivec3",
  "vec3<u32>": "uvec3",
  "vec3<bool>": "bvec3",
  vec3f: "vec3",
  vec3i: "ivec3",
  vec3u: "uvec3",
  vec3b: "bvec3",
  "vec4<f32>": "vec4",
  "vec4<i32>": "ivec4",
  "vec4<u32>": "uvec4",
  "vec4<bool>": "bvec4",
  vec4f: "vec4",
  vec4i: "ivec4",
  vec4u: "uvec4",
  vec4b: "bvec4",
  "mat2x2<f32>": "mat2",
  mat2x2f: "mat2",
  "mat3x3<f32>": "mat3",
  mat3x3f: "mat3",
  "mat4x4<f32>": "mat4",
  mat4x4f: "mat4",
  sampler: "sampler",
  texture_1d: "texture",
  texture_2d: "texture",
  texture_2d_array: "texture",
  texture_multisampled_2d: "cubeTexture",
  texture_depth_2d: "depthTexture",
  texture_depth_multisampled_2d: "depthTexture",
  texture_3d: "texture3D",
  texture_cube: "cubeTexture",
  texture_cube_array: "cubeTexture",
  texture_storage_1d: "storageTexture",
  texture_storage_2d: "storageTexture",
  texture_storage_2d_array: "storageTexture",
  texture_storage_3d: "storageTexture"
}, FA = (o) => {
  o = o.trim();
  const e = o.match(MA);
  if (e !== null && e.length === 4) {
    const t = e[2], s = [];
    let n = null;
    for (; (n = BA.exec(t)) !== null; )
      s.push({ name: n[1], type: n[2] });
    const r = [];
    for (let l = 0; l < s.length; l++) {
      const { name: d, type: h } = s[l];
      let p = h;
      p.startsWith("ptr") ? p = "pointer" : (p.startsWith("texture") && (p = h.split("<")[0]), p = Dc[p]), r.push(new Tu(p, d));
    }
    const i = o.substring(e[0].length), a = e[3] || "void", u = e[1] !== void 0 ? e[1] : "";
    return {
      type: Dc[a] || a,
      inputs: r,
      name: u,
      inputsCode: t,
      blockCode: i,
      outputType: a
    };
  } else
    throw new Error("FunctionNode: Function is not a WGSL code.");
};
class UA extends _u {
  /**
   * Constructs a new WGSL node function.
   *
   * @param {String} source - The WGSL source.
   */
  constructor(e) {
    const { type: t, inputs: s, name: n, inputsCode: r, blockCode: i, outputType: a } = FA(e);
    super(t, s, n), this.inputsCode = r, this.blockCode = i, this.outputType = a;
  }
  /**
   * This method returns the WGSL code of the node function.
   *
   * @param {String} [name=this.name] - The function's name.
   * @return {String} The shader code.
   */
  getCode(e = this.name) {
    const t = this.outputType !== "void" ? "-> " + this.outputType : "";
    return `fn ${e} ( ${this.inputsCode.trim()} ) ${t}` + this.blockCode;
  }
}
class PA extends Kf {
  /**
   * The method parses the given WGSL code an returns a node function.
   *
   * @param {String} source - The WGSL code.
   * @return {WGSLNodeFunction} A node function.
   */
  parseFunction(e) {
    return new UA(e);
  }
}
const Fs = typeof self < "u" ? self.GPUShaderStage : { VERTEX: 1, FRAGMENT: 2, COMPUTE: 4 }, DA = {
  [De.READ_ONLY]: "read",
  [De.WRITE_ONLY]: "write",
  [De.READ_WRITE]: "read_write"
}, Ic = {
  [ti]: "repeat",
  [ra]: "clamp",
  [si]: "mirror"
}, Sr = {
  vertex: Fs ? Fs.VERTEX : 1,
  fragment: Fs ? Fs.FRAGMENT : 2,
  compute: Fs ? Fs.COMPUTE : 4
}, Lc = {
  instance: !0,
  swizzleAssign: !1,
  storageBuffer: !0
}, IA = {
  "^^": "tsl_xor"
}, LA = {
  float: "f32",
  int: "i32",
  uint: "u32",
  bool: "bool",
  color: "vec3<f32>",
  vec2: "vec2<f32>",
  ivec2: "vec2<i32>",
  uvec2: "vec2<u32>",
  bvec2: "vec2<bool>",
  vec3: "vec3<f32>",
  ivec3: "vec3<i32>",
  uvec3: "vec3<u32>",
  bvec3: "vec3<bool>",
  vec4: "vec4<f32>",
  ivec4: "vec4<i32>",
  uvec4: "vec4<u32>",
  bvec4: "vec4<bool>",
  mat2: "mat2x2<f32>",
  mat3: "mat3x3<f32>",
  mat4: "mat4x4<f32>"
}, Vc = {}, tt = {
  tsl_xor: new be("fn tsl_xor( a : bool, b : bool ) -> bool { return ( a || b ) && !( a && b ); }"),
  mod_float: new be("fn tsl_mod_float( x : f32, y : f32 ) -> f32 { return x - y * floor( x / y ); }"),
  mod_vec2: new be("fn tsl_mod_vec2( x : vec2f, y : vec2f ) -> vec2f { return x - y * floor( x / y ); }"),
  mod_vec3: new be("fn tsl_mod_vec3( x : vec3f, y : vec3f ) -> vec3f { return x - y * floor( x / y ); }"),
  mod_vec4: new be("fn tsl_mod_vec4( x : vec4f, y : vec4f ) -> vec4f { return x - y * floor( x / y ); }"),
  equals_bool: new be("fn tsl_equals_bool( a : bool, b : bool ) -> bool { return a == b; }"),
  equals_bvec2: new be("fn tsl_equals_bvec2( a : vec2f, b : vec2f ) -> vec2<bool> { return vec2<bool>( a.x == b.x, a.y == b.y ); }"),
  equals_bvec3: new be("fn tsl_equals_bvec3( a : vec3f, b : vec3f ) -> vec3<bool> { return vec3<bool>( a.x == b.x, a.y == b.y, a.z == b.z ); }"),
  equals_bvec4: new be("fn tsl_equals_bvec4( a : vec4f, b : vec4f ) -> vec4<bool> { return vec4<bool>( a.x == b.x, a.y == b.y, a.z == b.z, a.w == b.w ); }"),
  repeatWrapping_float: new be("fn tsl_repeatWrapping_float( coord: f32 ) -> f32 { return fract( coord ); }"),
  mirrorWrapping_float: new be("fn tsl_mirrorWrapping_float( coord: f32 ) -> f32 { let mirrored = fract( coord * 0.5 ) * 2.0; return 1.0 - abs( 1.0 - mirrored ); }"),
  clampWrapping_float: new be("fn tsl_clampWrapping_float( coord: f32 ) -> f32 { return clamp( coord, 0.0, 1.0 ); }"),
  biquadraticTexture: new be(
    /* wgsl */
    `
fn tsl_biquadraticTexture( map : texture_2d<f32>, coord : vec2f, iRes : vec2u, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`
  )
}, xn = {
  dFdx: "dpdx",
  dFdy: "- dpdy",
  mod_float: "tsl_mod_float",
  mod_vec2: "tsl_mod_vec2",
  mod_vec3: "tsl_mod_vec3",
  mod_vec4: "tsl_mod_vec4",
  equals_bool: "tsl_equals_bool",
  equals_bvec2: "tsl_equals_bvec2",
  equals_bvec3: "tsl_equals_bvec3",
  equals_bvec4: "tsl_equals_bvec4",
  inversesqrt: "inverseSqrt",
  bitcast: "bitcast<f32>"
};
typeof navigator < "u" && /Windows/g.test(navigator.userAgent) && (tt.pow_float = new be("fn tsl_pow_float( a : f32, b : f32 ) -> f32 { return select( -pow( -a, b ), pow( a, b ), a > 0.0 ); }"), tt.pow_vec2 = new be("fn tsl_pow_vec2( a : vec2f, b : vec2f ) -> vec2f { return vec2f( tsl_pow_float( a.x, b.x ), tsl_pow_float( a.y, b.y ) ); }", [tt.pow_float]), tt.pow_vec3 = new be("fn tsl_pow_vec3( a : vec3f, b : vec3f ) -> vec3f { return vec3f( tsl_pow_float( a.x, b.x ), tsl_pow_float( a.y, b.y ), tsl_pow_float( a.z, b.z ) ); }", [tt.pow_float]), tt.pow_vec4 = new be("fn tsl_pow_vec4( a : vec4f, b : vec4f ) -> vec4f { return vec4f( tsl_pow_float( a.x, b.x ), tsl_pow_float( a.y, b.y ), tsl_pow_float( a.z, b.z ), tsl_pow_float( a.w, b.w ) ); }", [tt.pow_float]), xn.pow_float = "tsl_pow_float", xn.pow_vec2 = "tsl_pow_vec2", xn.pow_vec3 = "tsl_pow_vec3", xn.pow_vec4 = "tsl_pow_vec4");
let ng = "";
(typeof navigator < "u" && /Firefox|Deno/g.test(navigator.userAgent)) !== !0 && (ng += `diagnostic( off, derivative_uniformity );
`);
class VA extends qf {
  constructor(e, t) {
    super(e, t, new PA()), this.uniformGroups = {}, this.builtins = {}, this.directives = {}, this.scopedArrays = /* @__PURE__ */ new Map();
  }
  needsToWorkingColorSpace(e) {
    return e.isVideoTexture === !0 && e.colorSpace !== wn;
  }
  _generateTextureSample(e, t, s, n, r = this.shaderStage) {
    return r === "fragment" ? n ? `textureSample( ${t}, ${t}_sampler, ${s}, ${n} )` : `textureSample( ${t}, ${t}_sampler, ${s} )` : this.isFilteredTexture(e) ? this.generateFilteredTexture(e, t, s) : this.generateTextureLod(e, t, s, n, "0");
  }
  _generateVideoSample(e, t, s = this.shaderStage) {
    if (s === "fragment")
      return `textureSampleBaseClampToEdge( ${e}, ${e}_sampler, vec2<f32>( ${t}.x, 1.0 - ${t}.y ) )`;
    console.error(`WebGPURenderer: THREE.VideoTexture does not support ${s} shader.`);
  }
  _generateTextureSampleLevel(e, t, s, n, r, i = this.shaderStage) {
    return (i === "fragment" || i === "compute") && this.isUnfilterable(e) === !1 ? `textureSampleLevel( ${t}, ${t}_sampler, ${s}, ${n} )` : this.isFilteredTexture(e) ? this.generateFilteredTexture(e, t, s, n) : this.generateTextureLod(e, t, s, r, n);
  }
  generateWrapFunction(e) {
    const t = `tsl_coord_${Ic[e.wrapS]}S_${Ic[e.wrapT]}_${e.isData3DTexture ? "3d" : "2d"}T`;
    let s = Vc[t];
    if (s === void 0) {
      const n = [], r = e.isData3DTexture ? "vec3f" : "vec2f";
      let i = `fn ${t}( coord : ${r} ) -> ${r} {

	return ${r}(
`;
      const a = (u, c) => {
        u === ti ? (n.push(tt.repeatWrapping_float), i += `		tsl_repeatWrapping_float( coord.${c} )`) : u === ra ? (n.push(tt.clampWrapping_float), i += `		tsl_clampWrapping_float( coord.${c} )`) : u === si ? (n.push(tt.mirrorWrapping_float), i += `		tsl_mirrorWrapping_float( coord.${c} )`) : (i += `		coord.${c}`, console.warn(`WebGPURenderer: Unsupported texture wrap type "${u}" for vertex shader.`));
      };
      a(e.wrapS, "x"), i += `,
`, a(e.wrapT, "y"), e.isData3DTexture && (i += `,
`, a(e.wrapR, "z")), i += `
	);

}
`, Vc[t] = s = new be(i, n);
    }
    return s.build(this), t;
  }
  generateTextureDimension(e, t, s) {
    const n = this.getDataFromNode(e, this.shaderStage, this.globalCache);
    n.dimensionsSnippet === void 0 && (n.dimensionsSnippet = {});
    let r = n.dimensionsSnippet[s];
    if (n.dimensionsSnippet[s] === void 0) {
      let i, a;
      const { primarySamples: u } = this.renderer.backend.utils.getTextureSampleData(e), c = u > 1;
      e.isData3DTexture ? a = "vec3<u32>" : a = "vec2<u32>", c || e.isVideoTexture || e.isStorageTexture ? i = t : i = `${t}${s ? `, u32( ${s} )` : ""}`, r = new wr(new Mr(`textureDimensions( ${i} )`, a)), n.dimensionsSnippet[s] = r, (e.isDataArrayTexture || e.isData3DTexture) && (n.arrayLayerCount = new wr(
        new Mr(
          `textureNumLayers(${t})`,
          "u32"
        )
      )), e.isTextureCube && (n.cubeFaceCount = new wr(
        new Mr("6u", "u32")
      ));
    }
    return r.build(this);
  }
  generateFilteredTexture(e, t, s, n = "0u") {
    this._include("biquadraticTexture");
    const r = this.generateWrapFunction(e), i = this.generateTextureDimension(e, t, n);
    return `tsl_biquadraticTexture( ${t}, ${r}( ${s} ), ${i}, u32( ${n} ) )`;
  }
  generateTextureLod(e, t, s, n, r = "0u") {
    const i = this.generateWrapFunction(e), a = this.generateTextureDimension(e, t, r), u = e.isData3DTexture ? "vec3" : "vec2", c = `${u}<u32>(${i}(${s}) * ${u}<f32>(${a}))`;
    return this.generateTextureLoad(e, t, c, n, r);
  }
  generateTextureLoad(e, t, s, n, r = "0u") {
    return e.isVideoTexture === !0 || e.isStorageTexture === !0 ? `textureLoad( ${t}, ${s} )` : n ? `textureLoad( ${t}, ${s}, ${n}, u32( ${r} ) )` : `textureLoad( ${t}, ${s}, u32( ${r} ) )`;
  }
  generateTextureStore(e, t, s, n) {
    return `textureStore( ${t}, ${s}, ${n} )`;
  }
  isSampleCompare(e) {
    return e.isDepthTexture === !0 && e.compareFunction !== null;
  }
  isUnfilterable(e) {
    return this.getComponentTypeFromTexture(e) !== "float" || !this.isAvailable("float32Filterable") && e.isDataTexture === !0 && e.type === st || this.isSampleCompare(e) === !1 && e.minFilter === pt && e.magFilter === pt || this.renderer.backend.utils.getTextureSampleData(e).primarySamples > 1;
  }
  generateTexture(e, t, s, n, r = this.shaderStage) {
    let i = null;
    return e.isVideoTexture === !0 ? i = this._generateVideoSample(t, s, r) : this.isUnfilterable(e) ? i = this.generateTextureLod(e, t, s, n, "0", r) : i = this._generateTextureSample(e, t, s, n, r), i;
  }
  generateTextureGrad(e, t, s, n, r, i = this.shaderStage) {
    if (i === "fragment")
      return `textureSampleGrad( ${t}, ${t}_sampler, ${s},  ${n[0]}, ${n[1]} )`;
    console.error(`WebGPURenderer: THREE.TextureNode.gradient() does not support ${i} shader.`);
  }
  generateTextureCompare(e, t, s, n, r, i = this.shaderStage) {
    if (i === "fragment")
      return `textureSampleCompare( ${t}, ${t}_sampler, ${s}, ${n} )`;
    console.error(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${i} shader.`);
  }
  generateTextureLevel(e, t, s, n, r, i = this.shaderStage) {
    let a = null;
    return e.isVideoTexture === !0 ? a = this._generateVideoSample(t, s, i) : a = this._generateTextureSampleLevel(e, t, s, n, r, i), a;
  }
  generateTextureBias(e, t, s, n, r, i = this.shaderStage) {
    if (i === "fragment")
      return `textureSampleBias( ${t}, ${t}_sampler, ${s}, ${n} )`;
    console.error(`WebGPURenderer: THREE.TextureNode.biasNode does not support ${i} shader.`);
  }
  getPropertyName(e, t = this.shaderStage) {
    if (e.isNodeVarying === !0 && e.needsInterpolation === !0) {
      if (t === "vertex")
        return `varyings.${e.name}`;
    } else if (e.isNodeUniform === !0) {
      const s = e.name, n = e.type;
      return n === "texture" || n === "cubeTexture" || n === "storageTexture" || n === "texture3D" ? s : n === "buffer" || n === "storageBuffer" || n === "indirectStorageBuffer" ? `NodeBuffer_${e.id}.${s}` : e.groupNode.name + "." + s;
    }
    return super.getPropertyName(e);
  }
  getOutputStructName() {
    return "output";
  }
  _getUniformGroupCount(e) {
    return Object.keys(this.uniforms[e]).length;
  }
  getFunctionOperator(e) {
    const t = IA[e];
    return t !== void 0 ? (this._include(t), t) : null;
  }
  getNodeAccess(e, t) {
    return t !== "compute" ? De.READ_ONLY : e.access;
  }
  getStorageAccess(e, t) {
    return DA[this.getNodeAccess(e, t)];
  }
  getUniformFromNode(e, t, s, n = null) {
    const r = super.getUniformFromNode(e, t, s, n), i = this.getDataFromNode(e, s, this.globalCache);
    if (i.uniformGPU === void 0) {
      let a;
      const u = e.groupNode, c = u.name, l = this.getBindGroupArray(c, s);
      if (t === "texture" || t === "cubeTexture" || t === "storageTexture" || t === "texture3D") {
        let d = null;
        const h = this.getNodeAccess(e, s);
        if (t === "texture" || t === "storageTexture" ? d = new Ci(r.name, r.node, u, h) : t === "cubeTexture" ? d = new eg(r.name, r.node, u, h) : t === "texture3D" && (d = new tg(r.name, r.node, u, h)), d.store = e.isStorageTextureNode === !0, d.setVisibility(Sr[s]), (s === "fragment" || s === "compute") && this.isUnfilterable(e.value) === !1 && d.store === !1) {
          const p = new bA(`${r.name}_sampler`, r.node, u);
          p.setVisibility(Sr[s]), l.push(p, d), a = [p, d];
        } else
          l.push(d), a = [d];
      } else if (t === "buffer" || t === "storageBuffer" || t === "indirectStorageBuffer") {
        const d = t === "buffer" ? Zf : AA, h = new d(e, u);
        h.setVisibility(Sr[s]), l.push(h), a = h;
      } else {
        const d = this.uniformGroups[s] || (this.uniformGroups[s] = {});
        let h = d[c];
        h === void 0 && (h = new Jf(c, u), h.setVisibility(Sr[s]), d[c] = h, l.push(h)), a = this.getNodeUniform(r, t), h.addUniform(a);
      }
      i.uniformGPU = a;
    }
    return r;
  }
  getBuiltin(e, t, s, n = this.shaderStage) {
    const r = this.builtins[n] || (this.builtins[n] = /* @__PURE__ */ new Map());
    return r.has(e) === !1 && r.set(e, {
      name: e,
      property: t,
      type: s
    }), t;
  }
  hasBuiltin(e, t = this.shaderStage) {
    return this.builtins[t] !== void 0 && this.builtins[t].has(e);
  }
  getVertexIndex() {
    return this.shaderStage === "vertex" ? this.getBuiltin("vertex_index", "vertexIndex", "u32", "attribute") : "vertexIndex";
  }
  buildFunctionCode(e) {
    const t = e.layout, s = this.flowShaderNode(e), n = [];
    for (const i of t.inputs)
      n.push(i.name + " : " + this.getType(i.type));
    let r = `fn ${t.name}( ${n.join(", ")} ) -> ${this.getType(t.type)} {
${s.vars}
${s.code}
`;
    return s.result && (r += `	return ${s.result};
`), r += `
}
`, r;
  }
  getInstanceIndex() {
    return this.shaderStage === "vertex" ? this.getBuiltin("instance_index", "instanceIndex", "u32", "attribute") : "instanceIndex";
  }
  getInvocationLocalIndex() {
    return this.getBuiltin("local_invocation_index", "invocationLocalIndex", "u32", "attribute");
  }
  getSubgroupSize() {
    return this.enableSubGroups(), this.getBuiltin("subgroup_size", "subgroupSize", "u32", "attribute");
  }
  getInvocationSubgroupIndex() {
    return this.enableSubGroups(), this.getBuiltin("subgroup_invocation_id", "invocationSubgroupIndex", "u32", "attribute");
  }
  getSubgroupIndex() {
    return this.enableSubGroups(), this.getBuiltin("subgroup_id", "subgroupIndex", "u32", "attribute");
  }
  getDrawIndex() {
    return null;
  }
  getFrontFacing() {
    return this.getBuiltin("front_facing", "isFront", "bool");
  }
  getFragCoord() {
    return this.getBuiltin("position", "fragCoord", "vec4<f32>") + ".xy";
  }
  getFragDepth() {
    return "output." + this.getBuiltin("frag_depth", "depth", "f32", "output");
  }
  getClipDistance() {
    return "varyings.hw_clip_distances";
  }
  isFlipY() {
    return !1;
  }
  enableDirective(e, t = this.shaderStage) {
    (this.directives[t] || (this.directives[t] = /* @__PURE__ */ new Set())).add(e);
  }
  getDirectives(e) {
    const t = [], s = this.directives[e];
    if (s !== void 0)
      for (const n of s)
        t.push(`enable ${n};`);
    return t.join(`
`);
  }
  enableSubGroups() {
    this.enableDirective("subgroups");
  }
  enableSubgroupsF16() {
    this.enableDirective("subgroups-f16");
  }
  enableClipDistances() {
    this.enableDirective("clip_distances");
  }
  enableShaderF16() {
    this.enableDirective("f16");
  }
  enableDualSourceBlending() {
    this.enableDirective("dual_source_blending");
  }
  enableHardwareClipping(e) {
    this.enableClipDistances(), this.getBuiltin("clip_distances", "hw_clip_distances", `array<f32, ${e} >`, "vertex");
  }
  getBuiltins(e) {
    const t = [], s = this.builtins[e];
    if (s !== void 0)
      for (const { name: n, property: r, type: i } of s.values())
        t.push(`@builtin( ${n} ) ${r} : ${i}`);
    return t.join(`,
	`);
  }
  getScopedArray(e, t, s, n) {
    return this.scopedArrays.has(e) === !1 && this.scopedArrays.set(e, {
      name: e,
      scope: t,
      bufferType: s,
      bufferCount: n
    }), e;
  }
  getScopedArrays(e) {
    if (e !== "compute")
      return;
    const t = [];
    for (const { name: s, scope: n, bufferType: r, bufferCount: i } of this.scopedArrays.values()) {
      const a = this.getType(r);
      t.push(`var<${n}> ${s}: array< ${a}, ${i} >;`);
    }
    return t.join(`
`);
  }
  getAttributes(e) {
    const t = [];
    if (e === "compute" && (this.getBuiltin("global_invocation_id", "id", "vec3<u32>", "attribute"), this.getBuiltin("workgroup_id", "workgroupId", "vec3<u32>", "attribute"), this.getBuiltin("local_invocation_id", "localId", "vec3<u32>", "attribute"), this.getBuiltin("num_workgroups", "numWorkgroups", "vec3<u32>", "attribute"), this.renderer.hasFeature("subgroups") && (this.enableDirective("subgroups", e), this.getBuiltin("subgroup_size", "subgroupSize", "u32", "attribute"))), e === "vertex" || e === "compute") {
      const s = this.getBuiltins("attribute");
      s && t.push(s);
      const n = this.getAttributesArray();
      for (let r = 0, i = n.length; r < i; r++) {
        const a = n[r], u = a.name, c = this.getType(a.type);
        t.push(`@location( ${r} ) ${u} : ${c}`);
      }
    }
    return t.join(`,
	`);
  }
  getStructMembers(e) {
    const t = [], s = e.getMemberTypes();
    for (let r = 0; r < s.length; r++) {
      const i = s[r];
      t.push(`	@location( ${r} ) m${r} : ${i}<f32>`);
    }
    const n = this.getBuiltins("output");
    return n && t.push("	" + n), t.join(`,
`);
  }
  getStructs(e) {
    const t = [], s = this.structs[e];
    for (let n = 0, r = s.length; n < r; n++) {
      const i = s[n], a = i.name;
      let u = `struct ${a} {
`;
      u += this.getStructMembers(i), u += `
}`, t.push(u), t.push(`
var<private> output : ${a};

`);
    }
    return t.join(`

`);
  }
  getVar(e, t) {
    return `var ${t} : ${this.getType(e)}`;
  }
  getVars(e) {
    const t = [], s = this.vars[e];
    if (s !== void 0)
      for (const n of s)
        t.push(`	${this.getVar(n.type, n.name)};`);
    return `
${t.join(`
`)}
`;
  }
  getVaryings(e) {
    const t = [];
    if (e === "vertex" && this.getBuiltin("position", "Vertex", "vec4<f32>", "vertex"), e === "vertex" || e === "fragment") {
      const r = this.varyings, i = this.vars[e];
      for (let a = 0; a < r.length; a++) {
        const u = r[a];
        if (u.needsInterpolation) {
          let c = `@location( ${a} )`;
          /^(int|uint|ivec|uvec)/.test(u.type) && (c += " @interpolate( flat )"), t.push(`${c} ${u.name} : ${this.getType(u.type)}`);
        } else e === "vertex" && i.includes(u) === !1 && i.push(u);
      }
    }
    const s = this.getBuiltins(e);
    s && t.push(s);
    const n = t.join(`,
	`);
    return e === "vertex" ? this._getWGSLStruct("VaryingsStruct", "	" + n) : n;
  }
  getUniforms(e) {
    const t = this.uniforms[e], s = [], n = [], r = [], i = {};
    for (const u of t) {
      const c = u.groupNode.name, l = this.bindingsIndexes[c];
      if (u.type === "texture" || u.type === "cubeTexture" || u.type === "storageTexture" || u.type === "texture3D") {
        const d = u.node.value;
        (e === "fragment" || e === "compute") && this.isUnfilterable(d) === !1 && u.node.isStorageTextureNode !== !0 && (this.isSampleCompare(d) ? s.push(`@binding( ${l.binding++} ) @group( ${l.group} ) var ${u.name}_sampler : sampler_comparison;`) : s.push(`@binding( ${l.binding++} ) @group( ${l.group} ) var ${u.name}_sampler : sampler;`));
        let h, p = "";
        const { primarySamples: f } = this.renderer.backend.utils.getTextureSampleData(d);
        if (f > 1 && (p = "_multisampled"), d.isCubeTexture === !0)
          h = "texture_cube<f32>";
        else if (d.isDataArrayTexture === !0 || d.isCompressedArrayTexture === !0)
          h = "texture_2d_array<f32>";
        else if (d.isDepthTexture === !0)
          h = `texture_depth${p}_2d`;
        else if (d.isVideoTexture === !0)
          h = "texture_external";
        else if (d.isData3DTexture === !0)
          h = "texture_3d<f32>";
        else if (u.node.isStorageTextureNode === !0) {
          const m = Zo(d), _ = this.getStorageAccess(u.node, e);
          h = `texture_storage_2d<${m}, ${_}>`;
        } else {
          const m = this.getComponentTypeFromTexture(d).charAt(0);
          h = `texture${p}_2d<${m}32>`;
        }
        s.push(`@binding( ${l.binding++} ) @group( ${l.group} ) var ${u.name} : ${h};`);
      } else if (u.type === "buffer" || u.type === "storageBuffer" || u.type === "indirectStorageBuffer") {
        const d = u.node, h = this.getType(d.bufferType), p = d.bufferCount, f = p > 0 && u.type === "buffer" ? ", " + p : "", m = d.isAtomic ? `atomic<${h}>` : `${h}`, _ = `	${u.name} : array< ${m}${f} >
`, S = d.isStorageBufferNode ? `storage, ${this.getStorageAccess(d, e)}` : "uniform";
        n.push(this._getWGSLStructBinding("NodeBuffer_" + d.id, _, S, l.binding++, l.group));
      } else {
        const d = this.getType(this.getVectorType(u.type)), h = u.groupNode.name;
        (i[h] || (i[h] = {
          index: l.binding++,
          id: l.group,
          snippets: []
        })).snippets.push(`	${u.name} : ${d}`);
      }
    }
    for (const u in i) {
      const c = i[u];
      r.push(this._getWGSLStructBinding(u, c.snippets.join(`,
`), "uniform", c.index, c.id));
    }
    let a = s.join(`
`);
    return a += n.join(`
`), a += r.join(`
`), a;
  }
  buildCode() {
    const e = this.material !== null ? { fragment: {}, vertex: {} } : { compute: {} };
    this.sortBindingGroups();
    for (const t in e) {
      const s = e[t];
      s.uniforms = this.getUniforms(t), s.attributes = this.getAttributes(t), s.varyings = this.getVaryings(t), s.structs = this.getStructs(t), s.vars = this.getVars(t), s.codes = this.getCodes(t), s.directives = this.getDirectives(t), s.scopedArrays = this.getScopedArrays(t);
      let n = `// code

`;
      n += this.flowCode[t];
      const r = this.flowNodes[t], i = r[r.length - 1], a = i.outputNode, u = a !== void 0 && a.isOutputStructNode === !0;
      for (const c of r) {
        const l = this.getFlowData(
          c
          /*, shaderStage*/
        ), d = c.name;
        if (d && (n.length > 0 && (n += `
`), n += `	// flow -> ${d}
	`), n += `${l.code}
	`, c === i && t !== "compute") {
          if (n += `// result

	`, t === "vertex")
            n += `varyings.Vertex = ${l.result};`;
          else if (t === "fragment")
            if (u)
              s.returnType = a.nodeType, n += `return ${l.result};`;
            else {
              let h = "	@location(0) color: vec4<f32>";
              const p = this.getBuiltins("output");
              p && (h += `,
	` + p), s.returnType = "OutputStruct", s.structs += this._getWGSLStruct("OutputStruct", h), s.structs += `
var<private> output : OutputStruct;

`, n += `output.color = ${l.result};

	return output;`;
            }
        }
      }
      s.flow = n;
    }
    this.material !== null ? (this.vertexShader = this._getWGSLVertexCode(e.vertex), this.fragmentShader = this._getWGSLFragmentCode(e.fragment)) : this.computeShader = this._getWGSLComputeCode(e.compute, (this.object.workgroupSize || [64]).join(", "));
  }
  getMethod(e, t = null) {
    let s;
    return t !== null && (s = this._getWGSLMethod(e + "_" + t)), s === void 0 && (s = this._getWGSLMethod(e)), s || e;
  }
  getType(e) {
    return LA[e] || e;
  }
  isAvailable(e) {
    let t = Lc[e];
    return t === void 0 && (e === "float32Filterable" ? t = this.renderer.hasFeature("float32-filterable") : e === "clipDistance" && (t = this.renderer.hasFeature("clip-distances")), Lc[e] = t), t;
  }
  _getWGSLMethod(e) {
    return tt[e] !== void 0 && this._include(e), xn[e];
  }
  _include(e) {
    const t = tt[e];
    return t.build(this), this.currentFunctionNode !== null && this.currentFunctionNode.includes.push(t), t;
  }
  _getWGSLVertexCode(e) {
    return `${this.getSignature()}
// directives
${e.directives}

// uniforms
${e.uniforms}

// varyings
${e.varyings}
var<private> varyings : VaryingsStruct;

// codes
${e.codes}

@vertex
fn main( ${e.attributes} ) -> VaryingsStruct {

	// vars
	${e.vars}

	// flow
	${e.flow}

	return varyings;

}
`;
  }
  _getWGSLFragmentCode(e) {
    return `${this.getSignature()}
// global
${ng}

// uniforms
${e.uniforms}

// structs
${e.structs}

// codes
${e.codes}

@fragment
fn main( ${e.varyings} ) -> ${e.returnType} {

	// vars
	${e.vars}

	// flow
	${e.flow}

}
`;
  }
  _getWGSLComputeCode(e, t) {
    return `${this.getSignature()}
// directives
${e.directives}

// system
var<private> instanceIndex : u32;

// locals
${e.scopedArrays}

// uniforms
${e.uniforms}

// codes
${e.codes}

@compute @workgroup_size( ${t} )
fn main( ${e.attributes} ) {

	// system
	instanceIndex = id.x + id.y * numWorkgroups.x * u32(${t}) + id.z * numWorkgroups.x * numWorkgroups.y * u32(${t});

	// vars
	${e.vars}

	// flow
	${e.flow}

}
`;
  }
  _getWGSLStruct(e, t) {
    return `
struct ${e} {
${t}
};`;
  }
  _getWGSLStructBinding(e, t, s, n = 0, r = 0) {
    const i = e + "Struct";
    return `${this._getWGSLStruct(i, t)}
@binding( ${n} ) @group( ${r} )
var<${s}> ${e} : ${i};`;
  }
}
class GA {
  constructor(e) {
    this.backend = e;
  }
  getCurrentDepthStencilFormat(e) {
    let t;
    return e.depthTexture !== null ? t = this.getTextureFormatGPU(e.depthTexture) : e.depth && e.stencil ? t = x.Depth24PlusStencil8 : e.depth && (t = x.Depth24Plus), t;
  }
  getTextureFormatGPU(e) {
    return this.backend.get(e).format;
  }
  getTextureSampleData(e) {
    let t;
    if (e.isFramebufferTexture)
      t = 1;
    else if (e.isDepthTexture && !e.renderTarget) {
      const r = this.backend.renderer, i = r.getRenderTarget();
      t = i ? i.samples : r.samples;
    } else e.renderTarget && (t = e.renderTarget.samples);
    t = t || 1;
    const s = t > 1 && e.renderTarget !== null && e.isDepthTexture !== !0 && e.isFramebufferTexture !== !0;
    return { samples: t, primarySamples: s ? 1 : t, isMSAA: s };
  }
  getCurrentColorFormat(e) {
    let t;
    return e.textures !== null ? t = this.getTextureFormatGPU(e.textures[0]) : t = this.getPreferredCanvasFormat(), t;
  }
  getCurrentColorSpace(e) {
    return e.textures !== null ? e.textures[0].colorSpace : this.backend.renderer.outputColorSpace;
  }
  getPrimitiveTopology(e, t) {
    if (e.isPoints) return ks.PointList;
    if (e.isLineSegments || e.isMesh && t.wireframe === !0) return ks.LineList;
    if (e.isLine) return ks.LineStrip;
    if (e.isMesh) return ks.TriangleList;
  }
  getSampleCount(e) {
    let t = 1;
    return e > 1 && (t = Math.pow(2, Math.floor(Math.log2(e))), t === 2 && (t = 4)), t;
  }
  getSampleCountRenderContext(e) {
    return e.textures !== null ? this.getSampleCount(e.sampleCount) : this.getSampleCount(this.backend.renderer.samples);
  }
  getPreferredCanvasFormat() {
    return navigator.userAgent.includes("Quest") ? x.BGRA8Unorm : navigator.gpu.getPreferredCanvasFormat();
  }
}
const OA = /* @__PURE__ */ new Map([
  [Int8Array, ["sint8", "snorm8"]],
  [Uint8Array, ["uint8", "unorm8"]],
  [Int16Array, ["sint16", "snorm16"]],
  [Uint16Array, ["uint16", "unorm16"]],
  [Int32Array, ["sint32", "snorm32"]],
  [Uint32Array, ["uint32", "unorm32"]],
  [Float32Array, ["float32"]]
]), kA = /* @__PURE__ */ new Map([
  [Rl, ["float16"]]
]), zA = /* @__PURE__ */ new Map([
  [Int32Array, "sint32"],
  [Int16Array, "sint32"],
  // patch for INT16
  [Uint32Array, "uint32"],
  [Uint16Array, "uint32"],
  // patch for UINT16
  [Float32Array, "float32"]
]);
class $A {
  constructor(e) {
    this.backend = e;
  }
  createAttribute(e, t) {
    const s = this._getBufferAttribute(e), n = this.backend, r = n.get(s);
    let i = r.buffer;
    if (i === void 0) {
      const a = n.device;
      let u = s.array;
      if (e.normalized === !1 && (u.constructor === Int16Array || u.constructor === Uint16Array)) {
        const l = new Uint32Array(u.length);
        for (let d = 0; d < u.length; d++)
          l[d] = u[d];
        u = l;
      }
      if (s.array = u, (s.isStorageBufferAttribute || s.isStorageInstancedBufferAttribute) && s.itemSize === 3) {
        u = new u.constructor(s.count * 4);
        for (let l = 0; l < s.count; l++)
          u.set(s.array.subarray(l * 3, l * 3 + 3), l * 4);
        s.itemSize = 4, s.array = u;
      }
      const c = u.byteLength + (4 - u.byteLength % 4) % 4;
      i = a.createBuffer({
        label: s.name,
        size: c,
        usage: t,
        mappedAtCreation: !0
      }), new u.constructor(i.getMappedRange()).set(u), i.unmap(), r.buffer = i;
    }
  }
  updateAttribute(e) {
    const t = this._getBufferAttribute(e), s = this.backend, n = s.device, r = s.get(t).buffer, i = t.array, a = this._isTypedArray(i), u = t.updateRanges;
    if (u.length === 0)
      n.queue.writeBuffer(
        r,
        0,
        i,
        0
      );
    else {
      const c = a ? 1 : i.BYTES_PER_ELEMENT;
      for (let l = 0, d = u.length; l < d; l++) {
        const h = u[l], p = h.start * c, f = h.count * c;
        n.queue.writeBuffer(
          r,
          0,
          i,
          p,
          f
        );
      }
      t.clearUpdateRanges();
    }
  }
  createShaderVertexBuffers(e) {
    const t = e.getAttributes(), s = /* @__PURE__ */ new Map();
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = r.array.BYTES_PER_ELEMENT, a = this._getBufferAttribute(r);
      let u = s.get(a);
      if (u === void 0) {
        let d, h;
        r.isInterleavedBufferAttribute === !0 ? (d = r.data.stride * i, h = r.data.isInstancedInterleavedBuffer ? br.Instance : br.Vertex) : (d = r.itemSize * i, h = r.isInstancedBufferAttribute ? br.Instance : br.Vertex), r.normalized === !1 && (r.array.constructor === Int16Array || r.array.constructor === Uint16Array) && (d = 4), u = {
          arrayStride: d,
          attributes: [],
          stepMode: h
        }, s.set(a, u);
      }
      const c = this._getVertexFormat(r), l = r.isInterleavedBufferAttribute === !0 ? r.offset * i : 0;
      u.attributes.push({
        shaderLocation: n,
        offset: l,
        format: c
      });
    }
    return Array.from(s.values());
  }
  destroyAttribute(e) {
    const t = this.backend;
    t.get(this._getBufferAttribute(e)).buffer.destroy(), t.delete(e);
  }
  async getArrayBufferAsync(e) {
    const t = this.backend, s = t.device, r = t.get(this._getBufferAttribute(e)).buffer, i = r.size, a = s.createBuffer({
      label: `${e.name}_readback`,
      size: i,
      usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
    }), u = s.createCommandEncoder({
      label: `readback_encoder_${e.name}`
    });
    u.copyBufferToBuffer(
      r,
      0,
      a,
      0,
      i
    );
    const c = u.finish();
    s.queue.submit([c]), await a.mapAsync(GPUMapMode.READ);
    const l = a.getMappedRange(), d = new e.array.constructor(l.slice(0));
    return a.unmap(), d.buffer;
  }
  _getVertexFormat(e) {
    const { itemSize: t, normalized: s } = e, n = e.array.constructor, r = e.constructor;
    let i;
    if (t === 1)
      i = zA.get(n);
    else {
      const u = (kA.get(r) || OA.get(n))[s ? 1 : 0];
      if (u) {
        const c = n.BYTES_PER_ELEMENT * t, d = Math.floor((c + 3) / 4) * 4 / n.BYTES_PER_ELEMENT;
        if (d % 1)
          throw new Error("THREE.WebGPUAttributeUtils: Bad vertex format item size.");
        i = `${u}x${d}`;
      }
    }
    return i || console.error("THREE.WebGPUAttributeUtils: Vertex format not supported yet."), i;
  }
  _isTypedArray(e) {
    return ArrayBuffer.isView(e) && !(e instanceof DataView);
  }
  _getBufferAttribute(e) {
    return e.isInterleavedBufferAttribute && (e = e.data), e;
  }
}
class WA {
  constructor(e) {
    this.backend = e, this.bindGroupLayoutCache = /* @__PURE__ */ new WeakMap();
  }
  createBindingsLayout(e) {
    const t = this.backend, s = t.device, n = [];
    let r = 0;
    for (const i of e.bindings) {
      const a = {
        binding: r++,
        visibility: i.visibility
      };
      if (i.isUniformBuffer || i.isStorageBuffer) {
        const u = {};
        i.isStorageBuffer && (i.visibility & 4 && (i.access === De.READ_WRITE || i.access === De.WRITE_ONLY) ? u.type = co.Storage : u.type = co.ReadOnlyStorage), a.buffer = u;
      } else if (i.isSampler) {
        const u = {};
        i.texture.isDepthTexture && i.texture.compareFunction !== null && (u.type = "comparison"), a.sampler = u;
      } else if (i.isSampledTexture && i.texture.isVideoTexture)
        a.externalTexture = {};
      else if (i.isSampledTexture && i.store) {
        const u = {};
        u.format = this.backend.get(i.texture).texture.format;
        const c = i.access;
        c === De.READ_WRITE ? u.access = lo.ReadWrite : c === De.WRITE_ONLY ? u.access = lo.WriteOnly : u.access = lo.ReadOnly, a.storageTexture = u;
      } else if (i.isSampledTexture) {
        const u = {}, { primarySamples: c } = t.utils.getTextureSampleData(i.texture);
        if (c > 1 && (u.multisampled = !0, i.texture.isDepthTexture || (u.sampleType = Bs.UnfilterableFloat)), i.texture.isDepthTexture)
          u.sampleType = Bs.Depth;
        else if (i.texture.isDataTexture || i.texture.isDataArrayTexture || i.texture.isData3DTexture) {
          const l = i.texture.type;
          l === Ve ? u.sampleType = Bs.SInt : l === Pe ? u.sampleType = Bs.UInt : l === st && (this.backend.hasFeature("float32-filterable") ? u.sampleType = Bs.Float : u.sampleType = Bs.UnfilterableFloat);
        }
        i.isSampledCubeTexture ? u.viewDimension = Oe.Cube : i.texture.isDataArrayTexture || i.texture.isCompressedArrayTexture ? u.viewDimension = Oe.TwoDArray : i.isSampledTexture3D && (u.viewDimension = Oe.ThreeD), a.texture = u;
      } else
        console.error(`WebGPUBindingUtils: Unsupported binding "${i}".`);
      n.push(a);
    }
    return s.createBindGroupLayout({ entries: n });
  }
  createBindings(e, t, s, n = 0) {
    const { backend: r, bindGroupLayoutCache: i } = this, a = r.get(e);
    let u = i.get(e.bindingsReference);
    u === void 0 && (u = this.createBindingsLayout(e), i.set(e.bindingsReference, u));
    let c;
    s > 0 && (a.groups === void 0 && (a.groups = [], a.versions = []), a.versions[s] === n && (c = a.groups[s])), c === void 0 && (c = this.createBindGroup(e, u), s > 0 && (a.groups[s] = c, a.versions[s] = n)), a.group = c, a.layout = u;
  }
  updateBinding(e) {
    const t = this.backend, s = t.device, n = e.buffer, r = t.get(e).buffer;
    s.queue.writeBuffer(r, 0, n, 0);
  }
  createBindGroup(e, t) {
    const s = this.backend, n = s.device;
    let r = 0;
    const i = [];
    for (const a of e.bindings) {
      if (a.isUniformBuffer) {
        const u = s.get(a);
        if (u.buffer === void 0) {
          const c = a.byteLength, l = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST, d = n.createBuffer({
            label: "bindingBuffer_" + a.name,
            size: c,
            usage: l
          });
          u.buffer = d;
        }
        i.push({ binding: r, resource: { buffer: u.buffer } });
      } else if (a.isStorageBuffer) {
        const u = s.get(a);
        if (u.buffer === void 0) {
          const c = a.attribute;
          u.buffer = s.get(c).buffer;
        }
        i.push({ binding: r, resource: { buffer: u.buffer } });
      } else if (a.isSampler) {
        const u = s.get(a.texture);
        i.push({ binding: r, resource: u.sampler });
      } else if (a.isSampledTexture) {
        const u = s.get(a.texture);
        let c;
        if (u.externalTexture !== void 0)
          c = n.importExternalTexture({ source: u.externalTexture });
        else {
          const l = a.store ? 1 : u.texture.mipLevelCount, d = `view-${u.texture.width}-${u.texture.height}-${l}`;
          if (c = u[d], c === void 0) {
            const h = _A.All;
            let p;
            a.isSampledCubeTexture ? p = Oe.Cube : a.isSampledTexture3D ? p = Oe.ThreeD : a.texture.isDataArrayTexture || a.texture.isCompressedArrayTexture ? p = Oe.TwoDArray : p = Oe.TwoD, c = u[d] = u.texture.createView({ aspect: h, dimension: p, mipLevelCount: l });
          }
        }
        i.push({ binding: r, resource: c });
      }
      r++;
    }
    return n.createBindGroup({
      label: "bindGroup_" + e.name,
      layout: t,
      entries: i
    });
  }
}
class HA {
  constructor(e) {
    this.backend = e;
  }
  _getSampleCount(e) {
    return this.backend.utils.getSampleCountRenderContext(e);
  }
  createRenderPipeline(e, t) {
    const { object: s, material: n, geometry: r, pipeline: i } = e, { vertexProgram: a, fragmentProgram: u } = i, c = this.backend, l = c.device, d = c.utils, h = c.get(i), p = [];
    for (const Ye of e.getBindings()) {
      const wt = c.get(Ye);
      p.push(wt.layout);
    }
    const f = c.attributeUtils.createShaderVertexBuffers(e);
    let m;
    n.transparent === !0 && n.blending !== Mn && (m = this._getBlending(n));
    let _ = {};
    n.stencilWrite === !0 && (_ = {
      compare: this._getStencilCompare(n),
      failOp: this._getStencilOperation(n.stencilFail),
      depthFailOp: this._getStencilOperation(n.stencilZFail),
      passOp: this._getStencilOperation(n.stencilZPass)
    });
    const S = this._getColorWriteMask(n), A = [];
    if (e.context.textures !== null) {
      const Ye = e.context.textures;
      for (let wt = 0; wt < Ye.length; wt++) {
        const vs = d.getTextureFormatGPU(Ye[wt]);
        A.push({
          format: vs,
          blend: m,
          writeMask: S
        });
      }
    } else {
      const Ye = d.getCurrentColorFormat(e.context);
      A.push({
        format: Ye,
        blend: m,
        writeMask: S
      });
    }
    const M = c.get(a).module, F = c.get(u).module, D = this._getPrimitiveState(s, r, n), P = this._getDepthCompare(n), V = d.getCurrentDepthStencilFormat(e.context), k = this._getSampleCount(e.context), ie = {
      label: `renderPipeline_${n.name || n.type}_${n.id}`,
      vertex: Object.assign({}, M, { buffers: f }),
      fragment: Object.assign({}, F, { targets: A }),
      primitive: D,
      multisample: {
        count: k,
        alphaToCoverageEnabled: n.alphaToCoverage && k > 1
      },
      layout: l.createPipelineLayout({
        bindGroupLayouts: p
      })
    }, me = {}, ne = e.context.depth, Ke = e.context.stencil;
    if ((ne === !0 || Ke === !0) && (ne === !0 && (me.format = V, me.depthWriteEnabled = n.depthWrite, me.depthCompare = P), Ke === !0 && (me.stencilFront = _, me.stencilBack = {}, me.stencilReadMask = n.stencilFuncMask, me.stencilWriteMask = n.stencilWriteMask), ie.depthStencil = me), t === null)
      h.pipeline = l.createRenderPipeline(ie);
    else {
      const Ye = new Promise((wt) => {
        l.createRenderPipelineAsync(ie).then((vs) => {
          h.pipeline = vs, wt();
        });
      });
      t.push(Ye);
    }
  }
  createBundleEncoder(e) {
    const t = this.backend, { utils: s, device: n } = t, r = s.getCurrentDepthStencilFormat(e), i = s.getCurrentColorFormat(e), a = this._getSampleCount(e), u = {
      label: "renderBundleEncoder",
      colorFormats: [i],
      depthStencilFormat: r,
      sampleCount: a
    };
    return n.createRenderBundleEncoder(u);
  }
  createComputePipeline(e, t) {
    const s = this.backend, n = s.device, r = s.get(e.computeProgram).module, i = s.get(e), a = [];
    for (const u of t) {
      const c = s.get(u);
      a.push(c.layout);
    }
    i.pipeline = n.createComputePipeline({
      compute: r,
      layout: n.createPipelineLayout({
        bindGroupLayouts: a
      })
    });
  }
  _getBlending(e) {
    let t, s;
    const n = e.blending, r = e.blendSrc, i = e.blendDst, a = e.blendEquation;
    if (n === il) {
      const u = e.blendSrcAlpha !== null ? e.blendSrcAlpha : r, c = e.blendDstAlpha !== null ? e.blendDstAlpha : i, l = e.blendEquationAlpha !== null ? e.blendEquationAlpha : a;
      t = {
        srcFactor: this._getBlendFactor(r),
        dstFactor: this._getBlendFactor(i),
        operation: this._getBlendOperation(a)
      }, s = {
        srcFactor: this._getBlendFactor(u),
        dstFactor: this._getBlendFactor(c),
        operation: this._getBlendOperation(l)
      };
    } else {
      const u = e.premultipliedAlpha, c = (l, d, h, p) => {
        t = {
          srcFactor: l,
          dstFactor: d,
          operation: ns.Add
        }, s = {
          srcFactor: h,
          dstFactor: p,
          operation: ns.Add
        };
      };
      if (u)
        switch (n) {
          case zs:
            c(W.One, W.OneMinusSrcAlpha, W.One, W.OneMinusSrcAlpha);
            break;
          case Lr:
            c(W.One, W.One, W.One, W.One);
            break;
          case Ir:
            c(W.Zero, W.OneMinusSrc, W.Zero, W.One);
            break;
          case Dr:
            c(W.Zero, W.Src, W.Zero, W.SrcAlpha);
            break;
        }
      else
        switch (n) {
          case zs:
            c(W.SrcAlpha, W.OneMinusSrcAlpha, W.One, W.OneMinusSrcAlpha);
            break;
          case Lr:
            c(W.SrcAlpha, W.One, W.SrcAlpha, W.One);
            break;
          case Ir:
            c(W.Zero, W.OneMinusSrc, W.Zero, W.One);
            break;
          case Dr:
            c(W.Zero, W.Src, W.Zero, W.Src);
            break;
        }
    }
    if (t !== void 0 && s !== void 0)
      return { color: t, alpha: s };
    console.error("THREE.WebGPURenderer: Invalid blending: ", n);
  }
  _getBlendFactor(e) {
    let t;
    switch (e) {
      case Kc:
        t = W.Zero;
        break;
      case Yc:
        t = W.One;
        break;
      case jc:
        t = W.Src;
        break;
      case tl:
        t = W.OneMinusSrc;
        break;
      case Qc:
        t = W.SrcAlpha;
        break;
      case sl:
        t = W.OneMinusSrcAlpha;
        break;
      case Jc:
        t = W.Dst;
        break;
      case nl:
        t = W.OneMinusDstColor;
        break;
      case el:
        t = W.DstAlpha;
        break;
      case rl:
        t = W.OneMinusDstAlpha;
        break;
      case Zc:
        t = W.SrcAlphaSaturated;
        break;
      case t_:
        t = W.Constant;
        break;
      case s_:
        t = W.OneMinusConstant;
        break;
      default:
        console.error("THREE.WebGPURenderer: Blend factor not supported.", e);
    }
    return t;
  }
  _getStencilCompare(e) {
    let t;
    const s = e.stencilFunc;
    switch (s) {
      case lm:
        t = we.Never;
        break;
      case cm:
        t = we.Always;
        break;
      case um:
        t = we.Less;
        break;
      case am:
        t = we.LessEqual;
        break;
      case om:
        t = we.Equal;
        break;
      case im:
        t = we.GreaterEqual;
        break;
      case rm:
        t = we.Greater;
        break;
      case nm:
        t = we.NotEqual;
        break;
      default:
        console.error("THREE.WebGPURenderer: Invalid stencil function.", s);
    }
    return t;
  }
  _getStencilOperation(e) {
    let t;
    switch (e) {
      case xm:
        t = Wt.Keep;
        break;
      case ym:
        t = Wt.Zero;
        break;
      case mm:
        t = Wt.Replace;
        break;
      case gm:
        t = Wt.Invert;
        break;
      case fm:
        t = Wt.IncrementClamp;
        break;
      case pm:
        t = Wt.DecrementClamp;
        break;
      case hm:
        t = Wt.IncrementWrap;
        break;
      case dm:
        t = Wt.DecrementWrap;
        break;
      default:
        console.error("THREE.WebGPURenderer: Invalid stencil operation.", t);
    }
    return t;
  }
  _getBlendOperation(e) {
    let t;
    switch (e) {
      case Us:
        t = ns.Add;
        break;
      case qc:
        t = ns.Subtract;
        break;
      case Xc:
        t = ns.ReverseSubtract;
        break;
      case _m:
        t = ns.Min;
        break;
      case Tm:
        t = ns.Max;
        break;
      default:
        console.error("THREE.WebGPUPipelineUtils: Blend equation not supported.", e);
    }
    return t;
  }
  _getPrimitiveState(e, t, s) {
    const n = {}, r = this.backend.utils;
    switch (n.topology = r.getPrimitiveTopology(e, s), t.index !== null && e.isLine === !0 && e.isLineSegments !== !0 && (n.stripIndexFormat = t.index.array instanceof Uint16Array ? tn.Uint16 : tn.Uint32), s.side) {
      case ho:
        n.frontFace = oo.CCW, n.cullMode = ao.Back;
        break;
      case Tt:
        n.frontFace = oo.CCW, n.cullMode = ao.Front;
        break;
      case Ws:
        n.frontFace = oo.CCW, n.cullMode = ao.None;
        break;
      default:
        console.error("THREE.WebGPUPipelineUtils: Unknown material.side value.", s.side);
        break;
    }
    return n;
  }
  _getColorWriteMask(e) {
    return e.colorWrite === !0 ? Uc.All : Uc.None;
  }
  _getDepthCompare(e) {
    let t;
    if (e.depthTest === !1)
      t = we.Always;
    else {
      const s = e.depthFunc;
      switch (s) {
        case pl:
          t = we.Never;
          break;
        case hl:
          t = we.Always;
          break;
        case dl:
          t = we.Less;
          break;
        case ll:
          t = we.LessEqual;
          break;
        case cl:
          t = we.Equal;
          break;
        case ul:
          t = we.GreaterEqual;
          break;
        case al:
          t = we.Greater;
          break;
        case ol:
          t = we.NotEqual;
          break;
        default:
          console.error("THREE.WebGPUPipelineUtils: Invalid depth function.", s);
      }
    }
    return t;
  }
}
class qA extends sg {
  /**
   * Constructs a new WebGPU backend.
   *
   * @param {Object} parameters - The configuration parameter.
   * @param {Boolean} [parameters.logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @param {Boolean} [parameters.alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @param {Boolean} [parameters.depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @param {Boolean} [parameters.stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @param {Boolean} [parameters.antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @param {Number} [parameters.samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
   * @param {Boolean} [parameters.forceWebGL=false] - If set to `true`, the renderer uses it WebGL 2 backend no matter if WebGPU is supported or not.
   * @param {Boolean} [parameters.trackTimestamp=false] - Whether to track timestamps with a Timestamp Query API or not.
   * @param {String?} [parameters.powerPreference=null] - The power preference.
   * @param {String?} [parameters.requiredLimits={}] - Specifies the limits that are required by the device request.
   * The request will fail if the adapter cannot provide these limits.
   */
  constructor(e = {}) {
    super(e), this.isWebGPUBackend = !0, this.parameters.alpha = e.alpha === void 0 ? !0 : e.alpha, this.parameters.requiredLimits = e.requiredLimits === void 0 ? {} : e.requiredLimits, this.trackTimestamp = e.trackTimestamp === !0, this.device = null, this.context = null, this.colorBuffer = null, this.defaultRenderPassdescriptor = null, this.utils = new GA(this), this.attributeUtils = new $A(this), this.bindingUtils = new WA(this), this.pipelineUtils = new HA(this), this.textureUtils = new wA(this), this.occludedResolveCache = /* @__PURE__ */ new Map();
  }
  /**
   * Initializes the backend so it is ready for usage.
   *
   * @async
   * @param {Renderer} renderer - The renderer.
   * @return {Promise} A Promise that resolves when the backend has been initialized.
   */
  async init(e) {
    await super.init(e);
    const t = this.parameters;
    let s;
    if (t.device === void 0) {
      const i = {
        powerPreference: t.powerPreference
      }, a = typeof navigator < "u" ? await navigator.gpu.requestAdapter(i) : null;
      if (a === null)
        throw new Error("WebGPUBackend: Unable to create WebGPU adapter.");
      const u = Object.values(Qo), c = [];
      for (const d of u)
        a.features.has(d) && c.push(d);
      const l = {
        requiredFeatures: c,
        requiredLimits: t.requiredLimits
      };
      s = await a.requestDevice(l);
    } else
      s = t.device;
    s.lost.then((i) => {
      const a = {
        api: "WebGPU",
        message: i.message || "Unknown reason",
        reason: i.reason || null,
        originalEvent: i
      };
      e.onDeviceLost(a);
    });
    const n = t.context !== void 0 ? t.context : e.domElement.getContext("webgpu");
    this.device = s, this.context = n;
    const r = t.alpha ? "premultiplied" : "opaque";
    this.trackTimestamp = this.trackTimestamp && this.hasFeature(Qo.TimestampQuery), this.context.configure({
      device: this.device,
      format: this.utils.getPreferredCanvasFormat(),
      usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
      alphaMode: r
    }), this.updateSize();
  }
  /**
   * The coordinate system of the backend.
   *
   * @type {Number}
   * @readonly
   */
  get coordinateSystem() {
    return sn;
  }
  /**
   * Transfers buffer data from a storage buffer attribute
   * from the GPU to the CPU in context of compute shaders.
   *
   * @async
   * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
   * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
   */
  async getArrayBufferAsync(e) {
    return await this.attributeUtils.getArrayBufferAsync(e);
  }
  /**
   * Returns the backend's rendering context.
   *
   * @return {GPUCanvasContext} The rendering context.
   */
  getContext() {
    return this.context;
  }
  /**
   * Returns the default render pass descriptor.
   *
   * In WebGPU, the default framebuffer must be configured
   * like custom fraemebuffers so the backend needs a render
   * pass descriptor even when rendering directly to screen.
   *
   * @private
   * @return {Object} The render pass descriptor.
   */
  _getDefaultRenderPassDescriptor() {
    let e = this.defaultRenderPassdescriptor;
    if (e === null) {
      const s = this.renderer;
      e = {
        colorAttachments: [{
          view: null
        }]
      }, (this.renderer.depth === !0 || this.renderer.stencil === !0) && (e.depthStencilAttachment = {
        view: this.textureUtils.getDepthBuffer(s.depth, s.stencil).createView()
      });
      const n = e.colorAttachments[0];
      this.renderer.samples > 0 ? n.view = this.colorBuffer.createView() : n.resolveTarget = void 0, this.defaultRenderPassdescriptor = e;
    }
    const t = e.colorAttachments[0];
    return this.renderer.samples > 0 ? t.resolveTarget = this.context.getCurrentTexture().createView() : t.view = this.context.getCurrentTexture().createView(), e;
  }
  /**
   * Returns the render pass descriptor for the given render context.
   *
   * @private
   * @param {RenderContext} renderContext - The render context.
   * @param {Object} colorAttachmentsConfig - Configuration object for the color attachments.
   * @return {Object} The render pass descriptor.
   */
  _getRenderPassDescriptor(e, t = {}) {
    const s = e.renderTarget, n = this.get(s);
    let r = n.descriptors;
    if (r === void 0 || n.width !== s.width || n.height !== s.height || n.dimensions !== s.dimensions || n.activeMipmapLevel !== s.activeMipmapLevel || n.activeCubeFace !== e.activeCubeFace || n.samples !== s.samples || n.loadOp !== t.loadOp) {
      r = {}, n.descriptors = r;
      const u = () => {
        s.removeEventListener("dispose", u), this.delete(s);
      };
      s.addEventListener("dispose", u);
    }
    const i = e.getCacheKey();
    let a = r[i];
    if (a === void 0) {
      const u = e.textures, c = [];
      let l;
      for (let d = 0; d < u.length; d++) {
        const h = this.get(u[d]), p = {
          label: `colorAttachment_${d}`,
          baseMipLevel: e.activeMipmapLevel,
          mipLevelCount: 1,
          baseArrayLayer: e.activeCubeFace,
          arrayLayerCount: 1,
          dimension: Oe.TwoD
        };
        s.isRenderTarget3D ? (l = e.activeCubeFace, p.baseArrayLayer = 0, p.dimension = Oe.ThreeD, p.depthOrArrayLayers = u[d].image.depth) : s.isRenderTargetArray && (p.dimension = Oe.TwoDArray, p.depthOrArrayLayers = u[d].image.depth);
        const f = h.texture.createView(p);
        let m, _;
        h.msaaTexture !== void 0 ? (m = h.msaaTexture.createView(), _ = f) : (m = f, _ = void 0), c.push({
          view: m,
          depthSlice: l,
          resolveTarget: _,
          loadOp: ye.Load,
          storeOp: Fe.Store,
          ...t
        });
      }
      if (a = {
        colorAttachments: c
      }, e.depth) {
        const h = {
          view: this.get(e.depthTexture).texture.createView()
        };
        a.depthStencilAttachment = h;
      }
      r[i] = a, n.width = s.width, n.height = s.height, n.samples = s.samples, n.activeMipmapLevel = e.activeMipmapLevel, n.activeCubeFace = e.activeCubeFace, n.dimensions = s.dimensions, n.depthSlice = l, n.loadOp = c[0].loadOp;
    }
    return a;
  }
  /**
   * This method is executed at the beginning of a render call and prepares
   * the WebGPU state for upcoming render calls
   *
   * @param {RenderContext} renderContext - The render context.
   */
  beginRender(e) {
    const t = this.get(e), s = this.device, n = e.occlusionQueryCount;
    let r;
    n > 0 && (t.currentOcclusionQuerySet && t.currentOcclusionQuerySet.destroy(), t.currentOcclusionQueryBuffer && t.currentOcclusionQueryBuffer.destroy(), t.currentOcclusionQuerySet = t.occlusionQuerySet, t.currentOcclusionQueryBuffer = t.occlusionQueryBuffer, t.currentOcclusionQueryObjects = t.occlusionQueryObjects, r = s.createQuerySet({ type: "occlusion", count: n, label: `occlusionQuerySet_${e.id}` }), t.occlusionQuerySet = r, t.occlusionQueryIndex = 0, t.occlusionQueryObjects = new Array(n), t.lastOcclusionObject = null);
    let i;
    e.textures === null ? i = this._getDefaultRenderPassDescriptor() : i = this._getRenderPassDescriptor(e, { loadOp: ye.Load }), this.initTimestampQuery(e, i), i.occlusionQuerySet = r;
    const a = i.depthStencilAttachment;
    if (e.textures !== null) {
      const l = i.colorAttachments;
      for (let d = 0; d < l.length; d++) {
        const h = l[d];
        e.clearColor ? (h.clearValue = d === 0 ? e.clearColorValue : { r: 0, g: 0, b: 0, a: 1 }, h.loadOp = ye.Clear, h.storeOp = Fe.Store) : (h.loadOp = ye.Load, h.storeOp = Fe.Store);
      }
    } else {
      const l = i.colorAttachments[0];
      e.clearColor ? (l.clearValue = e.clearColorValue, l.loadOp = ye.Clear, l.storeOp = Fe.Store) : (l.loadOp = ye.Load, l.storeOp = Fe.Store);
    }
    e.depth && (e.clearDepth ? (a.depthClearValue = e.clearDepthValue, a.depthLoadOp = ye.Clear, a.depthStoreOp = Fe.Store) : (a.depthLoadOp = ye.Load, a.depthStoreOp = Fe.Store)), e.stencil && (e.clearStencil ? (a.stencilClearValue = e.clearStencilValue, a.stencilLoadOp = ye.Clear, a.stencilStoreOp = Fe.Store) : (a.stencilLoadOp = ye.Load, a.stencilStoreOp = Fe.Store));
    const u = s.createCommandEncoder({ label: "renderContext_" + e.id }), c = u.beginRenderPass(i);
    if (t.descriptor = i, t.encoder = u, t.currentPass = c, t.currentSets = { attributes: {}, bindingGroups: [], pipeline: null, index: null }, t.renderBundles = [], e.viewport && this.updateViewport(e), e.scissor) {
      const { x: l, y: d, width: h, height: p } = e.scissorValue;
      c.setScissorRect(l, d, h, p);
    }
  }
  /**
   * This method is executed at the end of a render call and finalizes work
   * after draw calls.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  finishRender(e) {
    const t = this.get(e), s = e.occlusionQueryCount;
    if (t.renderBundles.length > 0 && t.currentPass.executeBundles(t.renderBundles), s > t.occlusionQueryIndex && t.currentPass.endOcclusionQuery(), t.currentPass.end(), s > 0) {
      const n = s * 8;
      let r = this.occludedResolveCache.get(n);
      r === void 0 && (r = this.device.createBuffer(
        {
          size: n,
          usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
        }
      ), this.occludedResolveCache.set(n, r));
      const i = this.device.createBuffer(
        {
          size: n,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }
      );
      t.encoder.resolveQuerySet(t.occlusionQuerySet, 0, s, r, 0), t.encoder.copyBufferToBuffer(r, 0, i, 0, n), t.occlusionQueryBuffer = i, this.resolveOccludedAsync(e);
    }
    if (this.prepareTimestampBuffer(e, t.encoder), this.device.queue.submit([t.encoder.finish()]), e.textures !== null) {
      const n = e.textures;
      for (let r = 0; r < n.length; r++) {
        const i = n[r];
        i.generateMipmaps === !0 && this.textureUtils.generateMipmaps(i);
      }
    }
  }
  /**
   * Returns `true` if the given 3D object is fully occluded by other
   * 3D objects in the scene.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object3D} object - The 3D object to test.
   * @return {Boolean} Whether the 3D object is fully occluded or not.
   */
  isOccluded(e, t) {
    const s = this.get(e);
    return s.occluded && s.occluded.has(t);
  }
  /**
   * This method processes the result of occlusion queries and writes it
   * into render context data.
   *
   * @async
   * @param {RenderContext} renderContext - The render context.
   */
  async resolveOccludedAsync(e) {
    const t = this.get(e), { currentOcclusionQueryBuffer: s, currentOcclusionQueryObjects: n } = t;
    if (s && n) {
      const r = /* @__PURE__ */ new WeakSet();
      t.currentOcclusionQueryObjects = null, t.currentOcclusionQueryBuffer = null, await s.mapAsync(GPUMapMode.READ);
      const i = s.getMappedRange(), a = new BigUint64Array(i);
      for (let u = 0; u < n.length; u++)
        a[u] !== BigInt(0) && r.add(n[u]);
      s.destroy(), t.occluded = r;
    }
  }
  /**
   * Updates the viewport with the values from the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  updateViewport(e) {
    const { currentPass: t } = this.get(e), { x: s, y: n, width: r, height: i, minDepth: a, maxDepth: u } = e.viewportValue;
    t.setViewport(s, n, r, i, a, u);
  }
  /**
   * Performs a clear operation.
   *
   * @param {Boolean} color - Whether the color buffer should be cleared or not.
   * @param {Boolean} depth - Whether the depth buffer should be cleared or not.
   * @param {Boolean} stencil - Whether the stencil buffer should be cleared or not.
   * @param {RenderContext?} [renderTargetContext=null] - The render context of the current set render target.
   */
  clear(e, t, s, n = null) {
    const r = this.device, i = this.renderer;
    let a = [], u, c, l, d;
    if (e) {
      const f = this.getClearColor();
      if (this.renderer.alpha === !0) {
        const m = f.a;
        c = { r: f.r * m, g: f.g * m, b: f.b * m, a: m };
      } else
        c = { r: f.r, g: f.g, b: f.b, a: f.a };
    }
    if (n === null) {
      l = i.depth, d = i.stencil;
      const f = this._getDefaultRenderPassDescriptor();
      if (e) {
        a = f.colorAttachments;
        const m = a[0];
        m.clearValue = c, m.loadOp = ye.Clear, m.storeOp = Fe.Store;
      }
      (l || d) && (u = f.depthStencilAttachment);
    } else
      l = n.depth, d = n.stencil, e && (a = this._getRenderPassDescriptor(n, { loadOp: ye.Clear }).colorAttachments), (l || d) && (u = {
        view: this.get(n.depthTexture).texture.createView()
      });
    l && (t ? (u.depthLoadOp = ye.Clear, u.depthClearValue = i.getClearDepth(), u.depthStoreOp = Fe.Store) : (u.depthLoadOp = ye.Load, u.depthStoreOp = Fe.Store)), d && (s ? (u.stencilLoadOp = ye.Clear, u.stencilClearValue = i.getClearStencil(), u.stencilStoreOp = Fe.Store) : (u.stencilLoadOp = ye.Load, u.stencilStoreOp = Fe.Store));
    const h = r.createCommandEncoder({});
    h.beginRenderPass({
      colorAttachments: a,
      depthStencilAttachment: u
    }).end(), r.queue.submit([h.finish()]);
  }
  // compute
  /**
   * This method is executed at the beginning of a compute call and
   * prepares the state for upcoming compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */
  beginCompute(e) {
    const t = this.get(e), s = {};
    this.initTimestampQuery(e, s), t.cmdEncoderGPU = this.device.createCommandEncoder(), t.passEncoderGPU = t.cmdEncoderGPU.beginComputePass(s);
  }
  /**
   * Executes a compute command for the given compute node.
   *
   * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
   * @param {Node} computeNode - The compute node.
   * @param {Array<BindGroup>} bindings - The bindings.
   * @param {ComputePipeline} pipeline - The compute pipeline.
   */
  compute(e, t, s, n) {
    const { passEncoderGPU: r } = this.get(e), i = this.get(n).pipeline;
    r.setPipeline(i);
    for (let l = 0, d = s.length; l < d; l++) {
      const h = s[l], p = this.get(h);
      r.setBindGroup(l, p.group);
    }
    const a = this.device.limits.maxComputeWorkgroupsPerDimension, u = this.get(t);
    u.dispatchSize === void 0 && (u.dispatchSize = { x: 0, y: 1, z: 1 });
    const { dispatchSize: c } = u;
    t.dispatchCount > a ? (c.x = Math.min(t.dispatchCount, a), c.y = Math.ceil(t.dispatchCount / a)) : c.x = t.dispatchCount, r.dispatchWorkgroups(
      c.x,
      c.y,
      c.z
    );
  }
  /**
   * This method is executed at the end of a compute call and
   * finalizes work after compute tasks.
   *
   * @param {Node|Array<Node>} computeGroup - The compute node(s).
   */
  finishCompute(e) {
    const t = this.get(e);
    t.passEncoderGPU.end(), this.prepareTimestampBuffer(e, t.cmdEncoderGPU), this.device.queue.submit([t.cmdEncoderGPU.finish()]);
  }
  /**
   * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
   * the CPU waits for the GPU to complete its operation (e.g. a compute task).
   *
   * @async
   * @return {Promise} A Promise that resolves when synchronization has been finished.
   */
  async waitForGPU() {
    await this.device.queue.onSubmittedWorkDone();
  }
  // render object
  /**
   * Executes a draw command for the given render object.
   *
   * @param {RenderObject} renderObject - The render object to draw.
   * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
   */
  draw(e, t) {
    const { object: s, context: n, pipeline: r } = e, i = e.getBindings(), a = this.get(n), u = this.get(r).pipeline, c = a.currentSets, l = a.currentPass, d = e.getDrawParameters();
    if (d === null) return;
    c.pipeline !== u && (l.setPipeline(u), c.pipeline = u);
    const h = c.bindingGroups;
    for (let _ = 0, S = i.length; _ < S; _++) {
      const A = i[_], M = this.get(A);
      h[A.index] !== A.id && (l.setBindGroup(A.index, M.group), h[A.index] = A.id);
    }
    const p = e.getIndex(), f = p !== null;
    if (f === !0 && c.index !== p) {
      const _ = this.get(p).buffer, S = p.array instanceof Uint16Array ? tn.Uint16 : tn.Uint32;
      l.setIndexBuffer(_, S), c.index = p;
    }
    const m = e.getVertexBuffers();
    for (let _ = 0, S = m.length; _ < S; _++) {
      const A = m[_];
      if (c.attributes[_] !== A) {
        const M = this.get(A).buffer;
        l.setVertexBuffer(_, M), c.attributes[_] = A;
      }
    }
    if (a.occlusionQuerySet !== void 0) {
      const _ = a.lastOcclusionObject;
      _ !== s && (_ !== null && _.occlusionTest === !0 && (l.endOcclusionQuery(), a.occlusionQueryIndex++), s.occlusionTest === !0 && (l.beginOcclusionQuery(a.occlusionQueryIndex), a.occlusionQueryObjects[a.occlusionQueryIndex] = s), a.lastOcclusionObject = s);
    }
    if (s.isBatchedMesh === !0) {
      const _ = s._multiDrawStarts, S = s._multiDrawCounts, A = s._multiDrawCount, M = s._multiDrawInstances;
      for (let F = 0; F < A; F++) {
        const D = M ? M[F] : 1, P = D > 1 ? 0 : F;
        f === !0 ? l.drawIndexed(S[F], D, _[F] / p.array.BYTES_PER_ELEMENT, 0, P) : l.draw(S[F], D, _[F], P);
      }
    } else if (f === !0) {
      const { vertexCount: _, instanceCount: S, firstVertex: A } = d, M = e.getIndirect();
      if (M !== null) {
        const F = this.get(M).buffer;
        l.drawIndexedIndirect(F, 0);
      } else
        l.drawIndexed(_, S, A, 0, 0);
      t.update(s, _, S);
    } else {
      const { vertexCount: _, instanceCount: S, firstVertex: A } = d, M = e.getIndirect();
      if (M !== null) {
        const F = this.get(M).buffer;
        l.drawIndirect(F, 0);
      } else
        l.draw(_, S, A, 0);
      t.update(s, _, S);
    }
  }
  // cache key
  /**
   * Returns `true` if the render pipeline requires an update.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {Boolean} Whether the render pipeline requires an update or not.
   */
  needsRenderUpdate(e) {
    const t = this.get(e), { object: s, material: n } = e, r = this.utils, i = r.getSampleCountRenderContext(e.context), a = r.getCurrentColorSpace(e.context), u = r.getCurrentColorFormat(e.context), c = r.getCurrentDepthStencilFormat(e.context), l = r.getPrimitiveTopology(s, n);
    let d = !1;
    return (t.material !== n || t.materialVersion !== n.version || t.transparent !== n.transparent || t.blending !== n.blending || t.premultipliedAlpha !== n.premultipliedAlpha || t.blendSrc !== n.blendSrc || t.blendDst !== n.blendDst || t.blendEquation !== n.blendEquation || t.blendSrcAlpha !== n.blendSrcAlpha || t.blendDstAlpha !== n.blendDstAlpha || t.blendEquationAlpha !== n.blendEquationAlpha || t.colorWrite !== n.colorWrite || t.depthWrite !== n.depthWrite || t.depthTest !== n.depthTest || t.depthFunc !== n.depthFunc || t.stencilWrite !== n.stencilWrite || t.stencilFunc !== n.stencilFunc || t.stencilFail !== n.stencilFail || t.stencilZFail !== n.stencilZFail || t.stencilZPass !== n.stencilZPass || t.stencilFuncMask !== n.stencilFuncMask || t.stencilWriteMask !== n.stencilWriteMask || t.side !== n.side || t.alphaToCoverage !== n.alphaToCoverage || t.sampleCount !== i || t.colorSpace !== a || t.colorFormat !== u || t.depthStencilFormat !== c || t.primitiveTopology !== l || t.clippingContextCacheKey !== e.clippingContextCacheKey) && (t.material = n, t.materialVersion = n.version, t.transparent = n.transparent, t.blending = n.blending, t.premultipliedAlpha = n.premultipliedAlpha, t.blendSrc = n.blendSrc, t.blendDst = n.blendDst, t.blendEquation = n.blendEquation, t.blendSrcAlpha = n.blendSrcAlpha, t.blendDstAlpha = n.blendDstAlpha, t.blendEquationAlpha = n.blendEquationAlpha, t.colorWrite = n.colorWrite, t.depthWrite = n.depthWrite, t.depthTest = n.depthTest, t.depthFunc = n.depthFunc, t.stencilWrite = n.stencilWrite, t.stencilFunc = n.stencilFunc, t.stencilFail = n.stencilFail, t.stencilZFail = n.stencilZFail, t.stencilZPass = n.stencilZPass, t.stencilFuncMask = n.stencilFuncMask, t.stencilWriteMask = n.stencilWriteMask, t.side = n.side, t.alphaToCoverage = n.alphaToCoverage, t.sampleCount = i, t.colorSpace = a, t.colorFormat = u, t.depthStencilFormat = c, t.primitiveTopology = l, t.clippingContextCacheKey = e.clippingContextCacheKey, d = !0), d;
  }
  /**
   * Returns a cache key that is used to identify render pipelines.
   *
   * @param {RenderObject} renderObject - The render object.
   * @return {String} The cache key.
   */
  getRenderCacheKey(e) {
    const { object: t, material: s } = e, n = this.utils, r = e.context;
    return [
      s.transparent,
      s.blending,
      s.premultipliedAlpha,
      s.blendSrc,
      s.blendDst,
      s.blendEquation,
      s.blendSrcAlpha,
      s.blendDstAlpha,
      s.blendEquationAlpha,
      s.colorWrite,
      s.depthWrite,
      s.depthTest,
      s.depthFunc,
      s.stencilWrite,
      s.stencilFunc,
      s.stencilFail,
      s.stencilZFail,
      s.stencilZPass,
      s.stencilFuncMask,
      s.stencilWriteMask,
      s.side,
      n.getSampleCountRenderContext(r),
      n.getCurrentColorSpace(r),
      n.getCurrentColorFormat(r),
      n.getCurrentDepthStencilFormat(r),
      n.getPrimitiveTopology(t, s),
      e.getGeometryCacheKey(),
      e.clippingContextCacheKey
    ].join();
  }
  // textures
  /**
   * Creates a sampler for the given texture.
   *
   * @param {Texture} texture - The texture to create the sampler for.
   */
  createSampler(e) {
    this.textureUtils.createSampler(e);
  }
  /**
   * Destroys the sampler for the given texture.
   *
   * @param {Texture} texture - The texture to destroy the sampler for.
   */
  destroySampler(e) {
    this.textureUtils.destroySampler(e);
  }
  /**
   * Creates a default texture for the given texture that can be used
   * as a placeholder until the actual texture is ready for usage.
   *
   * @param {Texture} texture - The texture to create a default texture for.
   */
  createDefaultTexture(e) {
    this.textureUtils.createDefaultTexture(e);
  }
  /**
   * Defines a texture on the GPU for the given texture object.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */
  createTexture(e, t) {
    this.textureUtils.createTexture(e, t);
  }
  /**
   * Uploads the updated texture data to the GPU.
   *
   * @param {Texture} texture - The texture.
   * @param {Object} [options={}] - Optional configuration parameter.
   */
  updateTexture(e, t) {
    this.textureUtils.updateTexture(e, t);
  }
  /**
   * Generates mipmaps for the given texture
   *
   * @param {Texture} texture - The texture.
   */
  generateMipmaps(e) {
    this.textureUtils.generateMipmaps(e);
  }
  /**
   * Destroys the GPU data for the given texture object.
   *
   * @param {Texture} texture - The texture.
   */
  destroyTexture(e) {
    this.textureUtils.destroyTexture(e);
  }
  /**
   * Returns texture data as a typed array.
   *
   * @param {Texture} texture - The texture to copy.
   * @param {Number} x - The x coordinate of the copy origin.
   * @param {Number} y - The y coordinate of the copy origin.
   * @param {Number} width - The width of the copy.
   * @param {Number} height - The height of the copy.
   * @param {Number} faceIndex - The face index.
   * @return {TypedArray} The texture data as a typed array.
   */
  copyTextureToBuffer(e, t, s, n, r, i) {
    return this.textureUtils.copyTextureToBuffer(e, t, s, n, r, i);
  }
  /**
   * Inits a time stamp query for the given render context.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {Object} descriptor - The query descriptor.
   */
  initTimestampQuery(e, t) {
    if (!this.trackTimestamp) return;
    const s = this.get(e);
    if (!s.timeStampQuerySet) {
      const n = e.isComputeNode ? "compute" : "render", r = this.device.createQuerySet({ type: "timestamp", count: 2, label: `timestamp_${n}_${e.id}` });
      Object.assign(t, { timestampWrites: {
        querySet: r,
        beginningOfPassWriteIndex: 0,
        // Write timestamp in index 0 when pass begins.
        endOfPassWriteIndex: 1
        // Write timestamp in index 1 when pass ends.
      } }), s.timeStampQuerySet = r;
    }
  }
  /**
   * Prepares the timestamp buffer.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {GPUCommandEncoder} encoder - The command encoder.
   */
  prepareTimestampBuffer(e, t) {
    if (!this.trackTimestamp) return;
    const s = this.get(e), n = 2 * BigInt64Array.BYTES_PER_ELEMENT;
    s.currentTimestampQueryBuffers === void 0 && (s.currentTimestampQueryBuffers = {
      resolveBuffer: this.device.createBuffer({
        label: "timestamp resolve buffer",
        size: n,
        usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
      }),
      resultBuffer: this.device.createBuffer({
        label: "timestamp result buffer",
        size: n,
        usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
      })
    });
    const { resolveBuffer: r, resultBuffer: i } = s.currentTimestampQueryBuffers;
    t.resolveQuerySet(s.timeStampQuerySet, 0, 2, r, 0), i.mapState === "unmapped" && t.copyBufferToBuffer(r, 0, i, 0, n);
  }
  /**
   * Resolves the time stamp for the given render context and type.
   *
   * @async
   * @param {RenderContext} renderContext - The render context.
   * @param {String} type - The render context.
   * @return {Promise} A Promise that resolves when the time stamp has been computed.
   */
  async resolveTimestampAsync(e, t = "render") {
    if (!this.trackTimestamp) return;
    const s = this.get(e);
    if (s.currentTimestampQueryBuffers === void 0) return;
    const { resultBuffer: n } = s.currentTimestampQueryBuffers;
    n.mapState === "unmapped" && n.mapAsync(GPUMapMode.READ).then(() => {
      const r = new BigUint64Array(n.getMappedRange()), i = Number(r[1] - r[0]) / 1e6;
      this.renderer.info.updateTimestamp(t, i), n.unmap();
    });
  }
  // node builder
  /**
   * Returns a node builder for the given render object.
   *
   * @param {RenderObject} object - The render object.
   * @param {Renderer} renderer - The renderer.
   * @return {WGSLNodeBuilder} The node builder.
   */
  createNodeBuilder(e, t) {
    return new VA(e, t);
  }
  // program
  /**
   * Creates a shader program from the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */
  createProgram(e) {
    const t = this.get(e);
    t.module = {
      module: this.device.createShaderModule({ code: e.code, label: e.stage + (e.name !== "" ? `_${e.name}` : "") }),
      entryPoint: "main"
    };
  }
  /**
   * Destroys the shader program of the given programmable stage.
   *
   * @param {ProgrammableStage} program - The programmable stage.
   */
  destroyProgram(e) {
    this.delete(e);
  }
  // pipelines
  /**
   * Creates a render pipeline for the given render object.
   *
   * @param {RenderObject} renderObject - The render object.
   * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
   */
  createRenderPipeline(e, t) {
    this.pipelineUtils.createRenderPipeline(e, t);
  }
  /**
   * Creates a compute pipeline for the given compute node.
   *
   * @param {ComputePipeline} computePipeline - The compute pipeline.
   * @param {Array<BindGroup>} bindings - The bindings.
   */
  createComputePipeline(e, t) {
    this.pipelineUtils.createComputePipeline(e, t);
  }
  /**
   * Prepares the state for encoding render bundles.
   *
   * @param {RenderContext} renderContext - The render context.
   */
  beginBundle(e) {
    const t = this.get(e);
    t._currentPass = t.currentPass, t._currentSets = t.currentSets, t.currentSets = { attributes: {}, bindingGroups: [], pipeline: null, index: null }, t.currentPass = this.pipelineUtils.createBundleEncoder(e);
  }
  /**
   * After processing render bundles this method finalizes related work.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {RenderBundle} bundle - The render bundle.
   */
  finishBundle(e, t) {
    const s = this.get(e), r = s.currentPass.finish();
    this.get(t).bundleGPU = r, s.currentSets = s._currentSets, s.currentPass = s._currentPass;
  }
  /**
   * Adds a render bundle to the render context data.
   *
   * @param {RenderContext} renderContext - The render context.
   * @param {RenderBundle} bundle - The render bundle to add.
   */
  addBundle(e, t) {
    this.get(e).renderBundles.push(this.get(t).bundleGPU);
  }
  // bindings
  /**
   * Creates bindings from the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {Number} cacheIndex - The cache index.
   * @param {Number} version - The version.
   */
  createBindings(e, t, s, n) {
    this.bindingUtils.createBindings(e, t, s, n);
  }
  /**
   * Updates the given bind group definition.
   *
   * @param {BindGroup} bindGroup - The bind group.
   * @param {Array<BindGroup>} bindings - Array of bind groups.
   * @param {Number} cacheIndex - The cache index.
   * @param {Number} version - The version.
   */
  updateBindings(e, t, s, n) {
    this.bindingUtils.createBindings(e, t, s, n);
  }
  /**
   * Updates a buffer binding.
   *
   *  @param {Buffer} binding - The buffer binding to update.
   */
  updateBinding(e) {
    this.bindingUtils.updateBinding(e);
  }
  // attributes
  /**
   * Creates the buffer of an indexed shader attribute.
   *
   * @param {BufferAttribute} attribute - The indexed buffer attribute.
   */
  createIndexAttribute(e) {
    this.attributeUtils.createAttribute(e, GPUBufferUsage.INDEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
  }
  /**
   * Creates the buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createAttribute(e) {
    this.attributeUtils.createAttribute(e, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
  }
  /**
   * Creates the buffer of a storage attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createStorageAttribute(e) {
    this.attributeUtils.createAttribute(e, GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
  }
  /**
   * Creates the buffer of an indirect storage attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute.
   */
  createIndirectStorageAttribute(e) {
    this.attributeUtils.createAttribute(e, GPUBufferUsage.STORAGE | GPUBufferUsage.INDIRECT | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
  }
  /**
   * Updates the buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to update.
   */
  updateAttribute(e) {
    this.attributeUtils.updateAttribute(e);
  }
  /**
   * Destroys the buffer of a shader attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute to destroy.
   */
  destroyAttribute(e) {
    this.attributeUtils.destroyAttribute(e);
  }
  // canvas
  /**
   * Triggers an update of the default render pass descriptor.
   */
  updateSize() {
    this.colorBuffer = this.textureUtils.getColorBuffer(), this.defaultRenderPassdescriptor = null;
  }
  // utils public
  /**
   * Returns the maximum anisotropy texture filtering value.
   *
   * @return {Number} The maximum anisotropy texture filtering value.
   */
  getMaxAnisotropy() {
    return 16;
  }
  /**
   * Checks if the given feature is supported  by the backend.
   *
   * @param {String} name - The feature's name.
   * @return {Boolean} Whether the feature is supported or not.
   */
  hasFeature(e) {
    return this.device.features.has(e);
  }
  /**
   * Copies data of the given source texture to the given destination texture.
   *
   * @param {Texture} srcTexture - The source texture.
   * @param {Texture} dstTexture - The destination texture.
   * @param {Vector4?} [srcRegion=null] - The region of the source texture to copy.
   * @param {(Vector2|Vector3)?} [dstPosition=null] - The destination position of the copy.
   * @param {Number} [level=0] - The mip level to copy.
   */
  copyTextureToTexture(e, t, s = null, n = null, r = 0) {
    let i = 0, a = 0, u = 0, c = 0, l = 0, d = 0, h = e.image.width, p = e.image.height;
    s !== null && (c = s.x, l = s.y, d = s.z || 0, h = s.width, p = s.height), n !== null && (i = n.x, a = n.y, u = n.z || 0);
    const f = this.device.createCommandEncoder({ label: "copyTextureToTexture_" + e.id + "_" + t.id }), m = this.get(e).texture, _ = this.get(t).texture;
    f.copyTextureToTexture(
      {
        texture: m,
        mipLevel: r,
        origin: { x: c, y: l, z: d }
      },
      {
        texture: _,
        mipLevel: r,
        origin: { x: i, y: a, z: u }
      },
      [
        h,
        p,
        1
      ]
    ), this.device.queue.submit([f.finish()]);
  }
  /**
   * Copies the current bound framebuffer to the given texture.
   *
   * @param {Texture} texture - The destination texture.
   * @param {RenderContext} renderContext - The render context.
   * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
   */
  copyFramebufferToTexture(e, t, s) {
    const n = this.get(t);
    let r = null;
    t.renderTarget ? e.isDepthTexture ? r = this.get(t.depthTexture).texture : r = this.get(t.textures[0]).texture : e.isDepthTexture ? r = this.textureUtils.getDepthBuffer(t.depth, t.stencil) : r = this.context.getCurrentTexture();
    const i = this.get(e).texture;
    if (r.format !== i.format) {
      console.error("WebGPUBackend: copyFramebufferToTexture: Source and destination formats do not match.", r.format, i.format);
      return;
    }
    let a;
    if (n.currentPass ? (n.currentPass.end(), a = n.encoder) : a = this.device.createCommandEncoder({ label: "copyFramebufferToTexture_" + e.id }), a.copyTextureToTexture(
      {
        texture: r,
        origin: [s.x, s.y, 0]
      },
      {
        texture: i
      },
      [
        s.z,
        s.w
      ]
    ), e.generateMipmaps && this.textureUtils.generateMipmaps(e), n.currentPass) {
      const { descriptor: u } = n;
      for (let c = 0; c < u.colorAttachments.length; c++)
        u.colorAttachments[c].loadOp = ye.Load;
      if (t.depth && (u.depthStencilAttachment.depthLoadOp = ye.Load), t.stencil && (u.depthStencilAttachment.stencilLoadOp = ye.Load), n.currentPass = a.beginRenderPass(u), n.currentSets = { attributes: {}, bindingGroups: [], pipeline: null, index: null }, t.viewport && this.updateViewport(t), t.scissor) {
        const { x: c, y: l, width: d, height: h } = t.scissorValue;
        n.currentPass.setScissorRect(c, l, d, h);
      }
    } else
      this.device.queue.submit([a.finish()]);
  }
}
class XA extends kc {
  constructor(e, t, s, n, r, i) {
    super(e, t, s, n, r, i), this.iesMap = null;
  }
  copy(e, t) {
    return super.copy(e, t), this.iesMap = e.iesMap, this;
  }
}
class KA extends Yf {
  /**
   * Constructs a new standard node library.
   */
  constructor() {
    super(), this.addMaterial(Jx, "MeshPhongMaterial"), this.addMaterial(Xp, "MeshStandardMaterial"), this.addMaterial(BT, "MeshPhysicalMaterial"), this.addMaterial(DT, "MeshToonMaterial"), this.addMaterial(qx, "MeshBasicMaterial"), this.addMaterial(Qx, "MeshLambertMaterial"), this.addMaterial(Ox, "MeshNormalMaterial"), this.addMaterial(VT, "MeshMatcapMaterial"), this.addMaterial(Ux, "LineBasicMaterial"), this.addMaterial(Dx, "LineDashedMaterial"), this.addMaterial(OT, "PointsMaterial"), this.addMaterial($T, "SpriteMaterial"), this.addMaterial(qT, "ShadowMaterial"), this.addLight(Kb, lg), this.addLight(Lv, dg), this.addLight(Vv, hg), this.addLight(Xf, kc), this.addLight(Ov, pg), this.addLight(kv, fg), this.addLight(zv, gg), this.addLight(Gv, XA), this.addToneMapping(gf, mg), this.addToneMapping(mf, yg), this.addToneMapping(yf, xg), this.addToneMapping(xf, Tg), this.addToneMapping(Tf, _g), this.addToneMapping(_f, Ng);
  }
}
class ZA extends Jv {
  /**
   * Constructs a new WebGPU renderer.
   *
   * @param {Object} parameters - The configuration parameter.
   * @param {Boolean} [parameters.logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
   * @param {Boolean} [parameters.alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
   * @param {Boolean} [parameters.depth=true] - Whether the default framebuffer should have a depth buffer or not.
   * @param {Boolean} [parameters.stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
   * @param {Boolean} [parameters.antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
   * @param {Number} [parameters.samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0
   * to overwrite the default.
   * @param {Boolean} [parameters.forceWebGL=false] - If set to `true`, the renderer uses it
   * WebGL 2 backend no matter if WebGPU is supported or not.
   */
  constructor(e = {}) {
    let t;
    e.forceWebGL ? t = Fc : (t = qA, e.getFallback = () => (console.warn("THREE.WebGPURenderer: WebGPU is not available, running under WebGL2 backend."), new Fc(e)));
    const s = new t(e);
    super(s, e), this.library = new KA(), this.isWebGPURenderer = !0;
  }
}
export {
  Tg as ACESFilmicToneMapping,
  px as AONode,
  Us as AddEquation,
  rg as AddOperation,
  Lr as AdditiveBlending,
  _g as AgXToneMapping,
  Fg as AlphaFormat,
  ml as AlwaysCompare,
  hl as AlwaysDepth,
  cm as AlwaysStencilFunc,
  pg as AmbientLight,
  Ov as AmbientLightNode,
  bs as AnalyticLightNode,
  Ts as ArrayElementNode,
  Zm as AssignNode,
  xh as AttributeNode,
  Tt as BackSide,
  Qa as BasicEnvironmentNode,
  Am as BasicShadowMap,
  ox as BatchNode,
  tR as Box3,
  Cl as BoxGeometry,
  Cr as BufferAttribute,
  hy as BufferAttributeNode,
  El as BufferGeometry,
  Ga as BufferNode,
  Zy as BumpMapNode,
  gy as BypassNode,
  Tn as ByteType,
  fy as CacheNode,
  sR as Camera,
  xg as CineonToneMapping,
  ra as ClampToEdgeWrapping,
  be as CodeNode,
  Ct as Color,
  ht as ColorManagement,
  Yn as ColorSpaceNode,
  py as ComputeNode,
  ct as ConstNode,
  jd as ContextNode,
  Gl as ConvertNode,
  vm as CubeCamera,
  Ks as CubeReflectionMapping,
  Ys as CubeRefractionMapping,
  Sl as CubeTexture,
  Ly as CubeTextureNode,
  po as CubeUVReflectionMapping,
  Eg as CullFaceBack,
  wg as CullFaceFront,
  Cg as CullFaceNone,
  il as CustomBlending,
  bm as DataArrayTexture,
  Ag as DataTexture,
  pm as DecrementStencilOp,
  dm as DecrementWrapStencilOp,
  Jr as DepthFormat,
  Zr as DepthStencilFormat,
  ys as DepthTexture,
  dg as DirectionalLight,
  Lv as DirectionalLightNode,
  Ws as DoubleSide,
  el as DstAlphaFactor,
  Jc as DstColorFactor,
  Is as DynamicDrawUsage,
  CT as EnvironmentNode,
  xl as EqualCompare,
  cl as EqualDepth,
  om as EqualStencilFunc,
  kx as EquirectUVNode,
  Wn as EquirectangularReflectionMapping,
  Hn as EquirectangularRefractionMapping,
  bg as Euler,
  zc as EventDispatcher,
  Mr as ExpressionNode,
  Rl as Float16BufferAttribute,
  Uu as Float32BufferAttribute,
  st as FloatType,
  bl as FramebufferTexture,
  Iy as FrontFacingNode,
  ho as FrontSide,
  vg as Frustum,
  Jm as FunctionCallNode,
  Nf as FunctionNode,
  M_ as FunctionOverloadingNode,
  Xv as GLSLNodeParser,
  _l as GreaterCompare,
  al as GreaterDepth,
  Tl as GreaterEqualCompare,
  ul as GreaterEqualDepth,
  im as GreaterEqualStencilFunc,
  rm as GreaterStencilFunc,
  at as HalfFloatType,
  fg as HemisphereLight,
  kv as HemisphereLightNode,
  XA as IESSpotLight,
  Gv as IESSpotLightNode,
  nR as ImageUtils,
  fm as IncrementStencilOp,
  hm as IncrementWrapStencilOp,
  ae as IndexNode,
  yp as InstanceNode,
  oa as InstancedBufferAttribute,
  Gg as InstancedInterleavedBuffer,
  ix as InstancedMeshNode,
  Ve as IntType,
  Lg as InterleavedBuffer,
  Nm as InterleavedBufferAttribute,
  gm as InvertStencilOp,
  gx as IrradianceNode,
  Fm as JoinNode,
  xm as KeepStencilOp,
  rR as Layers,
  ia as LessCompare,
  dl as LessDepth,
  yl as LessEqualCompare,
  ll as LessEqualDepth,
  am as LessEqualStencilFunc,
  um as LessStencilFunc,
  iR as Light,
  gg as LightProbe,
  zv as LightProbeNode,
  Zv as Lighting,
  fx as LightingContextNode,
  Ni as LightingModel,
  on as LightingNode,
  hu as LightsNode,
  Og as LineBasicMaterial,
  Ux as LineBasicNodeMaterial,
  kg as LineDashedMaterial,
  Dx as LineDashedNodeMaterial,
  Lt as LinearFilter,
  tm as LinearMipMapLinearFilter,
  ds as LinearMipmapLinearFilter,
  Bo as LinearMipmapNearestFilter,
  cs as LinearSRGBColorSpace,
  mg as LinearToneMapping,
  oR as LinearTransfer,
  ux as LoopNode,
  Pg as LuminanceAlphaFormat,
  Ug as LuminanceFormat,
  S_ as MRTNode,
  IT as MatcapUVNode,
  bu as Material,
  v as MaterialNode,
  ky as MaterialReferenceNode,
  $c as MathUtils,
  $n as Matrix3,
  Ue as Matrix4,
  Tm as MaxEquation,
  _y as MaxMipLevelNode,
  js as Mesh,
  Gc as MeshBasicMaterial,
  qx as MeshBasicNodeMaterial,
  $g as MeshLambertMaterial,
  Qx as MeshLambertNodeMaterial,
  Kg as MeshMatcapMaterial,
  VT as MeshMatcapNodeMaterial,
  zg as MeshNormalMaterial,
  Ox as MeshNormalNodeMaterial,
  Wg as MeshPhongMaterial,
  Jx as MeshPhongNodeMaterial,
  qg as MeshPhysicalMaterial,
  BT as MeshPhysicalNodeMaterial,
  Hg as MeshStandardMaterial,
  Xp as MeshStandardNodeMaterial,
  Xg as MeshToonMaterial,
  DT as MeshToonNodeMaterial,
  _m as MinEquation,
  si as MirroredRepeatWrapping,
  ig as MixOperation,
  St as ModelNode,
  hx as MorphNode,
  Dr as MultiplyBlending,
  og as MultiplyOperation,
  pt as NearestFilter,
  Hs as NearestMipmapLinearFilter,
  Mo as NearestMipmapNearestFilter,
  Ng as NeutralToneMapping,
  gl as NeverCompare,
  pl as NeverDepth,
  lm as NeverStencilFunc,
  Mn as NoBlending,
  wn as NoColorSpace,
  $s as NoToneMapping,
  G as Node,
  De as NodeAccess,
  fc as NodeAttribute,
  qf as NodeBuilder,
  Xi as NodeCache,
  fv as NodeCode,
  bc as NodeFrame,
  Tu as NodeFunctionInput,
  ge as NodeMaterial,
  Em as NodeMaterialObserver,
  Fo as NodeShaderStage,
  Mm as NodeType,
  hv as NodeUniform,
  z as NodeUpdateType,
  Hf as NodeVar,
  pv as NodeVarying,
  zs as NormalBlending,
  Yy as NormalMapNode,
  Nl as NotEqualCompare,
  ol as NotEqualDepth,
  nm as NotEqualStencilFunc,
  em as Object3D,
  j as Object3DNode,
  Vg as ObjectSpaceNormalMap,
  Yc as OneFactor,
  rl as OneMinusDstAlphaFactor,
  nl as OneMinusDstColorFactor,
  sl as OneMinusSrcAlphaFactor,
  tl as OneMinusSrcColorFactor,
  Al as OrthographicCamera,
  Jp as OutputStructNode,
  ug as PCFShadowMap,
  Uv as PMREMGenerator,
  vT as PMREMNode,
  Zp as ParameterNode,
  Rt as PassNode,
  Rm as PerspectiveCamera,
  Pp as PhongLightingModel,
  $p as PhysicalLightingModel,
  Oc as Plane,
  lg as PointLight,
  Kb as PointLightNode,
  fN as PointUVNode,
  Yg as PointsMaterial,
  OT as PointsNodeMaterial,
  FN as PosterizeNode,
  ee as PropertyNode,
  ru as QuadMesh,
  aR as Quaternion,
  wu as RED_GREEN_RGTC2_Format,
  Dg as RED_RGTC1_Format,
  Hc as REVISION,
  Xs as RGBAFormat,
  na as RGBAIntegerFormat,
  Co as RGBA_ASTC_10x10_Format,
  vo as RGBA_ASTC_10x5_Format,
  Ao as RGBA_ASTC_10x6_Format,
  Ro as RGBA_ASTC_10x8_Format,
  Eo as RGBA_ASTC_12x10_Format,
  wo as RGBA_ASTC_12x12_Format,
  mo as RGBA_ASTC_4x4_Format,
  yo as RGBA_ASTC_5x4_Format,
  xo as RGBA_ASTC_5x5_Format,
  To as RGBA_ASTC_6x5_Format,
  _o as RGBA_ASTC_6x6_Format,
  No as RGBA_ASTC_8x5_Format,
  bo as RGBA_ASTC_8x6_Format,
  So as RGBA_ASTC_8x8_Format,
  wi as RGBA_BPTC_Format,
  go as RGBA_ETC2_EAC_Format,
  Ru as RGBA_PVRTC_2BPPV1_Format,
  Au as RGBA_PVRTC_4BPPV1_Format,
  vr as RGBA_S3TC_DXT1_Format,
  Ar as RGBA_S3TC_DXT3_Format,
  Rr as RGBA_S3TC_DXT5_Format,
  Jo as RGBFormat,
  sm as RGBIntegerFormat,
  Cu as RGB_ETC1_Format,
  fo as RGB_ETC2_Format,
  vu as RGB_PVRTC_2BPPV1_Format,
  Su as RGB_PVRTC_4BPPV1_Format,
  Ei as RGB_S3TC_DXT1_Format,
  Bn as RGFormat,
  sa as RGIntegerFormat,
  eN as RTTNode,
  tb as RangeNode,
  uR as Ray,
  hg as RectAreaLight,
  Vv as RectAreaLightNode,
  ea as RedFormat,
  ta as RedIntegerFormat,
  xi as ReferenceNode,
  nu as ReflectorNode,
  yg as ReinhardToneMapping,
  ph as RemapNode,
  yy as RenderOutputNode,
  ms as RenderTarget,
  ly as RendererReferenceNode,
  ti as RepeatWrapping,
  mm as ReplaceStencilOp,
  Xc as ReverseSubtractEquation,
  kT as RotateNode,
  Mu as SIGNED_RED_GREEN_RGTC2_Format,
  Eu as SIGNED_RED_RGTC1_Format,
  q as SRGBColorSpace,
  Bu as SRGBTransfer,
  Wc as Scene,
  ze as SceneNode,
  Se as ScreenNode,
  QN as ScriptableNode,
  YN as ScriptableValueNode,
  Pm as SetNode,
  cR as ShaderMaterial,
  Cb as ShadowBaseNode,
  Qg as ShadowMaterial,
  Bf as ShadowNode,
  qT as ShadowNodeMaterial,
  _n as ShortType,
  _p as SkinningNode,
  lR as Source,
  dR as Sphere,
  Sg as SphereGeometry,
  hR as SphericalHarmonics3,
  Do as SplitNode,
  kc as SpotLight,
  Xf as SpotLightNode,
  jg as SpriteMaterial,
  $T as SpriteNodeMaterial,
  W_ as SpriteSheetUVNode,
  Qc as SrcAlphaFactor,
  Zc as SrcAlphaSaturateFactor,
  jc as SrcColorFactor,
  N_ as StackNode,
  Ig as StaticDrawUsage,
  oN as StorageArrayElementNode,
  iN as StorageBufferAttribute,
  uN as StorageBufferNode,
  rN as StorageInstancedBufferAttribute,
  mN as StorageTextureNode,
  qc as SubtractEquation,
  Ir as SubtractiveBlending,
  QA as TSL,
  Fu as TangentSpaceNormalMap,
  Ne as TempNode,
  vl as Texture,
  KT as Texture3DNode,
  bt as TextureNode,
  Ty as TextureSizeNode,
  dy as ToneMappingNode,
  VN as ToonOutlinePassNode,
  pR as Triangle,
  q_ as TriplanarTexturesNode,
  ag as UVMapping,
  Jg as Uint16BufferAttribute,
  Zg as Uint32BufferAttribute,
  Fh as UniformArrayNode,
  ed as UniformGroupNode,
  Xn as UniformNode,
  ls as UnsignedByteType,
  ei as UnsignedInt248Type,
  fl as UnsignedInt5999Type,
  Pe as UnsignedIntType,
  Mg as UnsignedShort4444Type,
  Bg as UnsignedShort5551Type,
  Ls as UnsignedShortType,
  xN as UserDataNode,
  or as VSMShadowMap,
  wr as VarNode,
  oy as VaryingNode,
  He as Vector2,
  Y as Vector3,
  Ce as Vector4,
  hN as VertexColorNode,
  ke as ViewportDepthNode,
  Nx as ViewportDepthTextureNode,
  Ix as ViewportSharedTextureNode,
  _i as ViewportTextureNode,
  En as WebGLCoordinateSystem,
  Sm as WebGLCubeRenderTarget,
  fR as WebGLRenderTarget,
  sn as WebGPUCoordinateSystem,
  ZA as WebGPURenderer,
  Kc as ZeroFactor,
  ym as ZeroStencilOp,
  Rg as createCanvasElement,
  Uo as defaultBuildStages,
  Vl as defaultShaderStages,
  Po as shaderStages,
  xs as vectorComponents
};
